window.serviceableAreas = [
 {
   "suburb": "DARWIN",
   "postcode": "800"
 },
 {
   "suburb": "DARWIN CITY",
   "postcode": "800"
 },
 {
   "suburb": "ALAWA",
   "postcode": "810"
 },
 {
   "suburb": "BRINKIN",
   "postcode": "810"
 },
 {
   "suburb": "CASUARINA",
   "postcode": "810"
 },
 {
   "suburb": "COCONUT GROVE",
   "postcode": "810"
 },
 {
   "suburb": "DARWIN",
   "postcode": "810"
 },
 {
   "suburb": "JINGILI",
   "postcode": "810"
 },
 {
   "suburb": "LEE POINT",
   "postcode": "810"
 },
 {
   "suburb": "LYONS",
   "postcode": "810"
 },
 {
   "suburb": "MILLNER",
   "postcode": "810"
 },
 {
   "suburb": "MOIL",
   "postcode": "810"
 },
 {
   "suburb": "MUIRHEAD",
   "postcode": "810"
 },
 {
   "suburb": "NAKARA",
   "postcode": "810"
 },
 {
   "suburb": "NIGHTCLIFF",
   "postcode": "810"
 },
 {
   "suburb": "RAPID CREEK",
   "postcode": "810"
 },
 {
   "suburb": "TIWI",
   "postcode": "810"
 },
 {
   "suburb": "WAGAMAN",
   "postcode": "810"
 },
 {
   "suburb": "WANGURI",
   "postcode": "810"
 },
 {
   "suburb": "ANULA",
   "postcode": "812"
 },
 {
   "suburb": "HOLMES",
   "postcode": "812"
 },
 {
   "suburb": "KARAMA",
   "postcode": "812"
 },
 {
   "suburb": "LEANYER",
   "postcode": "812"
 },
 {
   "suburb": "MALAK",
   "postcode": "812"
 },
 {
   "suburb": "MARRARA",
   "postcode": "812"
 },
 {
   "suburb": "WULAGI",
   "postcode": "812"
 },
 {
   "suburb": "BAYVIEW",
   "postcode": "820"
 },
 {
   "suburb": "CHARLES DARWIN",
   "postcode": "820"
 },
 {
   "suburb": "COONAWARRA",
   "postcode": "820"
 },
 {
   "suburb": "DARWIN CITY",
   "postcode": "820"
 },
 {
   "suburb": "EAST POINT",
   "postcode": "820"
 },
 {
   "suburb": "EATON",
   "postcode": "820"
 },
 {
   "suburb": "FANNIE BAY",
   "postcode": "820"
 },
 {
   "suburb": "LARRAKEYAH",
   "postcode": "820"
 },
 {
   "suburb": "LUDMILLA",
   "postcode": "820"
 },
 {
   "suburb": "PARAP",
   "postcode": "820"
 },
 {
   "suburb": "STUART PARK",
   "postcode": "820"
 },
 {
   "suburb": "THE GARDENS",
   "postcode": "820"
 },
 {
   "suburb": "THE NARROWS",
   "postcode": "820"
 },
 {
   "suburb": "WINNELLIE",
   "postcode": "820"
 },
 {
   "suburb": "WOOLNER",
   "postcode": "820"
 },
 {
   "suburb": "BEES CREEK",
   "postcode": "822"
 },
 {
   "suburb": "CHARLES DARWIN",
   "postcode": "822"
 },
 {
   "suburb": "DELISSAVILLE",
   "postcode": "822"
 },
 {
   "suburb": "EAST ARM",
   "postcode": "822"
 },
 {
   "suburb": "ELRUNDIE",
   "postcode": "822"
 },
 {
   "suburb": "FREDS PASS",
   "postcode": "822"
 },
 {
   "suburb": "HIDDEN VALLEY",
   "postcode": "822"
 },
 {
   "suburb": "LAMBELLS LAGOON",
   "postcode": "822"
 },
 {
   "suburb": "LLOYD CREEK",
   "postcode": "822"
 },
 {
   "suburb": "MCMINNS LAGOON",
   "postcode": "822"
 },
 {
   "suburb": "TIVENDALE",
   "postcode": "822"
 },
 {
   "suburb": "WISHART",
   "postcode": "822"
 },
 {
   "suburb": "WOOLANING",
   "postcode": "822"
 },
 {
   "suburb": "BERRIMAH",
   "postcode": "828"
 },
 {
   "suburb": "HOLTZE",
   "postcode": "828"
 },
 {
   "suburb": "KNUCKEY LAGOON",
   "postcode": "828"
 },
 {
   "suburb": "PINELANDS",
   "postcode": "828"
 },
 {
   "suburb": "HOLTZE",
   "postcode": "829"
 },
 {
   "suburb": "PINELANDS",
   "postcode": "829"
 },
 {
   "suburb": "ARCHER",
   "postcode": "830"
 },
 {
   "suburb": "DRIVER",
   "postcode": "830"
 },
 {
   "suburb": "DURACK",
   "postcode": "830"
 },
 {
   "suburb": "FARRAR",
   "postcode": "830"
 },
 {
   "suburb": "GRAY",
   "postcode": "830"
 },
 {
   "suburb": "HOLTZE",
   "postcode": "830"
 },
 {
   "suburb": "MARLOW LAGOON",
   "postcode": "830"
 },
 {
   "suburb": "MOULDEN",
   "postcode": "830"
 },
 {
   "suburb": "PALMERSTON",
   "postcode": "830"
 },
 {
   "suburb": "PALMERSTON CITY",
   "postcode": "830"
 },
 {
   "suburb": "SHOAL BAY",
   "postcode": "830"
 },
 {
   "suburb": "WOODROFFE",
   "postcode": "830"
 },
 {
   "suburb": "YARRAWONGA",
   "postcode": "830"
 },
 {
   "suburb": "BAKEWELL",
   "postcode": "832"
 },
 {
   "suburb": "BELLAMACK",
   "postcode": "832"
 },
 {
   "suburb": "GUNN",
   "postcode": "832"
 },
 {
   "suburb": "JOHNSTON",
   "postcode": "832"
 },
 {
   "suburb": "MITCHELL",
   "postcode": "832"
 },
 {
   "suburb": "ROSEBERY",
   "postcode": "832"
 },
 {
   "suburb": "ROSEBERY HEIGHTS",
   "postcode": "832"
 },
 {
   "suburb": "ZUCCOLI",
   "postcode": "832"
 },
 {
   "suburb": "VIRGINIA",
   "postcode": "834"
 },
 {
   "suburb": "GIRRAWEEN",
   "postcode": "835"
 },
 {
   "suburb": "HOWARD SPRINGS",
   "postcode": "835"
 },
 {
   "suburb": "GIRRAWEEN",
   "postcode": "836"
 },
 {
   "suburb": "HERBERT",
   "postcode": "836"
 },
 {
   "suburb": "HUMPTY DOO",
   "postcode": "836"
 },
 {
   "suburb": "COOLALINGA",
   "postcode": "839"
 },
 {
   "suburb": "COSSACK",
   "postcode": "850"
 },
 {
   "suburb": "EMUNGALAN",
   "postcode": "850"
 },
 {
   "suburb": "KATHERINE",
   "postcode": "850"
 },
 {
   "suburb": "KATHERINE EAST",
   "postcode": "850"
 },
 {
   "suburb": "KATHERINE SOUTH",
   "postcode": "850"
 },
 {
   "suburb": "LANSDOWNE",
   "postcode": "850"
 },
 {
   "suburb": "URALLA",
   "postcode": "852"
 },
 {
   "suburb": "TINDAL",
   "postcode": "853"
 },
 {
   "suburb": "BARANGAROO",
   "postcode": "2000"
 },
 {
   "suburb": "DAWES POINT",
   "postcode": "2000"
 },
 {
   "suburb": "HAYMARKET",
   "postcode": "2000"
 },
 {
   "suburb": "MILLERS POINT",
   "postcode": "2000"
 },
 {
   "suburb": "PARLIAMENT HOUSE",
   "postcode": "2000"
 },
 {
   "suburb": "SYDNEY",
   "postcode": "2000"
 },
 {
   "suburb": "SYDNEY SOUTH",
   "postcode": "2000"
 },
 {
   "suburb": "THE ROCKS",
   "postcode": "2000"
 },
 {
   "suburb": "THE UNIVERSITY OF SYDNEY",
   "postcode": "2006"
 },
 {
   "suburb": "BROADWAY",
   "postcode": "2007"
 },
 {
   "suburb": "ULTIMO",
   "postcode": "2007"
 },
 {
   "suburb": "CHIPPENDALE",
   "postcode": "2008"
 },
 {
   "suburb": "DARLINGTON",
   "postcode": "2008"
 },
 {
   "suburb": "PYRMONT",
   "postcode": "2009"
 },
 {
   "suburb": "DARLINGHURST",
   "postcode": "2010"
 },
 {
   "suburb": "SURRY HILLS",
   "postcode": "2010"
 },
 {
   "suburb": "ELIZABETH BAY",
   "postcode": "2011"
 },
 {
   "suburb": "HMAS KUTTABUL",
   "postcode": "2011"
 },
 {
   "suburb": "POTTS POINT",
   "postcode": "2011"
 },
 {
   "suburb": "RUSHCUTTERS BAY",
   "postcode": "2011"
 },
 {
   "suburb": "WOOLLOOMOOLOO",
   "postcode": "2011"
 },
 {
   "suburb": "ALEXANDRIA",
   "postcode": "2015"
 },
 {
   "suburb": "BEACONSFIELD",
   "postcode": "2015"
 },
 {
   "suburb": "EVELEIGH",
   "postcode": "2015"
 },
 {
   "suburb": "REDFERN",
   "postcode": "2016"
 },
 {
   "suburb": "WATERLOO",
   "postcode": "2017"
 },
 {
   "suburb": "ZETLAND",
   "postcode": "2017"
 },
 {
   "suburb": "EASTLAKES",
   "postcode": "2018"
 },
 {
   "suburb": "ROSEBERY",
   "postcode": "2018"
 },
 {
   "suburb": "BANKSMEADOW",
   "postcode": "2019"
 },
 {
   "suburb": "BOTANY",
   "postcode": "2019"
 },
 {
   "suburb": "MASCOT",
   "postcode": "2020"
 },
 {
   "suburb": "SYDNEY DOMESTIC AIRPORT",
   "postcode": "2020"
 },
 {
   "suburb": "SYDNEY INTERNATIONAL AIRPORT",
   "postcode": "2020"
 },
 {
   "suburb": "CENTENNIAL PARK",
   "postcode": "2021"
 },
 {
   "suburb": "MOORE PARK",
   "postcode": "2021"
 },
 {
   "suburb": "PADDINGTON",
   "postcode": "2021"
 },
 {
   "suburb": "BONDI JUNCTION",
   "postcode": "2022"
 },
 {
   "suburb": "QUEENS PARK",
   "postcode": "2022"
 },
 {
   "suburb": "BELLEVUE HILL",
   "postcode": "2023"
 },
 {
   "suburb": "BRONTE",
   "postcode": "2024"
 },
 {
   "suburb": "WAVERLEY",
   "postcode": "2024"
 },
 {
   "suburb": "WOOLLAHRA",
   "postcode": "2025"
 },
 {
   "suburb": "BONDI",
   "postcode": "2026"
 },
 {
   "suburb": "BONDI BEACH",
   "postcode": "2026"
 },
 {
   "suburb": "NORTH BONDI",
   "postcode": "2026"
 },
 {
   "suburb": "TAMARAMA",
   "postcode": "2026"
 },
 {
   "suburb": "DARLING POINT",
   "postcode": "2027"
 },
 {
   "suburb": "EDGECLIFF",
   "postcode": "2027"
 },
 {
   "suburb": "HMAS RUSHCUTTERS",
   "postcode": "2027"
 },
 {
   "suburb": "POINT PIPER",
   "postcode": "2027"
 },
 {
   "suburb": "DOUBLE BAY",
   "postcode": "2028"
 },
 {
   "suburb": "ROSE BAY",
   "postcode": "2029"
 },
 {
   "suburb": "DOVER HEIGHTS",
   "postcode": "2030"
 },
 {
   "suburb": "HMAS WATSON",
   "postcode": "2030"
 },
 {
   "suburb": "ROSE BAY NORTH",
   "postcode": "2030"
 },
 {
   "suburb": "VAUCLUSE",
   "postcode": "2030"
 },
 {
   "suburb": "WATSONS BAY",
   "postcode": "2030"
 },
 {
   "suburb": "CLOVELLY",
   "postcode": "2031"
 },
 {
   "suburb": "CLOVELLY WEST",
   "postcode": "2031"
 },
 {
   "suburb": "RANDWICK",
   "postcode": "2031"
 },
 {
   "suburb": "ST PAULS",
   "postcode": "2031"
 },
 {
   "suburb": "DACEYVILLE",
   "postcode": "2032"
 },
 {
   "suburb": "KINGSFORD",
   "postcode": "2032"
 },
 {
   "suburb": "KENSINGTON",
   "postcode": "2033"
 },
 {
   "suburb": "COOGEE",
   "postcode": "2034"
 },
 {
   "suburb": "SOUTH COOGEE",
   "postcode": "2034"
 },
 {
   "suburb": "MAROUBRA",
   "postcode": "2035"
 },
 {
   "suburb": "MAROUBRA SOUTH",
   "postcode": "2035"
 },
 {
   "suburb": "PAGEWOOD",
   "postcode": "2035"
 },
 {
   "suburb": "CHIFLEY",
   "postcode": "2036"
 },
 {
   "suburb": "EASTGARDENS",
   "postcode": "2036"
 },
 {
   "suburb": "HILLSDALE",
   "postcode": "2036"
 },
 {
   "suburb": "LA PEROUSE",
   "postcode": "2036"
 },
 {
   "suburb": "LITTLE BAY",
   "postcode": "2036"
 },
 {
   "suburb": "MALABAR",
   "postcode": "2036"
 },
 {
   "suburb": "MATRAVILLE",
   "postcode": "2036"
 },
 {
   "suburb": "PHILLIP BAY",
   "postcode": "2036"
 },
 {
   "suburb": "PORT BOTANY",
   "postcode": "2036"
 },
 {
   "suburb": "FOREST LODGE",
   "postcode": "2037"
 },
 {
   "suburb": "GLEBE",
   "postcode": "2037"
 },
 {
   "suburb": "ANNANDALE",
   "postcode": "2038"
 },
 {
   "suburb": "ROZELLE",
   "postcode": "2039"
 },
 {
   "suburb": "LEICHHARDT",
   "postcode": "2040"
 },
 {
   "suburb": "LILYFIELD",
   "postcode": "2040"
 },
 {
   "suburb": "BALMAIN",
   "postcode": "2041"
 },
 {
   "suburb": "BALMAIN EAST",
   "postcode": "2041"
 },
 {
   "suburb": "BIRCHGROVE",
   "postcode": "2041"
 },
 {
   "suburb": "ENMORE",
   "postcode": "2042"
 },
 {
   "suburb": "NEWTOWN",
   "postcode": "2042"
 },
 {
   "suburb": "ERSKINEVILLE",
   "postcode": "2043"
 },
 {
   "suburb": "ST PETERS",
   "postcode": "2044"
 },
 {
   "suburb": "SYDENHAM",
   "postcode": "2044"
 },
 {
   "suburb": "TEMPE",
   "postcode": "2044"
 },
 {
   "suburb": "HABERFIELD",
   "postcode": "2045"
 },
 {
   "suburb": "ABBOTSFORD",
   "postcode": "2046"
 },
 {
   "suburb": "CANADA BAY",
   "postcode": "2046"
 },
 {
   "suburb": "CHISWICK",
   "postcode": "2046"
 },
 {
   "suburb": "FIVE DOCK",
   "postcode": "2046"
 },
 {
   "suburb": "RODD POINT",
   "postcode": "2046"
 },
 {
   "suburb": "RUSSELL LEA",
   "postcode": "2046"
 },
 {
   "suburb": "WAREEMBA",
   "postcode": "2046"
 },
 {
   "suburb": "DRUMMOYNE",
   "postcode": "2047"
 },
 {
   "suburb": "STANMORE",
   "postcode": "2048"
 },
 {
   "suburb": "WESTGATE",
   "postcode": "2048"
 },
 {
   "suburb": "LEWISHAM",
   "postcode": "2049"
 },
 {
   "suburb": "PETERSHAM",
   "postcode": "2049"
 },
 {
   "suburb": "PETERSHAM NORTH",
   "postcode": "2049"
 },
 {
   "suburb": "CAMPERDOWN",
   "postcode": "2050"
 },
 {
   "suburb": "MISSENDEN ROAD",
   "postcode": "2050"
 },
 {
   "suburb": "UNSW SYDNEY",
   "postcode": "2052"
 },
 {
   "suburb": "HMAS PLATYPUS",
   "postcode": "2060"
 },
 {
   "suburb": "HMAS WATERHEN",
   "postcode": "2060"
 },
 {
   "suburb": "LAVENDER BAY",
   "postcode": "2060"
 },
 {
   "suburb": "MCMAHONS POINT",
   "postcode": "2060"
 },
 {
   "suburb": "NORTH SYDNEY",
   "postcode": "2060"
 },
 {
   "suburb": "NORTH SYDNEY SHOPPINGWORLD",
   "postcode": "2060"
 },
 {
   "suburb": "WAVERTON",
   "postcode": "2060"
 },
 {
   "suburb": "KIRRIBILLI",
   "postcode": "2061"
 },
 {
   "suburb": "MILSONS POINT",
   "postcode": "2061"
 },
 {
   "suburb": "CAMMERAY",
   "postcode": "2062"
 },
 {
   "suburb": "NORTHBRIDGE",
   "postcode": "2063"
 },
 {
   "suburb": "ARTARMON",
   "postcode": "2064"
 },
 {
   "suburb": "CROWS NEST",
   "postcode": "2065"
 },
 {
   "suburb": "GREENWICH",
   "postcode": "2065"
 },
 {
   "suburb": "NAREMBURN",
   "postcode": "2065"
 },
 {
   "suburb": "ROYAL NORTH SHORE HOSPITAL",
   "postcode": "2065"
 },
 {
   "suburb": "ST LEONARDS",
   "postcode": "2065"
 },
 {
   "suburb": "WOLLSTONECRAFT",
   "postcode": "2065"
 },
 {
   "suburb": "LANE COVE",
   "postcode": "2066"
 },
 {
   "suburb": "LANE COVE NORTH",
   "postcode": "2066"
 },
 {
   "suburb": "LANE COVE WEST",
   "postcode": "2066"
 },
 {
   "suburb": "LINLEY POINT",
   "postcode": "2066"
 },
 {
   "suburb": "LONGUEVILLE",
   "postcode": "2066"
 },
 {
   "suburb": "NORTHWOOD",
   "postcode": "2066"
 },
 {
   "suburb": "RIVERVIEW",
   "postcode": "2066"
 },
 {
   "suburb": "CHATSWOOD",
   "postcode": "2067"
 },
 {
   "suburb": "CHATSWOOD WEST",
   "postcode": "2067"
 },
 {
   "suburb": "CASTLECRAG",
   "postcode": "2068"
 },
 {
   "suburb": "MIDDLE COVE",
   "postcode": "2068"
 },
 {
   "suburb": "NORTH WILLOUGHBY",
   "postcode": "2068"
 },
 {
   "suburb": "WILLOUGHBY",
   "postcode": "2068"
 },
 {
   "suburb": "WILLOUGHBY EAST",
   "postcode": "2068"
 },
 {
   "suburb": "WILLOUGHBY NORTH",
   "postcode": "2068"
 },
 {
   "suburb": "CASTLE COVE",
   "postcode": "2069"
 },
 {
   "suburb": "ROSEVILLE",
   "postcode": "2069"
 },
 {
   "suburb": "ROSEVILLE CHASE",
   "postcode": "2069"
 },
 {
   "suburb": "EAST LINDFIELD",
   "postcode": "2070"
 },
 {
   "suburb": "LINDFIELD",
   "postcode": "2070"
 },
 {
   "suburb": "LINDFIELD WEST",
   "postcode": "2070"
 },
 {
   "suburb": "EAST KILLARA",
   "postcode": "2071"
 },
 {
   "suburb": "KILLARA",
   "postcode": "2071"
 },
 {
   "suburb": "GORDON",
   "postcode": "2072"
 },
 {
   "suburb": "PYMBLE",
   "postcode": "2073"
 },
 {
   "suburb": "WEST PYMBLE",
   "postcode": "2073"
 },
 {
   "suburb": "NORTH TURRAMURRA",
   "postcode": "2074"
 },
 {
   "suburb": "SOUTH TURRAMURRA",
   "postcode": "2074"
 },
 {
   "suburb": "TURRAMURRA",
   "postcode": "2074"
 },
 {
   "suburb": "WARRAWEE",
   "postcode": "2074"
 },
 {
   "suburb": "ST IVES",
   "postcode": "2075"
 },
 {
   "suburb": "ST IVES CHASE",
   "postcode": "2075"
 },
 {
   "suburb": "NORMANHURST",
   "postcode": "2076"
 },
 {
   "suburb": "NORTH WAHROONGA",
   "postcode": "2076"
 },
 {
   "suburb": "WAHROONGA",
   "postcode": "2076"
 },
 {
   "suburb": "ASQUITH",
   "postcode": "2077"
 },
 {
   "suburb": "HORNSBY",
   "postcode": "2077"
 },
 {
   "suburb": "HORNSBY HEIGHTS",
   "postcode": "2077"
 },
 {
   "suburb": "WAITARA",
   "postcode": "2077"
 },
 {
   "suburb": "MOUNT COLAH",
   "postcode": "2079"
 },
 {
   "suburb": "MOUNT KURING-GAI",
   "postcode": "2080"
 },
 {
   "suburb": "BEROWRA",
   "postcode": "2081"
 },
 {
   "suburb": "COWAN",
   "postcode": "2081"
 },
 {
   "suburb": "BEROWRA HEIGHTS",
   "postcode": "2082"
 },
 {
   "suburb": "BROOKLYN",
   "postcode": "2083"
 },
 {
   "suburb": "CHEERO POINT",
   "postcode": "2083"
 },
 {
   "suburb": "MOONEY MOONEY",
   "postcode": "2083"
 },
 {
   "suburb": "COTTAGE POINT",
   "postcode": "2084"
 },
 {
   "suburb": "DUFFYS FOREST",
   "postcode": "2084"
 },
 {
   "suburb": "TERREY HILLS",
   "postcode": "2084"
 },
 {
   "suburb": "BELROSE",
   "postcode": "2085"
 },
 {
   "suburb": "BELROSE WEST",
   "postcode": "2085"
 },
 {
   "suburb": "DAVIDSON",
   "postcode": "2085"
 },
 {
   "suburb": "FRENCHS FOREST",
   "postcode": "2086"
 },
 {
   "suburb": "FRENCHS FOREST EAST",
   "postcode": "2086"
 },
 {
   "suburb": "FORESTVILLE",
   "postcode": "2087"
 },
 {
   "suburb": "KILLARNEY HEIGHTS",
   "postcode": "2087"
 },
 {
   "suburb": "MOSMAN",
   "postcode": "2088"
 },
 {
   "suburb": "SPIT JUNCTION",
   "postcode": "2088"
 },
 {
   "suburb": "KURRABA POINT",
   "postcode": "2089"
 },
 {
   "suburb": "NEUTRAL BAY",
   "postcode": "2089"
 },
 {
   "suburb": "NEUTRAL BAY JUNCTION",
   "postcode": "2089"
 },
 {
   "suburb": "CREMORNE",
   "postcode": "2090"
 },
 {
   "suburb": "CREMORNE JUNCTION",
   "postcode": "2090"
 },
 {
   "suburb": "CREMORNE POINT",
   "postcode": "2090"
 },
 {
   "suburb": "HMAS PENGUIN",
   "postcode": "2091"
 },
 {
   "suburb": "SEAFORTH",
   "postcode": "2092"
 },
 {
   "suburb": "BALGOWLAH",
   "postcode": "2093"
 },
 {
   "suburb": "BALGOWLAH HEIGHTS",
   "postcode": "2093"
 },
 {
   "suburb": "CLONTARF",
   "postcode": "2093"
 },
 {
   "suburb": "MANLY VALE",
   "postcode": "2093"
 },
 {
   "suburb": "NORTH BALGOWLAH",
   "postcode": "2093"
 },
 {
   "suburb": "FAIRLIGHT",
   "postcode": "2094"
 },
 {
   "suburb": "MANLY",
   "postcode": "2095"
 },
 {
   "suburb": "MANLY EAST",
   "postcode": "2095"
 },
 {
   "suburb": "CURL CURL",
   "postcode": "2096"
 },
 {
   "suburb": "FRESHWATER",
   "postcode": "2096"
 },
 {
   "suburb": "QUEENSCLIFF",
   "postcode": "2096"
 },
 {
   "suburb": "COLLAROY",
   "postcode": "2097"
 },
 {
   "suburb": "COLLAROY BEACH",
   "postcode": "2097"
 },
 {
   "suburb": "COLLAROY PLATEAU",
   "postcode": "2097"
 },
 {
   "suburb": "WHEELER HEIGHTS",
   "postcode": "2097"
 },
 {
   "suburb": "CROMER",
   "postcode": "2099"
 },
 {
   "suburb": "DEE WHY",
   "postcode": "2099"
 },
 {
   "suburb": "NARRAWEENA",
   "postcode": "2099"
 },
 {
   "suburb": "NORTH CURL CURL",
   "postcode": "2099"
 },
 {
   "suburb": "ALLAMBIE HEIGHTS",
   "postcode": "2100"
 },
 {
   "suburb": "BEACON HILL",
   "postcode": "2100"
 },
 {
   "suburb": "BROOKVALE",
   "postcode": "2100"
 },
 {
   "suburb": "NORTH MANLY",
   "postcode": "2100"
 },
 {
   "suburb": "OXFORD FALLS",
   "postcode": "2100"
 },
 {
   "suburb": "WARRINGAH MALL",
   "postcode": "2100"
 },
 {
   "suburb": "ELANORA HEIGHTS",
   "postcode": "2101"
 },
 {
   "suburb": "INGLESIDE",
   "postcode": "2101"
 },
 {
   "suburb": "NARRABEEN",
   "postcode": "2101"
 },
 {
   "suburb": "NORTH NARRABEEN",
   "postcode": "2101"
 },
 {
   "suburb": "WARRIEWOOD",
   "postcode": "2102"
 },
 {
   "suburb": "WARRIEWOOD SHOPPING SQUARE",
   "postcode": "2102"
 },
 {
   "suburb": "MONA VALE",
   "postcode": "2103"
 },
 {
   "suburb": "BAYVIEW",
   "postcode": "2104"
 },
 {
   "suburb": "CHURCH POINT",
   "postcode": "2105"
 },
 {
   "suburb": "ELVINA BAY",
   "postcode": "2105"
 },
 {
   "suburb": "LOVETT BAY",
   "postcode": "2105"
 },
 {
   "suburb": "MCCARRS CREEK",
   "postcode": "2105"
 },
 {
   "suburb": "MORNING BAY",
   "postcode": "2105"
 },
 {
   "suburb": "NEWPORT",
   "postcode": "2106"
 },
 {
   "suburb": "NEWPORT BEACH",
   "postcode": "2106"
 },
 {
   "suburb": "AVALON BEACH",
   "postcode": "2107"
 },
 {
   "suburb": "BILGOLA BEACH",
   "postcode": "2107"
 },
 {
   "suburb": "BILGOLA PLATEAU",
   "postcode": "2107"
 },
 {
   "suburb": "CLAREVILLE",
   "postcode": "2107"
 },
 {
   "suburb": "WHALE BEACH",
   "postcode": "2107"
 },
 {
   "suburb": "COASTERS RETREAT",
   "postcode": "2108"
 },
 {
   "suburb": "CURRAWONG BEACH",
   "postcode": "2108"
 },
 {
   "suburb": "GREAT MACKEREL BEACH",
   "postcode": "2108"
 },
 {
   "suburb": "PALM BEACH",
   "postcode": "2108"
 },
 {
   "suburb": "MACQUARIE UNIVERSITY",
   "postcode": "2109"
 },
 {
   "suburb": "HUNTERS HILL",
   "postcode": "2110"
 },
 {
   "suburb": "WOOLWICH",
   "postcode": "2110"
 },
 {
   "suburb": "BORONIA PARK",
   "postcode": "2111"
 },
 {
   "suburb": "GLADESVILLE",
   "postcode": "2111"
 },
 {
   "suburb": "HENLEY",
   "postcode": "2111"
 },
 {
   "suburb": "HUNTLEYS COVE",
   "postcode": "2111"
 },
 {
   "suburb": "HUNTLEYS POINT",
   "postcode": "2111"
 },
 {
   "suburb": "MONASH PARK",
   "postcode": "2111"
 },
 {
   "suburb": "TENNYSON POINT",
   "postcode": "2111"
 },
 {
   "suburb": "DENISTONE EAST",
   "postcode": "2112"
 },
 {
   "suburb": "PUTNEY",
   "postcode": "2112"
 },
 {
   "suburb": "RYDE",
   "postcode": "2112"
 },
 {
   "suburb": "BLENHEIM ROAD",
   "postcode": "2113"
 },
 {
   "suburb": "EAST RYDE",
   "postcode": "2113"
 },
 {
   "suburb": "MACQUARIE CENTRE",
   "postcode": "2113"
 },
 {
   "suburb": "MACQUARIE PARK",
   "postcode": "2113"
 },
 {
   "suburb": "NORTH RYDE",
   "postcode": "2113"
 },
 {
   "suburb": "DENISTONE",
   "postcode": "2114"
 },
 {
   "suburb": "DENISTONE WEST",
   "postcode": "2114"
 },
 {
   "suburb": "MEADOWBANK",
   "postcode": "2114"
 },
 {
   "suburb": "MELROSE PARK",
   "postcode": "2114"
 },
 {
   "suburb": "WEST RYDE",
   "postcode": "2114"
 },
 {
   "suburb": "ERMINGTON",
   "postcode": "2115"
 },
 {
   "suburb": "RYDALMERE",
   "postcode": "2116"
 },
 {
   "suburb": "DUNDAS",
   "postcode": "2117"
 },
 {
   "suburb": "DUNDAS VALLEY",
   "postcode": "2117"
 },
 {
   "suburb": "OATLANDS",
   "postcode": "2117"
 },
 {
   "suburb": "TELOPEA",
   "postcode": "2117"
 },
 {
   "suburb": "CARLINGFORD",
   "postcode": "2118"
 },
 {
   "suburb": "CARLINGFORD COURT",
   "postcode": "2118"
 },
 {
   "suburb": "CARLINGFORD NORTH",
   "postcode": "2118"
 },
 {
   "suburb": "KINGSDENE",
   "postcode": "2118"
 },
 {
   "suburb": "BEECROFT",
   "postcode": "2119"
 },
 {
   "suburb": "CHELTENHAM",
   "postcode": "2119"
 },
 {
   "suburb": "PENNANT HILLS",
   "postcode": "2120"
 },
 {
   "suburb": "THORNLEIGH",
   "postcode": "2120"
 },
 {
   "suburb": "WESTLEIGH",
   "postcode": "2120"
 },
 {
   "suburb": "EPPING",
   "postcode": "2121"
 },
 {
   "suburb": "NORTH EPPING",
   "postcode": "2121"
 },
 {
   "suburb": "EASTWOOD",
   "postcode": "2122"
 },
 {
   "suburb": "MARSFIELD",
   "postcode": "2122"
 },
 {
   "suburb": "PARRAMATTA",
   "postcode": "2123"
 },
 {
   "suburb": "WEST PENNANT HILLS",
   "postcode": "2125"
 },
 {
   "suburb": "CHERRYBROOK",
   "postcode": "2126"
 },
 {
   "suburb": "NEWINGTON",
   "postcode": "2127"
 },
 {
   "suburb": "SYDNEY OLYMPIC PARK",
   "postcode": "2127"
 },
 {
   "suburb": "WENTWORTH POINT",
   "postcode": "2127"
 },
 {
   "suburb": "SILVERWATER",
   "postcode": "2128"
 },
 {
   "suburb": "SUMMER HILL",
   "postcode": "2130"
 },
 {
   "suburb": "ASHFIELD",
   "postcode": "2131"
 },
 {
   "suburb": "CROYDON",
   "postcode": "2132"
 },
 {
   "suburb": "CROYDON PARK",
   "postcode": "2133"
 },
 {
   "suburb": "ENFIELD SOUTH",
   "postcode": "2133"
 },
 {
   "suburb": "BURWOOD",
   "postcode": "2134"
 },
 {
   "suburb": "BURWOOD NORTH",
   "postcode": "2134"
 },
 {
   "suburb": "STRATHFIELD",
   "postcode": "2135"
 },
 {
   "suburb": "BURWOOD HEIGHTS",
   "postcode": "2136"
 },
 {
   "suburb": "ENFIELD",
   "postcode": "2136"
 },
 {
   "suburb": "STRATHFIELD SOUTH",
   "postcode": "2136"
 },
 {
   "suburb": "BREAKFAST POINT",
   "postcode": "2137"
 },
 {
   "suburb": "CABARITA",
   "postcode": "2137"
 },
 {
   "suburb": "CONCORD",
   "postcode": "2137"
 },
 {
   "suburb": "MORTLAKE",
   "postcode": "2137"
 },
 {
   "suburb": "NORTH STRATHFIELD",
   "postcode": "2137"
 },
 {
   "suburb": "CONCORD WEST",
   "postcode": "2138"
 },
 {
   "suburb": "LIBERTY GROVE",
   "postcode": "2138"
 },
 {
   "suburb": "RHODES",
   "postcode": "2138"
 },
 {
   "suburb": "CONCORD REPATRIATION HOSPITAL",
   "postcode": "2139"
 },
 {
   "suburb": "HOMEBUSH",
   "postcode": "2140"
 },
 {
   "suburb": "HOMEBUSH SOUTH",
   "postcode": "2140"
 },
 {
   "suburb": "HOMEBUSH WEST",
   "postcode": "2140"
 },
 {
   "suburb": "BERALA",
   "postcode": "2141"
 },
 {
   "suburb": "LIDCOMBE",
   "postcode": "2141"
 },
 {
   "suburb": "LIDCOMBE NORTH",
   "postcode": "2141"
 },
 {
   "suburb": "ROOKWOOD",
   "postcode": "2141"
 },
 {
   "suburb": "BLAXCELL",
   "postcode": "2142"
 },
 {
   "suburb": "CAMELLIA",
   "postcode": "2142"
 },
 {
   "suburb": "CLYDE",
   "postcode": "2142"
 },
 {
   "suburb": "GRANVILLE",
   "postcode": "2142"
 },
 {
   "suburb": "HOLROYD",
   "postcode": "2142"
 },
 {
   "suburb": "ROSEHILL",
   "postcode": "2142"
 },
 {
   "suburb": "SOUTH GRANVILLE",
   "postcode": "2142"
 },
 {
   "suburb": "BIRRONG",
   "postcode": "2143"
 },
 {
   "suburb": "POTTS HILL",
   "postcode": "2143"
 },
 {
   "suburb": "REGENTS PARK",
   "postcode": "2143"
 },
 {
   "suburb": "AUBURN",
   "postcode": "2144"
 },
 {
   "suburb": "CONSTITUTION HILL",
   "postcode": "2145"
 },
 {
   "suburb": "GIRRAWEEN",
   "postcode": "2145"
 },
 {
   "suburb": "GREYSTANES",
   "postcode": "2145"
 },
 {
   "suburb": "MAYS HILL",
   "postcode": "2145"
 },
 {
   "suburb": "PEMULWUY",
   "postcode": "2145"
 },
 {
   "suburb": "PENDLE HILL",
   "postcode": "2145"
 },
 {
   "suburb": "SOUTH WENTWORTHVILLE",
   "postcode": "2145"
 },
 {
   "suburb": "WENTWORTHVILLE",
   "postcode": "2145"
 },
 {
   "suburb": "WESTMEAD",
   "postcode": "2145"
 },
 {
   "suburb": "OLD TOONGABBIE",
   "postcode": "2146"
 },
 {
   "suburb": "TOONGABBIE",
   "postcode": "2146"
 },
 {
   "suburb": "TOONGABBIE EAST",
   "postcode": "2146"
 },
 {
   "suburb": "KINGS LANGLEY",
   "postcode": "2147"
 },
 {
   "suburb": "LALOR PARK",
   "postcode": "2147"
 },
 {
   "suburb": "SEVEN HILLS",
   "postcode": "2147"
 },
 {
   "suburb": "SEVEN HILLS WEST",
   "postcode": "2147"
 },
 {
   "suburb": "ARNDELL PARK",
   "postcode": "2148"
 },
 {
   "suburb": "BLACKTOWN",
   "postcode": "2148"
 },
 {
   "suburb": "BLACKTOWN WESTPOINT",
   "postcode": "2148"
 },
 {
   "suburb": "HUNTINGWOOD",
   "postcode": "2148"
 },
 {
   "suburb": "KINGS PARK",
   "postcode": "2148"
 },
 {
   "suburb": "MARAYONG",
   "postcode": "2148"
 },
 {
   "suburb": "PROSPECT",
   "postcode": "2148"
 },
 {
   "suburb": "HARRIS PARK",
   "postcode": "2150"
 },
 {
   "suburb": "PARRAMATTA",
   "postcode": "2150"
 },
 {
   "suburb": "PARRAMATTA WESTFIELD",
   "postcode": "2150"
 },
 {
   "suburb": "NORTH PARRAMATTA",
   "postcode": "2151"
 },
 {
   "suburb": "NORTH ROCKS",
   "postcode": "2151"
 },
 {
   "suburb": "NORTHMEAD",
   "postcode": "2152"
 },
 {
   "suburb": "BAULKHAM HILLS",
   "postcode": "2153"
 },
 {
   "suburb": "BELLA VISTA",
   "postcode": "2153"
 },
 {
   "suburb": "NORWEST",
   "postcode": "2153"
 },
 {
   "suburb": "WINSTON HILLS",
   "postcode": "2153"
 },
 {
   "suburb": "CASTLE HILL",
   "postcode": "2154"
 },
 {
   "suburb": "BEAUMONT HILLS",
   "postcode": "2155"
 },
 {
   "suburb": "KELLYVILLE",
   "postcode": "2155"
 },
 {
   "suburb": "KELLYVILLE RIDGE",
   "postcode": "2155"
 },
 {
   "suburb": "NORTH KELLYVILLE",
   "postcode": "2155"
 },
 {
   "suburb": "ROUSE HILL",
   "postcode": "2155"
 },
 {
   "suburb": "ANNANGROVE",
   "postcode": "2156"
 },
 {
   "suburb": "GLENHAVEN",
   "postcode": "2156"
 },
 {
   "suburb": "KENTHURST",
   "postcode": "2156"
 },
 {
   "suburb": "CANOELANDS",
   "postcode": "2157"
 },
 {
   "suburb": "FOREST GLEN",
   "postcode": "2157"
 },
 {
   "suburb": "GLENORIE",
   "postcode": "2157"
 },
 {
   "suburb": "DURAL",
   "postcode": "2158"
 },
 {
   "suburb": "MIDDLE DURAL",
   "postcode": "2158"
 },
 {
   "suburb": "ROUND CORNER",
   "postcode": "2158"
 },
 {
   "suburb": "ARCADIA",
   "postcode": "2159"
 },
 {
   "suburb": "BERRILEE",
   "postcode": "2159"
 },
 {
   "suburb": "FIDDLETOWN",
   "postcode": "2159"
 },
 {
   "suburb": "GALSTON",
   "postcode": "2159"
 },
 {
   "suburb": "MERRYLANDS",
   "postcode": "2160"
 },
 {
   "suburb": "MERRYLANDS WEST",
   "postcode": "2160"
 },
 {
   "suburb": "GUILDFORD",
   "postcode": "2161"
 },
 {
   "suburb": "GUILDFORD WEST",
   "postcode": "2161"
 },
 {
   "suburb": "OLD GUILDFORD",
   "postcode": "2161"
 },
 {
   "suburb": "YENNORA",
   "postcode": "2161"
 },
 {
   "suburb": "CHESTER HILL",
   "postcode": "2162"
 },
 {
   "suburb": "SEFTON",
   "postcode": "2162"
 },
 {
   "suburb": "CARRAMAR",
   "postcode": "2163"
 },
 {
   "suburb": "LANSDOWNE",
   "postcode": "2163"
 },
 {
   "suburb": "VILLAWOOD",
   "postcode": "2163"
 },
 {
   "suburb": "SMITHFIELD",
   "postcode": "2164"
 },
 {
   "suburb": "SMITHFIELD WEST",
   "postcode": "2164"
 },
 {
   "suburb": "WETHERILL PARK",
   "postcode": "2164"
 },
 {
   "suburb": "WOODPARK",
   "postcode": "2164"
 },
 {
   "suburb": "FAIRFIELD",
   "postcode": "2165"
 },
 {
   "suburb": "FAIRFIELD EAST",
   "postcode": "2165"
 },
 {
   "suburb": "FAIRFIELD HEIGHTS",
   "postcode": "2165"
 },
 {
   "suburb": "FAIRFIELD WEST",
   "postcode": "2165"
 },
 {
   "suburb": "CABRAMATTA",
   "postcode": "2166"
 },
 {
   "suburb": "CABRAMATTA WEST",
   "postcode": "2166"
 },
 {
   "suburb": "CANLEY HEIGHTS",
   "postcode": "2166"
 },
 {
   "suburb": "CANLEY VALE",
   "postcode": "2166"
 },
 {
   "suburb": "LANSVALE",
   "postcode": "2166"
 },
 {
   "suburb": "GLENFIELD",
   "postcode": "2167"
 },
 {
   "suburb": "ASHCROFT",
   "postcode": "2168"
 },
 {
   "suburb": "BUSBY",
   "postcode": "2168"
 },
 {
   "suburb": "CARTWRIGHT",
   "postcode": "2168"
 },
 {
   "suburb": "GREEN VALLEY",
   "postcode": "2168"
 },
 {
   "suburb": "HECKENBERG",
   "postcode": "2168"
 },
 {
   "suburb": "HINCHINBROOK",
   "postcode": "2168"
 },
 {
   "suburb": "MILLER",
   "postcode": "2168"
 },
 {
   "suburb": "SADLEIR",
   "postcode": "2168"
 },
 {
   "suburb": "CASULA",
   "postcode": "2170"
 },
 {
   "suburb": "CASULA MALL",
   "postcode": "2170"
 },
 {
   "suburb": "CHIPPING NORTON",
   "postcode": "2170"
 },
 {
   "suburb": "HAMMONDVILLE",
   "postcode": "2170"
 },
 {
   "suburb": "LIVERPOOL",
   "postcode": "2170"
 },
 {
   "suburb": "LIVERPOOL SOUTH",
   "postcode": "2170"
 },
 {
   "suburb": "LIVERPOOL WESTFIELD",
   "postcode": "2170"
 },
 {
   "suburb": "LURNEA",
   "postcode": "2170"
 },
 {
   "suburb": "MOOREBANK",
   "postcode": "2170"
 },
 {
   "suburb": "MOUNT PRITCHARD",
   "postcode": "2170"
 },
 {
   "suburb": "PRESTONS",
   "postcode": "2170"
 },
 {
   "suburb": "WARWICK FARM",
   "postcode": "2170"
 },
 {
   "suburb": "CARNES HILL",
   "postcode": "2171"
 },
 {
   "suburb": "CECIL HILLS",
   "postcode": "2171"
 },
 {
   "suburb": "ELIZABETH HILLS",
   "postcode": "2171"
 },
 {
   "suburb": "HORNINGSEA PARK",
   "postcode": "2171"
 },
 {
   "suburb": "HOXTON PARK",
   "postcode": "2171"
 },
 {
   "suburb": "LEN WATERS ESTATE",
   "postcode": "2171"
 },
 {
   "suburb": "MIDDLETON GRANGE",
   "postcode": "2171"
 },
 {
   "suburb": "WEST HOXTON",
   "postcode": "2171"
 },
 {
   "suburb": "PLEASURE POINT",
   "postcode": "2172"
 },
 {
   "suburb": "SANDY POINT",
   "postcode": "2172"
 },
 {
   "suburb": "VOYAGER POINT",
   "postcode": "2172"
 },
 {
   "suburb": "HOLSWORTHY",
   "postcode": "2173"
 },
 {
   "suburb": "WATTLE GROVE",
   "postcode": "2173"
 },
 {
   "suburb": "EDMONDSON PARK",
   "postcode": "2174"
 },
 {
   "suburb": "HORSLEY PARK",
   "postcode": "2175"
 },
 {
   "suburb": "ABBOTSBURY",
   "postcode": "2176"
 },
 {
   "suburb": "BOSSLEY PARK",
   "postcode": "2176"
 },
 {
   "suburb": "EDENSOR PARK",
   "postcode": "2176"
 },
 {
   "suburb": "GREENFIELD PARK",
   "postcode": "2176"
 },
 {
   "suburb": "PRAIRIEWOOD",
   "postcode": "2176"
 },
 {
   "suburb": "ST JOHNS PARK",
   "postcode": "2176"
 },
 {
   "suburb": "WAKELEY",
   "postcode": "2176"
 },
 {
   "suburb": "BONNYRIGG",
   "postcode": "2177"
 },
 {
   "suburb": "BONNYRIGG HEIGHTS",
   "postcode": "2177"
 },
 {
   "suburb": "CECIL PARK",
   "postcode": "2178"
 },
 {
   "suburb": "KEMPS CREEK",
   "postcode": "2178"
 },
 {
   "suburb": "MOUNT VERNON",
   "postcode": "2178"
 },
 {
   "suburb": "AUSTRAL",
   "postcode": "2179"
 },
 {
   "suburb": "LEPPINGTON",
   "postcode": "2179"
 },
 {
   "suburb": "CHULLORA",
   "postcode": "2190"
 },
 {
   "suburb": "GREENACRE",
   "postcode": "2190"
 },
 {
   "suburb": "MOUNT LEWIS",
   "postcode": "2190"
 },
 {
   "suburb": "BELFIELD",
   "postcode": "2191"
 },
 {
   "suburb": "BELMORE",
   "postcode": "2192"
 },
 {
   "suburb": "ASHBURY",
   "postcode": "2193"
 },
 {
   "suburb": "CANTERBURY",
   "postcode": "2193"
 },
 {
   "suburb": "HURLSTONE PARK",
   "postcode": "2193"
 },
 {
   "suburb": "CAMPSIE",
   "postcode": "2194"
 },
 {
   "suburb": "LAKEMBA",
   "postcode": "2195"
 },
 {
   "suburb": "WILEY PARK",
   "postcode": "2195"
 },
 {
   "suburb": "PUNCHBOWL",
   "postcode": "2196"
 },
 {
   "suburb": "ROSELANDS",
   "postcode": "2196"
 },
 {
   "suburb": "BASS HILL",
   "postcode": "2197"
 },
 {
   "suburb": "GEORGES HALL",
   "postcode": "2198"
 },
 {
   "suburb": "YAGOONA",
   "postcode": "2199"
 },
 {
   "suburb": "YAGOONA WEST",
   "postcode": "2199"
 },
 {
   "suburb": "BANKSTOWN",
   "postcode": "2200"
 },
 {
   "suburb": "BANKSTOWN AERODROME",
   "postcode": "2200"
 },
 {
   "suburb": "BANKSTOWN NORTH",
   "postcode": "2200"
 },
 {
   "suburb": "BANKSTOWN SQUARE",
   "postcode": "2200"
 },
 {
   "suburb": "CONDELL PARK",
   "postcode": "2200"
 },
 {
   "suburb": "MANAHAN",
   "postcode": "2200"
 },
 {
   "suburb": "MOUNT LEWIS",
   "postcode": "2200"
 },
 {
   "suburb": "DULWICH HILL",
   "postcode": "2203"
 },
 {
   "suburb": "MARRICKVILLE",
   "postcode": "2204"
 },
 {
   "suburb": "MARRICKVILLE METRO",
   "postcode": "2204"
 },
 {
   "suburb": "MARRICKVILLE SOUTH",
   "postcode": "2204"
 },
 {
   "suburb": "ARNCLIFFE",
   "postcode": "2205"
 },
 {
   "suburb": "TURRELLA",
   "postcode": "2205"
 },
 {
   "suburb": "WOLLI CREEK",
   "postcode": "2205"
 },
 {
   "suburb": "CLEMTON PARK",
   "postcode": "2206"
 },
 {
   "suburb": "EARLWOOD",
   "postcode": "2206"
 },
 {
   "suburb": "BARDWELL PARK",
   "postcode": "2207"
 },
 {
   "suburb": "BARDWELL VALLEY",
   "postcode": "2207"
 },
 {
   "suburb": "BEXLEY",
   "postcode": "2207"
 },
 {
   "suburb": "BEXLEY NORTH",
   "postcode": "2207"
 },
 {
   "suburb": "BEXLEY SOUTH",
   "postcode": "2207"
 },
 {
   "suburb": "KINGSGROVE",
   "postcode": "2208"
 },
 {
   "suburb": "KINGSWAY WEST",
   "postcode": "2208"
 },
 {
   "suburb": "BEVERLY HILLS",
   "postcode": "2209"
 },
 {
   "suburb": "NARWEE",
   "postcode": "2209"
 },
 {
   "suburb": "LUGARNO",
   "postcode": "2210"
 },
 {
   "suburb": "PEAKHURST",
   "postcode": "2210"
 },
 {
   "suburb": "PEAKHURST HEIGHTS",
   "postcode": "2210"
 },
 {
   "suburb": "RIVERWOOD",
   "postcode": "2210"
 },
 {
   "suburb": "PADSTOW",
   "postcode": "2211"
 },
 {
   "suburb": "PADSTOW HEIGHTS",
   "postcode": "2211"
 },
 {
   "suburb": "REVESBY",
   "postcode": "2212"
 },
 {
   "suburb": "REVESBY HEIGHTS",
   "postcode": "2212"
 },
 {
   "suburb": "REVESBY NORTH",
   "postcode": "2212"
 },
 {
   "suburb": "EAST HILLS",
   "postcode": "2213"
 },
 {
   "suburb": "PANANIA",
   "postcode": "2213"
 },
 {
   "suburb": "PICNIC POINT",
   "postcode": "2213"
 },
 {
   "suburb": "MILPERRA",
   "postcode": "2214"
 },
 {
   "suburb": "BANKSIA",
   "postcode": "2216"
 },
 {
   "suburb": "BRIGHTON-LE-SANDS",
   "postcode": "2216"
 },
 {
   "suburb": "KYEEMAGH",
   "postcode": "2216"
 },
 {
   "suburb": "ROCKDALE",
   "postcode": "2216"
 },
 {
   "suburb": "BEVERLEY PARK",
   "postcode": "2217"
 },
 {
   "suburb": "KOGARAH",
   "postcode": "2217"
 },
 {
   "suburb": "KOGARAH BAY",
   "postcode": "2217"
 },
 {
   "suburb": "MONTEREY",
   "postcode": "2217"
 },
 {
   "suburb": "RAMSGATE",
   "postcode": "2217"
 },
 {
   "suburb": "RAMSGATE BEACH",
   "postcode": "2217"
 },
 {
   "suburb": "ALLAWAH",
   "postcode": "2218"
 },
 {
   "suburb": "CARLTON",
   "postcode": "2218"
 },
 {
   "suburb": "DOLLS POINT",
   "postcode": "2219"
 },
 {
   "suburb": "SANDRINGHAM",
   "postcode": "2219"
 },
 {
   "suburb": "SANS SOUCI",
   "postcode": "2219"
 },
 {
   "suburb": "HURSTVILLE",
   "postcode": "2220"
 },
 {
   "suburb": "HURSTVILLE GROVE",
   "postcode": "2220"
 },
 {
   "suburb": "HURSTVILLE WESTFIELD",
   "postcode": "2220"
 },
 {
   "suburb": "BLAKEHURST",
   "postcode": "2221"
 },
 {
   "suburb": "CARSS PARK",
   "postcode": "2221"
 },
 {
   "suburb": "CONNELLS POINT",
   "postcode": "2221"
 },
 {
   "suburb": "KYLE BAY",
   "postcode": "2221"
 },
 {
   "suburb": "SOUTH HURSTVILLE",
   "postcode": "2221"
 },
 {
   "suburb": "PENSHURST",
   "postcode": "2222"
 },
 {
   "suburb": "MORTDALE",
   "postcode": "2223"
 },
 {
   "suburb": "OATLEY",
   "postcode": "2223"
 },
 {
   "suburb": "KANGAROO POINT",
   "postcode": "2224"
 },
 {
   "suburb": "SYLVANIA",
   "postcode": "2224"
 },
 {
   "suburb": "SYLVANIA SOUTHGATE",
   "postcode": "2224"
 },
 {
   "suburb": "SYLVANIA WATERS",
   "postcode": "2224"
 },
 {
   "suburb": "OYSTER BAY",
   "postcode": "2225"
 },
 {
   "suburb": "BONNET BAY",
   "postcode": "2226"
 },
 {
   "suburb": "COMO",
   "postcode": "2226"
 },
 {
   "suburb": "JANNALI",
   "postcode": "2226"
 },
 {
   "suburb": "GYMEA",
   "postcode": "2227"
 },
 {
   "suburb": "GYMEA BAY",
   "postcode": "2227"
 },
 {
   "suburb": "MIRANDA",
   "postcode": "2228"
 },
 {
   "suburb": "YOWIE BAY",
   "postcode": "2228"
 },
 {
   "suburb": "CARINGBAH",
   "postcode": "2229"
 },
 {
   "suburb": "CARINGBAH SOUTH",
   "postcode": "2229"
 },
 {
   "suburb": "DOLANS BAY",
   "postcode": "2229"
 },
 {
   "suburb": "LILLI PILLI",
   "postcode": "2229"
 },
 {
   "suburb": "PORT HACKING",
   "postcode": "2229"
 },
 {
   "suburb": "TAREN POINT",
   "postcode": "2229"
 },
 {
   "suburb": "BUNDEENA",
   "postcode": "2230"
 },
 {
   "suburb": "BURRANEER",
   "postcode": "2230"
 },
 {
   "suburb": "CRONULLA",
   "postcode": "2230"
 },
 {
   "suburb": "GREENHILLS BEACH",
   "postcode": "2230"
 },
 {
   "suburb": "MAIANBAR",
   "postcode": "2230"
 },
 {
   "suburb": "WOOLOOWARE",
   "postcode": "2230"
 },
 {
   "suburb": "KURNELL",
   "postcode": "2231"
 },
 {
   "suburb": "GRAYS POINT",
   "postcode": "2232"
 },
 {
   "suburb": "KAREELA",
   "postcode": "2232"
 },
 {
   "suburb": "KIRRAWEE",
   "postcode": "2232"
 },
 {
   "suburb": "LOFTUS",
   "postcode": "2232"
 },
 {
   "suburb": "SUTHERLAND",
   "postcode": "2232"
 },
 {
   "suburb": "WORONORA",
   "postcode": "2232"
 },
 {
   "suburb": "ENGADINE",
   "postcode": "2233"
 },
 {
   "suburb": "HEATHCOTE",
   "postcode": "2233"
 },
 {
   "suburb": "WATERFALL",
   "postcode": "2233"
 },
 {
   "suburb": "WORONORA HEIGHTS",
   "postcode": "2233"
 },
 {
   "suburb": "YARRAWARRAH",
   "postcode": "2233"
 },
 {
   "suburb": "ALFORDS POINT",
   "postcode": "2234"
 },
 {
   "suburb": "BANGOR",
   "postcode": "2234"
 },
 {
   "suburb": "BARDEN RIDGE",
   "postcode": "2234"
 },
 {
   "suburb": "ILLAWONG",
   "postcode": "2234"
 },
 {
   "suburb": "LUCAS HEIGHTS",
   "postcode": "2234"
 },
 {
   "suburb": "MENAI",
   "postcode": "2234"
 },
 {
   "suburb": "MENAI CENTRAL",
   "postcode": "2234"
 },
 {
   "suburb": "BUCKETTY",
   "postcode": "2250"
 },
 {
   "suburb": "CALGA",
   "postcode": "2250"
 },
 {
   "suburb": "CENTRAL MANGROVE",
   "postcode": "2250"
 },
 {
   "suburb": "EAST GOSFORD",
   "postcode": "2250"
 },
 {
   "suburb": "ERINA",
   "postcode": "2250"
 },
 {
   "suburb": "ERINA FAIR",
   "postcode": "2250"
 },
 {
   "suburb": "GLENWORTH VALLEY",
   "postcode": "2250"
 },
 {
   "suburb": "GOSFORD",
   "postcode": "2250"
 },
 {
   "suburb": "GREENGROVE",
   "postcode": "2250"
 },
 {
   "suburb": "HOLGATE",
   "postcode": "2250"
 },
 {
   "suburb": "KARIONG",
   "postcode": "2250"
 },
 {
   "suburb": "KULNURA",
   "postcode": "2250"
 },
 {
   "suburb": "LISAROW",
   "postcode": "2250"
 },
 {
   "suburb": "LOWER MANGROVE",
   "postcode": "2250"
 },
 {
   "suburb": "MANGROVE CREEK",
   "postcode": "2250"
 },
 {
   "suburb": "MANGROVE MOUNTAIN",
   "postcode": "2250"
 },
 {
   "suburb": "MATCHAM",
   "postcode": "2250"
 },
 {
   "suburb": "MOONEY MOONEY CREEK",
   "postcode": "2250"
 },
 {
   "suburb": "MOUNT ELLIOT",
   "postcode": "2250"
 },
 {
   "suburb": "MOUNT WHITE",
   "postcode": "2250"
 },
 {
   "suburb": "NARARA",
   "postcode": "2250"
 },
 {
   "suburb": "NIAGARA PARK",
   "postcode": "2250"
 },
 {
   "suburb": "NORTH GOSFORD",
   "postcode": "2250"
 },
 {
   "suburb": "OURIMBAH",
   "postcode": "2250"
 },
 {
   "suburb": "PEATS RIDGE",
   "postcode": "2250"
 },
 {
   "suburb": "POINT CLARE",
   "postcode": "2250"
 },
 {
   "suburb": "POINT FREDERICK",
   "postcode": "2250"
 },
 {
   "suburb": "SOMERSBY",
   "postcode": "2250"
 },
 {
   "suburb": "SPRINGFIELD",
   "postcode": "2250"
 },
 {
   "suburb": "TASCOTT",
   "postcode": "2250"
 },
 {
   "suburb": "TEN MILE HOLLOW",
   "postcode": "2250"
 },
 {
   "suburb": "UPPER MANGROVE",
   "postcode": "2250"
 },
 {
   "suburb": "WENDOREE PARK",
   "postcode": "2250"
 },
 {
   "suburb": "WEST GOSFORD",
   "postcode": "2250"
 },
 {
   "suburb": "WYOMING",
   "postcode": "2250"
 },
 {
   "suburb": "AVOCA BEACH",
   "postcode": "2251"
 },
 {
   "suburb": "BENSVILLE",
   "postcode": "2251"
 },
 {
   "suburb": "BOUDDI",
   "postcode": "2251"
 },
 {
   "suburb": "COPACABANA",
   "postcode": "2251"
 },
 {
   "suburb": "DAVISTOWN",
   "postcode": "2251"
 },
 {
   "suburb": "GREEN POINT",
   "postcode": "2251"
 },
 {
   "suburb": "KINCUMBER",
   "postcode": "2251"
 },
 {
   "suburb": "KINCUMBER SOUTH",
   "postcode": "2251"
 },
 {
   "suburb": "MACMASTERS BEACH",
   "postcode": "2251"
 },
 {
   "suburb": "PICKETTS VALLEY",
   "postcode": "2251"
 },
 {
   "suburb": "SARATOGA",
   "postcode": "2251"
 },
 {
   "suburb": "YATTALUNGA",
   "postcode": "2251"
 },
 {
   "suburb": "BLACKWALL",
   "postcode": "2256"
 },
 {
   "suburb": "HORSFIELD BAY",
   "postcode": "2256"
 },
 {
   "suburb": "KOOLEWONG",
   "postcode": "2256"
 },
 {
   "suburb": "LITTLE WOBBY",
   "postcode": "2256"
 },
 {
   "suburb": "PATONGA",
   "postcode": "2256"
 },
 {
   "suburb": "PEARL BEACH",
   "postcode": "2256"
 },
 {
   "suburb": "PHEGANS BAY",
   "postcode": "2256"
 },
 {
   "suburb": "WONDABYNE",
   "postcode": "2256"
 },
 {
   "suburb": "WOY WOY",
   "postcode": "2256"
 },
 {
   "suburb": "WOY WOY BAY",
   "postcode": "2256"
 },
 {
   "suburb": "BOOKER BAY",
   "postcode": "2257"
 },
 {
   "suburb": "BOX HEAD",
   "postcode": "2257"
 },
 {
   "suburb": "DALEYS POINT",
   "postcode": "2257"
 },
 {
   "suburb": "EMPIRE BAY",
   "postcode": "2257"
 },
 {
   "suburb": "ETTALONG BEACH",
   "postcode": "2257"
 },
 {
   "suburb": "HARDYS BAY",
   "postcode": "2257"
 },
 {
   "suburb": "KILLCARE",
   "postcode": "2257"
 },
 {
   "suburb": "KILLCARE HEIGHTS",
   "postcode": "2257"
 },
 {
   "suburb": "PRETTY BEACH",
   "postcode": "2257"
 },
 {
   "suburb": "ST HUBERTS ISLAND",
   "postcode": "2257"
 },
 {
   "suburb": "UMINA BEACH",
   "postcode": "2257"
 },
 {
   "suburb": "WAGSTAFFE",
   "postcode": "2257"
 },
 {
   "suburb": "FOUNTAINDALE",
   "postcode": "2258"
 },
 {
   "suburb": "KANGY ANGY",
   "postcode": "2258"
 },
 {
   "suburb": "OURIMBAH",
   "postcode": "2258"
 },
 {
   "suburb": "PALM GROVE",
   "postcode": "2258"
 },
 {
   "suburb": "PALMDALE",
   "postcode": "2258"
 },
 {
   "suburb": "ALISON",
   "postcode": "2259"
 },
 {
   "suburb": "BUSHELLS RIDGE",
   "postcode": "2259"
 },
 {
   "suburb": "CEDAR BRUSH CREEK",
   "postcode": "2259"
 },
 {
   "suburb": "CHAIN VALLEY BAY",
   "postcode": "2259"
 },
 {
   "suburb": "CRANGAN BAY",
   "postcode": "2259"
 },
 {
   "suburb": "DOORALONG",
   "postcode": "2259"
 },
 {
   "suburb": "DURREN DURREN",
   "postcode": "2259"
 },
 {
   "suburb": "FRAZER PARK",
   "postcode": "2259"
 },
 {
   "suburb": "FREEMANS",
   "postcode": "2259"
 },
 {
   "suburb": "GWANDALAN",
   "postcode": "2259"
 },
 {
   "suburb": "HALLORAN",
   "postcode": "2259"
 },
 {
   "suburb": "HAMLYN TERRACE",
   "postcode": "2259"
 },
 {
   "suburb": "JILLIBY",
   "postcode": "2259"
 },
 {
   "suburb": "KANWAL",
   "postcode": "2259"
 },
 {
   "suburb": "KIAR",
   "postcode": "2259"
 },
 {
   "suburb": "KINGFISHER SHORES",
   "postcode": "2259"
 },
 {
   "suburb": "LAKE MUNMORAH",
   "postcode": "2259"
 },
 {
   "suburb": "LEMON TREE",
   "postcode": "2259"
 },
 {
   "suburb": "LITTLE JILLIBY",
   "postcode": "2259"
 },
 {
   "suburb": "MANNERING PARK",
   "postcode": "2259"
 },
 {
   "suburb": "MARDI",
   "postcode": "2259"
 },
 {
   "suburb": "MOONEE",
   "postcode": "2259"
 },
 {
   "suburb": "POINT WOLSTONCROFT",
   "postcode": "2259"
 },
 {
   "suburb": "RAVENSDALE",
   "postcode": "2259"
 },
 {
   "suburb": "ROCKY POINT",
   "postcode": "2259"
 },
 {
   "suburb": "SUMMERLAND POINT",
   "postcode": "2259"
 },
 {
   "suburb": "TACOMA",
   "postcode": "2259"
 },
 {
   "suburb": "TACOMA SOUTH",
   "postcode": "2259"
 },
 {
   "suburb": "TUGGERAH",
   "postcode": "2259"
 },
 {
   "suburb": "TUGGERAWONG",
   "postcode": "2259"
 },
 {
   "suburb": "WADALBA",
   "postcode": "2259"
 },
 {
   "suburb": "WALLARAH",
   "postcode": "2259"
 },
 {
   "suburb": "WARNERVALE",
   "postcode": "2259"
 },
 {
   "suburb": "WATANOBBI",
   "postcode": "2259"
 },
 {
   "suburb": "WOONGARRAH",
   "postcode": "2259"
 },
 {
   "suburb": "WYBUNG",
   "postcode": "2259"
 },
 {
   "suburb": "WYEE",
   "postcode": "2259"
 },
 {
   "suburb": "WYEE POINT",
   "postcode": "2259"
 },
 {
   "suburb": "WYONG",
   "postcode": "2259"
 },
 {
   "suburb": "WYONG CREEK",
   "postcode": "2259"
 },
 {
   "suburb": "WYONGAH",
   "postcode": "2259"
 },
 {
   "suburb": "YARRAMALONG",
   "postcode": "2259"
 },
 {
   "suburb": "ERINA HEIGHTS",
   "postcode": "2260"
 },
 {
   "suburb": "FORRESTERS BEACH",
   "postcode": "2260"
 },
 {
   "suburb": "NORTH AVOCA",
   "postcode": "2260"
 },
 {
   "suburb": "TERRIGAL",
   "postcode": "2260"
 },
 {
   "suburb": "WAMBERAL",
   "postcode": "2260"
 },
 {
   "suburb": "BATEAU BAY",
   "postcode": "2261"
 },
 {
   "suburb": "BAY VILLAGE",
   "postcode": "2261"
 },
 {
   "suburb": "BERKELEY VALE",
   "postcode": "2261"
 },
 {
   "suburb": "BLUE BAY",
   "postcode": "2261"
 },
 {
   "suburb": "CHITTAWAY BAY",
   "postcode": "2261"
 },
 {
   "suburb": "CHITTAWAY POINT",
   "postcode": "2261"
 },
 {
   "suburb": "GLENNING VALLEY",
   "postcode": "2261"
 },
 {
   "suburb": "KILLARNEY VALE",
   "postcode": "2261"
 },
 {
   "suburb": "LONG JETTY",
   "postcode": "2261"
 },
 {
   "suburb": "MAGENTA",
   "postcode": "2261"
 },
 {
   "suburb": "SHELLY BEACH",
   "postcode": "2261"
 },
 {
   "suburb": "THE ENTRANCE",
   "postcode": "2261"
 },
 {
   "suburb": "THE ENTRANCE NORTH",
   "postcode": "2261"
 },
 {
   "suburb": "TOOWOON BAY",
   "postcode": "2261"
 },
 {
   "suburb": "TUMBI UMBI",
   "postcode": "2261"
 },
 {
   "suburb": "BLUE HAVEN",
   "postcode": "2262"
 },
 {
   "suburb": "BUDGEWOI",
   "postcode": "2262"
 },
 {
   "suburb": "BUDGEWOI PENINSULA",
   "postcode": "2262"
 },
 {
   "suburb": "BUFF POINT",
   "postcode": "2262"
 },
 {
   "suburb": "COLONGRA",
   "postcode": "2262"
 },
 {
   "suburb": "DOYALSON",
   "postcode": "2262"
 },
 {
   "suburb": "DOYALSON NORTH",
   "postcode": "2262"
 },
 {
   "suburb": "HALEKULANI",
   "postcode": "2262"
 },
 {
   "suburb": "SAN REMO",
   "postcode": "2262"
 },
 {
   "suburb": "CANTON BEACH",
   "postcode": "2263"
 },
 {
   "suburb": "CHARMHAVEN",
   "postcode": "2263"
 },
 {
   "suburb": "GOROKAN",
   "postcode": "2263"
 },
 {
   "suburb": "LAKE HAVEN",
   "postcode": "2263"
 },
 {
   "suburb": "NORAH HEAD",
   "postcode": "2263"
 },
 {
   "suburb": "NORAVILLE",
   "postcode": "2263"
 },
 {
   "suburb": "TOUKLEY",
   "postcode": "2263"
 },
 {
   "suburb": "BALCOLYN",
   "postcode": "2264"
 },
 {
   "suburb": "BONNELLS BAY",
   "postcode": "2264"
 },
 {
   "suburb": "BRIGHTWATERS",
   "postcode": "2264"
 },
 {
   "suburb": "DORA CREEK",
   "postcode": "2264"
 },
 {
   "suburb": "ERARING",
   "postcode": "2264"
 },
 {
   "suburb": "MANDALONG",
   "postcode": "2264"
 },
 {
   "suburb": "MIRRABOOKA",
   "postcode": "2264"
 },
 {
   "suburb": "MORISSET",
   "postcode": "2264"
 },
 {
   "suburb": "MORISSET PARK",
   "postcode": "2264"
 },
 {
   "suburb": "MYUNA BAY",
   "postcode": "2264"
 },
 {
   "suburb": "SILVERWATER",
   "postcode": "2264"
 },
 {
   "suburb": "SUNSHINE",
   "postcode": "2264"
 },
 {
   "suburb": "WINDERMERE PARK",
   "postcode": "2264"
 },
 {
   "suburb": "YARRAWONGA PARK",
   "postcode": "2264"
 },
 {
   "suburb": "COORANBONG",
   "postcode": "2265"
 },
 {
   "suburb": "MARTINSVILLE",
   "postcode": "2265"
 },
 {
   "suburb": "WANGI WANGI",
   "postcode": "2267"
 },
 {
   "suburb": "BARNSLEY",
   "postcode": "2278"
 },
 {
   "suburb": "KILLINGWORTH",
   "postcode": "2278"
 },
 {
   "suburb": "WAKEFIELD",
   "postcode": "2278"
 },
 {
   "suburb": "BELMONT",
   "postcode": "2280"
 },
 {
   "suburb": "BELMONT NORTH",
   "postcode": "2280"
 },
 {
   "suburb": "BELMONT SOUTH",
   "postcode": "2280"
 },
 {
   "suburb": "CROUDACE BAY",
   "postcode": "2280"
 },
 {
   "suburb": "FLORAVILLE",
   "postcode": "2280"
 },
 {
   "suburb": "JEWELLS",
   "postcode": "2280"
 },
 {
   "suburb": "MARKS POINT",
   "postcode": "2280"
 },
 {
   "suburb": "VALENTINE",
   "postcode": "2280"
 },
 {
   "suburb": "BLACKSMITHS",
   "postcode": "2281"
 },
 {
   "suburb": "CAMS WHARF",
   "postcode": "2281"
 },
 {
   "suburb": "CATHERINE HILL BAY",
   "postcode": "2281"
 },
 {
   "suburb": "CAVES BEACH",
   "postcode": "2281"
 },
 {
   "suburb": "LITTLE PELICAN",
   "postcode": "2281"
 },
 {
   "suburb": "MURRAYS BEACH",
   "postcode": "2281"
 },
 {
   "suburb": "NORDS WHARF",
   "postcode": "2281"
 },
 {
   "suburb": "PELICAN",
   "postcode": "2281"
 },
 {
   "suburb": "PINNY BEACH",
   "postcode": "2281"
 },
 {
   "suburb": "SWANSEA",
   "postcode": "2281"
 },
 {
   "suburb": "SWANSEA HEADS",
   "postcode": "2281"
 },
 {
   "suburb": "ELEEBANA",
   "postcode": "2282"
 },
 {
   "suburb": "LAKELANDS",
   "postcode": "2282"
 },
 {
   "suburb": "WARNERS BAY",
   "postcode": "2282"
 },
 {
   "suburb": "ARCADIA VALE",
   "postcode": "2283"
 },
 {
   "suburb": "AWABA",
   "postcode": "2283"
 },
 {
   "suburb": "BALMORAL",
   "postcode": "2283"
 },
 {
   "suburb": "BLACKALLS PARK",
   "postcode": "2283"
 },
 {
   "suburb": "BOLTON POINT",
   "postcode": "2283"
 },
 {
   "suburb": "BUTTABA",
   "postcode": "2283"
 },
 {
   "suburb": "CAREY BAY",
   "postcode": "2283"
 },
 {
   "suburb": "COAL POINT",
   "postcode": "2283"
 },
 {
   "suburb": "FASSIFERN",
   "postcode": "2283"
 },
 {
   "suburb": "FENNELL BAY",
   "postcode": "2283"
 },
 {
   "suburb": "FISHING POINT",
   "postcode": "2283"
 },
 {
   "suburb": "KILABEN BAY",
   "postcode": "2283"
 },
 {
   "suburb": "RATHMINES",
   "postcode": "2283"
 },
 {
   "suburb": "RYHOPE",
   "postcode": "2283"
 },
 {
   "suburb": "TORONTO",
   "postcode": "2283"
 },
 {
   "suburb": "ARGENTON",
   "postcode": "2284"
 },
 {
   "suburb": "BOOLAROO",
   "postcode": "2284"
 },
 {
   "suburb": "BOORAGUL",
   "postcode": "2284"
 },
 {
   "suburb": "MARMONG POINT",
   "postcode": "2284"
 },
 {
   "suburb": "SPEERS POINT",
   "postcode": "2284"
 },
 {
   "suburb": "TERALBA",
   "postcode": "2284"
 },
 {
   "suburb": "WOODRISING",
   "postcode": "2284"
 },
 {
   "suburb": "CAMERON PARK",
   "postcode": "2285"
 },
 {
   "suburb": "CARDIFF",
   "postcode": "2285"
 },
 {
   "suburb": "CARDIFF HEIGHTS",
   "postcode": "2285"
 },
 {
   "suburb": "CARDIFF SOUTH",
   "postcode": "2285"
 },
 {
   "suburb": "EDGEWORTH",
   "postcode": "2285"
 },
 {
   "suburb": "GLENDALE",
   "postcode": "2285"
 },
 {
   "suburb": "MACQUARIE HILLS",
   "postcode": "2285"
 },
 {
   "suburb": "HOLMESVILLE",
   "postcode": "2286"
 },
 {
   "suburb": "SEAHAMPTON",
   "postcode": "2286"
 },
 {
   "suburb": "WEST WALLSEND",
   "postcode": "2286"
 },
 {
   "suburb": "BIRMINGHAM GARDENS",
   "postcode": "2287"
 },
 {
   "suburb": "ELERMORE VALE",
   "postcode": "2287"
 },
 {
   "suburb": "FLETCHER",
   "postcode": "2287"
 },
 {
   "suburb": "MARYLAND",
   "postcode": "2287"
 },
 {
   "suburb": "MINMI",
   "postcode": "2287"
 },
 {
   "suburb": "RANKIN PARK",
   "postcode": "2287"
 },
 {
   "suburb": "WALLSEND",
   "postcode": "2287"
 },
 {
   "suburb": "WALLSEND SOUTH",
   "postcode": "2287"
 },
 {
   "suburb": "ADAMSTOWN",
   "postcode": "2289"
 },
 {
   "suburb": "ADAMSTOWN HEIGHTS",
   "postcode": "2289"
 },
 {
   "suburb": "GARDEN suburb",
   "postcode": "2289"
 },
 {
   "suburb": "HIGHFIELDS",
   "postcode": "2289"
 },
 {
   "suburb": "KOTARA",
   "postcode": "2289"
 },
 {
   "suburb": "KOTARA FAIR",
   "postcode": "2289"
 },
 {
   "suburb": "KOTARA SOUTH",
   "postcode": "2289"
 },
 {
   "suburb": "BENNETTS GREEN",
   "postcode": "2290"
 },
 {
   "suburb": "CHARLESTOWN",
   "postcode": "2290"
 },
 {
   "suburb": "DUDLEY",
   "postcode": "2290"
 },
 {
   "suburb": "GATESHEAD",
   "postcode": "2290"
 },
 {
   "suburb": "HILLSBOROUGH",
   "postcode": "2290"
 },
 {
   "suburb": "KAHIBAH",
   "postcode": "2290"
 },
 {
   "suburb": "MOUNT HUTTON",
   "postcode": "2290"
 },
 {
   "suburb": "REDHEAD",
   "postcode": "2290"
 },
 {
   "suburb": "TINGIRA HEIGHTS",
   "postcode": "2290"
 },
 {
   "suburb": "WHITEBRIDGE",
   "postcode": "2290"
 },
 {
   "suburb": "MEREWETHER",
   "postcode": "2291"
 },
 {
   "suburb": "MEREWETHER HEIGHTS",
   "postcode": "2291"
 },
 {
   "suburb": "THE JUNCTION",
   "postcode": "2291"
 },
 {
   "suburb": "BROADMEADOW",
   "postcode": "2292"
 },
 {
   "suburb": "HAMILTON NORTH",
   "postcode": "2292"
 },
 {
   "suburb": "MARYVILLE",
   "postcode": "2293"
 },
 {
   "suburb": "WICKHAM",
   "postcode": "2293"
 },
 {
   "suburb": "CARRINGTON",
   "postcode": "2294"
 },
 {
   "suburb": "FERN BAY",
   "postcode": "2295"
 },
 {
   "suburb": "STOCKTON",
   "postcode": "2295"
 },
 {
   "suburb": "ISLINGTON",
   "postcode": "2296"
 },
 {
   "suburb": "TIGHES HILL",
   "postcode": "2297"
 },
 {
   "suburb": "GEORGETOWN",
   "postcode": "2298"
 },
 {
   "suburb": "WARATAH",
   "postcode": "2298"
 },
 {
   "suburb": "WARATAH WEST",
   "postcode": "2298"
 },
 {
   "suburb": "JESMOND",
   "postcode": "2299"
 },
 {
   "suburb": "LAMBTON",
   "postcode": "2299"
 },
 {
   "suburb": "NORTH LAMBTON",
   "postcode": "2299"
 },
 {
   "suburb": "BAR BEACH",
   "postcode": "2300"
 },
 {
   "suburb": "COOKS HILL",
   "postcode": "2300"
 },
 {
   "suburb": "NEWCASTLE",
   "postcode": "2300"
 },
 {
   "suburb": "NEWCASTLE EAST",
   "postcode": "2300"
 },
 {
   "suburb": "THE HILL",
   "postcode": "2300"
 },
 {
   "suburb": "NEWCASTLE WEST",
   "postcode": "2302"
 },
 {
   "suburb": "HAMILTON",
   "postcode": "2303"
 },
 {
   "suburb": "HAMILTON EAST",
   "postcode": "2303"
 },
 {
   "suburb": "HAMILTON SOUTH",
   "postcode": "2303"
 },
 {
   "suburb": "KOORAGANG",
   "postcode": "2304"
 },
 {
   "suburb": "MAYFIELD",
   "postcode": "2304"
 },
 {
   "suburb": "MAYFIELD EAST",
   "postcode": "2304"
 },
 {
   "suburb": "MAYFIELD NORTH",
   "postcode": "2304"
 },
 {
   "suburb": "MAYFIELD WEST",
   "postcode": "2304"
 },
 {
   "suburb": "SANDGATE",
   "postcode": "2304"
 },
 {
   "suburb": "WARABROOK",
   "postcode": "2304"
 },
 {
   "suburb": "KOTARA EAST",
   "postcode": "2305"
 },
 {
   "suburb": "NEW LAMBTON",
   "postcode": "2305"
 },
 {
   "suburb": "NEW LAMBTON HEIGHTS",
   "postcode": "2305"
 },
 {
   "suburb": "WINDALE",
   "postcode": "2306"
 },
 {
   "suburb": "SHORTLAND",
   "postcode": "2307"
 },
 {
   "suburb": "CALLAGHAN",
   "postcode": "2308"
 },
 {
   "suburb": "NEWCASTLE UNIVERSITY",
   "postcode": "2308"
 },
 {
   "suburb": "DANGAR",
   "postcode": "2309"
 },
 {
   "suburb": "MINIMBAH",
   "postcode": "2312"
 },
 {
   "suburb": "NABIAC",
   "postcode": "2312"
 },
 {
   "suburb": "CORLETTE",
   "postcode": "2315"
 },
 {
   "suburb": "FINGAL BAY",
   "postcode": "2315"
 },
 {
   "suburb": "NELSON BAY",
   "postcode": "2315"
 },
 {
   "suburb": "SHOAL BAY",
   "postcode": "2315"
 },
 {
   "suburb": "ANNA BAY",
   "postcode": "2316"
 },
 {
   "suburb": "BOAT HARBOUR",
   "postcode": "2316"
 },
 {
   "suburb": "BOBS FARM",
   "postcode": "2316"
 },
 {
   "suburb": "FISHERMANS BAY",
   "postcode": "2316"
 },
 {
   "suburb": "ONE MILE",
   "postcode": "2316"
 },
 {
   "suburb": "TAYLORS BEACH",
   "postcode": "2316"
 },
 {
   "suburb": "SALAMANDER BAY",
   "postcode": "2317"
 },
 {
   "suburb": "SOLDIERS POINT",
   "postcode": "2317"
 },
 {
   "suburb": "CAMPVALE",
   "postcode": "2318"
 },
 {
   "suburb": "FERODALE",
   "postcode": "2318"
 },
 {
   "suburb": "FULLERTON COVE",
   "postcode": "2318"
 },
 {
   "suburb": "MEDOWIE",
   "postcode": "2318"
 },
 {
   "suburb": "OYSTER COVE",
   "postcode": "2318"
 },
 {
   "suburb": "SALT ASH",
   "postcode": "2318"
 },
 {
   "suburb": "WILLIAMTOWN",
   "postcode": "2318"
 },
 {
   "suburb": "LEMON TREE PASSAGE",
   "postcode": "2319"
 },
 {
   "suburb": "MALLABULA",
   "postcode": "2319"
 },
 {
   "suburb": "TANILBA BAY",
   "postcode": "2319"
 },
 {
   "suburb": "TILLIGERRY CREEK",
   "postcode": "2319"
 },
 {
   "suburb": "ABERGLASSLYN",
   "postcode": "2320"
 },
 {
   "suburb": "ALLANDALE",
   "postcode": "2320"
 },
 {
   "suburb": "ANAMBAH",
   "postcode": "2320"
 },
 {
   "suburb": "BOLWARRA",
   "postcode": "2320"
 },
 {
   "suburb": "BOLWARRA HEIGHTS",
   "postcode": "2320"
 },
 {
   "suburb": "FARLEY",
   "postcode": "2320"
 },
 {
   "suburb": "GLEN OAK",
   "postcode": "2320"
 },
 {
   "suburb": "GOSFORTH",
   "postcode": "2320"
 },
 {
   "suburb": "HILLSBOROUGH",
   "postcode": "2320"
 },
 {
   "suburb": "HORSESHOE BEND",
   "postcode": "2320"
 },
 {
   "suburb": "KEINBAH",
   "postcode": "2320"
 },
 {
   "suburb": "LARGS",
   "postcode": "2320"
 },
 {
   "suburb": "LORN",
   "postcode": "2320"
 },
 {
   "suburb": "LOUTH PARK",
   "postcode": "2320"
 },
 {
   "suburb": "MAITLAND",
   "postcode": "2320"
 },
 {
   "suburb": "MAITLAND NORTH",
   "postcode": "2320"
 },
 {
   "suburb": "MAITLAND VALE",
   "postcode": "2320"
 },
 {
   "suburb": "MELVILLE",
   "postcode": "2320"
 },
 {
   "suburb": "MINDARIBBA",
   "postcode": "2320"
 },
 {
   "suburb": "MOUNT DEE",
   "postcode": "2320"
 },
 {
   "suburb": "OAKHAMPTON",
   "postcode": "2320"
 },
 {
   "suburb": "OAKHAMPTON HEIGHTS",
   "postcode": "2320"
 },
 {
   "suburb": "POKOLBIN",
   "postcode": "2320"
 },
 {
   "suburb": "ROSEBROOK",
   "postcode": "2320"
 },
 {
   "suburb": "ROTHBURY",
   "postcode": "2320"
 },
 {
   "suburb": "RUTHERFORD",
   "postcode": "2320"
 },
 {
   "suburb": "SOUTH MAITLAND",
   "postcode": "2320"
 },
 {
   "suburb": "TELARAH",
   "postcode": "2320"
 },
 {
   "suburb": "WALLALONG",
   "postcode": "2320"
 },
 {
   "suburb": "WINDELLA",
   "postcode": "2320"
 },
 {
   "suburb": "BERRY PARK",
   "postcode": "2321"
 },
 {
   "suburb": "BUTTERWICK",
   "postcode": "2321"
 },
 {
   "suburb": "CLARENCE TOWN",
   "postcode": "2321"
 },
 {
   "suburb": "CLIFTLEIGH",
   "postcode": "2321"
 },
 {
   "suburb": "DUCKENFIELD",
   "postcode": "2321"
 },
 {
   "suburb": "DUNS CREEK",
   "postcode": "2321"
 },
 {
   "suburb": "GILLIESTON HEIGHTS",
   "postcode": "2321"
 },
 {
   "suburb": "GLEN MARTIN",
   "postcode": "2321"
 },
 {
   "suburb": "GLEN WILLIAM",
   "postcode": "2321"
 },
 {
   "suburb": "HARPERS HILL",
   "postcode": "2321"
 },
 {
   "suburb": "HEDDON GRETA",
   "postcode": "2321"
 },
 {
   "suburb": "HINTON",
   "postcode": "2321"
 },
 {
   "suburb": "LOCHINVAR",
   "postcode": "2321"
 },
 {
   "suburb": "LUSKINTYRE",
   "postcode": "2321"
 },
 {
   "suburb": "MORPETH",
   "postcode": "2321"
 },
 {
   "suburb": "OSWALD",
   "postcode": "2321"
 },
 {
   "suburb": "PHOENIX PARK",
   "postcode": "2321"
 },
 {
   "suburb": "RAWORTH",
   "postcode": "2321"
 },
 {
   "suburb": "WINDERMERE",
   "postcode": "2321"
 },
 {
   "suburb": "WOODVILLE",
   "postcode": "2321"
 },
 {
   "suburb": "BERESFIELD",
   "postcode": "2322"
 },
 {
   "suburb": "BLACK HILL",
   "postcode": "2322"
 },
 {
   "suburb": "CHISHOLM",
   "postcode": "2322"
 },
 {
   "suburb": "HEXHAM",
   "postcode": "2322"
 },
 {
   "suburb": "LENAGHAN",
   "postcode": "2322"
 },
 {
   "suburb": "STOCKRINGTON",
   "postcode": "2322"
 },
 {
   "suburb": "TARRO",
   "postcode": "2322"
 },
 {
   "suburb": "THORNTON",
   "postcode": "2322"
 },
 {
   "suburb": "TOMAGO",
   "postcode": "2322"
 },
 {
   "suburb": "WOODBERRY",
   "postcode": "2322"
 },
 {
   "suburb": "ASHTONFIELD",
   "postcode": "2323"
 },
 {
   "suburb": "BRUNKERVILLE",
   "postcode": "2323"
 },
 {
   "suburb": "BUCHANAN",
   "postcode": "2323"
 },
 {
   "suburb": "BUTTAI",
   "postcode": "2323"
 },
 {
   "suburb": "EAST MAITLAND",
   "postcode": "2323"
 },
 {
   "suburb": "FOUR MILE CREEK",
   "postcode": "2323"
 },
 {
   "suburb": "FREEMANS WATERHOLE",
   "postcode": "2323"
 },
 {
   "suburb": "GREENHILLS",
   "postcode": "2323"
 },
 {
   "suburb": "METFORD",
   "postcode": "2323"
 },
 {
   "suburb": "MOUNT VINCENT",
   "postcode": "2323"
 },
 {
   "suburb": "MULBRING",
   "postcode": "2323"
 },
 {
   "suburb": "PITNACREE",
   "postcode": "2323"
 },
 {
   "suburb": "RICHMOND VALE",
   "postcode": "2323"
 },
 {
   "suburb": "TENAMBIT",
   "postcode": "2323"
 },
 {
   "suburb": "BALICKERA",
   "postcode": "2324"
 },
 {
   "suburb": "BRANDY HILL",
   "postcode": "2324"
 },
 {
   "suburb": "BUNDABAH",
   "postcode": "2324"
 },
 {
   "suburb": "CARRINGTON",
   "postcode": "2324"
 },
 {
   "suburb": "EAGLETON",
   "postcode": "2324"
 },
 {
   "suburb": "EAST SEAHAM",
   "postcode": "2324"
 },
 {
   "suburb": "HAWKS NEST",
   "postcode": "2324"
 },
 {
   "suburb": "HEATHERBRAE",
   "postcode": "2324"
 },
 {
   "suburb": "KARUAH",
   "postcode": "2324"
 },
 {
   "suburb": "LIMEBURNERS CREEK",
   "postcode": "2324"
 },
 {
   "suburb": "MILLERS FOREST",
   "postcode": "2324"
 },
 {
   "suburb": "NELSONS PLAINS",
   "postcode": "2324"
 },
 {
   "suburb": "NORTH ARM COVE",
   "postcode": "2324"
 },
 {
   "suburb": "OSTERLEY",
   "postcode": "2324"
 },
 {
   "suburb": "PINDIMAR",
   "postcode": "2324"
 },
 {
   "suburb": "RAYMOND TERRACE",
   "postcode": "2324"
 },
 {
   "suburb": "RAYMOND TERRACE EAST",
   "postcode": "2324"
 },
 {
   "suburb": "SEAHAM",
   "postcode": "2324"
 },
 {
   "suburb": "SWAN BAY",
   "postcode": "2324"
 },
 {
   "suburb": "TAHLEE",
   "postcode": "2324"
 },
 {
   "suburb": "TEA GARDENS",
   "postcode": "2324"
 },
 {
   "suburb": "TWELVE MILE CREEK",
   "postcode": "2324"
 },
 {
   "suburb": "ABERDARE",
   "postcode": "2325"
 },
 {
   "suburb": "ABERNETHY",
   "postcode": "2325"
 },
 {
   "suburb": "BELLBIRD",
   "postcode": "2325"
 },
 {
   "suburb": "BELLBIRD HEIGHTS",
   "postcode": "2325"
 },
 {
   "suburb": "CESSNOCK",
   "postcode": "2325"
 },
 {
   "suburb": "CESSNOCK WEST",
   "postcode": "2325"
 },
 {
   "suburb": "CONGEWAI",
   "postcode": "2325"
 },
 {
   "suburb": "ELLALONG",
   "postcode": "2325"
 },
 {
   "suburb": "ELRINGTON",
   "postcode": "2325"
 },
 {
   "suburb": "GRETA MAIN",
   "postcode": "2325"
 },
 {
   "suburb": "KEARSLEY",
   "postcode": "2325"
 },
 {
   "suburb": "KITCHENER",
   "postcode": "2325"
 },
 {
   "suburb": "LAGUNA",
   "postcode": "2325"
 },
 {
   "suburb": "LOVEDALE",
   "postcode": "2325"
 },
 {
   "suburb": "MILLFIELD",
   "postcode": "2325"
 },
 {
   "suburb": "MORUBEN",
   "postcode": "2325"
 },
 {
   "suburb": "MOUNT VIEW",
   "postcode": "2325"
 },
 {
   "suburb": "NULKABA",
   "postcode": "2325"
 },
 {
   "suburb": "PAXTON",
   "postcode": "2325"
 },
 {
   "suburb": "PELTON",
   "postcode": "2325"
 },
 {
   "suburb": "QUORROBOLONG",
   "postcode": "2325"
 },
 {
   "suburb": "WOLLOMBI",
   "postcode": "2325"
 },
 {
   "suburb": "ABERMAIN",
   "postcode": "2326"
 },
 {
   "suburb": "BISHOPS BRIDGE",
   "postcode": "2326"
 },
 {
   "suburb": "LOXFORD",
   "postcode": "2326"
 },
 {
   "suburb": "NEATH",
   "postcode": "2326"
 },
 {
   "suburb": "SAWYERS GULLY",
   "postcode": "2326"
 },
 {
   "suburb": "WESTON",
   "postcode": "2326"
 },
 {
   "suburb": "KURRI KURRI",
   "postcode": "2327"
 },
 {
   "suburb": "PELAW MAIN",
   "postcode": "2327"
 },
 {
   "suburb": "STANFORD MERTHYR",
   "postcode": "2327"
 },
 {
   "suburb": "BUREEN",
   "postcode": "2328"
 },
 {
   "suburb": "DENMAN",
   "postcode": "2328"
 },
 {
   "suburb": "HOLLYDEEN",
   "postcode": "2328"
 },
 {
   "suburb": "MANGOOLA",
   "postcode": "2328"
 },
 {
   "suburb": "MARTINDALE",
   "postcode": "2328"
 },
 {
   "suburb": "YARRAWA",
   "postcode": "2328"
 },
 {
   "suburb": "BORAMBIL",
   "postcode": "2329"
 },
 {
   "suburb": "MERRIWA",
   "postcode": "2329"
 },
 {
   "suburb": "APPLETREE FLAT",
   "postcode": "2330"
 },
 {
   "suburb": "BIG RIDGE",
   "postcode": "2330"
 },
 {
   "suburb": "BIG YENGO",
   "postcode": "2330"
 },
 {
   "suburb": "BOWMANS CREEK",
   "postcode": "2330"
 },
 {
   "suburb": "BRIDGMAN",
   "postcode": "2330"
 },
 {
   "suburb": "BROKE",
   "postcode": "2330"
 },
 {
   "suburb": "BULGA",
   "postcode": "2330"
 },
 {
   "suburb": "CAMBERWELL",
   "postcode": "2330"
 },
 {
   "suburb": "CARROWBROOK",
   "postcode": "2330"
 },
 {
   "suburb": "CLYDESDALE",
   "postcode": "2330"
 },
 {
   "suburb": "COMBO",
   "postcode": "2330"
 },
 {
   "suburb": "DARLINGTON",
   "postcode": "2330"
 },
 {
   "suburb": "DOYLES CREEK",
   "postcode": "2330"
 },
 {
   "suburb": "DUNOLLY",
   "postcode": "2330"
 },
 {
   "suburb": "DURAL",
   "postcode": "2330"
 },
 {
   "suburb": "DYRRING",
   "postcode": "2330"
 },
 {
   "suburb": "FALBROOK",
   "postcode": "2330"
 },
 {
   "suburb": "FERN GULLY",
   "postcode": "2330"
 },
 {
   "suburb": "FORDWICH",
   "postcode": "2330"
 },
 {
   "suburb": "GLENDON",
   "postcode": "2330"
 },
 {
   "suburb": "GLENDON BROOK",
   "postcode": "2330"
 },
 {
   "suburb": "GLENNIES CREEK",
   "postcode": "2330"
 },
 {
   "suburb": "GLENRIDDING",
   "postcode": "2330"
 },
 {
   "suburb": "GOORANGOOLA",
   "postcode": "2330"
 },
 {
   "suburb": "GOULDSVILLE",
   "postcode": "2330"
 },
 {
   "suburb": "GOWRIE",
   "postcode": "2330"
 },
 {
   "suburb": "GREENLANDS",
   "postcode": "2330"
 },
 {
   "suburb": "HAMBLEDON HILL",
   "postcode": "2330"
 },
 {
   "suburb": "HEBDEN",
   "postcode": "2330"
 },
 {
   "suburb": "HOWICK",
   "postcode": "2330"
 },
 {
   "suburb": "HUNTERVIEW",
   "postcode": "2330"
 },
 {
   "suburb": "JERRYS PLAINS",
   "postcode": "2330"
 },
 {
   "suburb": "LEMINGTON",
   "postcode": "2330"
 },
 {
   "suburb": "LONG POINT",
   "postcode": "2330"
 },
 {
   "suburb": "MAISON DIEU",
   "postcode": "2330"
 },
 {
   "suburb": "MCDOUGALLS HILL",
   "postcode": "2330"
 },
 {
   "suburb": "MIDDLE FALBROOK",
   "postcode": "2330"
 },
 {
   "suburb": "MILBRODALE",
   "postcode": "2330"
 },
 {
   "suburb": "MIRANNIE",
   "postcode": "2330"
 },
 {
   "suburb": "MITCHELLS FLAT",
   "postcode": "2330"
 },
 {
   "suburb": "MOUNT OLIVE",
   "postcode": "2330"
 },
 {
   "suburb": "MOUNT ROYAL",
   "postcode": "2330"
 },
 {
   "suburb": "MOUNT THORLEY",
   "postcode": "2330"
 },
 {
   "suburb": "OBANVALE",
   "postcode": "2330"
 },
 {
   "suburb": "RAVENSWORTH",
   "postcode": "2330"
 },
 {
   "suburb": "REDBOURNBERRY",
   "postcode": "2330"
 },
 {
   "suburb": "REEDY CREEK",
   "postcode": "2330"
 },
 {
   "suburb": "RIXS CREEK",
   "postcode": "2330"
 },
 {
   "suburb": "ROUGHIT",
   "postcode": "2330"
 },
 {
   "suburb": "SCOTTS FLAT",
   "postcode": "2330"
 },
 {
   "suburb": "SEDGEFIELD",
   "postcode": "2330"
 },
 {
   "suburb": "SINGLETON",
   "postcode": "2330"
 },
 {
   "suburb": "SINGLETON HEIGHTS",
   "postcode": "2330"
 },
 {
   "suburb": "ST CLAIR",
   "postcode": "2330"
 },
 {
   "suburb": "WARKWORTH",
   "postcode": "2330"
 },
 {
   "suburb": "WATTLE PONDS",
   "postcode": "2330"
 },
 {
   "suburb": "WESTBROOK",
   "postcode": "2330"
 },
 {
   "suburb": "WHITTINGHAM",
   "postcode": "2330"
 },
 {
   "suburb": "WYLIES FLAT",
   "postcode": "2330"
 },
 {
   "suburb": "BAERAMI",
   "postcode": "2333"
 },
 {
   "suburb": "BENGALLA",
   "postcode": "2333"
 },
 {
   "suburb": "CASTLE ROCK",
   "postcode": "2333"
 },
 {
   "suburb": "EDDERTON",
   "postcode": "2333"
 },
 {
   "suburb": "GUNGAL",
   "postcode": "2333"
 },
 {
   "suburb": "KAYUGA",
   "postcode": "2333"
 },
 {
   "suburb": "LIDDELL",
   "postcode": "2333"
 },
 {
   "suburb": "MCCULLYS GAP",
   "postcode": "2333"
 },
 {
   "suburb": "MUSCLE CREEK",
   "postcode": "2333"
 },
 {
   "suburb": "MUSWELLBROOK",
   "postcode": "2333"
 },
 {
   "suburb": "SANDY HOLLOW",
   "postcode": "2333"
 },
 {
   "suburb": "WYBONG",
   "postcode": "2333"
 },
 {
   "suburb": "GRETA",
   "postcode": "2334"
 },
 {
   "suburb": "BELFORD",
   "postcode": "2335"
 },
 {
   "suburb": "BRANXTON",
   "postcode": "2335"
 },
 {
   "suburb": "DALWOOD",
   "postcode": "2335"
 },
 {
   "suburb": "EAST BRANXTON",
   "postcode": "2335"
 },
 {
   "suburb": "ELDERSLIE",
   "postcode": "2335"
 },
 {
   "suburb": "LAMBS VALLEY",
   "postcode": "2335"
 },
 {
   "suburb": "LECONFIELD",
   "postcode": "2335"
 },
 {
   "suburb": "LOWER BELFORD",
   "postcode": "2335"
 },
 {
   "suburb": "NORTH ROTHBURY",
   "postcode": "2335"
 },
 {
   "suburb": "STANHOPE",
   "postcode": "2335"
 },
 {
   "suburb": "ABERDEEN",
   "postcode": "2336"
 },
 {
   "suburb": "DARTBROOK",
   "postcode": "2336"
 },
 {
   "suburb": "DAVIS CREEK",
   "postcode": "2336"
 },
 {
   "suburb": "ROSSGOLE",
   "postcode": "2336"
 },
 {
   "suburb": "ROUCHEL",
   "postcode": "2336"
 },
 {
   "suburb": "ROUCHEL BROOK",
   "postcode": "2336"
 },
 {
   "suburb": "UPPER DARTBROOK",
   "postcode": "2336"
 },
 {
   "suburb": "UPPER ROUCHEL",
   "postcode": "2336"
 },
 {
   "suburb": "DRY CREEK",
   "postcode": "2337"
 },
 {
   "suburb": "GLENBAWN",
   "postcode": "2337"
 },
 {
   "suburb": "MIDDLE BROOK",
   "postcode": "2337"
 },
 {
   "suburb": "MOOBI",
   "postcode": "2337"
 },
 {
   "suburb": "MURULLA",
   "postcode": "2337"
 },
 {
   "suburb": "PARKVILLE",
   "postcode": "2337"
 },
 {
   "suburb": "SCONE",
   "postcode": "2337"
 },
 {
   "suburb": "SEGENHOE",
   "postcode": "2337"
 },
 {
   "suburb": "WINGEN",
   "postcode": "2337"
 },
 {
   "suburb": "ARDGLEN",
   "postcode": "2338"
 },
 {
   "suburb": "BLANDFORD",
   "postcode": "2338"
 },
 {
   "suburb": "MURRURUNDI",
   "postcode": "2338"
 },
 {
   "suburb": "BRAEFIELD",
   "postcode": "2339"
 },
 {
   "suburb": "WARRAH",
   "postcode": "2339"
 },
 {
   "suburb": "WILLOW TREE",
   "postcode": "2339"
 },
 {
   "suburb": "BECTIVE",
   "postcode": "2340"
 },
 {
   "suburb": "BITHRAMERE",
   "postcode": "2340"
 },
 {
   "suburb": "CALALA",
   "postcode": "2340"
 },
 {
   "suburb": "CARROLL",
   "postcode": "2340"
 },
 {
   "suburb": "DARUKA",
   "postcode": "2340"
 },
 {
   "suburb": "DUNGOWAN",
   "postcode": "2340"
 },
 {
   "suburb": "EAST TAMWORTH",
   "postcode": "2340"
 },
 {
   "suburb": "GAROO",
   "postcode": "2340"
 },
 {
   "suburb": "GIDLEY",
   "postcode": "2340"
 },
 {
   "suburb": "GOONOO GOONOO",
   "postcode": "2340"
 },
 {
   "suburb": "GOWRIE",
   "postcode": "2340"
 },
 {
   "suburb": "HALLSVILLE",
   "postcode": "2340"
 },
 {
   "suburb": "HILLVUE",
   "postcode": "2340"
 },
 {
   "suburb": "KINGSWOOD",
   "postcode": "2340"
 },
 {
   "suburb": "LOOMBERAH",
   "postcode": "2340"
 },
 {
   "suburb": "MOORE CREEK",
   "postcode": "2340"
 },
 {
   "suburb": "NEMINGHA",
   "postcode": "2340"
 },
 {
   "suburb": "NORTH TAMWORTH",
   "postcode": "2340"
 },
 {
   "suburb": "OXLEY VALE",
   "postcode": "2340"
 },
 {
   "suburb": "PIALLAMORE",
   "postcode": "2340"
 },
 {
   "suburb": "SOMERTON",
   "postcode": "2340"
 },
 {
   "suburb": "SOUTH TAMWORTH",
   "postcode": "2340"
 },
 {
   "suburb": "TAMINDA",
   "postcode": "2340"
 },
 {
   "suburb": "TAMWORTH",
   "postcode": "2340"
 },
 {
   "suburb": "TIMBUMBURI",
   "postcode": "2340"
 },
 {
   "suburb": "WALLAMORE",
   "postcode": "2340"
 },
 {
   "suburb": "WARRAL",
   "postcode": "2340"
 },
 {
   "suburb": "WEST TAMWORTH",
   "postcode": "2340"
 },
 {
   "suburb": "WESTDALE",
   "postcode": "2340"
 },
 {
   "suburb": "WERRIS CREEK",
   "postcode": "2341"
 },
 {
   "suburb": "CURRABUBULA",
   "postcode": "2342"
 },
 {
   "suburb": "QUIRINDI",
   "postcode": "2343"
 },
 {
   "suburb": "WALLABADAH",
   "postcode": "2343"
 },
 {
   "suburb": "DURI",
   "postcode": "2344"
 },
 {
   "suburb": "WINTON",
   "postcode": "2344"
 },
 {
   "suburb": "ATTUNGA",
   "postcode": "2345"
 },
 {
   "suburb": "KLORI",
   "postcode": "2346"
 },
 {
   "suburb": "MANILLA",
   "postcode": "2346"
 },
 {
   "suburb": "ARGYLE",
   "postcode": "2350"
 },
 {
   "suburb": "ARMIDALE",
   "postcode": "2350"
 },
 {
   "suburb": "CASTLE DOYLE",
   "postcode": "2350"
 },
 {
   "suburb": "DANGARSLEIGH",
   "postcode": "2350"
 },
 {
   "suburb": "DONALD CREEK",
   "postcode": "2350"
 },
 {
   "suburb": "DUMARESQ",
   "postcode": "2350"
 },
 {
   "suburb": "DUVAL",
   "postcode": "2350"
 },
 {
   "suburb": "INVERGOWRIE",
   "postcode": "2350"
 },
 {
   "suburb": "KELLYS PLAINS",
   "postcode": "2350"
 },
 {
   "suburb": "PUDDLEDOCK",
   "postcode": "2350"
 },
 {
   "suburb": "SAUMAREZ",
   "postcode": "2350"
 },
 {
   "suburb": "SAUMAREZ PONDS",
   "postcode": "2350"
 },
 {
   "suburb": "TILBUSTER",
   "postcode": "2350"
 },
 {
   "suburb": "WEST ARMIDALE",
   "postcode": "2350"
 },
 {
   "suburb": "KOOTINGAL",
   "postcode": "2352"
 },
 {
   "suburb": "TINTINHULL",
   "postcode": "2352"
 },
 {
   "suburb": "MOONBI",
   "postcode": "2353"
 },
 {
   "suburb": "KENTUCKY",
   "postcode": "2354"
 },
 {
   "suburb": "WALCHA",
   "postcode": "2354"
 },
 {
   "suburb": "WALCHA ROAD",
   "postcode": "2354"
 },
 {
   "suburb": "BENDEMEER",
   "postcode": "2355"
 },
 {
   "suburb": "ARDING",
   "postcode": "2358"
 },
 {
   "suburb": "KENTUCKY",
   "postcode": "2358"
 },
 {
   "suburb": "ROCKY RIVER",
   "postcode": "2358"
 },
 {
   "suburb": "URALLA",
   "postcode": "2358"
 },
 {
   "suburb": "INVERELL",
   "postcode": "2360"
 },
 {
   "suburb": "GLEN INNES",
   "postcode": "2370"
 },
 {
   "suburb": "DEEPWATER",
   "postcode": "2371"
 },
 {
   "suburb": "TENTERFIELD",
   "postcode": "2372"
 },
 {
   "suburb": "BREEZA",
   "postcode": "2381"
 },
 {
   "suburb": "MOREE",
   "postcode": "2400"
 },
 {
   "suburb": "GRAVESEND",
   "postcode": "2401"
 },
 {
   "suburb": "WARIALDA",
   "postcode": "2402"
 },
 {
   "suburb": "BOOMI",
   "postcode": "2405"
 },
 {
   "suburb": "GARAH",
   "postcode": "2405"
 },
 {
   "suburb": "MUNGINDI",
   "postcode": "2406"
 },
 {
   "suburb": "DUNGOG",
   "postcode": "2420"
 },
 {
   "suburb": "PATERSON",
   "postcode": "2421"
 },
 {
   "suburb": "VACY",
   "postcode": "2421"
 },
 {
   "suburb": "BACK CREEK",
   "postcode": "2422"
 },
 {
   "suburb": "CRAVEN",
   "postcode": "2422"
 },
 {
   "suburb": "FORBESDALE",
   "postcode": "2422"
 },
 {
   "suburb": "GLOUCESTER",
   "postcode": "2422"
 },
 {
   "suburb": "STRATFORD",
   "postcode": "2422"
 },
 {
   "suburb": "WAUKIVORY",
   "postcode": "2422"
 },
 {
   "suburb": "BOMBAH POINT",
   "postcode": "2423"
 },
 {
   "suburb": "BOOLAMBAYTE",
   "postcode": "2423"
 },
 {
   "suburb": "BULAHDELAH",
   "postcode": "2423"
 },
 {
   "suburb": "BUNGWAHL",
   "postcode": "2423"
 },
 {
   "suburb": "COOLONGOLOOK",
   "postcode": "2423"
 },
 {
   "suburb": "CRAWFORD RIVER",
   "postcode": "2423"
 },
 {
   "suburb": "MARKWELL",
   "postcode": "2423"
 },
 {
   "suburb": "MAYERS FLAT",
   "postcode": "2423"
 },
 {
   "suburb": "MUNGO BRUSH",
   "postcode": "2423"
 },
 {
   "suburb": "MYALL LAKE",
   "postcode": "2423"
 },
 {
   "suburb": "NERONG",
   "postcode": "2423"
 },
 {
   "suburb": "SEAL ROCKS",
   "postcode": "2423"
 },
 {
   "suburb": "TOPI TOPI",
   "postcode": "2423"
 },
 {
   "suburb": "UPPER MYALL",
   "postcode": "2423"
 },
 {
   "suburb": "VIOLET HILL",
   "postcode": "2423"
 },
 {
   "suburb": "WANG WAUK",
   "postcode": "2423"
 },
 {
   "suburb": "WARRANULLA",
   "postcode": "2423"
 },
 {
   "suburb": "WILLINA",
   "postcode": "2423"
 },
 {
   "suburb": "WOOTTON",
   "postcode": "2423"
 },
 {
   "suburb": "YAGON",
   "postcode": "2423"
 },
 {
   "suburb": "STROUD",
   "postcode": "2425"
 },
 {
   "suburb": "COOPERNOOK",
   "postcode": "2426"
 },
 {
   "suburb": "LANGLEY VALE",
   "postcode": "2426"
 },
 {
   "suburb": "MOTO",
   "postcode": "2426"
 },
 {
   "suburb": "CROWDY HEAD",
   "postcode": "2427"
 },
 {
   "suburb": "HARRINGTON",
   "postcode": "2427"
 },
 {
   "suburb": "BLUEYS BEACH",
   "postcode": "2428"
 },
 {
   "suburb": "BOOMERANG BEACH",
   "postcode": "2428"
 },
 {
   "suburb": "BOOTI BOOTI",
   "postcode": "2428"
 },
 {
   "suburb": "CHARLOTTE BAY",
   "postcode": "2428"
 },
 {
   "suburb": "COOMBA BAY",
   "postcode": "2428"
 },
 {
   "suburb": "COOMBA PARK",
   "postcode": "2428"
 },
 {
   "suburb": "DARAWANK",
   "postcode": "2428"
 },
 {
   "suburb": "ELIZABETH BEACH",
   "postcode": "2428"
 },
 {
   "suburb": "FORSTER",
   "postcode": "2428"
 },
 {
   "suburb": "FORSTER SHOPPING VILLAGE",
   "postcode": "2428"
 },
 {
   "suburb": "GREEN POINT",
   "postcode": "2428"
 },
 {
   "suburb": "PACIFIC PALMS",
   "postcode": "2428"
 },
 {
   "suburb": "SANDBAR",
   "postcode": "2428"
 },
 {
   "suburb": "SMITHS LAKE",
   "postcode": "2428"
 },
 {
   "suburb": "TARBUCK BAY",
   "postcode": "2428"
 },
 {
   "suburb": "TIONA",
   "postcode": "2428"
 },
 {
   "suburb": "TUNCURRY",
   "postcode": "2428"
 },
 {
   "suburb": "WHOOTA",
   "postcode": "2428"
 },
 {
   "suburb": "BUCCA WAUKA",
   "postcode": "2429"
 },
 {
   "suburb": "BUNYAH",
   "postcode": "2429"
 },
 {
   "suburb": "BURRELL CREEK",
   "postcode": "2429"
 },
 {
   "suburb": "CEDAR PARTY",
   "postcode": "2429"
 },
 {
   "suburb": "DOLLYS FLAT",
   "postcode": "2429"
 },
 {
   "suburb": "DYERS CROSSING",
   "postcode": "2429"
 },
 {
   "suburb": "FIREFLY",
   "postcode": "2429"
 },
 {
   "suburb": "KARAAK FLAT",
   "postcode": "2429"
 },
 {
   "suburb": "KILLAWARRA",
   "postcode": "2429"
 },
 {
   "suburb": "KIMBRIKI",
   "postcode": "2429"
 },
 {
   "suburb": "KRAMBACH",
   "postcode": "2429"
 },
 {
   "suburb": "KUNDIBAKH",
   "postcode": "2429"
 },
 {
   "suburb": "THE BIGHT",
   "postcode": "2429"
 },
 {
   "suburb": "WARRIWILLAH",
   "postcode": "2429"
 },
 {
   "suburb": "WHERROL FLAT",
   "postcode": "2429"
 },
 {
   "suburb": "WINGHAM",
   "postcode": "2429"
 },
 {
   "suburb": "BLACK HEAD",
   "postcode": "2430"
 },
 {
   "suburb": "BOHNOCK",
   "postcode": "2430"
 },
 {
   "suburb": "BOOTAWA",
   "postcode": "2430"
 },
 {
   "suburb": "BRIMBIN",
   "postcode": "2430"
 },
 {
   "suburb": "CABBAGE TREE ISLAND",
   "postcode": "2430"
 },
 {
   "suburb": "CHATHAM",
   "postcode": "2430"
 },
 {
   "suburb": "CROKI",
   "postcode": "2430"
 },
 {
   "suburb": "CUNDLETOWN",
   "postcode": "2430"
 },
 {
   "suburb": "DIAMOND BEACH",
   "postcode": "2430"
 },
 {
   "suburb": "DUMARESQ ISLAND",
   "postcode": "2430"
 },
 {
   "suburb": "FAILFORD",
   "postcode": "2430"
 },
 {
   "suburb": "GHINNI GHINNI",
   "postcode": "2430"
 },
 {
   "suburb": "GLENTHORNE",
   "postcode": "2430"
 },
 {
   "suburb": "HALLIDAYS POINT",
   "postcode": "2430"
 },
 {
   "suburb": "HILLVILLE",
   "postcode": "2430"
 },
 {
   "suburb": "JONES ISLAND",
   "postcode": "2430"
 },
 {
   "suburb": "KIWARRAK",
   "postcode": "2430"
 },
 {
   "suburb": "KOORAINGHAT",
   "postcode": "2430"
 },
 {
   "suburb": "KUNDLE KUNDLE",
   "postcode": "2430"
 },
 {
   "suburb": "LANSDOWNE",
   "postcode": "2430"
 },
 {
   "suburb": "LANSDOWNE FOREST",
   "postcode": "2430"
 },
 {
   "suburb": "MANNING POINT",
   "postcode": "2430"
 },
 {
   "suburb": "MELINGA",
   "postcode": "2430"
 },
 {
   "suburb": "MITCHELLS ISLAND",
   "postcode": "2430"
 },
 {
   "suburb": "MONDROOK",
   "postcode": "2430"
 },
 {
   "suburb": "OLD BAR",
   "postcode": "2430"
 },
 {
   "suburb": "OXLEY ISLAND",
   "postcode": "2430"
 },
 {
   "suburb": "PAMPOOLAH",
   "postcode": "2430"
 },
 {
   "suburb": "POSSUM BRUSH",
   "postcode": "2430"
 },
 {
   "suburb": "PURFLEET",
   "postcode": "2430"
 },
 {
   "suburb": "RAINBOW FLAT",
   "postcode": "2430"
 },
 {
   "suburb": "RED HEAD",
   "postcode": "2430"
 },
 {
   "suburb": "SALTWATER",
   "postcode": "2430"
 },
 {
   "suburb": "TALLWOODS VILLAGE",
   "postcode": "2430"
 },
 {
   "suburb": "TAREE",
   "postcode": "2430"
 },
 {
   "suburb": "TAREE SOUTH",
   "postcode": "2430"
 },
 {
   "suburb": "TINONEE",
   "postcode": "2430"
 },
 {
   "suburb": "UPPER LANSDOWNE",
   "postcode": "2430"
 },
 {
   "suburb": "WALLABI POINT",
   "postcode": "2430"
 },
 {
   "suburb": "ARAKOON",
   "postcode": "2431"
 },
 {
   "suburb": "JERSEYVILLE",
   "postcode": "2431"
 },
 {
   "suburb": "SOUTH WEST ROCKS",
   "postcode": "2431"
 },
 {
   "suburb": "BATAR CREEK",
   "postcode": "2439"
 },
 {
   "suburb": "BLACK CREEK",
   "postcode": "2439"
 },
 {
   "suburb": "KENDALL",
   "postcode": "2439"
 },
 {
   "suburb": "KEREWONG",
   "postcode": "2439"
 },
 {
   "suburb": "KEW",
   "postcode": "2439"
 },
 {
   "suburb": "LOGANS CROSSING",
   "postcode": "2439"
 },
 {
   "suburb": "LORNE",
   "postcode": "2439"
 },
 {
   "suburb": "ROSSGLEN",
   "postcode": "2439"
 },
 {
   "suburb": "SWANS CROSSING",
   "postcode": "2439"
 },
 {
   "suburb": "UPSALLS CREEK",
   "postcode": "2439"
 },
 {
   "suburb": "ALDAVILLA",
   "postcode": "2440"
 },
 {
   "suburb": "AUSTRAL EDEN",
   "postcode": "2440"
 },
 {
   "suburb": "BELLIMBOPINNI",
   "postcode": "2440"
 },
 {
   "suburb": "BELMORE RIVER",
   "postcode": "2440"
 },
 {
   "suburb": "BURNT BRIDGE",
   "postcode": "2440"
 },
 {
   "suburb": "CLYBUCCA",
   "postcode": "2440"
 },
 {
   "suburb": "COLLOMBATTI",
   "postcode": "2440"
 },
 {
   "suburb": "CORANGULA",
   "postcode": "2440"
 },
 {
   "suburb": "CRESCENT HEAD",
   "postcode": "2440"
 },
 {
   "suburb": "DEEP CREEK",
   "postcode": "2440"
 },
 {
   "suburb": "DONDINGALONG",
   "postcode": "2440"
 },
 {
   "suburb": "EAST KEMPSEY",
   "postcode": "2440"
 },
 {
   "suburb": "EUROKA",
   "postcode": "2440"
 },
 {
   "suburb": "FREDERICKTON",
   "postcode": "2440"
 },
 {
   "suburb": "GLADSTONE",
   "postcode": "2440"
 },
 {
   "suburb": "GREENHILL",
   "postcode": "2440"
 },
 {
   "suburb": "HAMPDEN HALL",
   "postcode": "2440"
 },
 {
   "suburb": "HAT HEAD",
   "postcode": "2440"
 },
 {
   "suburb": "KEMPSEY",
   "postcode": "2440"
 },
 {
   "suburb": "KINCHELA",
   "postcode": "2440"
 },
 {
   "suburb": "MOONEBA",
   "postcode": "2440"
 },
 {
   "suburb": "OLD STATION",
   "postcode": "2440"
 },
 {
   "suburb": "POLA CREEK",
   "postcode": "2440"
 },
 {
   "suburb": "RAINBOW REACH",
   "postcode": "2440"
 },
 {
   "suburb": "SEVEN OAKS",
   "postcode": "2440"
 },
 {
   "suburb": "SHERWOOD",
   "postcode": "2440"
 },
 {
   "suburb": "SKILLION FLAT",
   "postcode": "2440"
 },
 {
   "suburb": "SMITHTOWN",
   "postcode": "2440"
 },
 {
   "suburb": "SOUTH KEMPSEY",
   "postcode": "2440"
 },
 {
   "suburb": "SUMMER ISLAND",
   "postcode": "2440"
 },
 {
   "suburb": "TURNERS FLAT",
   "postcode": "2440"
 },
 {
   "suburb": "VERGES CREEK",
   "postcode": "2440"
 },
 {
   "suburb": "WEST KEMPSEY",
   "postcode": "2440"
 },
 {
   "suburb": "YARRAVEL",
   "postcode": "2440"
 },
 {
   "suburb": "YESSABAH",
   "postcode": "2440"
 },
 {
   "suburb": "BARRAGANYATTI",
   "postcode": "2441"
 },
 {
   "suburb": "COOPERABUNG",
   "postcode": "2441"
 },
 {
   "suburb": "EUNGAI CREEK",
   "postcode": "2441"
 },
 {
   "suburb": "EUNGAI RAIL",
   "postcode": "2441"
 },
 {
   "suburb": "FISHERMANS REACH",
   "postcode": "2441"
 },
 {
   "suburb": "HACKS FERRY",
   "postcode": "2441"
 },
 {
   "suburb": "KUNDABUNG",
   "postcode": "2441"
 },
 {
   "suburb": "STUARTS POINT",
   "postcode": "2441"
 },
 {
   "suburb": "TELEGRAPH POINT",
   "postcode": "2441"
 },
 {
   "suburb": "YARRAHAPINNI",
   "postcode": "2441"
 },
 {
   "suburb": "CAMDEN HEAD",
   "postcode": "2443"
 },
 {
   "suburb": "DEAUVILLE",
   "postcode": "2443"
 },
 {
   "suburb": "DUNBOGAN",
   "postcode": "2443"
 },
 {
   "suburb": "HANNAM VALE",
   "postcode": "2443"
 },
 {
   "suburb": "HERONS CREEK",
   "postcode": "2443"
 },
 {
   "suburb": "JOHNS RIVER",
   "postcode": "2443"
 },
 {
   "suburb": "LAKEWOOD",
   "postcode": "2443"
 },
 {
   "suburb": "LAURIETON",
   "postcode": "2443"
 },
 {
   "suburb": "MIDDLE BROTHER",
   "postcode": "2443"
 },
 {
   "suburb": "MOORLAND",
   "postcode": "2443"
 },
 {
   "suburb": "NORTH HAVEN",
   "postcode": "2443"
 },
 {
   "suburb": "STEWARTS RIVER",
   "postcode": "2443"
 },
 {
   "suburb": "WAITUI",
   "postcode": "2443"
 },
 {
   "suburb": "WEST HAVEN",
   "postcode": "2443"
 },
 {
   "suburb": "BLACKMANS POINT",
   "postcode": "2444"
 },
 {
   "suburb": "FERNBANK CREEK",
   "postcode": "2444"
 },
 {
   "suburb": "FLYNNS BEACH",
   "postcode": "2444"
 },
 {
   "suburb": "LIGHTHOUSE BEACH",
   "postcode": "2444"
 },
 {
   "suburb": "PORT MACQUARIE",
   "postcode": "2444"
 },
 {
   "suburb": "SETTLEMENT CITY",
   "postcode": "2444"
 },
 {
   "suburb": "THE HATCH",
   "postcode": "2444"
 },
 {
   "suburb": "THRUMSTER",
   "postcode": "2444"
 },
 {
   "suburb": "BONNY HILLS",
   "postcode": "2445"
 },
 {
   "suburb": "GRANTS BEACH",
   "postcode": "2445"
 },
 {
   "suburb": "LAKE CATHIE",
   "postcode": "2445"
 },
 {
   "suburb": "BAGNOO",
   "postcode": "2446"
 },
 {
   "suburb": "BEECHWOOD",
   "postcode": "2446"
 },
 {
   "suburb": "BROMBIN",
   "postcode": "2446"
 },
 {
   "suburb": "BYABARRA",
   "postcode": "2446"
 },
 {
   "suburb": "CROSSLANDS",
   "postcode": "2446"
 },
 {
   "suburb": "FRAZERS CREEK",
   "postcode": "2446"
 },
 {
   "suburb": "HARTYS PLAINS",
   "postcode": "2446"
 },
 {
   "suburb": "HUNTINGDON",
   "postcode": "2446"
 },
 {
   "suburb": "HYNDMANS CREEK",
   "postcode": "2446"
 },
 {
   "suburb": "KING CREEK",
   "postcode": "2446"
 },
 {
   "suburb": "LAKE INNES",
   "postcode": "2446"
 },
 {
   "suburb": "LONG FLAT",
   "postcode": "2446"
 },
 {
   "suburb": "LOWER PAPPINBARRA",
   "postcode": "2446"
 },
 {
   "suburb": "MORTONS CREEK",
   "postcode": "2446"
 },
 {
   "suburb": "PEMBROOKE",
   "postcode": "2446"
 },
 {
   "suburb": "PIPECLAY",
   "postcode": "2446"
 },
 {
   "suburb": "RAWDON ISLAND",
   "postcode": "2446"
 },
 {
   "suburb": "REDBANK",
   "postcode": "2446"
 },
 {
   "suburb": "ROSEWOOD",
   "postcode": "2446"
 },
 {
   "suburb": "SANCROX",
   "postcode": "2446"
 },
 {
   "suburb": "WAUCHOPE",
   "postcode": "2446"
 },
 {
   "suburb": "YIPPIN CREEK",
   "postcode": "2446"
 },
 {
   "suburb": "CONGARINNI",
   "postcode": "2447"
 },
 {
   "suburb": "CONGARINNI NORTH",
   "postcode": "2447"
 },
 {
   "suburb": "DONNELLYVILLE",
   "postcode": "2447"
 },
 {
   "suburb": "GUMMA",
   "postcode": "2447"
 },
 {
   "suburb": "MACKSVILLE",
   "postcode": "2447"
 },
 {
   "suburb": "NEWEE CREEK",
   "postcode": "2447"
 },
 {
   "suburb": "NORTH MACKSVILLE",
   "postcode": "2447"
 },
 {
   "suburb": "SCOTTS HEAD",
   "postcode": "2447"
 },
 {
   "suburb": "TALARM",
   "postcode": "2447"
 },
 {
   "suburb": "UTUNGUN",
   "postcode": "2447"
 },
 {
   "suburb": "WARRELL CREEK",
   "postcode": "2447"
 },
 {
   "suburb": "WIRRIMBI",
   "postcode": "2447"
 },
 {
   "suburb": "HYLAND PARK",
   "postcode": "2448"
 },
 {
   "suburb": "NAMBUCCA HEADS",
   "postcode": "2448"
 },
 {
   "suburb": "VALLA",
   "postcode": "2448"
 },
 {
   "suburb": "VALLA BEACH",
   "postcode": "2448"
 },
 {
   "suburb": "BOWRAVILLE",
   "postcode": "2449"
 },
 {
   "suburb": "TEWINGA",
   "postcode": "2449"
 },
 {
   "suburb": "BOAMBEE",
   "postcode": "2450"
 },
 {
   "suburb": "BONVILLE",
   "postcode": "2450"
 },
 {
   "suburb": "BROOKLANA",
   "postcode": "2450"
 },
 {
   "suburb": "BUCCA",
   "postcode": "2450"
 },
 {
   "suburb": "COFFS HARBOUR",
   "postcode": "2450"
 },
 {
   "suburb": "COFFS HARBOUR JETTY",
   "postcode": "2450"
 },
 {
   "suburb": "COFFS HARBOUR PLAZA",
   "postcode": "2450"
 },
 {
   "suburb": "CORAMBA",
   "postcode": "2450"
 },
 {
   "suburb": "GLENREAGH",
   "postcode": "2450"
 },
 {
   "suburb": "KARANGI",
   "postcode": "2450"
 },
 {
   "suburb": "KORORA",
   "postcode": "2450"
 },
 {
   "suburb": "MOONEE BEACH",
   "postcode": "2450"
 },
 {
   "suburb": "NANA GLEN",
   "postcode": "2450"
 },
 {
   "suburb": "NORTH BOAMBEE VALLEY",
   "postcode": "2450"
 },
 {
   "suburb": "SAPPHIRE BEACH",
   "postcode": "2450"
 },
 {
   "suburb": "SHERWOOD",
   "postcode": "2450"
 },
 {
   "suburb": "ULONG",
   "postcode": "2450"
 },
 {
   "suburb": "UPPER ORARA",
   "postcode": "2450"
 },
 {
   "suburb": "BOAMBEE EAST",
   "postcode": "2452"
 },
 {
   "suburb": "SAWTELL",
   "postcode": "2452"
 },
 {
   "suburb": "TOORMINA",
   "postcode": "2452"
 },
 {
   "suburb": "BELLINGEN",
   "postcode": "2454"
 },
 {
   "suburb": "BRIERFIELD",
   "postcode": "2454"
 },
 {
   "suburb": "FERNMOUNT",
   "postcode": "2454"
 },
 {
   "suburb": "GLENIFFER",
   "postcode": "2454"
 },
 {
   "suburb": "HYDES CREEK",
   "postcode": "2454"
 },
 {
   "suburb": "MYLESTOM",
   "postcode": "2454"
 },
 {
   "suburb": "RALEIGH",
   "postcode": "2454"
 },
 {
   "suburb": "REPTON",
   "postcode": "2454"
 },
 {
   "suburb": "URUNGA",
   "postcode": "2455"
 },
 {
   "suburb": "ARRAWARRA",
   "postcode": "2456"
 },
 {
   "suburb": "ARRAWARRA HEADLAND",
   "postcode": "2456"
 },
 {
   "suburb": "CORINDI BEACH",
   "postcode": "2456"
 },
 {
   "suburb": "DIRTY CREEK",
   "postcode": "2456"
 },
 {
   "suburb": "EMERALD BEACH",
   "postcode": "2456"
 },
 {
   "suburb": "MULLAWAY",
   "postcode": "2456"
 },
 {
   "suburb": "RED ROCK",
   "postcode": "2456"
 },
 {
   "suburb": "SAFETY BEACH",
   "postcode": "2456"
 },
 {
   "suburb": "SANDY BEACH",
   "postcode": "2456"
 },
 {
   "suburb": "UPPER CORINDI",
   "postcode": "2456"
 },
 {
   "suburb": "WOOLGOOLGA",
   "postcode": "2456"
 },
 {
   "suburb": "ALUMY CREEK",
   "postcode": "2460"
 },
 {
   "suburb": "BRAUNSTONE",
   "postcode": "2460"
 },
 {
   "suburb": "CARRS CREEK",
   "postcode": "2460"
 },
 {
   "suburb": "CARRS ISLAND",
   "postcode": "2460"
 },
 {
   "suburb": "CARRS PENINSULAR",
   "postcode": "2460"
 },
 {
   "suburb": "CLARENZA",
   "postcode": "2460"
 },
 {
   "suburb": "COPMANHURST",
   "postcode": "2460"
 },
 {
   "suburb": "COUTTS CROSSING",
   "postcode": "2460"
 },
 {
   "suburb": "COWPER",
   "postcode": "2460"
 },
 {
   "suburb": "CROWTHER ISLAND",
   "postcode": "2460"
 },
 {
   "suburb": "EATONSVILLE",
   "postcode": "2460"
 },
 {
   "suburb": "ELLAND",
   "postcode": "2460"
 },
 {
   "suburb": "GLENUGIE",
   "postcode": "2460"
 },
 {
   "suburb": "GRAFTON",
   "postcode": "2460"
 },
 {
   "suburb": "GREAT MARLOW",
   "postcode": "2460"
 },
 {
   "suburb": "HALFWAY CREEK",
   "postcode": "2460"
 },
 {
   "suburb": "JUNCTION HILL",
   "postcode": "2460"
 },
 {
   "suburb": "KOOLKHAN",
   "postcode": "2460"
 },
 {
   "suburb": "KUNGALA",
   "postcode": "2460"
 },
 {
   "suburb": "KYARRAN",
   "postcode": "2460"
 },
 {
   "suburb": "LAWRENCE",
   "postcode": "2460"
 },
 {
   "suburb": "LOWER SOUTHGATE",
   "postcode": "2460"
 },
 {
   "suburb": "MOUNTAIN VIEW",
   "postcode": "2460"
 },
 {
   "suburb": "SEELANDS",
   "postcode": "2460"
 },
 {
   "suburb": "SOUTH ARM",
   "postcode": "2460"
 },
 {
   "suburb": "SOUTH GRAFTON",
   "postcode": "2460"
 },
 {
   "suburb": "SOUTHAMPTON",
   "postcode": "2460"
 },
 {
   "suburb": "SOUTHGATE",
   "postcode": "2460"
 },
 {
   "suburb": "THE WHITEMAN",
   "postcode": "2460"
 },
 {
   "suburb": "TRENAYR",
   "postcode": "2460"
 },
 {
   "suburb": "UPPER COPMANHURST",
   "postcode": "2460"
 },
 {
   "suburb": "WARRAGAI CREEK",
   "postcode": "2460"
 },
 {
   "suburb": "WATERVIEW",
   "postcode": "2460"
 },
 {
   "suburb": "WATERVIEW HEIGHTS",
   "postcode": "2460"
 },
 {
   "suburb": "WELLS CROSSING",
   "postcode": "2460"
 },
 {
   "suburb": "ASHBY",
   "postcode": "2463"
 },
 {
   "suburb": "ASHBY HEIGHTS",
   "postcode": "2463"
 },
 {
   "suburb": "ASHBY ISLAND",
   "postcode": "2463"
 },
 {
   "suburb": "BROOMS HEAD",
   "postcode": "2463"
 },
 {
   "suburb": "GULMARRAD",
   "postcode": "2463"
 },
 {
   "suburb": "ILARWILL",
   "postcode": "2463"
 },
 {
   "suburb": "JAMES CREEK",
   "postcode": "2463"
 },
 {
   "suburb": "MACLEAN",
   "postcode": "2463"
 },
 {
   "suburb": "PALMERS ISLAND",
   "postcode": "2463"
 },
 {
   "suburb": "TALOUMBI",
   "postcode": "2463"
 },
 {
   "suburb": "TOWNSEND",
   "postcode": "2463"
 },
 {
   "suburb": "WOODFORD ISLAND",
   "postcode": "2463"
 },
 {
   "suburb": "ANGOURIE",
   "postcode": "2464"
 },
 {
   "suburb": "MICALO ISLAND",
   "postcode": "2464"
 },
 {
   "suburb": "WOOLOWEYAH",
   "postcode": "2464"
 },
 {
   "suburb": "YAMBA",
   "postcode": "2464"
 },
 {
   "suburb": "HARWOOD",
   "postcode": "2465"
 },
 {
   "suburb": "BACKMEDE",
   "postcode": "2470"
 },
 {
   "suburb": "CASINO",
   "postcode": "2470"
 },
 {
   "suburb": "DOUBTFUL CREEK",
   "postcode": "2470"
 },
 {
   "suburb": "FAIRY HILL",
   "postcode": "2470"
 },
 {
   "suburb": "IRVINGTON",
   "postcode": "2470"
 },
 {
   "suburb": "MONGOGARIE",
   "postcode": "2470"
 },
 {
   "suburb": "NAUGHTONS GAP",
   "postcode": "2470"
 },
 {
   "suburb": "NORTH CASINO",
   "postcode": "2470"
 },
 {
   "suburb": "SPRING GROVE",
   "postcode": "2470"
 },
 {
   "suburb": "STRATHEDEN",
   "postcode": "2470"
 },
 {
   "suburb": "TOMKI",
   "postcode": "2470"
 },
 {
   "suburb": "YORKLEA",
   "postcode": "2470"
 },
 {
   "suburb": "CORAKI",
   "postcode": "2471"
 },
 {
   "suburb": "GREEN FOREST",
   "postcode": "2471"
 },
 {
   "suburb": "GREENRIDGE",
   "postcode": "2471"
 },
 {
   "suburb": "NORTH WOODBURN",
   "postcode": "2471"
 },
 {
   "suburb": "BROADWATER",
   "postcode": "2472"
 },
 {
   "suburb": "BUCKENDOON",
   "postcode": "2472"
 },
 {
   "suburb": "KILGIN",
   "postcode": "2472"
 },
 {
   "suburb": "NEW ITALY",
   "postcode": "2472"
 },
 {
   "suburb": "RILEYS HILL",
   "postcode": "2472"
 },
 {
   "suburb": "WOODBURN",
   "postcode": "2472"
 },
 {
   "suburb": "DOONBAH",
   "postcode": "2473"
 },
 {
   "suburb": "EVANS HEAD",
   "postcode": "2473"
 },
 {
   "suburb": "BARKERS VALE",
   "postcode": "2474"
 },
 {
   "suburb": "CAWONGLA",
   "postcode": "2474"
 },
 {
   "suburb": "CEDAR POINT",
   "postcode": "2474"
 },
 {
   "suburb": "EDENVILLE",
   "postcode": "2474"
 },
 {
   "suburb": "GENEVA",
   "postcode": "2474"
 },
 {
   "suburb": "HORSE STATION CREEK",
   "postcode": "2474"
 },
 {
   "suburb": "KYOGLE",
   "postcode": "2474"
 },
 {
   "suburb": "UPPER HORSESHOE CREEK",
   "postcode": "2474"
 },
 {
   "suburb": "WADEVILLE",
   "postcode": "2474"
 },
 {
   "suburb": "ALSTONVALE",
   "postcode": "2477"
 },
 {
   "suburb": "ALSTONVILLE",
   "postcode": "2477"
 },
 {
   "suburb": "BAGOTVILLE",
   "postcode": "2477"
 },
 {
   "suburb": "CABBAGE TREE ISLAND",
   "postcode": "2477"
 },
 {
   "suburb": "DALWOOD",
   "postcode": "2477"
 },
 {
   "suburb": "EAST WARDELL",
   "postcode": "2477"
 },
 {
   "suburb": "GOAT ISLAND",
   "postcode": "2477"
 },
 {
   "suburb": "LYNWOOD",
   "postcode": "2477"
 },
 {
   "suburb": "MEERSCHAUM VALE",
   "postcode": "2477"
 },
 {
   "suburb": "PEARCES CREEK",
   "postcode": "2477"
 },
 {
   "suburb": "ROUS",
   "postcode": "2477"
 },
 {
   "suburb": "ROUS MILL",
   "postcode": "2477"
 },
 {
   "suburb": "TUCKOMBIL",
   "postcode": "2477"
 },
 {
   "suburb": "URALBA",
   "postcode": "2477"
 },
 {
   "suburb": "WARDELL",
   "postcode": "2477"
 },
 {
   "suburb": "WOLLONGBAR",
   "postcode": "2477"
 },
 {
   "suburb": "BALLINA",
   "postcode": "2478"
 },
 {
   "suburb": "COOLGARDIE",
   "postcode": "2478"
 },
 {
   "suburb": "CUMBALUM",
   "postcode": "2478"
 },
 {
   "suburb": "EAST BALLINA",
   "postcode": "2478"
 },
 {
   "suburb": "EMPIRE VALE",
   "postcode": "2478"
 },
 {
   "suburb": "KEITH HALL",
   "postcode": "2478"
 },
 {
   "suburb": "KINVARA",
   "postcode": "2478"
 },
 {
   "suburb": "LENNOX HEAD",
   "postcode": "2478"
 },
 {
   "suburb": "PATCHS BEACH",
   "postcode": "2478"
 },
 {
   "suburb": "PIMLICO",
   "postcode": "2478"
 },
 {
   "suburb": "PIMLICO ISLAND",
   "postcode": "2478"
 },
 {
   "suburb": "SKENNARS HEAD",
   "postcode": "2478"
 },
 {
   "suburb": "SOUTH BALLINA",
   "postcode": "2478"
 },
 {
   "suburb": "TEVEN",
   "postcode": "2478"
 },
 {
   "suburb": "TINTENBAR",
   "postcode": "2478"
 },
 {
   "suburb": "WEST BALLINA",
   "postcode": "2478"
 },
 {
   "suburb": "BANGALOW",
   "postcode": "2479"
 },
 {
   "suburb": "BINNA BURRA",
   "postcode": "2479"
 },
 {
   "suburb": "BROOKLET",
   "postcode": "2479"
 },
 {
   "suburb": "COOPERS SHOOT",
   "postcode": "2479"
 },
 {
   "suburb": "COORABELL",
   "postcode": "2479"
 },
 {
   "suburb": "FERNLEIGH",
   "postcode": "2479"
 },
 {
   "suburb": "KNOCKROW",
   "postcode": "2479"
 },
 {
   "suburb": "MCLEODS SHOOT",
   "postcode": "2479"
 },
 {
   "suburb": "NASHUA",
   "postcode": "2479"
 },
 {
   "suburb": "NEWRYBAR",
   "postcode": "2479"
 },
 {
   "suburb": "POSSUM CREEK",
   "postcode": "2479"
 },
 {
   "suburb": "BENTLEY",
   "postcode": "2480"
 },
 {
   "suburb": "BEXHILL",
   "postcode": "2480"
 },
 {
   "suburb": "BLAKEBROOK",
   "postcode": "2480"
 },
 {
   "suburb": "BLUE KNOB",
   "postcode": "2480"
 },
 {
   "suburb": "BOAT HARBOUR",
   "postcode": "2480"
 },
 {
   "suburb": "BOOERIE CREEK",
   "postcode": "2480"
 },
 {
   "suburb": "BOORABEE PARK",
   "postcode": "2480"
 },
 {
   "suburb": "BOOYONG",
   "postcode": "2480"
 },
 {
   "suburb": "BUNGABBEE",
   "postcode": "2480"
 },
 {
   "suburb": "CANIABA",
   "postcode": "2480"
 },
 {
   "suburb": "CHILCOTTS GRASS",
   "postcode": "2480"
 },
 {
   "suburb": "CLOVASS",
   "postcode": "2480"
 },
 {
   "suburb": "CLUNES",
   "postcode": "2480"
 },
 {
   "suburb": "COFFEE CAMP",
   "postcode": "2480"
 },
 {
   "suburb": "CORNDALE",
   "postcode": "2480"
 },
 {
   "suburb": "DORROUGHBY",
   "postcode": "2480"
 },
 {
   "suburb": "DUNGARUBBA",
   "postcode": "2480"
 },
 {
   "suburb": "DUNOON",
   "postcode": "2480"
 },
 {
   "suburb": "EAST LISMORE",
   "postcode": "2480"
 },
 {
   "suburb": "ELTHAM",
   "postcode": "2480"
 },
 {
   "suburb": "EUREKA",
   "postcode": "2480"
 },
 {
   "suburb": "FEDERAL",
   "postcode": "2480"
 },
 {
   "suburb": "FERNSIDE",
   "postcode": "2480"
 },
 {
   "suburb": "GEORGICA",
   "postcode": "2480"
 },
 {
   "suburb": "GIRARDS HILL",
   "postcode": "2480"
 },
 {
   "suburb": "GOOLMANGAR",
   "postcode": "2480"
 },
 {
   "suburb": "GOONELLABAH",
   "postcode": "2480"
 },
 {
   "suburb": "HOWARDS GRASS",
   "postcode": "2480"
 },
 {
   "suburb": "JIGGI",
   "postcode": "2480"
 },
 {
   "suburb": "KEERRONG",
   "postcode": "2480"
 },
 {
   "suburb": "KOONORIGAN",
   "postcode": "2480"
 },
 {
   "suburb": "LAGOON GRASS",
   "postcode": "2480"
 },
 {
   "suburb": "LARNOOK",
   "postcode": "2480"
 },
 {
   "suburb": "LEYCESTER",
   "postcode": "2480"
 },
 {
   "suburb": "LILLIAN ROCK",
   "postcode": "2480"
 },
 {
   "suburb": "LINDENDALE",
   "postcode": "2480"
 },
 {
   "suburb": "LISMORE",
   "postcode": "2480"
 },
 {
   "suburb": "LISMORE HEIGHTS",
   "postcode": "2480"
 },
 {
   "suburb": "LOFTVILLE",
   "postcode": "2480"
 },
 {
   "suburb": "MAROM CREEK",
   "postcode": "2480"
 },
 {
   "suburb": "MCKEES HILL",
   "postcode": "2480"
 },
 {
   "suburb": "MCLEANS RIDGES",
   "postcode": "2480"
 },
 {
   "suburb": "MODANVILLE",
   "postcode": "2480"
 },
 {
   "suburb": "MONALTRIE",
   "postcode": "2480"
 },
 {
   "suburb": "MOUNTAIN TOP",
   "postcode": "2480"
 },
 {
   "suburb": "NIGHTCAP",
   "postcode": "2480"
 },
 {
   "suburb": "NIMBIN",
   "postcode": "2480"
 },
 {
   "suburb": "NORTH LISMORE",
   "postcode": "2480"
 },
 {
   "suburb": "NUMULGI",
   "postcode": "2480"
 },
 {
   "suburb": "REPENTANCE CREEK",
   "postcode": "2480"
 },
 {
   "suburb": "RICHMOND HILL",
   "postcode": "2480"
 },
 {
   "suburb": "ROCK VALLEY",
   "postcode": "2480"
 },
 {
   "suburb": "ROSEBANK",
   "postcode": "2480"
 },
 {
   "suburb": "RUTHVEN",
   "postcode": "2480"
 },
 {
   "suburb": "SOUTH GUNDURIMBA",
   "postcode": "2480"
 },
 {
   "suburb": "SOUTH LISMORE",
   "postcode": "2480"
 },
 {
   "suburb": "STONY CHUTE",
   "postcode": "2480"
 },
 {
   "suburb": "TERANIA CREEK",
   "postcode": "2480"
 },
 {
   "suburb": "THE CHANNON",
   "postcode": "2480"
 },
 {
   "suburb": "TREGEAGLE",
   "postcode": "2480"
 },
 {
   "suburb": "TUCKI TUCKI",
   "postcode": "2480"
 },
 {
   "suburb": "TUCKURIMBA",
   "postcode": "2480"
 },
 {
   "suburb": "TULLERA",
   "postcode": "2480"
 },
 {
   "suburb": "TUNCESTER",
   "postcode": "2480"
 },
 {
   "suburb": "TUNTABLE CREEK",
   "postcode": "2480"
 },
 {
   "suburb": "WHIAN WHIAN",
   "postcode": "2480"
 },
 {
   "suburb": "WOODLAWN",
   "postcode": "2480"
 },
 {
   "suburb": "WYRALLAH",
   "postcode": "2480"
 },
 {
   "suburb": "BROKEN HEAD",
   "postcode": "2481"
 },
 {
   "suburb": "BYRON BAY",
   "postcode": "2481"
 },
 {
   "suburb": "EWINGSDALE",
   "postcode": "2481"
 },
 {
   "suburb": "HAYTERS HILL",
   "postcode": "2481"
 },
 {
   "suburb": "MYOCUM",
   "postcode": "2481"
 },
 {
   "suburb": "SKINNERS SHOOT",
   "postcode": "2481"
 },
 {
   "suburb": "SUFFOLK PARK",
   "postcode": "2481"
 },
 {
   "suburb": "TALOFA",
   "postcode": "2481"
 },
 {
   "suburb": "TYAGARAH",
   "postcode": "2481"
 },
 {
   "suburb": "GOONENGERRY",
   "postcode": "2482"
 },
 {
   "suburb": "HUONBROOK",
   "postcode": "2482"
 },
 {
   "suburb": "KOONYUM RANGE",
   "postcode": "2482"
 },
 {
   "suburb": "MAIN ARM",
   "postcode": "2482"
 },
 {
   "suburb": "MONTECOLLUM",
   "postcode": "2482"
 },
 {
   "suburb": "MULLUMBIMBY",
   "postcode": "2482"
 },
 {
   "suburb": "MULLUMBIMBY CREEK",
   "postcode": "2482"
 },
 {
   "suburb": "PALMWOODS",
   "postcode": "2482"
 },
 {
   "suburb": "UPPER COOPERS CREEK",
   "postcode": "2482"
 },
 {
   "suburb": "UPPER MAIN ARM",
   "postcode": "2482"
 },
 {
   "suburb": "UPPER WILSONS CREEK",
   "postcode": "2482"
 },
 {
   "suburb": "WANGANUI",
   "postcode": "2482"
 },
 {
   "suburb": "WILSONS CREEK",
   "postcode": "2482"
 },
 {
   "suburb": "BILLINUDGEL",
   "postcode": "2483"
 },
 {
   "suburb": "BRUNSWICK HEADS",
   "postcode": "2483"
 },
 {
   "suburb": "BURRINGBAR",
   "postcode": "2483"
 },
 {
   "suburb": "CRABBES CREEK",
   "postcode": "2483"
 },
 {
   "suburb": "MIDDLE POCKET",
   "postcode": "2483"
 },
 {
   "suburb": "MOOBALL",
   "postcode": "2483"
 },
 {
   "suburb": "NEW BRIGHTON",
   "postcode": "2483"
 },
 {
   "suburb": "OCEAN SHORES",
   "postcode": "2483"
 },
 {
   "suburb": "SLEEPY HOLLOW",
   "postcode": "2483"
 },
 {
   "suburb": "SOUTH GOLDEN BEACH",
   "postcode": "2483"
 },
 {
   "suburb": "THE POCKET",
   "postcode": "2483"
 },
 {
   "suburb": "UPPER BURRINGBAR",
   "postcode": "2483"
 },
 {
   "suburb": "WOOYUNG",
   "postcode": "2483"
 },
 {
   "suburb": "YELGUN",
   "postcode": "2483"
 },
 {
   "suburb": "BACK CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "BRAY PARK",
   "postcode": "2484"
 },
 {
   "suburb": "BRAYS CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "BYANGUM",
   "postcode": "2484"
 },
 {
   "suburb": "BYRRILL CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "CEDAR CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "CHILLINGHAM",
   "postcode": "2484"
 },
 {
   "suburb": "CHOWAN CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "CLOTHIERS CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "COMMISSIONERS CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "CONDONG",
   "postcode": "2484"
 },
 {
   "suburb": "CRYSTAL CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "CUDGERA CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "DOON DOON",
   "postcode": "2484"
 },
 {
   "suburb": "DULGUIGAN",
   "postcode": "2484"
 },
 {
   "suburb": "DUM DUM",
   "postcode": "2484"
 },
 {
   "suburb": "DUNBIBLE",
   "postcode": "2484"
 },
 {
   "suburb": "DUNGAY",
   "postcode": "2484"
 },
 {
   "suburb": "EUNGELLA",
   "postcode": "2484"
 },
 {
   "suburb": "EVIRON",
   "postcode": "2484"
 },
 {
   "suburb": "FARRANTS HILL",
   "postcode": "2484"
 },
 {
   "suburb": "FERNVALE",
   "postcode": "2484"
 },
 {
   "suburb": "HOPKINS CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "KIELVALE",
   "postcode": "2484"
 },
 {
   "suburb": "KUNGHUR",
   "postcode": "2484"
 },
 {
   "suburb": "KUNGHUR CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "KYNNUMBOON",
   "postcode": "2484"
 },
 {
   "suburb": "LIMPINWOOD",
   "postcode": "2484"
 },
 {
   "suburb": "MEBBIN",
   "postcode": "2484"
 },
 {
   "suburb": "MIDGINBIL",
   "postcode": "2484"
 },
 {
   "suburb": "MOUNT BURRELL",
   "postcode": "2484"
 },
 {
   "suburb": "MOUNT WARNING",
   "postcode": "2484"
 },
 {
   "suburb": "MURWILLUMBAH",
   "postcode": "2484"
 },
 {
   "suburb": "MURWILLUMBAH SOUTH",
   "postcode": "2484"
 },
 {
   "suburb": "NOBBYS CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "NORTH ARM",
   "postcode": "2484"
 },
 {
   "suburb": "NUMINBAH",
   "postcode": "2484"
 },
 {
   "suburb": "NUNDERI",
   "postcode": "2484"
 },
 {
   "suburb": "PALMVALE",
   "postcode": "2484"
 },
 {
   "suburb": "PUMPENBIL",
   "postcode": "2484"
 },
 {
   "suburb": "RESERVE CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "ROUND MOUNTAIN",
   "postcode": "2484"
 },
 {
   "suburb": "ROWLANDS CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "SMITHS CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "SOUTH MURWILLUMBAH",
   "postcode": "2484"
 },
 {
   "suburb": "STOKERS SIDING",
   "postcode": "2484"
 },
 {
   "suburb": "TERRAGON",
   "postcode": "2484"
 },
 {
   "suburb": "TOMEWIN",
   "postcode": "2484"
 },
 {
   "suburb": "TYALGUM",
   "postcode": "2484"
 },
 {
   "suburb": "TYALGUM CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "TYGALGAH",
   "postcode": "2484"
 },
 {
   "suburb": "UKI",
   "postcode": "2484"
 },
 {
   "suburb": "UPPER CRYSTAL CREEK",
   "postcode": "2484"
 },
 {
   "suburb": "URLIUP",
   "postcode": "2484"
 },
 {
   "suburb": "WARDROP VALLEY",
   "postcode": "2484"
 },
 {
   "suburb": "ZARA",
   "postcode": "2484"
 },
 {
   "suburb": "COOLANGATTA",
   "postcode": "2485"
 },
 {
   "suburb": "TWEED HEADS",
   "postcode": "2485"
 },
 {
   "suburb": "TWEED HEADS WEST",
   "postcode": "2485"
 },
 {
   "suburb": "BANORA POINT",
   "postcode": "2486"
 },
 {
   "suburb": "BILAMBIL",
   "postcode": "2486"
 },
 {
   "suburb": "BILAMBIL HEIGHTS",
   "postcode": "2486"
 },
 {
   "suburb": "BUNGALORA",
   "postcode": "2486"
 },
 {
   "suburb": "CAROOL",
   "postcode": "2486"
 },
 {
   "suburb": "COBAKI",
   "postcode": "2486"
 },
 {
   "suburb": "COBAKI LAKES",
   "postcode": "2486"
 },
 {
   "suburb": "DUROBY",
   "postcode": "2486"
 },
 {
   "suburb": "ENORA POINT",
   "postcode": "2486"
 },
 {
   "suburb": "GLENGARRIE",
   "postcode": "2486"
 },
 {
   "suburb": "PIGGABEEN",
   "postcode": "2486"
 },
 {
   "suburb": "TERRANORA",
   "postcode": "2486"
 },
 {
   "suburb": "TWEED HEADS SOUTH",
   "postcode": "2486"
 },
 {
   "suburb": "UPPER DUROBY",
   "postcode": "2486"
 },
 {
   "suburb": "CASUARINA",
   "postcode": "2487"
 },
 {
   "suburb": "CHINDERAH",
   "postcode": "2487"
 },
 {
   "suburb": "CUDGEN",
   "postcode": "2487"
 },
 {
   "suburb": "DURANBAH",
   "postcode": "2487"
 },
 {
   "suburb": "FINGAL HEAD",
   "postcode": "2487"
 },
 {
   "suburb": "KINGS FOREST",
   "postcode": "2487"
 },
 {
   "suburb": "KINGSCLIFF",
   "postcode": "2487"
 },
 {
   "suburb": "STOTTS CREEK",
   "postcode": "2487"
 },
 {
   "suburb": "BOGANGAR",
   "postcode": "2488"
 },
 {
   "suburb": "CABARITA BEACH",
   "postcode": "2488"
 },
 {
   "suburb": "TANGLEWOOD",
   "postcode": "2488"
 },
 {
   "suburb": "HASTINGS POINT",
   "postcode": "2489"
 },
 {
   "suburb": "POTTSVILLE",
   "postcode": "2489"
 },
 {
   "suburb": "POTTSVILLE BEACH",
   "postcode": "2489"
 },
 {
   "suburb": "NORTH TUMBULGUM",
   "postcode": "2490"
 },
 {
   "suburb": "TUMBULGUM",
   "postcode": "2490"
 },
 {
   "suburb": "CONISTON",
   "postcode": "2500"
 },
 {
   "suburb": "GWYNNEVILLE",
   "postcode": "2500"
 },
 {
   "suburb": "KEIRAVILLE",
   "postcode": "2500"
 },
 {
   "suburb": "MANGERTON",
   "postcode": "2500"
 },
 {
   "suburb": "MOUNT KEIRA",
   "postcode": "2500"
 },
 {
   "suburb": "MOUNT SAINT THOMAS",
   "postcode": "2500"
 },
 {
   "suburb": "NORTH WOLLONGONG",
   "postcode": "2500"
 },
 {
   "suburb": "SPRING HILL",
   "postcode": "2500"
 },
 {
   "suburb": "WEST WOLLONGONG",
   "postcode": "2500"
 },
 {
   "suburb": "WOLLONGONG",
   "postcode": "2500"
 },
 {
   "suburb": "WOLLONGONG WEST",
   "postcode": "2500"
 },
 {
   "suburb": "CRINGILA",
   "postcode": "2502"
 },
 {
   "suburb": "LAKE HEIGHTS",
   "postcode": "2502"
 },
 {
   "suburb": "PRIMBEE",
   "postcode": "2502"
 },
 {
   "suburb": "WARRAWONG",
   "postcode": "2502"
 },
 {
   "suburb": "PORT KEMBLA",
   "postcode": "2505"
 },
 {
   "suburb": "BERKELEY",
   "postcode": "2506"
 },
 {
   "suburb": "COALCLIFF",
   "postcode": "2508"
 },
 {
   "suburb": "DARKES FOREST",
   "postcode": "2508"
 },
 {
   "suburb": "HELENSBURGH",
   "postcode": "2508"
 },
 {
   "suburb": "LILYVALE",
   "postcode": "2508"
 },
 {
   "suburb": "MADDENS PLAINS",
   "postcode": "2508"
 },
 {
   "suburb": "OTFORD",
   "postcode": "2508"
 },
 {
   "suburb": "STANWELL PARK",
   "postcode": "2508"
 },
 {
   "suburb": "STANWELL TOPS",
   "postcode": "2508"
 },
 {
   "suburb": "WORONORA DAM",
   "postcode": "2508"
 },
 {
   "suburb": "AUSTINMER",
   "postcode": "2515"
 },
 {
   "suburb": "CLIFTON",
   "postcode": "2515"
 },
 {
   "suburb": "COLEDALE",
   "postcode": "2515"
 },
 {
   "suburb": "SCARBOROUGH",
   "postcode": "2515"
 },
 {
   "suburb": "THIRROUL",
   "postcode": "2515"
 },
 {
   "suburb": "WOMBARRA",
   "postcode": "2515"
 },
 {
   "suburb": "BULLI",
   "postcode": "2516"
 },
 {
   "suburb": "RUSSELL VALE",
   "postcode": "2517"
 },
 {
   "suburb": "WOONONA",
   "postcode": "2517"
 },
 {
   "suburb": "WOONONA EAST",
   "postcode": "2517"
 },
 {
   "suburb": "BELLAMBI",
   "postcode": "2518"
 },
 {
   "suburb": "CORRIMAL",
   "postcode": "2518"
 },
 {
   "suburb": "CORRIMAL EAST",
   "postcode": "2518"
 },
 {
   "suburb": "EAST CORRIMAL",
   "postcode": "2518"
 },
 {
   "suburb": "TARRAWANNA",
   "postcode": "2518"
 },
 {
   "suburb": "TOWRADGI",
   "postcode": "2518"
 },
 {
   "suburb": "BALGOWNIE",
   "postcode": "2519"
 },
 {
   "suburb": "FAIRY MEADOW",
   "postcode": "2519"
 },
 {
   "suburb": "FERNHILL",
   "postcode": "2519"
 },
 {
   "suburb": "MOUNT OUSLEY",
   "postcode": "2519"
 },
 {
   "suburb": "MOUNT PLEASANT",
   "postcode": "2519"
 },
 {
   "suburb": "WOLLONGONG",
   "postcode": "2520"
 },
 {
   "suburb": "FIGTREE",
   "postcode": "2525"
 },
 {
   "suburb": "CORDEAUX",
   "postcode": "2526"
 },
 {
   "suburb": "CORDEAUX HEIGHTS",
   "postcode": "2526"
 },
 {
   "suburb": "FARMBOROUGH HEIGHTS",
   "postcode": "2526"
 },
 {
   "suburb": "KEMBLA GRANGE",
   "postcode": "2526"
 },
 {
   "suburb": "KEMBLA HEIGHTS",
   "postcode": "2526"
 },
 {
   "suburb": "MOUNT KEMBLA",
   "postcode": "2526"
 },
 {
   "suburb": "STREAM HILL",
   "postcode": "2526"
 },
 {
   "suburb": "UNANDERRA",
   "postcode": "2526"
 },
 {
   "suburb": "ALBION PARK",
   "postcode": "2527"
 },
 {
   "suburb": "ALBION PARK RAIL",
   "postcode": "2527"
 },
 {
   "suburb": "CALDERWOOD",
   "postcode": "2527"
 },
 {
   "suburb": "CROOM",
   "postcode": "2527"
 },
 {
   "suburb": "NORTH MACQUARIE",
   "postcode": "2527"
 },
 {
   "suburb": "TONGARRA",
   "postcode": "2527"
 },
 {
   "suburb": "TULLIMBAR",
   "postcode": "2527"
 },
 {
   "suburb": "YELLOW ROCK",
   "postcode": "2527"
 },
 {
   "suburb": "BARRACK HEIGHTS",
   "postcode": "2528"
 },
 {
   "suburb": "BARRACK POINT",
   "postcode": "2528"
 },
 {
   "suburb": "LAKE ILLAWARRA",
   "postcode": "2528"
 },
 {
   "suburb": "MOUNT WARRIGAL",
   "postcode": "2528"
 },
 {
   "suburb": "WARILLA",
   "postcode": "2528"
 },
 {
   "suburb": "WINDANG",
   "postcode": "2528"
 },
 {
   "suburb": "BLACKBUTT",
   "postcode": "2529"
 },
 {
   "suburb": "DUNMORE",
   "postcode": "2529"
 },
 {
   "suburb": "FLINDERS",
   "postcode": "2529"
 },
 {
   "suburb": "OAK FLATS",
   "postcode": "2529"
 },
 {
   "suburb": "SHELL COVE",
   "postcode": "2529"
 },
 {
   "suburb": "SHELLHARBOUR",
   "postcode": "2529"
 },
 {
   "suburb": "SHELLHARBOUR CITY CENTRE",
   "postcode": "2529"
 },
 {
   "suburb": "AVONDALE",
   "postcode": "2530"
 },
 {
   "suburb": "BROWNSVILLE",
   "postcode": "2530"
 },
 {
   "suburb": "CLEVELAND",
   "postcode": "2530"
 },
 {
   "suburb": "DAPTO",
   "postcode": "2530"
 },
 {
   "suburb": "DOMBARTON",
   "postcode": "2530"
 },
 {
   "suburb": "HAYWARDS BAY",
   "postcode": "2530"
 },
 {
   "suburb": "HORSLEY",
   "postcode": "2530"
 },
 {
   "suburb": "HUNTLEY",
   "postcode": "2530"
 },
 {
   "suburb": "KANAHOOKA",
   "postcode": "2530"
 },
 {
   "suburb": "KOONAWARRA",
   "postcode": "2530"
 },
 {
   "suburb": "MARSHALL MOUNT",
   "postcode": "2530"
 },
 {
   "suburb": "PENROSE",
   "postcode": "2530"
 },
 {
   "suburb": "WONGAWILLI",
   "postcode": "2530"
 },
 {
   "suburb": "YALLAH",
   "postcode": "2530"
 },
 {
   "suburb": "BOMBO",
   "postcode": "2533"
 },
 {
   "suburb": "CURRAMORE",
   "postcode": "2533"
 },
 {
   "suburb": "JAMBEROO",
   "postcode": "2533"
 },
 {
   "suburb": "JERRARA",
   "postcode": "2533"
 },
 {
   "suburb": "KIAMA",
   "postcode": "2533"
 },
 {
   "suburb": "KIAMA DOWNS",
   "postcode": "2533"
 },
 {
   "suburb": "KIAMA HEIGHTS",
   "postcode": "2533"
 },
 {
   "suburb": "MINNAMURRA",
   "postcode": "2533"
 },
 {
   "suburb": "SADDLEBACK MOUNTAIN",
   "postcode": "2533"
 },
 {
   "suburb": "BROUGHTON VILLAGE",
   "postcode": "2534"
 },
 {
   "suburb": "FOXGROUND",
   "postcode": "2534"
 },
 {
   "suburb": "GERRINGONG",
   "postcode": "2534"
 },
 {
   "suburb": "GERROA",
   "postcode": "2534"
 },
 {
   "suburb": "ROSE VALLEY",
   "postcode": "2534"
 },
 {
   "suburb": "TOOLIJOOA",
   "postcode": "2534"
 },
 {
   "suburb": "WERRI BEACH",
   "postcode": "2534"
 },
 {
   "suburb": "WILLOW VALE",
   "postcode": "2534"
 },
 {
   "suburb": "BACK FOREST",
   "postcode": "2535"
 },
 {
   "suburb": "BELLAWONGARAH",
   "postcode": "2535"
 },
 {
   "suburb": "BERRY",
   "postcode": "2535"
 },
 {
   "suburb": "BERRY MOUNTAIN",
   "postcode": "2535"
 },
 {
   "suburb": "BROGERS CREEK",
   "postcode": "2535"
 },
 {
   "suburb": "BROUGHTON",
   "postcode": "2535"
 },
 {
   "suburb": "BROUGHTON VALE",
   "postcode": "2535"
 },
 {
   "suburb": "BUDDEROO",
   "postcode": "2535"
 },
 {
   "suburb": "BUNDEWALLAH",
   "postcode": "2535"
 },
 {
   "suburb": "COOLANGATTA",
   "postcode": "2535"
 },
 {
   "suburb": "FAR MEADOW",
   "postcode": "2535"
 },
 {
   "suburb": "JASPERS BRUSH",
   "postcode": "2535"
 },
 {
   "suburb": "SHOALHAVEN HEADS",
   "postcode": "2535"
 },
 {
   "suburb": "WATTAMOLLA",
   "postcode": "2535"
 },
 {
   "suburb": "WOODHILL",
   "postcode": "2535"
 },
 {
   "suburb": "BATEHAVEN",
   "postcode": "2536"
 },
 {
   "suburb": "BATEMANS BAY",
   "postcode": "2536"
 },
 {
   "suburb": "BENANDARAH",
   "postcode": "2536"
 },
 {
   "suburb": "BIMBIMBIE",
   "postcode": "2536"
 },
 {
   "suburb": "BUCKENBOWRA",
   "postcode": "2536"
 },
 {
   "suburb": "CATALINA",
   "postcode": "2536"
 },
 {
   "suburb": "CURROWAN",
   "postcode": "2536"
 },
 {
   "suburb": "DENHAMS BEACH",
   "postcode": "2536"
 },
 {
   "suburb": "DEPOT BEACH",
   "postcode": "2536"
 },
 {
   "suburb": "DURRAS NORTH",
   "postcode": "2536"
 },
 {
   "suburb": "EAST LYNNE",
   "postcode": "2536"
 },
 {
   "suburb": "GUERILLA BAY",
   "postcode": "2536"
 },
 {
   "suburb": "JEREMADRA",
   "postcode": "2536"
 },
 {
   "suburb": "LILLI PILLI",
   "postcode": "2536"
 },
 {
   "suburb": "LONG BEACH",
   "postcode": "2536"
 },
 {
   "suburb": "MALONEYS BEACH",
   "postcode": "2536"
 },
 {
   "suburb": "MALUA BAY",
   "postcode": "2536"
 },
 {
   "suburb": "MOGO",
   "postcode": "2536"
 },
 {
   "suburb": "NELLIGEN",
   "postcode": "2536"
 },
 {
   "suburb": "NORTH BATEMANS BAY",
   "postcode": "2536"
 },
 {
   "suburb": "PEBBLY BEACH",
   "postcode": "2536"
 },
 {
   "suburb": "ROSEDALE",
   "postcode": "2536"
 },
 {
   "suburb": "RUNNYFORD",
   "postcode": "2536"
 },
 {
   "suburb": "SOUTH DURRAS",
   "postcode": "2536"
 },
 {
   "suburb": "SUNSHINE BAY",
   "postcode": "2536"
 },
 {
   "suburb": "SURF BEACH",
   "postcode": "2536"
 },
 {
   "suburb": "SURFSIDE",
   "postcode": "2536"
 },
 {
   "suburb": "WOODLANDS",
   "postcode": "2536"
 },
 {
   "suburb": "BERGALIA",
   "postcode": "2537"
 },
 {
   "suburb": "BINGIE",
   "postcode": "2537"
 },
 {
   "suburb": "BROULEE",
   "postcode": "2537"
 },
 {
   "suburb": "COILA",
   "postcode": "2537"
 },
 {
   "suburb": "CONGO",
   "postcode": "2537"
 },
 {
   "suburb": "DEUA",
   "postcode": "2537"
 },
 {
   "suburb": "DEUA RIVER VALLEY",
   "postcode": "2537"
 },
 {
   "suburb": "KIORA",
   "postcode": "2537"
 },
 {
   "suburb": "MERINGO",
   "postcode": "2537"
 },
 {
   "suburb": "MOGENDOURA",
   "postcode": "2537"
 },
 {
   "suburb": "MORUYA",
   "postcode": "2537"
 },
 {
   "suburb": "MORUYA HEADS",
   "postcode": "2537"
 },
 {
   "suburb": "MOSSY POINT",
   "postcode": "2537"
 },
 {
   "suburb": "TOMAKIN",
   "postcode": "2537"
 },
 {
   "suburb": "TURLINJAH",
   "postcode": "2537"
 },
 {
   "suburb": "TUROSS HEAD",
   "postcode": "2537"
 },
 {
   "suburb": "WAMBAN",
   "postcode": "2537"
 },
 {
   "suburb": "BROOMAN",
   "postcode": "2538"
 },
 {
   "suburb": "LITTLE FOREST",
   "postcode": "2538"
 },
 {
   "suburb": "MILTON",
   "postcode": "2538"
 },
 {
   "suburb": "MOGOOD",
   "postcode": "2538"
 },
 {
   "suburb": "MORTON",
   "postcode": "2538"
 },
 {
   "suburb": "PORTERS CREEK",
   "postcode": "2538"
 },
 {
   "suburb": "WOODBURN",
   "postcode": "2538"
 },
 {
   "suburb": "WOODSTOCK",
   "postcode": "2538"
 },
 {
   "suburb": "BAWLEY POINT",
   "postcode": "2539"
 },
 {
   "suburb": "BENDALONG",
   "postcode": "2539"
 },
 {
   "suburb": "BERRINGER LAKE",
   "postcode": "2539"
 },
 {
   "suburb": "BURRILL LAKE",
   "postcode": "2539"
 },
 {
   "suburb": "COCKWHY",
   "postcode": "2539"
 },
 {
   "suburb": "CONJOLA",
   "postcode": "2539"
 },
 {
   "suburb": "CONJOLA PARK",
   "postcode": "2539"
 },
 {
   "suburb": "CROOBYAR",
   "postcode": "2539"
 },
 {
   "suburb": "CUNJURONG POINT",
   "postcode": "2539"
 },
 {
   "suburb": "DOLPHIN POINT",
   "postcode": "2539"
 },
 {
   "suburb": "FISHERMANS PARADISE",
   "postcode": "2539"
 },
 {
   "suburb": "KINGS POINT",
   "postcode": "2539"
 },
 {
   "suburb": "KIOLOA",
   "postcode": "2539"
 },
 {
   "suburb": "LAKE CONJOLA",
   "postcode": "2539"
 },
 {
   "suburb": "LAKE TABOURIE",
   "postcode": "2539"
 },
 {
   "suburb": "MANYANA",
   "postcode": "2539"
 },
 {
   "suburb": "MOLLYMOOK",
   "postcode": "2539"
 },
 {
   "suburb": "MOLLYMOOK BEACH",
   "postcode": "2539"
 },
 {
   "suburb": "MOUNT KINGIMAN",
   "postcode": "2539"
 },
 {
   "suburb": "NARRAWALLEE",
   "postcode": "2539"
 },
 {
   "suburb": "POINTER MOUNTAIN",
   "postcode": "2539"
 },
 {
   "suburb": "PRETTY BEACH",
   "postcode": "2539"
 },
 {
   "suburb": "TERMEIL",
   "postcode": "2539"
 },
 {
   "suburb": "ULLADULLA",
   "postcode": "2539"
 },
 {
   "suburb": "YADBORO",
   "postcode": "2539"
 },
 {
   "suburb": "YATTE YATTAH",
   "postcode": "2539"
 },
 {
   "suburb": "BAMARANG",
   "postcode": "2540"
 },
 {
   "suburb": "BARRINGELLA",
   "postcode": "2540"
 },
 {
   "suburb": "BASIN VIEW",
   "postcode": "2540"
 },
 {
   "suburb": "BEECROFT PENINSULA",
   "postcode": "2540"
 },
 {
   "suburb": "BERRARA",
   "postcode": "2540"
 },
 {
   "suburb": "BEWONG",
   "postcode": "2540"
 },
 {
   "suburb": "BOLONG",
   "postcode": "2540"
 },
 {
   "suburb": "BOOLIJAH",
   "postcode": "2540"
 },
 {
   "suburb": "BREAM BEACH",
   "postcode": "2540"
 },
 {
   "suburb": "BROWNS MOUNTAIN",
   "postcode": "2540"
 },
 {
   "suburb": "BRUNDEE",
   "postcode": "2540"
 },
 {
   "suburb": "BUANGLA",
   "postcode": "2540"
 },
 {
   "suburb": "BURRIER",
   "postcode": "2540"
 },
 {
   "suburb": "CALLALA BAY",
   "postcode": "2540"
 },
 {
   "suburb": "CALLALA BEACH",
   "postcode": "2540"
 },
 {
   "suburb": "CAMBEWARRA",
   "postcode": "2540"
 },
 {
   "suburb": "CAMBEWARRA VILLAGE",
   "postcode": "2540"
 },
 {
   "suburb": "COMBERTON",
   "postcode": "2540"
 },
 {
   "suburb": "COMERONG ISLAND",
   "postcode": "2540"
 },
 {
   "suburb": "CUDMIRRAH",
   "postcode": "2540"
 },
 {
   "suburb": "CULBURRA BEACH",
   "postcode": "2540"
 },
 {
   "suburb": "CURRARONG",
   "postcode": "2540"
 },
 {
   "suburb": "EROWAL BAY",
   "postcode": "2540"
 },
 {
   "suburb": "ETTREMA",
   "postcode": "2540"
 },
 {
   "suburb": "FALLS CREEK",
   "postcode": "2540"
 },
 {
   "suburb": "GREENWELL POINT",
   "postcode": "2540"
 },
 {
   "suburb": "HMAS ALBATROSS",
   "postcode": "2540"
 },
 {
   "suburb": "HMAS CRESWELL",
   "postcode": "2540"
 },
 {
   "suburb": "HUSKISSON",
   "postcode": "2540"
 },
 {
   "suburb": "HYAMS BEACH",
   "postcode": "2540"
 },
 {
   "suburb": "ILLAROO",
   "postcode": "2540"
 },
 {
   "suburb": "JERRAWANGALA",
   "postcode": "2540"
 },
 {
   "suburb": "JERVIS BAY",
   "postcode": "2540"
 },
 {
   "suburb": "KINGHORNE",
   "postcode": "2540"
 },
 {
   "suburb": "LONGREACH",
   "postcode": "2540"
 },
 {
   "suburb": "MAYFIELD",
   "postcode": "2540"
 },
 {
   "suburb": "MEROO MEADOW",
   "postcode": "2540"
 },
 {
   "suburb": "MONDAYONG",
   "postcode": "2540"
 },
 {
   "suburb": "MOOLLATTOO",
   "postcode": "2540"
 },
 {
   "suburb": "MUNDAMIA",
   "postcode": "2540"
 },
 {
   "suburb": "MYOLA",
   "postcode": "2540"
 },
 {
   "suburb": "NOWRA HILL",
   "postcode": "2540"
 },
 {
   "suburb": "NOWRA NAVAL PO",
   "postcode": "2540"
 },
 {
   "suburb": "NUMBAA",
   "postcode": "2540"
 },
 {
   "suburb": "OLD EROWAL BAY",
   "postcode": "2540"
 },
 {
   "suburb": "ORIENT POINT",
   "postcode": "2540"
 },
 {
   "suburb": "PARMA",
   "postcode": "2540"
 },
 {
   "suburb": "PYREE",
   "postcode": "2540"
 },
 {
   "suburb": "SAINT GEORGES BASIN",
   "postcode": "2540"
 },
 {
   "suburb": "SANCTUARY POINT",
   "postcode": "2540"
 },
 {
   "suburb": "ST GEORGES BASIN",
   "postcode": "2540"
 },
 {
   "suburb": "SUSSEX INLET",
   "postcode": "2540"
 },
 {
   "suburb": "SWANHAVEN",
   "postcode": "2540"
 },
 {
   "suburb": "TALLOWAL",
   "postcode": "2540"
 },
 {
   "suburb": "TAPITALLEE",
   "postcode": "2540"
 },
 {
   "suburb": "TERARA",
   "postcode": "2540"
 },
 {
   "suburb": "TOMERONG",
   "postcode": "2540"
 },
 {
   "suburb": "TULLARWALLA",
   "postcode": "2540"
 },
 {
   "suburb": "TWELVE MILE PEG",
   "postcode": "2540"
 },
 {
   "suburb": "VINCENTIA",
   "postcode": "2540"
 },
 {
   "suburb": "WANDANDIAN",
   "postcode": "2540"
 },
 {
   "suburb": "WATERSLEIGH",
   "postcode": "2540"
 },
 {
   "suburb": "WOLLUMBOOLA",
   "postcode": "2540"
 },
 {
   "suburb": "WOOLLAMIA",
   "postcode": "2540"
 },
 {
   "suburb": "WORRIGEE",
   "postcode": "2540"
 },
 {
   "suburb": "WORROWING HEIGHTS",
   "postcode": "2540"
 },
 {
   "suburb": "WRECK BAY",
   "postcode": "2540"
 },
 {
   "suburb": "WRIGHTS BEACH",
   "postcode": "2540"
 },
 {
   "suburb": "YALWAL",
   "postcode": "2540"
 },
 {
   "suburb": "YERRIYONG",
   "postcode": "2540"
 },
 {
   "suburb": "BANGALEE",
   "postcode": "2541"
 },
 {
   "suburb": "BOMADERRY",
   "postcode": "2541"
 },
 {
   "suburb": "NORTH NOWRA",
   "postcode": "2541"
 },
 {
   "suburb": "NOWRA",
   "postcode": "2541"
 },
 {
   "suburb": "NOWRA EAST",
   "postcode": "2541"
 },
 {
   "suburb": "NOWRA NORTH",
   "postcode": "2541"
 },
 {
   "suburb": "SOUTH NOWRA",
   "postcode": "2541"
 },
 {
   "suburb": "WEST NOWRA",
   "postcode": "2541"
 },
 {
   "suburb": "BELOWRA",
   "postcode": "2545"
 },
 {
   "suburb": "BODALLA",
   "postcode": "2545"
 },
 {
   "suburb": "CADGEE",
   "postcode": "2545"
 },
 {
   "suburb": "EUROBODALLA",
   "postcode": "2545"
 },
 {
   "suburb": "NERRIGUNDAH",
   "postcode": "2545"
 },
 {
   "suburb": "POTATO POINT",
   "postcode": "2545"
 },
 {
   "suburb": "AKOLELE",
   "postcode": "2546"
 },
 {
   "suburb": "BERMAGUI",
   "postcode": "2546"
 },
 {
   "suburb": "CENTRAL TILBA",
   "postcode": "2546"
 },
 {
   "suburb": "DALMENY",
   "postcode": "2546"
 },
 {
   "suburb": "KIANGA",
   "postcode": "2546"
 },
 {
   "suburb": "MYSTERY BAY",
   "postcode": "2546"
 },
 {
   "suburb": "NAROOMA",
   "postcode": "2546"
 },
 {
   "suburb": "NORTH NAROOMA",
   "postcode": "2546"
 },
 {
   "suburb": "WALLAGA LAKE",
   "postcode": "2546"
 },
 {
   "suburb": "BERRAMBOOL",
   "postcode": "2548"
 },
 {
   "suburb": "MERIMBULA",
   "postcode": "2548"
 },
 {
   "suburb": "MIRADOR",
   "postcode": "2548"
 },
 {
   "suburb": "TURA BEACH",
   "postcode": "2548"
 },
 {
   "suburb": "BALD HILLS",
   "postcode": "2549"
 },
 {
   "suburb": "BROADWATER",
   "postcode": "2549"
 },
 {
   "suburb": "GREIGS FLAT",
   "postcode": "2549"
 },
 {
   "suburb": "LOCHIEL",
   "postcode": "2549"
 },
 {
   "suburb": "MILLINGANDI",
   "postcode": "2549"
 },
 {
   "suburb": "NETHERCOTE",
   "postcode": "2549"
 },
 {
   "suburb": "PAMBULA",
   "postcode": "2549"
 },
 {
   "suburb": "PAMBULA BEACH",
   "postcode": "2549"
 },
 {
   "suburb": "SOUTH PAMBULA",
   "postcode": "2549"
 },
 {
   "suburb": "ANGLEDALE",
   "postcode": "2550"
 },
 {
   "suburb": "BEGA",
   "postcode": "2550"
 },
 {
   "suburb": "BEMBOKA",
   "postcode": "2550"
 },
 {
   "suburb": "BLACK RANGE",
   "postcode": "2550"
 },
 {
   "suburb": "BUCKAJO",
   "postcode": "2550"
 },
 {
   "suburb": "CANDELO",
   "postcode": "2550"
 },
 {
   "suburb": "COBARGO",
   "postcode": "2550"
 },
 {
   "suburb": "COOLAGOLITE",
   "postcode": "2550"
 },
 {
   "suburb": "COOPERS GULLY",
   "postcode": "2550"
 },
 {
   "suburb": "GREENDALE",
   "postcode": "2550"
 },
 {
   "suburb": "JELLAT JELLAT",
   "postcode": "2550"
 },
 {
   "suburb": "KALARU",
   "postcode": "2550"
 },
 {
   "suburb": "KANOONA",
   "postcode": "2550"
 },
 {
   "suburb": "MOGILLA",
   "postcode": "2550"
 },
 {
   "suburb": "QUAAMA",
   "postcode": "2550"
 },
 {
   "suburb": "REEDY SWAMP",
   "postcode": "2550"
 },
 {
   "suburb": "SOUTH WOLUMLA",
   "postcode": "2550"
 },
 {
   "suburb": "STONY CREEK",
   "postcode": "2550"
 },
 {
   "suburb": "TANTAWANGALO",
   "postcode": "2550"
 },
 {
   "suburb": "TARRAGANDA",
   "postcode": "2550"
 },
 {
   "suburb": "TATHRA",
   "postcode": "2550"
 },
 {
   "suburb": "TOOTHDALE",
   "postcode": "2550"
 },
 {
   "suburb": "VERONA",
   "postcode": "2550"
 },
 {
   "suburb": "WALLAGOOT",
   "postcode": "2550"
 },
 {
   "suburb": "WOLUMLA",
   "postcode": "2550"
 },
 {
   "suburb": "WYNDHAM",
   "postcode": "2550"
 },
 {
   "suburb": "EDEN",
   "postcode": "2551"
 },
 {
   "suburb": "BADGERYS CREEK",
   "postcode": "2555"
 },
 {
   "suburb": "BRINGELLY",
   "postcode": "2556"
 },
 {
   "suburb": "CATHERINE FIELD",
   "postcode": "2557"
 },
 {
   "suburb": "GLEDSWOOD HILLS",
   "postcode": "2557"
 },
 {
   "suburb": "GREGORY HILLS",
   "postcode": "2557"
 },
 {
   "suburb": "ROSSMORE",
   "postcode": "2557"
 },
 {
   "suburb": "EAGLE VALE",
   "postcode": "2558"
 },
 {
   "suburb": "ESCHOL PARK",
   "postcode": "2558"
 },
 {
   "suburb": "KEARNS",
   "postcode": "2558"
 },
 {
   "suburb": "BLAIRMOUNT",
   "postcode": "2559"
 },
 {
   "suburb": "CLAYMORE",
   "postcode": "2559"
 },
 {
   "suburb": "AIRDS",
   "postcode": "2560"
 },
 {
   "suburb": "AMBARVALE",
   "postcode": "2560"
 },
 {
   "suburb": "APPIN",
   "postcode": "2560"
 },
 {
   "suburb": "BLAIR ATHOL",
   "postcode": "2560"
 },
 {
   "suburb": "BRADBURY",
   "postcode": "2560"
 },
 {
   "suburb": "CAMPBELLTOWN",
   "postcode": "2560"
 },
 {
   "suburb": "CAMPBELLTOWN NORTH",
   "postcode": "2560"
 },
 {
   "suburb": "CATARACT",
   "postcode": "2560"
 },
 {
   "suburb": "ENGLORIE PARK",
   "postcode": "2560"
 },
 {
   "suburb": "GILEAD",
   "postcode": "2560"
 },
 {
   "suburb": "GLEN ALPINE",
   "postcode": "2560"
 },
 {
   "suburb": "KENTLYN",
   "postcode": "2560"
 },
 {
   "suburb": "LEUMEAH",
   "postcode": "2560"
 },
 {
   "suburb": "MACARTHUR SQUARE",
   "postcode": "2560"
 },
 {
   "suburb": "ROSEMEADOW",
   "postcode": "2560"
 },
 {
   "suburb": "RUSE",
   "postcode": "2560"
 },
 {
   "suburb": "ST HELENS PARK",
   "postcode": "2560"
 },
 {
   "suburb": "WEDDERBURN",
   "postcode": "2560"
 },
 {
   "suburb": "WOODBINE",
   "postcode": "2560"
 },
 {
   "suburb": "MENANGLE PARK",
   "postcode": "2563"
 },
 {
   "suburb": "GLENQUARIE",
   "postcode": "2564"
 },
 {
   "suburb": "LONG POINT",
   "postcode": "2564"
 },
 {
   "suburb": "MACQUARIE FIELDS",
   "postcode": "2564"
 },
 {
   "suburb": "BARDIA",
   "postcode": "2565"
 },
 {
   "suburb": "DENHAM COURT",
   "postcode": "2565"
 },
 {
   "suburb": "INGLEBURN",
   "postcode": "2565"
 },
 {
   "suburb": "MACQUARIE LINKS",
   "postcode": "2565"
 },
 {
   "suburb": "BOW BOWING",
   "postcode": "2566"
 },
 {
   "suburb": "MINTO",
   "postcode": "2566"
 },
 {
   "suburb": "MINTO HEIGHTS",
   "postcode": "2566"
 },
 {
   "suburb": "RABY",
   "postcode": "2566"
 },
 {
   "suburb": "ST ANDREWS",
   "postcode": "2566"
 },
 {
   "suburb": "VARROVILLE",
   "postcode": "2566"
 },
 {
   "suburb": "CURRANS HILL",
   "postcode": "2567"
 },
 {
   "suburb": "HARRINGTON PARK",
   "postcode": "2567"
 },
 {
   "suburb": "MOUNT ANNAN",
   "postcode": "2567"
 },
 {
   "suburb": "NARELLAN",
   "postcode": "2567"
 },
 {
   "suburb": "NARELLAN VALE",
   "postcode": "2567"
 },
 {
   "suburb": "SMEATON GRANGE",
   "postcode": "2567"
 },
 {
   "suburb": "MENANGLE",
   "postcode": "2568"
 },
 {
   "suburb": "DOUGLAS PARK",
   "postcode": "2569"
 },
 {
   "suburb": "BELIMBLA PARK",
   "postcode": "2570"
 },
 {
   "suburb": "BICKLEY VALE",
   "postcode": "2570"
 },
 {
   "suburb": "BROWNLOW HILL",
   "postcode": "2570"
 },
 {
   "suburb": "CAMDEN",
   "postcode": "2570"
 },
 {
   "suburb": "CAMDEN PARK",
   "postcode": "2570"
 },
 {
   "suburb": "CAMDEN SOUTH",
   "postcode": "2570"
 },
 {
   "suburb": "CAWDOR",
   "postcode": "2570"
 },
 {
   "suburb": "COBBITTY",
   "postcode": "2570"
 },
 {
   "suburb": "ELDERSLIE",
   "postcode": "2570"
 },
 {
   "suburb": "ELLIS LANE",
   "postcode": "2570"
 },
 {
   "suburb": "GLENMORE",
   "postcode": "2570"
 },
 {
   "suburb": "GRASMERE",
   "postcode": "2570"
 },
 {
   "suburb": "KIRKHAM",
   "postcode": "2570"
 },
 {
   "suburb": "MOUNT HUNTER",
   "postcode": "2570"
 },
 {
   "suburb": "NATTAI",
   "postcode": "2570"
 },
 {
   "suburb": "OAKDALE",
   "postcode": "2570"
 },
 {
   "suburb": "ORAN PARK",
   "postcode": "2570"
 },
 {
   "suburb": "ORANGEVILLE",
   "postcode": "2570"
 },
 {
   "suburb": "SPRING FARM",
   "postcode": "2570"
 },
 {
   "suburb": "THE OAKS",
   "postcode": "2570"
 },
 {
   "suburb": "THERESA PARK",
   "postcode": "2570"
 },
 {
   "suburb": "WEROMBI",
   "postcode": "2570"
 },
 {
   "suburb": "BALMORAL",
   "postcode": "2571"
 },
 {
   "suburb": "BUXTON",
   "postcode": "2571"
 },
 {
   "suburb": "COURIDJAH",
   "postcode": "2571"
 },
 {
   "suburb": "MALDON",
   "postcode": "2571"
 },
 {
   "suburb": "MOWBRAY PARK",
   "postcode": "2571"
 },
 {
   "suburb": "PICTON",
   "postcode": "2571"
 },
 {
   "suburb": "RAZORBACK",
   "postcode": "2571"
 },
 {
   "suburb": "WILTON",
   "postcode": "2571"
 },
 {
   "suburb": "LAKESLAND",
   "postcode": "2572"
 },
 {
   "suburb": "THIRLMERE",
   "postcode": "2572"
 },
 {
   "suburb": "TAHMOOR",
   "postcode": "2573"
 },
 {
   "suburb": "AVON",
   "postcode": "2574"
 },
 {
   "suburb": "BARGO",
   "postcode": "2574"
 },
 {
   "suburb": "PHEASANTS NEST",
   "postcode": "2574"
 },
 {
   "suburb": "YANDERRA",
   "postcode": "2574"
 },
 {
   "suburb": "ALPINE",
   "postcode": "2575"
 },
 {
   "suburb": "AYLMERTON",
   "postcode": "2575"
 },
 {
   "suburb": "BALACLAVA",
   "postcode": "2575"
 },
 {
   "suburb": "BRAEMAR",
   "postcode": "2575"
 },
 {
   "suburb": "BULLIO",
   "postcode": "2575"
 },
 {
   "suburb": "COLO VALE",
   "postcode": "2575"
 },
 {
   "suburb": "GOODMANS FORD",
   "postcode": "2575"
 },
 {
   "suburb": "HIGH RANGE",
   "postcode": "2575"
 },
 {
   "suburb": "HILL TOP",
   "postcode": "2575"
 },
 {
   "suburb": "JOADJA",
   "postcode": "2575"
 },
 {
   "suburb": "MANDEMAR",
   "postcode": "2575"
 },
 {
   "suburb": "MITTAGONG",
   "postcode": "2575"
 },
 {
   "suburb": "MOUNT LINDSEY",
   "postcode": "2575"
 },
 {
   "suburb": "RENWICK",
   "postcode": "2575"
 },
 {
   "suburb": "WATTLE RIDGE",
   "postcode": "2575"
 },
 {
   "suburb": "WELBY",
   "postcode": "2575"
 },
 {
   "suburb": "WILLOW VALE",
   "postcode": "2575"
 },
 {
   "suburb": "WOODLANDS",
   "postcode": "2575"
 },
 {
   "suburb": "YERRINBOOL",
   "postcode": "2575"
 },
 {
   "suburb": "BOWRAL",
   "postcode": "2576"
 },
 {
   "suburb": "BURRADOO",
   "postcode": "2576"
 },
 {
   "suburb": "EAST BOWRAL",
   "postcode": "2576"
 },
 {
   "suburb": "EAST KANGALOON",
   "postcode": "2576"
 },
 {
   "suburb": "GLENQUARRY",
   "postcode": "2576"
 },
 {
   "suburb": "KANGALOON",
   "postcode": "2576"
 },
 {
   "suburb": "AVOCA",
   "postcode": "2577"
 },
 {
   "suburb": "BARREN GROUNDS",
   "postcode": "2577"
 },
 {
   "suburb": "BARRENGARRY",
   "postcode": "2577"
 },
 {
   "suburb": "BEAUMONT",
   "postcode": "2577"
 },
 {
   "suburb": "BELANGLO",
   "postcode": "2577"
 },
 {
   "suburb": "BERRIMA",
   "postcode": "2577"
 },
 {
   "suburb": "BUDGONG",
   "postcode": "2577"
 },
 {
   "suburb": "BURRAWANG",
   "postcode": "2577"
 },
 {
   "suburb": "CANYONLEIGH",
   "postcode": "2577"
 },
 {
   "suburb": "CARRINGTON FALLS",
   "postcode": "2577"
 },
 {
   "suburb": "FITZROY FALLS",
   "postcode": "2577"
 },
 {
   "suburb": "KANGAROO VALLEY",
   "postcode": "2577"
 },
 {
   "suburb": "KNIGHTS HILL",
   "postcode": "2577"
 },
 {
   "suburb": "MACQUARIE PASS",
   "postcode": "2577"
 },
 {
   "suburb": "MANCHESTER SQUARE",
   "postcode": "2577"
 },
 {
   "suburb": "MEDWAY",
   "postcode": "2577"
 },
 {
   "suburb": "MERYLA",
   "postcode": "2577"
 },
 {
   "suburb": "MOSS VALE",
   "postcode": "2577"
 },
 {
   "suburb": "MOUNT MURRAY",
   "postcode": "2577"
 },
 {
   "suburb": "NEW BERRIMA",
   "postcode": "2577"
 },
 {
   "suburb": "PADDYS RIVER",
   "postcode": "2577"
 },
 {
   "suburb": "RED ROCKS",
   "postcode": "2577"
 },
 {
   "suburb": "ROBERTSON",
   "postcode": "2577"
 },
 {
   "suburb": "SUTTON FOREST",
   "postcode": "2577"
 },
 {
   "suburb": "UPPER KANGAROO RIVER",
   "postcode": "2577"
 },
 {
   "suburb": "UPPER KANGAROO VALLEY",
   "postcode": "2577"
 },
 {
   "suburb": "WERAI",
   "postcode": "2577"
 },
 {
   "suburb": "WILDES MEADOW",
   "postcode": "2577"
 },
 {
   "suburb": "BLAXLANDS RIDGE",
   "postcode": "2578"
 },
 {
   "suburb": "BUNDANOON",
   "postcode": "2578"
 },
 {
   "suburb": "BIG HILL",
   "postcode": "2579"
 },
 {
   "suburb": "BRAYTON",
   "postcode": "2579"
 },
 {
   "suburb": "EXETER",
   "postcode": "2579"
 },
 {
   "suburb": "MARULAN",
   "postcode": "2579"
 },
 {
   "suburb": "PENROSE",
   "postcode": "2579"
 },
 {
   "suburb": "TALLONG",
   "postcode": "2579"
 },
 {
   "suburb": "WINGELLO",
   "postcode": "2579"
 },
 {
   "suburb": "BANNABY",
   "postcode": "2580"
 },
 {
   "suburb": "BANNISTER",
   "postcode": "2580"
 },
 {
   "suburb": "BAW BAW",
   "postcode": "2580"
 },
 {
   "suburb": "BOXERS CREEK",
   "postcode": "2580"
 },
 {
   "suburb": "BRISBANE GROVE",
   "postcode": "2580"
 },
 {
   "suburb": "BUNGONIA",
   "postcode": "2580"
 },
 {
   "suburb": "CARRICK",
   "postcode": "2580"
 },
 {
   "suburb": "CHATSBURY",
   "postcode": "2580"
 },
 {
   "suburb": "CURRAWANG",
   "postcode": "2580"
 },
 {
   "suburb": "CURRAWEELA",
   "postcode": "2580"
 },
 {
   "suburb": "GOLSPIE",
   "postcode": "2580"
 },
 {
   "suburb": "GOULBURN",
   "postcode": "2580"
 },
 {
   "suburb": "GOULBURN MULWAREE COUNCIL",
   "postcode": "2580"
 },
 {
   "suburb": "GOULBURN NORTH",
   "postcode": "2580"
 },
 {
   "suburb": "GREENWICH PARK",
   "postcode": "2580"
 },
 {
   "suburb": "GUNDARY",
   "postcode": "2580"
 },
 {
   "suburb": "JERRONG",
   "postcode": "2580"
 },
 {
   "suburb": "KINGSDALE",
   "postcode": "2580"
 },
 {
   "suburb": "LAKE BATHURST",
   "postcode": "2580"
 },
 {
   "suburb": "LOWER BORO",
   "postcode": "2580"
 },
 {
   "suburb": "MAYFIELD",
   "postcode": "2580"
 },
 {
   "suburb": "MIDDLE ARM",
   "postcode": "2580"
 },
 {
   "suburb": "MOUNT FAIRY",
   "postcode": "2580"
 },
 {
   "suburb": "MUMMEL",
   "postcode": "2580"
 },
 {
   "suburb": "MYRTLEVILLE",
   "postcode": "2580"
 },
 {
   "suburb": "PALING YARDS",
   "postcode": "2580"
 },
 {
   "suburb": "PARKESBOURNE",
   "postcode": "2580"
 },
 {
   "suburb": "POMEROY",
   "postcode": "2580"
 },
 {
   "suburb": "QUIALIGO",
   "postcode": "2580"
 },
 {
   "suburb": "RICHLANDS",
   "postcode": "2580"
 },
 {
   "suburb": "ROSLYN",
   "postcode": "2580"
 },
 {
   "suburb": "RUN-O-WATERS",
   "postcode": "2580"
 },
 {
   "suburb": "STONEQUARRY",
   "postcode": "2580"
 },
 {
   "suburb": "TARAGO",
   "postcode": "2580"
 },
 {
   "suburb": "TARALGA",
   "postcode": "2580"
 },
 {
   "suburb": "TARLO",
   "postcode": "2580"
 },
 {
   "suburb": "TIRRANNAVILLE",
   "postcode": "2580"
 },
 {
   "suburb": "TOWRANG",
   "postcode": "2580"
 },
 {
   "suburb": "WAYO",
   "postcode": "2580"
 },
 {
   "suburb": "WIARBOROUGH",
   "postcode": "2580"
 },
 {
   "suburb": "WINDELLAMA",
   "postcode": "2580"
 },
 {
   "suburb": "WOMBEYAN CAVES",
   "postcode": "2580"
 },
 {
   "suburb": "WOODHOUSELEE",
   "postcode": "2580"
 },
 {
   "suburb": "YALBRAITH",
   "postcode": "2580"
 },
 {
   "suburb": "YARRA",
   "postcode": "2580"
 },
 {
   "suburb": "BELLMOUNT FOREST",
   "postcode": "2581"
 },
 {
   "suburb": "BREADALBANE",
   "postcode": "2581"
 },
 {
   "suburb": "BROADWAY",
   "postcode": "2581"
 },
 {
   "suburb": "COLLECTOR",
   "postcode": "2581"
 },
 {
   "suburb": "CULLERIN",
   "postcode": "2581"
 },
 {
   "suburb": "DALTON",
   "postcode": "2581"
 },
 {
   "suburb": "GUNNING",
   "postcode": "2581"
 },
 {
   "suburb": "LADE VALE",
   "postcode": "2581"
 },
 {
   "suburb": "LAKE GEORGE",
   "postcode": "2581"
 },
 {
   "suburb": "LERIDA",
   "postcode": "2581"
 },
 {
   "suburb": "MERRILL",
   "postcode": "2581"
 },
 {
   "suburb": "OOLONG",
   "postcode": "2581"
 },
 {
   "suburb": "WOLLOGORANG",
   "postcode": "2581"
 },
 {
   "suburb": "BANGO",
   "postcode": "2582"
 },
 {
   "suburb": "BOAMBOLO",
   "postcode": "2582"
 },
 {
   "suburb": "BOOKHAM",
   "postcode": "2582"
 },
 {
   "suburb": "BOWNING",
   "postcode": "2582"
 },
 {
   "suburb": "GOOD HOPE",
   "postcode": "2582"
 },
 {
   "suburb": "JEIR",
   "postcode": "2582"
 },
 {
   "suburb": "JERRAWA",
   "postcode": "2582"
 },
 {
   "suburb": "KANGIARA",
   "postcode": "2582"
 },
 {
   "suburb": "LAVERSTOCK",
   "postcode": "2582"
 },
 {
   "suburb": "MANTON",
   "postcode": "2582"
 },
 {
   "suburb": "MARCHMONT",
   "postcode": "2582"
 },
 {
   "suburb": "MURRUMBATEMAN",
   "postcode": "2582"
 },
 {
   "suburb": "YASS",
   "postcode": "2582"
 },
 {
   "suburb": "BIGGA",
   "postcode": "2583"
 },
 {
   "suburb": "BINDA",
   "postcode": "2583"
 },
 {
   "suburb": "CROOKED CORNER",
   "postcode": "2583"
 },
 {
   "suburb": "CROOKWELL",
   "postcode": "2583"
 },
 {
   "suburb": "FULLERTON",
   "postcode": "2583"
 },
 {
   "suburb": "GRABBEN GULLEN",
   "postcode": "2583"
 },
 {
   "suburb": "LAGGAN",
   "postcode": "2583"
 },
 {
   "suburb": "LIMERICK",
   "postcode": "2583"
 },
 {
   "suburb": "LOST RIVER",
   "postcode": "2583"
 },
 {
   "suburb": "NARRAWA",
   "postcode": "2583"
 },
 {
   "suburb": "PEELWOOD",
   "postcode": "2583"
 },
 {
   "suburb": "PEJAR",
   "postcode": "2583"
 },
 {
   "suburb": "RUGBY",
   "postcode": "2583"
 },
 {
   "suburb": "TUENA",
   "postcode": "2583"
 },
 {
   "suburb": "WHEEO",
   "postcode": "2583"
 },
 {
   "suburb": "BINALONG",
   "postcode": "2584"
 },
 {
   "suburb": "GALONG",
   "postcode": "2585"
 },
 {
   "suburb": "BOOROWA",
   "postcode": "2586"
 },
 {
   "suburb": "FROGMORE",
   "postcode": "2586"
 },
 {
   "suburb": "GODFREYS CREEK",
   "postcode": "2586"
 },
 {
   "suburb": "MURRINGO",
   "postcode": "2586"
 },
 {
   "suburb": "REIDS FLAT",
   "postcode": "2586"
 },
 {
   "suburb": "RYE PARK",
   "postcode": "2586"
 },
 {
   "suburb": "TAYLORS FLAT",
   "postcode": "2586"
 },
 {
   "suburb": "BEGGAN BEGGAN",
   "postcode": "2587"
 },
 {
   "suburb": "CUNNINGAR",
   "postcode": "2587"
 },
 {
   "suburb": "HARDEN",
   "postcode": "2587"
 },
 {
   "suburb": "KINGSVALE",
   "postcode": "2587"
 },
 {
   "suburb": "MCMAHONS REEF",
   "postcode": "2587"
 },
 {
   "suburb": "MURRUMBURRAH",
   "postcode": "2587"
 },
 {
   "suburb": "NUBBA",
   "postcode": "2587"
 },
 {
   "suburb": "WOMBAT",
   "postcode": "2587"
 },
 {
   "suburb": "WALLENDBEEN",
   "postcode": "2588"
 },
 {
   "suburb": "BETHUNGRA",
   "postcode": "2590"
 },
 {
   "suburb": "COOTAMUNDRA",
   "postcode": "2590"
 },
 {
   "suburb": "ILLABO",
   "postcode": "2590"
 },
 {
   "suburb": "BARWANG",
   "postcode": "2594"
 },
 {
   "suburb": "BERTHONG",
   "postcode": "2594"
 },
 {
   "suburb": "BRIBBAREE",
   "postcode": "2594"
 },
 {
   "suburb": "BULLA CREEK",
   "postcode": "2594"
 },
 {
   "suburb": "BURRANGONG",
   "postcode": "2594"
 },
 {
   "suburb": "KIKIAMAH",
   "postcode": "2594"
 },
 {
   "suburb": "MAIMURU",
   "postcode": "2594"
 },
 {
   "suburb": "MEMAGONG",
   "postcode": "2594"
 },
 {
   "suburb": "MILVALE",
   "postcode": "2594"
 },
 {
   "suburb": "MONTEAGLE",
   "postcode": "2594"
 },
 {
   "suburb": "THUDDUNGRA",
   "postcode": "2594"
 },
 {
   "suburb": "TUBBUL",
   "postcode": "2594"
 },
 {
   "suburb": "WEEDALLION",
   "postcode": "2594"
 },
 {
   "suburb": "YOUNG",
   "postcode": "2594"
 },
 {
   "suburb": "BARTON",
   "postcode": "2600"
 },
 {
   "suburb": "CANBERRA",
   "postcode": "2600"
 },
 {
   "suburb": "CAPITAL HILL",
   "postcode": "2600"
 },
 {
   "suburb": "DEAKIN",
   "postcode": "2600"
 },
 {
   "suburb": "DEAKIN WEST",
   "postcode": "2600"
 },
 {
   "suburb": "HARMAN",
   "postcode": "2600"
 },
 {
   "suburb": "HMAS HARMAN",
   "postcode": "2600"
 },
 {
   "suburb": "PARKES",
   "postcode": "2600"
 },
 {
   "suburb": "RUSSELL",
   "postcode": "2600"
 },
 {
   "suburb": "YARRALUMLA",
   "postcode": "2600"
 },
 {
   "suburb": "ACTON",
   "postcode": "2601"
 },
 {
   "suburb": "CANBERRA",
   "postcode": "2601"
 },
 {
   "suburb": "CITY",
   "postcode": "2601"
 },
 {
   "suburb": "AINSLIE",
   "postcode": "2602"
 },
 {
   "suburb": "DICKSON",
   "postcode": "2602"
 },
 {
   "suburb": "DOWNER",
   "postcode": "2602"
 },
 {
   "suburb": "HACKETT",
   "postcode": "2602"
 },
 {
   "suburb": "LYNEHAM",
   "postcode": "2602"
 },
 {
   "suburb": "O'CONNOR",
   "postcode": "2602"
 },
 {
   "suburb": "WATSON",
   "postcode": "2602"
 },
 {
   "suburb": "FORREST",
   "postcode": "2603"
 },
 {
   "suburb": "FYSHWICK",
   "postcode": "2603"
 },
 {
   "suburb": "GRIFFITH",
   "postcode": "2603"
 },
 {
   "suburb": "KINGSTON",
   "postcode": "2603"
 },
 {
   "suburb": "MANUKA",
   "postcode": "2603"
 },
 {
   "suburb": "RED HILL",
   "postcode": "2603"
 },
 {
   "suburb": "CAUSEWAY",
   "postcode": "2604"
 },
 {
   "suburb": "KINGSTON",
   "postcode": "2604"
 },
 {
   "suburb": "NARRABUNDAH",
   "postcode": "2604"
 },
 {
   "suburb": "CURTIN",
   "postcode": "2605"
 },
 {
   "suburb": "GARRAN",
   "postcode": "2605"
 },
 {
   "suburb": "HUGHES",
   "postcode": "2605"
 },
 {
   "suburb": "CHIFLEY",
   "postcode": "2606"
 },
 {
   "suburb": "LYONS",
   "postcode": "2606"
 },
 {
   "suburb": "O'MALLEY",
   "postcode": "2606"
 },
 {
   "suburb": "PHILLIP",
   "postcode": "2606"
 },
 {
   "suburb": "WODEN",
   "postcode": "2606"
 },
 {
   "suburb": "FARRER",
   "postcode": "2607"
 },
 {
   "suburb": "ISAACS",
   "postcode": "2607"
 },
 {
   "suburb": "MAWSON",
   "postcode": "2607"
 },
 {
   "suburb": "PEARCE",
   "postcode": "2607"
 },
 {
   "suburb": "TORRENS",
   "postcode": "2607"
 },
 {
   "suburb": "CIVIC SQUARE",
   "postcode": "2608"
 },
 {
   "suburb": "CANBERRA AIRPORT",
   "postcode": "2609"
 },
 {
   "suburb": "FYSHWICK",
   "postcode": "2609"
 },
 {
   "suburb": "MAJURA",
   "postcode": "2609"
 },
 {
   "suburb": "PIALLIGO",
   "postcode": "2609"
 },
 {
   "suburb": "SYMONSTON",
   "postcode": "2609"
 },
 {
   "suburb": "CANBERRA MC",
   "postcode": "2610"
 },
 {
   "suburb": "BIMBERI",
   "postcode": "2611"
 },
 {
   "suburb": "BRINDABELLA",
   "postcode": "2611"
 },
 {
   "suburb": "CHAPMAN",
   "postcode": "2611"
 },
 {
   "suburb": "COOLEMAN",
   "postcode": "2611"
 },
 {
   "suburb": "COOMBS",
   "postcode": "2611"
 },
 {
   "suburb": "COREE",
   "postcode": "2611"
 },
 {
   "suburb": "DENMAN PROSPECT",
   "postcode": "2611"
 },
 {
   "suburb": "DUFFY",
   "postcode": "2611"
 },
 {
   "suburb": "FISHER",
   "postcode": "2611"
 },
 {
   "suburb": "HOLDER",
   "postcode": "2611"
 },
 {
   "suburb": "RIVETT",
   "postcode": "2611"
 },
 {
   "suburb": "STIRLING",
   "postcode": "2611"
 },
 {
   "suburb": "STROMLO",
   "postcode": "2611"
 },
 {
   "suburb": "URIARRA",
   "postcode": "2611"
 },
 {
   "suburb": "URIARRA VILLAGE",
   "postcode": "2611"
 },
 {
   "suburb": "WARAMANGA",
   "postcode": "2611"
 },
 {
   "suburb": "WESTON",
   "postcode": "2611"
 },
 {
   "suburb": "WESTON CREEK",
   "postcode": "2611"
 },
 {
   "suburb": "WHITLAM",
   "postcode": "2611"
 },
 {
   "suburb": "WRIGHT",
   "postcode": "2611"
 },
 {
   "suburb": "BRADDON",
   "postcode": "2612"
 },
 {
   "suburb": "CAMPBELL",
   "postcode": "2612"
 },
 {
   "suburb": "REID",
   "postcode": "2612"
 },
 {
   "suburb": "TURNER",
   "postcode": "2612"
 },
 {
   "suburb": "ARANDA",
   "postcode": "2614"
 },
 {
   "suburb": "COOK",
   "postcode": "2614"
 },
 {
   "suburb": "HAWKER",
   "postcode": "2614"
 },
 {
   "suburb": "JAMISON CENTRE",
   "postcode": "2614"
 },
 {
   "suburb": "MACQUARIE",
   "postcode": "2614"
 },
 {
   "suburb": "PAGE",
   "postcode": "2614"
 },
 {
   "suburb": "SCULLIN",
   "postcode": "2614"
 },
 {
   "suburb": "WEETANGERA",
   "postcode": "2614"
 },
 {
   "suburb": "CHARNWOOD",
   "postcode": "2615"
 },
 {
   "suburb": "DUNLOP",
   "postcode": "2615"
 },
 {
   "suburb": "FLOREY",
   "postcode": "2615"
 },
 {
   "suburb": "FLYNN",
   "postcode": "2615"
 },
 {
   "suburb": "FRASER",
   "postcode": "2615"
 },
 {
   "suburb": "HIGGINS",
   "postcode": "2615"
 },
 {
   "suburb": "HOLT",
   "postcode": "2615"
 },
 {
   "suburb": "KIPPAX",
   "postcode": "2615"
 },
 {
   "suburb": "LATHAM",
   "postcode": "2615"
 },
 {
   "suburb": "MACGREGOR",
   "postcode": "2615"
 },
 {
   "suburb": "MACNAMARA",
   "postcode": "2615"
 },
 {
   "suburb": "MELBA",
   "postcode": "2615"
 },
 {
   "suburb": "NORTH WEST RURAL CANBERRA",
   "postcode": "2615"
 },
 {
   "suburb": "SPENCE",
   "postcode": "2615"
 },
 {
   "suburb": "STRATHNAIRN",
   "postcode": "2615"
 },
 {
   "suburb": "BELCONNEN",
   "postcode": "2616"
 },
 {
   "suburb": "BELCONNEN",
   "postcode": "2617"
 },
 {
   "suburb": "BRUCE",
   "postcode": "2617"
 },
 {
   "suburb": "EVATT",
   "postcode": "2617"
 },
 {
   "suburb": "GIRALANG",
   "postcode": "2617"
 },
 {
   "suburb": "KALEEN",
   "postcode": "2617"
 },
 {
   "suburb": "LAWSON",
   "postcode": "2617"
 },
 {
   "suburb": "MCKELLAR",
   "postcode": "2617"
 },
 {
   "suburb": "UNIVERSITY OF CANBERRA",
   "postcode": "2617"
 },
 {
   "suburb": "HALL",
   "postcode": "2618"
 },
 {
   "suburb": "NANIMA",
   "postcode": "2618"
 },
 {
   "suburb": "SPRINGRANGE",
   "postcode": "2618"
 },
 {
   "suburb": "WALLAROO",
   "postcode": "2618"
 },
 {
   "suburb": "JERRABOMBERRA",
   "postcode": "2619"
 },
 {
   "suburb": "BEARD",
   "postcode": "2620"
 },
 {
   "suburb": "BURRA",
   "postcode": "2620"
 },
 {
   "suburb": "CARWOOLA",
   "postcode": "2620"
 },
 {
   "suburb": "CLEAR RANGE",
   "postcode": "2620"
 },
 {
   "suburb": "CRESTWOOD",
   "postcode": "2620"
 },
 {
   "suburb": "ENVIRONA",
   "postcode": "2620"
 },
 {
   "suburb": "GOOGONG",
   "postcode": "2620"
 },
 {
   "suburb": "GREENLEIGH",
   "postcode": "2620"
 },
 {
   "suburb": "GUNDAROO",
   "postcode": "2620"
 },
 {
   "suburb": "HUME",
   "postcode": "2620"
 },
 {
   "suburb": "KARABAR",
   "postcode": "2620"
 },
 {
   "suburb": "KOWEN",
   "postcode": "2620"
 },
 {
   "suburb": "MICHELAGO",
   "postcode": "2620"
 },
 {
   "suburb": "OAKS ESTATE",
   "postcode": "2620"
 },
 {
   "suburb": "PADDYS RIVER",
   "postcode": "2620"
 },
 {
   "suburb": "QUEANBEYAN",
   "postcode": "2620"
 },
 {
   "suburb": "QUEANBEYAN EAST",
   "postcode": "2620"
 },
 {
   "suburb": "QUEANBEYAN WEST",
   "postcode": "2620"
 },
 {
   "suburb": "ROYALLA",
   "postcode": "2620"
 },
 {
   "suburb": "SUTTON",
   "postcode": "2620"
 },
 {
   "suburb": "THARWA",
   "postcode": "2620"
 },
 {
   "suburb": "THE ANGLE",
   "postcode": "2620"
 },
 {
   "suburb": "THE RIDGEWAY",
   "postcode": "2620"
 },
 {
   "suburb": "TINDERRY",
   "postcode": "2620"
 },
 {
   "suburb": "TRALEE",
   "postcode": "2620"
 },
 {
   "suburb": "URILA",
   "postcode": "2620"
 },
 {
   "suburb": "WAMBOIN",
   "postcode": "2620"
 },
 {
   "suburb": "WILLIAMSDALE",
   "postcode": "2620"
 },
 {
   "suburb": "YARROW",
   "postcode": "2620"
 },
 {
   "suburb": "BUNGENDORE",
   "postcode": "2621"
 },
 {
   "suburb": "BYWONG",
   "postcode": "2621"
 },
 {
   "suburb": "FORBES CREEK",
   "postcode": "2621"
 },
 {
   "suburb": "PRIMROSE VALLEY",
   "postcode": "2621"
 },
 {
   "suburb": "ARALUEN",
   "postcode": "2622"
 },
 {
   "suburb": "BENDOURA",
   "postcode": "2622"
 },
 {
   "suburb": "BRAIDWOOD",
   "postcode": "2622"
 },
 {
   "suburb": "DURRAN DURRA",
   "postcode": "2622"
 },
 {
   "suburb": "JEMBAICUMBENE",
   "postcode": "2622"
 },
 {
   "suburb": "LARBERT",
   "postcode": "2622"
 },
 {
   "suburb": "MAJORS CREEK",
   "postcode": "2622"
 },
 {
   "suburb": "MANAR",
   "postcode": "2622"
 },
 {
   "suburb": "MONGARLOWE",
   "postcode": "2622"
 },
 {
   "suburb": "REIDSDALE",
   "postcode": "2622"
 },
 {
   "suburb": "WARRI",
   "postcode": "2622"
 },
 {
   "suburb": "BREDBO",
   "postcode": "2626"
 },
 {
   "suburb": "BUMBALONG",
   "postcode": "2626"
 },
 {
   "suburb": "COLINTON",
   "postcode": "2626"
 },
 {
   "suburb": "BINJURA",
   "postcode": "2630"
 },
 {
   "suburb": "BUNYAN",
   "postcode": "2630"
 },
 {
   "suburb": "CHAKOLA",
   "postcode": "2630"
 },
 {
   "suburb": "COOLRINGDON",
   "postcode": "2630"
 },
 {
   "suburb": "COOMA",
   "postcode": "2630"
 },
 {
   "suburb": "COOMA NORTH",
   "postcode": "2630"
 },
 {
   "suburb": "DAIRYMANS PLAINS",
   "postcode": "2630"
 },
 {
   "suburb": "DANGELONG",
   "postcode": "2630"
 },
 {
   "suburb": "GLEN FERGUS",
   "postcode": "2630"
 },
 {
   "suburb": "MIDDLE FLAT",
   "postcode": "2630"
 },
 {
   "suburb": "MURRUMBUCCA",
   "postcode": "2630"
 },
 {
   "suburb": "NUMERALLA",
   "postcode": "2630"
 },
 {
   "suburb": "PINE VALLEY",
   "postcode": "2630"
 },
 {
   "suburb": "POLO FLAT",
   "postcode": "2630"
 },
 {
   "suburb": "ROCK FLAT",
   "postcode": "2630"
 },
 {
   "suburb": "THE BROTHERS",
   "postcode": "2630"
 },
 {
   "suburb": "ALBURY",
   "postcode": "2640"
 },
 {
   "suburb": "BUNGOWANNAH",
   "postcode": "2640"
 },
 {
   "suburb": "EAST ALBURY",
   "postcode": "2640"
 },
 {
   "suburb": "ETTAMOGAH",
   "postcode": "2640"
 },
 {
   "suburb": "GLENROY",
   "postcode": "2640"
 },
 {
   "suburb": "LAVINGTON DC",
   "postcode": "2640"
 },
 {
   "suburb": "MOORWATHA",
   "postcode": "2640"
 },
 {
   "suburb": "NORTH ALBURY",
   "postcode": "2640"
 },
 {
   "suburb": "SOUTH ALBURY",
   "postcode": "2640"
 },
 {
   "suburb": "SPLITTERS CREEK",
   "postcode": "2640"
 },
 {
   "suburb": "TABLE TOP",
   "postcode": "2640"
 },
 {
   "suburb": "TALMALMO",
   "postcode": "2640"
 },
 {
   "suburb": "THURGOONA",
   "postcode": "2640"
 },
 {
   "suburb": "WEST ALBURY",
   "postcode": "2640"
 },
 {
   "suburb": "WIRLINGA",
   "postcode": "2640"
 },
 {
   "suburb": "WYMAH",
   "postcode": "2640"
 },
 {
   "suburb": "HAMILTON VALLEY",
   "postcode": "2641"
 },
 {
   "suburb": "LAVINGTON",
   "postcode": "2641"
 },
 {
   "suburb": "SPRINGDALE HEIGHTS",
   "postcode": "2641"
 },
 {
   "suburb": "BIDGEEMIA",
   "postcode": "2642"
 },
 {
   "suburb": "BROCKLESBY",
   "postcode": "2642"
 },
 {
   "suburb": "BURRUMBUTTOCK",
   "postcode": "2642"
 },
 {
   "suburb": "GEROGERY",
   "postcode": "2642"
 },
 {
   "suburb": "GLENELLEN",
   "postcode": "2642"
 },
 {
   "suburb": "JINDERA",
   "postcode": "2642"
 },
 {
   "suburb": "RAND",
   "postcode": "2642"
 },
 {
   "suburb": "WALBUNDRIE",
   "postcode": "2642"
 },
 {
   "suburb": "WRATHALL",
   "postcode": "2642"
 },
 {
   "suburb": "YERONG CREEK",
   "postcode": "2642"
 },
 {
   "suburb": "HOWLONG",
   "postcode": "2643"
 },
 {
   "suburb": "BOWNA",
   "postcode": "2644"
 },
 {
   "suburb": "HOLBROOK",
   "postcode": "2644"
 },
 {
   "suburb": "LANKEYS CREEK",
   "postcode": "2644"
 },
 {
   "suburb": "LITTLE BILLABONG",
   "postcode": "2644"
 },
 {
   "suburb": "MOUNTAIN CREEK",
   "postcode": "2644"
 },
 {
   "suburb": "MULLENGANDRA",
   "postcode": "2644"
 },
 {
   "suburb": "WANTAGONG",
   "postcode": "2644"
 },
 {
   "suburb": "WOOMARGAMA",
   "postcode": "2644"
 },
 {
   "suburb": "CULLIVEL",
   "postcode": "2645"
 },
 {
   "suburb": "URANA",
   "postcode": "2645"
 },
 {
   "suburb": "BALLDALE",
   "postcode": "2646"
 },
 {
   "suburb": "COLLENDINA",
   "postcode": "2646"
 },
 {
   "suburb": "COROWA",
   "postcode": "2646"
 },
 {
   "suburb": "HOPEFIELD",
   "postcode": "2646"
 },
 {
   "suburb": "LOWESDALE",
   "postcode": "2646"
 },
 {
   "suburb": "REDLANDS",
   "postcode": "2646"
 },
 {
   "suburb": "RENNIE",
   "postcode": "2646"
 },
 {
   "suburb": "RINGWOOD",
   "postcode": "2646"
 },
 {
   "suburb": "SAVERNAKE",
   "postcode": "2646"
 },
 {
   "suburb": "MULWALA",
   "postcode": "2647"
 },
 {
   "suburb": "WENTWORTH",
   "postcode": "2648"
 },
 {
   "suburb": "ALFREDTOWN",
   "postcode": "2650"
 },
 {
   "suburb": "ASHMONT",
   "postcode": "2650"
 },
 {
   "suburb": "BOMEN",
   "postcode": "2650"
 },
 {
   "suburb": "BOOROOMA",
   "postcode": "2650"
 },
 {
   "suburb": "BORAMBOLA",
   "postcode": "2650"
 },
 {
   "suburb": "BOURKELANDS",
   "postcode": "2650"
 },
 {
   "suburb": "BRUCEDALE",
   "postcode": "2650"
 },
 {
   "suburb": "CARTWRIGHTS HILL",
   "postcode": "2650"
 },
 {
   "suburb": "COLLINGULLIE",
   "postcode": "2650"
 },
 {
   "suburb": "DOWNSIDE",
   "postcode": "2650"
 },
 {
   "suburb": "EAST WAGGA WAGGA",
   "postcode": "2650"
 },
 {
   "suburb": "ESTELLA",
   "postcode": "2650"
 },
 {
   "suburb": "EUBERTA",
   "postcode": "2650"
 },
 {
   "suburb": "EUNANOREENYA",
   "postcode": "2650"
 },
 {
   "suburb": "GELSTON PARK",
   "postcode": "2650"
 },
 {
   "suburb": "GLENFIELD PARK",
   "postcode": "2650"
 },
 {
   "suburb": "GOBBAGOMBALIN",
   "postcode": "2650"
 },
 {
   "suburb": "HILLGROVE",
   "postcode": "2650"
 },
 {
   "suburb": "KOORINGAL",
   "postcode": "2650"
 },
 {
   "suburb": "LAKE ALBERT",
   "postcode": "2650"
 },
 {
   "suburb": "LLOYD",
   "postcode": "2650"
 },
 {
   "suburb": "MOORONG",
   "postcode": "2650"
 },
 {
   "suburb": "MOUNT AUSTIN",
   "postcode": "2650"
 },
 {
   "suburb": "NORTH WAGGA WAGGA",
   "postcode": "2650"
 },
 {
   "suburb": "OURA",
   "postcode": "2650"
 },
 {
   "suburb": "ROWAN",
   "postcode": "2650"
 },
 {
   "suburb": "SAN ISIDORE",
   "postcode": "2650"
 },
 {
   "suburb": "SPRINGVALE",
   "postcode": "2650"
 },
 {
   "suburb": "TATTON",
   "postcode": "2650"
 },
 {
   "suburb": "TOLLAND",
   "postcode": "2650"
 },
 {
   "suburb": "TURVEY PARK",
   "postcode": "2650"
 },
 {
   "suburb": "WAGGA WAGGA",
   "postcode": "2650"
 },
 {
   "suburb": "YARRAGUNDRY",
   "postcode": "2650"
 },
 {
   "suburb": "FOREST HILL",
   "postcode": "2651"
 },
 {
   "suburb": "WAGGA WAGGA RAAF",
   "postcode": "2651"
 },
 {
   "suburb": "BOORGA",
   "postcode": "2652"
 },
 {
   "suburb": "BOREE CREEK",
   "postcode": "2652"
 },
 {
   "suburb": "COWABBIE",
   "postcode": "2652"
 },
 {
   "suburb": "GOOLGOWI",
   "postcode": "2652"
 },
 {
   "suburb": "GRONG GRONG",
   "postcode": "2652"
 },
 {
   "suburb": "GUMLY GUMLY",
   "postcode": "2652"
 },
 {
   "suburb": "HUMULA",
   "postcode": "2652"
 },
 {
   "suburb": "LADYSMITH",
   "postcode": "2652"
 },
 {
   "suburb": "LANDERVALE",
   "postcode": "2652"
 },
 {
   "suburb": "MANGOPLAH",
   "postcode": "2652"
 },
 {
   "suburb": "MARRAR",
   "postcode": "2652"
 },
 {
   "suburb": "MATONG",
   "postcode": "2652"
 },
 {
   "suburb": "MERRIWAGGA",
   "postcode": "2652"
 },
 {
   "suburb": "MURRULEBALE",
   "postcode": "2652"
 },
 {
   "suburb": "OLD JUNEE",
   "postcode": "2652"
 },
 {
   "suburb": "ROSEWOOD",
   "postcode": "2652"
 },
 {
   "suburb": "TABBITA",
   "postcode": "2652"
 },
 {
   "suburb": "TARCUTTA",
   "postcode": "2652"
 },
 {
   "suburb": "URANQUINTY",
   "postcode": "2652"
 },
 {
   "suburb": "BURRA",
   "postcode": "2653"
 },
 {
   "suburb": "COURABYRA",
   "postcode": "2653"
 },
 {
   "suburb": "GLENROY",
   "postcode": "2653"
 },
 {
   "suburb": "MANNUS",
   "postcode": "2653"
 },
 {
   "suburb": "TUMBARUMBA",
   "postcode": "2653"
 },
 {
   "suburb": "FRENCH PARK",
   "postcode": "2655"
 },
 {
   "suburb": "THE ROCK",
   "postcode": "2655"
 },
 {
   "suburb": "TOOTOOL",
   "postcode": "2655"
 },
 {
   "suburb": "BROOKONG",
   "postcode": "2656"
 },
 {
   "suburb": "LOCKHART",
   "postcode": "2656"
 },
 {
   "suburb": "MILBRULONG",
   "postcode": "2656"
 },
 {
   "suburb": "OSBORNE",
   "postcode": "2656"
 },
 {
   "suburb": "URANGELINE",
   "postcode": "2656"
 },
 {
   "suburb": "URANGELINE EAST",
   "postcode": "2656"
 },
 {
   "suburb": "GRUBBEN",
   "postcode": "2658"
 },
 {
   "suburb": "HENTY",
   "postcode": "2658"
 },
 {
   "suburb": "MUNYABLA",
   "postcode": "2658"
 },
 {
   "suburb": "PLEASANT HILLS",
   "postcode": "2658"
 },
 {
   "suburb": "RYAN",
   "postcode": "2658"
 },
 {
   "suburb": "ALMA PARK",
   "postcode": "2659"
 },
 {
   "suburb": "WALLA WALLA",
   "postcode": "2659"
 },
 {
   "suburb": "CULCAIRN",
   "postcode": "2660"
 },
 {
   "suburb": "MORVEN",
   "postcode": "2660"
 },
 {
   "suburb": "KAPOOKA",
   "postcode": "2661"
 },
 {
   "suburb": "ERIN VALE",
   "postcode": "2663"
 },
 {
   "suburb": "EURONGILLY",
   "postcode": "2663"
 },
 {
   "suburb": "JUNEE",
   "postcode": "2663"
 },
 {
   "suburb": "MARINNA",
   "postcode": "2663"
 },
 {
   "suburb": "WANTIOOL",
   "postcode": "2663"
 },
 {
   "suburb": "ARDLETHAN",
   "postcode": "2665"
 },
 {
   "suburb": "ARIAH PARK",
   "postcode": "2665"
 },
 {
   "suburb": "BARELLAN",
   "postcode": "2665"
 },
 {
   "suburb": "SEBASTOPOL",
   "postcode": "2666"
 },
 {
   "suburb": "TEMORA",
   "postcode": "2666"
 },
 {
   "suburb": "WEST WYALONG",
   "postcode": "2671"
 },
 {
   "suburb": "WYALONG",
   "postcode": "2671"
 },
 {
   "suburb": "BEELBANGERA",
   "postcode": "2680"
 },
 {
   "suburb": "BENEREMBAH",
   "postcode": "2680"
 },
 {
   "suburb": "BILBUL",
   "postcode": "2680"
 },
 {
   "suburb": "GRIFFITH",
   "postcode": "2680"
 },
 {
   "suburb": "GRIFFITH EAST",
   "postcode": "2680"
 },
 {
   "suburb": "HANWOOD",
   "postcode": "2680"
 },
 {
   "suburb": "KOOBA",
   "postcode": "2680"
 },
 {
   "suburb": "LAKE WYANGAN",
   "postcode": "2680"
 },
 {
   "suburb": "NERICON",
   "postcode": "2680"
 },
 {
   "suburb": "THARBOGANG",
   "postcode": "2680"
 },
 {
   "suburb": "WARBURN",
   "postcode": "2680"
 },
 {
   "suburb": "WARRAWIDGEE",
   "postcode": "2680"
 },
 {
   "suburb": "WIDGELLI",
   "postcode": "2680"
 },
 {
   "suburb": "WILLBRIGGIE",
   "postcode": "2680"
 },
 {
   "suburb": "YOOGALI",
   "postcode": "2680"
 },
 {
   "suburb": "YENDA",
   "postcode": "2681"
 },
 {
   "suburb": "BUNDURE",
   "postcode": "2700"
 },
 {
   "suburb": "COROBIMILLA",
   "postcode": "2700"
 },
 {
   "suburb": "GILLENBAH",
   "postcode": "2700"
 },
 {
   "suburb": "MORUNDAH",
   "postcode": "2700"
 },
 {
   "suburb": "NARRANDERA",
   "postcode": "2700"
 },
 {
   "suburb": "BROBENAH",
   "postcode": "2705"
 },
 {
   "suburb": "CORBIE HILL",
   "postcode": "2705"
 },
 {
   "suburb": "GOGELDRIE",
   "postcode": "2705"
 },
 {
   "suburb": "LEETON",
   "postcode": "2705"
 },
 {
   "suburb": "MERUNGLE HILL",
   "postcode": "2705"
 },
 {
   "suburb": "MURRAMI",
   "postcode": "2705"
 },
 {
   "suburb": "STANBRIDGE",
   "postcode": "2705"
 },
 {
   "suburb": "WHITTON",
   "postcode": "2705"
 },
 {
   "suburb": "DARLINGTON POINT",
   "postcode": "2706"
 },
 {
   "suburb": "COLEAMBALLY",
   "postcode": "2707"
 },
 {
   "suburb": "BIRGANBIGIL",
   "postcode": "2710"
 },
 {
   "suburb": "BULLATALE",
   "postcode": "2710"
 },
 {
   "suburb": "DENILIQUIN",
   "postcode": "2710"
 },
 {
   "suburb": "MATHOURA",
   "postcode": "2710"
 },
 {
   "suburb": "MAYRUNG",
   "postcode": "2710"
 },
 {
   "suburb": "WARRAGOON",
   "postcode": "2710"
 },
 {
   "suburb": "BERRIGAN",
   "postcode": "2712"
 },
 {
   "suburb": "BLIGHTY",
   "postcode": "2713"
 },
 {
   "suburb": "FINLEY",
   "postcode": "2713"
 },
 {
   "suburb": "TOCUMWAL",
   "postcode": "2714"
 },
 {
   "suburb": "TUPPAL",
   "postcode": "2714"
 },
 {
   "suburb": "JERILDERIE",
   "postcode": "2716"
 },
 {
   "suburb": "MAIRJIMMY",
   "postcode": "2716"
 },
 {
   "suburb": "COOMEALLA",
   "postcode": "2717"
 },
 {
   "suburb": "DARETON",
   "postcode": "2717"
 },
 {
   "suburb": "BOMBOWLEE",
   "postcode": "2720"
 },
 {
   "suburb": "BOMBOWLEE CREEK",
   "postcode": "2720"
 },
 {
   "suburb": "GADARA",
   "postcode": "2720"
 },
 {
   "suburb": "GILMORE",
   "postcode": "2720"
 },
 {
   "suburb": "GOCUP",
   "postcode": "2720"
 },
 {
   "suburb": "JONES BRIDGE",
   "postcode": "2720"
 },
 {
   "suburb": "LACMALAC",
   "postcode": "2720"
 },
 {
   "suburb": "LITTLE RIVER",
   "postcode": "2720"
 },
 {
   "suburb": "MUNDONGO",
   "postcode": "2720"
 },
 {
   "suburb": "TUMUT",
   "postcode": "2720"
 },
 {
   "suburb": "TUMUT PLAINS",
   "postcode": "2720"
 },
 {
   "suburb": "WERMATONG",
   "postcode": "2720"
 },
 {
   "suburb": "WINDOWIE",
   "postcode": "2720"
 },
 {
   "suburb": "BRUNGLE",
   "postcode": "2722"
 },
 {
   "suburb": "DARBALARA",
   "postcode": "2722"
 },
 {
   "suburb": "GUNDAGAI",
   "postcode": "2722"
 },
 {
   "suburb": "MUTTAMA",
   "postcode": "2722"
 },
 {
   "suburb": "NANGUS",
   "postcode": "2722"
 },
 {
   "suburb": "SOUTH GUNDAGAI",
   "postcode": "2722"
 },
 {
   "suburb": "COONEYS CREEK",
   "postcode": "2726"
 },
 {
   "suburb": "JUGIONG",
   "postcode": "2726"
 },
 {
   "suburb": "COOLAC",
   "postcode": "2727"
 },
 {
   "suburb": "ADELONG",
   "postcode": "2729"
 },
 {
   "suburb": "BANGADANG",
   "postcode": "2729"
 },
 {
   "suburb": "BLACK CREEK",
   "postcode": "2729"
 },
 {
   "suburb": "CALIFAT",
   "postcode": "2729"
 },
 {
   "suburb": "COOLEYS CREEK",
   "postcode": "2729"
 },
 {
   "suburb": "DARLOW",
   "postcode": "2729"
 },
 {
   "suburb": "ELLERSLIE",
   "postcode": "2729"
 },
 {
   "suburb": "GRAHAMSTOWN",
   "postcode": "2729"
 },
 {
   "suburb": "MOUNT ADRAH",
   "postcode": "2729"
 },
 {
   "suburb": "MOUNT HOREB",
   "postcode": "2729"
 },
 {
   "suburb": "MUNDARLO",
   "postcode": "2729"
 },
 {
   "suburb": "SANDY GULLY",
   "postcode": "2729"
 },
 {
   "suburb": "SHARPS CREEK",
   "postcode": "2729"
 },
 {
   "suburb": "TUMBLONG",
   "postcode": "2729"
 },
 {
   "suburb": "WESTWOOD",
   "postcode": "2729"
 },
 {
   "suburb": "WONDALGA",
   "postcode": "2729"
 },
 {
   "suburb": "YAVEN CREEK",
   "postcode": "2729"
 },
 {
   "suburb": "MOAMA",
   "postcode": "2731"
 },
 {
   "suburb": "WOMBOOTA",
   "postcode": "2731"
 },
 {
   "suburb": "BARHAM",
   "postcode": "2732"
 },
 {
   "suburb": "COBRAMUNGA",
   "postcode": "2732"
 },
 {
   "suburb": "GONN",
   "postcode": "2732"
 },
 {
   "suburb": "MURRAY DOWNS",
   "postcode": "2734"
 },
 {
   "suburb": "GOL GOL",
   "postcode": "2738"
 },
 {
   "suburb": "MALLEE",
   "postcode": "2738"
 },
 {
   "suburb": "MONAK",
   "postcode": "2738"
 },
 {
   "suburb": "PARINGI",
   "postcode": "2738"
 },
 {
   "suburb": "TRENTHAM CLIFFS",
   "postcode": "2738"
 },
 {
   "suburb": "BOEILL CREEK",
   "postcode": "2739"
 },
 {
   "suburb": "BURONGA",
   "postcode": "2739"
 },
 {
   "suburb": "MOURQUONG",
   "postcode": "2739"
 },
 {
   "suburb": "GLENMORE PARK",
   "postcode": "2745"
 },
 {
   "suburb": "GREENDALE",
   "postcode": "2745"
 },
 {
   "suburb": "LUDDENHAM",
   "postcode": "2745"
 },
 {
   "suburb": "MULGOA",
   "postcode": "2745"
 },
 {
   "suburb": "REGENTVILLE",
   "postcode": "2745"
 },
 {
   "suburb": "WALLACIA",
   "postcode": "2745"
 },
 {
   "suburb": "CADDENS",
   "postcode": "2747"
 },
 {
   "suburb": "CAMBRIDGE GARDENS",
   "postcode": "2747"
 },
 {
   "suburb": "CAMBRIDGE PARK",
   "postcode": "2747"
 },
 {
   "suburb": "CLAREMONT MEADOWS",
   "postcode": "2747"
 },
 {
   "suburb": "JORDAN SPRINGS",
   "postcode": "2747"
 },
 {
   "suburb": "KINGSWOOD",
   "postcode": "2747"
 },
 {
   "suburb": "LLANDILO",
   "postcode": "2747"
 },
 {
   "suburb": "SHANES PARK",
   "postcode": "2747"
 },
 {
   "suburb": "WERRINGTON",
   "postcode": "2747"
 },
 {
   "suburb": "WERRINGTON COUNTY",
   "postcode": "2747"
 },
 {
   "suburb": "WERRINGTON DOWNS",
   "postcode": "2747"
 },
 {
   "suburb": "ORCHARD HILLS",
   "postcode": "2748"
 },
 {
   "suburb": "CASTLEREAGH",
   "postcode": "2749"
 },
 {
   "suburb": "CRANEBROOK",
   "postcode": "2749"
 },
 {
   "suburb": "EMU HEIGHTS",
   "postcode": "2750"
 },
 {
   "suburb": "EMU PLAINS",
   "postcode": "2750"
 },
 {
   "suburb": "JAMISONTOWN",
   "postcode": "2750"
 },
 {
   "suburb": "LEONAY",
   "postcode": "2750"
 },
 {
   "suburb": "PENRITH",
   "postcode": "2750"
 },
 {
   "suburb": "PENRITH PLAZA",
   "postcode": "2750"
 },
 {
   "suburb": "PENRITH SOUTH",
   "postcode": "2750"
 },
 {
   "suburb": "SOUTH PENRITH",
   "postcode": "2750"
 },
 {
   "suburb": "PENRITH",
   "postcode": "2751"
 },
 {
   "suburb": "SILVERDALE",
   "postcode": "2752"
 },
 {
   "suburb": "WARRAGAMBA",
   "postcode": "2752"
 },
 {
   "suburb": "AGNES BANKS",
   "postcode": "2753"
 },
 {
   "suburb": "BOWEN MOUNTAIN",
   "postcode": "2753"
 },
 {
   "suburb": "GROSE VALE",
   "postcode": "2753"
 },
 {
   "suburb": "GROSE WOLD",
   "postcode": "2753"
 },
 {
   "suburb": "HOBARTVILLE",
   "postcode": "2753"
 },
 {
   "suburb": "LONDONDERRY",
   "postcode": "2753"
 },
 {
   "suburb": "RICHMOND",
   "postcode": "2753"
 },
 {
   "suburb": "RICHMOND LOWLANDS",
   "postcode": "2753"
 },
 {
   "suburb": "YARRAMUNDI",
   "postcode": "2753"
 },
 {
   "suburb": "NORTH RICHMOND",
   "postcode": "2754"
 },
 {
   "suburb": "TENNYSON",
   "postcode": "2754"
 },
 {
   "suburb": "THE SLOPES",
   "postcode": "2754"
 },
 {
   "suburb": "BLIGH PARK",
   "postcode": "2756"
 },
 {
   "suburb": "CATTAI",
   "postcode": "2756"
 },
 {
   "suburb": "CLARENDON",
   "postcode": "2756"
 },
 {
   "suburb": "CORNWALLIS",
   "postcode": "2756"
 },
 {
   "suburb": "CUMBERLAND REACH",
   "postcode": "2756"
 },
 {
   "suburb": "EBENEZER",
   "postcode": "2756"
 },
 {
   "suburb": "FREEMANS REACH",
   "postcode": "2756"
 },
 {
   "suburb": "GLOSSODIA",
   "postcode": "2756"
 },
 {
   "suburb": "LOWER PORTLAND",
   "postcode": "2756"
 },
 {
   "suburb": "MAROOTA",
   "postcode": "2756"
 },
 {
   "suburb": "MCGRATHS HILL",
   "postcode": "2756"
 },
 {
   "suburb": "MULGRAVE",
   "postcode": "2756"
 },
 {
   "suburb": "PITT TOWN",
   "postcode": "2756"
 },
 {
   "suburb": "PITT TOWN BOTTOMS",
   "postcode": "2756"
 },
 {
   "suburb": "SACKVILLE",
   "postcode": "2756"
 },
 {
   "suburb": "SACKVILLE NORTH",
   "postcode": "2756"
 },
 {
   "suburb": "SCHEYVILLE",
   "postcode": "2756"
 },
 {
   "suburb": "SOUTH MAROOTA",
   "postcode": "2756"
 },
 {
   "suburb": "SOUTH WINDSOR",
   "postcode": "2756"
 },
 {
   "suburb": "WILBERFORCE",
   "postcode": "2756"
 },
 {
   "suburb": "WINDSOR",
   "postcode": "2756"
 },
 {
   "suburb": "WINDSOR DOWNS",
   "postcode": "2756"
 },
 {
   "suburb": "KURMOND",
   "postcode": "2757"
 },
 {
   "suburb": "BERAMBING",
   "postcode": "2758"
 },
 {
   "suburb": "BILPIN",
   "postcode": "2758"
 },
 {
   "suburb": "BLAXLANDS RIDGE",
   "postcode": "2758"
 },
 {
   "suburb": "EAST KURRAJONG",
   "postcode": "2758"
 },
 {
   "suburb": "KURRAJONG",
   "postcode": "2758"
 },
 {
   "suburb": "KURRAJONG HEIGHTS",
   "postcode": "2758"
 },
 {
   "suburb": "KURRAJONG HILLS",
   "postcode": "2758"
 },
 {
   "suburb": "MOUNT TOMAH",
   "postcode": "2758"
 },
 {
   "suburb": "ERSKINE PARK",
   "postcode": "2759"
 },
 {
   "suburb": "ST CLAIR",
   "postcode": "2759"
 },
 {
   "suburb": "COLYTON",
   "postcode": "2760"
 },
 {
   "suburb": "NORTH ST MARYS",
   "postcode": "2760"
 },
 {
   "suburb": "OXLEY PARK",
   "postcode": "2760"
 },
 {
   "suburb": "ROPES CROSSING",
   "postcode": "2760"
 },
 {
   "suburb": "ST MARYS",
   "postcode": "2760"
 },
 {
   "suburb": "ST MARYS EAST",
   "postcode": "2760"
 },
 {
   "suburb": "ST MARYS SOUTH",
   "postcode": "2760"
 },
 {
   "suburb": "COLEBEE",
   "postcode": "2761"
 },
 {
   "suburb": "DEAN PARK",
   "postcode": "2761"
 },
 {
   "suburb": "GLENDENNING",
   "postcode": "2761"
 },
 {
   "suburb": "HASSALL GROVE",
   "postcode": "2761"
 },
 {
   "suburb": "OAKHURST",
   "postcode": "2761"
 },
 {
   "suburb": "PLUMPTON",
   "postcode": "2761"
 },
 {
   "suburb": "SCHOFIELDS",
   "postcode": "2762"
 },
 {
   "suburb": "TALLAWONG",
   "postcode": "2762"
 },
 {
   "suburb": "ACACIA GARDENS",
   "postcode": "2763"
 },
 {
   "suburb": "NIRIMBA FIELDS",
   "postcode": "2763"
 },
 {
   "suburb": "QUAKERS HILL",
   "postcode": "2763"
 },
 {
   "suburb": "BERKSHIRE PARK",
   "postcode": "2765"
 },
 {
   "suburb": "BOX HILL",
   "postcode": "2765"
 },
 {
   "suburb": "GABLES",
   "postcode": "2765"
 },
 {
   "suburb": "GRANTHAM FARM",
   "postcode": "2765"
 },
 {
   "suburb": "MARAYLYA",
   "postcode": "2765"
 },
 {
   "suburb": "MARSDEN PARK",
   "postcode": "2765"
 },
 {
   "suburb": "MELONBA",
   "postcode": "2765"
 },
 {
   "suburb": "NELSON",
   "postcode": "2765"
 },
 {
   "suburb": "OAKVILLE",
   "postcode": "2765"
 },
 {
   "suburb": "RIVERSTONE",
   "postcode": "2765"
 },
 {
   "suburb": "VINEYARD",
   "postcode": "2765"
 },
 {
   "suburb": "EASTERN CREEK",
   "postcode": "2766"
 },
 {
   "suburb": "ROOTY HILL",
   "postcode": "2766"
 },
 {
   "suburb": "BUNGARRIBEE",
   "postcode": "2767"
 },
 {
   "suburb": "DOONSIDE",
   "postcode": "2767"
 },
 {
   "suburb": "WOODCROFT",
   "postcode": "2767"
 },
 {
   "suburb": "GLENWOOD",
   "postcode": "2768"
 },
 {
   "suburb": "PARKLEA",
   "postcode": "2768"
 },
 {
   "suburb": "STANHOPE GARDENS",
   "postcode": "2768"
 },
 {
   "suburb": "THE PONDS",
   "postcode": "2769"
 },
 {
   "suburb": "BIDWILL",
   "postcode": "2770"
 },
 {
   "suburb": "BLACKETT",
   "postcode": "2770"
 },
 {
   "suburb": "DHARRUK",
   "postcode": "2770"
 },
 {
   "suburb": "EMERTON",
   "postcode": "2770"
 },
 {
   "suburb": "HEBERSHAM",
   "postcode": "2770"
 },
 {
   "suburb": "LETHBRIDGE PARK",
   "postcode": "2770"
 },
 {
   "suburb": "MINCHINBURY",
   "postcode": "2770"
 },
 {
   "suburb": "MOUNT DRUITT",
   "postcode": "2770"
 },
 {
   "suburb": "MOUNT DRUITT VILLAGE",
   "postcode": "2770"
 },
 {
   "suburb": "SHALVEY",
   "postcode": "2770"
 },
 {
   "suburb": "TREGEAR",
   "postcode": "2770"
 },
 {
   "suburb": "WHALAN",
   "postcode": "2770"
 },
 {
   "suburb": "WILLMOT",
   "postcode": "2770"
 },
 {
   "suburb": "GLENBROOK",
   "postcode": "2773"
 },
 {
   "suburb": "LAPSTONE",
   "postcode": "2773"
 },
 {
   "suburb": "BLAXLAND",
   "postcode": "2774"
 },
 {
   "suburb": "BLAXLAND EAST",
   "postcode": "2774"
 },
 {
   "suburb": "MOUNT RIVERVIEW",
   "postcode": "2774"
 },
 {
   "suburb": "WARRIMOO",
   "postcode": "2774"
 },
 {
   "suburb": "LAUGHTONDALE",
   "postcode": "2775"
 },
 {
   "suburb": "FAULCONBRIDGE",
   "postcode": "2776"
 },
 {
   "suburb": "HAWKESBURY HEIGHTS",
   "postcode": "2777"
 },
 {
   "suburb": "SPRINGWOOD",
   "postcode": "2777"
 },
 {
   "suburb": "SUN VALLEY",
   "postcode": "2777"
 },
 {
   "suburb": "VALLEY HEIGHTS",
   "postcode": "2777"
 },
 {
   "suburb": "WINMALEE",
   "postcode": "2777"
 },
 {
   "suburb": "YELLOW ROCK",
   "postcode": "2777"
 },
 {
   "suburb": "LINDEN",
   "postcode": "2778"
 },
 {
   "suburb": "WOODFORD",
   "postcode": "2778"
 },
 {
   "suburb": "HAZELBROOK",
   "postcode": "2779"
 },
 {
   "suburb": "KATOOMBA",
   "postcode": "2780"
 },
 {
   "suburb": "LEURA",
   "postcode": "2780"
 },
 {
   "suburb": "MEDLOW BATH",
   "postcode": "2780"
 },
 {
   "suburb": "WENTWORTH FALLS",
   "postcode": "2782"
 },
 {
   "suburb": "LAWSON",
   "postcode": "2783"
 },
 {
   "suburb": "BULLABURRA",
   "postcode": "2784"
 },
 {
   "suburb": "BLACKHEATH",
   "postcode": "2785"
 },
 {
   "suburb": "MEGALONG VALLEY",
   "postcode": "2785"
 },
 {
   "suburb": "BELL",
   "postcode": "2786"
 },
 {
   "suburb": "DARGAN",
   "postcode": "2786"
 },
 {
   "suburb": "MOUNT IRVINE",
   "postcode": "2786"
 },
 {
   "suburb": "MOUNT VICTORIA",
   "postcode": "2786"
 },
 {
   "suburb": "MOUNT WILSON",
   "postcode": "2786"
 },
 {
   "suburb": "OBERON",
   "postcode": "2787"
 },
 {
   "suburb": "TARANA",
   "postcode": "2787"
 },
 {
   "suburb": "BEN BULLEN",
   "postcode": "2790"
 },
 {
   "suburb": "BLACKMANS FLAT",
   "postcode": "2790"
 },
 {
   "suburb": "BOWENFELS",
   "postcode": "2790"
 },
 {
   "suburb": "CLARENCE",
   "postcode": "2790"
 },
 {
   "suburb": "COBAR PARK",
   "postcode": "2790"
 },
 {
   "suburb": "CORNEY TOWN",
   "postcode": "2790"
 },
 {
   "suburb": "CULLEN BULLEN",
   "postcode": "2790"
 },
 {
   "suburb": "DOCTORS GAP",
   "postcode": "2790"
 },
 {
   "suburb": "GANBENANG",
   "postcode": "2790"
 },
 {
   "suburb": "GOOD FOREST",
   "postcode": "2790"
 },
 {
   "suburb": "HAMPTON",
   "postcode": "2790"
 },
 {
   "suburb": "HARTLEY",
   "postcode": "2790"
 },
 {
   "suburb": "HARTLEY VALE",
   "postcode": "2790"
 },
 {
   "suburb": "HASSANS WALLS",
   "postcode": "2790"
 },
 {
   "suburb": "HERMITAGE FLAT",
   "postcode": "2790"
 },
 {
   "suburb": "JENOLAN",
   "postcode": "2790"
 },
 {
   "suburb": "KANIMBLA",
   "postcode": "2790"
 },
 {
   "suburb": "LIDSDALE",
   "postcode": "2790"
 },
 {
   "suburb": "LITHGOW",
   "postcode": "2790"
 },
 {
   "suburb": "LITTLE HARTLEY",
   "postcode": "2790"
 },
 {
   "suburb": "LITTLETON",
   "postcode": "2790"
 },
 {
   "suburb": "LOWTHER",
   "postcode": "2790"
 },
 {
   "suburb": "MARRANGAROO",
   "postcode": "2790"
 },
 {
   "suburb": "MCKELLARS PARK",
   "postcode": "2790"
 },
 {
   "suburb": "MORTS ESTATE",
   "postcode": "2790"
 },
 {
   "suburb": "MOUNT LAMBIE",
   "postcode": "2790"
 },
 {
   "suburb": "NEWNES",
   "postcode": "2790"
 },
 {
   "suburb": "NEWNES PLATEAU",
   "postcode": "2790"
 },
 {
   "suburb": "OAKY PARK",
   "postcode": "2790"
 },
 {
   "suburb": "POTTERY ESTATE",
   "postcode": "2790"
 },
 {
   "suburb": "RYDAL",
   "postcode": "2790"
 },
 {
   "suburb": "SHEEDYS GULLY",
   "postcode": "2790"
 },
 {
   "suburb": "SODWALLS",
   "postcode": "2790"
 },
 {
   "suburb": "SOUTH BOWENFELS",
   "postcode": "2790"
 },
 {
   "suburb": "SOUTH LITTLETON",
   "postcode": "2790"
 },
 {
   "suburb": "SPRINGVALE",
   "postcode": "2790"
 },
 {
   "suburb": "STATE MINE GULLY",
   "postcode": "2790"
 },
 {
   "suburb": "VALE OF CLWYDD",
   "postcode": "2790"
 },
 {
   "suburb": "WOLGAN VALLEY",
   "postcode": "2790"
 },
 {
   "suburb": "WOLLANGAMBE",
   "postcode": "2790"
 },
 {
   "suburb": "CARCOAR",
   "postcode": "2791"
 },
 {
   "suburb": "WOODSTOCK",
   "postcode": "2793"
 },
 {
   "suburb": "COWRA",
   "postcode": "2794"
 },
 {
   "suburb": "ABERCROMBIE",
   "postcode": "2795"
 },
 {
   "suburb": "ABERCROMBIE RIVER",
   "postcode": "2795"
 },
 {
   "suburb": "BATHAMPTON",
   "postcode": "2795"
 },
 {
   "suburb": "BATHURST",
   "postcode": "2795"
 },
 {
   "suburb": "BATHURST WEST",
   "postcode": "2795"
 },
 {
   "suburb": "BILLYWILLINGA",
   "postcode": "2795"
 },
 {
   "suburb": "BREWONGLE",
   "postcode": "2795"
 },
 {
   "suburb": "CHARLES STURT UNIVERSITY",
   "postcode": "2795"
 },
 {
   "suburb": "CLEAR CREEK",
   "postcode": "2795"
 },
 {
   "suburb": "COW FLAT",
   "postcode": "2795"
 },
 {
   "suburb": "DARK CORNER",
   "postcode": "2795"
 },
 {
   "suburb": "DUNKELD",
   "postcode": "2795"
 },
 {
   "suburb": "DURAMANA",
   "postcode": "2795"
 },
 {
   "suburb": "EGLINTON",
   "postcode": "2795"
 },
 {
   "suburb": "EVANS PLAINS",
   "postcode": "2795"
 },
 {
   "suburb": "FOREST GROVE",
   "postcode": "2795"
 },
 {
   "suburb": "GEMALLA",
   "postcode": "2795"
 },
 {
   "suburb": "GEORGES PLAINS",
   "postcode": "2795"
 },
 {
   "suburb": "GLANMIRE",
   "postcode": "2795"
 },
 {
   "suburb": "GORMANS HILL",
   "postcode": "2795"
 },
 {
   "suburb": "KELSO",
   "postcode": "2795"
 },
 {
   "suburb": "KIRKCONNELL",
   "postcode": "2795"
 },
 {
   "suburb": "LAFFING WATERS",
   "postcode": "2795"
 },
 {
   "suburb": "LLANARTH",
   "postcode": "2795"
 },
 {
   "suburb": "MEADOW FLAT",
   "postcode": "2795"
 },
 {
   "suburb": "MITCHELL",
   "postcode": "2795"
 },
 {
   "suburb": "MOUNT PANORAMA",
   "postcode": "2795"
 },
 {
   "suburb": "MOUNT RANKIN",
   "postcode": "2795"
 },
 {
   "suburb": "NAPOLEON REEF",
   "postcode": "2795"
 },
 {
   "suburb": "NEWBRIDGE",
   "postcode": "2795"
 },
 {
   "suburb": "O'CONNELL",
   "postcode": "2795"
 },
 {
   "suburb": "ORTON PARK",
   "postcode": "2795"
 },
 {
   "suburb": "PEEL",
   "postcode": "2795"
 },
 {
   "suburb": "PERTHVILLE",
   "postcode": "2795"
 },
 {
   "suburb": "RAGLAN",
   "postcode": "2795"
 },
 {
   "suburb": "ROBIN HILL",
   "postcode": "2795"
 },
 {
   "suburb": "ROCK FOREST",
   "postcode": "2795"
 },
 {
   "suburb": "ROCKLEY",
   "postcode": "2795"
 },
 {
   "suburb": "ROCKLEY MOUNT",
   "postcode": "2795"
 },
 {
   "suburb": "SOUTH BATHURST",
   "postcode": "2795"
 },
 {
   "suburb": "STEWARTS MOUNT",
   "postcode": "2795"
 },
 {
   "suburb": "SUNNY CORNER",
   "postcode": "2795"
 },
 {
   "suburb": "THE LAGOON",
   "postcode": "2795"
 },
 {
   "suburb": "THE ROCKS",
   "postcode": "2795"
 },
 {
   "suburb": "TRIANGLE FLAT",
   "postcode": "2795"
 },
 {
   "suburb": "WALANG",
   "postcode": "2795"
 },
 {
   "suburb": "WAMBOOL",
   "postcode": "2795"
 },
 {
   "suburb": "WATTON",
   "postcode": "2795"
 },
 {
   "suburb": "WEST BATHURST",
   "postcode": "2795"
 },
 {
   "suburb": "WHITE ROCK",
   "postcode": "2795"
 },
 {
   "suburb": "WIMBLEDON",
   "postcode": "2795"
 },
 {
   "suburb": "WINDRADYNE",
   "postcode": "2795"
 },
 {
   "suburb": "YARRAS",
   "postcode": "2795"
 },
 {
   "suburb": "YETHOLME",
   "postcode": "2795"
 },
 {
   "suburb": "LYNDHURST",
   "postcode": "2797"
 },
 {
   "suburb": "FOREST REEFS",
   "postcode": "2798"
 },
 {
   "suburb": "GUYONG",
   "postcode": "2798"
 },
 {
   "suburb": "MILLTHORPE",
   "postcode": "2798"
 },
 {
   "suburb": "SPRING TERRACE",
   "postcode": "2798"
 },
 {
   "suburb": "TALLWOOD",
   "postcode": "2798"
 },
 {
   "suburb": "BLAYNEY",
   "postcode": "2799"
 },
 {
   "suburb": "FITZGERALDS MOUNT",
   "postcode": "2799"
 },
 {
   "suburb": "KINGS PLAINS",
   "postcode": "2799"
 },
 {
   "suburb": "VITTORIA",
   "postcode": "2799"
 },
 {
   "suburb": "BORENORE",
   "postcode": "2800"
 },
 {
   "suburb": "CANOBOLAS",
   "postcode": "2800"
 },
 {
   "suburb": "CARGO",
   "postcode": "2800"
 },
 {
   "suburb": "CLERGATE",
   "postcode": "2800"
 },
 {
   "suburb": "CLIFTON GROVE",
   "postcode": "2800"
 },
 {
   "suburb": "EMU SWAMP",
   "postcode": "2800"
 },
 {
   "suburb": "HUNTLEY",
   "postcode": "2800"
 },
 {
   "suburb": "KANGAROOBIE",
   "postcode": "2800"
 },
 {
   "suburb": "KERRS CREEK",
   "postcode": "2800"
 },
 {
   "suburb": "LIDSTER",
   "postcode": "2800"
 },
 {
   "suburb": "LUCKNOW",
   "postcode": "2800"
 },
 {
   "suburb": "MARCH",
   "postcode": "2800"
 },
 {
   "suburb": "MULLION CREEK",
   "postcode": "2800"
 },
 {
   "suburb": "NASHDALE",
   "postcode": "2800"
 },
 {
   "suburb": "ORANGE",
   "postcode": "2800"
 },
 {
   "suburb": "ORANGE EAST",
   "postcode": "2800"
 },
 {
   "suburb": "SHADFORTH",
   "postcode": "2800"
 },
 {
   "suburb": "SPRING CREEK",
   "postcode": "2800"
 },
 {
   "suburb": "SPRING HILL",
   "postcode": "2800"
 },
 {
   "suburb": "SPRINGSIDE",
   "postcode": "2800"
 },
 {
   "suburb": "SUMMER HILL CREEK",
   "postcode": "2800"
 },
 {
   "suburb": "WINDERA",
   "postcode": "2800"
 },
 {
   "suburb": "EUGOWRA",
   "postcode": "2806"
 },
 {
   "suburb": "APSLEY",
   "postcode": "2820"
 },
 {
   "suburb": "ARTHURVILLE",
   "postcode": "2820"
 },
 {
   "suburb": "BAKERS SWAMP",
   "postcode": "2820"
 },
 {
   "suburb": "BODANGORA",
   "postcode": "2820"
 },
 {
   "suburb": "COMOBELLA",
   "postcode": "2820"
 },
 {
   "suburb": "CURRA CREEK",
   "postcode": "2820"
 },
 {
   "suburb": "DRIPSTONE",
   "postcode": "2820"
 },
 {
   "suburb": "FARNHAM",
   "postcode": "2820"
 },
 {
   "suburb": "GOLLAN",
   "postcode": "2820"
 },
 {
   "suburb": "LAKE BURRENDONG",
   "postcode": "2820"
 },
 {
   "suburb": "MARYVALE",
   "postcode": "2820"
 },
 {
   "suburb": "MEDWAY",
   "postcode": "2820"
 },
 {
   "suburb": "MONTEFIORES",
   "postcode": "2820"
 },
 {
   "suburb": "MOOKERAWA",
   "postcode": "2820"
 },
 {
   "suburb": "MOUNT AQUILA",
   "postcode": "2820"
 },
 {
   "suburb": "MOUNT ARTHUR",
   "postcode": "2820"
 },
 {
   "suburb": "MUMBIL",
   "postcode": "2820"
 },
 {
   "suburb": "NEUREA",
   "postcode": "2820"
 },
 {
   "suburb": "SPICERS CREEK",
   "postcode": "2820"
 },
 {
   "suburb": "STUART TOWN",
   "postcode": "2820"
 },
 {
   "suburb": "SUNTOP",
   "postcode": "2820"
 },
 {
   "suburb": "WALMER",
   "postcode": "2820"
 },
 {
   "suburb": "WELLINGTON",
   "postcode": "2820"
 },
 {
   "suburb": "WUULUMAN",
   "postcode": "2820"
 },
 {
   "suburb": "YARRAGAL",
   "postcode": "2820"
 },
 {
   "suburb": "BALLIMORE",
   "postcode": "2830"
 },
 {
   "suburb": "BROCKLEHURST",
   "postcode": "2830"
 },
 {
   "suburb": "DUBBO",
   "postcode": "2830"
 },
 {
   "suburb": "DUBBO EAST",
   "postcode": "2830"
 },
 {
   "suburb": "DUBBO GROVE",
   "postcode": "2830"
 },
 {
   "suburb": "DUBBO WEST",
   "postcode": "2830"
 },
 {
   "suburb": "GOONOO FOREST",
   "postcode": "2830"
 },
 {
   "suburb": "KICKABIL",
   "postcode": "2830"
 },
 {
   "suburb": "MINORE",
   "postcode": "2830"
 },
 {
   "suburb": "MOGRIGUY",
   "postcode": "2830"
 },
 {
   "suburb": "RAWSONVILLE",
   "postcode": "2830"
 },
 {
   "suburb": "TERRAMUNGAMINE",
   "postcode": "2830"
 },
 {
   "suburb": "TOONGI",
   "postcode": "2830"
 },
 {
   "suburb": "WAMBANGALANG",
   "postcode": "2830"
 },
 {
   "suburb": "WONGARBON",
   "postcode": "2831"
 },
 {
   "suburb": "WALLERAWANG",
   "postcode": "2845"
 },
 {
   "suburb": "CAPERTEE",
   "postcode": "2846"
 },
 {
   "suburb": "GLEN DAVIS",
   "postcode": "2846"
 },
 {
   "suburb": "ROUND SWAMP",
   "postcode": "2846"
 },
 {
   "suburb": "PORTLAND",
   "postcode": "2847"
 },
 {
   "suburb": "BROGANS CREEK",
   "postcode": "2848"
 },
 {
   "suburb": "CHARBON",
   "postcode": "2848"
 },
 {
   "suburb": "CLANDULLA",
   "postcode": "2848"
 },
 {
   "suburb": "KANDOS",
   "postcode": "2848"
 },
 {
   "suburb": "BREAKFAST CREEK",
   "postcode": "2849"
 },
 {
   "suburb": "DABEE",
   "postcode": "2849"
 },
 {
   "suburb": "DUNGEREE",
   "postcode": "2849"
 },
 {
   "suburb": "MOUNT MARSDEN",
   "postcode": "2849"
 },
 {
   "suburb": "RYLSTONE",
   "postcode": "2849"
 },
 {
   "suburb": "AARONS PASS",
   "postcode": "2850"
 },
 {
   "suburb": "APPLE TREE FLAT",
   "postcode": "2850"
 },
 {
   "suburb": "AVISFORD",
   "postcode": "2850"
 },
 {
   "suburb": "BARA",
   "postcode": "2850"
 },
 {
   "suburb": "BOCOBLE",
   "postcode": "2850"
 },
 {
   "suburb": "BOMBIRA",
   "postcode": "2850"
 },
 {
   "suburb": "BUCKAROO",
   "postcode": "2850"
 },
 {
   "suburb": "BUDGEE BUDGEE",
   "postcode": "2850"
 },
 {
   "suburb": "BURRUNDULLA",
   "postcode": "2850"
 },
 {
   "suburb": "CAERLEON",
   "postcode": "2850"
 },
 {
   "suburb": "CANADIAN LEAD",
   "postcode": "2850"
 },
 {
   "suburb": "CARCALGONG",
   "postcode": "2850"
 },
 {
   "suburb": "COLLINGWOOD",
   "postcode": "2850"
 },
 {
   "suburb": "COOKS GAP",
   "postcode": "2850"
 },
 {
   "suburb": "COOYAL",
   "postcode": "2850"
 },
 {
   "suburb": "CROSS ROADS",
   "postcode": "2850"
 },
 {
   "suburb": "CUDGEGONG",
   "postcode": "2850"
 },
 {
   "suburb": "CULLENBONE",
   "postcode": "2850"
 },
 {
   "suburb": "CUMBO",
   "postcode": "2850"
 },
 {
   "suburb": "ERUDGERE",
   "postcode": "2850"
 },
 {
   "suburb": "EURUNDEREE",
   "postcode": "2850"
 },
 {
   "suburb": "FROG ROCK",
   "postcode": "2850"
 },
 {
   "suburb": "GALAMBINE",
   "postcode": "2850"
 },
 {
   "suburb": "GRATTAI",
   "postcode": "2850"
 },
 {
   "suburb": "GREEN GULLY",
   "postcode": "2850"
 },
 {
   "suburb": "HARGRAVES",
   "postcode": "2850"
 },
 {
   "suburb": "HAVILAH",
   "postcode": "2850"
 },
 {
   "suburb": "HAYES GAP",
   "postcode": "2850"
 },
 {
   "suburb": "HOME RULE",
   "postcode": "2850"
 },
 {
   "suburb": "ILFORD",
   "postcode": "2850"
 },
 {
   "suburb": "LINBURN",
   "postcode": "2850"
 },
 {
   "suburb": "LUE",
   "postcode": "2850"
 },
 {
   "suburb": "MAITLAND BAR",
   "postcode": "2850"
 },
 {
   "suburb": "MENAH",
   "postcode": "2850"
 },
 {
   "suburb": "MEROO",
   "postcode": "2850"
 },
 {
   "suburb": "MILROY",
   "postcode": "2850"
 },
 {
   "suburb": "MOGO",
   "postcode": "2850"
 },
 {
   "suburb": "MONIVAE",
   "postcode": "2850"
 },
 {
   "suburb": "MOUNT FROME",
   "postcode": "2850"
 },
 {
   "suburb": "MOUNT KNOWLES",
   "postcode": "2850"
 },
 {
   "suburb": "MUDGEE",
   "postcode": "2850"
 },
 {
   "suburb": "MULLAMUDDY",
   "postcode": "2850"
 },
 {
   "suburb": "MUNGHORN",
   "postcode": "2850"
 },
 {
   "suburb": "PIAMBONG",
   "postcode": "2850"
 },
 {
   "suburb": "PUTTA BUCCA",
   "postcode": "2850"
 },
 {
   "suburb": "PYRAMUL",
   "postcode": "2850"
 },
 {
   "suburb": "QUEENS PINCH",
   "postcode": "2850"
 },
 {
   "suburb": "RIVERLEA",
   "postcode": "2850"
 },
 {
   "suburb": "RUNNING STREAM",
   "postcode": "2850"
 },
 {
   "suburb": "SALLYS FLAT",
   "postcode": "2850"
 },
 {
   "suburb": "SPRING FLAT",
   "postcode": "2850"
 },
 {
   "suburb": "ST FILLANS",
   "postcode": "2850"
 },
 {
   "suburb": "STONY CREEK",
   "postcode": "2850"
 },
 {
   "suburb": "TRIAMBLE",
   "postcode": "2850"
 },
 {
   "suburb": "TWELVE MILE",
   "postcode": "2850"
 },
 {
   "suburb": "WILBETREE",
   "postcode": "2850"
 },
 {
   "suburb": "WILPINJONG",
   "postcode": "2850"
 },
 {
   "suburb": "WINDEYER",
   "postcode": "2850"
 },
 {
   "suburb": "WORLDS END",
   "postcode": "2850"
 },
 {
   "suburb": "YARRAWONGA",
   "postcode": "2850"
 },
 {
   "suburb": "BARNEYS REEF",
   "postcode": "2852"
 },
 {
   "suburb": "BERYL",
   "postcode": "2852"
 },
 {
   "suburb": "BUNGABA",
   "postcode": "2852"
 },
 {
   "suburb": "COPE",
   "postcode": "2852"
 },
 {
   "suburb": "CUMBANDRY",
   "postcode": "2852"
 },
 {
   "suburb": "GOOLMA",
   "postcode": "2852"
 },
 {
   "suburb": "GULGONG",
   "postcode": "2852"
 },
 {
   "suburb": "GUNTAWANG",
   "postcode": "2852"
 },
 {
   "suburb": "MEBUL",
   "postcode": "2852"
 },
 {
   "suburb": "MEROTHERIE",
   "postcode": "2852"
 },
 {
   "suburb": "STUBBO",
   "postcode": "2852"
 },
 {
   "suburb": "TALLAWANG",
   "postcode": "2852"
 },
 {
   "suburb": "TWO MILE FLAT",
   "postcode": "2852"
 },
 {
   "suburb": "BOCOBRA",
   "postcode": "2865"
 },
 {
   "suburb": "GUMBLE",
   "postcode": "2865"
 },
 {
   "suburb": "MANILDRA",
   "postcode": "2865"
 },
 {
   "suburb": "AMAROO",
   "postcode": "2866"
 },
 {
   "suburb": "BOOMEY",
   "postcode": "2866"
 },
 {
   "suburb": "CUNDUMBUL",
   "postcode": "2866"
 },
 {
   "suburb": "EUCHAREENA",
   "postcode": "2866"
 },
 {
   "suburb": "GARRA",
   "postcode": "2866"
 },
 {
   "suburb": "LARRAS LEE",
   "postcode": "2866"
 },
 {
   "suburb": "MOLONG",
   "postcode": "2866"
 },
 {
   "suburb": "PEAK HILL",
   "postcode": "2869"
 },
 {
   "suburb": "TOMINGLEY",
   "postcode": "2869"
 },
 {
   "suburb": "TREWILGA",
   "postcode": "2869"
 },
 {
   "suburb": "ALECTOWN",
   "postcode": "2870"
 },
 {
   "suburb": "BUMBERRY",
   "postcode": "2870"
 },
 {
   "suburb": "COOKAMIDGERA",
   "postcode": "2870"
 },
 {
   "suburb": "COOKS MYALLS",
   "postcode": "2870"
 },
 {
   "suburb": "DAROOBALGIE",
   "postcode": "2870"
 },
 {
   "suburb": "GOONUMBLA",
   "postcode": "2870"
 },
 {
   "suburb": "MANDAGERY",
   "postcode": "2870"
 },
 {
   "suburb": "PARKES",
   "postcode": "2870"
 },
 {
   "suburb": "TICHBORNE",
   "postcode": "2870"
 },
 {
   "suburb": "BEDGERABONG",
   "postcode": "2871"
 },
 {
   "suburb": "CORINELLA",
   "postcode": "2871"
 },
 {
   "suburb": "FORBES",
   "postcode": "2871"
 },
 {
   "suburb": "GAREMA",
   "postcode": "2871"
 },
 {
   "suburb": "GUNNING GAP",
   "postcode": "2871"
 },
 {
   "suburb": "JEMALONG",
   "postcode": "2871"
 },
 {
   "suburb": "MULYANDRY",
   "postcode": "2871"
 },
 {
   "suburb": "OOMA",
   "postcode": "2871"
 },
 {
   "suburb": "PAYTENS BRIDGE",
   "postcode": "2871"
 },
 {
   "suburb": "WIRRINYA",
   "postcode": "2871"
 },
 {
   "suburb": "GREENWAY",
   "postcode": "2900"
 },
 {
   "suburb": "TUGGERANONG",
   "postcode": "2900"
 },
 {
   "suburb": "KAMBAH",
   "postcode": "2902"
 },
 {
   "suburb": "KAMBAH VILLAGE",
   "postcode": "2902"
 },
 {
   "suburb": "ERINDALE CENTRE",
   "postcode": "2903"
 },
 {
   "suburb": "OXLEY",
   "postcode": "2903"
 },
 {
   "suburb": "WANNIASSA",
   "postcode": "2903"
 },
 {
   "suburb": "FADDEN",
   "postcode": "2904"
 },
 {
   "suburb": "GOWRIE",
   "postcode": "2904"
 },
 {
   "suburb": "MACARTHUR",
   "postcode": "2904"
 },
 {
   "suburb": "MONASH",
   "postcode": "2904"
 },
 {
   "suburb": "BONYTHON",
   "postcode": "2905"
 },
 {
   "suburb": "CALWELL",
   "postcode": "2905"
 },
 {
   "suburb": "CHISHOLM",
   "postcode": "2905"
 },
 {
   "suburb": "GILMORE",
   "postcode": "2905"
 },
 {
   "suburb": "ISABELLA PLAINS",
   "postcode": "2905"
 },
 {
   "suburb": "RICHARDSON",
   "postcode": "2905"
 },
 {
   "suburb": "THEODORE",
   "postcode": "2905"
 },
 {
   "suburb": "BANKS",
   "postcode": "2906"
 },
 {
   "suburb": "CONDER",
   "postcode": "2906"
 },
 {
   "suburb": "GORDON",
   "postcode": "2906"
 },
 {
   "suburb": "CRACE",
   "postcode": "2911"
 },
 {
   "suburb": "MITCHELL",
   "postcode": "2911"
 },
 {
   "suburb": "GUNGAHLIN",
   "postcode": "2912"
 },
 {
   "suburb": "JACKA",
   "postcode": "2912"
 },
 {
   "suburb": "CASEY",
   "postcode": "2913"
 },
 {
   "suburb": "FRANKLIN",
   "postcode": "2913"
 },
 {
   "suburb": "GINNINDERRA VILLAGE",
   "postcode": "2913"
 },
 {
   "suburb": "KINLYSIDE",
   "postcode": "2913"
 },
 {
   "suburb": "NGUNNAWAL",
   "postcode": "2913"
 },
 {
   "suburb": "NICHOLLS",
   "postcode": "2913"
 },
 {
   "suburb": "PALMERSTON",
   "postcode": "2913"
 },
 {
   "suburb": "TAYLOR",
   "postcode": "2913"
 },
 {
   "suburb": "AMAROO",
   "postcode": "2914"
 },
 {
   "suburb": "BONNER",
   "postcode": "2914"
 },
 {
   "suburb": "FORDE",
   "postcode": "2914"
 },
 {
   "suburb": "HARRISON",
   "postcode": "2914"
 },
 {
   "suburb": "JACKA",
   "postcode": "2914"
 },
 {
   "suburb": "MONCRIEFF",
   "postcode": "2914"
 },
 {
   "suburb": "THROSBY",
   "postcode": "2914"
 },
 {
   "suburb": "MELBOURNE",
   "postcode": "3000"
 },
 {
   "suburb": "MELBOURNE",
   "postcode": "3001"
 },
 {
   "suburb": "EAST MELBOURNE",
   "postcode": "3002"
 },
 {
   "suburb": "WEST MELBOURNE",
   "postcode": "3003"
 },
 {
   "suburb": "MELBOURNE",
   "postcode": "3004"
 },
 {
   "suburb": "ST KILDA ROAD CENTRAL",
   "postcode": "3004"
 },
 {
   "suburb": "ST KILDA ROAD MELBOURNE",
   "postcode": "3004"
 },
 {
   "suburb": "WORLD TRADE CENTRE",
   "postcode": "3005"
 },
 {
   "suburb": "SOUTH WHARF",
   "postcode": "3006"
 },
 {
   "suburb": "SOUTHBANK",
   "postcode": "3006"
 },
 {
   "suburb": "DOCKLANDS",
   "postcode": "3008"
 },
 {
   "suburb": "UNIVERSITY OF MELBOURNE",
   "postcode": "3010"
 },
 {
   "suburb": "FOOTSCRAY",
   "postcode": "3011"
 },
 {
   "suburb": "SEDDON",
   "postcode": "3011"
 },
 {
   "suburb": "SEDDON WEST",
   "postcode": "3011"
 },
 {
   "suburb": "BROOKLYN",
   "postcode": "3012"
 },
 {
   "suburb": "KINGSVILLE",
   "postcode": "3012"
 },
 {
   "suburb": "MAIDSTONE",
   "postcode": "3012"
 },
 {
   "suburb": "TOTTENHAM",
   "postcode": "3012"
 },
 {
   "suburb": "WEST FOOTSCRAY",
   "postcode": "3012"
 },
 {
   "suburb": "YARRAVILLE",
   "postcode": "3013"
 },
 {
   "suburb": "YARRAVILLE WEST",
   "postcode": "3013"
 },
 {
   "suburb": "NEWPORT",
   "postcode": "3015"
 },
 {
   "suburb": "SOUTH KINGSVILLE",
   "postcode": "3015"
 },
 {
   "suburb": "SPOTSWOOD",
   "postcode": "3015"
 },
 {
   "suburb": "WILLIAMSTOWN",
   "postcode": "3016"
 },
 {
   "suburb": "WILLIAMSTOWN NORTH",
   "postcode": "3016"
 },
 {
   "suburb": "ALTONA",
   "postcode": "3018"
 },
 {
   "suburb": "SEAHOLME",
   "postcode": "3018"
 },
 {
   "suburb": "BRAYBROOK",
   "postcode": "3019"
 },
 {
   "suburb": "ROBINSON",
   "postcode": "3019"
 },
 {
   "suburb": "ALBION",
   "postcode": "3020"
 },
 {
   "suburb": "GLENGALA",
   "postcode": "3020"
 },
 {
   "suburb": "SUNSHINE",
   "postcode": "3020"
 },
 {
   "suburb": "SUNSHINE NORTH",
   "postcode": "3020"
 },
 {
   "suburb": "SUNSHINE WEST",
   "postcode": "3020"
 },
 {
   "suburb": "ALBANVALE",
   "postcode": "3021"
 },
 {
   "suburb": "KEALBA",
   "postcode": "3021"
 },
 {
   "suburb": "KINGS PARK",
   "postcode": "3021"
 },
 {
   "suburb": "ST ALBANS",
   "postcode": "3021"
 },
 {
   "suburb": "ARDEER",
   "postcode": "3022"
 },
 {
   "suburb": "DEER PARK EAST",
   "postcode": "3022"
 },
 {
   "suburb": "BURNSIDE",
   "postcode": "3023"
 },
 {
   "suburb": "BURNSIDE HEIGHTS",
   "postcode": "3023"
 },
 {
   "suburb": "CAIRNLEA",
   "postcode": "3023"
 },
 {
   "suburb": "CAROLINE SPRINGS",
   "postcode": "3023"
 },
 {
   "suburb": "DEER PARK",
   "postcode": "3023"
 },
 {
   "suburb": "DEER PARK NORTH",
   "postcode": "3023"
 },
 {
   "suburb": "RAVENHALL",
   "postcode": "3023"
 },
 {
   "suburb": "MAMBOURIN",
   "postcode": "3024"
 },
 {
   "suburb": "MANOR LAKES",
   "postcode": "3024"
 },
 {
   "suburb": "MOUNT COTTRELL",
   "postcode": "3024"
 },
 {
   "suburb": "WYNDHAM VALE",
   "postcode": "3024"
 },
 {
   "suburb": "ALTONA EAST",
   "postcode": "3025"
 },
 {
   "suburb": "ALTONA GATE",
   "postcode": "3025"
 },
 {
   "suburb": "ALTONA NORTH",
   "postcode": "3025"
 },
 {
   "suburb": "DERRIMUT",
   "postcode": "3026"
 },
 {
   "suburb": "LAVERTON NORTH",
   "postcode": "3026"
 },
 {
   "suburb": "WILLIAMS LANDING",
   "postcode": "3027"
 },
 {
   "suburb": "ALTONA MEADOWS",
   "postcode": "3028"
 },
 {
   "suburb": "LAVERTON",
   "postcode": "3028"
 },
 {
   "suburb": "SEABROOK",
   "postcode": "3028"
 },
 {
   "suburb": "HOPPERS CROSSING",
   "postcode": "3029"
 },
 {
   "suburb": "TARNEIT",
   "postcode": "3029"
 },
 {
   "suburb": "TRUGANINA",
   "postcode": "3029"
 },
 {
   "suburb": "COCOROC",
   "postcode": "3030"
 },
 {
   "suburb": "POINT COOK",
   "postcode": "3030"
 },
 {
   "suburb": "QUANDONG",
   "postcode": "3030"
 },
 {
   "suburb": "WERRIBEE",
   "postcode": "3030"
 },
 {
   "suburb": "WERRIBEE SOUTH",
   "postcode": "3030"
 },
 {
   "suburb": "FLEMINGTON",
   "postcode": "3031"
 },
 {
   "suburb": "KENSINGTON",
   "postcode": "3031"
 },
 {
   "suburb": "ASCOT VALE",
   "postcode": "3032"
 },
 {
   "suburb": "HIGHPOINT CITY",
   "postcode": "3032"
 },
 {
   "suburb": "MARIBYRNONG",
   "postcode": "3032"
 },
 {
   "suburb": "TRAVANCORE",
   "postcode": "3032"
 },
 {
   "suburb": "KEILOR EAST",
   "postcode": "3033"
 },
 {
   "suburb": "AVONDALE HEIGHTS",
   "postcode": "3034"
 },
 {
   "suburb": "KEILOR",
   "postcode": "3036"
 },
 {
   "suburb": "KEILOR NORTH",
   "postcode": "3036"
 },
 {
   "suburb": "CALDER PARK",
   "postcode": "3037"
 },
 {
   "suburb": "DELAHEY",
   "postcode": "3037"
 },
 {
   "suburb": "HILLSIDE",
   "postcode": "3037"
 },
 {
   "suburb": "SYDENHAM",
   "postcode": "3037"
 },
 {
   "suburb": "TAYLORS HILL",
   "postcode": "3037"
 },
 {
   "suburb": "KEILOR DOWNS",
   "postcode": "3038"
 },
 {
   "suburb": "KEILOR LODGE",
   "postcode": "3038"
 },
 {
   "suburb": "TAYLORS LAKES",
   "postcode": "3038"
 },
 {
   "suburb": "WATERGARDENS",
   "postcode": "3038"
 },
 {
   "suburb": "MOONEE PONDS",
   "postcode": "3039"
 },
 {
   "suburb": "ABERFELDIE",
   "postcode": "3040"
 },
 {
   "suburb": "ESSENDON",
   "postcode": "3040"
 },
 {
   "suburb": "ESSENDON WEST",
   "postcode": "3040"
 },
 {
   "suburb": "CROSS KEYS",
   "postcode": "3041"
 },
 {
   "suburb": "ESSENDON FIELDS",
   "postcode": "3041"
 },
 {
   "suburb": "ESSENDON NORTH",
   "postcode": "3041"
 },
 {
   "suburb": "STRATHMORE",
   "postcode": "3041"
 },
 {
   "suburb": "STRATHMORE HEIGHTS",
   "postcode": "3041"
 },
 {
   "suburb": "AIRPORT WEST",
   "postcode": "3042"
 },
 {
   "suburb": "KEILOR PARK",
   "postcode": "3042"
 },
 {
   "suburb": "NIDDRIE",
   "postcode": "3042"
 },
 {
   "suburb": "NIDDRIE NORTH",
   "postcode": "3042"
 },
 {
   "suburb": "GLADSTONE PARK",
   "postcode": "3043"
 },
 {
   "suburb": "GOWANBRAE",
   "postcode": "3043"
 },
 {
   "suburb": "TULLAMARINE",
   "postcode": "3043"
 },
 {
   "suburb": "PASCOE VALE",
   "postcode": "3044"
 },
 {
   "suburb": "PASCOE VALE SOUTH",
   "postcode": "3044"
 },
 {
   "suburb": "MELBOURNE AIRPORT",
   "postcode": "3045"
 },
 {
   "suburb": "GLENROY",
   "postcode": "3046"
 },
 {
   "suburb": "HADFIELD",
   "postcode": "3046"
 },
 {
   "suburb": "OAK PARK",
   "postcode": "3046"
 },
 {
   "suburb": "BROADMEADOWS",
   "postcode": "3047"
 },
 {
   "suburb": "DALLAS",
   "postcode": "3047"
 },
 {
   "suburb": "JACANA",
   "postcode": "3047"
 },
 {
   "suburb": "COOLAROO",
   "postcode": "3048"
 },
 {
   "suburb": "MEADOW HEIGHTS",
   "postcode": "3048"
 },
 {
   "suburb": "ATTWOOD",
   "postcode": "3049"
 },
 {
   "suburb": "WESTMEADOWS",
   "postcode": "3049"
 },
 {
   "suburb": "ROYAL MELBOURNE HOSPITAL",
   "postcode": "3050"
 },
 {
   "suburb": "HOTHAM HILL",
   "postcode": "3051"
 },
 {
   "suburb": "NORTH MELBOURNE",
   "postcode": "3051"
 },
 {
   "suburb": "MELBOURNE UNIVERSITY",
   "postcode": "3052"
 },
 {
   "suburb": "PARKVILLE",
   "postcode": "3052"
 },
 {
   "suburb": "CARLTON",
   "postcode": "3053"
 },
 {
   "suburb": "CARLTON SOUTH",
   "postcode": "3053"
 },
 {
   "suburb": "CARLTON NORTH",
   "postcode": "3054"
 },
 {
   "suburb": "PRINCES HILL",
   "postcode": "3054"
 },
 {
   "suburb": "BRUNSWICK SOUTH",
   "postcode": "3055"
 },
 {
   "suburb": "BRUNSWICK WEST",
   "postcode": "3055"
 },
 {
   "suburb": "MOONEE VALE",
   "postcode": "3055"
 },
 {
   "suburb": "MORELAND WEST",
   "postcode": "3055"
 },
 {
   "suburb": "BRUNSWICK",
   "postcode": "3056"
 },
 {
   "suburb": "BRUNSWICK LOWER",
   "postcode": "3056"
 },
 {
   "suburb": "BRUNSWICK NORTH",
   "postcode": "3056"
 },
 {
   "suburb": "BRUNSWICK EAST",
   "postcode": "3057"
 },
 {
   "suburb": "SUMNER",
   "postcode": "3057"
 },
 {
   "suburb": "BATMAN",
   "postcode": "3058"
 },
 {
   "suburb": "COBURG",
   "postcode": "3058"
 },
 {
   "suburb": "COBURG NORTH",
   "postcode": "3058"
 },
 {
   "suburb": "MERLYNSTON",
   "postcode": "3058"
 },
 {
   "suburb": "MORELAND",
   "postcode": "3058"
 },
 {
   "suburb": "GREENVALE",
   "postcode": "3059"
 },
 {
   "suburb": "FAWKNER",
   "postcode": "3060"
 },
 {
   "suburb": "CAMPBELLFIELD",
   "postcode": "3061"
 },
 {
   "suburb": "SOMERTON",
   "postcode": "3062"
 },
 {
   "suburb": "OAKLANDS JUNCTION",
   "postcode": "3063"
 },
 {
   "suburb": "YUROKE",
   "postcode": "3063"
 },
 {
   "suburb": "CRAIGIEBURN",
   "postcode": "3064"
 },
 {
   "suburb": "DONNYBROOK",
   "postcode": "3064"
 },
 {
   "suburb": "KALKALLO",
   "postcode": "3064"
 },
 {
   "suburb": "MICKLEHAM",
   "postcode": "3064"
 },
 {
   "suburb": "ROXBURGH PARK",
   "postcode": "3064"
 },
 {
   "suburb": "FITZROY",
   "postcode": "3065"
 },
 {
   "suburb": "COLLINGWOOD",
   "postcode": "3066"
 },
 {
   "suburb": "COLLINGWOOD NORTH",
   "postcode": "3066"
 },
 {
   "suburb": "ABBOTSFORD",
   "postcode": "3067"
 },
 {
   "suburb": "CLIFTON HILL",
   "postcode": "3068"
 },
 {
   "suburb": "FITZROY NORTH",
   "postcode": "3068"
 },
 {
   "suburb": "NORTHCOTE",
   "postcode": "3070"
 },
 {
   "suburb": "NORTHCOTE SOUTH",
   "postcode": "3070"
 },
 {
   "suburb": "THORNBURY",
   "postcode": "3071"
 },
 {
   "suburb": "GILBERTON",
   "postcode": "3072"
 },
 {
   "suburb": "NORTHLAND CENTRE",
   "postcode": "3072"
 },
 {
   "suburb": "PRESTON",
   "postcode": "3072"
 },
 {
   "suburb": "PRESTON LOWER",
   "postcode": "3072"
 },
 {
   "suburb": "PRESTON SOUTH",
   "postcode": "3072"
 },
 {
   "suburb": "PRESTON WEST",
   "postcode": "3072"
 },
 {
   "suburb": "REGENT WEST",
   "postcode": "3072"
 },
 {
   "suburb": "RESERVOIR",
   "postcode": "3073"
 },
 {
   "suburb": "THOMASTOWN",
   "postcode": "3074"
 },
 {
   "suburb": "LALOR",
   "postcode": "3075"
 },
 {
   "suburb": "EPPING",
   "postcode": "3076"
 },
 {
   "suburb": "ALPHINGTON",
   "postcode": "3078"
 },
 {
   "suburb": "FAIRFIELD",
   "postcode": "3078"
 },
 {
   "suburb": "IVANHOE",
   "postcode": "3079"
 },
 {
   "suburb": "IVANHOE EAST",
   "postcode": "3079"
 },
 {
   "suburb": "IVANHOE NORTH",
   "postcode": "3079"
 },
 {
   "suburb": "BELLFIELD",
   "postcode": "3081"
 },
 {
   "suburb": "HEIDELBERG HEIGHTS",
   "postcode": "3081"
 },
 {
   "suburb": "HEIDELBERG RGH",
   "postcode": "3081"
 },
 {
   "suburb": "HEIDELBERG WEST",
   "postcode": "3081"
 },
 {
   "suburb": "MILL PARK",
   "postcode": "3082"
 },
 {
   "suburb": "BUNDOORA",
   "postcode": "3083"
 },
 {
   "suburb": "KINGSBURY",
   "postcode": "3083"
 },
 {
   "suburb": "LA TROBE UNIVERSITY",
   "postcode": "3083"
 },
 {
   "suburb": "BANYULE",
   "postcode": "3084"
 },
 {
   "suburb": "EAGLEMONT",
   "postcode": "3084"
 },
 {
   "suburb": "HEIDELBERG",
   "postcode": "3084"
 },
 {
   "suburb": "ROSANNA",
   "postcode": "3084"
 },
 {
   "suburb": "VIEWBANK",
   "postcode": "3084"
 },
 {
   "suburb": "MACLEOD",
   "postcode": "3085"
 },
 {
   "suburb": "MACLEOD WEST",
   "postcode": "3085"
 },
 {
   "suburb": "YALLAMBIE",
   "postcode": "3085"
 },
 {
   "suburb": "LA TROBE UNIVERSITY",
   "postcode": "3086"
 },
 {
   "suburb": "WATSONIA",
   "postcode": "3087"
 },
 {
   "suburb": "WATSONIA NORTH",
   "postcode": "3087"
 },
 {
   "suburb": "BRIAR HILL",
   "postcode": "3088"
 },
 {
   "suburb": "GREENSBOROUGH",
   "postcode": "3088"
 },
 {
   "suburb": "SAINT HELENA",
   "postcode": "3088"
 },
 {
   "suburb": "ST HELENA",
   "postcode": "3088"
 },
 {
   "suburb": "DIAMOND CREEK",
   "postcode": "3089"
 },
 {
   "suburb": "PLENTY",
   "postcode": "3090"
 },
 {
   "suburb": "YARRAMBAT",
   "postcode": "3091"
 },
 {
   "suburb": "LOWER PLENTY",
   "postcode": "3093"
 },
 {
   "suburb": "MONTMORENCY",
   "postcode": "3094"
 },
 {
   "suburb": "ELTHAM",
   "postcode": "3095"
 },
 {
   "suburb": "ELTHAM NORTH",
   "postcode": "3095"
 },
 {
   "suburb": "RESEARCH",
   "postcode": "3095"
 },
 {
   "suburb": "WATTLE GLEN",
   "postcode": "3096"
 },
 {
   "suburb": "BEND OF ISLANDS",
   "postcode": "3097"
 },
 {
   "suburb": "KANGAROO GROUND",
   "postcode": "3097"
 },
 {
   "suburb": "WATSONS CREEK",
   "postcode": "3097"
 },
 {
   "suburb": "ARTHURS CREEK",
   "postcode": "3099"
 },
 {
   "suburb": "COTTLES BRIDGE",
   "postcode": "3099"
 },
 {
   "suburb": "HURSTBRIDGE",
   "postcode": "3099"
 },
 {
   "suburb": "NUTFIELD",
   "postcode": "3099"
 },
 {
   "suburb": "STRATHEWEN",
   "postcode": "3099"
 },
 {
   "suburb": "COTHAM",
   "postcode": "3101"
 },
 {
   "suburb": "KEW",
   "postcode": "3101"
 },
 {
   "suburb": "KEW EAST",
   "postcode": "3102"
 },
 {
   "suburb": "BALWYN",
   "postcode": "3103"
 },
 {
   "suburb": "BALWYN EAST",
   "postcode": "3103"
 },
 {
   "suburb": "DEEPDENE",
   "postcode": "3103"
 },
 {
   "suburb": "STRADBROKE PARK",
   "postcode": "3103"
 },
 {
   "suburb": "BALWYN NORTH",
   "postcode": "3104"
 },
 {
   "suburb": "GREYTHORN",
   "postcode": "3104"
 },
 {
   "suburb": "BULLEEN",
   "postcode": "3105"
 },
 {
   "suburb": "TEMPLESTOWE",
   "postcode": "3106"
 },
 {
   "suburb": "TEMPLESTOWE LOWER",
   "postcode": "3107"
 },
 {
   "suburb": "DONCASTER",
   "postcode": "3108"
 },
 {
   "suburb": "DONCASTER EAST",
   "postcode": "3109"
 },
 {
   "suburb": "DONCASTER HEIGHTS",
   "postcode": "3109"
 },
 {
   "suburb": "DONVALE",
   "postcode": "3111"
 },
 {
   "suburb": "NORTH WARRANDYTE",
   "postcode": "3113"
 },
 {
   "suburb": "WARRANDYTE",
   "postcode": "3113"
 },
 {
   "suburb": "PARK ORCHARDS",
   "postcode": "3114"
 },
 {
   "suburb": "WONGA PARK",
   "postcode": "3115"
 },
 {
   "suburb": "CHIRNSIDE PARK",
   "postcode": "3116"
 },
 {
   "suburb": "BURNLEY",
   "postcode": "3121"
 },
 {
   "suburb": "BURNLEY NORTH",
   "postcode": "3121"
 },
 {
   "suburb": "CREMORNE",
   "postcode": "3121"
 },
 {
   "suburb": "RICHMOND",
   "postcode": "3121"
 },
 {
   "suburb": "RICHMOND EAST",
   "postcode": "3121"
 },
 {
   "suburb": "RICHMOND NORTH",
   "postcode": "3121"
 },
 {
   "suburb": "RICHMOND SOUTH",
   "postcode": "3121"
 },
 {
   "suburb": "AUBURN SOUTH",
   "postcode": "3122"
 },
 {
   "suburb": "GLENFERRIE SOUTH",
   "postcode": "3122"
 },
 {
   "suburb": "HAWTHORN",
   "postcode": "3122"
 },
 {
   "suburb": "HAWTHORN NORTH",
   "postcode": "3122"
 },
 {
   "suburb": "HAWTHORN WEST",
   "postcode": "3122"
 },
 {
   "suburb": "AUBURN",
   "postcode": "3123"
 },
 {
   "suburb": "HAWTHORN EAST",
   "postcode": "3123"
 },
 {
   "suburb": "CAMBERWELL",
   "postcode": "3124"
 },
 {
   "suburb": "CAMBERWELL NORTH",
   "postcode": "3124"
 },
 {
   "suburb": "CAMBERWELL SOUTH",
   "postcode": "3124"
 },
 {
   "suburb": "CAMBERWELL WEST",
   "postcode": "3124"
 },
 {
   "suburb": "HARTWELL",
   "postcode": "3124"
 },
 {
   "suburb": "MIDDLE CAMBERWELL",
   "postcode": "3124"
 },
 {
   "suburb": "BENNETTSWOOD",
   "postcode": "3125"
 },
 {
   "suburb": "BURWOOD",
   "postcode": "3125"
 },
 {
   "suburb": "SURREY HILLS SOUTH",
   "postcode": "3125"
 },
 {
   "suburb": "CAMBERWELL EAST",
   "postcode": "3126"
 },
 {
   "suburb": "CANTERBURY",
   "postcode": "3126"
 },
 {
   "suburb": "MONT ALBERT",
   "postcode": "3127"
 },
 {
   "suburb": "SURREY HILLS",
   "postcode": "3127"
 },
 {
   "suburb": "SURREY HILLS NORTH",
   "postcode": "3127"
 },
 {
   "suburb": "BOX HILL",
   "postcode": "3128"
 },
 {
   "suburb": "BOX HILL CENTRAL",
   "postcode": "3128"
 },
 {
   "suburb": "BOX HILL SOUTH",
   "postcode": "3128"
 },
 {
   "suburb": "HOUSTON",
   "postcode": "3128"
 },
 {
   "suburb": "WATTLE PARK",
   "postcode": "3128"
 },
 {
   "suburb": "BOX HILL NORTH",
   "postcode": "3129"
 },
 {
   "suburb": "KERRIMUIR",
   "postcode": "3129"
 },
 {
   "suburb": "MONT ALBERT NORTH",
   "postcode": "3129"
 },
 {
   "suburb": "BLACKBURN",
   "postcode": "3130"
 },
 {
   "suburb": "BLACKBURN NORTH",
   "postcode": "3130"
 },
 {
   "suburb": "BLACKBURN SOUTH",
   "postcode": "3130"
 },
 {
   "suburb": "LABURNUM",
   "postcode": "3130"
 },
 {
   "suburb": "BRENTFORD SQUARE",
   "postcode": "3131"
 },
 {
   "suburb": "FOREST HILL",
   "postcode": "3131"
 },
 {
   "suburb": "NUNAWADING",
   "postcode": "3131"
 },
 {
   "suburb": "MITCHAM",
   "postcode": "3132"
 },
 {
   "suburb": "MITCHAM NORTH",
   "postcode": "3132"
 },
 {
   "suburb": "RANGEVIEW",
   "postcode": "3132"
 },
 {
   "suburb": "VERMONT",
   "postcode": "3133"
 },
 {
   "suburb": "VERMONT SOUTH",
   "postcode": "3133"
 },
 {
   "suburb": "HEATHWOOD",
   "postcode": "3134"
 },
 {
   "suburb": "RINGWOOD",
   "postcode": "3134"
 },
 {
   "suburb": "RINGWOOD NORTH",
   "postcode": "3134"
 },
 {
   "suburb": "WARRANDYTE SOUTH",
   "postcode": "3134"
 },
 {
   "suburb": "WARRANWOOD",
   "postcode": "3134"
 },
 {
   "suburb": "BEDFORD ROAD",
   "postcode": "3135"
 },
 {
   "suburb": "HEATHMONT",
   "postcode": "3135"
 },
 {
   "suburb": "RINGWOOD EAST",
   "postcode": "3135"
 },
 {
   "suburb": "CROYDON",
   "postcode": "3136"
 },
 {
   "suburb": "CROYDON HILLS",
   "postcode": "3136"
 },
 {
   "suburb": "CROYDON NORTH",
   "postcode": "3136"
 },
 {
   "suburb": "CROYDON SOUTH",
   "postcode": "3136"
 },
 {
   "suburb": "KILSYTH",
   "postcode": "3137"
 },
 {
   "suburb": "KILSYTH SOUTH",
   "postcode": "3137"
 },
 {
   "suburb": "MOOROOLBARK",
   "postcode": "3138"
 },
 {
   "suburb": "BEENAK",
   "postcode": "3139"
 },
 {
   "suburb": "DON VALLEY",
   "postcode": "3139"
 },
 {
   "suburb": "HODDLES CREEK",
   "postcode": "3139"
 },
 {
   "suburb": "LAUNCHING PLACE",
   "postcode": "3139"
 },
 {
   "suburb": "SEVILLE",
   "postcode": "3139"
 },
 {
   "suburb": "SEVILLE EAST",
   "postcode": "3139"
 },
 {
   "suburb": "WANDIN EAST",
   "postcode": "3139"
 },
 {
   "suburb": "WANDIN NORTH",
   "postcode": "3139"
 },
 {
   "suburb": "WOORI YALLOCK",
   "postcode": "3139"
 },
 {
   "suburb": "YELLINGBO",
   "postcode": "3139"
 },
 {
   "suburb": "LILYDALE",
   "postcode": "3140"
 },
 {
   "suburb": "SOUTH YARRA",
   "postcode": "3141"
 },
 {
   "suburb": "HAWKSBURN",
   "postcode": "3142"
 },
 {
   "suburb": "TOORAK",
   "postcode": "3142"
 },
 {
   "suburb": "ARMADALE",
   "postcode": "3143"
 },
 {
   "suburb": "ARMADALE NORTH",
   "postcode": "3143"
 },
 {
   "suburb": "KOOYONG",
   "postcode": "3144"
 },
 {
   "suburb": "MALVERN",
   "postcode": "3144"
 },
 {
   "suburb": "MALVERN NORTH",
   "postcode": "3144"
 },
 {
   "suburb": "CAULFIELD EAST",
   "postcode": "3145"
 },
 {
   "suburb": "CENTRAL PARK",
   "postcode": "3145"
 },
 {
   "suburb": "DARLING",
   "postcode": "3145"
 },
 {
   "suburb": "DARLING SOUTH",
   "postcode": "3145"
 },
 {
   "suburb": "MALVERN EAST",
   "postcode": "3145"
 },
 {
   "suburb": "WATTLETREE ROAD PO",
   "postcode": "3145"
 },
 {
   "suburb": "GLEN IRIS",
   "postcode": "3146"
 },
 {
   "suburb": "TOORONGA",
   "postcode": "3146"
 },
 {
   "suburb": "ASHBURTON",
   "postcode": "3147"
 },
 {
   "suburb": "ASHWOOD",
   "postcode": "3147"
 },
 {
   "suburb": "CHADSTONE",
   "postcode": "3148"
 },
 {
   "suburb": "CHADSTONE CENTRE",
   "postcode": "3148"
 },
 {
   "suburb": "HOLMESGLEN",
   "postcode": "3148"
 },
 {
   "suburb": "JORDANVILLE",
   "postcode": "3148"
 },
 {
   "suburb": "MOUNT WAVERLEY",
   "postcode": "3149"
 },
 {
   "suburb": "PINEWOOD",
   "postcode": "3149"
 },
 {
   "suburb": "SYNDAL",
   "postcode": "3149"
 },
 {
   "suburb": "BRANDON PARK",
   "postcode": "3150"
 },
 {
   "suburb": "GLEN WAVERLEY",
   "postcode": "3150"
 },
 {
   "suburb": "WHEELERS HILL",
   "postcode": "3150"
 },
 {
   "suburb": "BURWOOD EAST",
   "postcode": "3151"
 },
 {
   "suburb": "BURWOOD HEIGHTS",
   "postcode": "3151"
 },
 {
   "suburb": "KNOX CITY CENTRE",
   "postcode": "3152"
 },
 {
   "suburb": "STUDFIELD",
   "postcode": "3152"
 },
 {
   "suburb": "WANTIRNA",
   "postcode": "3152"
 },
 {
   "suburb": "WANTIRNA SOUTH",
   "postcode": "3152"
 },
 {
   "suburb": "BAYSWATER",
   "postcode": "3153"
 },
 {
   "suburb": "BAYSWATER NORTH",
   "postcode": "3153"
 },
 {
   "suburb": "THE BASIN",
   "postcode": "3154"
 },
 {
   "suburb": "BORONIA",
   "postcode": "3155"
 },
 {
   "suburb": "FERNTREE GULLY",
   "postcode": "3156"
 },
 {
   "suburb": "LYSTERFIELD",
   "postcode": "3156"
 },
 {
   "suburb": "LYSTERFIELD SOUTH",
   "postcode": "3156"
 },
 {
   "suburb": "MOUNTAIN GATE",
   "postcode": "3156"
 },
 {
   "suburb": "UPPER FERNTREE GULLY",
   "postcode": "3156"
 },
 {
   "suburb": "UPWEY",
   "postcode": "3158"
 },
 {
   "suburb": "MENZIES CREEK",
   "postcode": "3159"
 },
 {
   "suburb": "SELBY",
   "postcode": "3159"
 },
 {
   "suburb": "BELGRAVE",
   "postcode": "3160"
 },
 {
   "suburb": "BELGRAVE HEIGHTS",
   "postcode": "3160"
 },
 {
   "suburb": "BELGRAVE SOUTH",
   "postcode": "3160"
 },
 {
   "suburb": "TECOMA",
   "postcode": "3160"
 },
 {
   "suburb": "CAULFIELD JUNCTION",
   "postcode": "3161"
 },
 {
   "suburb": "CAULFIELD NORTH",
   "postcode": "3161"
 },
 {
   "suburb": "CAULFIELD",
   "postcode": "3162"
 },
 {
   "suburb": "CAULFIELD SOUTH",
   "postcode": "3162"
 },
 {
   "suburb": "HOPETOUN GARDENS",
   "postcode": "3162"
 },
 {
   "suburb": "BOORAN ROAD PO",
   "postcode": "3163"
 },
 {
   "suburb": "CARNEGIE",
   "postcode": "3163"
 },
 {
   "suburb": "GLEN HUNTLY",
   "postcode": "3163"
 },
 {
   "suburb": "MURRUMBEENA",
   "postcode": "3163"
 },
 {
   "suburb": "DANDENONG SOUTH",
   "postcode": "3164"
 },
 {
   "suburb": "BENTLEIGH EAST",
   "postcode": "3165"
 },
 {
   "suburb": "HUGHESDALE",
   "postcode": "3166"
 },
 {
   "suburb": "HUNTINGDALE",
   "postcode": "3166"
 },
 {
   "suburb": "OAKLEIGH",
   "postcode": "3166"
 },
 {
   "suburb": "OAKLEIGH EAST",
   "postcode": "3166"
 },
 {
   "suburb": "OAKLEIGH SOUTH",
   "postcode": "3167"
 },
 {
   "suburb": "CLAYTON",
   "postcode": "3168"
 },
 {
   "suburb": "NOTTING HILL",
   "postcode": "3168"
 },
 {
   "suburb": "CLARINDA",
   "postcode": "3169"
 },
 {
   "suburb": "CLAYTON SOUTH",
   "postcode": "3169"
 },
 {
   "suburb": "MULGRAVE",
   "postcode": "3170"
 },
 {
   "suburb": "WAVERLEY GARDENS",
   "postcode": "3170"
 },
 {
   "suburb": "SANDOWN VILLAGE",
   "postcode": "3171"
 },
 {
   "suburb": "SPRINGVALE",
   "postcode": "3171"
 },
 {
   "suburb": "DINGLEY VILLAGE",
   "postcode": "3172"
 },
 {
   "suburb": "SPRINGVALE SOUTH",
   "postcode": "3172"
 },
 {
   "suburb": "KEYSBOROUGH",
   "postcode": "3173"
 },
 {
   "suburb": "NOBLE PARK",
   "postcode": "3174"
 },
 {
   "suburb": "NOBLE PARK NORTH",
   "postcode": "3174"
 },
 {
   "suburb": "BANGHOLME",
   "postcode": "3175"
 },
 {
   "suburb": "DANDENONG",
   "postcode": "3175"
 },
 {
   "suburb": "DANDENONG EAST",
   "postcode": "3175"
 },
 {
   "suburb": "DANDENONG NORTH",
   "postcode": "3175"
 },
 {
   "suburb": "DANDENONG SOUTH",
   "postcode": "3175"
 },
 {
   "suburb": "DUNEARN",
   "postcode": "3175"
 },
 {
   "suburb": "DOVETON",
   "postcode": "3177"
 },
 {
   "suburb": "EUMEMMERRING",
   "postcode": "3177"
 },
 {
   "suburb": "ROWVILLE",
   "postcode": "3178"
 },
 {
   "suburb": "SCORESBY",
   "postcode": "3179"
 },
 {
   "suburb": "KNOXFIELD",
   "postcode": "3180"
 },
 {
   "suburb": "PRAHRAN",
   "postcode": "3181"
 },
 {
   "suburb": "PRAHRAN EAST",
   "postcode": "3181"
 },
 {
   "suburb": "WINDSOR",
   "postcode": "3181"
 },
 {
   "suburb": "ST KILDA",
   "postcode": "3182"
 },
 {
   "suburb": "ST KILDA SOUTH",
   "postcode": "3182"
 },
 {
   "suburb": "ST KILDA WEST",
   "postcode": "3182"
 },
 {
   "suburb": "BALACLAVA",
   "postcode": "3183"
 },
 {
   "suburb": "ST KILDA EAST",
   "postcode": "3183"
 },
 {
   "suburb": "BRIGHTON ROAD",
   "postcode": "3184"
 },
 {
   "suburb": "ELWOOD",
   "postcode": "3184"
 },
 {
   "suburb": "ELSTERNWICK",
   "postcode": "3185"
 },
 {
   "suburb": "GARDENVALE",
   "postcode": "3185"
 },
 {
   "suburb": "RIPPONLEA",
   "postcode": "3185"
 },
 {
   "suburb": "BRIGHTON",
   "postcode": "3186"
 },
 {
   "suburb": "BRIGHTON NORTH",
   "postcode": "3186"
 },
 {
   "suburb": "DENDY",
   "postcode": "3186"
 },
 {
   "suburb": "WERE STREET PO",
   "postcode": "3186"
 },
 {
   "suburb": "BRIGHTON EAST",
   "postcode": "3187"
 },
 {
   "suburb": "NORTH ROAD",
   "postcode": "3187"
 },
 {
   "suburb": "HAMPTON",
   "postcode": "3188"
 },
 {
   "suburb": "HAMPTON EAST",
   "postcode": "3188"
 },
 {
   "suburb": "HAMPTON NORTH",
   "postcode": "3188"
 },
 {
   "suburb": "MOORABBIN",
   "postcode": "3189"
 },
 {
   "suburb": "MOORABBIN EAST",
   "postcode": "3189"
 },
 {
   "suburb": "WISHART",
   "postcode": "3189"
 },
 {
   "suburb": "HIGHETT",
   "postcode": "3190"
 },
 {
   "suburb": "SANDRINGHAM",
   "postcode": "3191"
 },
 {
   "suburb": "CHELTENHAM",
   "postcode": "3192"
 },
 {
   "suburb": "CHELTENHAM EAST",
   "postcode": "3192"
 },
 {
   "suburb": "SOUTHLAND CENTRE",
   "postcode": "3192"
 },
 {
   "suburb": "BEAUMARIS",
   "postcode": "3193"
 },
 {
   "suburb": "BLACK ROCK",
   "postcode": "3193"
 },
 {
   "suburb": "BLACK ROCK NORTH",
   "postcode": "3193"
 },
 {
   "suburb": "CROMER",
   "postcode": "3193"
 },
 {
   "suburb": "MENTONE",
   "postcode": "3194"
 },
 {
   "suburb": "MENTONE EAST",
   "postcode": "3194"
 },
 {
   "suburb": "MOORABBIN AIRPORT",
   "postcode": "3194"
 },
 {
   "suburb": "ASPENDALE",
   "postcode": "3195"
 },
 {
   "suburb": "ASPENDALE GARDENS",
   "postcode": "3195"
 },
 {
   "suburb": "BRAESIDE",
   "postcode": "3195"
 },
 {
   "suburb": "MORDIALLOC",
   "postcode": "3195"
 },
 {
   "suburb": "PARKDALE",
   "postcode": "3195"
 },
 {
   "suburb": "WATERWAYS",
   "postcode": "3195"
 },
 {
   "suburb": "BONBEACH",
   "postcode": "3196"
 },
 {
   "suburb": "CHELSEA",
   "postcode": "3196"
 },
 {
   "suburb": "CHELSEA HEIGHTS",
   "postcode": "3196"
 },
 {
   "suburb": "EDITHVALE",
   "postcode": "3196"
 },
 {
   "suburb": "CARRUM",
   "postcode": "3197"
 },
 {
   "suburb": "PATTERSON LAKES",
   "postcode": "3197"
 },
 {
   "suburb": "SEAFORD",
   "postcode": "3198"
 },
 {
   "suburb": "FRANKSTON",
   "postcode": "3199"
 },
 {
   "suburb": "FRANKSTON EAST",
   "postcode": "3199"
 },
 {
   "suburb": "FRANKSTON HEIGHTS",
   "postcode": "3199"
 },
 {
   "suburb": "FRANKSTON SOUTH",
   "postcode": "3199"
 },
 {
   "suburb": "KARINGAL",
   "postcode": "3199"
 },
 {
   "suburb": "KARINGAL CENTRE",
   "postcode": "3199"
 },
 {
   "suburb": "FRANKSTON NORTH",
   "postcode": "3200"
 },
 {
   "suburb": "PINES FOREST",
   "postcode": "3200"
 },
 {
   "suburb": "CARRUM DOWNS",
   "postcode": "3201"
 },
 {
   "suburb": "HEATHERTON",
   "postcode": "3202"
 },
 {
   "suburb": "BENTLEIGH",
   "postcode": "3204"
 },
 {
   "suburb": "MCKINNON",
   "postcode": "3204"
 },
 {
   "suburb": "ORMOND",
   "postcode": "3204"
 },
 {
   "suburb": "PATTERSON",
   "postcode": "3204"
 },
 {
   "suburb": "SOUTH MELBOURNE",
   "postcode": "3205"
 },
 {
   "suburb": "ALBERT PARK",
   "postcode": "3206"
 },
 {
   "suburb": "MIDDLE PARK",
   "postcode": "3206"
 },
 {
   "suburb": "GARDEN CITY",
   "postcode": "3207"
 },
 {
   "suburb": "PORT MELBOURNE",
   "postcode": "3207"
 },
 {
   "suburb": "LITTLE RIVER",
   "postcode": "3211"
 },
 {
   "suburb": "AVALON",
   "postcode": "3212"
 },
 {
   "suburb": "LARA",
   "postcode": "3212"
 },
 {
   "suburb": "POINT WILSON",
   "postcode": "3212"
 },
 {
   "suburb": "ANAKIE",
   "postcode": "3213"
 },
 {
   "suburb": "BATESFORD",
   "postcode": "3213"
 },
 {
   "suburb": "LOVELY BANKS",
   "postcode": "3213"
 },
 {
   "suburb": "MOORABOOL",
   "postcode": "3213"
 },
 {
   "suburb": "CORIO",
   "postcode": "3214"
 },
 {
   "suburb": "NORLANE",
   "postcode": "3214"
 },
 {
   "suburb": "NORTH SHORE",
   "postcode": "3214"
 },
 {
   "suburb": "BELL PARK",
   "postcode": "3215"
 },
 {
   "suburb": "BELL POST HILL",
   "postcode": "3215"
 },
 {
   "suburb": "DRUMCONDRA",
   "postcode": "3215"
 },
 {
   "suburb": "GEELONG NORTH",
   "postcode": "3215"
 },
 {
   "suburb": "HAMLYN HEIGHTS",
   "postcode": "3215"
 },
 {
   "suburb": "NORTH GEELONG",
   "postcode": "3215"
 },
 {
   "suburb": "RIPPLESIDE",
   "postcode": "3215"
 },
 {
   "suburb": "BELMONT",
   "postcode": "3216"
 },
 {
   "suburb": "GROVEDALE",
   "postcode": "3216"
 },
 {
   "suburb": "GROVEDALE EAST",
   "postcode": "3216"
 },
 {
   "suburb": "HIGHTON",
   "postcode": "3216"
 },
 {
   "suburb": "MARSHALL",
   "postcode": "3216"
 },
 {
   "suburb": "MOUNT DUNEED",
   "postcode": "3216"
 },
 {
   "suburb": "WANDANA HEIGHTS",
   "postcode": "3216"
 },
 {
   "suburb": "WAURN PONDS",
   "postcode": "3216"
 },
 {
   "suburb": "ARMSTRONG CREEK",
   "postcode": "3217"
 },
 {
   "suburb": "CHARLEMONT",
   "postcode": "3217"
 },
 {
   "suburb": "FRESHWATER CREEK",
   "postcode": "3217"
 },
 {
   "suburb": "MOUNT DUNEED",
   "postcode": "3217"
 },
 {
   "suburb": "FYANSFORD",
   "postcode": "3218"
 },
 {
   "suburb": "GEELONG WEST",
   "postcode": "3218"
 },
 {
   "suburb": "HERNE HILL",
   "postcode": "3218"
 },
 {
   "suburb": "MANIFOLD HEIGHTS",
   "postcode": "3218"
 },
 {
   "suburb": "MURGHEBOLUC",
   "postcode": "3218"
 },
 {
   "suburb": "STONEHAVEN",
   "postcode": "3218"
 },
 {
   "suburb": "BREAKWATER",
   "postcode": "3219"
 },
 {
   "suburb": "EAST GEELONG",
   "postcode": "3219"
 },
 {
   "suburb": "NEWCOMB",
   "postcode": "3219"
 },
 {
   "suburb": "ST ALBANS PARK",
   "postcode": "3219"
 },
 {
   "suburb": "THOMSON",
   "postcode": "3219"
 },
 {
   "suburb": "WHITTINGTON",
   "postcode": "3219"
 },
 {
   "suburb": "BAREENA",
   "postcode": "3220"
 },
 {
   "suburb": "GEELONG",
   "postcode": "3220"
 },
 {
   "suburb": "NEWTOWN",
   "postcode": "3220"
 },
 {
   "suburb": "SOUTH GEELONG",
   "postcode": "3220"
 },
 {
   "suburb": "BARRABOOL",
   "postcode": "3221"
 },
 {
   "suburb": "CERES",
   "postcode": "3221"
 },
 {
   "suburb": "GEELONG MC",
   "postcode": "3221"
 },
 {
   "suburb": "GNARWARRE",
   "postcode": "3221"
 },
 {
   "suburb": "LOVELY BANKS",
   "postcode": "3221"
 },
 {
   "suburb": "MOOLAP",
   "postcode": "3221"
 },
 {
   "suburb": "CLIFTON SPRINGS",
   "postcode": "3222"
 },
 {
   "suburb": "CURLEWIS",
   "postcode": "3222"
 },
 {
   "suburb": "DRYSDALE",
   "postcode": "3222"
 },
 {
   "suburb": "MANNERIM",
   "postcode": "3222"
 },
 {
   "suburb": "MARCUS HILL",
   "postcode": "3222"
 },
 {
   "suburb": "WALLINGTON",
   "postcode": "3222"
 },
 {
   "suburb": "BELLARINE",
   "postcode": "3223"
 },
 {
   "suburb": "INDENTED HEAD",
   "postcode": "3223"
 },
 {
   "suburb": "PORTARLINGTON",
   "postcode": "3223"
 },
 {
   "suburb": "ST LEONARDS",
   "postcode": "3223"
 },
 {
   "suburb": "LEOPOLD",
   "postcode": "3224"
 },
 {
   "suburb": "MOOLAP",
   "postcode": "3224"
 },
 {
   "suburb": "POINT LONSDALE",
   "postcode": "3225"
 },
 {
   "suburb": "QUEENSCLIFF",
   "postcode": "3225"
 },
 {
   "suburb": "SWAN BAY",
   "postcode": "3225"
 },
 {
   "suburb": "SWAN ISLAND",
   "postcode": "3225"
 },
 {
   "suburb": "OCEAN GROVE",
   "postcode": "3226"
 },
 {
   "suburb": "BARWON HEADS",
   "postcode": "3227"
 },
 {
   "suburb": "BREAMLEA",
   "postcode": "3227"
 },
 {
   "suburb": "CONNEWARRE",
   "postcode": "3227"
 },
 {
   "suburb": "BELLBRAE",
   "postcode": "3228"
 },
 {
   "suburb": "BELLS BEACH",
   "postcode": "3228"
 },
 {
   "suburb": "JAN JUC",
   "postcode": "3228"
 },
 {
   "suburb": "TORQUAY",
   "postcode": "3228"
 },
 {
   "suburb": "ANGLESEA",
   "postcode": "3230"
 },
 {
   "suburb": "AIREYS INLET",
   "postcode": "3231"
 },
 {
   "suburb": "BIG HILL",
   "postcode": "3231"
 },
 {
   "suburb": "EASTERN VIEW",
   "postcode": "3231"
 },
 {
   "suburb": "FAIRHAVEN",
   "postcode": "3231"
 },
 {
   "suburb": "MOGGS CREEK",
   "postcode": "3231"
 },
 {
   "suburb": "LORNE",
   "postcode": "3232"
 },
 {
   "suburb": "APOLLO BAY",
   "postcode": "3233"
 },
 {
   "suburb": "CAPE OTWAY",
   "postcode": "3233"
 },
 {
   "suburb": "MARENGO",
   "postcode": "3233"
 },
 {
   "suburb": "PETTICOAT CREEK",
   "postcode": "3233"
 },
 {
   "suburb": "SKENES CREEK",
   "postcode": "3233"
 },
 {
   "suburb": "SKENES CREEK NORTH",
   "postcode": "3233"
 },
 {
   "suburb": "GREY RIVER",
   "postcode": "3234"
 },
 {
   "suburb": "KENNETT RIVER",
   "postcode": "3234"
 },
 {
   "suburb": "SEPARATION CREEK",
   "postcode": "3234"
 },
 {
   "suburb": "SUGARLOAF",
   "postcode": "3234"
 },
 {
   "suburb": "WONGARRA",
   "postcode": "3234"
 },
 {
   "suburb": "WYE RIVER",
   "postcode": "3234"
 },
 {
   "suburb": "BENWERRIN",
   "postcode": "3235"
 },
 {
   "suburb": "BOONAH",
   "postcode": "3235"
 },
 {
   "suburb": "DEANS MARSH",
   "postcode": "3235"
 },
 {
   "suburb": "PENNYROYAL",
   "postcode": "3235"
 },
 {
   "suburb": "FORREST",
   "postcode": "3236"
 },
 {
   "suburb": "MOUNT SABINE",
   "postcode": "3236"
 },
 {
   "suburb": "AIRE VALLEY",
   "postcode": "3237"
 },
 {
   "suburb": "BEECH FOREST",
   "postcode": "3237"
 },
 {
   "suburb": "FERGUSON",
   "postcode": "3237"
 },
 {
   "suburb": "GELLIBRAND LOWER",
   "postcode": "3237"
 },
 {
   "suburb": "WATTLE HILL",
   "postcode": "3237"
 },
 {
   "suburb": "WEEAPROINAH",
   "postcode": "3237"
 },
 {
   "suburb": "WYELANGTA",
   "postcode": "3237"
 },
 {
   "suburb": "YUULONG",
   "postcode": "3237"
 },
 {
   "suburb": "GLENAIRE",
   "postcode": "3238"
 },
 {
   "suburb": "HORDERN VALE",
   "postcode": "3238"
 },
 {
   "suburb": "JOHANNA",
   "postcode": "3238"
 },
 {
   "suburb": "LAVERS HILL",
   "postcode": "3238"
 },
 {
   "suburb": "CARLISLE RIVER",
   "postcode": "3239"
 },
 {
   "suburb": "CHAPPLE VALE",
   "postcode": "3239"
 },
 {
   "suburb": "GELLIBRAND",
   "postcode": "3239"
 },
 {
   "suburb": "KENNEDYS CREEK",
   "postcode": "3239"
 },
 {
   "suburb": "BUCKLEY",
   "postcode": "3240"
 },
 {
   "suburb": "GHERANG",
   "postcode": "3240"
 },
 {
   "suburb": "MODEWARRE",
   "postcode": "3240"
 },
 {
   "suburb": "MORIAC",
   "postcode": "3240"
 },
 {
   "suburb": "MOUNT MORIAC",
   "postcode": "3240"
 },
 {
   "suburb": "PARAPARAP",
   "postcode": "3240"
 },
 {
   "suburb": "BAMBRA",
   "postcode": "3241"
 },
 {
   "suburb": "OMBERSLEY",
   "postcode": "3241"
 },
 {
   "suburb": "WENSLEYDALE",
   "postcode": "3241"
 },
 {
   "suburb": "WINCHELSEA",
   "postcode": "3241"
 },
 {
   "suburb": "WINCHELSEA SOUTH",
   "postcode": "3241"
 },
 {
   "suburb": "WURDIBOLUC",
   "postcode": "3241"
 },
 {
   "suburb": "BIRREGURRA",
   "postcode": "3242"
 },
 {
   "suburb": "BARWON DOWNS",
   "postcode": "3243"
 },
 {
   "suburb": "MURROON",
   "postcode": "3243"
 },
 {
   "suburb": "WARNCOORT",
   "postcode": "3243"
 },
 {
   "suburb": "WHOOREL",
   "postcode": "3243"
 },
 {
   "suburb": "ALVIE",
   "postcode": "3249"
 },
 {
   "suburb": "BALINTORE",
   "postcode": "3249"
 },
 {
   "suburb": "BARONGAROOK",
   "postcode": "3249"
 },
 {
   "suburb": "BARONGAROOK WEST",
   "postcode": "3249"
 },
 {
   "suburb": "BARRAMUNGA",
   "postcode": "3249"
 },
 {
   "suburb": "CORAGULAC",
   "postcode": "3249"
 },
 {
   "suburb": "CORUNNUN",
   "postcode": "3249"
 },
 {
   "suburb": "DREEITE",
   "postcode": "3249"
 },
 {
   "suburb": "DREEITE SOUTH",
   "postcode": "3249"
 },
 {
   "suburb": "GERANGAMETE",
   "postcode": "3249"
 },
 {
   "suburb": "IRREWARRA",
   "postcode": "3249"
 },
 {
   "suburb": "IRREWILLIPE",
   "postcode": "3249"
 },
 {
   "suburb": "IRREWILLIPE EAST",
   "postcode": "3249"
 },
 {
   "suburb": "KAWARREN",
   "postcode": "3249"
 },
 {
   "suburb": "LARPENT",
   "postcode": "3249"
 },
 {
   "suburb": "NALANGIL",
   "postcode": "3249"
 },
 {
   "suburb": "ONDIT",
   "postcode": "3249"
 },
 {
   "suburb": "PIRRON YALLOCK",
   "postcode": "3249"
 },
 {
   "suburb": "POMBORNEIT EAST",
   "postcode": "3249"
 },
 {
   "suburb": "SWAN MARSH",
   "postcode": "3249"
 },
 {
   "suburb": "TANYBRYN",
   "postcode": "3249"
 },
 {
   "suburb": "WARRION",
   "postcode": "3249"
 },
 {
   "suburb": "WOOL WOOL",
   "postcode": "3249"
 },
 {
   "suburb": "YEO",
   "postcode": "3249"
 },
 {
   "suburb": "YEODENE",
   "postcode": "3249"
 },
 {
   "suburb": "COLAC",
   "postcode": "3250"
 },
 {
   "suburb": "COLAC EAST",
   "postcode": "3250"
 },
 {
   "suburb": "COLAC WEST",
   "postcode": "3250"
 },
 {
   "suburb": "ELLIMINYT",
   "postcode": "3250"
 },
 {
   "suburb": "BEEAC",
   "postcode": "3251"
 },
 {
   "suburb": "CUNDARE",
   "postcode": "3251"
 },
 {
   "suburb": "CUNDARE NORTH",
   "postcode": "3251"
 },
 {
   "suburb": "EURACK",
   "postcode": "3251"
 },
 {
   "suburb": "WEERING",
   "postcode": "3251"
 },
 {
   "suburb": "COROROOKE",
   "postcode": "3254"
 },
 {
   "suburb": "BOOKAAR",
   "postcode": "3260"
 },
 {
   "suburb": "BOSTOCKS CREEK",
   "postcode": "3260"
 },
 {
   "suburb": "BUNGADOR",
   "postcode": "3260"
 },
 {
   "suburb": "CAMPERDOWN",
   "postcode": "3260"
 },
 {
   "suburb": "CARPENDEIT",
   "postcode": "3260"
 },
 {
   "suburb": "CHOCOLYN",
   "postcode": "3260"
 },
 {
   "suburb": "GNOTUK",
   "postcode": "3260"
 },
 {
   "suburb": "KARIAH",
   "postcode": "3260"
 },
 {
   "suburb": "KOALLAH",
   "postcode": "3260"
 },
 {
   "suburb": "LESLIE MANOR",
   "postcode": "3260"
 },
 {
   "suburb": "POMBORNEIT",
   "postcode": "3260"
 },
 {
   "suburb": "POMBORNEIT NORTH",
   "postcode": "3260"
 },
 {
   "suburb": "SKIBO",
   "postcode": "3260"
 },
 {
   "suburb": "SOUTH PURRUMBETE",
   "postcode": "3260"
 },
 {
   "suburb": "STONYFORD",
   "postcode": "3260"
 },
 {
   "suburb": "TANDAROOK",
   "postcode": "3260"
 },
 {
   "suburb": "TESBURY",
   "postcode": "3260"
 },
 {
   "suburb": "WEERITE",
   "postcode": "3260"
 },
 {
   "suburb": "TERANG",
   "postcode": "3264"
 },
 {
   "suburb": "BOORCAN",
   "postcode": "3265"
 },
 {
   "suburb": "CUDGEE",
   "postcode": "3265"
 },
 {
   "suburb": "DIXIE",
   "postcode": "3265"
 },
 {
   "suburb": "ECKLIN SOUTH",
   "postcode": "3265"
 },
 {
   "suburb": "ELLERSLIE",
   "postcode": "3265"
 },
 {
   "suburb": "FRAMLINGHAM",
   "postcode": "3265"
 },
 {
   "suburb": "FRAMLINGHAM EAST",
   "postcode": "3265"
 },
 {
   "suburb": "GARVOC",
   "postcode": "3265"
 },
 {
   "suburb": "GLENORMISTON NORTH",
   "postcode": "3265"
 },
 {
   "suburb": "GLENORMISTON SOUTH",
   "postcode": "3265"
 },
 {
   "suburb": "KOLORA",
   "postcode": "3265"
 },
 {
   "suburb": "LAANG",
   "postcode": "3265"
 },
 {
   "suburb": "NOORAT",
   "postcode": "3265"
 },
 {
   "suburb": "NOORAT EAST",
   "postcode": "3265"
 },
 {
   "suburb": "PANMURE",
   "postcode": "3265"
 },
 {
   "suburb": "TAROON",
   "postcode": "3265"
 },
 {
   "suburb": "THE SISTERS",
   "postcode": "3265"
 },
 {
   "suburb": "BULLAHARRE",
   "postcode": "3266"
 },
 {
   "suburb": "COBDEN",
   "postcode": "3266"
 },
 {
   "suburb": "COBRICO",
   "postcode": "3266"
 },
 {
   "suburb": "ELINGAMITE",
   "postcode": "3266"
 },
 {
   "suburb": "ELINGAMITE NORTH",
   "postcode": "3266"
 },
 {
   "suburb": "GLENFYNE",
   "postcode": "3266"
 },
 {
   "suburb": "JANCOURT",
   "postcode": "3266"
 },
 {
   "suburb": "JANCOURT EAST",
   "postcode": "3266"
 },
 {
   "suburb": "NAROGHID",
   "postcode": "3266"
 },
 {
   "suburb": "SIMPSON",
   "postcode": "3266"
 },
 {
   "suburb": "SCOTTS CREEK",
   "postcode": "3267"
 },
 {
   "suburb": "AYRFORD",
   "postcode": "3268"
 },
 {
   "suburb": "BRUCKNELL",
   "postcode": "3268"
 },
 {
   "suburb": "COORIEMUNGLE",
   "postcode": "3268"
 },
 {
   "suburb": "COWLEYS CREEK",
   "postcode": "3268"
 },
 {
   "suburb": "CURDIES RIVER",
   "postcode": "3268"
 },
 {
   "suburb": "CURDIEVALE",
   "postcode": "3268"
 },
 {
   "suburb": "HEYTESBURY LOWER",
   "postcode": "3268"
 },
 {
   "suburb": "NEWFIELD",
   "postcode": "3268"
 },
 {
   "suburb": "NIRRANDA",
   "postcode": "3268"
 },
 {
   "suburb": "NIRRANDA EAST",
   "postcode": "3268"
 },
 {
   "suburb": "NIRRANDA SOUTH",
   "postcode": "3268"
 },
 {
   "suburb": "NULLAWARRE",
   "postcode": "3268"
 },
 {
   "suburb": "NULLAWARRE NORTH",
   "postcode": "3268"
 },
 {
   "suburb": "PAARATTE",
   "postcode": "3268"
 },
 {
   "suburb": "THE COVE",
   "postcode": "3268"
 },
 {
   "suburb": "TIMBOON",
   "postcode": "3268"
 },
 {
   "suburb": "TIMBOON WEST",
   "postcode": "3268"
 },
 {
   "suburb": "PORT CAMPBELL",
   "postcode": "3269"
 },
 {
   "suburb": "PRINCETOWN",
   "postcode": "3269"
 },
 {
   "suburb": "WAARRE",
   "postcode": "3269"
 },
 {
   "suburb": "PETERBOROUGH",
   "postcode": "3270"
 },
 {
   "suburb": "DARLINGTON",
   "postcode": "3271"
 },
 {
   "suburb": "DUNDONNELL",
   "postcode": "3271"
 },
 {
   "suburb": "PURA PURA",
   "postcode": "3271"
 },
 {
   "suburb": "MORTLAKE",
   "postcode": "3272"
 },
 {
   "suburb": "WOORNDOO",
   "postcode": "3272"
 },
 {
   "suburb": "HEXHAM",
   "postcode": "3273"
 },
 {
   "suburb": "CARAMUT",
   "postcode": "3274"
 },
 {
   "suburb": "MAILER FLAT",
   "postcode": "3275"
 },
 {
   "suburb": "MAILORS FLAT",
   "postcode": "3275"
 },
 {
   "suburb": "MINJAH",
   "postcode": "3276"
 },
 {
   "suburb": "WOOLSTHORPE",
   "postcode": "3276"
 },
 {
   "suburb": "ALLANSFORD",
   "postcode": "3277"
 },
 {
   "suburb": "MEPUNGA",
   "postcode": "3277"
 },
 {
   "suburb": "MEPUNGA EAST",
   "postcode": "3277"
 },
 {
   "suburb": "MEPUNGA WEST",
   "postcode": "3277"
 },
 {
   "suburb": "NARINGAL",
   "postcode": "3277"
 },
 {
   "suburb": "NARINGAL EAST",
   "postcode": "3277"
 },
 {
   "suburb": "PURNIM",
   "postcode": "3278"
 },
 {
   "suburb": "PURNIM WEST",
   "postcode": "3278"
 },
 {
   "suburb": "BALLANGEICH",
   "postcode": "3279"
 },
 {
   "suburb": "WANGOOM",
   "postcode": "3279"
 },
 {
   "suburb": "DENNINGTON",
   "postcode": "3280"
 },
 {
   "suburb": "WARRNAMBOOL",
   "postcode": "3280"
 },
 {
   "suburb": "BUSHFIELD",
   "postcode": "3281"
 },
 {
   "suburb": "GRASSMERE",
   "postcode": "3281"
 },
 {
   "suburb": "WINSLOW",
   "postcode": "3281"
 },
 {
   "suburb": "WOODFORD",
   "postcode": "3281"
 },
 {
   "suburb": "ILLOWA",
   "postcode": "3282"
 },
 {
   "suburb": "KOROIT",
   "postcode": "3282"
 },
 {
   "suburb": "MAILORS FLAT",
   "postcode": "3282"
 },
 {
   "suburb": "CROSSLEY",
   "postcode": "3283"
 },
 {
   "suburb": "KILLARNEY",
   "postcode": "3283"
 },
 {
   "suburb": "KIRKSTALL",
   "postcode": "3283"
 },
 {
   "suburb": "SOUTHERN CROSS",
   "postcode": "3283"
 },
 {
   "suburb": "TARRONE",
   "postcode": "3283"
 },
 {
   "suburb": "TOWER HILL",
   "postcode": "3283"
 },
 {
   "suburb": "WARRONG",
   "postcode": "3283"
 },
 {
   "suburb": "WILLATOOK",
   "postcode": "3283"
 },
 {
   "suburb": "YANGERY",
   "postcode": "3283"
 },
 {
   "suburb": "YARPTURK",
   "postcode": "3283"
 },
 {
   "suburb": "ORFORD",
   "postcode": "3284"
 },
 {
   "suburb": "PORT FAIRY",
   "postcode": "3284"
 },
 {
   "suburb": "CODRINGTON",
   "postcode": "3285"
 },
 {
   "suburb": "NARRAWONG",
   "postcode": "3285"
 },
 {
   "suburb": "ROSEBROOK",
   "postcode": "3285"
 },
 {
   "suburb": "ST HELENS",
   "postcode": "3285"
 },
 {
   "suburb": "TOOLONG",
   "postcode": "3285"
 },
 {
   "suburb": "TYRENDARRA",
   "postcode": "3285"
 },
 {
   "suburb": "TYRENDARRA EAST",
   "postcode": "3285"
 },
 {
   "suburb": "YAMBUK",
   "postcode": "3285"
 },
 {
   "suburb": "CONDAH SWAMP",
   "postcode": "3286"
 },
 {
   "suburb": "KNEBSWORTH",
   "postcode": "3286"
 },
 {
   "suburb": "MACARTHUR",
   "postcode": "3286"
 },
 {
   "suburb": "WARRABKOOK",
   "postcode": "3286"
 },
 {
   "suburb": "HAWKESDALE",
   "postcode": "3287"
 },
 {
   "suburb": "MINHAMITE",
   "postcode": "3287"
 },
 {
   "suburb": "GAZETTE",
   "postcode": "3289"
 },
 {
   "suburb": "GERRIGERRUP",
   "postcode": "3289"
 },
 {
   "suburb": "PENSHURST",
   "postcode": "3289"
 },
 {
   "suburb": "PURDEET",
   "postcode": "3289"
 },
 {
   "suburb": "TABOR",
   "postcode": "3289"
 },
 {
   "suburb": "GLENTHOMPSON",
   "postcode": "3293"
 },
 {
   "suburb": "NAREEB",
   "postcode": "3293"
 },
 {
   "suburb": "NARRAPUMELAP SOUTH",
   "postcode": "3293"
 },
 {
   "suburb": "DUNKELD",
   "postcode": "3294"
 },
 {
   "suburb": "WOODHOUSE",
   "postcode": "3294"
 },
 {
   "suburb": "BYADUK NORTH",
   "postcode": "3300"
 },
 {
   "suburb": "HAMILTON",
   "postcode": "3300"
 },
 {
   "suburb": "BOCHARA",
   "postcode": "3301"
 },
 {
   "suburb": "BROADWATER",
   "postcode": "3301"
 },
 {
   "suburb": "BUCKLEY SWAMP",
   "postcode": "3301"
 },
 {
   "suburb": "BYADUK",
   "postcode": "3301"
 },
 {
   "suburb": "CROXTON EAST",
   "postcode": "3301"
 },
 {
   "suburb": "HENSLEY PARK",
   "postcode": "3301"
 },
 {
   "suburb": "MORGIANA",
   "postcode": "3301"
 },
 {
   "suburb": "MOUNT NAPIER",
   "postcode": "3301"
 },
 {
   "suburb": "STRATHKELLAR",
   "postcode": "3301"
 },
 {
   "suburb": "TARRINGTON",
   "postcode": "3301"
 },
 {
   "suburb": "WARRAYURE",
   "postcode": "3301"
 },
 {
   "suburb": "YATCHAW",
   "postcode": "3301"
 },
 {
   "suburb": "YULECART",
   "postcode": "3301"
 },
 {
   "suburb": "BRANXHOLME",
   "postcode": "3302"
 },
 {
   "suburb": "BREAKAWAY CREEK",
   "postcode": "3303"
 },
 {
   "suburb": "CONDAH",
   "postcode": "3303"
 },
 {
   "suburb": "LAKE CONDAH",
   "postcode": "3303"
 },
 {
   "suburb": "WALLACEDALE",
   "postcode": "3303"
 },
 {
   "suburb": "BESSIEBELLE",
   "postcode": "3304"
 },
 {
   "suburb": "DRUMBORG",
   "postcode": "3304"
 },
 {
   "suburb": "HEYWOOD",
   "postcode": "3304"
 },
 {
   "suburb": "HOMERTON",
   "postcode": "3304"
 },
 {
   "suburb": "MILLTOWN",
   "postcode": "3304"
 },
 {
   "suburb": "MYAMYN",
   "postcode": "3304"
 },
 {
   "suburb": "ALLESTREE",
   "postcode": "3305"
 },
 {
   "suburb": "BOLWARRA",
   "postcode": "3305"
 },
 {
   "suburb": "CAPE BRIDGEWATER",
   "postcode": "3305"
 },
 {
   "suburb": "CASHMORE",
   "postcode": "3305"
 },
 {
   "suburb": "DUTTON WAY",
   "postcode": "3305"
 },
 {
   "suburb": "GORAE",
   "postcode": "3305"
 },
 {
   "suburb": "GORAE WEST",
   "postcode": "3305"
 },
 {
   "suburb": "HEATHMERE",
   "postcode": "3305"
 },
 {
   "suburb": "PORTLAND",
   "postcode": "3305"
 },
 {
   "suburb": "PORTLAND NORTH",
   "postcode": "3305"
 },
 {
   "suburb": "PORTLAND WEST",
   "postcode": "3305"
 },
 {
   "suburb": "HESSE",
   "postcode": "3321"
 },
 {
   "suburb": "INVERLEIGH",
   "postcode": "3321"
 },
 {
   "suburb": "WINGEEL",
   "postcode": "3321"
 },
 {
   "suburb": "CRESSY",
   "postcode": "3322"
 },
 {
   "suburb": "BERRYBANK",
   "postcode": "3323"
 },
 {
   "suburb": "DUVERNEY",
   "postcode": "3323"
 },
 {
   "suburb": "FOXHOW",
   "postcode": "3323"
 },
 {
   "suburb": "LISMORE",
   "postcode": "3324"
 },
 {
   "suburb": "MINGAY",
   "postcode": "3324"
 },
 {
   "suburb": "MOUNT BUTE",
   "postcode": "3324"
 },
 {
   "suburb": "DERRINALLUM",
   "postcode": "3325"
 },
 {
   "suburb": "LARRALEA",
   "postcode": "3325"
 },
 {
   "suburb": "VITE VITE",
   "postcode": "3325"
 },
 {
   "suburb": "VITE VITE NORTH",
   "postcode": "3325"
 },
 {
   "suburb": "TEESDALE",
   "postcode": "3328"
 },
 {
   "suburb": "BARUNAH PARK",
   "postcode": "3329"
 },
 {
   "suburb": "BARUNAH PLAINS",
   "postcode": "3329"
 },
 {
   "suburb": "SHELFORD",
   "postcode": "3329"
 },
 {
   "suburb": "ROKEWOOD",
   "postcode": "3330"
 },
 {
   "suburb": "BANNOCKBURN",
   "postcode": "3331"
 },
 {
   "suburb": "GHERINGHAP",
   "postcode": "3331"
 },
 {
   "suburb": "MAUDE",
   "postcode": "3331"
 },
 {
   "suburb": "RUSSELLS BRIDGE",
   "postcode": "3331"
 },
 {
   "suburb": "SHE OAKS",
   "postcode": "3331"
 },
 {
   "suburb": "STEIGLITZ",
   "postcode": "3331"
 },
 {
   "suburb": "SUTHERLANDS CREEK",
   "postcode": "3331"
 },
 {
   "suburb": "LETHBRIDGE",
   "postcode": "3332"
 },
 {
   "suburb": "BAMGANIE",
   "postcode": "3333"
 },
 {
   "suburb": "MEREDITH",
   "postcode": "3333"
 },
 {
   "suburb": "BUNGAL",
   "postcode": "3334"
 },
 {
   "suburb": "CARGERIE",
   "postcode": "3334"
 },
 {
   "suburb": "ELAINE",
   "postcode": "3334"
 },
 {
   "suburb": "MORRISONS",
   "postcode": "3334"
 },
 {
   "suburb": "MOUNT DORAN",
   "postcode": "3334"
 },
 {
   "suburb": "BONNIE BROOK",
   "postcode": "3335"
 },
 {
   "suburb": "PLUMPTON",
   "postcode": "3335"
 },
 {
   "suburb": "ROCKBANK",
   "postcode": "3335"
 },
 {
   "suburb": "THORNHILL PARK",
   "postcode": "3335"
 },
 {
   "suburb": "AINTREE",
   "postcode": "3336"
 },
 {
   "suburb": "DEANSIDE",
   "postcode": "3336"
 },
 {
   "suburb": "FRASER RISE",
   "postcode": "3336"
 },
 {
   "suburb": "HARKNESS",
   "postcode": "3337"
 },
 {
   "suburb": "KURUNJANG",
   "postcode": "3337"
 },
 {
   "suburb": "MELTON",
   "postcode": "3337"
 },
 {
   "suburb": "MELTON WEST",
   "postcode": "3337"
 },
 {
   "suburb": "TOOLERN VALE",
   "postcode": "3337"
 },
 {
   "suburb": "BROOKFIELD",
   "postcode": "3338"
 },
 {
   "suburb": "COBBLEBANK",
   "postcode": "3338"
 },
 {
   "suburb": "EXFORD",
   "postcode": "3338"
 },
 {
   "suburb": "EYNESBURY",
   "postcode": "3338"
 },
 {
   "suburb": "MELTON SOUTH",
   "postcode": "3338"
 },
 {
   "suburb": "STRATHTULLOH",
   "postcode": "3338"
 },
 {
   "suburb": "WEIR VIEWS",
   "postcode": "3338"
 },
 {
   "suburb": "BACCHUS MARSH",
   "postcode": "3340"
 },
 {
   "suburb": "BALLIANG",
   "postcode": "3340"
 },
 {
   "suburb": "BALLIANG EAST",
   "postcode": "3340"
 },
 {
   "suburb": "COIMADAI",
   "postcode": "3340"
 },
 {
   "suburb": "DARLEY",
   "postcode": "3340"
 },
 {
   "suburb": "GLENMORE",
   "postcode": "3340"
 },
 {
   "suburb": "HOPETOUN PARK",
   "postcode": "3340"
 },
 {
   "suburb": "LONG FOREST",
   "postcode": "3340"
 },
 {
   "suburb": "MADDINGLEY",
   "postcode": "3340"
 },
 {
   "suburb": "MERRIMU",
   "postcode": "3340"
 },
 {
   "suburb": "PARWAN",
   "postcode": "3340"
 },
 {
   "suburb": "ROWSLEY",
   "postcode": "3340"
 },
 {
   "suburb": "STAUGHTON VALE",
   "postcode": "3340"
 },
 {
   "suburb": "DALES CREEK",
   "postcode": "3341"
 },
 {
   "suburb": "GREENDALE",
   "postcode": "3341"
 },
 {
   "suburb": "KOROBEIT",
   "postcode": "3341"
 },
 {
   "suburb": "MYRNIONG",
   "postcode": "3341"
 },
 {
   "suburb": "PENTLAND HILLS",
   "postcode": "3341"
 },
 {
   "suburb": "BALLAN",
   "postcode": "3342"
 },
 {
   "suburb": "BEREMBOKE",
   "postcode": "3342"
 },
 {
   "suburb": "BLAKEVILLE",
   "postcode": "3342"
 },
 {
   "suburb": "BUNDING",
   "postcode": "3342"
 },
 {
   "suburb": "COLBROOK",
   "postcode": "3342"
 },
 {
   "suburb": "DURDIDWARRAH",
   "postcode": "3342"
 },
 {
   "suburb": "FISKVILLE",
   "postcode": "3342"
 },
 {
   "suburb": "INGLISTON",
   "postcode": "3342"
 },
 {
   "suburb": "MOUNT WALLACE",
   "postcode": "3342"
 },
 {
   "suburb": "GORDON",
   "postcode": "3345"
 },
 {
   "suburb": "ALFREDTON",
   "postcode": "3350"
 },
 {
   "suburb": "BAKERY HILL",
   "postcode": "3350"
 },
 {
   "suburb": "BALLARAT",
   "postcode": "3350"
 },
 {
   "suburb": "BALLARAT CENTRAL",
   "postcode": "3350"
 },
 {
   "suburb": "BALLARAT EAST",
   "postcode": "3350"
 },
 {
   "suburb": "BALLARAT NORTH",
   "postcode": "3350"
 },
 {
   "suburb": "BALLARAT WEST",
   "postcode": "3350"
 },
 {
   "suburb": "BLACK HILL",
   "postcode": "3350"
 },
 {
   "suburb": "BROWN HILL",
   "postcode": "3350"
 },
 {
   "suburb": "CANADIAN",
   "postcode": "3350"
 },
 {
   "suburb": "EUREKA",
   "postcode": "3350"
 },
 {
   "suburb": "GOLDEN POINT",
   "postcode": "3350"
 },
 {
   "suburb": "INVERMAY PARK",
   "postcode": "3350"
 },
 {
   "suburb": "LAKE WENDOUREE",
   "postcode": "3350"
 },
 {
   "suburb": "LUCAS",
   "postcode": "3350"
 },
 {
   "suburb": "MOUNT CLEAR",
   "postcode": "3350"
 },
 {
   "suburb": "MOUNT HELEN",
   "postcode": "3350"
 },
 {
   "suburb": "MOUNT PLEASANT",
   "postcode": "3350"
 },
 {
   "suburb": "NERRINA",
   "postcode": "3350"
 },
 {
   "suburb": "NEWINGTON",
   "postcode": "3350"
 },
 {
   "suburb": "REDAN",
   "postcode": "3350"
 },
 {
   "suburb": "SOLDIERS HILL",
   "postcode": "3350"
 },
 {
   "suburb": "BERRINGA",
   "postcode": "3351"
 },
 {
   "suburb": "BO PEEP",
   "postcode": "3351"
 },
 {
   "suburb": "CAPE CLEAR",
   "postcode": "3351"
 },
 {
   "suburb": "CARNGHAM",
   "postcode": "3351"
 },
 {
   "suburb": "CHEPSTOWE",
   "postcode": "3351"
 },
 {
   "suburb": "HADDON",
   "postcode": "3351"
 },
 {
   "suburb": "HILLCREST",
   "postcode": "3351"
 },
 {
   "suburb": "ILLABAROOK",
   "postcode": "3351"
 },
 {
   "suburb": "LAKE BOLAC",
   "postcode": "3351"
 },
 {
   "suburb": "MININERA",
   "postcode": "3351"
 },
 {
   "suburb": "MOUNT EMU",
   "postcode": "3351"
 },
 {
   "suburb": "NERRIN NERRIN",
   "postcode": "3351"
 },
 {
   "suburb": "NEWTOWN",
   "postcode": "3351"
 },
 {
   "suburb": "NINTINGBOOL",
   "postcode": "3351"
 },
 {
   "suburb": "PIGGOREET",
   "postcode": "3351"
 },
 {
   "suburb": "PITFIELD",
   "postcode": "3351"
 },
 {
   "suburb": "ROKEWOOD JUNCTION",
   "postcode": "3351"
 },
 {
   "suburb": "ROSS CREEK",
   "postcode": "3351"
 },
 {
   "suburb": "SCARSDALE",
   "postcode": "3351"
 },
 {
   "suburb": "SMYTHES CREEK",
   "postcode": "3351"
 },
 {
   "suburb": "SMYTHESDALE",
   "postcode": "3351"
 },
 {
   "suburb": "SNAKE VALLEY",
   "postcode": "3351"
 },
 {
   "suburb": "SPRINGDALLAH",
   "postcode": "3351"
 },
 {
   "suburb": "STAFFORDSHIRE REEF",
   "postcode": "3351"
 },
 {
   "suburb": "STREATHAM",
   "postcode": "3351"
 },
 {
   "suburb": "WALLINDUC",
   "postcode": "3351"
 },
 {
   "suburb": "WESTMERE",
   "postcode": "3351"
 },
 {
   "suburb": "ADDINGTON",
   "postcode": "3352"
 },
 {
   "suburb": "BLOWHARD",
   "postcode": "3352"
 },
 {
   "suburb": "BOLWARRAH",
   "postcode": "3352"
 },
 {
   "suburb": "BONSHAW",
   "postcode": "3352"
 },
 {
   "suburb": "BREWSTER",
   "postcode": "3352"
 },
 {
   "suburb": "BULLAROOK",
   "postcode": "3352"
 },
 {
   "suburb": "BUNGAREE",
   "postcode": "3352"
 },
 {
   "suburb": "BUNKERS HILL",
   "postcode": "3352"
 },
 {
   "suburb": "BURRUMBEET",
   "postcode": "3352"
 },
 {
   "suburb": "CAMBRIAN HILL",
   "postcode": "3352"
 },
 {
   "suburb": "CARDIGAN",
   "postcode": "3352"
 },
 {
   "suburb": "CARDIGAN VILLAGE",
   "postcode": "3352"
 },
 {
   "suburb": "CHAPEL FLAT",
   "postcode": "3352"
 },
 {
   "suburb": "CLARENDON",
   "postcode": "3352"
 },
 {
   "suburb": "CLARETOWN",
   "postcode": "3352"
 },
 {
   "suburb": "CLARKES HILL",
   "postcode": "3352"
 },
 {
   "suburb": "CORINDHAP",
   "postcode": "3352"
 },
 {
   "suburb": "DEREEL",
   "postcode": "3352"
 },
 {
   "suburb": "DUNNSTOWN",
   "postcode": "3352"
 },
 {
   "suburb": "DURHAM LEAD",
   "postcode": "3352"
 },
 {
   "suburb": "ENFIELD",
   "postcode": "3352"
 },
 {
   "suburb": "ERCILDOUNE",
   "postcode": "3352"
 },
 {
   "suburb": "GARIBALDI",
   "postcode": "3352"
 },
 {
   "suburb": "GLEN PARK",
   "postcode": "3352"
 },
 {
   "suburb": "GLENBRAE",
   "postcode": "3352"
 },
 {
   "suburb": "GONG GONG",
   "postcode": "3352"
 },
 {
   "suburb": "GRENVILLE",
   "postcode": "3352"
 },
 {
   "suburb": "INVERMAY",
   "postcode": "3352"
 },
 {
   "suburb": "LAL LAL",
   "postcode": "3352"
 },
 {
   "suburb": "LAMPLOUGH",
   "postcode": "3352"
 },
 {
   "suburb": "LANGI KAL KAL",
   "postcode": "3352"
 },
 {
   "suburb": "LEARMONTH",
   "postcode": "3352"
 },
 {
   "suburb": "LEIGH CREEK",
   "postcode": "3352"
 },
 {
   "suburb": "LEXTON",
   "postcode": "3352"
 },
 {
   "suburb": "MAGPIE",
   "postcode": "3352"
 },
 {
   "suburb": "MILLBROOK",
   "postcode": "3352"
 },
 {
   "suburb": "MINERS REST",
   "postcode": "3352"
 },
 {
   "suburb": "MOLLONGGHIP",
   "postcode": "3352"
 },
 {
   "suburb": "MOUNT BOLTON",
   "postcode": "3352"
 },
 {
   "suburb": "MOUNT EGERTON",
   "postcode": "3352"
 },
 {
   "suburb": "MOUNT MERCER",
   "postcode": "3352"
 },
 {
   "suburb": "MOUNT ROWAN",
   "postcode": "3352"
 },
 {
   "suburb": "MT MERCER",
   "postcode": "3352"
 },
 {
   "suburb": "NAPOLEONS",
   "postcode": "3352"
 },
 {
   "suburb": "NAVIGATORS",
   "postcode": "3352"
 },
 {
   "suburb": "POOTILLA",
   "postcode": "3352"
 },
 {
   "suburb": "SCOTCHMANS LEAD",
   "postcode": "3352"
 },
 {
   "suburb": "SCOTSBURN",
   "postcode": "3352"
 },
 {
   "suburb": "SPRINGBANK",
   "postcode": "3352"
 },
 {
   "suburb": "SULKY",
   "postcode": "3352"
 },
 {
   "suburb": "WALLACE",
   "postcode": "3352"
 },
 {
   "suburb": "WARRENHEIP",
   "postcode": "3352"
 },
 {
   "suburb": "WATTLE FLAT",
   "postcode": "3352"
 },
 {
   "suburb": "WAUBRA",
   "postcode": "3352"
 },
 {
   "suburb": "WEATHERBOARD",
   "postcode": "3352"
 },
 {
   "suburb": "WERNETH",
   "postcode": "3352"
 },
 {
   "suburb": "WINDERMERE",
   "postcode": "3352"
 },
 {
   "suburb": "YENDON",
   "postcode": "3352"
 },
 {
   "suburb": "LAKE GARDENS",
   "postcode": "3355"
 },
 {
   "suburb": "MITCHELL PARK",
   "postcode": "3355"
 },
 {
   "suburb": "WENDOUREE",
   "postcode": "3355"
 },
 {
   "suburb": "WENDOUREE VILLAGE",
   "postcode": "3355"
 },
 {
   "suburb": "DELACOMBE",
   "postcode": "3356"
 },
 {
   "suburb": "SEBASTOPOL",
   "postcode": "3356"
 },
 {
   "suburb": "BUNINYONG",
   "postcode": "3357"
 },
 {
   "suburb": "WINTER VALLEY",
   "postcode": "3358"
 },
 {
   "suburb": "HAPPY VALLEY",
   "postcode": "3360"
 },
 {
   "suburb": "LINTON",
   "postcode": "3360"
 },
 {
   "suburb": "MANNIBADAR",
   "postcode": "3360"
 },
 {
   "suburb": "PITTONG",
   "postcode": "3360"
 },
 {
   "suburb": "WILLOWVALE",
   "postcode": "3360"
 },
 {
   "suburb": "BRADVALE",
   "postcode": "3361"
 },
 {
   "suburb": "CARRANBALLAC",
   "postcode": "3361"
 },
 {
   "suburb": "SKIPTON",
   "postcode": "3361"
 },
 {
   "suburb": "CRESWICK",
   "postcode": "3363"
 },
 {
   "suburb": "CRESWICK NORTH",
   "postcode": "3363"
 },
 {
   "suburb": "DEAN",
   "postcode": "3363"
 },
 {
   "suburb": "GLENDARUEL",
   "postcode": "3363"
 },
 {
   "suburb": "LANGDONS HILL",
   "postcode": "3363"
 },
 {
   "suburb": "MOUNT BECKWORTH",
   "postcode": "3363"
 },
 {
   "suburb": "TOURELLO",
   "postcode": "3363"
 },
 {
   "suburb": "ALLENDALE",
   "postcode": "3364"
 },
 {
   "suburb": "ASCOT",
   "postcode": "3364"
 },
 {
   "suburb": "BALD HILLS",
   "postcode": "3364"
 },
 {
   "suburb": "BARKSTEAD",
   "postcode": "3364"
 },
 {
   "suburb": "BLAMPIED",
   "postcode": "3364"
 },
 {
   "suburb": "BROOMFIELD",
   "postcode": "3364"
 },
 {
   "suburb": "CABBAGE TREE",
   "postcode": "3364"
 },
 {
   "suburb": "CAMPBELLTOWN",
   "postcode": "3364"
 },
 {
   "suburb": "COGHILLS CREEK",
   "postcode": "3364"
 },
 {
   "suburb": "GLENDONALD",
   "postcode": "3364"
 },
 {
   "suburb": "JOYCES CREEK",
   "postcode": "3364"
 },
 {
   "suburb": "KINGSTON",
   "postcode": "3364"
 },
 {
   "suburb": "KOOROOCHEANG",
   "postcode": "3364"
 },
 {
   "suburb": "LAWRENCE",
   "postcode": "3364"
 },
 {
   "suburb": "MOUNT PROSPECT",
   "postcode": "3364"
 },
 {
   "suburb": "NEWLYN",
   "postcode": "3364"
 },
 {
   "suburb": "NEWLYN NORTH",
   "postcode": "3364"
 },
 {
   "suburb": "ROCKLYN",
   "postcode": "3364"
 },
 {
   "suburb": "SMEATON",
   "postcode": "3364"
 },
 {
   "suburb": "SMOKEYTOWN",
   "postcode": "3364"
 },
 {
   "suburb": "SPRINGMOUNT",
   "postcode": "3364"
 },
 {
   "suburb": "STRATHLEA",
   "postcode": "3364"
 },
 {
   "suburb": "WERONA",
   "postcode": "3364"
 },
 {
   "suburb": "CLUNES",
   "postcode": "3370"
 },
 {
   "suburb": "GLENGOWER",
   "postcode": "3370"
 },
 {
   "suburb": "MOUNT CAMERON",
   "postcode": "3370"
 },
 {
   "suburb": "ULLINA",
   "postcode": "3370"
 },
 {
   "suburb": "AMHERST",
   "postcode": "3371"
 },
 {
   "suburb": "BURNBANK",
   "postcode": "3371"
 },
 {
   "suburb": "CARALULUP",
   "postcode": "3371"
 },
 {
   "suburb": "DUNACH",
   "postcode": "3371"
 },
 {
   "suburb": "EVANSFORD",
   "postcode": "3371"
 },
 {
   "suburb": "LILLICUR",
   "postcode": "3371"
 },
 {
   "suburb": "MOUNT GLASGOW",
   "postcode": "3371"
 },
 {
   "suburb": "RED LION",
   "postcode": "3371"
 },
 {
   "suburb": "STONY CREEK",
   "postcode": "3371"
 },
 {
   "suburb": "TALBOT",
   "postcode": "3371"
 },
 {
   "suburb": "BEAUFORT",
   "postcode": "3373"
 },
 {
   "suburb": "CHUTE",
   "postcode": "3373"
 },
 {
   "suburb": "CROSS ROADS",
   "postcode": "3373"
 },
 {
   "suburb": "LAKE GOLDSMITH",
   "postcode": "3373"
 },
 {
   "suburb": "LAKE WONGAN",
   "postcode": "3373"
 },
 {
   "suburb": "MAIN LEAD",
   "postcode": "3373"
 },
 {
   "suburb": "MENA PARK",
   "postcode": "3373"
 },
 {
   "suburb": "NERRING",
   "postcode": "3373"
 },
 {
   "suburb": "RAGLAN",
   "postcode": "3373"
 },
 {
   "suburb": "STOCKYARD HILL",
   "postcode": "3373"
 },
 {
   "suburb": "STONELEIGH",
   "postcode": "3373"
 },
 {
   "suburb": "TRAWALLA",
   "postcode": "3373"
 },
 {
   "suburb": "WATERLOO",
   "postcode": "3373"
 },
 {
   "suburb": "GREAT WESTERN",
   "postcode": "3374"
 },
 {
   "suburb": "BALLYROGAN",
   "postcode": "3375"
 },
 {
   "suburb": "BAYINDEEN",
   "postcode": "3375"
 },
 {
   "suburb": "BUANGOR",
   "postcode": "3375"
 },
 {
   "suburb": "MIDDLE CREEK",
   "postcode": "3375"
 },
 {
   "suburb": "ARARAT",
   "postcode": "3377"
 },
 {
   "suburb": "ARMSTRONG",
   "postcode": "3377"
 },
 {
   "suburb": "BULGANA",
   "postcode": "3377"
 },
 {
   "suburb": "CATHCART",
   "postcode": "3377"
 },
 {
   "suburb": "CROWLANDS",
   "postcode": "3377"
 },
 {
   "suburb": "DENICULL CREEK",
   "postcode": "3377"
 },
 {
   "suburb": "DOBIE",
   "postcode": "3377"
 },
 {
   "suburb": "DUNNEWORTHY",
   "postcode": "3377"
 },
 {
   "suburb": "EVERSLEY",
   "postcode": "3377"
 },
 {
   "suburb": "LANGI LOGAN",
   "postcode": "3377"
 },
 {
   "suburb": "MAROONA",
   "postcode": "3377"
 },
 {
   "suburb": "MOUNT COLE",
   "postcode": "3377"
 },
 {
   "suburb": "MOUNT COLE CREEK",
   "postcode": "3377"
 },
 {
   "suburb": "MOYSTON",
   "postcode": "3377"
 },
 {
   "suburb": "NORVAL",
   "postcode": "3377"
 },
 {
   "suburb": "RHYMNEY",
   "postcode": "3377"
 },
 {
   "suburb": "ROCKY POINT",
   "postcode": "3377"
 },
 {
   "suburb": "ROSSBRIDGE",
   "postcode": "3377"
 },
 {
   "suburb": "SHAYS FLAT",
   "postcode": "3377"
 },
 {
   "suburb": "WARRAK",
   "postcode": "3377"
 },
 {
   "suburb": "TATYOON",
   "postcode": "3378"
 },
 {
   "suburb": "YALLA-Y-POORA",
   "postcode": "3378"
 },
 {
   "suburb": "BERRAMBOOL",
   "postcode": "3379"
 },
 {
   "suburb": "BORNES HILL",
   "postcode": "3379"
 },
 {
   "suburb": "CHATSWORTH",
   "postcode": "3379"
 },
 {
   "suburb": "STAVELY",
   "postcode": "3379"
 },
 {
   "suburb": "WICKLIFFE",
   "postcode": "3379"
 },
 {
   "suburb": "WILLAURA",
   "postcode": "3379"
 },
 {
   "suburb": "WILLAURA NORTH",
   "postcode": "3379"
 },
 {
   "suburb": "STAWELL",
   "postcode": "3380"
 },
 {
   "suburb": "STAWELL WEST",
   "postcode": "3380"
 },
 {
   "suburb": "BELLELLEN",
   "postcode": "3381"
 },
 {
   "suburb": "BELLFIELD",
   "postcode": "3381"
 },
 {
   "suburb": "BLACK RANGE",
   "postcode": "3381"
 },
 {
   "suburb": "FYANS CREEK",
   "postcode": "3381"
 },
 {
   "suburb": "HALLS GAP",
   "postcode": "3381"
 },
 {
   "suburb": "ILLAWARRA",
   "postcode": "3381"
 },
 {
   "suburb": "LAKE FYANS",
   "postcode": "3381"
 },
 {
   "suburb": "LAKE LONSDALE",
   "postcode": "3381"
 },
 {
   "suburb": "MOKEPILLY",
   "postcode": "3381"
 },
 {
   "suburb": "MOUNT DRYDEN",
   "postcode": "3381"
 },
 {
   "suburb": "POMONAL",
   "postcode": "3381"
 },
 {
   "suburb": "CONCONGELLA",
   "postcode": "3384"
 },
 {
   "suburb": "FRENCHMANS",
   "postcode": "3384"
 },
 {
   "suburb": "JOEL JOEL",
   "postcode": "3384"
 },
 {
   "suburb": "JOEL SOUTH",
   "postcode": "3384"
 },
 {
   "suburb": "LANDSBOROUGH",
   "postcode": "3384"
 },
 {
   "suburb": "LANDSBOROUGH WEST",
   "postcode": "3384"
 },
 {
   "suburb": "WATTLE CREEK",
   "postcode": "3384"
 },
 {
   "suburb": "DADSWELLS BRIDGE",
   "postcode": "3385"
 },
 {
   "suburb": "DEEP LEAD",
   "postcode": "3385"
 },
 {
   "suburb": "GLENORCHY",
   "postcode": "3385"
 },
 {
   "suburb": "LEDCOURT",
   "postcode": "3385"
 },
 {
   "suburb": "ROSES GAP",
   "postcode": "3385"
 },
 {
   "suburb": "GERMANIA",
   "postcode": "3387"
 },
 {
   "suburb": "HORSHAM",
   "postcode": "3400"
 },
 {
   "suburb": "BUNGALALLY",
   "postcode": "3401"
 },
 {
   "suburb": "DOOEN",
   "postcode": "3401"
 },
 {
   "suburb": "DRUNG",
   "postcode": "3401"
 },
 {
   "suburb": "HAVEN",
   "postcode": "3401"
 },
 {
   "suburb": "LAHARUM",
   "postcode": "3401"
 },
 {
   "suburb": "LOWER NORTON",
   "postcode": "3401"
 },
 {
   "suburb": "MCKENZIE CREEK",
   "postcode": "3401"
 },
 {
   "suburb": "QUANTONG",
   "postcode": "3401"
 },
 {
   "suburb": "RIVERSIDE",
   "postcode": "3401"
 },
 {
   "suburb": "VECTIS",
   "postcode": "3401"
 },
 {
   "suburb": "WARTOOK",
   "postcode": "3401"
 },
 {
   "suburb": "NATIMUK",
   "postcode": "3409"
 },
 {
   "suburb": "DIGGERS REST",
   "postcode": "3427"
 },
 {
   "suburb": "BULLA",
   "postcode": "3428"
 },
 {
   "suburb": "SUNBURY",
   "postcode": "3429"
 },
 {
   "suburb": "WILDWOOD",
   "postcode": "3429"
 },
 {
   "suburb": "CLARKEFIELD",
   "postcode": "3430"
 },
 {
   "suburb": "RIDDELLS CREEK",
   "postcode": "3431"
 },
 {
   "suburb": "BOLINDA",
   "postcode": "3432"
 },
 {
   "suburb": "MONEGEETTA",
   "postcode": "3433"
 },
 {
   "suburb": "CHEROKEE",
   "postcode": "3434"
 },
 {
   "suburb": "KERRIE",
   "postcode": "3434"
 },
 {
   "suburb": "ROMSEY",
   "postcode": "3434"
 },
 {
   "suburb": "SPRINGFIELD",
   "postcode": "3434"
 },
 {
   "suburb": "BENLOCH",
   "postcode": "3435"
 },
 {
   "suburb": "GOLDIE",
   "postcode": "3435"
 },
 {
   "suburb": "LANCEFIELD",
   "postcode": "3435"
 },
 {
   "suburb": "NULLA VALE",
   "postcode": "3435"
 },
 {
   "suburb": "BULLENGAROOK",
   "postcode": "3437"
 },
 {
   "suburb": "GISBORNE",
   "postcode": "3437"
 },
 {
   "suburb": "GISBORNE SOUTH",
   "postcode": "3437"
 },
 {
   "suburb": "NEW GISBORNE",
   "postcode": "3438"
 },
 {
   "suburb": "MACEDON",
   "postcode": "3440"
 },
 {
   "suburb": "MOUNT MACEDON",
   "postcode": "3441"
 },
 {
   "suburb": "ASHBOURNE",
   "postcode": "3442"
 },
 {
   "suburb": "CADELLO",
   "postcode": "3442"
 },
 {
   "suburb": "CARLSRUHE",
   "postcode": "3442"
 },
 {
   "suburb": "COBAW",
   "postcode": "3442"
 },
 {
   "suburb": "HESKET",
   "postcode": "3442"
 },
 {
   "suburb": "NEWHAM",
   "postcode": "3442"
 },
 {
   "suburb": "ROCHFORD",
   "postcode": "3442"
 },
 {
   "suburb": "WOODEND",
   "postcode": "3442"
 },
 {
   "suburb": "WOODEND NORTH",
   "postcode": "3442"
 },
 {
   "suburb": "BARFOLD",
   "postcode": "3444"
 },
 {
   "suburb": "BAYNTON",
   "postcode": "3444"
 },
 {
   "suburb": "BAYNTON EAST",
   "postcode": "3444"
 },
 {
   "suburb": "EDGECOMBE",
   "postcode": "3444"
 },
 {
   "suburb": "GLENHOPE",
   "postcode": "3444"
 },
 {
   "suburb": "GREENHILL",
   "postcode": "3444"
 },
 {
   "suburb": "KYNETON",
   "postcode": "3444"
 },
 {
   "suburb": "KYNETON SOUTH",
   "postcode": "3444"
 },
 {
   "suburb": "LANGLEY",
   "postcode": "3444"
 },
 {
   "suburb": "LAURISTON",
   "postcode": "3444"
 },
 {
   "suburb": "LYAL",
   "postcode": "3444"
 },
 {
   "suburb": "METCALFE EAST",
   "postcode": "3444"
 },
 {
   "suburb": "MIA MIA",
   "postcode": "3444"
 },
 {
   "suburb": "PASTORIA",
   "postcode": "3444"
 },
 {
   "suburb": "PASTORIA EAST",
   "postcode": "3444"
 },
 {
   "suburb": "PIPERS CREEK",
   "postcode": "3444"
 },
 {
   "suburb": "REDESDALE",
   "postcode": "3444"
 },
 {
   "suburb": "SIDONIA",
   "postcode": "3444"
 },
 {
   "suburb": "SPRING HILL",
   "postcode": "3444"
 },
 {
   "suburb": "TYLDEN",
   "postcode": "3444"
 },
 {
   "suburb": "TYLDEN SOUTH",
   "postcode": "3444"
 },
 {
   "suburb": "DRUMMOND NORTH",
   "postcode": "3446"
 },
 {
   "suburb": "MALMSBURY",
   "postcode": "3446"
 },
 {
   "suburb": "TARADALE",
   "postcode": "3447"
 },
 {
   "suburb": "ELPHINSTONE",
   "postcode": "3448"
 },
 {
   "suburb": "METCALFE",
   "postcode": "3448"
 },
 {
   "suburb": "SUTTON GRANGE",
   "postcode": "3448"
 },
 {
   "suburb": "CASTLEMAINE",
   "postcode": "3450"
 },
 {
   "suburb": "MOONLIGHT FLAT",
   "postcode": "3450"
 },
 {
   "suburb": "BARKERS CREEK",
   "postcode": "3451"
 },
 {
   "suburb": "CAMPBELLS CREEK",
   "postcode": "3451"
 },
 {
   "suburb": "CHEWTON",
   "postcode": "3451"
 },
 {
   "suburb": "CHEWTON BUSHLANDS",
   "postcode": "3451"
 },
 {
   "suburb": "FARADAY",
   "postcode": "3451"
 },
 {
   "suburb": "FRYERSTOWN",
   "postcode": "3451"
 },
 {
   "suburb": "GLENLUCE",
   "postcode": "3451"
 },
 {
   "suburb": "GOLDEN POINT",
   "postcode": "3451"
 },
 {
   "suburb": "GUILDFORD",
   "postcode": "3451"
 },
 {
   "suburb": "IRISHTOWN",
   "postcode": "3451"
 },
 {
   "suburb": "MCKENZIE HILL",
   "postcode": "3451"
 },
 {
   "suburb": "MUCKLEFORD",
   "postcode": "3451"
 },
 {
   "suburb": "TARILTA",
   "postcode": "3451"
 },
 {
   "suburb": "VAUGHAN",
   "postcode": "3451"
 },
 {
   "suburb": "YAPEEN",
   "postcode": "3451"
 },
 {
   "suburb": "HARCOURT",
   "postcode": "3453"
 },
 {
   "suburb": "HARCOURT NORTH",
   "postcode": "3453"
 },
 {
   "suburb": "RAVENSWOOD",
   "postcode": "3453"
 },
 {
   "suburb": "RAVENSWOOD SOUTH",
   "postcode": "3453"
 },
 {
   "suburb": "BARRYS REEF",
   "postcode": "3458"
 },
 {
   "suburb": "BLACKWOOD",
   "postcode": "3458"
 },
 {
   "suburb": "FERN HILL",
   "postcode": "3458"
 },
 {
   "suburb": "LERDERDERG",
   "postcode": "3458"
 },
 {
   "suburb": "LITTLE HAMPTON",
   "postcode": "3458"
 },
 {
   "suburb": "NEWBURY",
   "postcode": "3458"
 },
 {
   "suburb": "NORTH BLACKWOOD",
   "postcode": "3458"
 },
 {
   "suburb": "TRENTHAM",
   "postcode": "3458"
 },
 {
   "suburb": "TRENTHAM EAST",
   "postcode": "3458"
 },
 {
   "suburb": "BASALT",
   "postcode": "3460"
 },
 {
   "suburb": "DAYLESFORD",
   "postcode": "3460"
 },
 {
   "suburb": "BULLARTO",
   "postcode": "3461"
 },
 {
   "suburb": "BULLARTO SOUTH",
   "postcode": "3461"
 },
 {
   "suburb": "CLYDESDALE",
   "postcode": "3461"
 },
 {
   "suburb": "COOMOORA",
   "postcode": "3461"
 },
 {
   "suburb": "DENVER",
   "postcode": "3461"
 },
 {
   "suburb": "DRUMMOND",
   "postcode": "3461"
 },
 {
   "suburb": "DRY DIGGINGS",
   "postcode": "3461"
 },
 {
   "suburb": "EGANSTOWN",
   "postcode": "3461"
 },
 {
   "suburb": "ELEVATED PLAINS",
   "postcode": "3461"
 },
 {
   "suburb": "FRANKLINFORD",
   "postcode": "3461"
 },
 {
   "suburb": "GLENLYON",
   "postcode": "3461"
 },
 {
   "suburb": "HEPBURN",
   "postcode": "3461"
 },
 {
   "suburb": "HEPBURN SPRINGS",
   "postcode": "3461"
 },
 {
   "suburb": "KORWEINGUBOORA",
   "postcode": "3461"
 },
 {
   "suburb": "LEONARDS HILL",
   "postcode": "3461"
 },
 {
   "suburb": "LYONVILLE",
   "postcode": "3461"
 },
 {
   "suburb": "MOUNT FRANKLIN",
   "postcode": "3461"
 },
 {
   "suburb": "MUSK",
   "postcode": "3461"
 },
 {
   "suburb": "MUSK VALE",
   "postcode": "3461"
 },
 {
   "suburb": "PORCUPINE RIDGE",
   "postcode": "3461"
 },
 {
   "suburb": "SAILORS FALLS",
   "postcode": "3461"
 },
 {
   "suburb": "SAILORS HILL",
   "postcode": "3461"
 },
 {
   "suburb": "SHEPHERDS FLAT",
   "postcode": "3461"
 },
 {
   "suburb": "SPARGO CREEK",
   "postcode": "3461"
 },
 {
   "suburb": "STRANGWAYS",
   "postcode": "3461"
 },
 {
   "suburb": "WHEATSHEAF",
   "postcode": "3461"
 },
 {
   "suburb": "YANDOIT",
   "postcode": "3461"
 },
 {
   "suburb": "YANDOIT HILLS",
   "postcode": "3461"
 },
 {
   "suburb": "GREEN GULLY",
   "postcode": "3462"
 },
 {
   "suburb": "MUCKLEFORD SOUTH",
   "postcode": "3462"
 },
 {
   "suburb": "NEWSTEAD",
   "postcode": "3462"
 },
 {
   "suburb": "SANDON",
   "postcode": "3462"
 },
 {
   "suburb": "WELSHMANS REEF",
   "postcode": "3462"
 },
 {
   "suburb": "BARINGHUP",
   "postcode": "3463"
 },
 {
   "suburb": "BARINGHUP WEST",
   "postcode": "3463"
 },
 {
   "suburb": "BRADFORD",
   "postcode": "3463"
 },
 {
   "suburb": "EASTVILLE",
   "postcode": "3463"
 },
 {
   "suburb": "GOWER",
   "postcode": "3463"
 },
 {
   "suburb": "LAANECOORIE",
   "postcode": "3463"
 },
 {
   "suburb": "MALDON",
   "postcode": "3463"
 },
 {
   "suburb": "NEEREMAN",
   "postcode": "3463"
 },
 {
   "suburb": "NUGGETTY",
   "postcode": "3463"
 },
 {
   "suburb": "TARRENGOWER",
   "postcode": "3463"
 },
 {
   "suburb": "WALMER",
   "postcode": "3463"
 },
 {
   "suburb": "WOODSTOCK WEST",
   "postcode": "3463"
 },
 {
   "suburb": "CARISBROOK",
   "postcode": "3464"
 },
 {
   "suburb": "ADELAIDE LEAD",
   "postcode": "3465"
 },
 {
   "suburb": "ALMA",
   "postcode": "3465"
 },
 {
   "suburb": "BOWENVALE",
   "postcode": "3465"
 },
 {
   "suburb": "BUNG BONG",
   "postcode": "3465"
 },
 {
   "suburb": "COTSWOLD",
   "postcode": "3465"
 },
 {
   "suburb": "CRAIGIE",
   "postcode": "3465"
 },
 {
   "suburb": "DAISY HILL",
   "postcode": "3465"
 },
 {
   "suburb": "FLAGSTAFF",
   "postcode": "3465"
 },
 {
   "suburb": "GOLDEN POINT",
   "postcode": "3465"
 },
 {
   "suburb": "HAVELOCK",
   "postcode": "3465"
 },
 {
   "suburb": "HOMEBUSH",
   "postcode": "3465"
 },
 {
   "suburb": "MAJORCA",
   "postcode": "3465"
 },
 {
   "suburb": "MARYBOROUGH",
   "postcode": "3465"
 },
 {
   "suburb": "MOOLORT",
   "postcode": "3465"
 },
 {
   "suburb": "MOONLIGHT FLAT",
   "postcode": "3465"
 },
 {
   "suburb": "NATTE YALLOCK",
   "postcode": "3465"
 },
 {
   "suburb": "RATHSCAR",
   "postcode": "3465"
 },
 {
   "suburb": "RATHSCAR WEST",
   "postcode": "3465"
 },
 {
   "suburb": "SIMSON",
   "postcode": "3465"
 },
 {
   "suburb": "TIMOR",
   "postcode": "3465"
 },
 {
   "suburb": "TIMOR WEST",
   "postcode": "3465"
 },
 {
   "suburb": "WAREEK",
   "postcode": "3465"
 },
 {
   "suburb": "AVOCA",
   "postcode": "3467"
 },
 {
   "suburb": "AMPHITHEATRE",
   "postcode": "3468"
 },
 {
   "suburb": "MOUNT LONARCH",
   "postcode": "3468"
 },
 {
   "suburb": "ELMHURST",
   "postcode": "3469"
 },
 {
   "suburb": "GLENLOFTY",
   "postcode": "3469"
 },
 {
   "suburb": "GLENLOGIE",
   "postcode": "3469"
 },
 {
   "suburb": "GLENPATRICK",
   "postcode": "3469"
 },
 {
   "suburb": "NOWHERE CREEK",
   "postcode": "3469"
 },
 {
   "suburb": "BET BET",
   "postcode": "3472"
 },
 {
   "suburb": "BETLEY",
   "postcode": "3472"
 },
 {
   "suburb": "BROMLEY",
   "postcode": "3472"
 },
 {
   "suburb": "DUNLUCE",
   "postcode": "3472"
 },
 {
   "suburb": "DUNOLLY",
   "postcode": "3472"
 },
 {
   "suburb": "EDDINGTON",
   "postcode": "3472"
 },
 {
   "suburb": "GOLDSBOROUGH",
   "postcode": "3472"
 },
 {
   "suburb": "INKERMAN",
   "postcode": "3472"
 },
 {
   "suburb": "MCINTYRE",
   "postcode": "3472"
 },
 {
   "suburb": "MOLIAGUL",
   "postcode": "3472"
 },
 {
   "suburb": "MOUNT HOOGHLY",
   "postcode": "3472"
 },
 {
   "suburb": "ARCHDALE",
   "postcode": "3475"
 },
 {
   "suburb": "ARCHDALE JUNCTION",
   "postcode": "3475"
 },
 {
   "suburb": "MOONAMBEL",
   "postcode": "3478"
 },
 {
   "suburb": "PERCYDALE",
   "postcode": "3478"
 },
 {
   "suburb": "TANWOOD",
   "postcode": "3478"
 },
 {
   "suburb": "WARRENMANG",
   "postcode": "3478"
 },
 {
   "suburb": "CARDROSS",
   "postcode": "3496"
 },
 {
   "suburb": "CULLULLERAINE",
   "postcode": "3496"
 },
 {
   "suburb": "LINDSAY POINT",
   "postcode": "3496"
 },
 {
   "suburb": "NEDS CORNER",
   "postcode": "3496"
 },
 {
   "suburb": "RED CLIFFS",
   "postcode": "3496"
 },
 {
   "suburb": "SUNNYCLIFFS",
   "postcode": "3496"
 },
 {
   "suburb": "IRYMPLE",
   "postcode": "3498"
 },
 {
   "suburb": "MILDURA",
   "postcode": "3500"
 },
 {
   "suburb": "MILDURA WEST",
   "postcode": "3500"
 },
 {
   "suburb": "HATTAH",
   "postcode": "3501"
 },
 {
   "suburb": "KOORLONG",
   "postcode": "3501"
 },
 {
   "suburb": "MILDURA CENTRE PLAZA",
   "postcode": "3501"
 },
 {
   "suburb": "MILDURA SOUTH",
   "postcode": "3501"
 },
 {
   "suburb": "NICHOLS POINT",
   "postcode": "3501"
 },
 {
   "suburb": "BIRDWOODTON",
   "postcode": "3505"
 },
 {
   "suburb": "CABARITA",
   "postcode": "3505"
 },
 {
   "suburb": "MERBEIN",
   "postcode": "3505"
 },
 {
   "suburb": "MERBEIN SOUTH",
   "postcode": "3505"
 },
 {
   "suburb": "MERBEIN WEST",
   "postcode": "3505"
 },
 {
   "suburb": "WARGAN",
   "postcode": "3505"
 },
 {
   "suburb": "YELTA",
   "postcode": "3505"
 },
 {
   "suburb": "MARONG",
   "postcode": "3515"
 },
 {
   "suburb": "SHELBOURNE",
   "postcode": "3515"
 },
 {
   "suburb": "WILSONS HILL",
   "postcode": "3515"
 },
 {
   "suburb": "BRIDGEWATER",
   "postcode": "3516"
 },
 {
   "suburb": "BRIDGEWATER ON LODDON",
   "postcode": "3516"
 },
 {
   "suburb": "DERBY",
   "postcode": "3516"
 },
 {
   "suburb": "LEICHARDT",
   "postcode": "3516"
 },
 {
   "suburb": "PYALONG",
   "postcode": "3521"
 },
 {
   "suburb": "GLENHOPE EAST",
   "postcode": "3522"
 },
 {
   "suburb": "TOOBORAC",
   "postcode": "3522"
 },
 {
   "suburb": "ARGYLE",
   "postcode": "3523"
 },
 {
   "suburb": "COSTERFIELD",
   "postcode": "3523"
 },
 {
   "suburb": "DERRINAL",
   "postcode": "3523"
 },
 {
   "suburb": "HEATHCOTE",
   "postcode": "3523"
 },
 {
   "suburb": "HEATHCOTE SOUTH",
   "postcode": "3523"
 },
 {
   "suburb": "KNOWSLEY",
   "postcode": "3523"
 },
 {
   "suburb": "LADYS PASS",
   "postcode": "3523"
 },
 {
   "suburb": "MOORMBOOL WEST",
   "postcode": "3523"
 },
 {
   "suburb": "MOUNT CAMEL",
   "postcode": "3523"
 },
 {
   "suburb": "REDCASTLE",
   "postcode": "3523"
 },
 {
   "suburb": "BENDIGO",
   "postcode": "3550"
 },
 {
   "suburb": "BENDIGO SOUTH",
   "postcode": "3550"
 },
 {
   "suburb": "EAST BENDIGO",
   "postcode": "3550"
 },
 {
   "suburb": "FLORA HILL",
   "postcode": "3550"
 },
 {
   "suburb": "IRONBARK",
   "postcode": "3550"
 },
 {
   "suburb": "KENNINGTON",
   "postcode": "3550"
 },
 {
   "suburb": "LONG GULLY",
   "postcode": "3550"
 },
 {
   "suburb": "NORTH BENDIGO",
   "postcode": "3550"
 },
 {
   "suburb": "QUARRY HILL",
   "postcode": "3550"
 },
 {
   "suburb": "SANDHURST EAST",
   "postcode": "3550"
 },
 {
   "suburb": "SPRING GULLY",
   "postcode": "3550"
 },
 {
   "suburb": "STRATHDALE",
   "postcode": "3550"
 },
 {
   "suburb": "WEST BENDIGO",
   "postcode": "3550"
 },
 {
   "suburb": "WHITE HILLS",
   "postcode": "3550"
 },
 {
   "suburb": "ARNOLD",
   "postcode": "3551"
 },
 {
   "suburb": "ARNOLD WEST",
   "postcode": "3551"
 },
 {
   "suburb": "ASCOT",
   "postcode": "3551"
 },
 {
   "suburb": "ASCOT VICTORIA",
   "postcode": "3551"
 },
 {
   "suburb": "AXE CREEK",
   "postcode": "3551"
 },
 {
   "suburb": "AXEDALE",
   "postcode": "3551"
 },
 {
   "suburb": "BAGSHOT",
   "postcode": "3551"
 },
 {
   "suburb": "BAGSHOT NORTH",
   "postcode": "3551"
 },
 {
   "suburb": "BENDIGO FORWARD",
   "postcode": "3551"
 },
 {
   "suburb": "CORNELLA",
   "postcode": "3551"
 },
 {
   "suburb": "CREEK VIEW",
   "postcode": "3551"
 },
 {
   "suburb": "EMU CREEK",
   "postcode": "3551"
 },
 {
   "suburb": "EPPALOCK",
   "postcode": "3551"
 },
 {
   "suburb": "EPSOM",
   "postcode": "3551"
 },
 {
   "suburb": "HUNTLY",
   "postcode": "3551"
 },
 {
   "suburb": "HUNTLY NORTH",
   "postcode": "3551"
 },
 {
   "suburb": "JUNORTOUN",
   "postcode": "3551"
 },
 {
   "suburb": "KIMBOLTON",
   "postcode": "3551"
 },
 {
   "suburb": "LAKE EPPALOCK",
   "postcode": "3551"
 },
 {
   "suburb": "LLANELLY",
   "postcode": "3551"
 },
 {
   "suburb": "LOCKWOOD",
   "postcode": "3551"
 },
 {
   "suburb": "LOCKWOOD SOUTH",
   "postcode": "3551"
 },
 {
   "suburb": "LONGLEA",
   "postcode": "3551"
 },
 {
   "suburb": "MAIDEN GULLY",
   "postcode": "3551"
 },
 {
   "suburb": "MANDURANG",
   "postcode": "3551"
 },
 {
   "suburb": "MANDURANG SOUTH",
   "postcode": "3551"
 },
 {
   "suburb": "MURPHYS CREEK",
   "postcode": "3551"
 },
 {
   "suburb": "MYOLA",
   "postcode": "3551"
 },
 {
   "suburb": "MYRTLE CREEK",
   "postcode": "3551"
 },
 {
   "suburb": "NEWBRIDGE",
   "postcode": "3551"
 },
 {
   "suburb": "PAINSWICK",
   "postcode": "3551"
 },
 {
   "suburb": "SEDGWICK",
   "postcode": "3551"
 },
 {
   "suburb": "STRATHFIELDSAYE",
   "postcode": "3551"
 },
 {
   "suburb": "TARNAGULLA",
   "postcode": "3551"
 },
 {
   "suburb": "TOOLLEEN",
   "postcode": "3551"
 },
 {
   "suburb": "WAANYARRA",
   "postcode": "3551"
 },
 {
   "suburb": "WELLSFORD",
   "postcode": "3551"
 },
 {
   "suburb": "WOODSTOCK ON LODDON",
   "postcode": "3551"
 },
 {
   "suburb": "BIG HILL",
   "postcode": "3555"
 },
 {
   "suburb": "GOLDEN GULLY",
   "postcode": "3555"
 },
 {
   "suburb": "GOLDEN SQUARE",
   "postcode": "3555"
 },
 {
   "suburb": "KANGAROO FLAT",
   "postcode": "3555"
 },
 {
   "suburb": "LANSELL PLAZA",
   "postcode": "3555"
 },
 {
   "suburb": "CALIFORNIA GULLY",
   "postcode": "3556"
 },
 {
   "suburb": "CAMPBELLS FOREST",
   "postcode": "3556"
 },
 {
   "suburb": "EAGLEHAWK",
   "postcode": "3556"
 },
 {
   "suburb": "EAGLEHAWK NORTH",
   "postcode": "3556"
 },
 {
   "suburb": "JACKASS FLAT",
   "postcode": "3556"
 },
 {
   "suburb": "MYERS FLAT",
   "postcode": "3556"
 },
 {
   "suburb": "SAILORS GULLY",
   "postcode": "3556"
 },
 {
   "suburb": "SEBASTIAN",
   "postcode": "3556"
 },
 {
   "suburb": "WHIPSTICK",
   "postcode": "3556"
 },
 {
   "suburb": "WOODVALE",
   "postcode": "3556"
 },
 {
   "suburb": "BARNADOWN",
   "postcode": "3557"
 },
 {
   "suburb": "FOSTERVILLE",
   "postcode": "3557"
 },
 {
   "suburb": "GOORNONG",
   "postcode": "3557"
 },
 {
   "suburb": "MUSKERRY",
   "postcode": "3557"
 },
 {
   "suburb": "BURNEWANG",
   "postcode": "3558"
 },
 {
   "suburb": "COROP WEST",
   "postcode": "3558"
 },
 {
   "suburb": "ELMORE",
   "postcode": "3558"
 },
 {
   "suburb": "HUNTER",
   "postcode": "3558"
 },
 {
   "suburb": "RUNNYMEDE",
   "postcode": "3558"
 },
 {
   "suburb": "AVONMORE",
   "postcode": "3559"
 },
 {
   "suburb": "BURRAMBOOT",
   "postcode": "3559"
 },
 {
   "suburb": "COLBINABBIN",
   "postcode": "3559"
 },
 {
   "suburb": "COROP",
   "postcode": "3559"
 },
 {
   "suburb": "GOBARUP",
   "postcode": "3559"
 },
 {
   "suburb": "BALLENDELLA",
   "postcode": "3561"
 },
 {
   "suburb": "BAMAWM",
   "postcode": "3561"
 },
 {
   "suburb": "BONN",
   "postcode": "3561"
 },
 {
   "suburb": "DIGGORA",
   "postcode": "3561"
 },
 {
   "suburb": "FAIRY DELL",
   "postcode": "3561"
 },
 {
   "suburb": "NANNEELLA",
   "postcode": "3561"
 },
 {
   "suburb": "ROCHESTER",
   "postcode": "3561"
 },
 {
   "suburb": "TIMMERING",
   "postcode": "3561"
 },
 {
   "suburb": "TORRUMBARRY",
   "postcode": "3562"
 },
 {
   "suburb": "LOCKINGTON",
   "postcode": "3563"
 },
 {
   "suburb": "BAMAWM EXTENSION",
   "postcode": "3564"
 },
 {
   "suburb": "ECHUCA",
   "postcode": "3564"
 },
 {
   "suburb": "ECHUCA SOUTH",
   "postcode": "3564"
 },
 {
   "suburb": "ECHUCA VILLAGE",
   "postcode": "3564"
 },
 {
   "suburb": "ECHUCA WEST",
   "postcode": "3564"
 },
 {
   "suburb": "KANYAPELLA",
   "postcode": "3564"
 },
 {
   "suburb": "PATHO",
   "postcode": "3564"
 },
 {
   "suburb": "ROSLYNMEAD",
   "postcode": "3564"
 },
 {
   "suburb": "WHARPARILLA",
   "postcode": "3564"
 },
 {
   "suburb": "KOTTA",
   "postcode": "3565"
 },
 {
   "suburb": "GUNBOWER",
   "postcode": "3566"
 },
 {
   "suburb": "HORFIELD",
   "postcode": "3567"
 },
 {
   "suburb": "LEITCHVILLE",
   "postcode": "3567"
 },
 {
   "suburb": "BURKES BRIDGE",
   "postcode": "3568"
 },
 {
   "suburb": "COHUNA",
   "postcode": "3568"
 },
 {
   "suburb": "CULLEN",
   "postcode": "3568"
 },
 {
   "suburb": "DALTONS BRIDGE",
   "postcode": "3568"
 },
 {
   "suburb": "GANNAWARRA",
   "postcode": "3568"
 },
 {
   "suburb": "KEELY",
   "postcode": "3568"
 },
 {
   "suburb": "MACORNA NORTH",
   "postcode": "3568"
 },
 {
   "suburb": "MCMILLANS",
   "postcode": "3568"
 },
 {
   "suburb": "MEAD",
   "postcode": "3568"
 },
 {
   "suburb": "MINCHA WEST",
   "postcode": "3568"
 },
 {
   "suburb": "WEE WEE RUP",
   "postcode": "3568"
 },
 {
   "suburb": "AUCHMORE",
   "postcode": "3570"
 },
 {
   "suburb": "DRUMMARTIN",
   "postcode": "3570"
 },
 {
   "suburb": "NEILBOROUGH",
   "postcode": "3570"
 },
 {
   "suburb": "RAYWOOD",
   "postcode": "3570"
 },
 {
   "suburb": "DINGEE",
   "postcode": "3571"
 },
 {
   "suburb": "MILLOO",
   "postcode": "3572"
 },
 {
   "suburb": "CALIVIL",
   "postcode": "3573"
 },
 {
   "suburb": "GLADFIELD",
   "postcode": "3575"
 },
 {
   "suburb": "JUNGABURRA",
   "postcode": "3575"
 },
 {
   "suburb": "LODDON VALE",
   "postcode": "3575"
 },
 {
   "suburb": "MINCHA",
   "postcode": "3575"
 },
 {
   "suburb": "MOLOGA",
   "postcode": "3575"
 },
 {
   "suburb": "PYRAMID HILL",
   "postcode": "3575"
 },
 {
   "suburb": "SYLVATERRE",
   "postcode": "3575"
 },
 {
   "suburb": "TERRICK TERRICK",
   "postcode": "3575"
 },
 {
   "suburb": "YARRAWALLA",
   "postcode": "3575"
 },
 {
   "suburb": "BENJEROOP",
   "postcode": "3579"
 },
 {
   "suburb": "CAPELS CROSSING",
   "postcode": "3579"
 },
 {
   "suburb": "GONN CROSSING",
   "postcode": "3579"
 },
 {
   "suburb": "KERANG",
   "postcode": "3579"
 },
 {
   "suburb": "KERANG EAST",
   "postcode": "3579"
 },
 {
   "suburb": "KOROOP",
   "postcode": "3579"
 },
 {
   "suburb": "MILNES BRIDGE",
   "postcode": "3579"
 },
 {
   "suburb": "MURRABIT",
   "postcode": "3579"
 },
 {
   "suburb": "MURRABIT WEST",
   "postcode": "3579"
 },
 {
   "suburb": "MYALL",
   "postcode": "3579"
 },
 {
   "suburb": "MYSTIC PARK",
   "postcode": "3579"
 },
 {
   "suburb": "REEDY LAKE",
   "postcode": "3579"
 },
 {
   "suburb": "TEAL POINT",
   "postcode": "3579"
 },
 {
   "suburb": "WESTBY",
   "postcode": "3579"
 },
 {
   "suburb": "KOONDROOK",
   "postcode": "3580"
 },
 {
   "suburb": "LAKE CHARM",
   "postcode": "3581"
 },
 {
   "suburb": "TRESCO",
   "postcode": "3583"
 },
 {
   "suburb": "LAKE BOGA",
   "postcode": "3584"
 },
 {
   "suburb": "TRESCO WEST",
   "postcode": "3584"
 },
 {
   "suburb": "CASTLE DONNINGTON",
   "postcode": "3585"
 },
 {
   "suburb": "FISH POINT",
   "postcode": "3585"
 },
 {
   "suburb": "SWAN HILL",
   "postcode": "3585"
 },
 {
   "suburb": "WINLATON",
   "postcode": "3585"
 },
 {
   "suburb": "MURRAWEE",
   "postcode": "3586"
 },
 {
   "suburb": "MURRAYDALE",
   "postcode": "3586"
 },
 {
   "suburb": "PENTAL ISLAND",
   "postcode": "3586"
 },
 {
   "suburb": "TYNTYNDER",
   "postcode": "3586"
 },
 {
   "suburb": "TYNTYNDER SOUTH",
   "postcode": "3586"
 },
 {
   "suburb": "WOORINEN SOUTH",
   "postcode": "3588"
 },
 {
   "suburb": "WOORINEN",
   "postcode": "3589"
 },
 {
   "suburb": "TABILK",
   "postcode": "3607"
 },
 {
   "suburb": "BAILIESTON",
   "postcode": "3608"
 },
 {
   "suburb": "GOULBURN WEIR",
   "postcode": "3608"
 },
 {
   "suburb": "GRAYTOWN",
   "postcode": "3608"
 },
 {
   "suburb": "KIRWANS BRIDGE",
   "postcode": "3608"
 },
 {
   "suburb": "MITCHELLSTOWN",
   "postcode": "3608"
 },
 {
   "suburb": "NAGAMBIE",
   "postcode": "3608"
 },
 {
   "suburb": "WAHRING",
   "postcode": "3608"
 },
 {
   "suburb": "WIRRATE",
   "postcode": "3608"
 },
 {
   "suburb": "DHURRINGILE",
   "postcode": "3610"
 },
 {
   "suburb": "MOORILIM",
   "postcode": "3610"
 },
 {
   "suburb": "MURCHISON",
   "postcode": "3610"
 },
 {
   "suburb": "MURCHISON EAST",
   "postcode": "3610"
 },
 {
   "suburb": "MURCHISON NORTH",
   "postcode": "3610"
 },
 {
   "suburb": "MOORA",
   "postcode": "3612"
 },
 {
   "suburb": "RUSHWORTH",
   "postcode": "3612"
 },
 {
   "suburb": "WANALTA",
   "postcode": "3612"
 },
 {
   "suburb": "WARANGA SHORES",
   "postcode": "3612"
 },
 {
   "suburb": "WHROO",
   "postcode": "3612"
 },
 {
   "suburb": "TOOLAMBA",
   "postcode": "3614"
 },
 {
   "suburb": "TOOLAMBA WEST",
   "postcode": "3614"
 },
 {
   "suburb": "COOMA",
   "postcode": "3616"
 },
 {
   "suburb": "GILLIESTON",
   "postcode": "3616"
 },
 {
   "suburb": "GIRGARRE EAST",
   "postcode": "3616"
 },
 {
   "suburb": "HARSTON",
   "postcode": "3616"
 },
 {
   "suburb": "MOOROOPNA NORTH WEST",
   "postcode": "3616"
 },
 {
   "suburb": "TATURA",
   "postcode": "3616"
 },
 {
   "suburb": "TATURA EAST",
   "postcode": "3616"
 },
 {
   "suburb": "WARANGA",
   "postcode": "3616"
 },
 {
   "suburb": "BYRNESIDE",
   "postcode": "3617"
 },
 {
   "suburb": "MERRIGUM",
   "postcode": "3618"
 },
 {
   "suburb": "KYABRAM",
   "postcode": "3620"
 },
 {
   "suburb": "KYABRAM SOUTH",
   "postcode": "3620"
 },
 {
   "suburb": "LANCASTER",
   "postcode": "3620"
 },
 {
   "suburb": "ST GERMAINS",
   "postcode": "3620"
 },
 {
   "suburb": "WYUNA",
   "postcode": "3620"
 },
 {
   "suburb": "WYUNA EAST",
   "postcode": "3620"
 },
 {
   "suburb": "KYVALLEY",
   "postcode": "3621"
 },
 {
   "suburb": "TONGALA",
   "postcode": "3621"
 },
 {
   "suburb": "YAMBUNA",
   "postcode": "3621"
 },
 {
   "suburb": "KOYUGA",
   "postcode": "3622"
 },
 {
   "suburb": "STRATHALLAN",
   "postcode": "3622"
 },
 {
   "suburb": "CARAG CARAG",
   "postcode": "3623"
 },
 {
   "suburb": "STANHOPE",
   "postcode": "3623"
 },
 {
   "suburb": "STANHOPE SOUTH",
   "postcode": "3623"
 },
 {
   "suburb": "GIRGARRE",
   "postcode": "3624"
 },
 {
   "suburb": "ARDMONA",
   "postcode": "3629"
 },
 {
   "suburb": "COOMBOONA",
   "postcode": "3629"
 },
 {
   "suburb": "MOOROOPNA",
   "postcode": "3629"
 },
 {
   "suburb": "MOOROOPNA NORTH",
   "postcode": "3629"
 },
 {
   "suburb": "UNDERA",
   "postcode": "3629"
 },
 {
   "suburb": "BRANDITT",
   "postcode": "3630"
 },
 {
   "suburb": "CANIAMBO",
   "postcode": "3630"
 },
 {
   "suburb": "COLLIVER",
   "postcode": "3630"
 },
 {
   "suburb": "DUNKIRK",
   "postcode": "3630"
 },
 {
   "suburb": "SHEPPARTON",
   "postcode": "3630"
 },
 {
   "suburb": "SHEPPARTON SOUTH",
   "postcode": "3630"
 },
 {
   "suburb": "ARCADIA",
   "postcode": "3631"
 },
 {
   "suburb": "ARCADIA SOUTH",
   "postcode": "3631"
 },
 {
   "suburb": "COSGROVE",
   "postcode": "3631"
 },
 {
   "suburb": "COSGROVE SOUTH",
   "postcode": "3631"
 },
 {
   "suburb": "GRAHAMVALE",
   "postcode": "3631"
 },
 {
   "suburb": "KARRAMOMUS",
   "postcode": "3631"
 },
 {
   "suburb": "KIALLA",
   "postcode": "3631"
 },
 {
   "suburb": "KIALLA EAST",
   "postcode": "3631"
 },
 {
   "suburb": "KIALLA WEST",
   "postcode": "3631"
 },
 {
   "suburb": "LEMNOS",
   "postcode": "3631"
 },
 {
   "suburb": "ORRVALE",
   "postcode": "3631"
 },
 {
   "suburb": "PINE LODGE",
   "postcode": "3631"
 },
 {
   "suburb": "SHEPPARTON EAST",
   "postcode": "3631"
 },
 {
   "suburb": "SHEPPARTON NORTH",
   "postcode": "3631"
 },
 {
   "suburb": "CONGUPNA",
   "postcode": "3633"
 },
 {
   "suburb": "BUNBARTHA",
   "postcode": "3634"
 },
 {
   "suburb": "KATANDRA",
   "postcode": "3634"
 },
 {
   "suburb": "KATANDRA WEST",
   "postcode": "3634"
 },
 {
   "suburb": "MARIONVALE",
   "postcode": "3634"
 },
 {
   "suburb": "MARUNGI",
   "postcode": "3634"
 },
 {
   "suburb": "TALLYGAROOPNA",
   "postcode": "3634"
 },
 {
   "suburb": "ZEERUST",
   "postcode": "3634"
 },
 {
   "suburb": "KAARIMBA",
   "postcode": "3635"
 },
 {
   "suburb": "MUNDOONA",
   "postcode": "3635"
 },
 {
   "suburb": "WUNGHNU",
   "postcode": "3635"
 },
 {
   "suburb": "DRUMANURE",
   "postcode": "3636"
 },
 {
   "suburb": "INVERGORDON",
   "postcode": "3636"
 },
 {
   "suburb": "NARING",
   "postcode": "3636"
 },
 {
   "suburb": "NUMURKAH",
   "postcode": "3636"
 },
 {
   "suburb": "WAAIA",
   "postcode": "3637"
 },
 {
   "suburb": "YALCA",
   "postcode": "3637"
 },
 {
   "suburb": "KOTUPNA",
   "postcode": "3638"
 },
 {
   "suburb": "NATHALIA",
   "postcode": "3638"
 },
 {
   "suburb": "YIELIMA",
   "postcode": "3638"
 },
 {
   "suburb": "BARMAH",
   "postcode": "3639"
 },
 {
   "suburb": "LOWER MOIRA",
   "postcode": "3639"
 },
 {
   "suburb": "PICOLA",
   "postcode": "3639"
 },
 {
   "suburb": "PICOLA WEST",
   "postcode": "3639"
 },
 {
   "suburb": "KATUNGA",
   "postcode": "3640"
 },
 {
   "suburb": "BEARII",
   "postcode": "3641"
 },
 {
   "suburb": "MYWEE",
   "postcode": "3641"
 },
 {
   "suburb": "STRATHMERTON",
   "postcode": "3641"
 },
 {
   "suburb": "ULUPNA",
   "postcode": "3641"
 },
 {
   "suburb": "BAROOGA",
   "postcode": "3644"
 },
 {
   "suburb": "COBRAM",
   "postcode": "3644"
 },
 {
   "suburb": "COBRAM EAST",
   "postcode": "3644"
 },
 {
   "suburb": "KOONOOMOO",
   "postcode": "3644"
 },
 {
   "suburb": "LALALTY",
   "postcode": "3644"
 },
 {
   "suburb": "MUCKATAH",
   "postcode": "3644"
 },
 {
   "suburb": "YARROWEYAH",
   "postcode": "3644"
 },
 {
   "suburb": "DOOKIE",
   "postcode": "3646"
 },
 {
   "suburb": "MOUNT MAJOR",
   "postcode": "3646"
 },
 {
   "suburb": "NALINGA",
   "postcode": "3646"
 },
 {
   "suburb": "WAGGARANDALL",
   "postcode": "3646"
 },
 {
   "suburb": "YABBA NORTH",
   "postcode": "3646"
 },
 {
   "suburb": "YABBA SOUTH",
   "postcode": "3646"
 },
 {
   "suburb": "YOUANMITE",
   "postcode": "3646"
 },
 {
   "suburb": "DOOKIE COLLEGE",
   "postcode": "3647"
 },
 {
   "suburb": "KATAMATITE",
   "postcode": "3649"
 },
 {
   "suburb": "KATAMATITE EAST",
   "postcode": "3649"
 },
 {
   "suburb": "BROADFORD",
   "postcode": "3658"
 },
 {
   "suburb": "CLONBINANE",
   "postcode": "3658"
 },
 {
   "suburb": "HAZELDENE",
   "postcode": "3658"
 },
 {
   "suburb": "REEDY CREEK",
   "postcode": "3658"
 },
 {
   "suburb": "STRATH CREEK",
   "postcode": "3658"
 },
 {
   "suburb": "SUGARLOAF CREEK",
   "postcode": "3658"
 },
 {
   "suburb": "SUNDAY CREEK",
   "postcode": "3658"
 },
 {
   "suburb": "TYAAK",
   "postcode": "3658"
 },
 {
   "suburb": "WATERFORD PARK",
   "postcode": "3658"
 },
 {
   "suburb": "TALLAROOK",
   "postcode": "3659"
 },
 {
   "suburb": "CAVEAT",
   "postcode": "3660"
 },
 {
   "suburb": "DROPMORE",
   "postcode": "3660"
 },
 {
   "suburb": "HIGHLANDS",
   "postcode": "3660"
 },
 {
   "suburb": "HILLDENE",
   "postcode": "3660"
 },
 {
   "suburb": "KERRISDALE",
   "postcode": "3660"
 },
 {
   "suburb": "NORTHWOOD",
   "postcode": "3660"
 },
 {
   "suburb": "SEYMOUR",
   "postcode": "3660"
 },
 {
   "suburb": "SEYMOUR SOUTH",
   "postcode": "3660"
 },
 {
   "suburb": "TRAWOOL",
   "postcode": "3660"
 },
 {
   "suburb": "WHITEHEADS CREEK",
   "postcode": "3660"
 },
 {
   "suburb": "PUCKAPUNYAL",
   "postcode": "3662"
 },
 {
   "suburb": "MANGALORE",
   "postcode": "3663"
 },
 {
   "suburb": "AVENEL",
   "postcode": "3664"
 },
 {
   "suburb": "UPTON HILL",
   "postcode": "3664"
 },
 {
   "suburb": "LOCKSLEY",
   "postcode": "3665"
 },
 {
   "suburb": "LONGWOOD",
   "postcode": "3665"
 },
 {
   "suburb": "BALMATTUM",
   "postcode": "3666"
 },
 {
   "suburb": "CREIGHTONS CREEK",
   "postcode": "3666"
 },
 {
   "suburb": "EUROA",
   "postcode": "3666"
 },
 {
   "suburb": "GOORAM",
   "postcode": "3666"
 },
 {
   "suburb": "KELVIN VIEW",
   "postcode": "3666"
 },
 {
   "suburb": "KITHBROOK",
   "postcode": "3666"
 },
 {
   "suburb": "LONGWOOD EAST",
   "postcode": "3666"
 },
 {
   "suburb": "MIEPOLL",
   "postcode": "3666"
 },
 {
   "suburb": "MOGLONEMBY",
   "postcode": "3666"
 },
 {
   "suburb": "MOLKA",
   "postcode": "3666"
 },
 {
   "suburb": "PRANJIP",
   "postcode": "3666"
 },
 {
   "suburb": "RIGGS CREEK",
   "postcode": "3666"
 },
 {
   "suburb": "RUFFY",
   "postcode": "3666"
 },
 {
   "suburb": "SHEANS CREEK",
   "postcode": "3666"
 },
 {
   "suburb": "STRATHBOGIE",
   "postcode": "3666"
 },
 {
   "suburb": "TARCOMBE",
   "postcode": "3666"
 },
 {
   "suburb": "BOHO",
   "postcode": "3669"
 },
 {
   "suburb": "BOHO SOUTH",
   "postcode": "3669"
 },
 {
   "suburb": "CREEK JUNCTION",
   "postcode": "3669"
 },
 {
   "suburb": "EARLSTON",
   "postcode": "3669"
 },
 {
   "suburb": "GOWANGARDIE",
   "postcode": "3669"
 },
 {
   "suburb": "KOONDA",
   "postcode": "3669"
 },
 {
   "suburb": "MARRAWEENEY",
   "postcode": "3669"
 },
 {
   "suburb": "TAMLEUGH",
   "postcode": "3669"
 },
 {
   "suburb": "TAMLEUGH NORTH",
   "postcode": "3669"
 },
 {
   "suburb": "UPOTIPOTPON",
   "postcode": "3669"
 },
 {
   "suburb": "VIOLET TOWN",
   "postcode": "3669"
 },
 {
   "suburb": "BADDAGINNIE",
   "postcode": "3670"
 },
 {
   "suburb": "TARNOOK",
   "postcode": "3670"
 },
 {
   "suburb": "WARRENBAYNE",
   "postcode": "3670"
 },
 {
   "suburb": "BENALLA",
   "postcode": "3672"
 },
 {
   "suburb": "BENALLA",
   "postcode": "3673"
 },
 {
   "suburb": "BROKEN CREEK",
   "postcode": "3673"
 },
 {
   "suburb": "GOOMALIBEE",
   "postcode": "3673"
 },
 {
   "suburb": "LIMA",
   "postcode": "3673"
 },
 {
   "suburb": "LIMA EAST",
   "postcode": "3673"
 },
 {
   "suburb": "LIMA SOUTH",
   "postcode": "3673"
 },
 {
   "suburb": "LURG",
   "postcode": "3673"
 },
 {
   "suburb": "MOLYULLAH",
   "postcode": "3673"
 },
 {
   "suburb": "MOORNGAG",
   "postcode": "3673"
 },
 {
   "suburb": "SAMARIA",
   "postcode": "3673"
 },
 {
   "suburb": "SWANPOOL",
   "postcode": "3673"
 },
 {
   "suburb": "UPPER LURG",
   "postcode": "3673"
 },
 {
   "suburb": "UPPER RYANS CREEK",
   "postcode": "3673"
 },
 {
   "suburb": "WINTON",
   "postcode": "3673"
 },
 {
   "suburb": "WINTON NORTH",
   "postcode": "3673"
 },
 {
   "suburb": "BOWEYA",
   "postcode": "3675"
 },
 {
   "suburb": "BOWEYA NORTH",
   "postcode": "3675"
 },
 {
   "suburb": "GLENROWAN",
   "postcode": "3675"
 },
 {
   "suburb": "GLENROWAN WEST",
   "postcode": "3675"
 },
 {
   "suburb": "GRETA",
   "postcode": "3675"
 },
 {
   "suburb": "GRETA SOUTH",
   "postcode": "3675"
 },
 {
   "suburb": "GRETA WEST",
   "postcode": "3675"
 },
 {
   "suburb": "HANSONVILLE",
   "postcode": "3675"
 },
 {
   "suburb": "MOUNT BRUNO",
   "postcode": "3675"
 },
 {
   "suburb": "TAMINICK",
   "postcode": "3675"
 },
 {
   "suburb": "WANGARATTA",
   "postcode": "3677"
 },
 {
   "suburb": "YARRUNGA",
   "postcode": "3677"
 },
 {
   "suburb": "BOBINAWARRAH",
   "postcode": "3678"
 },
 {
   "suburb": "BOORHAMAN",
   "postcode": "3678"
 },
 {
   "suburb": "BOORHAMAN EAST",
   "postcode": "3678"
 },
 {
   "suburb": "BOWSER",
   "postcode": "3678"
 },
 {
   "suburb": "BYAWATHA",
   "postcode": "3678"
 },
 {
   "suburb": "DOCKER",
   "postcode": "3678"
 },
 {
   "suburb": "DOCKERS PLAINS",
   "postcode": "3678"
 },
 {
   "suburb": "EAST WANGARATTA",
   "postcode": "3678"
 },
 {
   "suburb": "EVERTON",
   "postcode": "3678"
 },
 {
   "suburb": "EVERTON UPPER",
   "postcode": "3678"
 },
 {
   "suburb": "KILLAWARRA",
   "postcode": "3678"
 },
 {
   "suburb": "LACEBY",
   "postcode": "3678"
 },
 {
   "suburb": "LONDRIGAN",
   "postcode": "3678"
 },
 {
   "suburb": "MARKWOOD",
   "postcode": "3678"
 },
 {
   "suburb": "MEADOW CREEK",
   "postcode": "3678"
 },
 {
   "suburb": "MILAWA",
   "postcode": "3678"
 },
 {
   "suburb": "NORTH WANGARATTA",
   "postcode": "3678"
 },
 {
   "suburb": "OXLEY",
   "postcode": "3678"
 },
 {
   "suburb": "OXLEY FLATS",
   "postcode": "3678"
 },
 {
   "suburb": "PEECHELBA",
   "postcode": "3678"
 },
 {
   "suburb": "PEECHELBA EAST",
   "postcode": "3678"
 },
 {
   "suburb": "TARRAWINGEE",
   "postcode": "3678"
 },
 {
   "suburb": "WALDARA",
   "postcode": "3678"
 },
 {
   "suburb": "WANGANDARY",
   "postcode": "3678"
 },
 {
   "suburb": "WANGARATTA FORWARD",
   "postcode": "3678"
 },
 {
   "suburb": "WANGARATTA SOUTH",
   "postcode": "3678"
 },
 {
   "suburb": "BORALMA",
   "postcode": "3682"
 },
 {
   "suburb": "LILLIPUT",
   "postcode": "3682"
 },
 {
   "suburb": "NORONG",
   "postcode": "3682"
 },
 {
   "suburb": "SPRINGHURST",
   "postcode": "3682"
 },
 {
   "suburb": "CHILTERN",
   "postcode": "3683"
 },
 {
   "suburb": "CHILTERN VALLEY",
   "postcode": "3683"
 },
 {
   "suburb": "CORNISHTOWN",
   "postcode": "3683"
 },
 {
   "suburb": "BOORHAMAN NORTH",
   "postcode": "3685"
 },
 {
   "suburb": "BRIMIN",
   "postcode": "3685"
 },
 {
   "suburb": "BROWNS PLAINS",
   "postcode": "3685"
 },
 {
   "suburb": "CARLYLE",
   "postcode": "3685"
 },
 {
   "suburb": "GOORAMADDA",
   "postcode": "3685"
 },
 {
   "suburb": "GREAT SOUTHERN",
   "postcode": "3685"
 },
 {
   "suburb": "PRENTICE NORTH",
   "postcode": "3685"
 },
 {
   "suburb": "RUTHERGLEN",
   "postcode": "3685"
 },
 {
   "suburb": "WAHGUNYAH",
   "postcode": "3687"
 },
 {
   "suburb": "BARNAWARTHA",
   "postcode": "3688"
 },
 {
   "suburb": "INDIGO VALLEY",
   "postcode": "3688"
 },
 {
   "suburb": "LENEVA",
   "postcode": "3690"
 },
 {
   "suburb": "WEST WODONGA",
   "postcode": "3690"
 },
 {
   "suburb": "WODONGA",
   "postcode": "3690"
 },
 {
   "suburb": "WODONGA PLAZA",
   "postcode": "3690"
 },
 {
   "suburb": "ALLANS FLAT",
   "postcode": "3691"
 },
 {
   "suburb": "BANDIANA",
   "postcode": "3691"
 },
 {
   "suburb": "BARANDUDA",
   "postcode": "3691"
 },
 {
   "suburb": "BARNAWARTHA",
   "postcode": "3691"
 },
 {
   "suburb": "BARNAWARTHA NORTH",
   "postcode": "3691"
 },
 {
   "suburb": "BELLBRIDGE",
   "postcode": "3691"
 },
 {
   "suburb": "BETHANGA",
   "postcode": "3691"
 },
 {
   "suburb": "BONEGILLA",
   "postcode": "3691"
 },
 {
   "suburb": "CASTLE CREEK",
   "postcode": "3691"
 },
 {
   "suburb": "DEDERANG",
   "postcode": "3691"
 },
 {
   "suburb": "EBDEN",
   "postcode": "3691"
 },
 {
   "suburb": "GATEWAY ISLAND",
   "postcode": "3691"
 },
 {
   "suburb": "GLEN CREEK",
   "postcode": "3691"
 },
 {
   "suburb": "GUNDOWRING",
   "postcode": "3691"
 },
 {
   "suburb": "HUON CREEK",
   "postcode": "3691"
 },
 {
   "suburb": "KERGUNYAH",
   "postcode": "3691"
 },
 {
   "suburb": "KERGUNYAH SOUTH",
   "postcode": "3691"
 },
 {
   "suburb": "KIEWA",
   "postcode": "3691"
 },
 {
   "suburb": "KILLARA",
   "postcode": "3691"
 },
 {
   "suburb": "LAKE HUME VILLAGE",
   "postcode": "3691"
 },
 {
   "suburb": "LENEVA",
   "postcode": "3691"
 },
 {
   "suburb": "MONGANS BRIDGE",
   "postcode": "3691"
 },
 {
   "suburb": "OSBORNES FLAT",
   "postcode": "3691"
 },
 {
   "suburb": "RUNNING CREEK",
   "postcode": "3691"
 },
 {
   "suburb": "STAGHORN FLAT",
   "postcode": "3691"
 },
 {
   "suburb": "TALGARNO",
   "postcode": "3691"
 },
 {
   "suburb": "TANGAMBALANGA",
   "postcode": "3691"
 },
 {
   "suburb": "WODONGA FORWARD",
   "postcode": "3691"
 },
 {
   "suburb": "BANDIANA",
   "postcode": "3694"
 },
 {
   "suburb": "CHARLEROI",
   "postcode": "3695"
 },
 {
   "suburb": "HUON",
   "postcode": "3695"
 },
 {
   "suburb": "TAWONGA",
   "postcode": "3697"
 },
 {
   "suburb": "MOUNT BEAUTY",
   "postcode": "3698"
 },
 {
   "suburb": "TAWONGA SOUTH",
   "postcode": "3698"
 },
 {
   "suburb": "BOGONG",
   "postcode": "3699"
 },
 {
   "suburb": "MOUNT BEAUTY",
   "postcode": "3699"
 },
 {
   "suburb": "GEORGES CREEK",
   "postcode": "3700"
 },
 {
   "suburb": "JARVIS CREEK",
   "postcode": "3700"
 },
 {
   "suburb": "TALLANGATTA",
   "postcode": "3700"
 },
 {
   "suburb": "TALLANGATTA EAST",
   "postcode": "3700"
 },
 {
   "suburb": "TALLANGATTA SOUTH",
   "postcode": "3701"
 },
 {
   "suburb": "ACHERON",
   "postcode": "3714"
 },
 {
   "suburb": "ALEXANDRA",
   "postcode": "3714"
 },
 {
   "suburb": "CATHKIN",
   "postcode": "3714"
 },
 {
   "suburb": "FAWCETT",
   "postcode": "3714"
 },
 {
   "suburb": "KORIELLA",
   "postcode": "3714"
 },
 {
   "suburb": "MAINTONGOON",
   "postcode": "3714"
 },
 {
   "suburb": "TAGGERTY",
   "postcode": "3714"
 },
 {
   "suburb": "WHANREGARWEN",
   "postcode": "3714"
 },
 {
   "suburb": "ANCONA",
   "postcode": "3715"
 },
 {
   "suburb": "MERTON",
   "postcode": "3715"
 },
 {
   "suburb": "WOODFIELD",
   "postcode": "3715"
 },
 {
   "suburb": "FLOWERDALE",
   "postcode": "3717"
 },
 {
   "suburb": "GHIN GHIN",
   "postcode": "3717"
 },
 {
   "suburb": "GLENBURN",
   "postcode": "3717"
 },
 {
   "suburb": "HOMEWOOD",
   "postcode": "3717"
 },
 {
   "suburb": "KILLINGWORTH",
   "postcode": "3717"
 },
 {
   "suburb": "LIMESTONE",
   "postcode": "3717"
 },
 {
   "suburb": "YEA",
   "postcode": "3717"
 },
 {
   "suburb": "MOLESWORTH",
   "postcode": "3718"
 },
 {
   "suburb": "GOBUR",
   "postcode": "3719"
 },
 {
   "suburb": "KANUMBRA",
   "postcode": "3719"
 },
 {
   "suburb": "TERIP TERIP",
   "postcode": "3719"
 },
 {
   "suburb": "YARCK",
   "postcode": "3719"
 },
 {
   "suburb": "BONNIE DOON",
   "postcode": "3720"
 },
 {
   "suburb": "BARWITE",
   "postcode": "3722"
 },
 {
   "suburb": "MANSFIELD",
   "postcode": "3722"
 },
 {
   "suburb": "MIRIMBAH",
   "postcode": "3722"
 },
 {
   "suburb": "ARCHERTON",
   "postcode": "3723"
 },
 {
   "suburb": "BARJARG",
   "postcode": "3723"
 },
 {
   "suburb": "BOOROLITE",
   "postcode": "3723"
 },
 {
   "suburb": "BRIDGE CREEK",
   "postcode": "3723"
 },
 {
   "suburb": "DELATITE",
   "postcode": "3723"
 },
 {
   "suburb": "ENOCHS POINT",
   "postcode": "3723"
 },
 {
   "suburb": "GAFFNEYS CREEK",
   "postcode": "3723"
 },
 {
   "suburb": "GOUGHS BAY",
   "postcode": "3723"
 },
 {
   "suburb": "HOWES CREEK",
   "postcode": "3723"
 },
 {
   "suburb": "HOWQUA",
   "postcode": "3723"
 },
 {
   "suburb": "HOWQUA HILLS",
   "postcode": "3723"
 },
 {
   "suburb": "HOWQUA INLET",
   "postcode": "3723"
 },
 {
   "suburb": "JAMIESON",
   "postcode": "3723"
 },
 {
   "suburb": "KEVINGTON",
   "postcode": "3723"
 },
 {
   "suburb": "KNOCKWOOD",
   "postcode": "3723"
 },
 {
   "suburb": "MACS COVE",
   "postcode": "3723"
 },
 {
   "suburb": "MAINDAMPLE",
   "postcode": "3723"
 },
 {
   "suburb": "MATLOCK",
   "postcode": "3723"
 },
 {
   "suburb": "MERRIJIG",
   "postcode": "3723"
 },
 {
   "suburb": "MOUNTAIN BAY",
   "postcode": "3723"
 },
 {
   "suburb": "PIRIES",
   "postcode": "3723"
 },
 {
   "suburb": "SAWMILL SETTLEMENT",
   "postcode": "3723"
 },
 {
   "suburb": "TOLMIE",
   "postcode": "3723"
 },
 {
   "suburb": "WOODS POINT",
   "postcode": "3723"
 },
 {
   "suburb": "BOXWOOD",
   "postcode": "3725"
 },
 {
   "suburb": "CHESNEY VALE",
   "postcode": "3725"
 },
 {
   "suburb": "GOORAMBAT",
   "postcode": "3725"
 },
 {
   "suburb": "MAJOR PLAINS",
   "postcode": "3725"
 },
 {
   "suburb": "STEWARTON",
   "postcode": "3725"
 },
 {
   "suburb": "BUNGEET",
   "postcode": "3726"
 },
 {
   "suburb": "BUNGEET WEST",
   "postcode": "3726"
 },
 {
   "suburb": "DEVENISH",
   "postcode": "3726"
 },
 {
   "suburb": "THOONA",
   "postcode": "3726"
 },
 {
   "suburb": "ALMONDS",
   "postcode": "3727"
 },
 {
   "suburb": "LAKE ROWAN",
   "postcode": "3727"
 },
 {
   "suburb": "PELLUEBLA",
   "postcode": "3727"
 },
 {
   "suburb": "ST JAMES",
   "postcode": "3727"
 },
 {
   "suburb": "YUNDOOL",
   "postcode": "3727"
 },
 {
   "suburb": "BOOMAHNOOMOONAH",
   "postcode": "3728"
 },
 {
   "suburb": "TUNGAMAH",
   "postcode": "3728"
 },
 {
   "suburb": "WILBY",
   "postcode": "3728"
 },
 {
   "suburb": "YOUARANG",
   "postcode": "3728"
 },
 {
   "suburb": "BATHUMI",
   "postcode": "3730"
 },
 {
   "suburb": "BOOSEY",
   "postcode": "3730"
 },
 {
   "suburb": "BUNDALONG",
   "postcode": "3730"
 },
 {
   "suburb": "BUNDALONG SOUTH",
   "postcode": "3730"
 },
 {
   "suburb": "BURRAMINE",
   "postcode": "3730"
 },
 {
   "suburb": "BURRAMINE SOUTH",
   "postcode": "3730"
 },
 {
   "suburb": "ESMOND",
   "postcode": "3730"
 },
 {
   "suburb": "TELFORD",
   "postcode": "3730"
 },
 {
   "suburb": "YARRAWONGA",
   "postcode": "3730"
 },
 {
   "suburb": "YARRAWONGA SOUTH",
   "postcode": "3730"
 },
 {
   "suburb": "MOYHU",
   "postcode": "3732"
 },
 {
   "suburb": "BOWMANS FOREST",
   "postcode": "3735"
 },
 {
   "suburb": "WHOROULY",
   "postcode": "3735"
 },
 {
   "suburb": "WHOROULY EAST",
   "postcode": "3735"
 },
 {
   "suburb": "WHOROULY SOUTH",
   "postcode": "3735"
 },
 {
   "suburb": "BARWIDGEE",
   "postcode": "3737"
 },
 {
   "suburb": "BUFFALO RIVER",
   "postcode": "3737"
 },
 {
   "suburb": "GAPSTED",
   "postcode": "3737"
 },
 {
   "suburb": "HAVILAH",
   "postcode": "3737"
 },
 {
   "suburb": "MERRIANG",
   "postcode": "3737"
 },
 {
   "suburb": "MERRIANG SOUTH",
   "postcode": "3737"
 },
 {
   "suburb": "MUDGEGONGA",
   "postcode": "3737"
 },
 {
   "suburb": "MYRTLEFORD",
   "postcode": "3737"
 },
 {
   "suburb": "NUG NUG",
   "postcode": "3737"
 },
 {
   "suburb": "ROSEWHITE",
   "postcode": "3737"
 },
 {
   "suburb": "OVENS",
   "postcode": "3738"
 },
 {
   "suburb": "EUROBIN",
   "postcode": "3739"
 },
 {
   "suburb": "OVENS",
   "postcode": "3739"
 },
 {
   "suburb": "POREPUNKAH",
   "postcode": "3740"
 },
 {
   "suburb": "BRIGHT",
   "postcode": "3741"
 },
 {
   "suburb": "FREEBURGH",
   "postcode": "3741"
 },
 {
   "suburb": "GERMANTOWN",
   "postcode": "3741"
 },
 {
   "suburb": "HARRIETVILLE",
   "postcode": "3741"
 },
 {
   "suburb": "POREPUNKAH",
   "postcode": "3741"
 },
 {
   "suburb": "WANDILIGONG",
   "postcode": "3744"
 },
 {
   "suburb": "ELDORADO",
   "postcode": "3746"
 },
 {
   "suburb": "BEECHWORTH",
   "postcode": "3747"
 },
 {
   "suburb": "MURMUNGEE",
   "postcode": "3747"
 },
 {
   "suburb": "STANLEY",
   "postcode": "3747"
 },
 {
   "suburb": "WOORAGEE",
   "postcode": "3747"
 },
 {
   "suburb": "BRUARONG",
   "postcode": "3749"
 },
 {
   "suburb": "YACKANDANDAH",
   "postcode": "3749"
 },
 {
   "suburb": "WOLLERT",
   "postcode": "3750"
 },
 {
   "suburb": "WOODSTOCK",
   "postcode": "3751"
 },
 {
   "suburb": "SOUTH MORANG",
   "postcode": "3752"
 },
 {
   "suburb": "BEVERIDGE",
   "postcode": "3753"
 },
 {
   "suburb": "DOREEN",
   "postcode": "3754"
 },
 {
   "suburb": "MERNDA",
   "postcode": "3754"
 },
 {
   "suburb": "YAN YEAN",
   "postcode": "3755"
 },
 {
   "suburb": "CHINTIN",
   "postcode": "3756"
 },
 {
   "suburb": "DARRAWEIT GUIM",
   "postcode": "3756"
 },
 {
   "suburb": "UPPER PLENTY",
   "postcode": "3756"
 },
 {
   "suburb": "WALLAN",
   "postcode": "3756"
 },
 {
   "suburb": "EDEN PARK",
   "postcode": "3757"
 },
 {
   "suburb": "HUMEVALE",
   "postcode": "3757"
 },
 {
   "suburb": "KINGLAKE CENTRAL",
   "postcode": "3757"
 },
 {
   "suburb": "KINGLAKE WEST",
   "postcode": "3757"
 },
 {
   "suburb": "PHEASANT CREEK",
   "postcode": "3757"
 },
 {
   "suburb": "WHITTLESEA",
   "postcode": "3757"
 },
 {
   "suburb": "HEATHCOTE JUNCTION",
   "postcode": "3758"
 },
 {
   "suburb": "WANDONG",
   "postcode": "3758"
 },
 {
   "suburb": "PANTON HILL",
   "postcode": "3759"
 },
 {
   "suburb": "SMITHS GULLY",
   "postcode": "3760"
 },
 {
   "suburb": "ST ANDREWS",
   "postcode": "3761"
 },
 {
   "suburb": "BYLANDS",
   "postcode": "3762"
 },
 {
   "suburb": "KINGLAKE",
   "postcode": "3763"
 },
 {
   "suburb": "FORBES",
   "postcode": "3764"
 },
 {
   "suburb": "GLENAROUA",
   "postcode": "3764"
 },
 {
   "suburb": "HIGH CAMP",
   "postcode": "3764"
 },
 {
   "suburb": "KILMORE",
   "postcode": "3764"
 },
 {
   "suburb": "KILMORE EAST",
   "postcode": "3764"
 },
 {
   "suburb": "MORANDING",
   "postcode": "3764"
 },
 {
   "suburb": "TANTARABOO",
   "postcode": "3764"
 },
 {
   "suburb": "WILLOWMAVIN",
   "postcode": "3764"
 },
 {
   "suburb": "MONTROSE",
   "postcode": "3765"
 },
 {
   "suburb": "KALORAMA",
   "postcode": "3766"
 },
 {
   "suburb": "MOUNT DANDENONG",
   "postcode": "3767"
 },
 {
   "suburb": "COLDSTREAM",
   "postcode": "3770"
 },
 {
   "suburb": "GRUYERE",
   "postcode": "3770"
 },
 {
   "suburb": "YERING",
   "postcode": "3770"
 },
 {
   "suburb": "CHRISTMAS HILLS",
   "postcode": "3775"
 },
 {
   "suburb": "DIXONS CREEK",
   "postcode": "3775"
 },
 {
   "suburb": "STEELS CREEK",
   "postcode": "3775"
 },
 {
   "suburb": "TARRAWARRA",
   "postcode": "3775"
 },
 {
   "suburb": "YARRA GLEN",
   "postcode": "3775"
 },
 {
   "suburb": "BADGER CREEK",
   "postcode": "3777"
 },
 {
   "suburb": "CASTELLA",
   "postcode": "3777"
 },
 {
   "suburb": "CHUM CREEK",
   "postcode": "3777"
 },
 {
   "suburb": "HEALESVILLE",
   "postcode": "3777"
 },
 {
   "suburb": "HEALESVILLE MAIN STREET",
   "postcode": "3777"
 },
 {
   "suburb": "MOUNT TOOLEBEWONG",
   "postcode": "3777"
 },
 {
   "suburb": "TOOLANGI",
   "postcode": "3777"
 },
 {
   "suburb": "COCKATOO",
   "postcode": "3781"
 },
 {
   "suburb": "MOUNT BURNETT",
   "postcode": "3781"
 },
 {
   "suburb": "NANGANA",
   "postcode": "3781"
 },
 {
   "suburb": "AVONSLEIGH",
   "postcode": "3782"
 },
 {
   "suburb": "CLEMATIS",
   "postcode": "3782"
 },
 {
   "suburb": "EMERALD",
   "postcode": "3782"
 },
 {
   "suburb": "MACCLESFIELD",
   "postcode": "3782"
 },
 {
   "suburb": "GEMBROOK",
   "postcode": "3783"
 },
 {
   "suburb": "TREMONT",
   "postcode": "3785"
 },
 {
   "suburb": "FERNY CREEK",
   "postcode": "3786"
 },
 {
   "suburb": "SASSAFRAS",
   "postcode": "3787"
 },
 {
   "suburb": "SASSAFRAS GULLY",
   "postcode": "3787"
 },
 {
   "suburb": "OLINDA",
   "postcode": "3788"
 },
 {
   "suburb": "SHERBROOKE",
   "postcode": "3789"
 },
 {
   "suburb": "KALLISTA",
   "postcode": "3791"
 },
 {
   "suburb": "THE PATCH",
   "postcode": "3792"
 },
 {
   "suburb": "MONBULK",
   "postcode": "3793"
 },
 {
   "suburb": "SILVAN",
   "postcode": "3795"
 },
 {
   "suburb": "MOUNT EVELYN",
   "postcode": "3796"
 },
 {
   "suburb": "GILDEROY",
   "postcode": "3797"
 },
 {
   "suburb": "GLADYSDALE",
   "postcode": "3797"
 },
 {
   "suburb": "POWELLTOWN",
   "postcode": "3797"
 },
 {
   "suburb": "THREE BRIDGES",
   "postcode": "3797"
 },
 {
   "suburb": "YARRA JUNCTION",
   "postcode": "3797"
 },
 {
   "suburb": "BIG PATS CREEK",
   "postcode": "3799"
 },
 {
   "suburb": "EAST WARBURTON",
   "postcode": "3799"
 },
 {
   "suburb": "MCMAHONS CREEK",
   "postcode": "3799"
 },
 {
   "suburb": "MILLGROVE",
   "postcode": "3799"
 },
 {
   "suburb": "REEFTON",
   "postcode": "3799"
 },
 {
   "suburb": "WARBURTON",
   "postcode": "3799"
 },
 {
   "suburb": "WESBURN",
   "postcode": "3799"
 },
 {
   "suburb": "MONASH UNIVERSITY",
   "postcode": "3800"
 },
 {
   "suburb": "ENDEAVOUR HILLS",
   "postcode": "3802"
 },
 {
   "suburb": "HALLAM",
   "postcode": "3803"
 },
 {
   "suburb": "NARRE WARREN EAST",
   "postcode": "3804"
 },
 {
   "suburb": "NARRE WARREN NORTH",
   "postcode": "3804"
 },
 {
   "suburb": "FOUNTAIN GATE",
   "postcode": "3805"
 },
 {
   "suburb": "NARRE WARREN",
   "postcode": "3805"
 },
 {
   "suburb": "NARRE WARREN SOUTH",
   "postcode": "3805"
 },
 {
   "suburb": "BERWICK",
   "postcode": "3806"
 },
 {
   "suburb": "HARKAWAY",
   "postcode": "3806"
 },
 {
   "suburb": "BEACONSFIELD",
   "postcode": "3807"
 },
 {
   "suburb": "GUYS HILL",
   "postcode": "3807"
 },
 {
   "suburb": "BEACONSFIELD UPPER",
   "postcode": "3808"
 },
 {
   "suburb": "DEWHURST",
   "postcode": "3808"
 },
 {
   "suburb": "OFFICER",
   "postcode": "3809"
 },
 {
   "suburb": "OFFICER SOUTH",
   "postcode": "3809"
 },
 {
   "suburb": "PAKENHAM",
   "postcode": "3810"
 },
 {
   "suburb": "PAKENHAM SOUTH",
   "postcode": "3810"
 },
 {
   "suburb": "PAKENHAM UPPER",
   "postcode": "3810"
 },
 {
   "suburb": "RYTHDALE",
   "postcode": "3810"
 },
 {
   "suburb": "MARYKNOLL",
   "postcode": "3812"
 },
 {
   "suburb": "NAR NAR GOON",
   "postcode": "3812"
 },
 {
   "suburb": "NAR NAR GOON NORTH",
   "postcode": "3812"
 },
 {
   "suburb": "TYNONG",
   "postcode": "3813"
 },
 {
   "suburb": "TYNONG NORTH",
   "postcode": "3813"
 },
 {
   "suburb": "CORA LYNN",
   "postcode": "3814"
 },
 {
   "suburb": "GARFIELD",
   "postcode": "3814"
 },
 {
   "suburb": "GARFIELD NORTH",
   "postcode": "3814"
 },
 {
   "suburb": "VERVALE",
   "postcode": "3814"
 },
 {
   "suburb": "BUNYIP",
   "postcode": "3815"
 },
 {
   "suburb": "BUNYIP NORTH",
   "postcode": "3815"
 },
 {
   "suburb": "IONA",
   "postcode": "3815"
 },
 {
   "suburb": "TONIMBUK",
   "postcode": "3815"
 },
 {
   "suburb": "LABERTOUCHE",
   "postcode": "3816"
 },
 {
   "suburb": "LONGWARRY",
   "postcode": "3816"
 },
 {
   "suburb": "LONGWARRY NORTH",
   "postcode": "3816"
 },
 {
   "suburb": "MODELLA",
   "postcode": "3816"
 },
 {
   "suburb": "ATHLONE",
   "postcode": "3818"
 },
 {
   "suburb": "DROUIN",
   "postcode": "3818"
 },
 {
   "suburb": "DROUIN EAST",
   "postcode": "3818"
 },
 {
   "suburb": "DROUIN SOUTH",
   "postcode": "3818"
 },
 {
   "suburb": "DROUIN WEST",
   "postcode": "3818"
 },
 {
   "suburb": "HALLORA",
   "postcode": "3818"
 },
 {
   "suburb": "JINDIVICK",
   "postcode": "3818"
 },
 {
   "suburb": "RIPPLEBROOK",
   "postcode": "3818"
 },
 {
   "suburb": "BONA VISTA",
   "postcode": "3820"
 },
 {
   "suburb": "LILLICO",
   "postcode": "3820"
 },
 {
   "suburb": "WARRAGUL",
   "postcode": "3820"
 },
 {
   "suburb": "BRANDY CREEK",
   "postcode": "3821"
 },
 {
   "suburb": "BRAVINGTON",
   "postcode": "3821"
 },
 {
   "suburb": "BULN BULN",
   "postcode": "3821"
 },
 {
   "suburb": "BULN BULN EAST",
   "postcode": "3821"
 },
 {
   "suburb": "CROSSOVER",
   "postcode": "3821"
 },
 {
   "suburb": "ELLINBANK",
   "postcode": "3821"
 },
 {
   "suburb": "FERNDALE",
   "postcode": "3821"
 },
 {
   "suburb": "LARDNER",
   "postcode": "3821"
 },
 {
   "suburb": "NILMA",
   "postcode": "3821"
 },
 {
   "suburb": "NILMA NORTH",
   "postcode": "3821"
 },
 {
   "suburb": "ROKEBY",
   "postcode": "3821"
 },
 {
   "suburb": "SEAVIEW",
   "postcode": "3821"
 },
 {
   "suburb": "SHADY CREEK",
   "postcode": "3821"
 },
 {
   "suburb": "TETOORA ROAD",
   "postcode": "3821"
 },
 {
   "suburb": "TORWOOD",
   "postcode": "3821"
 },
 {
   "suburb": "WARRAGUL SOUTH",
   "postcode": "3821"
 },
 {
   "suburb": "WARRAGUL WEST",
   "postcode": "3821"
 },
 {
   "suburb": "CLOVERLEA",
   "postcode": "3822"
 },
 {
   "suburb": "DARNUM",
   "postcode": "3822"
 },
 {
   "suburb": "GAINSBOROUGH",
   "postcode": "3822"
 },
 {
   "suburb": "ALLAMBEE",
   "postcode": "3823"
 },
 {
   "suburb": "YARRAGON",
   "postcode": "3823"
 },
 {
   "suburb": "YARRAGON SOUTH",
   "postcode": "3823"
 },
 {
   "suburb": "CHILDERS",
   "postcode": "3824"
 },
 {
   "suburb": "NARRACAN",
   "postcode": "3824"
 },
 {
   "suburb": "THORPDALE SOUTH",
   "postcode": "3824"
 },
 {
   "suburb": "TRAFALGAR",
   "postcode": "3824"
 },
 {
   "suburb": "TRAFALGAR EAST",
   "postcode": "3824"
 },
 {
   "suburb": "TRAFALGAR SOUTH",
   "postcode": "3824"
 },
 {
   "suburb": "ABERFELDY",
   "postcode": "3825"
 },
 {
   "suburb": "AMOR",
   "postcode": "3825"
 },
 {
   "suburb": "BOOLA",
   "postcode": "3825"
 },
 {
   "suburb": "CARINGAL",
   "postcode": "3825"
 },
 {
   "suburb": "COALVILLE",
   "postcode": "3825"
 },
 {
   "suburb": "COOPERS CREEK",
   "postcode": "3825"
 },
 {
   "suburb": "ERICA",
   "postcode": "3825"
 },
 {
   "suburb": "FUMINA",
   "postcode": "3825"
 },
 {
   "suburb": "FUMINA SOUTH",
   "postcode": "3825"
 },
 {
   "suburb": "HERNES OAK",
   "postcode": "3825"
 },
 {
   "suburb": "HILL END",
   "postcode": "3825"
 },
 {
   "suburb": "JACOB CREEK",
   "postcode": "3825"
 },
 {
   "suburb": "JERICHO",
   "postcode": "3825"
 },
 {
   "suburb": "MOE",
   "postcode": "3825"
 },
 {
   "suburb": "MOE SOUTH",
   "postcode": "3825"
 },
 {
   "suburb": "MOONDARRA",
   "postcode": "3825"
 },
 {
   "suburb": "NEWBOROUGH",
   "postcode": "3825"
 },
 {
   "suburb": "RAWSON",
   "postcode": "3825"
 },
 {
   "suburb": "TANJIL",
   "postcode": "3825"
 },
 {
   "suburb": "TANJIL SOUTH",
   "postcode": "3825"
 },
 {
   "suburb": "THALLOO",
   "postcode": "3825"
 },
 {
   "suburb": "THOMSON",
   "postcode": "3825"
 },
 {
   "suburb": "TOOMBON",
   "postcode": "3825"
 },
 {
   "suburb": "WALHALLA",
   "postcode": "3825"
 },
 {
   "suburb": "WALHALLA EAST",
   "postcode": "3825"
 },
 {
   "suburb": "WESTBURY",
   "postcode": "3825"
 },
 {
   "suburb": "WILLOW GROVE",
   "postcode": "3825"
 },
 {
   "suburb": "YALLOURN",
   "postcode": "3825"
 },
 {
   "suburb": "YALLOURN NORTH",
   "postcode": "3825"
 },
 {
   "suburb": "NEERIM",
   "postcode": "3831"
 },
 {
   "suburb": "NEERIM SOUTH",
   "postcode": "3831"
 },
 {
   "suburb": "NAYOOK",
   "postcode": "3832"
 },
 {
   "suburb": "NEERIM JUNCTION",
   "postcode": "3832"
 },
 {
   "suburb": "NEERIM NORTH",
   "postcode": "3832"
 },
 {
   "suburb": "ICY CREEK",
   "postcode": "3833"
 },
 {
   "suburb": "NOOJEE",
   "postcode": "3833"
 },
 {
   "suburb": "PIEDMONT",
   "postcode": "3833"
 },
 {
   "suburb": "TANJIL BREN",
   "postcode": "3833"
 },
 {
   "suburb": "VESPER",
   "postcode": "3833"
 },
 {
   "suburb": "THORPDALE",
   "postcode": "3835"
 },
 {
   "suburb": "DRIFFIELD",
   "postcode": "3840"
 },
 {
   "suburb": "HAZELWOOD",
   "postcode": "3840"
 },
 {
   "suburb": "HAZELWOOD NORTH",
   "postcode": "3840"
 },
 {
   "suburb": "HAZELWOOD SOUTH",
   "postcode": "3840"
 },
 {
   "suburb": "JEERALANG",
   "postcode": "3840"
 },
 {
   "suburb": "JEERALANG JUNCTION",
   "postcode": "3840"
 },
 {
   "suburb": "MARYVALE",
   "postcode": "3840"
 },
 {
   "suburb": "MORWELL",
   "postcode": "3840"
 },
 {
   "suburb": "CHURCHILL",
   "postcode": "3842"
 },
 {
   "suburb": "BLACKWARRY",
   "postcode": "3844"
 },
 {
   "suburb": "CALLIGNEE",
   "postcode": "3844"
 },
 {
   "suburb": "CALLIGNEE NORTH",
   "postcode": "3844"
 },
 {
   "suburb": "CALLIGNEE SOUTH",
   "postcode": "3844"
 },
 {
   "suburb": "CARRAJUNG",
   "postcode": "3844"
 },
 {
   "suburb": "CARRAJUNG LOWER",
   "postcode": "3844"
 },
 {
   "suburb": "CARRAJUNG SOUTH",
   "postcode": "3844"
 },
 {
   "suburb": "FLYNN",
   "postcode": "3844"
 },
 {
   "suburb": "FLYNNS CREEK",
   "postcode": "3844"
 },
 {
   "suburb": "KOORNALLA",
   "postcode": "3844"
 },
 {
   "suburb": "LOY YANG",
   "postcode": "3844"
 },
 {
   "suburb": "MOUNT TASSIE",
   "postcode": "3844"
 },
 {
   "suburb": "TRARALGON",
   "postcode": "3844"
 },
 {
   "suburb": "TRARALGON EAST",
   "postcode": "3844"
 },
 {
   "suburb": "TRARALGON SOUTH",
   "postcode": "3844"
 },
 {
   "suburb": "TYERS",
   "postcode": "3844"
 },
 {
   "suburb": "HIAMDALE",
   "postcode": "3847"
 },
 {
   "suburb": "NAMBROK",
   "postcode": "3847"
 },
 {
   "suburb": "ROSEDALE",
   "postcode": "3847"
 },
 {
   "suburb": "WILLUNG",
   "postcode": "3847"
 },
 {
   "suburb": "WILLUNG SOUTH",
   "postcode": "3847"
 },
 {
   "suburb": "SALE",
   "postcode": "3850"
 },
 {
   "suburb": "WURRUK",
   "postcode": "3850"
 },
 {
   "suburb": "AIRLY",
   "postcode": "3851"
 },
 {
   "suburb": "BUNDALAGUAH",
   "postcode": "3851"
 },
 {
   "suburb": "CLYDEBANK",
   "postcode": "3851"
 },
 {
   "suburb": "COBAINS",
   "postcode": "3851"
 },
 {
   "suburb": "DARRIMAN",
   "postcode": "3851"
 },
 {
   "suburb": "DUTSON",
   "postcode": "3851"
 },
 {
   "suburb": "DUTSON DOWNS",
   "postcode": "3851"
 },
 {
   "suburb": "FLAMINGO BEACH",
   "postcode": "3851"
 },
 {
   "suburb": "FULHAM",
   "postcode": "3851"
 },
 {
   "suburb": "GIFFARD",
   "postcode": "3851"
 },
 {
   "suburb": "GIFFARD WEST",
   "postcode": "3851"
 },
 {
   "suburb": "GLOMAR BEACH",
   "postcode": "3851"
 },
 {
   "suburb": "GOLDEN BEACH",
   "postcode": "3851"
 },
 {
   "suburb": "KILMANY",
   "postcode": "3851"
 },
 {
   "suburb": "LAKE WELLINGTON",
   "postcode": "3851"
 },
 {
   "suburb": "LOCH SPORT",
   "postcode": "3851"
 },
 {
   "suburb": "LONGFORD",
   "postcode": "3851"
 },
 {
   "suburb": "MONTGOMERY",
   "postcode": "3851"
 },
 {
   "suburb": "MYRTLEBANK",
   "postcode": "3851"
 },
 {
   "suburb": "PARADISE BEACH",
   "postcode": "3851"
 },
 {
   "suburb": "PEARSONDALE",
   "postcode": "3851"
 },
 {
   "suburb": "SEACOMBE",
   "postcode": "3851"
 },
 {
   "suburb": "SEASPRAY",
   "postcode": "3851"
 },
 {
   "suburb": "SOMERTON PARK",
   "postcode": "3851"
 },
 {
   "suburb": "STRADBROKE",
   "postcode": "3851"
 },
 {
   "suburb": "THE HEART",
   "postcode": "3851"
 },
 {
   "suburb": "THE HONEYSUCKLES",
   "postcode": "3851"
 },
 {
   "suburb": "EAST SALE",
   "postcode": "3852"
 },
 {
   "suburb": "SALE EAST RAAF",
   "postcode": "3852"
 },
 {
   "suburb": "GLENGARRY",
   "postcode": "3854"
 },
 {
   "suburb": "GLENGARRY NORTH",
   "postcode": "3854"
 },
 {
   "suburb": "GLENGARRY WEST",
   "postcode": "3854"
 },
 {
   "suburb": "TOONGABBIE",
   "postcode": "3856"
 },
 {
   "suburb": "COWWARR",
   "postcode": "3857"
 },
 {
   "suburb": "DAWSON",
   "postcode": "3858"
 },
 {
   "suburb": "DENISON",
   "postcode": "3858"
 },
 {
   "suburb": "HEYFIELD",
   "postcode": "3858"
 },
 {
   "suburb": "SEATON",
   "postcode": "3858"
 },
 {
   "suburb": "WINNINDOO",
   "postcode": "3858"
 },
 {
   "suburb": "MAFFRA WEST UPPER",
   "postcode": "3859"
 },
 {
   "suburb": "NEWRY",
   "postcode": "3859"
 },
 {
   "suburb": "TINAMBA",
   "postcode": "3859"
 },
 {
   "suburb": "TINAMBA WEST",
   "postcode": "3859"
 },
 {
   "suburb": "BOISDALE",
   "postcode": "3860"
 },
 {
   "suburb": "BRIAGOLONG",
   "postcode": "3860"
 },
 {
   "suburb": "BUSHY PARK",
   "postcode": "3860"
 },
 {
   "suburb": "COONGULLA",
   "postcode": "3860"
 },
 {
   "suburb": "MAFFRA",
   "postcode": "3860"
 },
 {
   "suburb": "RIVERSLEA",
   "postcode": "3860"
 },
 {
   "suburb": "VALENCIA CREEK",
   "postcode": "3860"
 },
 {
   "suburb": "COBBANNAH",
   "postcode": "3862"
 },
 {
   "suburb": "HOLLANDS LANDING",
   "postcode": "3862"
 },
 {
   "suburb": "LLOWALONG",
   "postcode": "3862"
 },
 {
   "suburb": "MEERLIEU",
   "postcode": "3862"
 },
 {
   "suburb": "MOORNAPA",
   "postcode": "3862"
 },
 {
   "suburb": "MUNRO",
   "postcode": "3862"
 },
 {
   "suburb": "PERRY BRIDGE",
   "postcode": "3862"
 },
 {
   "suburb": "STOCKDALE",
   "postcode": "3862"
 },
 {
   "suburb": "STRATFORD",
   "postcode": "3862"
 },
 {
   "suburb": "WATERFORD",
   "postcode": "3862"
 },
 {
   "suburb": "FERNBANK",
   "postcode": "3864"
 },
 {
   "suburb": "GLENALADALE",
   "postcode": "3864"
 },
 {
   "suburb": "LINDENOW",
   "postcode": "3865"
 },
 {
   "suburb": "JUMBUK",
   "postcode": "3869"
 },
 {
   "suburb": "YINNAR",
   "postcode": "3869"
 },
 {
   "suburb": "YINNAR SOUTH",
   "postcode": "3869"
 },
 {
   "suburb": "BOOLARRA",
   "postcode": "3870"
 },
 {
   "suburb": "BOOLARRA SOUTH",
   "postcode": "3870"
 },
 {
   "suburb": "BUDGEREE",
   "postcode": "3870"
 },
 {
   "suburb": "GRAND RIDGE",
   "postcode": "3870"
 },
 {
   "suburb": "ALLAMBEE RESERVE",
   "postcode": "3871"
 },
 {
   "suburb": "ALLAMBEE SOUTH",
   "postcode": "3871"
 },
 {
   "suburb": "BAROMI",
   "postcode": "3871"
 },
 {
   "suburb": "DARLIMURLA",
   "postcode": "3871"
 },
 {
   "suburb": "DELBURN",
   "postcode": "3871"
 },
 {
   "suburb": "DOLLAR",
   "postcode": "3871"
 },
 {
   "suburb": "MIRBOO",
   "postcode": "3871"
 },
 {
   "suburb": "MIRBOO NORTH",
   "postcode": "3871"
 },
 {
   "suburb": "GORMANDALE",
   "postcode": "3873"
 },
 {
   "suburb": "CARRAJUNG SOUTH",
   "postcode": "3874"
 },
 {
   "suburb": "MCLOUGHLINS BEACH",
   "postcode": "3874"
 },
 {
   "suburb": "WOODSIDE",
   "postcode": "3874"
 },
 {
   "suburb": "WOODSIDE BEACH",
   "postcode": "3874"
 },
 {
   "suburb": "WOODSIDE NORTH",
   "postcode": "3874"
 },
 {
   "suburb": "BAIRNSDALE",
   "postcode": "3875"
 },
 {
   "suburb": "BANKSIA PENINSULA",
   "postcode": "3875"
 },
 {
   "suburb": "BENGWORDEN",
   "postcode": "3875"
 },
 {
   "suburb": "BROADLANDS",
   "postcode": "3875"
 },
 {
   "suburb": "BULLUMWAAL",
   "postcode": "3875"
 },
 {
   "suburb": "CALULU",
   "postcode": "3875"
 },
 {
   "suburb": "CLIFTON CREEK",
   "postcode": "3875"
 },
 {
   "suburb": "EAST BAIRNSDALE",
   "postcode": "3875"
 },
 {
   "suburb": "EASTWOOD",
   "postcode": "3875"
 },
 {
   "suburb": "ELLASWOOD",
   "postcode": "3875"
 },
 {
   "suburb": "FAIRY DELL",
   "postcode": "3875"
 },
 {
   "suburb": "FLAGGY CREEK",
   "postcode": "3875"
 },
 {
   "suburb": "FORGE CREEK",
   "postcode": "3875"
 },
 {
   "suburb": "GOON NURE",
   "postcode": "3875"
 },
 {
   "suburb": "GRANITE ROCK",
   "postcode": "3875"
 },
 {
   "suburb": "HILLSIDE",
   "postcode": "3875"
 },
 {
   "suburb": "IGUANA CREEK",
   "postcode": "3875"
 },
 {
   "suburb": "LINDENOW SOUTH",
   "postcode": "3875"
 },
 {
   "suburb": "LUCKNOW",
   "postcode": "3875"
 },
 {
   "suburb": "MELWOOD",
   "postcode": "3875"
 },
 {
   "suburb": "MOUNT TAYLOR",
   "postcode": "3875"
 },
 {
   "suburb": "NEWLANDS ARM",
   "postcode": "3875"
 },
 {
   "suburb": "SARSFIELD",
   "postcode": "3875"
 },
 {
   "suburb": "WALPA",
   "postcode": "3875"
 },
 {
   "suburb": "WATERHOLES",
   "postcode": "3875"
 },
 {
   "suburb": "WOODGLEN",
   "postcode": "3875"
 },
 {
   "suburb": "WUK WUK",
   "postcode": "3875"
 },
 {
   "suburb": "WY YUNG",
   "postcode": "3875"
 },
 {
   "suburb": "EAGLE POINT",
   "postcode": "3878"
 },
 {
   "suburb": "BOOLE POOLE",
   "postcode": "3880"
 },
 {
   "suburb": "OCEAN GRANGE",
   "postcode": "3880"
 },
 {
   "suburb": "PAYNESVILLE",
   "postcode": "3880"
 },
 {
   "suburb": "NICHOLSON",
   "postcode": "3882"
 },
 {
   "suburb": "BRUTHEN",
   "postcode": "3885"
 },
 {
   "suburb": "MOSSIFACE",
   "postcode": "3885"
 },
 {
   "suburb": "TAMBO UPPER",
   "postcode": "3885"
 },
 {
   "suburb": "WISELEIGH",
   "postcode": "3885"
 },
 {
   "suburb": "NEWMERELLA",
   "postcode": "3886"
 },
 {
   "suburb": "LAKE TYERS",
   "postcode": "3887"
 },
 {
   "suburb": "NOWA NOWA",
   "postcode": "3887"
 },
 {
   "suburb": "WAIREWA",
   "postcode": "3887"
 },
 {
   "suburb": "BETE BOLONG",
   "postcode": "3888"
 },
 {
   "suburb": "BRODRIBB RIVER",
   "postcode": "3888"
 },
 {
   "suburb": "CAPE CONRAN",
   "postcode": "3888"
 },
 {
   "suburb": "CORRINGLE",
   "postcode": "3888"
 },
 {
   "suburb": "JARRAHMOND",
   "postcode": "3888"
 },
 {
   "suburb": "MARLO",
   "postcode": "3888"
 },
 {
   "suburb": "ORBOST",
   "postcode": "3888"
 },
 {
   "suburb": "SIMPSONS CREEK",
   "postcode": "3888"
 },
 {
   "suburb": "TOSTAREE",
   "postcode": "3888"
 },
 {
   "suburb": "WAYGARA",
   "postcode": "3888"
 },
 {
   "suburb": "WOMBAT CREEK",
   "postcode": "3888"
 },
 {
   "suburb": "BUMBERRAH",
   "postcode": "3902"
 },
 {
   "suburb": "JOHNSONVILLE",
   "postcode": "3902"
 },
 {
   "suburb": "SWAN REACH",
   "postcode": "3903"
 },
 {
   "suburb": "METUNG",
   "postcode": "3904"
 },
 {
   "suburb": "KALIMNA",
   "postcode": "3909"
 },
 {
   "suburb": "KALIMNA WEST",
   "postcode": "3909"
 },
 {
   "suburb": "LAKE BUNGA",
   "postcode": "3909"
 },
 {
   "suburb": "LAKE TYERS BEACH",
   "postcode": "3909"
 },
 {
   "suburb": "LAKES ENTRANCE",
   "postcode": "3909"
 },
 {
   "suburb": "NUNGURNER",
   "postcode": "3909"
 },
 {
   "suburb": "NYERIMILANG",
   "postcode": "3909"
 },
 {
   "suburb": "TOORLOO ARM",
   "postcode": "3909"
 },
 {
   "suburb": "LANGWARRIN",
   "postcode": "3910"
 },
 {
   "suburb": "BAXTER",
   "postcode": "3911"
 },
 {
   "suburb": "LANGWARRIN SOUTH",
   "postcode": "3911"
 },
 {
   "suburb": "PEARCEDALE",
   "postcode": "3912"
 },
 {
   "suburb": "SOMERVILLE",
   "postcode": "3912"
 },
 {
   "suburb": "TYABB",
   "postcode": "3913"
 },
 {
   "suburb": "HASTINGS",
   "postcode": "3915"
 },
 {
   "suburb": "TUERONG",
   "postcode": "3915"
 },
 {
   "suburb": "MERRICKS",
   "postcode": "3916"
 },
 {
   "suburb": "POINT LEO",
   "postcode": "3916"
 },
 {
   "suburb": "SHOREHAM",
   "postcode": "3916"
 },
 {
   "suburb": "BITTERN",
   "postcode": "3918"
 },
 {
   "suburb": "CRIB POINT",
   "postcode": "3919"
 },
 {
   "suburb": "HMAS CERBERUS",
   "postcode": "3920"
 },
 {
   "suburb": "COWES",
   "postcode": "3922"
 },
 {
   "suburb": "SILVERLEAVES",
   "postcode": "3922"
 },
 {
   "suburb": "SMITHS BEACH",
   "postcode": "3922"
 },
 {
   "suburb": "SUMMERLANDS",
   "postcode": "3922"
 },
 {
   "suburb": "SUNDERLAND BAY",
   "postcode": "3922"
 },
 {
   "suburb": "SUNSET STRIP",
   "postcode": "3922"
 },
 {
   "suburb": "SURF BEACH",
   "postcode": "3922"
 },
 {
   "suburb": "VENTNOR",
   "postcode": "3922"
 },
 {
   "suburb": "WIMBLEDON HEIGHTS",
   "postcode": "3922"
 },
 {
   "suburb": "RHYLL",
   "postcode": "3923"
 },
 {
   "suburb": "CAPE WOOLAMAI",
   "postcode": "3925"
 },
 {
   "suburb": "CHURCHILL ISLAND",
   "postcode": "3925"
 },
 {
   "suburb": "NEWHAVEN",
   "postcode": "3925"
 },
 {
   "suburb": "SAN REMO",
   "postcode": "3925"
 },
 {
   "suburb": "BALNARRING",
   "postcode": "3926"
 },
 {
   "suburb": "BALNARRING BEACH",
   "postcode": "3926"
 },
 {
   "suburb": "MERRICKS BEACH",
   "postcode": "3926"
 },
 {
   "suburb": "MERRICKS NORTH",
   "postcode": "3926"
 },
 {
   "suburb": "SOMERS",
   "postcode": "3927"
 },
 {
   "suburb": "MAIN RIDGE",
   "postcode": "3928"
 },
 {
   "suburb": "FLINDERS",
   "postcode": "3929"
 },
 {
   "suburb": "KUNYUNG",
   "postcode": "3930"
 },
 {
   "suburb": "MOUNT ELIZA",
   "postcode": "3930"
 },
 {
   "suburb": "MORNINGTON",
   "postcode": "3931"
 },
 {
   "suburb": "MOOROODUC",
   "postcode": "3933"
 },
 {
   "suburb": "MOUNT MARTHA",
   "postcode": "3934"
 },
 {
   "suburb": "ARTHURS SEAT",
   "postcode": "3936"
 },
 {
   "suburb": "DROMANA",
   "postcode": "3936"
 },
 {
   "suburb": "SAFETY BEACH",
   "postcode": "3936"
 },
 {
   "suburb": "RED HILL",
   "postcode": "3937"
 },
 {
   "suburb": "RED HILL SOUTH",
   "postcode": "3937"
 },
 {
   "suburb": "MCCRAE",
   "postcode": "3938"
 },
 {
   "suburb": "BONEO",
   "postcode": "3939"
 },
 {
   "suburb": "CAPE SCHANCK",
   "postcode": "3939"
 },
 {
   "suburb": "FINGAL",
   "postcode": "3939"
 },
 {
   "suburb": "ROSEBUD",
   "postcode": "3939"
 },
 {
   "suburb": "ROSEBUD PLAZA",
   "postcode": "3939"
 },
 {
   "suburb": "CAPEL SOUND",
   "postcode": "3940"
 },
 {
   "suburb": "ROSEBUD WEST",
   "postcode": "3940"
 },
 {
   "suburb": "RYE",
   "postcode": "3941"
 },
 {
   "suburb": "ST ANDREWS BEACH",
   "postcode": "3941"
 },
 {
   "suburb": "TOOTGAROOK",
   "postcode": "3941"
 },
 {
   "suburb": "BLAIRGOWRIE",
   "postcode": "3942"
 },
 {
   "suburb": "SORRENTO",
   "postcode": "3943"
 },
 {
   "suburb": "PORTSEA",
   "postcode": "3944"
 },
 {
   "suburb": "JEETHO",
   "postcode": "3945"
 },
 {
   "suburb": "KROWERA",
   "postcode": "3945"
 },
 {
   "suburb": "LOCH",
   "postcode": "3945"
 },
 {
   "suburb": "WOODLEIGH",
   "postcode": "3945"
 },
 {
   "suburb": "BENA",
   "postcode": "3946"
 },
 {
   "suburb": "KARDELLA SOUTH",
   "postcode": "3950"
 },
 {
   "suburb": "KORUMBURRA",
   "postcode": "3950"
 },
 {
   "suburb": "KORUMBURRA SOUTH",
   "postcode": "3950"
 },
 {
   "suburb": "STRZELECKI",
   "postcode": "3950"
 },
 {
   "suburb": "WHITELAW",
   "postcode": "3950"
 },
 {
   "suburb": "ARAWATA",
   "postcode": "3951"
 },
 {
   "suburb": "FAIRBANK",
   "postcode": "3951"
 },
 {
   "suburb": "JUMBUNNA",
   "postcode": "3951"
 },
 {
   "suburb": "KARDELLA",
   "postcode": "3951"
 },
 {
   "suburb": "KONGWAK",
   "postcode": "3951"
 },
 {
   "suburb": "MOYARRA",
   "postcode": "3951"
 },
 {
   "suburb": "OUTTRIM",
   "postcode": "3951"
 },
 {
   "suburb": "RANCEBY",
   "postcode": "3951"
 },
 {
   "suburb": "BERRYS CREEK",
   "postcode": "3953"
 },
 {
   "suburb": "BOOROOL",
   "postcode": "3953"
 },
 {
   "suburb": "HALLSTON",
   "postcode": "3953"
 },
 {
   "suburb": "KOOROOMAN",
   "postcode": "3953"
 },
 {
   "suburb": "LEONGATHA",
   "postcode": "3953"
 },
 {
   "suburb": "LEONGATHA NORTH",
   "postcode": "3953"
 },
 {
   "suburb": "LEONGATHA SOUTH",
   "postcode": "3953"
 },
 {
   "suburb": "MARDAN",
   "postcode": "3953"
 },
 {
   "suburb": "MOUNT ECCLES",
   "postcode": "3953"
 },
 {
   "suburb": "MOUNT ECCLES SOUTH",
   "postcode": "3953"
 },
 {
   "suburb": "NERRENA",
   "postcode": "3953"
 },
 {
   "suburb": "RUBY",
   "postcode": "3953"
 },
 {
   "suburb": "TRIDA",
   "postcode": "3953"
 },
 {
   "suburb": "WILD DOG VALLEY",
   "postcode": "3953"
 },
 {
   "suburb": "WOOREEN",
   "postcode": "3953"
 },
 {
   "suburb": "KOONWARRA",
   "postcode": "3954"
 },
 {
   "suburb": "DUMBALK",
   "postcode": "3956"
 },
 {
   "suburb": "DUMBALK NORTH",
   "postcode": "3956"
 },
 {
   "suburb": "MEENIYAN",
   "postcode": "3956"
 },
 {
   "suburb": "MIDDLE TARWIN",
   "postcode": "3956"
 },
 {
   "suburb": "TARWIN",
   "postcode": "3956"
 },
 {
   "suburb": "TARWIN LOWER",
   "postcode": "3956"
 },
 {
   "suburb": "VENUS BAY",
   "postcode": "3956"
 },
 {
   "suburb": "WALKERVILLE",
   "postcode": "3956"
 },
 {
   "suburb": "WALKERVILLE NORTH",
   "postcode": "3956"
 },
 {
   "suburb": "WALKERVILLE SOUTH",
   "postcode": "3956"
 },
 {
   "suburb": "GRASSY SPUR",
   "postcode": "3957"
 },
 {
   "suburb": "STONY CREEK",
   "postcode": "3957"
 },
 {
   "suburb": "BUFFALO",
   "postcode": "3958"
 },
 {
   "suburb": "BUFFALO CREEK",
   "postcode": "3958"
 },
 {
   "suburb": "FISH CREEK",
   "postcode": "3959"
 },
 {
   "suburb": "SANDY POINT",
   "postcode": "3959"
 },
 {
   "suburb": "WARATAH BAY",
   "postcode": "3959"
 },
 {
   "suburb": "BENNISON",
   "postcode": "3960"
 },
 {
   "suburb": "BOOLARONG",
   "postcode": "3960"
 },
 {
   "suburb": "FOSTER",
   "postcode": "3960"
 },
 {
   "suburb": "FOSTER NORTH",
   "postcode": "3960"
 },
 {
   "suburb": "GUNYAH",
   "postcode": "3960"
 },
 {
   "suburb": "MOUNT BEST",
   "postcode": "3960"
 },
 {
   "suburb": "SHALLOW INLET",
   "postcode": "3960"
 },
 {
   "suburb": "TIDAL RIVER",
   "postcode": "3960"
 },
 {
   "suburb": "TURTONS CREEK",
   "postcode": "3960"
 },
 {
   "suburb": "WILSONS PROMONTORY",
   "postcode": "3960"
 },
 {
   "suburb": "WONGA",
   "postcode": "3960"
 },
 {
   "suburb": "WOORARRA WEST",
   "postcode": "3960"
 },
 {
   "suburb": "YANAKIE",
   "postcode": "3960"
 },
 {
   "suburb": "AGNES",
   "postcode": "3962"
 },
 {
   "suburb": "TOORA",
   "postcode": "3962"
 },
 {
   "suburb": "TOORA NORTH",
   "postcode": "3962"
 },
 {
   "suburb": "WONYIP",
   "postcode": "3962"
 },
 {
   "suburb": "WOORARRA EAST",
   "postcode": "3962"
 },
 {
   "suburb": "PORT FRANKLIN",
   "postcode": "3964"
 },
 {
   "suburb": "PORT WELSHPOOL",
   "postcode": "3965"
 },
 {
   "suburb": "BINGINWARRI",
   "postcode": "3966"
 },
 {
   "suburb": "HAZEL PARK",
   "postcode": "3966"
 },
 {
   "suburb": "WELSHPOOL",
   "postcode": "3966"
 },
 {
   "suburb": "HEDLEY",
   "postcode": "3967"
 },
 {
   "suburb": "ALBERTON",
   "postcode": "3971"
 },
 {
   "suburb": "ALBERTON WEST",
   "postcode": "3971"
 },
 {
   "suburb": "BALOOK",
   "postcode": "3971"
 },
 {
   "suburb": "CALROSSIE",
   "postcode": "3971"
 },
 {
   "suburb": "DEVON NORTH",
   "postcode": "3971"
 },
 {
   "suburb": "GELLIONDALE",
   "postcode": "3971"
 },
 {
   "suburb": "HIAWATHA",
   "postcode": "3971"
 },
 {
   "suburb": "HUNTERSTON",
   "postcode": "3971"
 },
 {
   "suburb": "JACK RIVER",
   "postcode": "3971"
 },
 {
   "suburb": "LANGSBOROUGH",
   "postcode": "3971"
 },
 {
   "suburb": "MACKS CREEK",
   "postcode": "3971"
 },
 {
   "suburb": "MADALYA",
   "postcode": "3971"
 },
 {
   "suburb": "MANNS BEACH",
   "postcode": "3971"
 },
 {
   "suburb": "PORT ALBERT",
   "postcode": "3971"
 },
 {
   "suburb": "ROBERTSONS BEACH",
   "postcode": "3971"
 },
 {
   "suburb": "SNAKE ISLAND",
   "postcode": "3971"
 },
 {
   "suburb": "STACEYS BRIDGE",
   "postcode": "3971"
 },
 {
   "suburb": "TARRA VALLEY",
   "postcode": "3971"
 },
 {
   "suburb": "TARRAVILLE",
   "postcode": "3971"
 },
 {
   "suburb": "WON WRON",
   "postcode": "3971"
 },
 {
   "suburb": "YARRAM",
   "postcode": "3971"
 },
 {
   "suburb": "LYNBROOK",
   "postcode": "3975"
 },
 {
   "suburb": "LYNDHURST",
   "postcode": "3975"
 },
 {
   "suburb": "HAMPTON PARK",
   "postcode": "3976"
 },
 {
   "suburb": "BOTANIC RIDGE",
   "postcode": "3977"
 },
 {
   "suburb": "CANNONS CREEK",
   "postcode": "3977"
 },
 {
   "suburb": "CRANBOURNE",
   "postcode": "3977"
 },
 {
   "suburb": "CRANBOURNE EAST",
   "postcode": "3977"
 },
 {
   "suburb": "CRANBOURNE NORTH",
   "postcode": "3977"
 },
 {
   "suburb": "CRANBOURNE SOUTH",
   "postcode": "3977"
 },
 {
   "suburb": "CRANBOURNE WEST",
   "postcode": "3977"
 },
 {
   "suburb": "DEVON MEADOWS",
   "postcode": "3977"
 },
 {
   "suburb": "JUNCTION VILLAGE",
   "postcode": "3977"
 },
 {
   "suburb": "SANDHURST",
   "postcode": "3977"
 },
 {
   "suburb": "SKYE",
   "postcode": "3977"
 },
 {
   "suburb": "CARDINIA",
   "postcode": "3978"
 },
 {
   "suburb": "CLYDE",
   "postcode": "3978"
 },
 {
   "suburb": "CLYDE NORTH",
   "postcode": "3978"
 },
 {
   "suburb": "ALMURTA",
   "postcode": "3979"
 },
 {
   "suburb": "GLEN ALVIE",
   "postcode": "3979"
 },
 {
   "suburb": "KERNOT",
   "postcode": "3979"
 },
 {
   "suburb": "BLIND BIGHT",
   "postcode": "3980"
 },
 {
   "suburb": "TOORADIN",
   "postcode": "3980"
 },
 {
   "suburb": "WARNEET",
   "postcode": "3980"
 },
 {
   "suburb": "BAYLES",
   "postcode": "3981"
 },
 {
   "suburb": "CATANI",
   "postcode": "3981"
 },
 {
   "suburb": "DALMORE",
   "postcode": "3981"
 },
 {
   "suburb": "HEATH HILL",
   "postcode": "3981"
 },
 {
   "suburb": "KOO WEE RUP",
   "postcode": "3981"
 },
 {
   "suburb": "KOO WEE RUP NORTH",
   "postcode": "3981"
 },
 {
   "suburb": "YANNATHAN",
   "postcode": "3981"
 },
 {
   "suburb": "ADAMS ESTATE",
   "postcode": "3984"
 },
 {
   "suburb": "CALDERMEADE",
   "postcode": "3984"
 },
 {
   "suburb": "CORINELLA",
   "postcode": "3984"
 },
 {
   "suburb": "CORONET BAY",
   "postcode": "3984"
 },
 {
   "suburb": "GRANTVILLE",
   "postcode": "3984"
 },
 {
   "suburb": "JAM JERRUP",
   "postcode": "3984"
 },
 {
   "suburb": "LANG LANG",
   "postcode": "3984"
 },
 {
   "suburb": "LANG LANG EAST",
   "postcode": "3984"
 },
 {
   "suburb": "MONOMEITH",
   "postcode": "3984"
 },
 {
   "suburb": "PIONEER BAY",
   "postcode": "3984"
 },
 {
   "suburb": "QUEENSFERRY",
   "postcode": "3984"
 },
 {
   "suburb": "TENBY POINT",
   "postcode": "3984"
 },
 {
   "suburb": "THE GURDIES",
   "postcode": "3984"
 },
 {
   "suburb": "NYORA",
   "postcode": "3987"
 },
 {
   "suburb": "MOUNTAIN VIEW",
   "postcode": "3988"
 },
 {
   "suburb": "POOWONG",
   "postcode": "3988"
 },
 {
   "suburb": "POOWONG EAST",
   "postcode": "3988"
 },
 {
   "suburb": "POOWONG NORTH",
   "postcode": "3988"
 },
 {
   "suburb": "GLEN FORBES",
   "postcode": "3990"
 },
 {
   "suburb": "BASS",
   "postcode": "3991"
 },
 {
   "suburb": "BLACKWOOD FOREST",
   "postcode": "3992"
 },
 {
   "suburb": "DALYSTON",
   "postcode": "3992"
 },
 {
   "suburb": "RYANSTON",
   "postcode": "3992"
 },
 {
   "suburb": "WEST CREEK",
   "postcode": "3992"
 },
 {
   "suburb": "ANDERSON",
   "postcode": "3995"
 },
 {
   "suburb": "ARCHIES CREEK",
   "postcode": "3995"
 },
 {
   "suburb": "CAPE PATERSON",
   "postcode": "3995"
 },
 {
   "suburb": "HARMERS HAVEN",
   "postcode": "3995"
 },
 {
   "suburb": "KILCUNDA",
   "postcode": "3995"
 },
 {
   "suburb": "LANCE CREEK",
   "postcode": "3995"
 },
 {
   "suburb": "NORTH WONTHAGGI",
   "postcode": "3995"
 },
 {
   "suburb": "SOUTH DUDLEY",
   "postcode": "3995"
 },
 {
   "suburb": "ST CLAIR",
   "postcode": "3995"
 },
 {
   "suburb": "WATTLE BANK",
   "postcode": "3995"
 },
 {
   "suburb": "WONTHAGGI",
   "postcode": "3995"
 },
 {
   "suburb": "WOOLAMAI",
   "postcode": "3995"
 },
 {
   "suburb": "INVERLOCH",
   "postcode": "3996"
 },
 {
   "suburb": "POUND CREEK",
   "postcode": "3996"
 },
 {
   "suburb": "BRISBANE",
   "postcode": "4000"
 },
 {
   "suburb": "BRISBANE ADELAIDE STREET",
   "postcode": "4000"
 },
 {
   "suburb": "BRISBANE CITY",
   "postcode": "4000"
 },
 {
   "suburb": "BRISBANE CITY DC",
   "postcode": "4000"
 },
 {
   "suburb": "BRISBANE GPO",
   "postcode": "4000"
 },
 {
   "suburb": "BRISBANE-CITY",
   "postcode": "4000"
 },
 {
   "suburb": "PARLIAMENT HOUSE",
   "postcode": "4000"
 },
 {
   "suburb": "PETRIE TERRACE",
   "postcode": "4000"
 },
 {
   "suburb": "SPRING HILL",
   "postcode": "4000"
 },
 {
   "suburb": "SPRING HILL",
   "postcode": "4004"
 },
 {
   "suburb": "NEW FARM",
   "postcode": "4005"
 },
 {
   "suburb": "TENERIFFE",
   "postcode": "4005"
 },
 {
   "suburb": "BOWEN HILLS",
   "postcode": "4006"
 },
 {
   "suburb": "BRISBANE CITY",
   "postcode": "4006"
 },
 {
   "suburb": "FORTITUDE VALLEY",
   "postcode": "4006"
 },
 {
   "suburb": "HERSTON",
   "postcode": "4006"
 },
 {
   "suburb": "NEWSTEAD",
   "postcode": "4006"
 },
 {
   "suburb": "ASCOT",
   "postcode": "4007"
 },
 {
   "suburb": "BRISBANE AIRPORT",
   "postcode": "4007"
 },
 {
   "suburb": "DOOMBEN",
   "postcode": "4007"
 },
 {
   "suburb": "HAMILTON",
   "postcode": "4007"
 },
 {
   "suburb": "HAMILTON CENTRAL",
   "postcode": "4007"
 },
 {
   "suburb": "WHINSTANES",
   "postcode": "4007"
 },
 {
   "suburb": "BRISBANE AIRPORT",
   "postcode": "4008"
 },
 {
   "suburb": "BULWER ISLAND",
   "postcode": "4008"
 },
 {
   "suburb": "MEEANDAH",
   "postcode": "4008"
 },
 {
   "suburb": "MYRTLETOWN",
   "postcode": "4008"
 },
 {
   "suburb": "PINKENBA",
   "postcode": "4008"
 },
 {
   "suburb": "EAGLE FARM",
   "postcode": "4009"
 },
 {
   "suburb": "EAGLE FARM BC",
   "postcode": "4009"
 },
 {
   "suburb": "ALBION",
   "postcode": "4010"
 },
 {
   "suburb": "ALBION BC",
   "postcode": "4010"
 },
 {
   "suburb": "ALBION DC",
   "postcode": "4010"
 },
 {
   "suburb": "BREAKFAST CREEK",
   "postcode": "4010"
 },
 {
   "suburb": "CLAYFIELD",
   "postcode": "4011"
 },
 {
   "suburb": "EAGLE JUNCTION",
   "postcode": "4011"
 },
 {
   "suburb": "HENDRA",
   "postcode": "4011"
 },
 {
   "suburb": "NUNDAH",
   "postcode": "4012"
 },
 {
   "suburb": "TOOMBUL",
   "postcode": "4012"
 },
 {
   "suburb": "WAVELL HEIGHTS",
   "postcode": "4012"
 },
 {
   "suburb": "WAVELL HEIGHTS NORTH",
   "postcode": "4012"
 },
 {
   "suburb": "NORTHGATE",
   "postcode": "4013"
 },
 {
   "suburb": "NORTHGATE MC",
   "postcode": "4013"
 },
 {
   "suburb": "BANYO",
   "postcode": "4014"
 },
 {
   "suburb": "NUDGEE",
   "postcode": "4014"
 },
 {
   "suburb": "NUDGEE BEACH",
   "postcode": "4014"
 },
 {
   "suburb": "VIRGINIA",
   "postcode": "4014"
 },
 {
   "suburb": "VIRGINIA BC",
   "postcode": "4014"
 },
 {
   "suburb": "VIRGINIA DC",
   "postcode": "4014"
 },
 {
   "suburb": "BRACKEN RIDGE",
   "postcode": "4017"
 },
 {
   "suburb": "BRIGHTON",
   "postcode": "4017"
 },
 {
   "suburb": "BRIGHTON EVENTIDE",
   "postcode": "4017"
 },
 {
   "suburb": "BRIGHTON NATHAN STREET",
   "postcode": "4017"
 },
 {
   "suburb": "DEAGON",
   "postcode": "4017"
 },
 {
   "suburb": "NASHVILLE",
   "postcode": "4017"
 },
 {
   "suburb": "SANDGATE",
   "postcode": "4017"
 },
 {
   "suburb": "SANDGATE DC",
   "postcode": "4017"
 },
 {
   "suburb": "SHORNCLIFFE",
   "postcode": "4017"
 },
 {
   "suburb": "FITZGIBBON",
   "postcode": "4018"
 },
 {
   "suburb": "TAIGUM",
   "postcode": "4018"
 },
 {
   "suburb": "CLONTARF",
   "postcode": "4019"
 },
 {
   "suburb": "CLONTARF BEACH",
   "postcode": "4019"
 },
 {
   "suburb": "MARGATE",
   "postcode": "4019"
 },
 {
   "suburb": "MARGATE BEACH",
   "postcode": "4019"
 },
 {
   "suburb": "SCOTTS POINT",
   "postcode": "4019"
 },
 {
   "suburb": "WOODY POINT",
   "postcode": "4019"
 },
 {
   "suburb": "NEWPORT",
   "postcode": "4020"
 },
 {
   "suburb": "REDCLIFFE",
   "postcode": "4020"
 },
 {
   "suburb": "REDCLIFFE NORTH",
   "postcode": "4020"
 },
 {
   "suburb": "SCARBOROUGH",
   "postcode": "4020"
 },
 {
   "suburb": "KIPPA-RING",
   "postcode": "4021"
 },
 {
   "suburb": "ROTHWELL",
   "postcode": "4022"
 },
 {
   "suburb": "ROYAL BRISBANE HOSPITAL",
   "postcode": "4029"
 },
 {
   "suburb": "EILDON HILL",
   "postcode": "4030"
 },
 {
   "suburb": "KALINGA",
   "postcode": "4030"
 },
 {
   "suburb": "LUTWYCHE",
   "postcode": "4030"
 },
 {
   "suburb": "WINDSOR",
   "postcode": "4030"
 },
 {
   "suburb": "WOOLOOWIN",
   "postcode": "4030"
 },
 {
   "suburb": "GLEN KEDRON",
   "postcode": "4031"
 },
 {
   "suburb": "GORDON PARK",
   "postcode": "4031"
 },
 {
   "suburb": "KEDRON",
   "postcode": "4031"
 },
 {
   "suburb": "CHERMSIDE",
   "postcode": "4032"
 },
 {
   "suburb": "CHERMSIDE CENTRE",
   "postcode": "4032"
 },
 {
   "suburb": "CHERMSIDE SOUTH",
   "postcode": "4032"
 },
 {
   "suburb": "CHERMSIDE WEST",
   "postcode": "4032"
 },
 {
   "suburb": "CRAIGSLEA",
   "postcode": "4032"
 },
 {
   "suburb": "ASPLEY",
   "postcode": "4034"
 },
 {
   "suburb": "BOONDALL",
   "postcode": "4034"
 },
 {
   "suburb": "CARSELDINE",
   "postcode": "4034"
 },
 {
   "suburb": "GEEBUNG",
   "postcode": "4034"
 },
 {
   "suburb": "ZILLMERE",
   "postcode": "4034"
 },
 {
   "suburb": "ALBANY CREEK",
   "postcode": "4035"
 },
 {
   "suburb": "BRIDGEMAN DOWNS",
   "postcode": "4035"
 },
 {
   "suburb": "CASHS CROSSING",
   "postcode": "4035"
 },
 {
   "suburb": "BALD HILLS",
   "postcode": "4036"
 },
 {
   "suburb": "EATONS HILL",
   "postcode": "4037"
 },
 {
   "suburb": "ALDERLEY",
   "postcode": "4051"
 },
 {
   "suburb": "ENOGGERA",
   "postcode": "4051"
 },
 {
   "suburb": "GAYTHORNE",
   "postcode": "4051"
 },
 {
   "suburb": "GRANGE",
   "postcode": "4051"
 },
 {
   "suburb": "NEWMARKET",
   "postcode": "4051"
 },
 {
   "suburb": "THE GRANGE",
   "postcode": "4051"
 },
 {
   "suburb": "WILSTON",
   "postcode": "4051"
 },
 {
   "suburb": "BROOKSIDE CENTRE",
   "postcode": "4053"
 },
 {
   "suburb": "EVERTON HILLS",
   "postcode": "4053"
 },
 {
   "suburb": "EVERTON PARK",
   "postcode": "4053"
 },
 {
   "suburb": "MCDOWALL",
   "postcode": "4053"
 },
 {
   "suburb": "MITCHELTON",
   "postcode": "4053"
 },
 {
   "suburb": "OXFORD PARK",
   "postcode": "4053"
 },
 {
   "suburb": "SOMERSET HILLS",
   "postcode": "4053"
 },
 {
   "suburb": "STAFFORD",
   "postcode": "4053"
 },
 {
   "suburb": "STAFFORD BC",
   "postcode": "4053"
 },
 {
   "suburb": "STAFFORD CITY",
   "postcode": "4053"
 },
 {
   "suburb": "STAFFORD DC",
   "postcode": "4053"
 },
 {
   "suburb": "STAFFORD HEIGHTS",
   "postcode": "4053"
 },
 {
   "suburb": "ARANA HILLS",
   "postcode": "4054"
 },
 {
   "suburb": "GROVELY",
   "postcode": "4054"
 },
 {
   "suburb": "KEPERRA",
   "postcode": "4054"
 },
 {
   "suburb": "BUNYA",
   "postcode": "4055"
 },
 {
   "suburb": "FERNY GROVE",
   "postcode": "4055"
 },
 {
   "suburb": "FERNY HILLS",
   "postcode": "4055"
 },
 {
   "suburb": "FERNY HILLS DC",
   "postcode": "4055"
 },
 {
   "suburb": "KEDRON UPPER",
   "postcode": "4055"
 },
 {
   "suburb": "UPPER KEDRON",
   "postcode": "4055"
 },
 {
   "suburb": "BALLYMORE",
   "postcode": "4059"
 },
 {
   "suburb": "ITHACA",
   "postcode": "4059"
 },
 {
   "suburb": "KELVIN GROVE",
   "postcode": "4059"
 },
 {
   "suburb": "NORMANBY",
   "postcode": "4059"
 },
 {
   "suburb": "RED HILL",
   "postcode": "4059"
 },
 {
   "suburb": "ASHGROVE",
   "postcode": "4060"
 },
 {
   "suburb": "ASHGROVE EAST",
   "postcode": "4060"
 },
 {
   "suburb": "ASHGROVE WEST",
   "postcode": "4060"
 },
 {
   "suburb": "DORRINGTON",
   "postcode": "4060"
 },
 {
   "suburb": "ST JOHNS WOOD",
   "postcode": "4060"
 },
 {
   "suburb": "THE GAP",
   "postcode": "4061"
 },
 {
   "suburb": "BAROONA",
   "postcode": "4064"
 },
 {
   "suburb": "MILTON",
   "postcode": "4064"
 },
 {
   "suburb": "MILTON BC",
   "postcode": "4064"
 },
 {
   "suburb": "PADDINGTON",
   "postcode": "4064"
 },
 {
   "suburb": "ROSALIE",
   "postcode": "4064"
 },
 {
   "suburb": "BARDON",
   "postcode": "4065"
 },
 {
   "suburb": "BARDON WEST",
   "postcode": "4065"
 },
 {
   "suburb": "JUBILEE",
   "postcode": "4065"
 },
 {
   "suburb": "RAINWORTH",
   "postcode": "4065"
 },
 {
   "suburb": "AUCHENFLOWER",
   "postcode": "4066"
 },
 {
   "suburb": "MOUNT COOT-THA",
   "postcode": "4066"
 },
 {
   "suburb": "STUARTHOLME",
   "postcode": "4066"
 },
 {
   "suburb": "TOOWONG",
   "postcode": "4066"
 },
 {
   "suburb": "TOOWONG BC",
   "postcode": "4066"
 },
 {
   "suburb": "TOOWONG DC",
   "postcode": "4066"
 },
 {
   "suburb": "TORWOOD",
   "postcode": "4066"
 },
 {
   "suburb": "IRONSIDE",
   "postcode": "4067"
 },
 {
   "suburb": "SAINT LUCIA",
   "postcode": "4067"
 },
 {
   "suburb": "ST LUCIA",
   "postcode": "4067"
 },
 {
   "suburb": "ST LUCIA SOUTH",
   "postcode": "4067"
 },
 {
   "suburb": "CHELMER",
   "postcode": "4068"
 },
 {
   "suburb": "INDOOROOPILLY",
   "postcode": "4068"
 },
 {
   "suburb": "INDOOROOPILLY CENTRE",
   "postcode": "4068"
 },
 {
   "suburb": "LONG POCKET",
   "postcode": "4068"
 },
 {
   "suburb": "TARINGA",
   "postcode": "4068"
 },
 {
   "suburb": "BROOKFIELD",
   "postcode": "4069"
 },
 {
   "suburb": "CHAPEL HILL",
   "postcode": "4069"
 },
 {
   "suburb": "FIG TREE POCKET",
   "postcode": "4069"
 },
 {
   "suburb": "KENMORE",
   "postcode": "4069"
 },
 {
   "suburb": "KENMORE EAST",
   "postcode": "4069"
 },
 {
   "suburb": "KENMORE HILLS",
   "postcode": "4069"
 },
 {
   "suburb": "PINJARRA HILLS",
   "postcode": "4069"
 },
 {
   "suburb": "PULLENVALE",
   "postcode": "4069"
 },
 {
   "suburb": "UPPER BROOKFIELD",
   "postcode": "4069"
 },
 {
   "suburb": "ANSTEAD",
   "postcode": "4070"
 },
 {
   "suburb": "BELLBOWRIE",
   "postcode": "4070"
 },
 {
   "suburb": "MOGGILL",
   "postcode": "4070"
 },
 {
   "suburb": "SAINT LUCIA",
   "postcode": "4072"
 },
 {
   "suburb": "UNIVERSITY OF QUEENSLAND",
   "postcode": "4072"
 },
 {
   "suburb": "SEVENTEEN MILE ROCKS",
   "postcode": "4073"
 },
 {
   "suburb": "SINNAMON PARK",
   "postcode": "4073"
 },
 {
   "suburb": "JAMBOREE HEIGHTS",
   "postcode": "4074"
 },
 {
   "suburb": "JINDALEE",
   "postcode": "4074"
 },
 {
   "suburb": "MIDDLE PARK",
   "postcode": "4074"
 },
 {
   "suburb": "MOUNT OMMANEY",
   "postcode": "4074"
 },
 {
   "suburb": "RIVERHILLS",
   "postcode": "4074"
 },
 {
   "suburb": "SUMNER",
   "postcode": "4074"
 },
 {
   "suburb": "SUMNER PARK BC",
   "postcode": "4074"
 },
 {
   "suburb": "WESTLAKE",
   "postcode": "4074"
 },
 {
   "suburb": "CORINDA",
   "postcode": "4075"
 },
 {
   "suburb": "GRACEVILLE",
   "postcode": "4075"
 },
 {
   "suburb": "GRACEVILLE EAST",
   "postcode": "4075"
 },
 {
   "suburb": "OXLEY",
   "postcode": "4075"
 },
 {
   "suburb": "SHERWOOD",
   "postcode": "4075"
 },
 {
   "suburb": "DARRA",
   "postcode": "4076"
 },
 {
   "suburb": "WACOL",
   "postcode": "4076"
 },
 {
   "suburb": "DOOLANDELLA",
   "postcode": "4077"
 },
 {
   "suburb": "DURACK",
   "postcode": "4077"
 },
 {
   "suburb": "INALA",
   "postcode": "4077"
 },
 {
   "suburb": "INALA EAST",
   "postcode": "4077"
 },
 {
   "suburb": "INALA HEIGHTS",
   "postcode": "4077"
 },
 {
   "suburb": "INALA WEST",
   "postcode": "4077"
 },
 {
   "suburb": "RICHLANDS",
   "postcode": "4077"
 },
 {
   "suburb": "RICHLANDS BC",
   "postcode": "4077"
 },
 {
   "suburb": "RICHLANDS DC",
   "postcode": "4077"
 },
 {
   "suburb": "SERVICETON",
   "postcode": "4077"
 },
 {
   "suburb": "ELLEN GROVE",
   "postcode": "4078"
 },
 {
   "suburb": "FOREST LAKE",
   "postcode": "4078"
 },
 {
   "suburb": "HIGHGATE HILL",
   "postcode": "4101"
 },
 {
   "suburb": "MATER HILL",
   "postcode": "4101"
 },
 {
   "suburb": "MATER HOSPITAL",
   "postcode": "4101"
 },
 {
   "suburb": "SOUTH BANK",
   "postcode": "4101"
 },
 {
   "suburb": "SOUTH BRISBANE",
   "postcode": "4101"
 },
 {
   "suburb": "SOUTH BRISBANE BC",
   "postcode": "4101"
 },
 {
   "suburb": "WEST END",
   "postcode": "4101"
 },
 {
   "suburb": "BURANDA",
   "postcode": "4102"
 },
 {
   "suburb": "DUTTON PARK",
   "postcode": "4102"
 },
 {
   "suburb": "PRINCESS ALEXANDRA HOSPITAL",
   "postcode": "4102"
 },
 {
   "suburb": "WOOLLOONGABBA",
   "postcode": "4102"
 },
 {
   "suburb": "ANNERLEY",
   "postcode": "4103"
 },
 {
   "suburb": "ANNERLEY DC",
   "postcode": "4103"
 },
 {
   "suburb": "FAIRFIELD",
   "postcode": "4103"
 },
 {
   "suburb": "FAIRFIELD GARDENS",
   "postcode": "4103"
 },
 {
   "suburb": "THOMPSON ESTATE",
   "postcode": "4103"
 },
 {
   "suburb": "YERONGA",
   "postcode": "4104"
 },
 {
   "suburb": "YERONGA WEST",
   "postcode": "4104"
 },
 {
   "suburb": "CLIFTON HILL",
   "postcode": "4105"
 },
 {
   "suburb": "MOOROOKA",
   "postcode": "4105"
 },
 {
   "suburb": "MOORVALE",
   "postcode": "4105"
 },
 {
   "suburb": "TENNYSON",
   "postcode": "4105"
 },
 {
   "suburb": "YEERONGPILLY",
   "postcode": "4105"
 },
 {
   "suburb": "BRISBANE MARKET",
   "postcode": "4106"
 },
 {
   "suburb": "ROCKLEA",
   "postcode": "4106"
 },
 {
   "suburb": "ROCKLEA DC",
   "postcode": "4106"
 },
 {
   "suburb": "SALISBURY",
   "postcode": "4107"
 },
 {
   "suburb": "SALISBURY EAST",
   "postcode": "4107"
 },
 {
   "suburb": "ARCHERFIELD",
   "postcode": "4108"
 },
 {
   "suburb": "COOPERS PLAINS",
   "postcode": "4108"
 },
 {
   "suburb": "ALTANDI",
   "postcode": "4109"
 },
 {
   "suburb": "BANOON",
   "postcode": "4109"
 },
 {
   "suburb": "MACGREGOR",
   "postcode": "4109"
 },
 {
   "suburb": "ROBERTSON",
   "postcode": "4109"
 },
 {
   "suburb": "SUNNYBANK",
   "postcode": "4109"
 },
 {
   "suburb": "SUNNYBANK HILLS",
   "postcode": "4109"
 },
 {
   "suburb": "SUNNYBANK SOUTH",
   "postcode": "4109"
 },
 {
   "suburb": "ACACIA RIDGE",
   "postcode": "4110"
 },
 {
   "suburb": "ACACIA RIDGE BC",
   "postcode": "4110"
 },
 {
   "suburb": "ACACIA RIDGE DC",
   "postcode": "4110"
 },
 {
   "suburb": "HEATHWOOD",
   "postcode": "4110"
 },
 {
   "suburb": "HEATHWOOD DF",
   "postcode": "4110"
 },
 {
   "suburb": "LARAPINTA",
   "postcode": "4110"
 },
 {
   "suburb": "PALLARA",
   "postcode": "4110"
 },
 {
   "suburb": "WILLAWONG",
   "postcode": "4110"
 },
 {
   "suburb": "GRIFFITH UNIVERSITY",
   "postcode": "4111"
 },
 {
   "suburb": "NATHAN",
   "postcode": "4111"
 },
 {
   "suburb": "KURABY",
   "postcode": "4112"
 },
 {
   "suburb": "EIGHT MILE PLAINS",
   "postcode": "4113"
 },
 {
   "suburb": "FRUITGROVE",
   "postcode": "4113"
 },
 {
   "suburb": "RUNCORN",
   "postcode": "4113"
 },
 {
   "suburb": "KINGSTON",
   "postcode": "4114"
 },
 {
   "suburb": "LOGAN CENTRAL",
   "postcode": "4114"
 },
 {
   "suburb": "LOGAN CITY BC",
   "postcode": "4114"
 },
 {
   "suburb": "LOGAN CITY DC",
   "postcode": "4114"
 },
 {
   "suburb": "TRINDER PARK",
   "postcode": "4114"
 },
 {
   "suburb": "WOODRIDGE",
   "postcode": "4114"
 },
 {
   "suburb": "WOODRIDGE EAST",
   "postcode": "4114"
 },
 {
   "suburb": "ALGESTER",
   "postcode": "4115"
 },
 {
   "suburb": "PARKINSON",
   "postcode": "4115"
 },
 {
   "suburb": "CALAMVALE",
   "postcode": "4116"
 },
 {
   "suburb": "DREWVALE",
   "postcode": "4116"
 },
 {
   "suburb": "STRETTON",
   "postcode": "4116"
 },
 {
   "suburb": "BERRINBA",
   "postcode": "4117"
 },
 {
   "suburb": "KARAWATHA",
   "postcode": "4117"
 },
 {
   "suburb": "BROWNS PLAINS",
   "postcode": "4118"
 },
 {
   "suburb": "BROWNS PLAINS BC",
   "postcode": "4118"
 },
 {
   "suburb": "BROWNSLEIGH",
   "postcode": "4118"
 },
 {
   "suburb": "FORESTDALE",
   "postcode": "4118"
 },
 {
   "suburb": "HERITAGE PARK",
   "postcode": "4118"
 },
 {
   "suburb": "HILLCREST",
   "postcode": "4118"
 },
 {
   "suburb": "REGENTS PARK",
   "postcode": "4118"
 },
 {
   "suburb": "UNDERWOOD",
   "postcode": "4119"
 },
 {
   "suburb": "COORPAROO",
   "postcode": "4120"
 },
 {
   "suburb": "GREENSLOPES",
   "postcode": "4120"
 },
 {
   "suburb": "LORETO HILL",
   "postcode": "4120"
 },
 {
   "suburb": "STONES CORNER",
   "postcode": "4120"
 },
 {
   "suburb": "EKIBIN",
   "postcode": "4121"
 },
 {
   "suburb": "HOLLAND PARK",
   "postcode": "4121"
 },
 {
   "suburb": "HOLLAND PARK EAST",
   "postcode": "4121"
 },
 {
   "suburb": "HOLLAND PARK WEST",
   "postcode": "4121"
 },
 {
   "suburb": "MOUNT THOMPSON",
   "postcode": "4121"
 },
 {
   "suburb": "TARRAGINDI",
   "postcode": "4121"
 },
 {
   "suburb": "WELLERS HILL",
   "postcode": "4121"
 },
 {
   "suburb": "MANSFIELD",
   "postcode": "4122"
 },
 {
   "suburb": "MANSFIELD BC",
   "postcode": "4122"
 },
 {
   "suburb": "MANSFIELD DC",
   "postcode": "4122"
 },
 {
   "suburb": "MOUNT GRAVATT",
   "postcode": "4122"
 },
 {
   "suburb": "MOUNT GRAVATT EAST",
   "postcode": "4122"
 },
 {
   "suburb": "UPPER MOUNT GRAVATT",
   "postcode": "4122"
 },
 {
   "suburb": "UPPER MOUNT GRAVATT BC",
   "postcode": "4122"
 },
 {
   "suburb": "WISHART",
   "postcode": "4122"
 },
 {
   "suburb": "PRIESTS GULLY",
   "postcode": "4123"
 },
 {
   "suburb": "ROCHEDALE",
   "postcode": "4123"
 },
 {
   "suburb": "ROCHEDALE SOUTH",
   "postcode": "4123"
 },
 {
   "suburb": "BORONIA HEIGHTS",
   "postcode": "4124"
 },
 {
   "suburb": "GREENBANK",
   "postcode": "4124"
 },
 {
   "suburb": "LYONS",
   "postcode": "4124"
 },
 {
   "suburb": "NEW BEITH",
   "postcode": "4124"
 },
 {
   "suburb": "MUNRUBEN",
   "postcode": "4125"
 },
 {
   "suburb": "PARK RIDGE",
   "postcode": "4125"
 },
 {
   "suburb": "PARK RIDGE SOUTH",
   "postcode": "4125"
 },
 {
   "suburb": "CHATSWOOD HILLS",
   "postcode": "4127"
 },
 {
   "suburb": "DAISY HILL",
   "postcode": "4127"
 },
 {
   "suburb": "PRIESTDALE",
   "postcode": "4127"
 },
 {
   "suburb": "SLACKS CREEK",
   "postcode": "4127"
 },
 {
   "suburb": "SPRINGWOOD",
   "postcode": "4127"
 },
 {
   "suburb": "SPRINGWOOD BC",
   "postcode": "4127"
 },
 {
   "suburb": "KIMBERLEY PARK",
   "postcode": "4128"
 },
 {
   "suburb": "LOGAN HYPERDOME BC",
   "postcode": "4128"
 },
 {
   "suburb": "SHAILER PARK",
   "postcode": "4128"
 },
 {
   "suburb": "TANAH MERAH",
   "postcode": "4128"
 },
 {
   "suburb": "LOGANDALE",
   "postcode": "4129"
 },
 {
   "suburb": "LOGANHOLME",
   "postcode": "4129"
 },
 {
   "suburb": "LOGANHOLME BC",
   "postcode": "4129"
 },
 {
   "suburb": "LOGANHOLME DC",
   "postcode": "4129"
 },
 {
   "suburb": "CARBROOK",
   "postcode": "4130"
 },
 {
   "suburb": "CORNUBIA",
   "postcode": "4130"
 },
 {
   "suburb": "HAVELOCK NORTH",
   "postcode": "4130"
 },
 {
   "suburb": "LOGANLEA",
   "postcode": "4131"
 },
 {
   "suburb": "MEADOWBROOK",
   "postcode": "4131"
 },
 {
   "suburb": "CRESTMEAD",
   "postcode": "4132"
 },
 {
   "suburb": "CRESTMEAD DC",
   "postcode": "4132"
 },
 {
   "suburb": "MARSDEN",
   "postcode": "4132"
 },
 {
   "suburb": "MARSDEN POSTAL DEPOT",
   "postcode": "4132"
 },
 {
   "suburb": "CHAMBERS FLAT",
   "postcode": "4133"
 },
 {
   "suburb": "LOGAN RESERVE",
   "postcode": "4133"
 },
 {
   "suburb": "WATERFORD",
   "postcode": "4133"
 },
 {
   "suburb": "WATERFORD WEST",
   "postcode": "4133"
 },
 {
   "suburb": "COORPAROO",
   "postcode": "4151"
 },
 {
   "suburb": "COORPAROO BC",
   "postcode": "4151"
 },
 {
   "suburb": "COORPAROO DC",
   "postcode": "4151"
 },
 {
   "suburb": "CAMP HILL",
   "postcode": "4152"
 },
 {
   "suburb": "CARINA",
   "postcode": "4152"
 },
 {
   "suburb": "CARINA HEIGHTS",
   "postcode": "4152"
 },
 {
   "suburb": "CARINA NORTH",
   "postcode": "4152"
 },
 {
   "suburb": "CARINDALE",
   "postcode": "4152"
 },
 {
   "suburb": "WHITES HILL",
   "postcode": "4152"
 },
 {
   "suburb": "BELMONT",
   "postcode": "4153"
 },
 {
   "suburb": "BELMONT HEIGHTS",
   "postcode": "4153"
 },
 {
   "suburb": "GUMDALE",
   "postcode": "4154"
 },
 {
   "suburb": "RANSOME",
   "postcode": "4154"
 },
 {
   "suburb": "WAKERLEY",
   "postcode": "4154"
 },
 {
   "suburb": "CHANDLER",
   "postcode": "4155"
 },
 {
   "suburb": "BURBANK",
   "postcode": "4156"
 },
 {
   "suburb": "MACKENZIE",
   "postcode": "4156"
 },
 {
   "suburb": "CAPALABA",
   "postcode": "4157"
 },
 {
   "suburb": "CAPALABA BC",
   "postcode": "4157"
 },
 {
   "suburb": "CAPALABA DC",
   "postcode": "4157"
 },
 {
   "suburb": "CAPALABA WEST",
   "postcode": "4157"
 },
 {
   "suburb": "SHELDON",
   "postcode": "4157"
 },
 {
   "suburb": "THORNESIDE",
   "postcode": "4158"
 },
 {
   "suburb": "BIRKDALE",
   "postcode": "4159"
 },
 {
   "suburb": "EROBIN",
   "postcode": "4160"
 },
 {
   "suburb": "ORMISTON",
   "postcode": "4160"
 },
 {
   "suburb": "WELLINGTON POINT",
   "postcode": "4160"
 },
 {
   "suburb": "ALEXANDRA HILLS",
   "postcode": "4161"
 },
 {
   "suburb": "CLEVELAND",
   "postcode": "4163"
 },
 {
   "suburb": "CLEVELAND DC",
   "postcode": "4163"
 },
 {
   "suburb": "RABY BAY",
   "postcode": "4163"
 },
 {
   "suburb": "PINKLANDS",
   "postcode": "4164"
 },
 {
   "suburb": "THORNLANDS",
   "postcode": "4164"
 },
 {
   "suburb": "MOUNT COTTON",
   "postcode": "4165"
 },
 {
   "suburb": "POINT HALLORAN",
   "postcode": "4165"
 },
 {
   "suburb": "POINT TALBURPIN",
   "postcode": "4165"
 },
 {
   "suburb": "REDLAND BAY",
   "postcode": "4165"
 },
 {
   "suburb": "VICTORIA POINT",
   "postcode": "4165"
 },
 {
   "suburb": "VICTORIA POINT WEST",
   "postcode": "4165"
 },
 {
   "suburb": "EAST BRISBANE",
   "postcode": "4169"
 },
 {
   "suburb": "KANGAROO POINT",
   "postcode": "4169"
 },
 {
   "suburb": "STANLEY BRIDGE",
   "postcode": "4169"
 },
 {
   "suburb": "CANNON HILL",
   "postcode": "4170"
 },
 {
   "suburb": "COLMSLIE",
   "postcode": "4170"
 },
 {
   "suburb": "MORNINGSIDE",
   "postcode": "4170"
 },
 {
   "suburb": "NORMAN PARK",
   "postcode": "4170"
 },
 {
   "suburb": "SEVEN HILLS",
   "postcode": "4170"
 },
 {
   "suburb": "BALMORAL",
   "postcode": "4171"
 },
 {
   "suburb": "BULIMBA",
   "postcode": "4171"
 },
 {
   "suburb": "GALLOWAYS HILL",
   "postcode": "4171"
 },
 {
   "suburb": "HAWTHORNE",
   "postcode": "4171"
 },
 {
   "suburb": "MURARRIE",
   "postcode": "4172"
 },
 {
   "suburb": "TINGALPA",
   "postcode": "4173"
 },
 {
   "suburb": "TINGALPA BC",
   "postcode": "4173"
 },
 {
   "suburb": "TINGALPA DC",
   "postcode": "4173"
 },
 {
   "suburb": "DOBOY",
   "postcode": "4174"
 },
 {
   "suburb": "HEMMANT",
   "postcode": "4174"
 },
 {
   "suburb": "LYTTON",
   "postcode": "4178"
 },
 {
   "suburb": "PORT OF BRISBANE",
   "postcode": "4178"
 },
 {
   "suburb": "WYNNUM",
   "postcode": "4178"
 },
 {
   "suburb": "WYNNUM NORTH",
   "postcode": "4178"
 },
 {
   "suburb": "WYNNUM PLAZA",
   "postcode": "4178"
 },
 {
   "suburb": "WYNNUM WEST",
   "postcode": "4178"
 },
 {
   "suburb": "LOTA",
   "postcode": "4179"
 },
 {
   "suburb": "MANLY",
   "postcode": "4179"
 },
 {
   "suburb": "MANLY WEST",
   "postcode": "4179"
 },
 {
   "suburb": "BETHANIA",
   "postcode": "4205"
 },
 {
   "suburb": "ALBERTON",
   "postcode": "4207"
 },
 {
   "suburb": "BAHRS SCRUB",
   "postcode": "4207"
 },
 {
   "suburb": "BANNOCKBURN",
   "postcode": "4207"
 },
 {
   "suburb": "BEENLEIGH",
   "postcode": "4207"
 },
 {
   "suburb": "BELIVAH",
   "postcode": "4207"
 },
 {
   "suburb": "BUCCAN",
   "postcode": "4207"
 },
 {
   "suburb": "CEDAR CREEK",
   "postcode": "4207"
 },
 {
   "suburb": "EAGLEBY",
   "postcode": "4207"
 },
 {
   "suburb": "EDENS LANDING",
   "postcode": "4207"
 },
 {
   "suburb": "HOLMVIEW",
   "postcode": "4207"
 },
 {
   "suburb": "KAIRABAH",
   "postcode": "4207"
 },
 {
   "suburb": "LOGAN VILLAGE",
   "postcode": "4207"
 },
 {
   "suburb": "LUSCOMBE",
   "postcode": "4207"
 },
 {
   "suburb": "MOUNT WARREN PARK",
   "postcode": "4207"
 },
 {
   "suburb": "STAPYLTON",
   "postcode": "4207"
 },
 {
   "suburb": "STEIGLITZ",
   "postcode": "4207"
 },
 {
   "suburb": "WINDAROO",
   "postcode": "4207"
 },
 {
   "suburb": "WOLFFDENE",
   "postcode": "4207"
 },
 {
   "suburb": "WOONGOOLBA",
   "postcode": "4207"
 },
 {
   "suburb": "YARRABILBA",
   "postcode": "4207"
 },
 {
   "suburb": "YATALA",
   "postcode": "4207"
 },
 {
   "suburb": "BURNSIDE",
   "postcode": "4208"
 },
 {
   "suburb": "GILBERTON",
   "postcode": "4208"
 },
 {
   "suburb": "HALFWAY CREEK",
   "postcode": "4208"
 },
 {
   "suburb": "JACOBS WELL",
   "postcode": "4208"
 },
 {
   "suburb": "KINGSHOLME",
   "postcode": "4208"
 },
 {
   "suburb": "NORWELL",
   "postcode": "4208"
 },
 {
   "suburb": "ORMEAU",
   "postcode": "4208"
 },
 {
   "suburb": "ORMEAU HILLS",
   "postcode": "4208"
 },
 {
   "suburb": "PIMPAMA",
   "postcode": "4208"
 },
 {
   "suburb": "COOMERA",
   "postcode": "4209"
 },
 {
   "suburb": "COOMERA WATERS",
   "postcode": "4209"
 },
 {
   "suburb": "PIMPAMA",
   "postcode": "4209"
 },
 {
   "suburb": "UPPER COOMERA",
   "postcode": "4209"
 },
 {
   "suburb": "WILLOW VALE",
   "postcode": "4209"
 },
 {
   "suburb": "WILLOWVALE",
   "postcode": "4209"
 },
 {
   "suburb": "GUANABA",
   "postcode": "4210"
 },
 {
   "suburb": "MAUDSLAND",
   "postcode": "4210"
 },
 {
   "suburb": "OXENFORD",
   "postcode": "4210"
 },
 {
   "suburb": "STUDIO VILLAGE",
   "postcode": "4210"
 },
 {
   "suburb": "WONGAWALLAN",
   "postcode": "4210"
 },
 {
   "suburb": "ADVANCETOWN",
   "postcode": "4211"
 },
 {
   "suburb": "BEECHMONT",
   "postcode": "4211"
 },
 {
   "suburb": "CARRARA",
   "postcode": "4211"
 },
 {
   "suburb": "CLAGIRABA",
   "postcode": "4211"
 },
 {
   "suburb": "GAVEN",
   "postcode": "4211"
 },
 {
   "suburb": "GILSTON",
   "postcode": "4211"
 },
 {
   "suburb": "HIGHLAND PARK",
   "postcode": "4211"
 },
 {
   "suburb": "LOWER BEECHMONT",
   "postcode": "4211"
 },
 {
   "suburb": "MOUNT NATHAN",
   "postcode": "4211"
 },
 {
   "suburb": "NERANG",
   "postcode": "4211"
 },
 {
   "suburb": "NERANG/ PAC PINE",
   "postcode": "4211"
 },
 {
   "suburb": "NUMINBAH VALLEY",
   "postcode": "4211"
 },
 {
   "suburb": "PACIFIC PINES",
   "postcode": "4211"
 },
 {
   "suburb": "BOYKAMBIL",
   "postcode": "4212"
 },
 {
   "suburb": "HELENSVALE",
   "postcode": "4212"
 },
 {
   "suburb": "HELENSVALE TOWN CENTRE",
   "postcode": "4212"
 },
 {
   "suburb": "HOPE ISLAND",
   "postcode": "4212"
 },
 {
   "suburb": "MONTEREY KEYS",
   "postcode": "4212"
 },
 {
   "suburb": "SANCTUARY COVE",
   "postcode": "4212"
 },
 {
   "suburb": "SANTA BARBARA",
   "postcode": "4212"
 },
 {
   "suburb": "AUSTINVILLE",
   "postcode": "4213"
 },
 {
   "suburb": "BONOGIN",
   "postcode": "4213"
 },
 {
   "suburb": "MUDGEERABA",
   "postcode": "4213"
 },
 {
   "suburb": "MUDGEREBA",
   "postcode": "4213"
 },
 {
   "suburb": "NERANWOOD",
   "postcode": "4213"
 },
 {
   "suburb": "SPRINGBROOK",
   "postcode": "4213"
 },
 {
   "suburb": "TALLAI",
   "postcode": "4213"
 },
 {
   "suburb": "WORONGARY",
   "postcode": "4213"
 },
 {
   "suburb": "ARUNDEL",
   "postcode": "4214"
 },
 {
   "suburb": "ARUNDEL BC",
   "postcode": "4214"
 },
 {
   "suburb": "ARUNDEL DC",
   "postcode": "4214"
 },
 {
   "suburb": "ASHMORE",
   "postcode": "4214"
 },
 {
   "suburb": "ASHMORE CITY",
   "postcode": "4214"
 },
 {
   "suburb": "MOLENDINAR",
   "postcode": "4214"
 },
 {
   "suburb": "PARKWOOD",
   "postcode": "4214"
 },
 {
   "suburb": "AUSTRALIA FAIR",
   "postcode": "4215"
 },
 {
   "suburb": "CHIRN PARK",
   "postcode": "4215"
 },
 {
   "suburb": "KEEBRA PARK",
   "postcode": "4215"
 },
 {
   "suburb": "LABRADOR",
   "postcode": "4215"
 },
 {
   "suburb": "SOUTHPORT",
   "postcode": "4215"
 },
 {
   "suburb": "SOUTHPORT BC",
   "postcode": "4215"
 },
 {
   "suburb": "SOUTHPORT PARK",
   "postcode": "4215"
 },
 {
   "suburb": "SUNDALE",
   "postcode": "4215"
 },
 {
   "suburb": "ANGLERS PARADISE",
   "postcode": "4216"
 },
 {
   "suburb": "BIGGERA WATERS",
   "postcode": "4216"
 },
 {
   "suburb": "COOMBABAH",
   "postcode": "4216"
 },
 {
   "suburb": "CURRIGEE",
   "postcode": "4216"
 },
 {
   "suburb": "HOLLYWELL",
   "postcode": "4216"
 },
 {
   "suburb": "PARADISE POINT",
   "postcode": "4216"
 },
 {
   "suburb": "PARADISE POINT KEYS",
   "postcode": "4216"
 },
 {
   "suburb": "RUNAWAY BAY",
   "postcode": "4216"
 },
 {
   "suburb": "SOUTH STRADBROKE",
   "postcode": "4216"
 },
 {
   "suburb": "SOVEREIGN ISLANDS",
   "postcode": "4216"
 },
 {
   "suburb": "ARUNDEL",
   "postcode": "4217"
 },
 {
   "suburb": "BENOWA",
   "postcode": "4217"
 },
 {
   "suburb": "BUNDALL",
   "postcode": "4217"
 },
 {
   "suburb": "BUNDALL BC",
   "postcode": "4217"
 },
 {
   "suburb": "BUNDALL DC",
   "postcode": "4217"
 },
 {
   "suburb": "CHEVRON ISLAND",
   "postcode": "4217"
 },
 {
   "suburb": "GOLD COAST MC",
   "postcode": "4217"
 },
 {
   "suburb": "ISLE OF CAPRI",
   "postcode": "4217"
 },
 {
   "suburb": "MAIN BEACH",
   "postcode": "4217"
 },
 {
   "suburb": "PARADISE ISLAND",
   "postcode": "4217"
 },
 {
   "suburb": "PARADISE WATERS",
   "postcode": "4217"
 },
 {
   "suburb": "SORRENTO",
   "postcode": "4217"
 },
 {
   "suburb": "SURFERS PARADISE",
   "postcode": "4217"
 },
 {
   "suburb": "THE SPIT",
   "postcode": "4217"
 },
 {
   "suburb": "BROADBEACH",
   "postcode": "4218"
 },
 {
   "suburb": "BROADBEACH WATERS",
   "postcode": "4218"
 },
 {
   "suburb": "CYPRESS GARDENS",
   "postcode": "4218"
 },
 {
   "suburb": "FLORIDA GARDENS",
   "postcode": "4218"
 },
 {
   "suburb": "MERMAID BEACH",
   "postcode": "4218"
 },
 {
   "suburb": "MERMAID KEYS",
   "postcode": "4218"
 },
 {
   "suburb": "MERMAID WATERS",
   "postcode": "4218"
 },
 {
   "suburb": "MIAMI KEYS",
   "postcode": "4218"
 },
 {
   "suburb": "MOANA PARK",
   "postcode": "4218"
 },
 {
   "suburb": "NOBBY BEACH",
   "postcode": "4218"
 },
 {
   "suburb": "PACIFIC FAIR",
   "postcode": "4218"
 },
 {
   "suburb": "Q SUPERCENTRE",
   "postcode": "4218"
 },
 {
   "suburb": "RIALTO",
   "postcode": "4218"
 },
 {
   "suburb": "RIO VISTA",
   "postcode": "4218"
 },
 {
   "suburb": "WEST BURLEIGH",
   "postcode": "4219"
 },
 {
   "suburb": "BURLEIGH BC",
   "postcode": "4220"
 },
 {
   "suburb": "BURLEIGH DC",
   "postcode": "4220"
 },
 {
   "suburb": "BURLEIGH HEADS",
   "postcode": "4220"
 },
 {
   "suburb": "BURLEIGH TOWN",
   "postcode": "4220"
 },
 {
   "suburb": "BURLEIGH WATERS",
   "postcode": "4220"
 },
 {
   "suburb": "MIAMI",
   "postcode": "4220"
 },
 {
   "suburb": "TALLY VALLEY",
   "postcode": "4220"
 },
 {
   "suburb": "ELANORA",
   "postcode": "4221"
 },
 {
   "suburb": "PALM BEACH",
   "postcode": "4221"
 },
 {
   "suburb": "GRIFFITH UNIVERSITY",
   "postcode": "4222"
 },
 {
   "suburb": "CURRUMBIN",
   "postcode": "4223"
 },
 {
   "suburb": "CURRUMBIN DC",
   "postcode": "4223"
 },
 {
   "suburb": "CURRUMBIN VALLEY",
   "postcode": "4223"
 },
 {
   "suburb": "CURRUMBIN WATERS",
   "postcode": "4223"
 },
 {
   "suburb": "TUGUN",
   "postcode": "4224"
 },
 {
   "suburb": "TUGUN HEIGHTS",
   "postcode": "4224"
 },
 {
   "suburb": "BILINGA",
   "postcode": "4225"
 },
 {
   "suburb": "COOLANGATTA",
   "postcode": "4225"
 },
 {
   "suburb": "CLEAR ISLAND WATERS",
   "postcode": "4226"
 },
 {
   "suburb": "KERRYDALE",
   "postcode": "4226"
 },
 {
   "suburb": "MERRIMAC",
   "postcode": "4226"
 },
 {
   "suburb": "ROBINA",
   "postcode": "4226"
 },
 {
   "suburb": "ROBINA DC",
   "postcode": "4226"
 },
 {
   "suburb": "REEDY CREEK",
   "postcode": "4227"
 },
 {
   "suburb": "VARSITY LAKES",
   "postcode": "4227"
 },
 {
   "suburb": "INGLESIDE",
   "postcode": "4228"
 },
 {
   "suburb": "TALLEBUDGERA",
   "postcode": "4228"
 },
 {
   "suburb": "TALLEBUDGERA VALLEY",
   "postcode": "4228"
 },
 {
   "suburb": "BOND UNIVERSITY",
   "postcode": "4229"
 },
 {
   "suburb": "ROBINA",
   "postcode": "4230"
 },
 {
   "suburb": "ROBINA TOWN CENTRE",
   "postcode": "4230"
 },
 {
   "suburb": "TAMBORINE",
   "postcode": "4270"
 },
 {
   "suburb": "EAGLE HEIGHTS",
   "postcode": "4272"
 },
 {
   "suburb": "MOUNT TAMBORINE",
   "postcode": "4272"
 },
 {
   "suburb": "NORTH TAMBORINE;QLD",
   "postcode": "4272"
 },
 {
   "suburb": "TAMBORINE MOUNTAIN",
   "postcode": "4272"
 },
 {
   "suburb": "BENOBBLE",
   "postcode": "4275"
 },
 {
   "suburb": "BOYLAND",
   "postcode": "4275"
 },
 {
   "suburb": "CANUNGRA",
   "postcode": "4275"
 },
 {
   "suburb": "WONGLEPONG",
   "postcode": "4275"
 },
 {
   "suburb": "FLAGSTONE",
   "postcode": "4280"
 },
 {
   "suburb": "GLENLOGAN",
   "postcode": "4280"
 },
 {
   "suburb": "JIMBOOMBA",
   "postcode": "4280"
 },
 {
   "suburb": "NORTH MACLEAN",
   "postcode": "4280"
 },
 {
   "suburb": "RIVERBEND",
   "postcode": "4280"
 },
 {
   "suburb": "SOUTH MACLEAN",
   "postcode": "4280"
 },
 {
   "suburb": "STOCKLEIGH",
   "postcode": "4280"
 },
 {
   "suburb": "UNDULLAH",
   "postcode": "4280"
 },
 {
   "suburb": "ALLENVIEW",
   "postcode": "4285"
 },
 {
   "suburb": "BEAUDESERT",
   "postcode": "4285"
 },
 {
   "suburb": "BIRNAM",
   "postcode": "4285"
 },
 {
   "suburb": "BROMELTON",
   "postcode": "4285"
 },
 {
   "suburb": "CEDAR GROVE",
   "postcode": "4285"
 },
 {
   "suburb": "CEDAR VALE",
   "postcode": "4285"
 },
 {
   "suburb": "CHRISTMAS CREEK",
   "postcode": "4285"
 },
 {
   "suburb": "CRYNA",
   "postcode": "4285"
 },
 {
   "suburb": "GLENEAGLE",
   "postcode": "4285"
 },
 {
   "suburb": "INNISPLAIN",
   "postcode": "4285"
 },
 {
   "suburb": "JOSEPHVILLE",
   "postcode": "4285"
 },
 {
   "suburb": "KERRY",
   "postcode": "4285"
 },
 {
   "suburb": "KNAPP CREEK",
   "postcode": "4285"
 },
 {
   "suburb": "KOORALBYN",
   "postcode": "4285"
 },
 {
   "suburb": "LARAVALE",
   "postcode": "4285"
 },
 {
   "suburb": "MUNDOOLUN",
   "postcode": "4285"
 },
 {
   "suburb": "TABRAGALBA",
   "postcode": "4285"
 },
 {
   "suburb": "TAMROOKUM",
   "postcode": "4285"
 },
 {
   "suburb": "VERESDALE",
   "postcode": "4285"
 },
 {
   "suburb": "VERESDALE SCRUB",
   "postcode": "4285"
 },
 {
   "suburb": "WOODHILL",
   "postcode": "4285"
 },
 {
   "suburb": "KOORALBYN",
   "postcode": "4286"
 },
 {
   "suburb": "RATHDOWNEY",
   "postcode": "4287"
 },
 {
   "suburb": "AUGUSTINE HEIGHTS",
   "postcode": "4300"
 },
 {
   "suburb": "BELLBIRD PARK",
   "postcode": "4300"
 },
 {
   "suburb": "BROOKWATER",
   "postcode": "4300"
 },
 {
   "suburb": "CAMIRA",
   "postcode": "4300"
 },
 {
   "suburb": "CAROLE PARK",
   "postcode": "4300"
 },
 {
   "suburb": "GAILES",
   "postcode": "4300"
 },
 {
   "suburb": "GOODNA",
   "postcode": "4300"
 },
 {
   "suburb": "SPRING MOUNTAIN",
   "postcode": "4300"
 },
 {
   "suburb": "SPRINGFIELD",
   "postcode": "4300"
 },
 {
   "suburb": "SPRINGFIELD CENTRAL",
   "postcode": "4300"
 },
 {
   "suburb": "SPRINGFIELD LAKES",
   "postcode": "4300"
 },
 {
   "suburb": "COLLINGWOOD PARK",
   "postcode": "4301"
 },
 {
   "suburb": "GREENWOOD VILLAGE",
   "postcode": "4301"
 },
 {
   "suburb": "REDBANK",
   "postcode": "4301"
 },
 {
   "suburb": "REDBANK PLAINS",
   "postcode": "4301"
 },
 {
   "suburb": "DINMORE",
   "postcode": "4303"
 },
 {
   "suburb": "NEW CHUM",
   "postcode": "4303"
 },
 {
   "suburb": "RIVERVIEW",
   "postcode": "4303"
 },
 {
   "suburb": "BLACKSTONE",
   "postcode": "4304"
 },
 {
   "suburb": "BOOVAL",
   "postcode": "4304"
 },
 {
   "suburb": "BOOVAL BC",
   "postcode": "4304"
 },
 {
   "suburb": "BOOVAL DC",
   "postcode": "4304"
 },
 {
   "suburb": "BOOVAL FAIR",
   "postcode": "4304"
 },
 {
   "suburb": "BUNDAMBA",
   "postcode": "4304"
 },
 {
   "suburb": "EBBW VALE",
   "postcode": "4304"
 },
 {
   "suburb": "NORTH BOOVAL",
   "postcode": "4304"
 },
 {
   "suburb": "SILKSTONE",
   "postcode": "4304"
 },
 {
   "suburb": "BASIN POCKET",
   "postcode": "4305"
 },
 {
   "suburb": "BRASSALL",
   "postcode": "4305"
 },
 {
   "suburb": "BRASSALL HEIGHTS",
   "postcode": "4305"
 },
 {
   "suburb": "BREMER",
   "postcode": "4305"
 },
 {
   "suburb": "CHURCHILL",
   "postcode": "4305"
 },
 {
   "suburb": "COALFALLS",
   "postcode": "4305"
 },
 {
   "suburb": "EAST IPSWICH",
   "postcode": "4305"
 },
 {
   "suburb": "EASTERN HEIGHTS",
   "postcode": "4305"
 },
 {
   "suburb": "FLINDERS VIEW",
   "postcode": "4305"
 },
 {
   "suburb": "IPSWICH",
   "postcode": "4305"
 },
 {
   "suburb": "LEICHHARDT",
   "postcode": "4305"
 },
 {
   "suburb": "LIMESTONE RIDGES",
   "postcode": "4305"
 },
 {
   "suburb": "MOORES POCKET",
   "postcode": "4305"
 },
 {
   "suburb": "NEWTOWN",
   "postcode": "4305"
 },
 {
   "suburb": "NORTH IPSWICH",
   "postcode": "4305"
 },
 {
   "suburb": "NORTH TIVOLI",
   "postcode": "4305"
 },
 {
   "suburb": "ONE MILE",
   "postcode": "4305"
 },
 {
   "suburb": "RACEVIEW",
   "postcode": "4305"
 },
 {
   "suburb": "RAYMONDS HILL",
   "postcode": "4305"
 },
 {
   "suburb": "SADLIERS CROSSING",
   "postcode": "4305"
 },
 {
   "suburb": "TIVOLI",
   "postcode": "4305"
 },
 {
   "suburb": "WEST IPSWICH",
   "postcode": "4305"
 },
 {
   "suburb": "WOODEND",
   "postcode": "4305"
 },
 {
   "suburb": "WULKURAKA",
   "postcode": "4305"
 },
 {
   "suburb": "YAMANTO",
   "postcode": "4305"
 },
 {
   "suburb": "AMBERLEY",
   "postcode": "4306"
 },
 {
   "suburb": "BANKS CREEK",
   "postcode": "4306"
 },
 {
   "suburb": "BARELLAN POINT",
   "postcode": "4306"
 },
 {
   "suburb": "BLACKSOIL",
   "postcode": "4306"
 },
 {
   "suburb": "BORALLON",
   "postcode": "4306"
 },
 {
   "suburb": "CHUWAR",
   "postcode": "4306"
 },
 {
   "suburb": "DEEBING HEIGHTS",
   "postcode": "4306"
 },
 {
   "suburb": "DUNDAS",
   "postcode": "4306"
 },
 {
   "suburb": "ENGLAND CREEK",
   "postcode": "4306"
 },
 {
   "suburb": "FAIRNEY VIEW",
   "postcode": "4306"
 },
 {
   "suburb": "FERNVALE",
   "postcode": "4306"
 },
 {
   "suburb": "GLAMORGAN VALE",
   "postcode": "4306"
 },
 {
   "suburb": "GOOLMAN",
   "postcode": "4306"
 },
 {
   "suburb": "HAIGSLEA",
   "postcode": "4306"
 },
 {
   "suburb": "IRONBARK",
   "postcode": "4306"
 },
 {
   "suburb": "KARALEE",
   "postcode": "4306"
 },
 {
   "suburb": "KARANA DOWNS",
   "postcode": "4306"
 },
 {
   "suburb": "KARRABIN",
   "postcode": "4306"
 },
 {
   "suburb": "KHOLO",
   "postcode": "4306"
 },
 {
   "suburb": "LAKE MANCHESTER",
   "postcode": "4306"
 },
 {
   "suburb": "LARK HILL",
   "postcode": "4306"
 },
 {
   "suburb": "MOUNT CROSBY",
   "postcode": "4306"
 },
 {
   "suburb": "MOUNT MARROW",
   "postcode": "4306"
 },
 {
   "suburb": "MUIRLEA",
   "postcode": "4306"
 },
 {
   "suburb": "PEAK CROSSING",
   "postcode": "4306"
 },
 {
   "suburb": "PINE MOUNTAIN",
   "postcode": "4306"
 },
 {
   "suburb": "PURGA",
   "postcode": "4306"
 },
 {
   "suburb": "RIPLEY",
   "postcode": "4306"
 },
 {
   "suburb": "ROSEWOOD",
   "postcode": "4306"
 },
 {
   "suburb": "SOUTH RIPLEY",
   "postcode": "4306"
 },
 {
   "suburb": "SPLIT YARD CREEK",
   "postcode": "4306"
 },
 {
   "suburb": "SWANBANK",
   "postcode": "4306"
 },
 {
   "suburb": "THAGOONA",
   "postcode": "4306"
 },
 {
   "suburb": "VERNOR",
   "postcode": "4306"
 },
 {
   "suburb": "WALLOON",
   "postcode": "4306"
 },
 {
   "suburb": "WANORA",
   "postcode": "4306"
 },
 {
   "suburb": "WASHPOOL",
   "postcode": "4306"
 },
 {
   "suburb": "WHITE ROCK",
   "postcode": "4306"
 },
 {
   "suburb": "WILLOWBANK",
   "postcode": "4306"
 },
 {
   "suburb": "WIVENHOE POCKET",
   "postcode": "4306"
 },
 {
   "suburb": "BOONAH",
   "postcode": "4310"
 },
 {
   "suburb": "BUNBURRA",
   "postcode": "4310"
 },
 {
   "suburb": "BUNJURGEN",
   "postcode": "4310"
 },
 {
   "suburb": "CANNON CREEK",
   "postcode": "4310"
 },
 {
   "suburb": "COULSON",
   "postcode": "4310"
 },
 {
   "suburb": "CROFTBY",
   "postcode": "4310"
 },
 {
   "suburb": "DUGANDAN",
   "postcode": "4310"
 },
 {
   "suburb": "FRENCHES CREEK",
   "postcode": "4310"
 },
 {
   "suburb": "KENTS POCKET",
   "postcode": "4310"
 },
 {
   "suburb": "MOUNT ALFORD",
   "postcode": "4310"
 },
 {
   "suburb": "MOUNT FRENCH",
   "postcode": "4310"
 },
 {
   "suburb": "ROADVALE",
   "postcode": "4310"
 },
 {
   "suburb": "TEMPLIN",
   "postcode": "4310"
 },
 {
   "suburb": "WALLACES CREEK",
   "postcode": "4310"
 },
 {
   "suburb": "ATKINSONS DAM",
   "postcode": "4311"
 },
 {
   "suburb": "BRIGHTVIEW",
   "postcode": "4311"
 },
 {
   "suburb": "CHURCHABLE",
   "postcode": "4311"
 },
 {
   "suburb": "CLARENDON",
   "postcode": "4311"
 },
 {
   "suburb": "COOMINYA",
   "postcode": "4311"
 },
 {
   "suburb": "LOCKYER WATERS",
   "postcode": "4311"
 },
 {
   "suburb": "LOWOOD",
   "postcode": "4311"
 },
 {
   "suburb": "MINDEN",
   "postcode": "4311"
 },
 {
   "suburb": "MOUNT TARAMPA",
   "postcode": "4311"
 },
 {
   "suburb": "PATRICK ESTATE",
   "postcode": "4311"
 },
 {
   "suburb": "PRENZLAU",
   "postcode": "4311"
 },
 {
   "suburb": "RIFLE RANGE",
   "postcode": "4311"
 },
 {
   "suburb": "TARAMPA",
   "postcode": "4311"
 },
 {
   "suburb": "CABOONBAH",
   "postcode": "4312"
 },
 {
   "suburb": "ESK",
   "postcode": "4312"
 },
 {
   "suburb": "MOOMBRA",
   "postcode": "4312"
 },
 {
   "suburb": "MOUNT HALLEN",
   "postcode": "4312"
 },
 {
   "suburb": "REDBANK CREEK",
   "postcode": "4312"
 },
 {
   "suburb": "BIARRA",
   "postcode": "4313"
 },
 {
   "suburb": "FULHAM",
   "postcode": "4313"
 },
 {
   "suburb": "SCRUB CREEK",
   "postcode": "4313"
 },
 {
   "suburb": "TOOGOOLAWAH",
   "postcode": "4313"
 },
 {
   "suburb": "BENARKIN",
   "postcode": "4314"
 },
 {
   "suburb": "BENARKIN NORTH",
   "postcode": "4314"
 },
 {
   "suburb": "BLACKBUTT",
   "postcode": "4314"
 },
 {
   "suburb": "BLACKBUTT NORTH",
   "postcode": "4314"
 },
 {
   "suburb": "BLACKBUTT SOUTH",
   "postcode": "4314"
 },
 {
   "suburb": "HARLIN",
   "postcode": "4314"
 },
 {
   "suburb": "MOORE",
   "postcode": "4314"
 },
 {
   "suburb": "TAROMEO",
   "postcode": "4314"
 },
 {
   "suburb": "ASHWELL",
   "postcode": "4340"
 },
 {
   "suburb": "CALVERT",
   "postcode": "4340"
 },
 {
   "suburb": "EBENEZER",
   "postcode": "4340"
 },
 {
   "suburb": "GRANDCHESTER",
   "postcode": "4340"
 },
 {
   "suburb": "ROSEWOOD",
   "postcode": "4340"
 },
 {
   "suburb": "TALLEGALLA",
   "postcode": "4340"
 },
 {
   "suburb": "HATTON VALE",
   "postcode": "4341"
 },
 {
   "suburb": "KENSINGTON GROVE",
   "postcode": "4341"
 },
 {
   "suburb": "KENTVILLE",
   "postcode": "4341"
 },
 {
   "suburb": "LAIDLEY",
   "postcode": "4341"
 },
 {
   "suburb": "LAIDLEY CREEK WEST",
   "postcode": "4341"
 },
 {
   "suburb": "LAIDLEY HEIGHTS",
   "postcode": "4341"
 },
 {
   "suburb": "LAIDLEY NORTH",
   "postcode": "4341"
 },
 {
   "suburb": "LAIDLEY SOUTH",
   "postcode": "4341"
 },
 {
   "suburb": "MULGOWIE",
   "postcode": "4341"
 },
 {
   "suburb": "PLAINLAND",
   "postcode": "4341"
 },
 {
   "suburb": "PRENZLAU",
   "postcode": "4341"
 },
 {
   "suburb": "REGENCY DOWNS",
   "postcode": "4341"
 },
 {
   "suburb": "SUMMERHOLM",
   "postcode": "4341"
 },
 {
   "suburb": "THORNTON",
   "postcode": "4341"
 },
 {
   "suburb": "CROWLEY VALE",
   "postcode": "4342"
 },
 {
   "suburb": "FOREST HILL",
   "postcode": "4342"
 },
 {
   "suburb": "GLENORE GROVE",
   "postcode": "4342"
 },
 {
   "suburb": "LOCKROSE",
   "postcode": "4342"
 },
 {
   "suburb": "ADARE",
   "postcode": "4343"
 },
 {
   "suburb": "COLLEGE VIEW",
   "postcode": "4343"
 },
 {
   "suburb": "GATTON",
   "postcode": "4343"
 },
 {
   "suburb": "LAKE CLARENDON",
   "postcode": "4343"
 },
 {
   "suburb": "LAWES",
   "postcode": "4343"
 },
 {
   "suburb": "LOWER TENTHILL",
   "postcode": "4343"
 },
 {
   "suburb": "MORTON VALE",
   "postcode": "4343"
 },
 {
   "suburb": "PLACID HILLS",
   "postcode": "4343"
 },
 {
   "suburb": "RINGWOOD",
   "postcode": "4343"
 },
 {
   "suburb": "ROPELEY",
   "postcode": "4343"
 },
 {
   "suburb": "CARPENDALE",
   "postcode": "4344"
 },
 {
   "suburb": "EGYPT",
   "postcode": "4344"
 },
 {
   "suburb": "FLAGSTONE CREEK",
   "postcode": "4344"
 },
 {
   "suburb": "HELIDON",
   "postcode": "4344"
 },
 {
   "suburb": "HELIDON SPA",
   "postcode": "4344"
 },
 {
   "suburb": "IREDALE",
   "postcode": "4344"
 },
 {
   "suburb": "LILYDALE",
   "postcode": "4344"
 },
 {
   "suburb": "LOCKYER",
   "postcode": "4344"
 },
 {
   "suburb": "ROCKMOUNT",
   "postcode": "4344"
 },
 {
   "suburb": "SEVENTEEN MILE",
   "postcode": "4344"
 },
 {
   "suburb": "STOCKYARD",
   "postcode": "4344"
 },
 {
   "suburb": "UPPER FLAGSTONE",
   "postcode": "4344"
 },
 {
   "suburb": "MARBURG",
   "postcode": "4346"
 },
 {
   "suburb": "GRANTHAM",
   "postcode": "4347"
 },
 {
   "suburb": "ATHOL",
   "postcode": "4350"
 },
 {
   "suburb": "BLUE MOUNTAIN HEIGHTS",
   "postcode": "4350"
 },
 {
   "suburb": "CENTENARY HEIGHTS",
   "postcode": "4350"
 },
 {
   "suburb": "CHARLTON",
   "postcode": "4350"
 },
 {
   "suburb": "CLIFFORD GARDENS",
   "postcode": "4350"
 },
 {
   "suburb": "COTSWOLD HILLS",
   "postcode": "4350"
 },
 {
   "suburb": "CRANLEY",
   "postcode": "4350"
 },
 {
   "suburb": "DARLING HEIGHTS",
   "postcode": "4350"
 },
 {
   "suburb": "DRAYTON",
   "postcode": "4350"
 },
 {
   "suburb": "DRAYTON NORTH",
   "postcode": "4350"
 },
 {
   "suburb": "EAST TOOWOOMBA",
   "postcode": "4350"
 },
 {
   "suburb": "FINNIE",
   "postcode": "4350"
 },
 {
   "suburb": "GLENVALE",
   "postcode": "4350"
 },
 {
   "suburb": "GOWRIE JUNCTION",
   "postcode": "4350"
 },
 {
   "suburb": "GOWRIE MOUNTAIN",
   "postcode": "4350"
 },
 {
   "suburb": "HARLAXTON",
   "postcode": "4350"
 },
 {
   "suburb": "HARRISTOWN",
   "postcode": "4350"
 },
 {
   "suburb": "KEARNEYS SPRING",
   "postcode": "4350"
 },
 {
   "suburb": "MIDDLE RIDGE",
   "postcode": "4350"
 },
 {
   "suburb": "MOUNT KYNOCH",
   "postcode": "4350"
 },
 {
   "suburb": "MOUNT LOFTY",
   "postcode": "4350"
 },
 {
   "suburb": "MOUNT RASCAL",
   "postcode": "4350"
 },
 {
   "suburb": "NEWTOWN",
   "postcode": "4350"
 },
 {
   "suburb": "NORTH TOOWOOMBA",
   "postcode": "4350"
 },
 {
   "suburb": "NORTHLANDS",
   "postcode": "4350"
 },
 {
   "suburb": "PRINCE HENRY HEIGHTS",
   "postcode": "4350"
 },
 {
   "suburb": "RANGEVILLE",
   "postcode": "4350"
 },
 {
   "suburb": "REDWOOD",
   "postcode": "4350"
 },
 {
   "suburb": "ROCKVILLE",
   "postcode": "4350"
 },
 {
   "suburb": "SOUTH TOOWOOMBA",
   "postcode": "4350"
 },
 {
   "suburb": "SOUTHTOWN",
   "postcode": "4350"
 },
 {
   "suburb": "TOOWOOMBA",
   "postcode": "4350"
 },
 {
   "suburb": "TOOWOOMBA CITY",
   "postcode": "4350"
 },
 {
   "suburb": "TOOWOOMBA EAST",
   "postcode": "4350"
 },
 {
   "suburb": "TOOWOOMBA SOUTH",
   "postcode": "4350"
 },
 {
   "suburb": "TOOWOOMBA VILLAGE FAIR",
   "postcode": "4350"
 },
 {
   "suburb": "TOOWOOMBA WEST",
   "postcode": "4350"
 },
 {
   "suburb": "TOP CAMP",
   "postcode": "4350"
 },
 {
   "suburb": "TORRINGTON",
   "postcode": "4350"
 },
 {
   "suburb": "WELLCAMP",
   "postcode": "4350"
 },
 {
   "suburb": "WESTBROOK",
   "postcode": "4350"
 },
 {
   "suburb": "WILSONTON",
   "postcode": "4350"
 },
 {
   "suburb": "WILSONTON HEIGHTS",
   "postcode": "4350"
 },
 {
   "suburb": "WYALLA PLAZA",
   "postcode": "4350"
 },
 {
   "suburb": "AMIENS",
   "postcode": "4352"
 },
 {
   "suburb": "BALLARD",
   "postcode": "4352"
 },
 {
   "suburb": "BAPAUME",
   "postcode": "4352"
 },
 {
   "suburb": "BIRNAM",
   "postcode": "4352"
 },
 {
   "suburb": "BLANCHVIEW",
   "postcode": "4352"
 },
 {
   "suburb": "BRANCHVIEW",
   "postcode": "4352"
 },
 {
   "suburb": "CABARLAH",
   "postcode": "4352"
 },
 {
   "suburb": "CAWDOR",
   "postcode": "4352"
 },
 {
   "suburb": "CEMENT MILLS",
   "postcode": "4352"
 },
 {
   "suburb": "COALBANK",
   "postcode": "4352"
 },
 {
   "suburb": "CONDAMINE PLAINS",
   "postcode": "4352"
 },
 {
   "suburb": "CUTELLA",
   "postcode": "4352"
 },
 {
   "suburb": "DERRYMORE",
   "postcode": "4352"
 },
 {
   "suburb": "DJUAN",
   "postcode": "4352"
 },
 {
   "suburb": "DOCTOR CREEK",
   "postcode": "4352"
 },
 {
   "suburb": "EVERGREEN",
   "postcode": "4352"
 },
 {
   "suburb": "FIFTEEN MILE",
   "postcode": "4352"
 },
 {
   "suburb": "GEHAM",
   "postcode": "4352"
 },
 {
   "suburb": "GLENCOE",
   "postcode": "4352"
 },
 {
   "suburb": "GORE",
   "postcode": "4352"
 },
 {
   "suburb": "GOWRIE JUNCTION",
   "postcode": "4352"
 },
 {
   "suburb": "GOWRIE LITTLE PLAIN",
   "postcode": "4352"
 },
 {
   "suburb": "GRAPE TREE",
   "postcode": "4352"
 },
 {
   "suburb": "GRAPETREE",
   "postcode": "4352"
 },
 {
   "suburb": "GROOMSVILLE",
   "postcode": "4352"
 },
 {
   "suburb": "HAMPTON",
   "postcode": "4352"
 },
 {
   "suburb": "HIGHFIELDS",
   "postcode": "4352"
 },
 {
   "suburb": "HIGHGROVE",
   "postcode": "4352"
 },
 {
   "suburb": "HODGSON VALE",
   "postcode": "4352"
 },
 {
   "suburb": "IREDALE",
   "postcode": "4352"
 },
 {
   "suburb": "KARARA",
   "postcode": "4352"
 },
 {
   "suburb": "KLEINTON",
   "postcode": "4352"
 },
 {
   "suburb": "KULPI",
   "postcode": "4352"
 },
 {
   "suburb": "KURROWAH",
   "postcode": "4352"
 },
 {
   "suburb": "LILYVALE",
   "postcode": "4352"
 },
 {
   "suburb": "LYRA",
   "postcode": "4352"
 },
 {
   "suburb": "MACLAGAN",
   "postcode": "4352"
 },
 {
   "suburb": "MALLING",
   "postcode": "4352"
 },
 {
   "suburb": "MERINGANDAN",
   "postcode": "4352"
 },
 {
   "suburb": "MERINGANDAN WEST",
   "postcode": "4352"
 },
 {
   "suburb": "MERRITTS CREEK",
   "postcode": "4352"
 },
 {
   "suburb": "MOUNT LUKE",
   "postcode": "4352"
 },
 {
   "suburb": "MUNIGANEEN",
   "postcode": "4352"
 },
 {
   "suburb": "MURPHYS CREEK",
   "postcode": "4352"
 },
 {
   "suburb": "NARKO",
   "postcode": "4352"
 },
 {
   "suburb": "NORTH MACLAGAN",
   "postcode": "4352"
 },
 {
   "suburb": "NUTGROVE",
   "postcode": "4352"
 },
 {
   "suburb": "OMAN AMA",
   "postcode": "4352"
 },
 {
   "suburb": "PALM TREE",
   "postcode": "4352"
 },
 {
   "suburb": "PALMTREE",
   "postcode": "4352"
 },
 {
   "suburb": "PAMPAS",
   "postcode": "4352"
 },
 {
   "suburb": "PECHEY",
   "postcode": "4352"
 },
 {
   "suburb": "PERANGA",
   "postcode": "4352"
 },
 {
   "suburb": "PERSEVERANCE",
   "postcode": "4352"
 },
 {
   "suburb": "POSTMANS RIDGE",
   "postcode": "4352"
 },
 {
   "suburb": "POZIERES",
   "postcode": "4352"
 },
 {
   "suburb": "PRESTON",
   "postcode": "4352"
 },
 {
   "suburb": "RAMSAY",
   "postcode": "4352"
 },
 {
   "suburb": "RANGEMORE",
   "postcode": "4352"
 },
 {
   "suburb": "RAVENSBOURNE",
   "postcode": "4352"
 },
 {
   "suburb": "REDWOOD",
   "postcode": "4352"
 },
 {
   "suburb": "SEVERNLEA",
   "postcode": "4352"
 },
 {
   "suburb": "SILVER RIDGE",
   "postcode": "4352"
 },
 {
   "suburb": "SPRING BLUFF",
   "postcode": "4352"
 },
 {
   "suburb": "ST AUBYN",
   "postcode": "4352"
 },
 {
   "suburb": "THORNVILLE",
   "postcode": "4352"
 },
 {
   "suburb": "TOOWOOMBA MC",
   "postcode": "4352"
 },
 {
   "suburb": "TUMMAVILLE",
   "postcode": "4352"
 },
 {
   "suburb": "UMBIRAM",
   "postcode": "4352"
 },
 {
   "suburb": "UPPER LOCKYER",
   "postcode": "4352"
 },
 {
   "suburb": "VALE VIEW",
   "postcode": "4352"
 },
 {
   "suburb": "WHICHELLO",
   "postcode": "4352"
 },
 {
   "suburb": "WHITE MOUNTAIN",
   "postcode": "4352"
 },
 {
   "suburb": "WITHCOTT",
   "postcode": "4352"
 },
 {
   "suburb": "WOODLEIGH",
   "postcode": "4352"
 },
 {
   "suburb": "WOOLMER",
   "postcode": "4352"
 },
 {
   "suburb": "WUTUL",
   "postcode": "4352"
 },
 {
   "suburb": "WYREEMA",
   "postcode": "4352"
 },
 {
   "suburb": "YALANGUR",
   "postcode": "4352"
 },
 {
   "suburb": "YANDILLA",
   "postcode": "4352"
 },
 {
   "suburb": "HADEN",
   "postcode": "4353"
 },
 {
   "suburb": "DOUGLAS",
   "postcode": "4354"
 },
 {
   "suburb": "GOOMBUNGEE",
   "postcode": "4354"
 },
 {
   "suburb": "BROXBURN",
   "postcode": "4356"
 },
 {
   "suburb": "LINTHORPE",
   "postcode": "4356"
 },
 {
   "suburb": "PITTSWORTH",
   "postcode": "4356"
 },
 {
   "suburb": "SCRUBBY MOUNTAIN",
   "postcode": "4356"
 },
 {
   "suburb": "CYPRESS GARDENS",
   "postcode": "4357"
 },
 {
   "suburb": "MILMERRAN",
   "postcode": "4357"
 },
 {
   "suburb": "CAMBOOYA",
   "postcode": "4358"
 },
 {
   "suburb": "FELTON",
   "postcode": "4358"
 },
 {
   "suburb": "FELTON SOUTH",
   "postcode": "4358"
 },
 {
   "suburb": "RAMSAY",
   "postcode": "4358"
 },
 {
   "suburb": "GREENMOUNT",
   "postcode": "4359"
 },
 {
   "suburb": "CLIFTON",
   "postcode": "4361"
 },
 {
   "suburb": "SPRING CREEK",
   "postcode": "4361"
 },
 {
   "suburb": "ALLORA",
   "postcode": "4362"
 },
 {
   "suburb": "SOUTHBROOK",
   "postcode": "4363"
 },
 {
   "suburb": "ALLAN",
   "postcode": "4370"
 },
 {
   "suburb": "BONY MOUNTAIN",
   "postcode": "4370"
 },
 {
   "suburb": "CANNINGVALE",
   "postcode": "4370"
 },
 {
   "suburb": "CHERRY GULLY",
   "postcode": "4370"
 },
 {
   "suburb": "CLINTONVALE",
   "postcode": "4370"
 },
 {
   "suburb": "CUNNINGHAM",
   "postcode": "4370"
 },
 {
   "suburb": "DANDEROO",
   "postcode": "4370"
 },
 {
   "suburb": "ELBOW VALLEY",
   "postcode": "4370"
 },
 {
   "suburb": "FREESTONE",
   "postcode": "4370"
 },
 {
   "suburb": "GLADFIELD",
   "postcode": "4370"
 },
 {
   "suburb": "GLENGALLAN",
   "postcode": "4370"
 },
 {
   "suburb": "GREYMARE",
   "postcode": "4370"
 },
 {
   "suburb": "JUNABEE",
   "postcode": "4370"
 },
 {
   "suburb": "LESLIE",
   "postcode": "4370"
 },
 {
   "suburb": "LESLIE DAM",
   "postcode": "4370"
 },
 {
   "suburb": "LOCH LOMOND",
   "postcode": "4370"
 },
 {
   "suburb": "MARYVALE",
   "postcode": "4370"
 },
 {
   "suburb": "MASSIE",
   "postcode": "4370"
 },
 {
   "suburb": "MONTROSE",
   "postcode": "4370"
 },
 {
   "suburb": "MORGAN PARK",
   "postcode": "4370"
 },
 {
   "suburb": "MOUNT COLLIERY",
   "postcode": "4370"
 },
 {
   "suburb": "MOUNT STURT",
   "postcode": "4370"
 },
 {
   "suburb": "MOUNT TABOR",
   "postcode": "4370"
 },
 {
   "suburb": "MURRAYS BRIDGE",
   "postcode": "4370"
 },
 {
   "suburb": "NORTH BRANCH",
   "postcode": "4370"
 },
 {
   "suburb": "PRATTEN",
   "postcode": "4370"
 },
 {
   "suburb": "RODGERS CREEK",
   "postcode": "4370"
 },
 {
   "suburb": "ROSEHILL",
   "postcode": "4370"
 },
 {
   "suburb": "ROSENTHAL HEIGHTS",
   "postcode": "4370"
 },
 {
   "suburb": "SILVERWOOD",
   "postcode": "4370"
 },
 {
   "suburb": "SLADEVALE",
   "postcode": "4370"
 },
 {
   "suburb": "SWAN CREEK",
   "postcode": "4370"
 },
 {
   "suburb": "THANE",
   "postcode": "4370"
 },
 {
   "suburb": "THANES CREEK",
   "postcode": "4370"
 },
 {
   "suburb": "THE GLEN",
   "postcode": "4370"
 },
 {
   "suburb": "THE HERMITAGE",
   "postcode": "4370"
 },
 {
   "suburb": "TOOLBURRA",
   "postcode": "4370"
 },
 {
   "suburb": "TREGONY",
   "postcode": "4370"
 },
 {
   "suburb": "UPPER FREESTONE",
   "postcode": "4370"
 },
 {
   "suburb": "UPPER WHEATVALE",
   "postcode": "4370"
 },
 {
   "suburb": "WARWICK",
   "postcode": "4370"
 },
 {
   "suburb": "WHEATVALE",
   "postcode": "4370"
 },
 {
   "suburb": "WILDASH",
   "postcode": "4370"
 },
 {
   "suburb": "WILLOWVALE",
   "postcode": "4370"
 },
 {
   "suburb": "WIYARRA",
   "postcode": "4370"
 },
 {
   "suburb": "WOMINA",
   "postcode": "4370"
 },
 {
   "suburb": "KILLARNEY",
   "postcode": "4373"
 },
 {
   "suburb": "THULIMBAH",
   "postcode": "4376"
 },
 {
   "suburb": "AMIENS",
   "postcode": "4380"
 },
 {
   "suburb": "APPLETHORPE",
   "postcode": "4380"
 },
 {
   "suburb": "BROADWATER",
   "postcode": "4380"
 },
 {
   "suburb": "DALCOUTH",
   "postcode": "4380"
 },
 {
   "suburb": "GREENLANDS",
   "postcode": "4380"
 },
 {
   "suburb": "KYOOMBA",
   "postcode": "4380"
 },
 {
   "suburb": "PIKEDALE",
   "postcode": "4380"
 },
 {
   "suburb": "SEVERNLEA",
   "postcode": "4380"
 },
 {
   "suburb": "STANTHORPE",
   "postcode": "4380"
 },
 {
   "suburb": "THORNDALE",
   "postcode": "4380"
 },
 {
   "suburb": "GLEN APLIN",
   "postcode": "4381"
 },
 {
   "suburb": "BALLANDEAN",
   "postcode": "4382"
 },
 {
   "suburb": "INGLEWOOD",
   "postcode": "4387"
 },
 {
   "suburb": "YELARBON",
   "postcode": "4388"
 },
 {
   "suburb": "GOONDIWINDI",
   "postcode": "4390"
 },
 {
   "suburb": "KINGSTHORPE",
   "postcode": "4400"
 },
 {
   "suburb": "AUBIGNY",
   "postcode": "4401"
 },
 {
   "suburb": "BIDDESTON",
   "postcode": "4401"
 },
 {
   "suburb": "OAKEY",
   "postcode": "4401"
 },
 {
   "suburb": "BRYMAROO",
   "postcode": "4403"
 },
 {
   "suburb": "JONDARYAN",
   "postcode": "4403"
 },
 {
   "suburb": "MALU",
   "postcode": "4403"
 },
 {
   "suburb": "MOUNT MORIAH",
   "postcode": "4403"
 },
 {
   "suburb": "QUINALOW",
   "postcode": "4403"
 },
 {
   "suburb": "WEST PRAIRIE",
   "postcode": "4403"
 },
 {
   "suburb": "BOWENVILLE",
   "postcode": "4404"
 },
 {
   "suburb": "FORMARTIN",
   "postcode": "4404"
 },
 {
   "suburb": "IRVINGDALE",
   "postcode": "4404"
 },
 {
   "suburb": "WAINUI",
   "postcode": "4404"
 },
 {
   "suburb": "BLAXLAND",
   "postcode": "4405"
 },
 {
   "suburb": "DALBY",
   "postcode": "4405"
 },
 {
   "suburb": "DUCKLO",
   "postcode": "4405"
 },
 {
   "suburb": "PIRRINUAN",
   "postcode": "4405"
 },
 {
   "suburb": "RANGES BRIDGE",
   "postcode": "4405"
 },
 {
   "suburb": "ST RUTH",
   "postcode": "4405"
 },
 {
   "suburb": "JANDOWAE",
   "postcode": "4410"
 },
 {
   "suburb": "WARRA",
   "postcode": "4411"
 },
 {
   "suburb": "BRIGALOW",
   "postcode": "4412"
 },
 {
   "suburb": "BAKING BOARD",
   "postcode": "4413"
 },
 {
   "suburb": "CANAGA",
   "postcode": "4413"
 },
 {
   "suburb": "CHANCES PLAIN",
   "postcode": "4413"
 },
 {
   "suburb": "CHINCHILLA",
   "postcode": "4413"
 },
 {
   "suburb": "HOPELAND",
   "postcode": "4413"
 },
 {
   "suburb": "MILES",
   "postcode": "4415"
 },
 {
   "suburb": "BARRAMORNIE",
   "postcode": "4416"
 },
 {
   "suburb": "CONDAMINE",
   "postcode": "4416"
 },
 {
   "suburb": "MORABY",
   "postcode": "4416"
 },
 {
   "suburb": "NANGRAM",
   "postcode": "4416"
 },
 {
   "suburb": "PINE HILLS",
   "postcode": "4416"
 },
 {
   "suburb": "SUNNYSIDE",
   "postcode": "4416"
 },
 {
   "suburb": "YULABILLA",
   "postcode": "4416"
 },
 {
   "suburb": "SURAT",
   "postcode": "4417"
 },
 {
   "suburb": "WANDOAN",
   "postcode": "4419"
 },
 {
   "suburb": "TAROOM",
   "postcode": "4420"
 },
 {
   "suburb": "COOMRITH",
   "postcode": "4422"
 },
 {
   "suburb": "FLINTON",
   "postcode": "4422"
 },
 {
   "suburb": "INGLESTONE",
   "postcode": "4422"
 },
 {
   "suburb": "MEANDARRA",
   "postcode": "4422"
 },
 {
   "suburb": "WESTMAR",
   "postcode": "4422"
 },
 {
   "suburb": "DRILLHAM",
   "postcode": "4424"
 },
 {
   "suburb": "DULACCA",
   "postcode": "4425"
 },
 {
   "suburb": "JACKSON",
   "postcode": "4426"
 },
 {
   "suburb": "JACKSON NORTH",
   "postcode": "4426"
 },
 {
   "suburb": "JACKSON SOUTH",
   "postcode": "4426"
 },
 {
   "suburb": "YULEBA",
   "postcode": "4427"
 },
 {
   "suburb": "WALLUMBILLA",
   "postcode": "4428"
 },
 {
   "suburb": "INJUNE",
   "postcode": "4454"
 },
 {
   "suburb": "ANGELLALA",
   "postcode": "4455"
 },
 {
   "suburb": "BALLAROO",
   "postcode": "4455"
 },
 {
   "suburb": "BLYTHDALE",
   "postcode": "4455"
 },
 {
   "suburb": "BUNGEWORGORAI",
   "postcode": "4455"
 },
 {
   "suburb": "BUNGIL",
   "postcode": "4455"
 },
 {
   "suburb": "BYMOUNT",
   "postcode": "4455"
 },
 {
   "suburb": "CORNWALL",
   "postcode": "4455"
 },
 {
   "suburb": "DARGAL ROAD",
   "postcode": "4455"
 },
 {
   "suburb": "EUMAMURRIN",
   "postcode": "4455"
 },
 {
   "suburb": "EUTHULLA",
   "postcode": "4455"
 },
 {
   "suburb": "GUNNEWIN",
   "postcode": "4455"
 },
 {
   "suburb": "HODGSON",
   "postcode": "4455"
 },
 {
   "suburb": "MOOGA",
   "postcode": "4455"
 },
 {
   "suburb": "MOUNT ABUNDANCE",
   "postcode": "4455"
 },
 {
   "suburb": "MOUNT BINDANGO",
   "postcode": "4455"
 },
 {
   "suburb": "ORALLO",
   "postcode": "4455"
 },
 {
   "suburb": "ORANGE HILL",
   "postcode": "4455"
 },
 {
   "suburb": "ROMA",
   "postcode": "4455"
 },
 {
   "suburb": "TINGUN",
   "postcode": "4455"
 },
 {
   "suburb": "WYCOMBE",
   "postcode": "4455"
 },
 {
   "suburb": "WOMALILLA",
   "postcode": "4465"
 },
 {
   "suburb": "WOMBLEBANK",
   "postcode": "4465"
 },
 {
   "suburb": "ST GEORGE",
   "postcode": "4487"
 },
 {
   "suburb": "TALWOOD",
   "postcode": "4496"
 },
 {
   "suburb": "NINDIGULLY",
   "postcode": "4497"
 },
 {
   "suburb": "TOOBEAH",
   "postcode": "4498"
 },
 {
   "suburb": "BRAY PARK",
   "postcode": "4500"
 },
 {
   "suburb": "BRENDALE",
   "postcode": "4500"
 },
 {
   "suburb": "CASHMERE",
   "postcode": "4500"
 },
 {
   "suburb": "CLEAR MOUNTAIN",
   "postcode": "4500"
 },
 {
   "suburb": "JOYNER",
   "postcode": "4500"
 },
 {
   "suburb": "STRATHPINE",
   "postcode": "4500"
 },
 {
   "suburb": "STRATHPINE CENTRE",
   "postcode": "4500"
 },
 {
   "suburb": "STRATHPINE CITY",
   "postcode": "4500"
 },
 {
   "suburb": "WARNER",
   "postcode": "4500"
 },
 {
   "suburb": "LAWNTON",
   "postcode": "4501"
 },
 {
   "suburb": "FRENCHS FOREST",
   "postcode": "4502"
 },
 {
   "suburb": "PETRIE",
   "postcode": "4502"
 },
 {
   "suburb": "DAKABIN",
   "postcode": "4503"
 },
 {
   "suburb": "DOHLES ROCKS",
   "postcode": "4503"
 },
 {
   "suburb": "GRIFFIN",
   "postcode": "4503"
 },
 {
   "suburb": "KALLANGUR",
   "postcode": "4503"
 },
 {
   "suburb": "KURWONGBAH",
   "postcode": "4503"
 },
 {
   "suburb": "MURRUMBA DOWNS",
   "postcode": "4503"
 },
 {
   "suburb": "WHITESIDE",
   "postcode": "4503"
 },
 {
   "suburb": "NARANGBA",
   "postcode": "4504"
 },
 {
   "suburb": "BURPENGARY",
   "postcode": "4505"
 },
 {
   "suburb": "BURPENGARY DC",
   "postcode": "4505"
 },
 {
   "suburb": "BURPENGARY EAST",
   "postcode": "4505"
 },
 {
   "suburb": "MOORINA",
   "postcode": "4506"
 },
 {
   "suburb": "MORAYFIELD",
   "postcode": "4506"
 },
 {
   "suburb": "BANKSIA BEACH",
   "postcode": "4507"
 },
 {
   "suburb": "BELLARA",
   "postcode": "4507"
 },
 {
   "suburb": "BONGAREE",
   "postcode": "4507"
 },
 {
   "suburb": "BRIBIE ISLAND",
   "postcode": "4507"
 },
 {
   "suburb": "BRIBIE ISLAND NORTH",
   "postcode": "4507"
 },
 {
   "suburb": "WELSBY",
   "postcode": "4507"
 },
 {
   "suburb": "WHITE PATCH",
   "postcode": "4507"
 },
 {
   "suburb": "WOORIM",
   "postcode": "4507"
 },
 {
   "suburb": "DECEPTION BAY",
   "postcode": "4508"
 },
 {
   "suburb": "MANGO HILL",
   "postcode": "4509"
 },
 {
   "suburb": "NORTH LAKES",
   "postcode": "4509"
 },
 {
   "suburb": "BEACHMERE",
   "postcode": "4510"
 },
 {
   "suburb": "BELLMERE",
   "postcode": "4510"
 },
 {
   "suburb": "CABOOLTURE",
   "postcode": "4510"
 },
 {
   "suburb": "CABOOLTURE SOUTH",
   "postcode": "4510"
 },
 {
   "suburb": "DONNYBROOK",
   "postcode": "4510"
 },
 {
   "suburb": "MELDALE",
   "postcode": "4510"
 },
 {
   "suburb": "MOODLU",
   "postcode": "4510"
 },
 {
   "suburb": "ROCKSBERG",
   "postcode": "4510"
 },
 {
   "suburb": "TOORBUL",
   "postcode": "4510"
 },
 {
   "suburb": "UPPER CABOOLTURE",
   "postcode": "4510"
 },
 {
   "suburb": "GODWIN BEACH",
   "postcode": "4511"
 },
 {
   "suburb": "NINGI",
   "postcode": "4511"
 },
 {
   "suburb": "SANDSTONE POINT",
   "postcode": "4511"
 },
 {
   "suburb": "BRACALBA",
   "postcode": "4512"
 },
 {
   "suburb": "WAMURAN",
   "postcode": "4512"
 },
 {
   "suburb": "BURPENGARY",
   "postcode": "4514"
 },
 {
   "suburb": "D'AGUILAR",
   "postcode": "4514"
 },
 {
   "suburb": "DELANEYS CREEK",
   "postcode": "4514"
 },
 {
   "suburb": "MOUNT ARCHER",
   "postcode": "4514"
 },
 {
   "suburb": "MOUNT DELANEY",
   "postcode": "4514"
 },
 {
   "suburb": "STANMORE",
   "postcode": "4514"
 },
 {
   "suburb": "STONY CREEK",
   "postcode": "4514"
 },
 {
   "suburb": "VILLENEUVE",
   "postcode": "4514"
 },
 {
   "suburb": "WOODFORD",
   "postcode": "4514"
 },
 {
   "suburb": "GLENFERN",
   "postcode": "4515"
 },
 {
   "suburb": "KILCOY",
   "postcode": "4515"
 },
 {
   "suburb": "ROYSTON",
   "postcode": "4515"
 },
 {
   "suburb": "SANDY CREEK",
   "postcode": "4515"
 },
 {
   "suburb": "WINYA",
   "postcode": "4515"
 },
 {
   "suburb": "WOOLMAR",
   "postcode": "4515"
 },
 {
   "suburb": "ELIMBAH",
   "postcode": "4516"
 },
 {
   "suburb": "BEERBURRUM",
   "postcode": "4517"
 },
 {
   "suburb": "GLASS HOUSE MOUNTAINS",
   "postcode": "4518"
 },
 {
   "suburb": "BEERWAH",
   "postcode": "4519"
 },
 {
   "suburb": "COOCHIN CREEK",
   "postcode": "4519"
 },
 {
   "suburb": "CROHAMHURST",
   "postcode": "4519"
 },
 {
   "suburb": "LANDSBOROUGH",
   "postcode": "4519"
 },
 {
   "suburb": "PEACHESTER",
   "postcode": "4519"
 },
 {
   "suburb": "ARMSTRONG CREEK",
   "postcode": "4520"
 },
 {
   "suburb": "CAMP MOUNTAIN",
   "postcode": "4520"
 },
 {
   "suburb": "CEDAR CREEK",
   "postcode": "4520"
 },
 {
   "suburb": "CLOSEBURN",
   "postcode": "4520"
 },
 {
   "suburb": "DRAPER",
   "postcode": "4520"
 },
 {
   "suburb": "HIGHVALE",
   "postcode": "4520"
 },
 {
   "suburb": "KOBBLE CREEK",
   "postcode": "4520"
 },
 {
   "suburb": "MOUNT GLORIOUS",
   "postcode": "4520"
 },
 {
   "suburb": "MOUNT NEBO",
   "postcode": "4520"
 },
 {
   "suburb": "MOUNT SAMSON",
   "postcode": "4520"
 },
 {
   "suburb": "SAMFORD",
   "postcode": "4520"
 },
 {
   "suburb": "SAMFORD VALLEY",
   "postcode": "4520"
 },
 {
   "suburb": "SAMFORD VILLAGE",
   "postcode": "4520"
 },
 {
   "suburb": "SAMSONVALE",
   "postcode": "4520"
 },
 {
   "suburb": "WIGHTS MOUNTAIN",
   "postcode": "4520"
 },
 {
   "suburb": "YUGAR",
   "postcode": "4520"
 },
 {
   "suburb": "CAMPBELLS POCKET",
   "postcode": "4521"
 },
 {
   "suburb": "DAYBORO",
   "postcode": "4521"
 },
 {
   "suburb": "KING SCRUB",
   "postcode": "4521"
 },
 {
   "suburb": "MOUNT MEE",
   "postcode": "4521"
 },
 {
   "suburb": "MOUNT PLEASANT",
   "postcode": "4521"
 },
 {
   "suburb": "OCEAN VIEW",
   "postcode": "4521"
 },
 {
   "suburb": "RUSH CREEK",
   "postcode": "4521"
 },
 {
   "suburb": "LANDSBOROUGH",
   "postcode": "4550"
 },
 {
   "suburb": "MOUNT MELLUM",
   "postcode": "4550"
 },
 {
   "suburb": "AROONA",
   "postcode": "4551"
 },
 {
   "suburb": "BANYA",
   "postcode": "4551"
 },
 {
   "suburb": "BARINGA",
   "postcode": "4551"
 },
 {
   "suburb": "BATTERY HILL",
   "postcode": "4551"
 },
 {
   "suburb": "BELLS CREEK",
   "postcode": "4551"
 },
 {
   "suburb": "CALOUNDRA",
   "postcode": "4551"
 },
 {
   "suburb": "CALOUNDRA WEST",
   "postcode": "4551"
 },
 {
   "suburb": "CORBOULD PARK",
   "postcode": "4551"
 },
 {
   "suburb": "CURRIMUNDI",
   "postcode": "4551"
 },
 {
   "suburb": "DICKY BEACH",
   "postcode": "4551"
 },
 {
   "suburb": "GOLDEN BEACH",
   "postcode": "4551"
 },
 {
   "suburb": "KINGS BEACH",
   "postcode": "4551"
 },
 {
   "suburb": "LITTLE MOUNTAIN",
   "postcode": "4551"
 },
 {
   "suburb": "MERIDAN PLAINS",
   "postcode": "4551"
 },
 {
   "suburb": "MOFFAT BEACH",
   "postcode": "4551"
 },
 {
   "suburb": "NIRIMBA",
   "postcode": "4551"
 },
 {
   "suburb": "PELICAN WATERS",
   "postcode": "4551"
 },
 {
   "suburb": "SHELLY BEACH",
   "postcode": "4551"
 },
 {
   "suburb": "SUNSHINE COAST",
   "postcode": "4551"
 },
 {
   "suburb": "SUNSHINE COAST REGIONAL",
   "postcode": "4551"
 },
 {
   "suburb": "BALD KNOB",
   "postcode": "4552"
 },
 {
   "suburb": "BALMORAL RIDGE",
   "postcode": "4552"
 },
 {
   "suburb": "BOOROOBIN",
   "postcode": "4552"
 },
 {
   "suburb": "CAMBROON",
   "postcode": "4552"
 },
 {
   "suburb": "CONONDALE",
   "postcode": "4552"
 },
 {
   "suburb": "CRYSTAL WATERS",
   "postcode": "4552"
 },
 {
   "suburb": "CURRAMORE",
   "postcode": "4552"
 },
 {
   "suburb": "ELAMAN CREEK",
   "postcode": "4552"
 },
 {
   "suburb": "HARPER CREEK",
   "postcode": "4552"
 },
 {
   "suburb": "MALENY",
   "postcode": "4552"
 },
 {
   "suburb": "NORTH MALENY",
   "postcode": "4552"
 },
 {
   "suburb": "REESVILLE",
   "postcode": "4552"
 },
 {
   "suburb": "WITTA",
   "postcode": "4552"
 },
 {
   "suburb": "WOOTHA",
   "postcode": "4552"
 },
 {
   "suburb": "DIAMOND VALLEY",
   "postcode": "4553"
 },
 {
   "suburb": "GLENVIEW",
   "postcode": "4553"
 },
 {
   "suburb": "MOOLOOLAH",
   "postcode": "4553"
 },
 {
   "suburb": "MOOLOOLAH VALLEY",
   "postcode": "4553"
 },
 {
   "suburb": "PALMVIEW",
   "postcode": "4553"
 },
 {
   "suburb": "EUDLO",
   "postcode": "4554"
 },
 {
   "suburb": "ILKLEY",
   "postcode": "4554"
 },
 {
   "suburb": "CHEVALLUM",
   "postcode": "4555"
 },
 {
   "suburb": "HUNCHY",
   "postcode": "4555"
 },
 {
   "suburb": "LANDERS SHOOT",
   "postcode": "4555"
 },
 {
   "suburb": "PALMWOODS",
   "postcode": "4555"
 },
 {
   "suburb": "BUDERIM",
   "postcode": "4556"
 },
 {
   "suburb": "FOREST GLEN",
   "postcode": "4556"
 },
 {
   "suburb": "KUNDA PARK",
   "postcode": "4556"
 },
 {
   "suburb": "MONS",
   "postcode": "4556"
 },
 {
   "suburb": "SIPPY DOWNS",
   "postcode": "4556"
 },
 {
   "suburb": "TANAWHA",
   "postcode": "4556"
 },
 {
   "suburb": "MOOLOOLABA",
   "postcode": "4557"
 },
 {
   "suburb": "MOUNTAIN CREEK",
   "postcode": "4557"
 },
 {
   "suburb": "COTTON TREE",
   "postcode": "4558"
 },
 {
   "suburb": "KULUIN",
   "postcode": "4558"
 },
 {
   "suburb": "MAROOCHYDORE",
   "postcode": "4558"
 },
 {
   "suburb": "MOUNTAIN CREEK",
   "postcode": "4558"
 },
 {
   "suburb": "SUNSHINE PLAZA",
   "postcode": "4558"
 },
 {
   "suburb": "TWIN WATERS",
   "postcode": "4558"
 },
 {
   "suburb": "DIDDILLIBAH",
   "postcode": "4559"
 },
 {
   "suburb": "KIELS MOUNTAIN",
   "postcode": "4559"
 },
 {
   "suburb": "WEST WOOMBYE",
   "postcode": "4559"
 },
 {
   "suburb": "WOOMBYE",
   "postcode": "4559"
 },
 {
   "suburb": "BLI BLI",
   "postcode": "4560"
 },
 {
   "suburb": "BURNSIDE",
   "postcode": "4560"
 },
 {
   "suburb": "COES CREEK",
   "postcode": "4560"
 },
 {
   "suburb": "COOLOOLABIN",
   "postcode": "4560"
 },
 {
   "suburb": "DULONG",
   "postcode": "4560"
 },
 {
   "suburb": "FLAXTON",
   "postcode": "4560"
 },
 {
   "suburb": "HIGHWORTH",
   "postcode": "4560"
 },
 {
   "suburb": "IMAGE FLAT",
   "postcode": "4560"
 },
 {
   "suburb": "KIAMBA",
   "postcode": "4560"
 },
 {
   "suburb": "KULANGOOR",
   "postcode": "4560"
 },
 {
   "suburb": "KUREELPA",
   "postcode": "4560"
 },
 {
   "suburb": "LANDSBOROUGH",
   "postcode": "4560"
 },
 {
   "suburb": "MAPLETON",
   "postcode": "4560"
 },
 {
   "suburb": "MONTVILLE",
   "postcode": "4560"
 },
 {
   "suburb": "NAMBOUR",
   "postcode": "4560"
 },
 {
   "suburb": "NAMBOUR WEST",
   "postcode": "4560"
 },
 {
   "suburb": "PARKLANDS",
   "postcode": "4560"
 },
 {
   "suburb": "PERWILLOWEN",
   "postcode": "4560"
 },
 {
   "suburb": "ROSEMOUNT",
   "postcode": "4560"
 },
 {
   "suburb": "SUNSHINE COAST MC",
   "postcode": "4560"
 },
 {
   "suburb": "TOWEN MOUNTAIN",
   "postcode": "4560"
 },
 {
   "suburb": "BRIDGES",
   "postcode": "4561"
 },
 {
   "suburb": "MAROOCHY RIVER",
   "postcode": "4561"
 },
 {
   "suburb": "NINDERRY",
   "postcode": "4561"
 },
 {
   "suburb": "NORTH ARM",
   "postcode": "4561"
 },
 {
   "suburb": "VALDORA",
   "postcode": "4561"
 },
 {
   "suburb": "YANDINA",
   "postcode": "4561"
 },
 {
   "suburb": "YANDINA CREEK",
   "postcode": "4561"
 },
 {
   "suburb": "BELLI PARK",
   "postcode": "4562"
 },
 {
   "suburb": "DOONAN",
   "postcode": "4562"
 },
 {
   "suburb": "EARWAH VALE",
   "postcode": "4562"
 },
 {
   "suburb": "EERWAH VALE",
   "postcode": "4562"
 },
 {
   "suburb": "EUMUNDI",
   "postcode": "4562"
 },
 {
   "suburb": "VERRIERDALE",
   "postcode": "4562"
 },
 {
   "suburb": "WEYBA DOWNS",
   "postcode": "4562"
 },
 {
   "suburb": "BLACK MOUNTAIN",
   "postcode": "4563"
 },
 {
   "suburb": "CARTERS RIDGE",
   "postcode": "4563"
 },
 {
   "suburb": "COOROY",
   "postcode": "4563"
 },
 {
   "suburb": "COOROY MOUNTAIN",
   "postcode": "4563"
 },
 {
   "suburb": "LAKE MACDONALD",
   "postcode": "4563"
 },
 {
   "suburb": "RIDGEWOOD",
   "postcode": "4563"
 },
 {
   "suburb": "TINBEERWAH",
   "postcode": "4563"
 },
 {
   "suburb": "MARCOOLA",
   "postcode": "4564"
 },
 {
   "suburb": "MUDJIMBA",
   "postcode": "4564"
 },
 {
   "suburb": "PACIFIC PARADISE",
   "postcode": "4564"
 },
 {
   "suburb": "TWIN WATERS",
   "postcode": "4564"
 },
 {
   "suburb": "BOREEN POINT",
   "postcode": "4565"
 },
 {
   "suburb": "COOROIBAH",
   "postcode": "4565"
 },
 {
   "suburb": "COOTHARABA",
   "postcode": "4565"
 },
 {
   "suburb": "NOOSA NORTH SHORE",
   "postcode": "4565"
 },
 {
   "suburb": "RINGTAIL CREEK",
   "postcode": "4565"
 },
 {
   "suburb": "TEWANTIN",
   "postcode": "4565"
 },
 {
   "suburb": "NOOSAVILLE",
   "postcode": "4566"
 },
 {
   "suburb": "CASTAWAY BEACH",
   "postcode": "4567"
 },
 {
   "suburb": "CASTAWAYS BEACH",
   "postcode": "4567"
 },
 {
   "suburb": "NOOSA HEADS",
   "postcode": "4567"
 },
 {
   "suburb": "SUNRISE BEACH",
   "postcode": "4567"
 },
 {
   "suburb": "SUNSHINE BEACH",
   "postcode": "4567"
 },
 {
   "suburb": "SUNSHINE COAST",
   "postcode": "4567"
 },
 {
   "suburb": "FEDERAL",
   "postcode": "4568"
 },
 {
   "suburb": "PINBARREN",
   "postcode": "4568"
 },
 {
   "suburb": "POMONA",
   "postcode": "4568"
 },
 {
   "suburb": "COORAN",
   "postcode": "4569"
 },
 {
   "suburb": "AMAMOOR",
   "postcode": "4570"
 },
 {
   "suburb": "ANDERLEIGH",
   "postcode": "4570"
 },
 {
   "suburb": "ARALUEN",
   "postcode": "4570"
 },
 {
   "suburb": "BANKS POCKET",
   "postcode": "4570"
 },
 {
   "suburb": "BEENAAM VALLEY",
   "postcode": "4570"
 },
 {
   "suburb": "BELLS BRIDGE",
   "postcode": "4570"
 },
 {
   "suburb": "BOLLIER",
   "postcode": "4570"
 },
 {
   "suburb": "BROOLOO",
   "postcode": "4570"
 },
 {
   "suburb": "CALICO CREEK",
   "postcode": "4570"
 },
 {
   "suburb": "CANINA",
   "postcode": "4570"
 },
 {
   "suburb": "CEDAR POCKET",
   "postcode": "4570"
 },
 {
   "suburb": "CHATSWORTH",
   "postcode": "4570"
 },
 {
   "suburb": "COLES CREEK",
   "postcode": "4570"
 },
 {
   "suburb": "COONDOO",
   "postcode": "4570"
 },
 {
   "suburb": "CORELLA",
   "postcode": "4570"
 },
 {
   "suburb": "CURRA",
   "postcode": "4570"
 },
 {
   "suburb": "DAGUN",
   "postcode": "4570"
 },
 {
   "suburb": "DOWNSFIELD",
   "postcode": "4570"
 },
 {
   "suburb": "EAST DEEP CREEK",
   "postcode": "4570"
 },
 {
   "suburb": "FISHERMANS POCKET",
   "postcode": "4570"
 },
 {
   "suburb": "GILLDORA",
   "postcode": "4570"
 },
 {
   "suburb": "GLANMIRE",
   "postcode": "4570"
 },
 {
   "suburb": "GLASTONBURY",
   "postcode": "4570"
 },
 {
   "suburb": "GLENWOOD",
   "postcode": "4570"
 },
 {
   "suburb": "GOOMBOORIAN",
   "postcode": "4570"
 },
 {
   "suburb": "GREENS CREEK",
   "postcode": "4570"
 },
 {
   "suburb": "GUNALDA",
   "postcode": "4570"
 },
 {
   "suburb": "GYMPIE",
   "postcode": "4570"
 },
 {
   "suburb": "IMBIL",
   "postcode": "4570"
 },
 {
   "suburb": "JONES HILL",
   "postcode": "4570"
 },
 {
   "suburb": "KANDANGA",
   "postcode": "4570"
 },
 {
   "suburb": "KANDANGA CREEK",
   "postcode": "4570"
 },
 {
   "suburb": "KANIGAN",
   "postcode": "4570"
 },
 {
   "suburb": "KIA ORA",
   "postcode": "4570"
 },
 {
   "suburb": "KYBONG",
   "postcode": "4570"
 },
 {
   "suburb": "LAGOON POCKET",
   "postcode": "4570"
 },
 {
   "suburb": "LANGSHAW",
   "postcode": "4570"
 },
 {
   "suburb": "LONG FLAT",
   "postcode": "4570"
 },
 {
   "suburb": "MARYS CREEK",
   "postcode": "4570"
 },
 {
   "suburb": "MCINTOSH CREEK",
   "postcode": "4570"
 },
 {
   "suburb": "MELAWONDI",
   "postcode": "4570"
 },
 {
   "suburb": "MONKLAND",
   "postcode": "4570"
 },
 {
   "suburb": "MOOLOO",
   "postcode": "4570"
 },
 {
   "suburb": "MOTHAR MOUNTAIN",
   "postcode": "4570"
 },
 {
   "suburb": "NAHRUNDA",
   "postcode": "4570"
 },
 {
   "suburb": "NEERDIE",
   "postcode": "4570"
 },
 {
   "suburb": "NEUSA VALE",
   "postcode": "4570"
 },
 {
   "suburb": "NORTH DEEP CREEK",
   "postcode": "4570"
 },
 {
   "suburb": "PIE CREEK",
   "postcode": "4570"
 },
 {
   "suburb": "ROSS CREEK",
   "postcode": "4570"
 },
 {
   "suburb": "SCOTCHY POCKET",
   "postcode": "4570"
 },
 {
   "suburb": "SCRUBBY CREEK",
   "postcode": "4570"
 },
 {
   "suburb": "SEXTON",
   "postcode": "4570"
 },
 {
   "suburb": "SOUTHSIDE",
   "postcode": "4570"
 },
 {
   "suburb": "TAMAREE",
   "postcode": "4570"
 },
 {
   "suburb": "TANDUR",
   "postcode": "4570"
 },
 {
   "suburb": "THE DAWN",
   "postcode": "4570"
 },
 {
   "suburb": "THE PALMS",
   "postcode": "4570"
 },
 {
   "suburb": "THEEBINE",
   "postcode": "4570"
 },
 {
   "suburb": "TRAVESTON",
   "postcode": "4570"
 },
 {
   "suburb": "TUCHEKOI",
   "postcode": "4570"
 },
 {
   "suburb": "TWO MILE",
   "postcode": "4570"
 },
 {
   "suburb": "VETERAN",
   "postcode": "4570"
 },
 {
   "suburb": "VICTORY HEIGHTS",
   "postcode": "4570"
 },
 {
   "suburb": "WIDGEE",
   "postcode": "4570"
 },
 {
   "suburb": "WIDGEE CROSSING NORTH",
   "postcode": "4570"
 },
 {
   "suburb": "WIDGEE CROSSING SOUTH",
   "postcode": "4570"
 },
 {
   "suburb": "WILSONS POCKET",
   "postcode": "4570"
 },
 {
   "suburb": "WOLVI",
   "postcode": "4570"
 },
 {
   "suburb": "WOONDUM",
   "postcode": "4570"
 },
 {
   "suburb": "ALEXANDRA HEADLAND",
   "postcode": "4572"
 },
 {
   "suburb": "COOLUM BEACH",
   "postcode": "4573"
 },
 {
   "suburb": "MARCUS BEACH",
   "postcode": "4573"
 },
 {
   "suburb": "MOUNT COOLUM",
   "postcode": "4573"
 },
 {
   "suburb": "PEREGIAN BEACH",
   "postcode": "4573"
 },
 {
   "suburb": "PEREGIAN SPRINGS",
   "postcode": "4573"
 },
 {
   "suburb": "POINT ARKWRIGHT",
   "postcode": "4573"
 },
 {
   "suburb": "YAROOMBA",
   "postcode": "4573"
 },
 {
   "suburb": "GHEERULLA",
   "postcode": "4574"
 },
 {
   "suburb": "KENILWORTH",
   "postcode": "4574"
 },
 {
   "suburb": "OBI OBI",
   "postcode": "4574"
 },
 {
   "suburb": "BIRTINYA",
   "postcode": "4575"
 },
 {
   "suburb": "BOKARINA",
   "postcode": "4575"
 },
 {
   "suburb": "BUDDINA",
   "postcode": "4575"
 },
 {
   "suburb": "MINYAMA",
   "postcode": "4575"
 },
 {
   "suburb": "PARREARRA",
   "postcode": "4575"
 },
 {
   "suburb": "WARANA",
   "postcode": "4575"
 },
 {
   "suburb": "WURTULLA",
   "postcode": "4575"
 },
 {
   "suburb": "COOLOOLA COVE",
   "postcode": "4580"
 },
 {
   "suburb": "TIN CAN BAY",
   "postcode": "4580"
 },
 {
   "suburb": "RAINBOW BEACH",
   "postcode": "4581"
 },
 {
   "suburb": "BOOIE",
   "postcode": "4610"
 },
 {
   "suburb": "COOLABUNIA",
   "postcode": "4610"
 },
 {
   "suburb": "CORNDALE",
   "postcode": "4610"
 },
 {
   "suburb": "CRAWFORD",
   "postcode": "4610"
 },
 {
   "suburb": "ELLESMERE",
   "postcode": "4610"
 },
 {
   "suburb": "HALY CREEK",
   "postcode": "4610"
 },
 {
   "suburb": "HODGLEIGH",
   "postcode": "4610"
 },
 {
   "suburb": "KINGAROY",
   "postcode": "4610"
 },
 {
   "suburb": "KUMBIA",
   "postcode": "4610"
 },
 {
   "suburb": "MEMERAMBI",
   "postcode": "4610"
 },
 {
   "suburb": "TAABINGA",
   "postcode": "4610"
 },
 {
   "suburb": "YARRAMAN",
   "postcode": "4614"
 },
 {
   "suburb": "BARKER CREEK FLAT",
   "postcode": "4615"
 },
 {
   "suburb": "BROOKLANDS",
   "postcode": "4615"
 },
 {
   "suburb": "BULLCAMP",
   "postcode": "4615"
 },
 {
   "suburb": "EAST NANANGO",
   "postcode": "4615"
 },
 {
   "suburb": "GLAN DEVON",
   "postcode": "4615"
 },
 {
   "suburb": "JOHNSTOWN",
   "postcode": "4615"
 },
 {
   "suburb": "MAIDENWELL",
   "postcode": "4615"
 },
 {
   "suburb": "NANANGO",
   "postcode": "4615"
 },
 {
   "suburb": "PIMPIMBUDGEE",
   "postcode": "4615"
 },
 {
   "suburb": "SANDY RIDGES",
   "postcode": "4615"
 },
 {
   "suburb": "SOUTH EAST NANANGO",
   "postcode": "4615"
 },
 {
   "suburb": "SOUTH NANANGO",
   "postcode": "4615"
 },
 {
   "suburb": "WYALLA",
   "postcode": "4615"
 },
 {
   "suburb": "ALDERSHOT",
   "postcode": "4650"
 },
 {
   "suburb": "ANTIGUA",
   "postcode": "4650"
 },
 {
   "suburb": "BAUPLE",
   "postcode": "4650"
 },
 {
   "suburb": "BAUPLE FOREST",
   "postcode": "4650"
 },
 {
   "suburb": "BEAVER ROCK",
   "postcode": "4650"
 },
 {
   "suburb": "BIDWILL",
   "postcode": "4650"
 },
 {
   "suburb": "BOONOOROO",
   "postcode": "4650"
 },
 {
   "suburb": "BOONOOROO PLAINS",
   "postcode": "4650"
 },
 {
   "suburb": "DUCKINWILLA",
   "postcode": "4650"
 },
 {
   "suburb": "DUNDATHU",
   "postcode": "4650"
 },
 {
   "suburb": "DUNMORA",
   "postcode": "4650"
 },
 {
   "suburb": "FERNEY",
   "postcode": "4650"
 },
 {
   "suburb": "GLENORCHY",
   "postcode": "4650"
 },
 {
   "suburb": "GOOTCHIE",
   "postcode": "4650"
 },
 {
   "suburb": "GRAHAMS CREEK",
   "postcode": "4650"
 },
 {
   "suburb": "GRANVILLE",
   "postcode": "4650"
 },
 {
   "suburb": "GUNDIAH",
   "postcode": "4650"
 },
 {
   "suburb": "ISLAND PLANTATION",
   "postcode": "4650"
 },
 {
   "suburb": "MAAROOM",
   "postcode": "4650"
 },
 {
   "suburb": "MAGNOLIA",
   "postcode": "4650"
 },
 {
   "suburb": "MARYBOROUGH",
   "postcode": "4650"
 },
 {
   "suburb": "MARYBOROUGH WEST",
   "postcode": "4650"
 },
 {
   "suburb": "MOUNT URAH",
   "postcode": "4650"
 },
 {
   "suburb": "MUNGAR",
   "postcode": "4650"
 },
 {
   "suburb": "NETHERBY",
   "postcode": "4650"
 },
 {
   "suburb": "OAKHURST",
   "postcode": "4650"
 },
 {
   "suburb": "OWANYILLA",
   "postcode": "4650"
 },
 {
   "suburb": "PALLAS STREET MARYBOROUGH",
   "postcode": "4650"
 },
 {
   "suburb": "PILERWA",
   "postcode": "4650"
 },
 {
   "suburb": "PIONEERS REST",
   "postcode": "4650"
 },
 {
   "suburb": "POONA",
   "postcode": "4650"
 },
 {
   "suburb": "PRAWLE",
   "postcode": "4650"
 },
 {
   "suburb": "ST HELENS",
   "postcode": "4650"
 },
 {
   "suburb": "ST MARY",
   "postcode": "4650"
 },
 {
   "suburb": "TALEGALLA WEIR",
   "postcode": "4650"
 },
 {
   "suburb": "TANDORA",
   "postcode": "4650"
 },
 {
   "suburb": "TEDDINGTON",
   "postcode": "4650"
 },
 {
   "suburb": "THE DIMONDS",
   "postcode": "4650"
 },
 {
   "suburb": "THINOOMBA",
   "postcode": "4650"
 },
 {
   "suburb": "TIARO",
   "postcode": "4650"
 },
 {
   "suburb": "TINANA",
   "postcode": "4650"
 },
 {
   "suburb": "TINANA SOUTH",
   "postcode": "4650"
 },
 {
   "suburb": "TINNANBAR",
   "postcode": "4650"
 },
 {
   "suburb": "TUAN",
   "postcode": "4650"
 },
 {
   "suburb": "TUAN FOREST",
   "postcode": "4650"
 },
 {
   "suburb": "WALKERS POINT",
   "postcode": "4650"
 },
 {
   "suburb": "YENGARIE",
   "postcode": "4650"
 },
 {
   "suburb": "YERRA",
   "postcode": "4650"
 },
 {
   "suburb": "BOORAL",
   "postcode": "4655"
 },
 {
   "suburb": "BUNYA CREEK",
   "postcode": "4655"
 },
 {
   "suburb": "CRAIGNISH",
   "postcode": "4655"
 },
 {
   "suburb": "DUNDOWRAN",
   "postcode": "4655"
 },
 {
   "suburb": "DUNDOWRAN BEACH",
   "postcode": "4655"
 },
 {
   "suburb": "ELI WATERS",
   "postcode": "4655"
 },
 {
   "suburb": "GREAT SANDY STRAIT",
   "postcode": "4655"
 },
 {
   "suburb": "HERVEY BAY",
   "postcode": "4655"
 },
 {
   "suburb": "KAWUNGAN",
   "postcode": "4655"
 },
 {
   "suburb": "KINGFISHER BAY RESORT",
   "postcode": "4655"
 },
 {
   "suburb": "NIKENBAH",
   "postcode": "4655"
 },
 {
   "suburb": "PIALBA",
   "postcode": "4655"
 },
 {
   "suburb": "POINT VERNON",
   "postcode": "4655"
 },
 {
   "suburb": "RIVER HEADS",
   "postcode": "4655"
 },
 {
   "suburb": "SCARNESS",
   "postcode": "4655"
 },
 {
   "suburb": "SUNSHINE ACRES",
   "postcode": "4655"
 },
 {
   "suburb": "SUSAN RIVER",
   "postcode": "4655"
 },
 {
   "suburb": "TAKURA",
   "postcode": "4655"
 },
 {
   "suburb": "TOOGOOM",
   "postcode": "4655"
 },
 {
   "suburb": "TORQUAY",
   "postcode": "4655"
 },
 {
   "suburb": "URANGAN",
   "postcode": "4655"
 },
 {
   "suburb": "URRAWEEN",
   "postcode": "4655"
 },
 {
   "suburb": "WALLIEBUM",
   "postcode": "4655"
 },
 {
   "suburb": "WALLIGAN",
   "postcode": "4655"
 },
 {
   "suburb": "WONDUNNA",
   "postcode": "4655"
 },
 {
   "suburb": "BEELBI CREEK",
   "postcode": "4659"
 },
 {
   "suburb": "BURGOWAN",
   "postcode": "4659"
 },
 {
   "suburb": "BURRUM HEADS",
   "postcode": "4659"
 },
 {
   "suburb": "BURRUM RIVER",
   "postcode": "4659"
 },
 {
   "suburb": "BURRUM TOWN",
   "postcode": "4659"
 },
 {
   "suburb": "HOWARD",
   "postcode": "4659"
 },
 {
   "suburb": "PACIFIC HAVEN",
   "postcode": "4659"
 },
 {
   "suburb": "ABINGTON",
   "postcode": "4660"
 },
 {
   "suburb": "APPLE TREE CREEK",
   "postcode": "4660"
 },
 {
   "suburb": "BUXTON",
   "postcode": "4660"
 },
 {
   "suburb": "CHERWELL",
   "postcode": "4660"
 },
 {
   "suburb": "CHILDERS",
   "postcode": "4660"
 },
 {
   "suburb": "CORDALBA",
   "postcode": "4660"
 },
 {
   "suburb": "DOOLBI",
   "postcode": "4660"
 },
 {
   "suburb": "EUREKA",
   "postcode": "4660"
 },
 {
   "suburb": "FARNSFIELD",
   "postcode": "4660"
 },
 {
   "suburb": "GOODWOOD",
   "postcode": "4660"
 },
 {
   "suburb": "GREGORY RIVER",
   "postcode": "4660"
 },
 {
   "suburb": "HORTON",
   "postcode": "4660"
 },
 {
   "suburb": "ISIS CENTRAL",
   "postcode": "4660"
 },
 {
   "suburb": "ISIS RIVER",
   "postcode": "4660"
 },
 {
   "suburb": "KULLOGUM",
   "postcode": "4660"
 },
 {
   "suburb": "NORTH GREGORY",
   "postcode": "4660"
 },
 {
   "suburb": "NORTH ISIS",
   "postcode": "4660"
 },
 {
   "suburb": "PROMISEDLAND",
   "postcode": "4660"
 },
 {
   "suburb": "REDRIDGE",
   "postcode": "4660"
 },
 {
   "suburb": "SOUTH ISIS",
   "postcode": "4660"
 },
 {
   "suburb": "WOODGATE",
   "postcode": "4660"
 },
 {
   "suburb": "TORBANLEA",
   "postcode": "4662"
 },
 {
   "suburb": "ABBOTSFORD",
   "postcode": "4670"
 },
 {
   "suburb": "ALLOWAY",
   "postcode": "4670"
 },
 {
   "suburb": "ASHFIELD",
   "postcode": "4670"
 },
 {
   "suburb": "AVENELL HEIGHTS",
   "postcode": "4670"
 },
 {
   "suburb": "AVOCA",
   "postcode": "4670"
 },
 {
   "suburb": "AVONDALE",
   "postcode": "4670"
 },
 {
   "suburb": "BARGARA",
   "postcode": "4670"
 },
 {
   "suburb": "BRANYAN",
   "postcode": "4670"
 },
 {
   "suburb": "BUCCA",
   "postcode": "4670"
 },
 {
   "suburb": "BUNDABERG",
   "postcode": "4670"
 },
 {
   "suburb": "BUNDABERG CENTRAL",
   "postcode": "4670"
 },
 {
   "suburb": "BUNDABERG EAST",
   "postcode": "4670"
 },
 {
   "suburb": "BUNDABERG NORTH",
   "postcode": "4670"
 },
 {
   "suburb": "BUNDABERG SOUTH",
   "postcode": "4670"
 },
 {
   "suburb": "BUNDABERG WEST",
   "postcode": "4670"
 },
 {
   "suburb": "BURNETT HEADS",
   "postcode": "4670"
 },
 {
   "suburb": "CALAVOS",
   "postcode": "4670"
 },
 {
   "suburb": "COONARR",
   "postcode": "4670"
 },
 {
   "suburb": "CORAL COVE",
   "postcode": "4670"
 },
 {
   "suburb": "ELECTRA",
   "postcode": "4670"
 },
 {
   "suburb": "ELLIOTT",
   "postcode": "4670"
 },
 {
   "suburb": "ELLIOTT HEADS",
   "postcode": "4670"
 },
 {
   "suburb": "FAIRYMEAD",
   "postcode": "4670"
 },
 {
   "suburb": "GIVELDA",
   "postcode": "4670"
 },
 {
   "suburb": "GOOBURRUM",
   "postcode": "4670"
 },
 {
   "suburb": "INNES PARK",
   "postcode": "4670"
 },
 {
   "suburb": "KALKIE",
   "postcode": "4670"
 },
 {
   "suburb": "KENSINGTON",
   "postcode": "4670"
 },
 {
   "suburb": "KEPNOCK",
   "postcode": "4670"
 },
 {
   "suburb": "KINKUNA",
   "postcode": "4670"
 },
 {
   "suburb": "MEADOWVALE",
   "postcode": "4670"
 },
 {
   "suburb": "MILLBANK",
   "postcode": "4670"
 },
 {
   "suburb": "MON REPOS",
   "postcode": "4670"
 },
 {
   "suburb": "MOORE PARK BEACH",
   "postcode": "4670"
 },
 {
   "suburb": "MOORLAND",
   "postcode": "4670"
 },
 {
   "suburb": "MULLETT CREEK",
   "postcode": "4670"
 },
 {
   "suburb": "NORVILLE",
   "postcode": "4670"
 },
 {
   "suburb": "OAKWOOD",
   "postcode": "4670"
 },
 {
   "suburb": "PINE CREEK",
   "postcode": "4670"
 },
 {
   "suburb": "QUNABA",
   "postcode": "4670"
 },
 {
   "suburb": "RUBYANNA",
   "postcode": "4670"
 },
 {
   "suburb": "SHARON",
   "postcode": "4670"
 },
 {
   "suburb": "SOUTH BINGERA",
   "postcode": "4670"
 },
 {
   "suburb": "SOUTH KOLAN",
   "postcode": "4670"
 },
 {
   "suburb": "SVENSSON HEIGHTS",
   "postcode": "4670"
 },
 {
   "suburb": "THABEBAN",
   "postcode": "4670"
 },
 {
   "suburb": "WALKERVALE",
   "postcode": "4670"
 },
 {
   "suburb": "WATALGAN",
   "postcode": "4670"
 },
 {
   "suburb": "WELCOME CREEK",
   "postcode": "4670"
 },
 {
   "suburb": "WINDERMERE",
   "postcode": "4670"
 },
 {
   "suburb": "WINFIELD",
   "postcode": "4670"
 },
 {
   "suburb": "WOONGARRA",
   "postcode": "4670"
 },
 {
   "suburb": "BULLYARD",
   "postcode": "4671"
 },
 {
   "suburb": "DELAN",
   "postcode": "4671"
 },
 {
   "suburb": "GIN GIN",
   "postcode": "4671"
 },
 {
   "suburb": "MAROONDAN",
   "postcode": "4671"
 },
 {
   "suburb": "MCILWRAITH",
   "postcode": "4671"
 },
 {
   "suburb": "MOOLBOOLAMAN",
   "postcode": "4671"
 },
 {
   "suburb": "WALLAVILLE",
   "postcode": "4671"
 },
 {
   "suburb": "MIARA",
   "postcode": "4673"
 },
 {
   "suburb": "WATERLOO",
   "postcode": "4673"
 },
 {
   "suburb": "YANDARAN",
   "postcode": "4673"
 },
 {
   "suburb": "ROSEDALE",
   "postcode": "4674"
 },
 {
   "suburb": "AGNES WATER",
   "postcode": "4677"
 },
 {
   "suburb": "CAPTAIN CREEK",
   "postcode": "4677"
 },
 {
   "suburb": "COLOSSEUM",
   "postcode": "4677"
 },
 {
   "suburb": "MIRIAM VALE",
   "postcode": "4677"
 },
 {
   "suburb": "MOUNT TOM",
   "postcode": "4677"
 },
 {
   "suburb": "ROUND HILL",
   "postcode": "4677"
 },
 {
   "suburb": "SEVENTEEN SEVENTY",
   "postcode": "4677"
 },
 {
   "suburb": "BARNEY POINT",
   "postcode": "4680"
 },
 {
   "suburb": "BEECHER",
   "postcode": "4680"
 },
 {
   "suburb": "BENARABY",
   "postcode": "4680"
 },
 {
   "suburb": "BOYNE ISLAND",
   "postcode": "4680"
 },
 {
   "suburb": "BUILYAN",
   "postcode": "4680"
 },
 {
   "suburb": "BURUA",
   "postcode": "4680"
 },
 {
   "suburb": "BYELLEE",
   "postcode": "4680"
 },
 {
   "suburb": "CALLEMONDAH",
   "postcode": "4680"
 },
 {
   "suburb": "CALLIOPE",
   "postcode": "4680"
 },
 {
   "suburb": "CLINTON",
   "postcode": "4680"
 },
 {
   "suburb": "CURTIS ISLAND",
   "postcode": "4680"
 },
 {
   "suburb": "GLADSTONE",
   "postcode": "4680"
 },
 {
   "suburb": "GLADSTONE CENTRAL",
   "postcode": "4680"
 },
 {
   "suburb": "GLADSTONE HARBOUR",
   "postcode": "4680"
 },
 {
   "suburb": "GLEN EDEN",
   "postcode": "4680"
 },
 {
   "suburb": "HERON ISLAND",
   "postcode": "4680"
 },
 {
   "suburb": "IVERAGH",
   "postcode": "4680"
 },
 {
   "suburb": "KIN KORA",
   "postcode": "4680"
 },
 {
   "suburb": "KIRKWOOD",
   "postcode": "4680"
 },
 {
   "suburb": "NEW AUCKLAND",
   "postcode": "4680"
 },
 {
   "suburb": "O'CONNELL",
   "postcode": "4680"
 },
 {
   "suburb": "RIVER RANCH",
   "postcode": "4680"
 },
 {
   "suburb": "SOUTH END",
   "postcode": "4680"
 },
 {
   "suburb": "SOUTH GLADSTONE",
   "postcode": "4680"
 },
 {
   "suburb": "SOUTH TREES",
   "postcode": "4680"
 },
 {
   "suburb": "SUN VALLEY",
   "postcode": "4680"
 },
 {
   "suburb": "TANNUM SANDS",
   "postcode": "4680"
 },
 {
   "suburb": "TARAGOOLA",
   "postcode": "4680"
 },
 {
   "suburb": "TELINA",
   "postcode": "4680"
 },
 {
   "suburb": "TOOLOOA",
   "postcode": "4680"
 },
 {
   "suburb": "UBOBO",
   "postcode": "4680"
 },
 {
   "suburb": "WEST GLADSTONE",
   "postcode": "4680"
 },
 {
   "suburb": "WEST STOWE",
   "postcode": "4680"
 },
 {
   "suburb": "WOODERSON",
   "postcode": "4680"
 },
 {
   "suburb": "WURDONG HEIGHTS",
   "postcode": "4680"
 },
 {
   "suburb": "AMBROSE",
   "postcode": "4695"
 },
 {
   "suburb": "MOUNT LARCOM",
   "postcode": "4695"
 },
 {
   "suburb": "BAJOOL",
   "postcode": "4699"
 },
 {
   "suburb": "ALLENSTOWN",
   "postcode": "4700"
 },
 {
   "suburb": "DEPOT HILL",
   "postcode": "4700"
 },
 {
   "suburb": "FAIRY BOWER",
   "postcode": "4700"
 },
 {
   "suburb": "GREAT KEPPEL ISLAND",
   "postcode": "4700"
 },
 {
   "suburb": "PORT CURTIS",
   "postcode": "4700"
 },
 {
   "suburb": "ROCKHAMPTON",
   "postcode": "4700"
 },
 {
   "suburb": "ROCKHAMPTON CITY",
   "postcode": "4700"
 },
 {
   "suburb": "ROCKHAMPTON HOSPITAL",
   "postcode": "4700"
 },
 {
   "suburb": "THE KEPPELS",
   "postcode": "4700"
 },
 {
   "suburb": "THE RANGE",
   "postcode": "4700"
 },
 {
   "suburb": "WANDAL",
   "postcode": "4700"
 },
 {
   "suburb": "WEST ROCKHAMPTON",
   "postcode": "4700"
 },
 {
   "suburb": "BERSERKER",
   "postcode": "4701"
 },
 {
   "suburb": "CENTRAL QUEENSLAND UNIVERSITY",
   "postcode": "4701"
 },
 {
   "suburb": "FRENCHVILLE",
   "postcode": "4701"
 },
 {
   "suburb": "GREENLAKE",
   "postcode": "4701"
 },
 {
   "suburb": "IRONPOT",
   "postcode": "4701"
 },
 {
   "suburb": "KAWANA",
   "postcode": "4701"
 },
 {
   "suburb": "KOONGAL",
   "postcode": "4701"
 },
 {
   "suburb": "LAKES CREEK",
   "postcode": "4701"
 },
 {
   "suburb": "LIMESTONE CREEK",
   "postcode": "4701"
 },
 {
   "suburb": "MOUNT ARCHER",
   "postcode": "4701"
 },
 {
   "suburb": "NANKIN",
   "postcode": "4701"
 },
 {
   "suburb": "NERIMBERA",
   "postcode": "4701"
 },
 {
   "suburb": "NORMAN GARDENS",
   "postcode": "4701"
 },
 {
   "suburb": "PARK AVENUE",
   "postcode": "4701"
 },
 {
   "suburb": "RED HILL ROCKHAMPTON",
   "postcode": "4701"
 },
 {
   "suburb": "ROCKYVIEW",
   "postcode": "4701"
 },
 {
   "suburb": "SANDRINGHAM",
   "postcode": "4701"
 },
 {
   "suburb": "THE COMMON",
   "postcode": "4701"
 },
 {
   "suburb": "ALTON DOWNS",
   "postcode": "4702"
 },
 {
   "suburb": "BLUFF",
   "postcode": "4702"
 },
 {
   "suburb": "BOULDERCOMBE",
   "postcode": "4702"
 },
 {
   "suburb": "CAWARRAL",
   "postcode": "4702"
 },
 {
   "suburb": "COOROOMAN",
   "postcode": "4702"
 },
 {
   "suburb": "DINGO",
   "postcode": "4702"
 },
 {
   "suburb": "ETNA CREEK",
   "postcode": "4702"
 },
 {
   "suburb": "GRACEMERE",
   "postcode": "4702"
 },
 {
   "suburb": "JOSKELEIGH",
   "postcode": "4702"
 },
 {
   "suburb": "KABRA",
   "postcode": "4702"
 },
 {
   "suburb": "MARMOR",
   "postcode": "4702"
 },
 {
   "suburb": "MIDGEE",
   "postcode": "4702"
 },
 {
   "suburb": "MOUNT CHALMERS",
   "postcode": "4702"
 },
 {
   "suburb": "MOUNT ETNA",
   "postcode": "4702"
 },
 {
   "suburb": "NINE MILE",
   "postcode": "4702"
 },
 {
   "suburb": "NORTH ROCKHAMPTON",
   "postcode": "4702"
 },
 {
   "suburb": "PARKHURST",
   "postcode": "4702"
 },
 {
   "suburb": "PINK LILY",
   "postcode": "4702"
 },
 {
   "suburb": "RIDGELANDS",
   "postcode": "4702"
 },
 {
   "suburb": "ROLLESTON",
   "postcode": "4702"
 },
 {
   "suburb": "STANWELL",
   "postcode": "4702"
 },
 {
   "suburb": "THE CAVES",
   "postcode": "4702"
 },
 {
   "suburb": "THOMPSON POINT",
   "postcode": "4702"
 },
 {
   "suburb": "TUNGAMULL",
   "postcode": "4702"
 },
 {
   "suburb": "ADELAIDE PARK",
   "postcode": "4703"
 },
 {
   "suburb": "BANGALEE",
   "postcode": "4703"
 },
 {
   "suburb": "BARLOWS HILL",
   "postcode": "4703"
 },
 {
   "suburb": "BARMARYEE",
   "postcode": "4703"
 },
 {
   "suburb": "BARMOYA",
   "postcode": "4703"
 },
 {
   "suburb": "BONDOOLA",
   "postcode": "4703"
 },
 {
   "suburb": "BUNGUNDARRA",
   "postcode": "4703"
 },
 {
   "suburb": "CAUSEWAY LAKE",
   "postcode": "4703"
 },
 {
   "suburb": "COBRABALL",
   "postcode": "4703"
 },
 {
   "suburb": "COOEE BAY",
   "postcode": "4703"
 },
 {
   "suburb": "FARNBOROUGH",
   "postcode": "4703"
 },
 {
   "suburb": "HIDDEN VALLEY",
   "postcode": "4703"
 },
 {
   "suburb": "INVERNESS",
   "postcode": "4703"
 },
 {
   "suburb": "KINKA BEACH",
   "postcode": "4703"
 },
 {
   "suburb": "LAKE MARY",
   "postcode": "4703"
 },
 {
   "suburb": "LAMMERMOOR",
   "postcode": "4703"
 },
 {
   "suburb": "MARYVALE",
   "postcode": "4703"
 },
 {
   "suburb": "MEIKLEVILLE HILL",
   "postcode": "4703"
 },
 {
   "suburb": "MULAMBIN",
   "postcode": "4703"
 },
 {
   "suburb": "MULARA",
   "postcode": "4703"
 },
 {
   "suburb": "PACIFIC HEIGHTS",
   "postcode": "4703"
 },
 {
   "suburb": "ROSSLYN",
   "postcode": "4703"
 },
 {
   "suburb": "STOCKYARD",
   "postcode": "4703"
 },
 {
   "suburb": "TANBY",
   "postcode": "4703"
 },
 {
   "suburb": "TARANGANBA",
   "postcode": "4703"
 },
 {
   "suburb": "TAROOMBALL",
   "postcode": "4703"
 },
 {
   "suburb": "WEERRIBA",
   "postcode": "4703"
 },
 {
   "suburb": "WOODBURY",
   "postcode": "4703"
 },
 {
   "suburb": "YEPPOON",
   "postcode": "4703"
 },
 {
   "suburb": "YAAMBA",
   "postcode": "4704"
 },
 {
   "suburb": "MARLBOROUGH",
   "postcode": "4705"
 },
 {
   "suburb": "EMU PARK",
   "postcode": "4710"
 },
 {
   "suburb": "ZILZIE",
   "postcode": "4710"
 },
 {
   "suburb": "GLENDALE",
   "postcode": "4711"
 },
 {
   "suburb": "GLENLEE",
   "postcode": "4711"
 },
 {
   "suburb": "DUARINGA",
   "postcode": "4712"
 },
 {
   "suburb": "BAREE",
   "postcode": "4714"
 },
 {
   "suburb": "BOULDER CREEK",
   "postcode": "4714"
 },
 {
   "suburb": "FLETCHER CREEK",
   "postcode": "4714"
 },
 {
   "suburb": "HAMILTON CREEK",
   "postcode": "4714"
 },
 {
   "suburb": "HORSE CREEK",
   "postcode": "4714"
 },
 {
   "suburb": "JOHNSONS HILL",
   "postcode": "4714"
 },
 {
   "suburb": "LEYDENS HILL",
   "postcode": "4714"
 },
 {
   "suburb": "LIMESTONE",
   "postcode": "4714"
 },
 {
   "suburb": "MOONGAN",
   "postcode": "4714"
 },
 {
   "suburb": "MOUNT MORGAN",
   "postcode": "4714"
 },
 {
   "suburb": "NINE MILE CREEK",
   "postcode": "4714"
 },
 {
   "suburb": "OAKEY CREEK",
   "postcode": "4714"
 },
 {
   "suburb": "STRUCK OIL",
   "postcode": "4714"
 },
 {
   "suburb": "THE MINE",
   "postcode": "4714"
 },
 {
   "suburb": "TROTTER CREEK",
   "postcode": "4714"
 },
 {
   "suburb": "WALMUL",
   "postcode": "4714"
 },
 {
   "suburb": "WALTERHALL",
   "postcode": "4714"
 },
 {
   "suburb": "WURA",
   "postcode": "4714"
 },
 {
   "suburb": "BILOELA",
   "postcode": "4715"
 },
 {
   "suburb": "CALLIDE",
   "postcode": "4715"
 },
 {
   "suburb": "DAKENBA",
   "postcode": "4715"
 },
 {
   "suburb": "GREYCLIFFE",
   "postcode": "4715"
 },
 {
   "suburb": "MOUNT MURCHISON",
   "postcode": "4715"
 },
 {
   "suburb": "ORANGE CREEK",
   "postcode": "4715"
 },
 {
   "suburb": "PROSPECT",
   "postcode": "4715"
 },
 {
   "suburb": "VALENTINE PLAINS",
   "postcode": "4715"
 },
 {
   "suburb": "THANGOOL",
   "postcode": "4716"
 },
 {
   "suburb": "BLACKWATER",
   "postcode": "4717"
 },
 {
   "suburb": "MOURA",
   "postcode": "4718"
 },
 {
   "suburb": "THEODORE",
   "postcode": "4719"
 },
 {
   "suburb": "EMERALD",
   "postcode": "4720"
 },
 {
   "suburb": "SPRINGSURE",
   "postcode": "4722"
 },
 {
   "suburb": "ARMSTRONG BEACH",
   "postcode": "4737"
 },
 {
   "suburb": "CAMPWIN BEACH",
   "postcode": "4737"
 },
 {
   "suburb": "COLSTONE PARK",
   "postcode": "4737"
 },
 {
   "suburb": "FRESHWATER POINT",
   "postcode": "4737"
 },
 {
   "suburb": "GRASSTREE",
   "postcode": "4737"
 },
 {
   "suburb": "PLANE CREEK WEST",
   "postcode": "4737"
 },
 {
   "suburb": "SARINA",
   "postcode": "4737"
 },
 {
   "suburb": "SARINA BEACH",
   "postcode": "4737"
 },
 {
   "suburb": "SHINFIELD",
   "postcode": "4737"
 },
 {
   "suburb": "SUNNYSIDE",
   "postcode": "4737"
 },
 {
   "suburb": "ALEXANDRA",
   "postcode": "4740"
 },
 {
   "suburb": "ALLIGATOR CREEK",
   "postcode": "4740"
 },
 {
   "suburb": "ANDERGROVE",
   "postcode": "4740"
 },
 {
   "suburb": "BAKERS CREEK",
   "postcode": "4740"
 },
 {
   "suburb": "BALBERRA",
   "postcode": "4740"
 },
 {
   "suburb": "BALNAGOWAN",
   "postcode": "4740"
 },
 {
   "suburb": "BEACONSFIELD",
   "postcode": "4740"
 },
 {
   "suburb": "BELMUNDA",
   "postcode": "4740"
 },
 {
   "suburb": "BLACKS BEACH",
   "postcode": "4740"
 },
 {
   "suburb": "CAPE HILLSBOROUGH",
   "postcode": "4740"
 },
 {
   "suburb": "CHELONA",
   "postcode": "4740"
 },
 {
   "suburb": "CREMORNE",
   "postcode": "4740"
 },
 {
   "suburb": "DOLPHIN HEADS",
   "postcode": "4740"
 },
 {
   "suburb": "DUMBLETON",
   "postcode": "4740"
 },
 {
   "suburb": "DUNDULA",
   "postcode": "4740"
 },
 {
   "suburb": "DUNNROCK",
   "postcode": "4740"
 },
 {
   "suburb": "EAST MACKAY",
   "postcode": "4740"
 },
 {
   "suburb": "EIMEO",
   "postcode": "4740"
 },
 {
   "suburb": "ERAKALA",
   "postcode": "4740"
 },
 {
   "suburb": "FOULDEN",
   "postcode": "4740"
 },
 {
   "suburb": "GLENELLA",
   "postcode": "4740"
 },
 {
   "suburb": "GRASSTREE BEACH",
   "postcode": "4740"
 },
 {
   "suburb": "HABANA",
   "postcode": "4740"
 },
 {
   "suburb": "HALIDAY BAY",
   "postcode": "4740"
 },
 {
   "suburb": "HAY POINT",
   "postcode": "4740"
 },
 {
   "suburb": "HOMEBUSH",
   "postcode": "4740"
 },
 {
   "suburb": "MACKAY",
   "postcode": "4740"
 },
 {
   "suburb": "MACKAY CANELAND",
   "postcode": "4740"
 },
 {
   "suburb": "MACKAY HARBOUR",
   "postcode": "4740"
 },
 {
   "suburb": "MACKAY NORTH",
   "postcode": "4740"
 },
 {
   "suburb": "MACKAY REGIONAL",
   "postcode": "4740"
 },
 {
   "suburb": "MACKAY SOUTH",
   "postcode": "4740"
 },
 {
   "suburb": "MACKAY WEST",
   "postcode": "4740"
 },
 {
   "suburb": "MCEWENS BEACH",
   "postcode": "4740"
 },
 {
   "suburb": "MOUNT JUKES",
   "postcode": "4740"
 },
 {
   "suburb": "MOUNT PLEASANT",
   "postcode": "4740"
 },
 {
   "suburb": "MUNBURA",
   "postcode": "4740"
 },
 {
   "suburb": "NINDAROO",
   "postcode": "4740"
 },
 {
   "suburb": "NORTH MACKAY",
   "postcode": "4740"
 },
 {
   "suburb": "OORALEA",
   "postcode": "4740"
 },
 {
   "suburb": "PAGET",
   "postcode": "4740"
 },
 {
   "suburb": "RACECOURSE",
   "postcode": "4740"
 },
 {
   "suburb": "RICHMOND",
   "postcode": "4740"
 },
 {
   "suburb": "ROSELLA",
   "postcode": "4740"
 },
 {
   "suburb": "RURAL VIEW",
   "postcode": "4740"
 },
 {
   "suburb": "SANDIFORD",
   "postcode": "4740"
 },
 {
   "suburb": "SLADE POINT",
   "postcode": "4740"
 },
 {
   "suburb": "SOUTH MACKAY",
   "postcode": "4740"
 },
 {
   "suburb": "TE KOWAI",
   "postcode": "4740"
 },
 {
   "suburb": "THE LEAP",
   "postcode": "4740"
 },
 {
   "suburb": "WEST MACKAY",
   "postcode": "4740"
 },
 {
   "suburb": "BALL BAY",
   "postcode": "4741"
 },
 {
   "suburb": "BRIGHTLY",
   "postcode": "4741"
 },
 {
   "suburb": "COPPABELLA",
   "postcode": "4741"
 },
 {
   "suburb": "ETON",
   "postcode": "4741"
 },
 {
   "suburb": "FARLEIGH",
   "postcode": "4741"
 },
 {
   "suburb": "GARGETT",
   "postcode": "4741"
 },
 {
   "suburb": "HAMPDEN",
   "postcode": "4741"
 },
 {
   "suburb": "KINCHANT DAM",
   "postcode": "4741"
 },
 {
   "suburb": "KUTTABUL",
   "postcode": "4741"
 },
 {
   "suburb": "MACKAY MC",
   "postcode": "4741"
 },
 {
   "suburb": "MOUNT OSSA",
   "postcode": "4741"
 },
 {
   "suburb": "MOUNT PELION",
   "postcode": "4741"
 },
 {
   "suburb": "NORTH ETON",
   "postcode": "4741"
 },
 {
   "suburb": "OAKENDEN",
   "postcode": "4741"
 },
 {
   "suburb": "PINNACLE",
   "postcode": "4741"
 },
 {
   "suburb": "PLEYSTOWE",
   "postcode": "4741"
 },
 {
   "suburb": "SEAFORTH",
   "postcode": "4741"
 },
 {
   "suburb": "YALBOROO",
   "postcode": "4741"
 },
 {
   "suburb": "NEBO",
   "postcode": "4742"
 },
 {
   "suburb": "MORANBAH",
   "postcode": "4744"
 },
 {
   "suburb": "DYSART",
   "postcode": "4745"
 },
 {
   "suburb": "MIDDLEMOUNT",
   "postcode": "4746"
 },
 {
   "suburb": "BUCASIA",
   "postcode": "4750"
 },
 {
   "suburb": "MACKAY",
   "postcode": "4750"
 },
 {
   "suburb": "SHOAL POINT",
   "postcode": "4750"
 },
 {
   "suburb": "GREENMOUNT",
   "postcode": "4751"
 },
 {
   "suburb": "PALMYRA",
   "postcode": "4751"
 },
 {
   "suburb": "VICTORIA PLAINS",
   "postcode": "4751"
 },
 {
   "suburb": "WALKERSTON",
   "postcode": "4751"
 },
 {
   "suburb": "DEVEREUX CREEK",
   "postcode": "4753"
 },
 {
   "suburb": "MARIAN",
   "postcode": "4753"
 },
 {
   "suburb": "BENHOLME",
   "postcode": "4754"
 },
 {
   "suburb": "MIRANI",
   "postcode": "4754"
 },
 {
   "suburb": "MOUNT MARTIN",
   "postcode": "4754"
 },
 {
   "suburb": "BLOOMSBURY",
   "postcode": "4799"
 },
 {
   "suburb": "MIDGE POINT",
   "postcode": "4799"
 },
 {
   "suburb": "CANNON VALLEY",
   "postcode": "4800"
 },
 {
   "suburb": "CONWAY",
   "postcode": "4800"
 },
 {
   "suburb": "CONWAY BEACH",
   "postcode": "4800"
 },
 {
   "suburb": "FOXDALE",
   "postcode": "4800"
 },
 {
   "suburb": "GLEN ISLA",
   "postcode": "4800"
 },
 {
   "suburb": "GUNYARRA",
   "postcode": "4800"
 },
 {
   "suburb": "HAMILTON PLAINS",
   "postcode": "4800"
 },
 {
   "suburb": "LETHEBROOK",
   "postcode": "4800"
 },
 {
   "suburb": "MOUNT JULIAN",
   "postcode": "4800"
 },
 {
   "suburb": "MOUNT MARLOW",
   "postcode": "4800"
 },
 {
   "suburb": "PALM GROVE",
   "postcode": "4800"
 },
 {
   "suburb": "PRESTON",
   "postcode": "4800"
 },
 {
   "suburb": "PROSERPINE",
   "postcode": "4800"
 },
 {
   "suburb": "RIORDANVALE",
   "postcode": "4800"
 },
 {
   "suburb": "STRATHDICKIE",
   "postcode": "4800"
 },
 {
   "suburb": "SUGARLOAF",
   "postcode": "4800"
 },
 {
   "suburb": "WILSON BEACH",
   "postcode": "4800"
 },
 {
   "suburb": "AIRLIE BEACH",
   "postcode": "4802"
 },
 {
   "suburb": "CANNONVALE",
   "postcode": "4802"
 },
 {
   "suburb": "FLAMETREE",
   "postcode": "4802"
 },
 {
   "suburb": "JUBILEE POCKET",
   "postcode": "4802"
 },
 {
   "suburb": "MANDALAY",
   "postcode": "4802"
 },
 {
   "suburb": "SHUTE HARBOUR",
   "postcode": "4802"
 },
 {
   "suburb": "WOODWARK",
   "postcode": "4802"
 },
 {
   "suburb": "BOGIE",
   "postcode": "4805"
 },
 {
   "suburb": "BOWEN",
   "postcode": "4805"
 },
 {
   "suburb": "GUMLU",
   "postcode": "4805"
 },
 {
   "suburb": "GUTHALUNGRA",
   "postcode": "4805"
 },
 {
   "suburb": "MERINDA",
   "postcode": "4805"
 },
 {
   "suburb": "QUEENS BEACH",
   "postcode": "4805"
 },
 {
   "suburb": "CARSTAIRS",
   "postcode": "4806"
 },
 {
   "suburb": "FREDERICKSFIELD",
   "postcode": "4806"
 },
 {
   "suburb": "HOME HILL",
   "postcode": "4806"
 },
 {
   "suburb": "INKERMAN",
   "postcode": "4806"
 },
 {
   "suburb": "OSBORNE",
   "postcode": "4806"
 },
 {
   "suburb": "AIRVILLE",
   "postcode": "4807"
 },
 {
   "suburb": "ALVA",
   "postcode": "4807"
 },
 {
   "suburb": "AYR",
   "postcode": "4807"
 },
 {
   "suburb": "JARVISFIELD",
   "postcode": "4807"
 },
 {
   "suburb": "MCDESME",
   "postcode": "4807"
 },
 {
   "suburb": "MOUNT KELLY",
   "postcode": "4807"
 },
 {
   "suburb": "RITA ISLAND",
   "postcode": "4807"
 },
 {
   "suburb": "BRANDON",
   "postcode": "4808"
 },
 {
   "suburb": "COLEVALE",
   "postcode": "4808"
 },
 {
   "suburb": "BARRATTA",
   "postcode": "4809"
 },
 {
   "suburb": "HORSESHOE LAGOON",
   "postcode": "4809"
 },
 {
   "suburb": "MOUNT SURROUND",
   "postcode": "4809"
 },
 {
   "suburb": "BELGIAN GARDENS",
   "postcode": "4810"
 },
 {
   "suburb": "CAPE CLEVELAND",
   "postcode": "4810"
 },
 {
   "suburb": "CASTLE HILL",
   "postcode": "4810"
 },
 {
   "suburb": "GARBUTT",
   "postcode": "4810"
 },
 {
   "suburb": "NORTH WARD",
   "postcode": "4810"
 },
 {
   "suburb": "OONOONBA",
   "postcode": "4810"
 },
 {
   "suburb": "PALLARENDA",
   "postcode": "4810"
 },
 {
   "suburb": "RAILWAY ESTATE",
   "postcode": "4810"
 },
 {
   "suburb": "ROWES BAY",
   "postcode": "4810"
 },
 {
   "suburb": "SHELLY BEACH",
   "postcode": "4810"
 },
 {
   "suburb": "SOUTH TOWNSVILLE",
   "postcode": "4810"
 },
 {
   "suburb": "TOWN COMMON",
   "postcode": "4810"
 },
 {
   "suburb": "TOWNSVILLE",
   "postcode": "4810"
 },
 {
   "suburb": "TOWNSVILLE CITY",
   "postcode": "4810"
 },
 {
   "suburb": "TOWNSVILLE MC",
   "postcode": "4810"
 },
 {
   "suburb": "WEST END",
   "postcode": "4810"
 },
 {
   "suburb": "CLUDEN",
   "postcode": "4811"
 },
 {
   "suburb": "IDALIA",
   "postcode": "4811"
 },
 {
   "suburb": "JAMES COOK UNIVERSITY",
   "postcode": "4811"
 },
 {
   "suburb": "MOUNT STUART",
   "postcode": "4811"
 },
 {
   "suburb": "OAK VALLEY",
   "postcode": "4811"
 },
 {
   "suburb": "OONOONBA",
   "postcode": "4811"
 },
 {
   "suburb": "ROSENEATH",
   "postcode": "4811"
 },
 {
   "suburb": "STUART",
   "postcode": "4811"
 },
 {
   "suburb": "TOWNSVILLE",
   "postcode": "4811"
 },
 {
   "suburb": "WULGURU",
   "postcode": "4811"
 },
 {
   "suburb": "CURRAJONG",
   "postcode": "4812"
 },
 {
   "suburb": "GULLIVER",
   "postcode": "4812"
 },
 {
   "suburb": "HERMIT PARK",
   "postcode": "4812"
 },
 {
   "suburb": "HYDE PARK",
   "postcode": "4812"
 },
 {
   "suburb": "HYDE PARK CASTLETOWN",
   "postcode": "4812"
 },
 {
   "suburb": "MUNDINGBURRA",
   "postcode": "4812"
 },
 {
   "suburb": "MYSTERTON",
   "postcode": "4812"
 },
 {
   "suburb": "PIMLICO",
   "postcode": "4812"
 },
 {
   "suburb": "ROSSLEA",
   "postcode": "4812"
 },
 {
   "suburb": "TOWNSVILLE",
   "postcode": "4812"
 },
 {
   "suburb": "LAVARACK BARRACKS",
   "postcode": "4813"
 },
 {
   "suburb": "TOWNSVILLE MILPO",
   "postcode": "4813"
 },
 {
   "suburb": "AITKENVALE",
   "postcode": "4814"
 },
 {
   "suburb": "ANNANDALE",
   "postcode": "4814"
 },
 {
   "suburb": "CRANBROOK",
   "postcode": "4814"
 },
 {
   "suburb": "DOUGLAS",
   "postcode": "4814"
 },
 {
   "suburb": "GARBUTT",
   "postcode": "4814"
 },
 {
   "suburb": "GARBUTT EAST",
   "postcode": "4814"
 },
 {
   "suburb": "HEATLEY",
   "postcode": "4814"
 },
 {
   "suburb": "MOUNT LOUISA",
   "postcode": "4814"
 },
 {
   "suburb": "MURRAY",
   "postcode": "4814"
 },
 {
   "suburb": "TOWNSVILLE",
   "postcode": "4814"
 },
 {
   "suburb": "TOWNSVILLE CITY",
   "postcode": "4814"
 },
 {
   "suburb": "VINCENT",
   "postcode": "4814"
 },
 {
   "suburb": "CONDON",
   "postcode": "4815"
 },
 {
   "suburb": "GRANITE VALE",
   "postcode": "4815"
 },
 {
   "suburb": "GUMLOW",
   "postcode": "4815"
 },
 {
   "suburb": "KELSO",
   "postcode": "4815"
 },
 {
   "suburb": "PINNACLES",
   "postcode": "4815"
 },
 {
   "suburb": "RASMUSSEN",
   "postcode": "4815"
 },
 {
   "suburb": "ALLIGATOR CREEK",
   "postcode": "4816"
 },
 {
   "suburb": "BALGAL BEACH",
   "postcode": "4816"
 },
 {
   "suburb": "BROOKHILL",
   "postcode": "4816"
 },
 {
   "suburb": "ELLERBECK",
   "postcode": "4816"
 },
 {
   "suburb": "JULAGO",
   "postcode": "4816"
 },
 {
   "suburb": "KENNEDY",
   "postcode": "4816"
 },
 {
   "suburb": "NOME",
   "postcode": "4816"
 },
 {
   "suburb": "ROLLINGSTONE",
   "postcode": "4816"
 },
 {
   "suburb": "TOOMULLA",
   "postcode": "4816"
 },
 {
   "suburb": "TOONPAN",
   "postcode": "4816"
 },
 {
   "suburb": "ALICE RIVER",
   "postcode": "4817"
 },
 {
   "suburb": "BOHLE PLAINS",
   "postcode": "4817"
 },
 {
   "suburb": "HERVEY RANGE",
   "postcode": "4817"
 },
 {
   "suburb": "KIRWAN",
   "postcode": "4817"
 },
 {
   "suburb": "RANGEWOOD",
   "postcode": "4817"
 },
 {
   "suburb": "THURINGOWA CENTRAL",
   "postcode": "4817"
 },
 {
   "suburb": "BEACH HOLM",
   "postcode": "4818"
 },
 {
   "suburb": "BLACK RIVER",
   "postcode": "4818"
 },
 {
   "suburb": "BLUE HILLS",
   "postcode": "4818"
 },
 {
   "suburb": "BLUEWATER",
   "postcode": "4818"
 },
 {
   "suburb": "BLUEWATER PARK",
   "postcode": "4818"
 },
 {
   "suburb": "BOHLE",
   "postcode": "4818"
 },
 {
   "suburb": "BURDELL",
   "postcode": "4818"
 },
 {
   "suburb": "BUSHLAND BEACH",
   "postcode": "4818"
 },
 {
   "suburb": "COSGROVE",
   "postcode": "4818"
 },
 {
   "suburb": "DEERAGUN",
   "postcode": "4818"
 },
 {
   "suburb": "JENSEN",
   "postcode": "4818"
 },
 {
   "suburb": "LYNAM",
   "postcode": "4818"
 },
 {
   "suburb": "MOUNT LOW",
   "postcode": "4818"
 },
 {
   "suburb": "MOUNT ST JOHN",
   "postcode": "4818"
 },
 {
   "suburb": "SAUNDERS BEACH",
   "postcode": "4818"
 },
 {
   "suburb": "SHAW",
   "postcode": "4818"
 },
 {
   "suburb": "TOOLAKEA",
   "postcode": "4818"
 },
 {
   "suburb": "YABULU",
   "postcode": "4818"
 },
 {
   "suburb": "ALABAMA HILL",
   "postcode": "4820"
 },
 {
   "suburb": "BALFES CREEK",
   "postcode": "4820"
 },
 {
   "suburb": "BLACK JACK",
   "postcode": "4820"
 },
 {
   "suburb": "BREDDAN",
   "postcode": "4820"
 },
 {
   "suburb": "BROUGHTON",
   "postcode": "4820"
 },
 {
   "suburb": "CHARTERS TOWERS",
   "postcode": "4820"
 },
 {
   "suburb": "CHARTERS TOWERS CITY",
   "postcode": "4820"
 },
 {
   "suburb": "COLUMBIA",
   "postcode": "4820"
 },
 {
   "suburb": "GRAND SECRET",
   "postcode": "4820"
 },
 {
   "suburb": "LISSNER",
   "postcode": "4820"
 },
 {
   "suburb": "MILLCHESTER",
   "postcode": "4820"
 },
 {
   "suburb": "MOSMAN PARK",
   "postcode": "4820"
 },
 {
   "suburb": "QUEENTON",
   "postcode": "4820"
 },
 {
   "suburb": "RICHMOND HILL",
   "postcode": "4820"
 },
 {
   "suburb": "SOUTHERN CROSS",
   "postcode": "4820"
 },
 {
   "suburb": "TOLL",
   "postcode": "4820"
 },
 {
   "suburb": "TOWERS HILL",
   "postcode": "4820"
 },
 {
   "suburb": "CARDWELL",
   "postcode": "4849"
 },
 {
   "suburb": "BLACKROCK",
   "postcode": "4850"
 },
 {
   "suburb": "BRAEMEADOWS",
   "postcode": "4850"
 },
 {
   "suburb": "CORDELIA",
   "postcode": "4850"
 },
 {
   "suburb": "FORESTHOME",
   "postcode": "4850"
 },
 {
   "suburb": "FORREST BEACH",
   "postcode": "4850"
 },
 {
   "suburb": "HELENS HILL",
   "postcode": "4850"
 },
 {
   "suburb": "INGHAM",
   "postcode": "4850"
 },
 {
   "suburb": "LUCINDA",
   "postcode": "4850"
 },
 {
   "suburb": "MACKNADE",
   "postcode": "4850"
 },
 {
   "suburb": "TAYLORS BEACH",
   "postcode": "4850"
 },
 {
   "suburb": "TOOBANNA",
   "postcode": "4850"
 },
 {
   "suburb": "VICTORIA PLANTATION",
   "postcode": "4850"
 },
 {
   "suburb": "CARMOO",
   "postcode": "4852"
 },
 {
   "suburb": "MISSION BEACH",
   "postcode": "4852"
 },
 {
   "suburb": "SOUTH MISSION BEACH",
   "postcode": "4852"
 },
 {
   "suburb": "WONGALING BEACH",
   "postcode": "4852"
 },
 {
   "suburb": "BIRKALLA",
   "postcode": "4854"
 },
 {
   "suburb": "EAST FELUGA",
   "postcode": "4854"
 },
 {
   "suburb": "FELUGA",
   "postcode": "4854"
 },
 {
   "suburb": "MERRYBURN",
   "postcode": "4854"
 },
 {
   "suburb": "SILKY OAK",
   "postcode": "4854"
 },
 {
   "suburb": "TULLY",
   "postcode": "4854"
 },
 {
   "suburb": "TULLY HEADS",
   "postcode": "4854"
 },
 {
   "suburb": "EL ARISH",
   "postcode": "4855"
 },
 {
   "suburb": "GRANADILLA",
   "postcode": "4855"
 },
 {
   "suburb": "SOUTH JOHNSTONE",
   "postcode": "4859"
 },
 {
   "suburb": "BELVEDERE",
   "postcode": "4860"
 },
 {
   "suburb": "COCONUTS",
   "postcode": "4860"
 },
 {
   "suburb": "CULLINANE",
   "postcode": "4860"
 },
 {
   "suburb": "EAST INNISFAIL",
   "postcode": "4860"
 },
 {
   "suburb": "FLYING FISH POINT",
   "postcode": "4860"
 },
 {
   "suburb": "GOONDI BEND",
   "postcode": "4860"
 },
 {
   "suburb": "GOONDI HILL",
   "postcode": "4860"
 },
 {
   "suburb": "HUDSON",
   "postcode": "4860"
 },
 {
   "suburb": "INNISFAIL",
   "postcode": "4860"
 },
 {
   "suburb": "INNISFAIL ESTATE",
   "postcode": "4860"
 },
 {
   "suburb": "JUBILEE HEIGHTS",
   "postcode": "4860"
 },
 {
   "suburb": "MIGHELL",
   "postcode": "4860"
 },
 {
   "suburb": "MUNDOO",
   "postcode": "4860"
 },
 {
   "suburb": "O'BRIENS HILL",
   "postcode": "4860"
 },
 {
   "suburb": "PIN GIN HILL",
   "postcode": "4860"
 },
 {
   "suburb": "SOUTH INNISFAIL",
   "postcode": "4860"
 },
 {
   "suburb": "WEBB",
   "postcode": "4860"
 },
 {
   "suburb": "BABINDA",
   "postcode": "4861"
 },
 {
   "suburb": "GOLDSBOROUGH",
   "postcode": "4865"
 },
 {
   "suburb": "GORDONVALE",
   "postcode": "4865"
 },
 {
   "suburb": "LITTLE MULGRAVE",
   "postcode": "4865"
 },
 {
   "suburb": "BAYVIEW HEIGHTS",
   "postcode": "4868"
 },
 {
   "suburb": "MOUNT SHERIDAN",
   "postcode": "4868"
 },
 {
   "suburb": "WHITE ROCK",
   "postcode": "4868"
 },
 {
   "suburb": "WOREE",
   "postcode": "4868"
 },
 {
   "suburb": "BENTLEY PARK",
   "postcode": "4869"
 },
 {
   "suburb": "EDMONTON",
   "postcode": "4869"
 },
 {
   "suburb": "MOUNT PETER",
   "postcode": "4869"
 },
 {
   "suburb": "WRIGHTS CREEK",
   "postcode": "4869"
 },
 {
   "suburb": "AEROGLEN",
   "postcode": "4870"
 },
 {
   "suburb": "BARRON GORGE",
   "postcode": "4870"
 },
 {
   "suburb": "BRINSMEAD",
   "postcode": "4870"
 },
 {
   "suburb": "BUNGALOW",
   "postcode": "4870"
 },
 {
   "suburb": "CAIRNS",
   "postcode": "4870"
 },
 {
   "suburb": "CAIRNS CENTRAL",
   "postcode": "4870"
 },
 {
   "suburb": "CAIRNS CITY",
   "postcode": "4870"
 },
 {
   "suburb": "CAIRNS NORTH",
   "postcode": "4870"
 },
 {
   "suburb": "EARLVILLE",
   "postcode": "4870"
 },
 {
   "suburb": "EDGE HILL",
   "postcode": "4870"
 },
 {
   "suburb": "FRESHWATER",
   "postcode": "4870"
 },
 {
   "suburb": "KAMERUNGA",
   "postcode": "4870"
 },
 {
   "suburb": "KANIMBLA",
   "postcode": "4870"
 },
 {
   "suburb": "LAMB RANGE",
   "postcode": "4870"
 },
 {
   "suburb": "MANOORA",
   "postcode": "4870"
 },
 {
   "suburb": "MANUNDA",
   "postcode": "4870"
 },
 {
   "suburb": "MARTYNVALE",
   "postcode": "4870"
 },
 {
   "suburb": "MOOROOBOOL",
   "postcode": "4870"
 },
 {
   "suburb": "NORTH CAIRNS",
   "postcode": "4870"
 },
 {
   "suburb": "PARRAMATTA PARK",
   "postcode": "4870"
 },
 {
   "suburb": "PORTSMITH",
   "postcode": "4870"
 },
 {
   "suburb": "REDLYNCH",
   "postcode": "4870"
 },
 {
   "suburb": "STRATFORD",
   "postcode": "4870"
 },
 {
   "suburb": "WESTCOURT",
   "postcode": "4870"
 },
 {
   "suburb": "WHITFIELD",
   "postcode": "4870"
 },
 {
   "suburb": "ALOOMBA",
   "postcode": "4871"
 },
 {
   "suburb": "BELLENDEN KER",
   "postcode": "4871"
 },
 {
   "suburb": "BOOGAN",
   "postcode": "4871"
 },
 {
   "suburb": "STOCKTON",
   "postcode": "4871"
 },
 {
   "suburb": "WANGAN",
   "postcode": "4871"
 },
 {
   "suburb": "BONNIE DOON",
   "postcode": "4873"
 },
 {
   "suburb": "COOYA BEACH",
   "postcode": "4873"
 },
 {
   "suburb": "MOSSMAN",
   "postcode": "4873"
 },
 {
   "suburb": "NEWELL",
   "postcode": "4873"
 },
 {
   "suburb": "CRAIGLIE",
   "postcode": "4877"
 },
 {
   "suburb": "KILLALOE",
   "postcode": "4877"
 },
 {
   "suburb": "MOWBRAY",
   "postcode": "4877"
 },
 {
   "suburb": "OAK BEACH",
   "postcode": "4877"
 },
 {
   "suburb": "PORT DOUGLAS",
   "postcode": "4877"
 },
 {
   "suburb": "WANGETTI",
   "postcode": "4877"
 },
 {
   "suburb": "BARRON",
   "postcode": "4878"
 },
 {
   "suburb": "CARAVONICA",
   "postcode": "4878"
 },
 {
   "suburb": "HOLLOWAYS BEACH",
   "postcode": "4878"
 },
 {
   "suburb": "MACHANS BEACH",
   "postcode": "4878"
 },
 {
   "suburb": "SMITHFIELD",
   "postcode": "4878"
 },
 {
   "suburb": "YORKEYS KNOB",
   "postcode": "4878"
 },
 {
   "suburb": "CLIFTON BEACH",
   "postcode": "4879"
 },
 {
   "suburb": "ELLIS BEACH",
   "postcode": "4879"
 },
 {
   "suburb": "KEWARRA BEACH",
   "postcode": "4879"
 },
 {
   "suburb": "PALM COVE",
   "postcode": "4879"
 },
 {
   "suburb": "TRINITY BEACH",
   "postcode": "4879"
 },
 {
   "suburb": "TRINITY PARK",
   "postcode": "4879"
 },
 {
   "suburb": "BIBOOHRA",
   "postcode": "4880"
 },
 {
   "suburb": "GLEN RUSSELL",
   "postcode": "4880"
 },
 {
   "suburb": "MAREEBA",
   "postcode": "4880"
 },
 {
   "suburb": "PADDYS GREEN",
   "postcode": "4880"
 },
 {
   "suburb": "TOLGA",
   "postcode": "4882"
 },
 {
   "suburb": "ATHERTON",
   "postcode": "4883"
 },
 {
   "suburb": "EAST BARRON",
   "postcode": "4883"
 },
 {
   "suburb": "YUNGABURRA",
   "postcode": "4884"
 },
 {
   "suburb": "MALANDA",
   "postcode": "4885"
 },
 {
   "suburb": "PEERAMON",
   "postcode": "4885"
 },
 {
   "suburb": "ADELAIDE",
   "postcode": "5000"
 },
 {
   "suburb": "CITY WEST CAMPUS",
   "postcode": "5000"
 },
 {
   "suburb": "HALIFAX STREET",
   "postcode": "5000"
 },
 {
   "suburb": "HUTT STREET",
   "postcode": "5000"
 },
 {
   "suburb": "PARLIAMENT HOUSE",
   "postcode": "5000"
 },
 {
   "suburb": "RUNDLE MALL",
   "postcode": "5000"
 },
 {
   "suburb": "STATION ARCADE",
   "postcode": "5000"
 },
 {
   "suburb": "STURT STREET",
   "postcode": "5000"
 },
 {
   "suburb": "NORTH ADELAIDE",
   "postcode": "5006"
 },
 {
   "suburb": "NORTH ADELAIDE MELBOURNE ST",
   "postcode": "5006"
 },
 {
   "suburb": "BOWDEN",
   "postcode": "5007"
 },
 {
   "suburb": "BROMPTON",
   "postcode": "5007"
 },
 {
   "suburb": "HINDMARSH",
   "postcode": "5007"
 },
 {
   "suburb": "WELLAND",
   "postcode": "5007"
 },
 {
   "suburb": "WEST HINDMARSH",
   "postcode": "5007"
 },
 {
   "suburb": "CROYDON",
   "postcode": "5008"
 },
 {
   "suburb": "CROYDON PARK",
   "postcode": "5008"
 },
 {
   "suburb": "CROYDON PARK SOUTH",
   "postcode": "5008"
 },
 {
   "suburb": "DEVON PARK",
   "postcode": "5008"
 },
 {
   "suburb": "DUDLEY PARK",
   "postcode": "5008"
 },
 {
   "suburb": "RENOWN PARK",
   "postcode": "5008"
 },
 {
   "suburb": "RIDLEYTON",
   "postcode": "5008"
 },
 {
   "suburb": "WEST CROYDON",
   "postcode": "5008"
 },
 {
   "suburb": "ALLENBY GARDENS",
   "postcode": "5009"
 },
 {
   "suburb": "BEVERLEY",
   "postcode": "5009"
 },
 {
   "suburb": "KILKENNY",
   "postcode": "5009"
 },
 {
   "suburb": "ANGLE PARK",
   "postcode": "5010"
 },
 {
   "suburb": "FERRYDEN PARK",
   "postcode": "5010"
 },
 {
   "suburb": "REGENCY PARK",
   "postcode": "5010"
 },
 {
   "suburb": "SAINT CLAIR",
   "postcode": "5011"
 },
 {
   "suburb": "ST CLAIR",
   "postcode": "5011"
 },
 {
   "suburb": "WOODVILLE",
   "postcode": "5011"
 },
 {
   "suburb": "WOODVILLE PARK",
   "postcode": "5011"
 },
 {
   "suburb": "WOODVILLE SOUTH",
   "postcode": "5011"
 },
 {
   "suburb": "WOODVILLE WEST",
   "postcode": "5011"
 },
 {
   "suburb": "ATHOL PARK",
   "postcode": "5012"
 },
 {
   "suburb": "MANSFIELD PARK",
   "postcode": "5012"
 },
 {
   "suburb": "WOODVILLE GARDENS",
   "postcode": "5012"
 },
 {
   "suburb": "WOODVILLE NORTH",
   "postcode": "5012"
 },
 {
   "suburb": "GILLMAN",
   "postcode": "5013"
 },
 {
   "suburb": "OTTOWAY",
   "postcode": "5013"
 },
 {
   "suburb": "PENNINGTON",
   "postcode": "5013"
 },
 {
   "suburb": "ROSEWATER",
   "postcode": "5013"
 },
 {
   "suburb": "ROSEWATER EAST",
   "postcode": "5013"
 },
 {
   "suburb": "WINGFIELD",
   "postcode": "5013"
 },
 {
   "suburb": "ALBERT PARK",
   "postcode": "5014"
 },
 {
   "suburb": "ALBERTON",
   "postcode": "5014"
 },
 {
   "suburb": "CHELTENHAM",
   "postcode": "5014"
 },
 {
   "suburb": "HENDON",
   "postcode": "5014"
 },
 {
   "suburb": "QUEENSTOWN",
   "postcode": "5014"
 },
 {
   "suburb": "ROYAL PARK",
   "postcode": "5014"
 },
 {
   "suburb": "WAINUIOMATA",
   "postcode": "5014"
 },
 {
   "suburb": "BIRKENHEAD",
   "postcode": "5015"
 },
 {
   "suburb": "ETHELTON",
   "postcode": "5015"
 },
 {
   "suburb": "GLANVILLE",
   "postcode": "5015"
 },
 {
   "suburb": "NEW PORT",
   "postcode": "5015"
 },
 {
   "suburb": "PORT ADELAIDE",
   "postcode": "5015"
 },
 {
   "suburb": "LARGS BAY",
   "postcode": "5016"
 },
 {
   "suburb": "LARGS NORTH",
   "postcode": "5016"
 },
 {
   "suburb": "PETERHEAD",
   "postcode": "5016"
 },
 {
   "suburb": "OSBORNE",
   "postcode": "5017"
 },
 {
   "suburb": "TAPEROO",
   "postcode": "5017"
 },
 {
   "suburb": "NORTH HAVEN",
   "postcode": "5018"
 },
 {
   "suburb": "OUTER HARBOR",
   "postcode": "5018"
 },
 {
   "suburb": "EXETER",
   "postcode": "5019"
 },
 {
   "suburb": "SEMAPHORE",
   "postcode": "5019"
 },
 {
   "suburb": "SEMAPHORE PARK",
   "postcode": "5019"
 },
 {
   "suburb": "SEMAPHORE SOUTH",
   "postcode": "5019"
 },
 {
   "suburb": "WEST LAKES SHORE",
   "postcode": "5020"
 },
 {
   "suburb": "WEST LAKES",
   "postcode": "5021"
 },
 {
   "suburb": "GRANGE",
   "postcode": "5022"
 },
 {
   "suburb": "HENLEY BEACH",
   "postcode": "5022"
 },
 {
   "suburb": "HENLEY BEACH SOUTH",
   "postcode": "5022"
 },
 {
   "suburb": "KIRKCALDY",
   "postcode": "5022"
 },
 {
   "suburb": "TENNYSON",
   "postcode": "5022"
 },
 {
   "suburb": "FINDON",
   "postcode": "5023"
 },
 {
   "suburb": "SEATON",
   "postcode": "5023"
 },
 {
   "suburb": "SEATON NORTH",
   "postcode": "5023"
 },
 {
   "suburb": "FULHAM",
   "postcode": "5024"
 },
 {
   "suburb": "FULHAM GARDENS",
   "postcode": "5024"
 },
 {
   "suburb": "WEST BEACH",
   "postcode": "5024"
 },
 {
   "suburb": "FLINDERS PARK",
   "postcode": "5025"
 },
 {
   "suburb": "KIDMAN PARK",
   "postcode": "5025"
 },
 {
   "suburb": "MILE END",
   "postcode": "5031"
 },
 {
   "suburb": "MILE END SOUTH",
   "postcode": "5031"
 },
 {
   "suburb": "THEBARTON",
   "postcode": "5031"
 },
 {
   "suburb": "TORRENSVILLE",
   "postcode": "5031"
 },
 {
   "suburb": "TORRENSVILLE PLAZA",
   "postcode": "5031"
 },
 {
   "suburb": "BROOKLYN PARK",
   "postcode": "5032"
 },
 {
   "suburb": "LOCKLEYS",
   "postcode": "5032"
 },
 {
   "suburb": "UNDERDALE",
   "postcode": "5032"
 },
 {
   "suburb": "COWANDILLA",
   "postcode": "5033"
 },
 {
   "suburb": "HILTON",
   "postcode": "5033"
 },
 {
   "suburb": "HILTON PLAZA",
   "postcode": "5033"
 },
 {
   "suburb": "MARLESTON",
   "postcode": "5033"
 },
 {
   "suburb": "RICHMOND",
   "postcode": "5033"
 },
 {
   "suburb": "WEST RICHMOND",
   "postcode": "5033"
 },
 {
   "suburb": "CLARENCE PARK",
   "postcode": "5034"
 },
 {
   "suburb": "GOODWOOD",
   "postcode": "5034"
 },
 {
   "suburb": "KINGS PARK",
   "postcode": "5034"
 },
 {
   "suburb": "MILLSWOOD",
   "postcode": "5034"
 },
 {
   "suburb": "WAYVILLE",
   "postcode": "5034"
 },
 {
   "suburb": "ASHFORD",
   "postcode": "5035"
 },
 {
   "suburb": "BLACK FOREST",
   "postcode": "5035"
 },
 {
   "suburb": "EVERARD PARK",
   "postcode": "5035"
 },
 {
   "suburb": "FORESTVILLE",
   "postcode": "5035"
 },
 {
   "suburb": "KESWICK",
   "postcode": "5035"
 },
 {
   "suburb": "KESWICK TERMINAL",
   "postcode": "5035"
 },
 {
   "suburb": "GLANDORE",
   "postcode": "5037"
 },
 {
   "suburb": "KURRALTA PARK",
   "postcode": "5037"
 },
 {
   "suburb": "NETLEY",
   "postcode": "5037"
 },
 {
   "suburb": "NORTH PLYMPTON",
   "postcode": "5037"
 },
 {
   "suburb": "CAMDEN PARK",
   "postcode": "5038"
 },
 {
   "suburb": "PLYMPTON",
   "postcode": "5038"
 },
 {
   "suburb": "PLYMPTON PARK",
   "postcode": "5038"
 },
 {
   "suburb": "SOUTH PLYMPTON",
   "postcode": "5038"
 },
 {
   "suburb": "CLARENCE GARDENS",
   "postcode": "5039"
 },
 {
   "suburb": "EDWARDSTOWN",
   "postcode": "5039"
 },
 {
   "suburb": "MELROSE PARK",
   "postcode": "5039"
 },
 {
   "suburb": "NOVAR GARDENS",
   "postcode": "5040"
 },
 {
   "suburb": "COLONEL LIGHT GARDENS",
   "postcode": "5041"
 },
 {
   "suburb": "CUMBERLAND PARK",
   "postcode": "5041"
 },
 {
   "suburb": "DAW PARK",
   "postcode": "5041"
 },
 {
   "suburb": "PANORAMA",
   "postcode": "5041"
 },
 {
   "suburb": "WESTBOURNE PARK",
   "postcode": "5041"
 },
 {
   "suburb": "BEDFORD PARK",
   "postcode": "5042"
 },
 {
   "suburb": "CLOVELLY PARK",
   "postcode": "5042"
 },
 {
   "suburb": "FLINDERS UNIVERSITY",
   "postcode": "5042"
 },
 {
   "suburb": "PASADENA",
   "postcode": "5042"
 },
 {
   "suburb": "SAINT MARYS",
   "postcode": "5042"
 },
 {
   "suburb": "ST MARYS",
   "postcode": "5042"
 },
 {
   "suburb": "TONSLEY",
   "postcode": "5042"
 },
 {
   "suburb": "ASCOT PARK",
   "postcode": "5043"
 },
 {
   "suburb": "MARION",
   "postcode": "5043"
 },
 {
   "suburb": "MITCHELL PARK",
   "postcode": "5043"
 },
 {
   "suburb": "MORPHETTVILLE",
   "postcode": "5043"
 },
 {
   "suburb": "PARK HOLME",
   "postcode": "5043"
 },
 {
   "suburb": "GLENGOWRIE",
   "postcode": "5044"
 },
 {
   "suburb": "SOMERTON PARK",
   "postcode": "5044"
 },
 {
   "suburb": "GLENELG",
   "postcode": "5045"
 },
 {
   "suburb": "GLENELG EAST",
   "postcode": "5045"
 },
 {
   "suburb": "GLENELG JETTY ROAD",
   "postcode": "5045"
 },
 {
   "suburb": "GLENELG NORTH",
   "postcode": "5045"
 },
 {
   "suburb": "GLENELG SOUTH",
   "postcode": "5045"
 },
 {
   "suburb": "OAKLANDS PARK",
   "postcode": "5046"
 },
 {
   "suburb": "WARRADALE",
   "postcode": "5046"
 },
 {
   "suburb": "WARRADALE NORTH",
   "postcode": "5046"
 },
 {
   "suburb": "DARLINGTON",
   "postcode": "5047"
 },
 {
   "suburb": "SEACOMBE GARDENS",
   "postcode": "5047"
 },
 {
   "suburb": "SEACOMBE HEIGHTS",
   "postcode": "5047"
 },
 {
   "suburb": "STURT",
   "postcode": "5047"
 },
 {
   "suburb": "BRIGHTON",
   "postcode": "5048"
 },
 {
   "suburb": "DOVER GARDENS",
   "postcode": "5048"
 },
 {
   "suburb": "HOVE",
   "postcode": "5048"
 },
 {
   "suburb": "NORTH BRIGHTON",
   "postcode": "5048"
 },
 {
   "suburb": "SOUTH BRIGHTON",
   "postcode": "5048"
 },
 {
   "suburb": "KINGSTON PARK",
   "postcode": "5049"
 },
 {
   "suburb": "MARINO",
   "postcode": "5049"
 },
 {
   "suburb": "SEACLIFF",
   "postcode": "5049"
 },
 {
   "suburb": "SEACLIFF PARK",
   "postcode": "5049"
 },
 {
   "suburb": "SEAVIEW DOWNS",
   "postcode": "5049"
 },
 {
   "suburb": "BELLEVUE HEIGHTS",
   "postcode": "5050"
 },
 {
   "suburb": "EDEN HILLS",
   "postcode": "5050"
 },
 {
   "suburb": "BLACKWOOD",
   "postcode": "5051"
 },
 {
   "suburb": "COROMANDEL VALLEY",
   "postcode": "5051"
 },
 {
   "suburb": "CRAIGBURN FARM",
   "postcode": "5051"
 },
 {
   "suburb": "HAWTHORNDENE",
   "postcode": "5051"
 },
 {
   "suburb": "BELAIR",
   "postcode": "5052"
 },
 {
   "suburb": "GLENALTA",
   "postcode": "5052"
 },
 {
   "suburb": "HYDE PARK",
   "postcode": "5061"
 },
 {
   "suburb": "MALVERN",
   "postcode": "5061"
 },
 {
   "suburb": "UNLEY",
   "postcode": "5061"
 },
 {
   "suburb": "UNLEY PARK",
   "postcode": "5061"
 },
 {
   "suburb": "BROWN HILL CREEK",
   "postcode": "5062"
 },
 {
   "suburb": "CLAPHAM",
   "postcode": "5062"
 },
 {
   "suburb": "HAWTHORN",
   "postcode": "5062"
 },
 {
   "suburb": "KINGSWOOD",
   "postcode": "5062"
 },
 {
   "suburb": "LOWER MITCHAM",
   "postcode": "5062"
 },
 {
   "suburb": "LYNTON",
   "postcode": "5062"
 },
 {
   "suburb": "MITCHAM",
   "postcode": "5062"
 },
 {
   "suburb": "MITCHAM SHOPPING CENTRE",
   "postcode": "5062"
 },
 {
   "suburb": "NETHERBY",
   "postcode": "5062"
 },
 {
   "suburb": "SPRINGFIELD",
   "postcode": "5062"
 },
 {
   "suburb": "TORRENS PARK",
   "postcode": "5062"
 },
 {
   "suburb": "EASTWOOD",
   "postcode": "5063"
 },
 {
   "suburb": "FREWVILLE",
   "postcode": "5063"
 },
 {
   "suburb": "FULLARTON",
   "postcode": "5063"
 },
 {
   "suburb": "HIGHGATE",
   "postcode": "5063"
 },
 {
   "suburb": "PARKSIDE",
   "postcode": "5063"
 },
 {
   "suburb": "GLEN OSMOND",
   "postcode": "5064"
 },
 {
   "suburb": "GLENUNGA",
   "postcode": "5064"
 },
 {
   "suburb": "MOUNT OSMOND",
   "postcode": "5064"
 },
 {
   "suburb": "MYRTLE BANK",
   "postcode": "5064"
 },
 {
   "suburb": "ST GEORGES",
   "postcode": "5064"
 },
 {
   "suburb": "URRBRAE",
   "postcode": "5064"
 },
 {
   "suburb": "DULWICH",
   "postcode": "5065"
 },
 {
   "suburb": "GLENSIDE",
   "postcode": "5065"
 },
 {
   "suburb": "LINDEN PARK",
   "postcode": "5065"
 },
 {
   "suburb": "TOORAK GARDENS",
   "postcode": "5065"
 },
 {
   "suburb": "TUSMORE",
   "postcode": "5065"
 },
 {
   "suburb": "BEAUMONT",
   "postcode": "5066"
 },
 {
   "suburb": "BURNSIDE",
   "postcode": "5066"
 },
 {
   "suburb": "ERINDALE",
   "postcode": "5066"
 },
 {
   "suburb": "HAZELWOOD PARK",
   "postcode": "5066"
 },
 {
   "suburb": "STONYFELL",
   "postcode": "5066"
 },
 {
   "suburb": "WATERFALL GULLY",
   "postcode": "5066"
 },
 {
   "suburb": "WATTLE PARK",
   "postcode": "5066"
 },
 {
   "suburb": "BEULAH PARK",
   "postcode": "5067"
 },
 {
   "suburb": "KENT TOWN",
   "postcode": "5067"
 },
 {
   "suburb": "NORWOOD",
   "postcode": "5067"
 },
 {
   "suburb": "NORWOOD SOUTH",
   "postcode": "5067"
 },
 {
   "suburb": "ROSE PARK",
   "postcode": "5067"
 },
 {
   "suburb": "HEATHPOOL",
   "postcode": "5068"
 },
 {
   "suburb": "KENSINGTON",
   "postcode": "5068"
 },
 {
   "suburb": "KENSINGTON GARDENS",
   "postcode": "5068"
 },
 {
   "suburb": "KENSINGTON PARK",
   "postcode": "5068"
 },
 {
   "suburb": "LEABROOK",
   "postcode": "5068"
 },
 {
   "suburb": "MARRYATVILLE",
   "postcode": "5068"
 },
 {
   "suburb": "SAINT MORRIS",
   "postcode": "5068"
 },
 {
   "suburb": "ST MORRIS",
   "postcode": "5068"
 },
 {
   "suburb": "TRINITY GARDENS",
   "postcode": "5068"
 },
 {
   "suburb": "COLLEGE PARK",
   "postcode": "5069"
 },
 {
   "suburb": "EVANDALE",
   "postcode": "5069"
 },
 {
   "suburb": "HACKNEY",
   "postcode": "5069"
 },
 {
   "suburb": "MAYLANDS",
   "postcode": "5069"
 },
 {
   "suburb": "SAINT PETERS",
   "postcode": "5069"
 },
 {
   "suburb": "ST PETERS",
   "postcode": "5069"
 },
 {
   "suburb": "STEPNEY",
   "postcode": "5069"
 },
 {
   "suburb": "FELIXSTOW",
   "postcode": "5070"
 },
 {
   "suburb": "FIRLE",
   "postcode": "5070"
 },
 {
   "suburb": "GLYNDE",
   "postcode": "5070"
 },
 {
   "suburb": "GLYNDE PLAZA",
   "postcode": "5070"
 },
 {
   "suburb": "JOSLIN",
   "postcode": "5070"
 },
 {
   "suburb": "MARDEN",
   "postcode": "5070"
 },
 {
   "suburb": "PAYNEHAM",
   "postcode": "5070"
 },
 {
   "suburb": "PAYNEHAM SOUTH",
   "postcode": "5070"
 },
 {
   "suburb": "ROYSTON",
   "postcode": "5070"
 },
 {
   "suburb": "ROYSTON PARK",
   "postcode": "5070"
 },
 {
   "suburb": "AULDANA",
   "postcode": "5072"
 },
 {
   "suburb": "MAGILL",
   "postcode": "5072"
 },
 {
   "suburb": "MAGILL NORTH",
   "postcode": "5072"
 },
 {
   "suburb": "MAGILL SOUTH",
   "postcode": "5072"
 },
 {
   "suburb": "ROSSLYN PARK",
   "postcode": "5072"
 },
 {
   "suburb": "SKYE",
   "postcode": "5072"
 },
 {
   "suburb": "TERINGIE",
   "postcode": "5072"
 },
 {
   "suburb": "WOODFORDE",
   "postcode": "5072"
 },
 {
   "suburb": "HECTORVILLE",
   "postcode": "5073"
 },
 {
   "suburb": "ROSTREVOR",
   "postcode": "5073"
 },
 {
   "suburb": "TRANMERE",
   "postcode": "5073"
 },
 {
   "suburb": "TRANMERE NORTH",
   "postcode": "5073"
 },
 {
   "suburb": "CAMPBELLTOWN",
   "postcode": "5074"
 },
 {
   "suburb": "NEWTON",
   "postcode": "5074"
 },
 {
   "suburb": "DERNANCOURT",
   "postcode": "5075"
 },
 {
   "suburb": "PARADISE",
   "postcode": "5075"
 },
 {
   "suburb": "ATHELSTONE",
   "postcode": "5076"
 },
 {
   "suburb": "CASTAMBUL",
   "postcode": "5076"
 },
 {
   "suburb": "COLLINSWOOD",
   "postcode": "5081"
 },
 {
   "suburb": "GILBERTON",
   "postcode": "5081"
 },
 {
   "suburb": "MEDINDIE",
   "postcode": "5081"
 },
 {
   "suburb": "MEDINDIE GARDENS",
   "postcode": "5081"
 },
 {
   "suburb": "VALE PARK",
   "postcode": "5081"
 },
 {
   "suburb": "WALKERVILLE",
   "postcode": "5081"
 },
 {
   "suburb": "FITZROY",
   "postcode": "5082"
 },
 {
   "suburb": "OVINGHAM",
   "postcode": "5082"
 },
 {
   "suburb": "PROSPECT",
   "postcode": "5082"
 },
 {
   "suburb": "PROSPECT EAST",
   "postcode": "5082"
 },
 {
   "suburb": "PROSPECT WEST",
   "postcode": "5082"
 },
 {
   "suburb": "THORNGATE",
   "postcode": "5082"
 },
 {
   "suburb": "BROADVIEW",
   "postcode": "5083"
 },
 {
   "suburb": "NAILSWORTH",
   "postcode": "5083"
 },
 {
   "suburb": "SEFTON PARK",
   "postcode": "5083"
 },
 {
   "suburb": "BLAIR ATHOL",
   "postcode": "5084"
 },
 {
   "suburb": "BLAIR ATHOL WEST",
   "postcode": "5084"
 },
 {
   "suburb": "KILBURN",
   "postcode": "5084"
 },
 {
   "suburb": "KILBURN NORTH",
   "postcode": "5084"
 },
 {
   "suburb": "CLEARVIEW",
   "postcode": "5085"
 },
 {
   "suburb": "ENFIELD",
   "postcode": "5085"
 },
 {
   "suburb": "ENFIELD PLAZA",
   "postcode": "5085"
 },
 {
   "suburb": "LIGHTSVIEW",
   "postcode": "5085"
 },
 {
   "suburb": "NORTHFIELD",
   "postcode": "5085"
 },
 {
   "suburb": "NORTHGATE",
   "postcode": "5085"
 },
 {
   "suburb": "GILLES PLAINS",
   "postcode": "5086"
 },
 {
   "suburb": "GREENACRES",
   "postcode": "5086"
 },
 {
   "suburb": "HAMPSTEAD GARDENS",
   "postcode": "5086"
 },
 {
   "suburb": "HILLCREST",
   "postcode": "5086"
 },
 {
   "suburb": "MANNINGHAM",
   "postcode": "5086"
 },
 {
   "suburb": "OAKDEN",
   "postcode": "5086"
 },
 {
   "suburb": "KLEMZIG",
   "postcode": "5087"
 },
 {
   "suburb": "WINDSOR GARDENS",
   "postcode": "5087"
 },
 {
   "suburb": "HOLDEN HILL",
   "postcode": "5088"
 },
 {
   "suburb": "HIGHBURY",
   "postcode": "5089"
 },
 {
   "suburb": "HOPE VALLEY",
   "postcode": "5090"
 },
 {
   "suburb": "BANKSIA PARK",
   "postcode": "5091"
 },
 {
   "suburb": "TEA TREE GULLY",
   "postcode": "5091"
 },
 {
   "suburb": "VISTA",
   "postcode": "5091"
 },
 {
   "suburb": "MODBURY",
   "postcode": "5092"
 },
 {
   "suburb": "MODBURY HEIGHTS",
   "postcode": "5092"
 },
 {
   "suburb": "MODBURY NORTH",
   "postcode": "5092"
 },
 {
   "suburb": "PARA VISTA",
   "postcode": "5093"
 },
 {
   "suburb": "VALLEY VIEW",
   "postcode": "5093"
 },
 {
   "suburb": "CAVAN",
   "postcode": "5094"
 },
 {
   "suburb": "DRY CREEK",
   "postcode": "5094"
 },
 {
   "suburb": "GEPPS CROSS",
   "postcode": "5094"
 },
 {
   "suburb": "MAWSON LAKES",
   "postcode": "5095"
 },
 {
   "suburb": "POORAKA",
   "postcode": "5095"
 },
 {
   "suburb": "THE LEVELS",
   "postcode": "5095"
 },
 {
   "suburb": "GULFVIEW HEIGHTS",
   "postcode": "5096"
 },
 {
   "suburb": "MODBURY HEIGHTS",
   "postcode": "5096"
 },
 {
   "suburb": "PARA HILLS",
   "postcode": "5096"
 },
 {
   "suburb": "PARA HILLS WEST",
   "postcode": "5096"
 },
 {
   "suburb": "REDWOOD PARK",
   "postcode": "5097"
 },
 {
   "suburb": "RIDGEHAVEN",
   "postcode": "5097"
 },
 {
   "suburb": "SAINT AGNES",
   "postcode": "5097"
 },
 {
   "suburb": "ST AGNES",
   "postcode": "5097"
 },
 {
   "suburb": "INGLE FARM",
   "postcode": "5098"
 },
 {
   "suburb": "WALKLEY HEIGHTS",
   "postcode": "5098"
 },
 {
   "suburb": "PARAFIELD",
   "postcode": "5106"
 },
 {
   "suburb": "PARAFIELD AIRPORT",
   "postcode": "5106"
 },
 {
   "suburb": "SALISBURY SOUTH",
   "postcode": "5106"
 },
 {
   "suburb": "GREEN FIELDS",
   "postcode": "5107"
 },
 {
   "suburb": "PARAFIELD GARDENS",
   "postcode": "5107"
 },
 {
   "suburb": "PARALOWIE",
   "postcode": "5108"
 },
 {
   "suburb": "SALISBURY",
   "postcode": "5108"
 },
 {
   "suburb": "SALISBURY DOWNS",
   "postcode": "5108"
 },
 {
   "suburb": "SALISBURY NORTH",
   "postcode": "5108"
 },
 {
   "suburb": "SALISBURY NORTH WHITES ROAD",
   "postcode": "5108"
 },
 {
   "suburb": "BRAHMA LODGE",
   "postcode": "5109"
 },
 {
   "suburb": "SALISBURY EAST",
   "postcode": "5109"
 },
 {
   "suburb": "SALISBURY EAST NORTHBRI AVE",
   "postcode": "5109"
 },
 {
   "suburb": "SALISBURY HEIGHTS",
   "postcode": "5109"
 },
 {
   "suburb": "SALISBURY PARK",
   "postcode": "5109"
 },
 {
   "suburb": "SALISBURY PLAIN",
   "postcode": "5109"
 },
 {
   "suburb": "BOLIVAR",
   "postcode": "5110"
 },
 {
   "suburb": "BURTON",
   "postcode": "5110"
 },
 {
   "suburb": "DIREK",
   "postcode": "5110"
 },
 {
   "suburb": "GLOBE DERBY PARK",
   "postcode": "5110"
 },
 {
   "suburb": "ST KILDA",
   "postcode": "5110"
 },
 {
   "suburb": "WATERLOO CORNER",
   "postcode": "5110"
 },
 {
   "suburb": "EDINBURGH",
   "postcode": "5111"
 },
 {
   "suburb": "ELIZABETH",
   "postcode": "5112"
 },
 {
   "suburb": "ELIZABETH EAST",
   "postcode": "5112"
 },
 {
   "suburb": "ELIZABETH GROVE",
   "postcode": "5112"
 },
 {
   "suburb": "ELIZABETH SOUTH",
   "postcode": "5112"
 },
 {
   "suburb": "ELIZABETH VALE",
   "postcode": "5112"
 },
 {
   "suburb": "HILLBANK",
   "postcode": "5112"
 },
 {
   "suburb": "DAVOREN PARK",
   "postcode": "5113"
 },
 {
   "suburb": "DAVOREN PARK NORTH",
   "postcode": "5113"
 },
 {
   "suburb": "DAVOREN PARK SOUTH",
   "postcode": "5113"
 },
 {
   "suburb": "EDINBURGH NORTH",
   "postcode": "5113"
 },
 {
   "suburb": "ELIZABETH DOWNS",
   "postcode": "5113"
 },
 {
   "suburb": "ELIZABETH NORTH",
   "postcode": "5113"
 },
 {
   "suburb": "ELIZABETH PARK",
   "postcode": "5113"
 },
 {
   "suburb": "ELIZABETH WEST",
   "postcode": "5113"
 },
 {
   "suburb": "ANDREWS FARM",
   "postcode": "5114"
 },
 {
   "suburb": "BLAKEVIEW",
   "postcode": "5114"
 },
 {
   "suburb": "CRAIGMORE",
   "postcode": "5114"
 },
 {
   "suburb": "GOULD CREEK",
   "postcode": "5114"
 },
 {
   "suburb": "HUMBUG SCRUB",
   "postcode": "5114"
 },
 {
   "suburb": "ONE TREE HILL",
   "postcode": "5114"
 },
 {
   "suburb": "SAMPSON FLAT",
   "postcode": "5114"
 },
 {
   "suburb": "SMITHFIELD",
   "postcode": "5114"
 },
 {
   "suburb": "SMITHFIELD PLAINS",
   "postcode": "5114"
 },
 {
   "suburb": "SMITHFIELD WEST",
   "postcode": "5114"
 },
 {
   "suburb": "ULEYBURY",
   "postcode": "5114"
 },
 {
   "suburb": "YATTALUNGA",
   "postcode": "5114"
 },
 {
   "suburb": "KUDLA",
   "postcode": "5115"
 },
 {
   "suburb": "MUNNO PARA",
   "postcode": "5115"
 },
 {
   "suburb": "MUNNO PARA DOWNS",
   "postcode": "5115"
 },
 {
   "suburb": "MUNNO PARA WEST",
   "postcode": "5115"
 },
 {
   "suburb": "EVANSTON",
   "postcode": "5116"
 },
 {
   "suburb": "EVANSTON GARDENS",
   "postcode": "5116"
 },
 {
   "suburb": "EVANSTON PARK",
   "postcode": "5116"
 },
 {
   "suburb": "EVANSTON SOUTH",
   "postcode": "5116"
 },
 {
   "suburb": "HILLIER",
   "postcode": "5116"
 },
 {
   "suburb": "ANGLE VALE",
   "postcode": "5117"
 },
 {
   "suburb": "BIBARINGA",
   "postcode": "5118"
 },
 {
   "suburb": "BUCHFELDE",
   "postcode": "5118"
 },
 {
   "suburb": "CONCORDIA",
   "postcode": "5118"
 },
 {
   "suburb": "GAWLER",
   "postcode": "5118"
 },
 {
   "suburb": "GAWLER BELT",
   "postcode": "5118"
 },
 {
   "suburb": "GAWLER EAST",
   "postcode": "5118"
 },
 {
   "suburb": "GAWLER RIVER",
   "postcode": "5118"
 },
 {
   "suburb": "GAWLER SOUTH",
   "postcode": "5118"
 },
 {
   "suburb": "GAWLER WEST",
   "postcode": "5118"
 },
 {
   "suburb": "HEWETT",
   "postcode": "5118"
 },
 {
   "suburb": "KALBEEBA",
   "postcode": "5118"
 },
 {
   "suburb": "KANGAROO FLAT",
   "postcode": "5118"
 },
 {
   "suburb": "KINGSFORD",
   "postcode": "5118"
 },
 {
   "suburb": "REID",
   "postcode": "5118"
 },
 {
   "suburb": "WARD BELT",
   "postcode": "5118"
 },
 {
   "suburb": "WILLASTON",
   "postcode": "5118"
 },
 {
   "suburb": "BUCKLAND PARK",
   "postcode": "5120"
 },
 {
   "suburb": "VIRGINIA",
   "postcode": "5120"
 },
 {
   "suburb": "EYRE",
   "postcode": "5121"
 },
 {
   "suburb": "MACDONALD PARK",
   "postcode": "5121"
 },
 {
   "suburb": "PENFIELD",
   "postcode": "5121"
 },
 {
   "suburb": "PENFIELD GARDENS",
   "postcode": "5121"
 },
 {
   "suburb": "GOLDEN GROVE",
   "postcode": "5125"
 },
 {
   "suburb": "GOLDEN GROVE VILLAGE",
   "postcode": "5125"
 },
 {
   "suburb": "GREENWITH",
   "postcode": "5125"
 },
 {
   "suburb": "FAIRVIEW PARK",
   "postcode": "5126"
 },
 {
   "suburb": "SURREY DOWNS",
   "postcode": "5126"
 },
 {
   "suburb": "YATALA VALE",
   "postcode": "5126"
 },
 {
   "suburb": "WYNN VALE",
   "postcode": "5127"
 },
 {
   "suburb": "HOUGHTON",
   "postcode": "5131"
 },
 {
   "suburb": "LOWER HERMITAGE",
   "postcode": "5131"
 },
 {
   "suburb": "SOUTH HOUGHTON",
   "postcode": "5131"
 },
 {
   "suburb": "UPPER HERMITAGE",
   "postcode": "5131"
 },
 {
   "suburb": "PARACOMBE",
   "postcode": "5132"
 },
 {
   "suburb": "INGLEWOOD",
   "postcode": "5133"
 },
 {
   "suburb": "CHERRYVILLE",
   "postcode": "5134"
 },
 {
   "suburb": "MONTACUTE",
   "postcode": "5134"
 },
 {
   "suburb": "NORTON SUMMIT",
   "postcode": "5136"
 },
 {
   "suburb": "ASHTON",
   "postcode": "5137"
 },
 {
   "suburb": "MARBLE HILL",
   "postcode": "5137"
 },
 {
   "suburb": "BASKET RANGE",
   "postcode": "5138"
 },
 {
   "suburb": "FOREST RANGE",
   "postcode": "5139"
 },
 {
   "suburb": "GREENHILL",
   "postcode": "5140"
 },
 {
   "suburb": "HORSNELL GULLY",
   "postcode": "5141"
 },
 {
   "suburb": "SUMMERTOWN",
   "postcode": "5141"
 },
 {
   "suburb": "URAIDLA",
   "postcode": "5142"
 },
 {
   "suburb": "CAREY GULLY",
   "postcode": "5144"
 },
 {
   "suburb": "EAGLE ON THE HILL",
   "postcode": "5150"
 },
 {
   "suburb": "LEAWOOD GARDENS",
   "postcode": "5150"
 },
 {
   "suburb": "PICCADILLY",
   "postcode": "5151"
 },
 {
   "suburb": "CLELAND",
   "postcode": "5152"
 },
 {
   "suburb": "CRAFERS",
   "postcode": "5152"
 },
 {
   "suburb": "CRAFERS WEST",
   "postcode": "5152"
 },
 {
   "suburb": "MOUNT LOFTY",
   "postcode": "5152"
 },
 {
   "suburb": "STIRLING",
   "postcode": "5152"
 },
 {
   "suburb": "BIGGS FLAT",
   "postcode": "5153"
 },
 {
   "suburb": "BRADBURY",
   "postcode": "5153"
 },
 {
   "suburb": "CHAPEL HILL",
   "postcode": "5153"
 },
 {
   "suburb": "ECHUNGA",
   "postcode": "5153"
 },
 {
   "suburb": "FLAXLEY",
   "postcode": "5153"
 },
 {
   "suburb": "GREEN HILLS RANGE",
   "postcode": "5153"
 },
 {
   "suburb": "HEATHFIELD",
   "postcode": "5153"
 },
 {
   "suburb": "IRONBANK",
   "postcode": "5153"
 },
 {
   "suburb": "JUPITER CREEK",
   "postcode": "5153"
 },
 {
   "suburb": "LONGWOOD",
   "postcode": "5153"
 },
 {
   "suburb": "MACCLESFIELD",
   "postcode": "5153"
 },
 {
   "suburb": "MYLOR",
   "postcode": "5153"
 },
 {
   "suburb": "SCOTT CREEK",
   "postcode": "5153"
 },
 {
   "suburb": "ALDGATE",
   "postcode": "5154"
 },
 {
   "suburb": "BRIDGEWATER",
   "postcode": "5155"
 },
 {
   "suburb": "MOUNT GEORGE",
   "postcode": "5155"
 },
 {
   "suburb": "UPPER STURT",
   "postcode": "5156"
 },
 {
   "suburb": "ASHBOURNE",
   "postcode": "5157"
 },
 {
   "suburb": "BULL CREEK",
   "postcode": "5157"
 },
 {
   "suburb": "CHERRY GARDENS",
   "postcode": "5157"
 },
 {
   "suburb": "CLARENDON",
   "postcode": "5157"
 },
 {
   "suburb": "COROMANDEL EAST",
   "postcode": "5157"
 },
 {
   "suburb": "DORSET VALE",
   "postcode": "5157"
 },
 {
   "suburb": "KANGARILLA",
   "postcode": "5157"
 },
 {
   "suburb": "MCHARG CREEK",
   "postcode": "5157"
 },
 {
   "suburb": "HALLETT COVE",
   "postcode": "5158"
 },
 {
   "suburb": "O'HALLORAN HILL",
   "postcode": "5158"
 },
 {
   "suburb": "SHEIDOW PARK",
   "postcode": "5158"
 },
 {
   "suburb": "TROTT PARK",
   "postcode": "5158"
 },
 {
   "suburb": "ABERFOYLE PARK",
   "postcode": "5159"
 },
 {
   "suburb": "CHANDLERS HILL",
   "postcode": "5159"
 },
 {
   "suburb": "FLAGSTAFF HILL",
   "postcode": "5159"
 },
 {
   "suburb": "HAPPY VALLEY",
   "postcode": "5159"
 },
 {
   "suburb": "LONSDALE",
   "postcode": "5160"
 },
 {
   "suburb": "PORT STANVAC",
   "postcode": "5160"
 },
 {
   "suburb": "OLD REYNELLA",
   "postcode": "5161"
 },
 {
   "suburb": "REYNELLA",
   "postcode": "5161"
 },
 {
   "suburb": "REYNELLA EAST",
   "postcode": "5161"
 },
 {
   "suburb": "MORPHETT VALE",
   "postcode": "5162"
 },
 {
   "suburb": "WOODCROFT",
   "postcode": "5162"
 },
 {
   "suburb": "HACKHAM",
   "postcode": "5163"
 },
 {
   "suburb": "HACKHAM WEST",
   "postcode": "5163"
 },
 {
   "suburb": "HUNTFIELD HEIGHTS",
   "postcode": "5163"
 },
 {
   "suburb": "ONKAPARINGA HILLS",
   "postcode": "5163"
 },
 {
   "suburb": "CHRISTIE DOWNS",
   "postcode": "5164"
 },
 {
   "suburb": "CHRISTIES BEACH",
   "postcode": "5165"
 },
 {
   "suburb": "CHRISTIES BEACH NORTH",
   "postcode": "5165"
 },
 {
   "suburb": "O'SULLIVAN BEACH",
   "postcode": "5166"
 },
 {
   "suburb": "PORT NOARLUNGA",
   "postcode": "5167"
 },
 {
   "suburb": "PORT NOARLUNGA SOUTH",
   "postcode": "5167"
 },
 {
   "suburb": "NOARLUNGA",
   "postcode": "5168"
 },
 {
   "suburb": "NOARLUNGA CENTRE",
   "postcode": "5168"
 },
 {
   "suburb": "NOARLUNGA DOWNS",
   "postcode": "5168"
 },
 {
   "suburb": "OLD NOARLUNGA",
   "postcode": "5168"
 },
 {
   "suburb": "MOANA",
   "postcode": "5169"
 },
 {
   "suburb": "SEAFORD",
   "postcode": "5169"
 },
 {
   "suburb": "SEAFORD HEIGHTS",
   "postcode": "5169"
 },
 {
   "suburb": "SEAFORD MEADOWS",
   "postcode": "5169"
 },
 {
   "suburb": "SEAFORD RISE",
   "postcode": "5169"
 },
 {
   "suburb": "MASLIN BEACH",
   "postcode": "5170"
 },
 {
   "suburb": "BLEWITT SPRINGS",
   "postcode": "5171"
 },
 {
   "suburb": "MCLAREN FLAT",
   "postcode": "5171"
 },
 {
   "suburb": "MCLAREN VALE",
   "postcode": "5171"
 },
 {
   "suburb": "PEDLER CREEK",
   "postcode": "5171"
 },
 {
   "suburb": "TATACHILLA",
   "postcode": "5171"
 },
 {
   "suburb": "DINGABLEDINGA",
   "postcode": "5172"
 },
 {
   "suburb": "HOPE FOREST",
   "postcode": "5172"
 },
 {
   "suburb": "KUITPO COLONY",
   "postcode": "5172"
 },
 {
   "suburb": "KYEEMA",
   "postcode": "5172"
 },
 {
   "suburb": "MONTARRA",
   "postcode": "5172"
 },
 {
   "suburb": "PAGES FLAT",
   "postcode": "5172"
 },
 {
   "suburb": "THE RANGE",
   "postcode": "5172"
 },
 {
   "suburb": "WHITES VALLEY",
   "postcode": "5172"
 },
 {
   "suburb": "WILLUNGA",
   "postcode": "5172"
 },
 {
   "suburb": "WILLUNGA HILL",
   "postcode": "5172"
 },
 {
   "suburb": "WILLUNGA SOUTH",
   "postcode": "5172"
 },
 {
   "suburb": "YUNDI",
   "postcode": "5172"
 },
 {
   "suburb": "ALDINGA",
   "postcode": "5173"
 },
 {
   "suburb": "ALDINGA BEACH",
   "postcode": "5173"
 },
 {
   "suburb": "PORT WILLUNGA",
   "postcode": "5173"
 },
 {
   "suburb": "SILVER SANDS",
   "postcode": "5173"
 },
 {
   "suburb": "SELLICKS BEACH",
   "postcode": "5174"
 },
 {
   "suburb": "SELLICKS HILL",
   "postcode": "5174"
 },
 {
   "suburb": "BLACKFELLOWS CREEK",
   "postcode": "5201"
 },
 {
   "suburb": "KUITPO",
   "postcode": "5201"
 },
 {
   "suburb": "MEADOWS",
   "postcode": "5201"
 },
 {
   "suburb": "PARIS CREEK",
   "postcode": "5201"
 },
 {
   "suburb": "PROSPECT HILL",
   "postcode": "5201"
 },
 {
   "suburb": "HINDMARSH TIERS",
   "postcode": "5202"
 },
 {
   "suburb": "MYPONGA",
   "postcode": "5202"
 },
 {
   "suburb": "MYPONGA BEACH",
   "postcode": "5202"
 },
 {
   "suburb": "BALD HILLS",
   "postcode": "5203"
 },
 {
   "suburb": "PARAWA",
   "postcode": "5203"
 },
 {
   "suburb": "TORRENS VALE",
   "postcode": "5203"
 },
 {
   "suburb": "TUNKALILLA",
   "postcode": "5203"
 },
 {
   "suburb": "WATTLE FLAT",
   "postcode": "5203"
 },
 {
   "suburb": "YANKALILLA",
   "postcode": "5203"
 },
 {
   "suburb": "CAPE JERVIS",
   "postcode": "5204"
 },
 {
   "suburb": "CARRICKALINGA",
   "postcode": "5204"
 },
 {
   "suburb": "DEEP CREEK",
   "postcode": "5204"
 },
 {
   "suburb": "DELAMERE",
   "postcode": "5204"
 },
 {
   "suburb": "HAY FLAT",
   "postcode": "5204"
 },
 {
   "suburb": "NORMANVILLE",
   "postcode": "5204"
 },
 {
   "suburb": "RAPID BAY",
   "postcode": "5204"
 },
 {
   "suburb": "SECOND VALLEY",
   "postcode": "5204"
 },
 {
   "suburb": "SILVERTON",
   "postcode": "5204"
 },
 {
   "suburb": "WIRRINA COVE",
   "postcode": "5204"
 },
 {
   "suburb": "MOUNT COMPASS",
   "postcode": "5210"
 },
 {
   "suburb": "MOUNT MAGNIFICENT",
   "postcode": "5210"
 },
 {
   "suburb": "NANGKITA",
   "postcode": "5210"
 },
 {
   "suburb": "BACK VALLEY",
   "postcode": "5211"
 },
 {
   "suburb": "CHITON",
   "postcode": "5211"
 },
 {
   "suburb": "ENCOUNTER BAY",
   "postcode": "5211"
 },
 {
   "suburb": "HAYBOROUGH",
   "postcode": "5211"
 },
 {
   "suburb": "HINDMARSH VALLEY",
   "postcode": "5211"
 },
 {
   "suburb": "INMAN VALLEY",
   "postcode": "5211"
 },
 {
   "suburb": "LOWER INMAN VALLEY",
   "postcode": "5211"
 },
 {
   "suburb": "MCCRACKEN",
   "postcode": "5211"
 },
 {
   "suburb": "MOUNT JAGGED",
   "postcode": "5211"
 },
 {
   "suburb": "VICTOR HARBOR",
   "postcode": "5211"
 },
 {
   "suburb": "VICTOR HARBOR CENTRAL",
   "postcode": "5211"
 },
 {
   "suburb": "WAITPINGA",
   "postcode": "5211"
 },
 {
   "suburb": "WILLOW CREEK",
   "postcode": "5211"
 },
 {
   "suburb": "YILKI",
   "postcode": "5211"
 },
 {
   "suburb": "PORT ELLIOT",
   "postcode": "5212"
 },
 {
   "suburb": "MIDDLETON",
   "postcode": "5213"
 },
 {
   "suburb": "CURRENCY CREEK",
   "postcode": "5214"
 },
 {
   "suburb": "GOOLWA",
   "postcode": "5214"
 },
 {
   "suburb": "GOOLWA BEACH",
   "postcode": "5214"
 },
 {
   "suburb": "GOOLWA NORTH",
   "postcode": "5214"
 },
 {
   "suburb": "GOOLWA SOUTH",
   "postcode": "5214"
 },
 {
   "suburb": "HINDMARSH ISLAND",
   "postcode": "5214"
 },
 {
   "suburb": "MOSQUITO HILL",
   "postcode": "5214"
 },
 {
   "suburb": "CHAIN OF PONDS",
   "postcode": "5231"
 },
 {
   "suburb": "KERSBROOK",
   "postcode": "5231"
 },
 {
   "suburb": "MILLBROOK",
   "postcode": "5231"
 },
 {
   "suburb": "CUDLEE CREEK",
   "postcode": "5232"
 },
 {
   "suburb": "FORRESTON",
   "postcode": "5233"
 },
 {
   "suburb": "GUMERACHA",
   "postcode": "5233"
 },
 {
   "suburb": "KENTON VALLEY",
   "postcode": "5233"
 },
 {
   "suburb": "WARREN",
   "postcode": "5233"
 },
 {
   "suburb": "BIRDWOOD",
   "postcode": "5234"
 },
 {
   "suburb": "CROMER",
   "postcode": "5235"
 },
 {
   "suburb": "EDEN VALLEY",
   "postcode": "5235"
 },
 {
   "suburb": "FLAXMAN VALLEY",
   "postcode": "5235"
 },
 {
   "suburb": "MOUNT PLEASANT",
   "postcode": "5235"
 },
 {
   "suburb": "SPRINGTON",
   "postcode": "5235"
 },
 {
   "suburb": "TAUNTON",
   "postcode": "5235"
 },
 {
   "suburb": "TUNGKILLO",
   "postcode": "5236"
 },
 {
   "suburb": "APAMURRA",
   "postcode": "5237"
 },
 {
   "suburb": "MILENDELLA",
   "postcode": "5237"
 },
 {
   "suburb": "PALMER",
   "postcode": "5237"
 },
 {
   "suburb": "SANDERSTON",
   "postcode": "5237"
 },
 {
   "suburb": "ANGAS VALLEY",
   "postcode": "5238"
 },
 {
   "suburb": "BOLTO",
   "postcode": "5238"
 },
 {
   "suburb": "COWIRRA",
   "postcode": "5238"
 },
 {
   "suburb": "FIVE MILES",
   "postcode": "5238"
 },
 {
   "suburb": "FRAHNS",
   "postcode": "5238"
 },
 {
   "suburb": "FRAYVILLE",
   "postcode": "5238"
 },
 {
   "suburb": "MANNUM",
   "postcode": "5238"
 },
 {
   "suburb": "PELLARING FLAT",
   "postcode": "5238"
 },
 {
   "suburb": "POMPOOTA",
   "postcode": "5238"
 },
 {
   "suburb": "PONDE",
   "postcode": "5238"
 },
 {
   "suburb": "PORT MANNUM",
   "postcode": "5238"
 },
 {
   "suburb": "PUNTHARI",
   "postcode": "5238"
 },
 {
   "suburb": "LENSWOOD",
   "postcode": "5240"
 },
 {
   "suburb": "LOBETHAL",
   "postcode": "5241"
 },
 {
   "suburb": "BALHANNAH",
   "postcode": "5242"
 },
 {
   "suburb": "OAKBANK",
   "postcode": "5243"
 },
 {
   "suburb": "CHARLESTON",
   "postcode": "5244"
 },
 {
   "suburb": "HARROGATE",
   "postcode": "5244"
 },
 {
   "suburb": "INVERBRACKIE",
   "postcode": "5244"
 },
 {
   "suburb": "MOUNT TORRENS",
   "postcode": "5244"
 },
 {
   "suburb": "WOODSIDE",
   "postcode": "5244"
 },
 {
   "suburb": "HAHNDORF",
   "postcode": "5245"
 },
 {
   "suburb": "PAECHTOWN",
   "postcode": "5245"
 },
 {
   "suburb": "VERDUN",
   "postcode": "5245"
 },
 {
   "suburb": "BLAKISTON",
   "postcode": "5250"
 },
 {
   "suburb": "LITTLEHAMPTON",
   "postcode": "5250"
 },
 {
   "suburb": "TOTNESS",
   "postcode": "5250"
 },
 {
   "suburb": "BUGLE RANGES",
   "postcode": "5251"
 },
 {
   "suburb": "MOUNT BARKER",
   "postcode": "5251"
 },
 {
   "suburb": "MOUNT BARKER JUNCTION",
   "postcode": "5251"
 },
 {
   "suburb": "MOUNT BARKER SPRINGS",
   "postcode": "5251"
 },
 {
   "suburb": "MOUNT BARKER SUMMIT",
   "postcode": "5251"
 },
 {
   "suburb": "WISTOW",
   "postcode": "5251"
 },
 {
   "suburb": "BRUKUNGA",
   "postcode": "5252"
 },
 {
   "suburb": "DAWESLEY",
   "postcode": "5252"
 },
 {
   "suburb": "HAY VALLEY",
   "postcode": "5252"
 },
 {
   "suburb": "KANMANTOO",
   "postcode": "5252"
 },
 {
   "suburb": "NAIRNE",
   "postcode": "5252"
 },
 {
   "suburb": "ST IVES",
   "postcode": "5252"
 },
 {
   "suburb": "AVOCA DELL",
   "postcode": "5253"
 },
 {
   "suburb": "BRINKLEY",
   "postcode": "5253"
 },
 {
   "suburb": "BURDETT",
   "postcode": "5253"
 },
 {
   "suburb": "CHAPMAN BORE",
   "postcode": "5253"
 },
 {
   "suburb": "ETTRICK",
   "postcode": "5253"
 },
 {
   "suburb": "GIFFORD HILL",
   "postcode": "5253"
 },
 {
   "suburb": "GREENBANKS",
   "postcode": "5253"
 },
 {
   "suburb": "LONG FLAT",
   "postcode": "5253"
 },
 {
   "suburb": "MOBILONG",
   "postcode": "5253"
 },
 {
   "suburb": "MONTEITH",
   "postcode": "5253"
 },
 {
   "suburb": "MURRAWONG",
   "postcode": "5253"
 },
 {
   "suburb": "MURRAY BRIDGE",
   "postcode": "5253"
 },
 {
   "suburb": "MURRAY BRIDGE EAST",
   "postcode": "5253"
 },
 {
   "suburb": "MURRAY BRIDGE NORTH",
   "postcode": "5253"
 },
 {
   "suburb": "MURRAY BRIDGE SOUTH",
   "postcode": "5253"
 },
 {
   "suburb": "NORTHERN HEIGHTS",
   "postcode": "5253"
 },
 {
   "suburb": "RIVERGLADES",
   "postcode": "5253"
 },
 {
   "suburb": "RIVERGLEN",
   "postcode": "5253"
 },
 {
   "suburb": "ROCKY GULLY",
   "postcode": "5253"
 },
 {
   "suburb": "SUNNYSIDE",
   "postcode": "5253"
 },
 {
   "suburb": "SWANPORT",
   "postcode": "5253"
 },
 {
   "suburb": "TOORA",
   "postcode": "5253"
 },
 {
   "suburb": "WHITE HILL",
   "postcode": "5253"
 },
 {
   "suburb": "WHITE SANDS",
   "postcode": "5253"
 },
 {
   "suburb": "WILLOW BANKS",
   "postcode": "5253"
 },
 {
   "suburb": "WOODS POINT",
   "postcode": "5253"
 },
 {
   "suburb": "CALLINGTON",
   "postcode": "5254"
 },
 {
   "suburb": "CALOOTE",
   "postcode": "5254"
 },
 {
   "suburb": "MONARTO",
   "postcode": "5254"
 },
 {
   "suburb": "MONARTO SOUTH",
   "postcode": "5254"
 },
 {
   "suburb": "MYPOLONGA",
   "postcode": "5254"
 },
 {
   "suburb": "PALLAMANA",
   "postcode": "5254"
 },
 {
   "suburb": "PETWOOD",
   "postcode": "5254"
 },
 {
   "suburb": "ROCKLEIGH",
   "postcode": "5254"
 },
 {
   "suburb": "ROCKY GULLY",
   "postcode": "5254"
 },
 {
   "suburb": "TEPKO",
   "postcode": "5254"
 },
 {
   "suburb": "WALL FLAT",
   "postcode": "5254"
 },
 {
   "suburb": "WHITE HILL",
   "postcode": "5254"
 },
 {
   "suburb": "WOODLANE",
   "postcode": "5254"
 },
 {
   "suburb": "ZADOWS LANDING",
   "postcode": "5254"
 },
 {
   "suburb": "ANGAS PLAINS",
   "postcode": "5255"
 },
 {
   "suburb": "BELVIDERE",
   "postcode": "5255"
 },
 {
   "suburb": "BLETCHLEY",
   "postcode": "5255"
 },
 {
   "suburb": "FINNISS",
   "postcode": "5255"
 },
 {
   "suburb": "GEMMELLS",
   "postcode": "5255"
 },
 {
   "suburb": "HARTLEY",
   "postcode": "5255"
 },
 {
   "suburb": "HIGHLAND VALLEY",
   "postcode": "5255"
 },
 {
   "suburb": "LAKE PLAINS",
   "postcode": "5255"
 },
 {
   "suburb": "LANGHORNE CREEK",
   "postcode": "5255"
 },
 {
   "suburb": "MOUNT OBSERVATION",
   "postcode": "5255"
 },
 {
   "suburb": "RED CREEK",
   "postcode": "5255"
 },
 {
   "suburb": "SALEM",
   "postcode": "5255"
 },
 {
   "suburb": "SANDERGROVE",
   "postcode": "5255"
 },
 {
   "suburb": "STRATHALBYN",
   "postcode": "5255"
 },
 {
   "suburb": "TOOPERANG",
   "postcode": "5255"
 },
 {
   "suburb": "WILLYAROO",
   "postcode": "5255"
 },
 {
   "suburb": "WOODCHESTER",
   "postcode": "5255"
 },
 {
   "suburb": "CLAYTON BAY",
   "postcode": "5256"
 },
 {
   "suburb": "MILANG",
   "postcode": "5256"
 },
 {
   "suburb": "NURRAGI",
   "postcode": "5256"
 },
 {
   "suburb": "TOLDEROL",
   "postcode": "5256"
 },
 {
   "suburb": "KEPA",
   "postcode": "5259"
 },
 {
   "suburb": "MOUNT GAMBIER",
   "postcode": "5290"
 },
 {
   "suburb": "ALLENDALE EAST",
   "postcode": "5291"
 },
 {
   "suburb": "CAROLINE",
   "postcode": "5291"
 },
 {
   "suburb": "CAVETON",
   "postcode": "5291"
 },
 {
   "suburb": "COMPTON",
   "postcode": "5291"
 },
 {
   "suburb": "DONOVANS",
   "postcode": "5291"
 },
 {
   "suburb": "EIGHT MILE CREEK",
   "postcode": "5291"
 },
 {
   "suburb": "GLENBURNIE",
   "postcode": "5291"
 },
 {
   "suburb": "GLENCOE",
   "postcode": "5291"
 },
 {
   "suburb": "MIL-LEL",
   "postcode": "5291"
 },
 {
   "suburb": "MOORAK",
   "postcode": "5291"
 },
 {
   "suburb": "MOUNT GAMBIER",
   "postcode": "5291"
 },
 {
   "suburb": "MOUNT GAMBIER EAST",
   "postcode": "5291"
 },
 {
   "suburb": "MOUNT GAMBIER WEST",
   "postcode": "5291"
 },
 {
   "suburb": "MOUNT SCHANK",
   "postcode": "5291"
 },
 {
   "suburb": "OB FLAT",
   "postcode": "5291"
 },
 {
   "suburb": "PORT MACDONNELL",
   "postcode": "5291"
 },
 {
   "suburb": "RACECOURSE BAY",
   "postcode": "5291"
 },
 {
   "suburb": "SQUARE MILE",
   "postcode": "5291"
 },
 {
   "suburb": "SUTTONTOWN",
   "postcode": "5291"
 },
 {
   "suburb": "WANDILO",
   "postcode": "5291"
 },
 {
   "suburb": "WORROLONG",
   "postcode": "5291"
 },
 {
   "suburb": "WYE",
   "postcode": "5291"
 },
 {
   "suburb": "YAHL",
   "postcode": "5291"
 },
 {
   "suburb": "GOLDEN HEIGHTS",
   "postcode": "5322"
 },
 {
   "suburb": "QUALCO",
   "postcode": "5322"
 },
 {
   "suburb": "RAMCO",
   "postcode": "5322"
 },
 {
   "suburb": "RAMCO HEIGHTS",
   "postcode": "5322"
 },
 {
   "suburb": "GOOD HOPE LANDING",
   "postcode": "5330"
 },
 {
   "suburb": "HOLDER",
   "postcode": "5330"
 },
 {
   "suburb": "LOWBANK",
   "postcode": "5330"
 },
 {
   "suburb": "OVERLAND CORNER",
   "postcode": "5330"
 },
 {
   "suburb": "WAIKERIE",
   "postcode": "5330"
 },
 {
   "suburb": "WIGLEY FLAT",
   "postcode": "5330"
 },
 {
   "suburb": "KINGSTON ON MURRAY",
   "postcode": "5331"
 },
 {
   "suburb": "KINGSTON-ON-MURRAY",
   "postcode": "5331"
 },
 {
   "suburb": "MOOROOK",
   "postcode": "5332"
 },
 {
   "suburb": "MOOROOK SOUTH",
   "postcode": "5332"
 },
 {
   "suburb": "BOOKPURNONG",
   "postcode": "5333"
 },
 {
   "suburb": "LOXTON",
   "postcode": "5333"
 },
 {
   "suburb": "LOXTON NORTH",
   "postcode": "5333"
 },
 {
   "suburb": "NEW RESIDENCE",
   "postcode": "5333"
 },
 {
   "suburb": "PYAP",
   "postcode": "5333"
 },
 {
   "suburb": "MUNDIC CREEK",
   "postcode": "5340"
 },
 {
   "suburb": "MURTHO",
   "postcode": "5340"
 },
 {
   "suburb": "PARINGA",
   "postcode": "5340"
 },
 {
   "suburb": "PIKE RIVER",
   "postcode": "5340"
 },
 {
   "suburb": "WONUARRA",
   "postcode": "5340"
 },
 {
   "suburb": "YAMBA",
   "postcode": "5340"
 },
 {
   "suburb": "CHAFFEY",
   "postcode": "5341"
 },
 {
   "suburb": "COOLTONG",
   "postcode": "5341"
 },
 {
   "suburb": "CRESCENT",
   "postcode": "5341"
 },
 {
   "suburb": "OLD CALPERUM",
   "postcode": "5341"
 },
 {
   "suburb": "RENMARK",
   "postcode": "5341"
 },
 {
   "suburb": "RENMARK NORTH",
   "postcode": "5341"
 },
 {
   "suburb": "RENMARK SOUTH",
   "postcode": "5341"
 },
 {
   "suburb": "RENMARK WEST",
   "postcode": "5341"
 },
 {
   "suburb": "MONASH",
   "postcode": "5342"
 },
 {
   "suburb": "BERRI",
   "postcode": "5343"
 },
 {
   "suburb": "GURRA GURRA",
   "postcode": "5343"
 },
 {
   "suburb": "KATARAPKO",
   "postcode": "5343"
 },
 {
   "suburb": "LYRUP",
   "postcode": "5343"
 },
 {
   "suburb": "WINKIE",
   "postcode": "5343"
 },
 {
   "suburb": "GLOSSOP",
   "postcode": "5344"
 },
 {
   "suburb": "BARMERA",
   "postcode": "5345"
 },
 {
   "suburb": "LOVEDAY",
   "postcode": "5345"
 },
 {
   "suburb": "SPECTACLE LAKE",
   "postcode": "5345"
 },
 {
   "suburb": "COBDOGLA",
   "postcode": "5346"
 },
 {
   "suburb": "COBDOLGA",
   "postcode": "5346"
 },
 {
   "suburb": "ROSEDALE",
   "postcode": "5350"
 },
 {
   "suburb": "SANDY CREEK",
   "postcode": "5350"
 },
 {
   "suburb": "ALTONA",
   "postcode": "5351"
 },
 {
   "suburb": "BAROSSA GOLDFIELDS",
   "postcode": "5351"
 },
 {
   "suburb": "COCKATOO VALLEY",
   "postcode": "5351"
 },
 {
   "suburb": "LYNDOCH",
   "postcode": "5351"
 },
 {
   "suburb": "MOUNT CRAWFORD",
   "postcode": "5351"
 },
 {
   "suburb": "PEWSEY VALE",
   "postcode": "5351"
 },
 {
   "suburb": "WILLIAMSTOWN",
   "postcode": "5351"
 },
 {
   "suburb": "BETHANY",
   "postcode": "5352"
 },
 {
   "suburb": "GOMERSAL",
   "postcode": "5352"
 },
 {
   "suburb": "KRONDORF",
   "postcode": "5352"
 },
 {
   "suburb": "ROWLAND FLAT",
   "postcode": "5352"
 },
 {
   "suburb": "STONE WELL",
   "postcode": "5352"
 },
 {
   "suburb": "TANUNDA",
   "postcode": "5352"
 },
 {
   "suburb": "VINE VALE",
   "postcode": "5352"
 },
 {
   "suburb": "ANGASTON",
   "postcode": "5353"
 },
 {
   "suburb": "BLACK HILL",
   "postcode": "5353"
 },
 {
   "suburb": "CAMBRAI",
   "postcode": "5353"
 },
 {
   "suburb": "KEYNETON",
   "postcode": "5353"
 },
 {
   "suburb": "KONGOLIA",
   "postcode": "5353"
 },
 {
   "suburb": "MOCULTA",
   "postcode": "5353"
 },
 {
   "suburb": "MOUNT MCKENZIE",
   "postcode": "5353"
 },
 {
   "suburb": "PENRICE",
   "postcode": "5353"
 },
 {
   "suburb": "SEDAN",
   "postcode": "5353"
 },
 {
   "suburb": "TOWITTA",
   "postcode": "5353"
 },
 {
   "suburb": "DAVEYSTON",
   "postcode": "5355"
 },
 {
   "suburb": "EBENEZER",
   "postcode": "5355"
 },
 {
   "suburb": "LIGHT PASS",
   "postcode": "5355"
 },
 {
   "suburb": "MARANANGA",
   "postcode": "5355"
 },
 {
   "suburb": "MOPPA",
   "postcode": "5355"
 },
 {
   "suburb": "NURIOOTPA",
   "postcode": "5355"
 },
 {
   "suburb": "SEPPELTSFIELD",
   "postcode": "5355"
 },
 {
   "suburb": "STOCKWELL",
   "postcode": "5355"
 },
 {
   "suburb": "DUTTON",
   "postcode": "5356"
 },
 {
   "suburb": "ST KITTS",
   "postcode": "5356"
 },
 {
   "suburb": "TRURO",
   "postcode": "5356"
 },
 {
   "suburb": "GREENOCK",
   "postcode": "5360"
 },
 {
   "suburb": "NAIN",
   "postcode": "5360"
 },
 {
   "suburb": "MORN HILL",
   "postcode": "5371"
 },
 {
   "suburb": "ROSEWORTHY",
   "postcode": "5371"
 },
 {
   "suburb": "SHEA-OAK LOG",
   "postcode": "5371"
 },
 {
   "suburb": "TEMPLERS",
   "postcode": "5371"
 },
 {
   "suburb": "FREELING",
   "postcode": "5372"
 },
 {
   "suburb": "ALLENDALE NORTH",
   "postcode": "5373"
 },
 {
   "suburb": "BAGOT WELL",
   "postcode": "5373"
 },
 {
   "suburb": "BETHEL",
   "postcode": "5373"
 },
 {
   "suburb": "FORDS",
   "postcode": "5373"
 },
 {
   "suburb": "HAMILTON",
   "postcode": "5373"
 },
 {
   "suburb": "KAPUNDA",
   "postcode": "5373"
 },
 {
   "suburb": "KOONUNGA",
   "postcode": "5373"
 },
 {
   "suburb": "ST JOHNS",
   "postcode": "5373"
 },
 {
   "suburb": "BUCHANAN",
   "postcode": "5374"
 },
 {
   "suburb": "EUDUNDA",
   "postcode": "5374"
 },
 {
   "suburb": "HANSBOROUGH",
   "postcode": "5374"
 },
 {
   "suburb": "MAGDALA",
   "postcode": "5400"
 },
 {
   "suburb": "PINKERTON PLAINS",
   "postcode": "5400"
 },
 {
   "suburb": "WASLEYS",
   "postcode": "5400"
 },
 {
   "suburb": "WOOLSHEDS",
   "postcode": "5400"
 },
 {
   "suburb": "ALMA",
   "postcode": "5401"
 },
 {
   "suburb": "HAMLEY BRIDGE",
   "postcode": "5401"
 },
 {
   "suburb": "LINWOOD",
   "postcode": "5410"
 },
 {
   "suburb": "STOCKPORT",
   "postcode": "5410"
 },
 {
   "suburb": "GILES CORNER",
   "postcode": "5411"
 },
 {
   "suburb": "TARLEE",
   "postcode": "5411"
 },
 {
   "suburb": "RIVERTON",
   "postcode": "5412"
 },
 {
   "suburb": "BARABBA",
   "postcode": "5460"
 },
 {
   "suburb": "OWEN",
   "postcode": "5460"
 },
 {
   "suburb": "PINERY",
   "postcode": "5460"
 },
 {
   "suburb": "STOCKYARD CREEK",
   "postcode": "5460"
 },
 {
   "suburb": "CALOMBA",
   "postcode": "5501"
 },
 {
   "suburb": "DUBLIN",
   "postcode": "5501"
 },
 {
   "suburb": "LEWISTON",
   "postcode": "5501"
 },
 {
   "suburb": "LONG PLAINS",
   "postcode": "5501"
 },
 {
   "suburb": "LOWER LIGHT",
   "postcode": "5501"
 },
 {
   "suburb": "MIDDLE BEACH",
   "postcode": "5501"
 },
 {
   "suburb": "PARHAM",
   "postcode": "5501"
 },
 {
   "suburb": "PORT GAWLER",
   "postcode": "5501"
 },
 {
   "suburb": "THOMPSON BEACH",
   "postcode": "5501"
 },
 {
   "suburb": "TWO WELLS",
   "postcode": "5501"
 },
 {
   "suburb": "WEBB BEACH",
   "postcode": "5501"
 },
 {
   "suburb": "WILD HORSE PLAINS",
   "postcode": "5501"
 },
 {
   "suburb": "WINDSOR",
   "postcode": "5501"
 },
 {
   "suburb": "FISCHER",
   "postcode": "5502"
 },
 {
   "suburb": "GRACE PLAINS",
   "postcode": "5502"
 },
 {
   "suburb": "KORUNYE",
   "postcode": "5502"
 },
 {
   "suburb": "MALLALA",
   "postcode": "5502"
 },
 {
   "suburb": "REDBANKS",
   "postcode": "5502"
 },
 {
   "suburb": "REEVES PLAINS",
   "postcode": "5502"
 },
 {
   "suburb": "ADELAIDE AIRPORT",
   "postcode": "5950"
 },
 {
   "suburb": "PERTH",
   "postcode": "6000"
 },
 {
   "suburb": "HIGHGATE",
   "postcode": "6003"
 },
 {
   "suburb": "NORTHBRIDGE",
   "postcode": "6003"
 },
 {
   "suburb": "EAST PERTH",
   "postcode": "6004"
 },
 {
   "suburb": "KINGS PARK",
   "postcode": "6005"
 },
 {
   "suburb": "WEST PERTH",
   "postcode": "6005"
 },
 {
   "suburb": "NORTH PERTH",
   "postcode": "6006"
 },
 {
   "suburb": "LEEDERVILLE",
   "postcode": "6007"
 },
 {
   "suburb": "WEST LEEDERVILLE",
   "postcode": "6007"
 },
 {
   "suburb": "DAGLISH",
   "postcode": "6008"
 },
 {
   "suburb": "SHENTON PARK",
   "postcode": "6008"
 },
 {
   "suburb": "SUBIACO",
   "postcode": "6008"
 },
 {
   "suburb": "SUBIACO EAST",
   "postcode": "6008"
 },
 {
   "suburb": "CRAWLEY",
   "postcode": "6009"
 },
 {
   "suburb": "DALKEITH",
   "postcode": "6009"
 },
 {
   "suburb": "NEDLANDS",
   "postcode": "6009"
 },
 {
   "suburb": "CLAREMONT",
   "postcode": "6010"
 },
 {
   "suburb": "KARRAKATTA",
   "postcode": "6010"
 },
 {
   "suburb": "MOUNT CLAREMONT",
   "postcode": "6010"
 },
 {
   "suburb": "SWANBOURNE",
   "postcode": "6010"
 },
 {
   "suburb": "COTTESLOE",
   "postcode": "6011"
 },
 {
   "suburb": "PEPPERMINT GROVE",
   "postcode": "6011"
 },
 {
   "suburb": "MOSMAN PARK",
   "postcode": "6012"
 },
 {
   "suburb": "FLOREAT",
   "postcode": "6014"
 },
 {
   "suburb": "JOLIMONT",
   "postcode": "6014"
 },
 {
   "suburb": "WEMBLEY",
   "postcode": "6014"
 },
 {
   "suburb": "CITY BEACH",
   "postcode": "6015"
 },
 {
   "suburb": "GLENDALOUGH",
   "postcode": "6016"
 },
 {
   "suburb": "MOUNT HAWTHORN",
   "postcode": "6016"
 },
 {
   "suburb": "HERDSMAN",
   "postcode": "6017"
 },
 {
   "suburb": "OSBORNE PARK",
   "postcode": "6017"
 },
 {
   "suburb": "CHURCHLANDS",
   "postcode": "6018"
 },
 {
   "suburb": "DOUBLEVIEW",
   "postcode": "6018"
 },
 {
   "suburb": "GWELUP",
   "postcode": "6018"
 },
 {
   "suburb": "INNALOO",
   "postcode": "6018"
 },
 {
   "suburb": "KARRINYUP",
   "postcode": "6018"
 },
 {
   "suburb": "WOODLANDS",
   "postcode": "6018"
 },
 {
   "suburb": "SCARBOROUGH",
   "postcode": "6019"
 },
 {
   "suburb": "WEMBLEY DOWNS",
   "postcode": "6019"
 },
 {
   "suburb": "CARINE",
   "postcode": "6020"
 },
 {
   "suburb": "MARMION",
   "postcode": "6020"
 },
 {
   "suburb": "NORTH BEACH",
   "postcode": "6020"
 },
 {
   "suburb": "SORRENTO",
   "postcode": "6020"
 },
 {
   "suburb": "WATERMANS BAY",
   "postcode": "6020"
 },
 {
   "suburb": "BALCATTA",
   "postcode": "6021"
 },
 {
   "suburb": "STIRLING",
   "postcode": "6021"
 },
 {
   "suburb": "HAMERSLEY",
   "postcode": "6022"
 },
 {
   "suburb": "DUNCRAIG",
   "postcode": "6023"
 },
 {
   "suburb": "GREENWOOD",
   "postcode": "6024"
 },
 {
   "suburb": "WARWICK",
   "postcode": "6024"
 },
 {
   "suburb": "CRAIGIE",
   "postcode": "6025"
 },
 {
   "suburb": "HILLARYS",
   "postcode": "6025"
 },
 {
   "suburb": "KALLAROO",
   "postcode": "6025"
 },
 {
   "suburb": "PADBURY",
   "postcode": "6025"
 },
 {
   "suburb": "KINGSLEY",
   "postcode": "6026"
 },
 {
   "suburb": "WOODVALE",
   "postcode": "6026"
 },
 {
   "suburb": "BELDON",
   "postcode": "6027"
 },
 {
   "suburb": "CONNOLLY",
   "postcode": "6027"
 },
 {
   "suburb": "EDGEWATER",
   "postcode": "6027"
 },
 {
   "suburb": "HEATHRIDGE",
   "postcode": "6027"
 },
 {
   "suburb": "JOONDALUP",
   "postcode": "6027"
 },
 {
   "suburb": "MULLALOO",
   "postcode": "6027"
 },
 {
   "suburb": "OCEAN REEF",
   "postcode": "6027"
 },
 {
   "suburb": "BURNS BEACH",
   "postcode": "6028"
 },
 {
   "suburb": "CURRAMBINE",
   "postcode": "6028"
 },
 {
   "suburb": "ILUKA",
   "postcode": "6028"
 },
 {
   "suburb": "KINROSS",
   "postcode": "6028"
 },
 {
   "suburb": "TRIGG",
   "postcode": "6029"
 },
 {
   "suburb": "CLARKSON",
   "postcode": "6030"
 },
 {
   "suburb": "MERRIWA",
   "postcode": "6030"
 },
 {
   "suburb": "MINDARIE",
   "postcode": "6030"
 },
 {
   "suburb": "QUINNS ROCKS",
   "postcode": "6030"
 },
 {
   "suburb": "RIDGEWOOD",
   "postcode": "6030"
 },
 {
   "suburb": "TAMALA PARK",
   "postcode": "6030"
 },
 {
   "suburb": "BANKSIA GROVE",
   "postcode": "6031"
 },
 {
   "suburb": "CARRAMAR",
   "postcode": "6031"
 },
 {
   "suburb": "NEERABUP",
   "postcode": "6031"
 },
 {
   "suburb": "NOWERGUP",
   "postcode": "6032"
 },
 {
   "suburb": "CARABOODA",
   "postcode": "6033"
 },
 {
   "suburb": "EGLINTON",
   "postcode": "6034"
 },
 {
   "suburb": "YANCHEP",
   "postcode": "6035"
 },
 {
   "suburb": "BUTLER",
   "postcode": "6036"
 },
 {
   "suburb": "JINDALEE",
   "postcode": "6036"
 },
 {
   "suburb": "TWO ROCKS",
   "postcode": "6037"
 },
 {
   "suburb": "ALKIMOS",
   "postcode": "6038"
 },
 {
   "suburb": "CARABAN",
   "postcode": "6041"
 },
 {
   "suburb": "GABBADAH",
   "postcode": "6041"
 },
 {
   "suburb": "GUILDERTON",
   "postcode": "6041"
 },
 {
   "suburb": "WILBINGA",
   "postcode": "6041"
 },
 {
   "suburb": "WOODRIDGE",
   "postcode": "6041"
 },
 {
   "suburb": "SEABIRD",
   "postcode": "6042"
 },
 {
   "suburb": "BRETON BAY",
   "postcode": "6043"
 },
 {
   "suburb": "LEDGE POINT",
   "postcode": "6043"
 },
 {
   "suburb": "KARAKIN",
   "postcode": "6044"
 },
 {
   "suburb": "LANCELIN",
   "postcode": "6044"
 },
 {
   "suburb": "NILGEN",
   "postcode": "6044"
 },
 {
   "suburb": "WEDGE ISLAND",
   "postcode": "6044"
 },
 {
   "suburb": "COOLBINIA",
   "postcode": "6050"
 },
 {
   "suburb": "MENORA",
   "postcode": "6050"
 },
 {
   "suburb": "MOUNT LAWLEY",
   "postcode": "6050"
 },
 {
   "suburb": "MAYLANDS",
   "postcode": "6051"
 },
 {
   "suburb": "BEDFORD",
   "postcode": "6052"
 },
 {
   "suburb": "INGLEWOOD",
   "postcode": "6052"
 },
 {
   "suburb": "BAYSWATER",
   "postcode": "6053"
 },
 {
   "suburb": "ASHFIELD",
   "postcode": "6054"
 },
 {
   "suburb": "BASSENDEAN",
   "postcode": "6054"
 },
 {
   "suburb": "EDEN HILL",
   "postcode": "6054"
 },
 {
   "suburb": "KIARA",
   "postcode": "6054"
 },
 {
   "suburb": "LOCKRIDGE",
   "postcode": "6054"
 },
 {
   "suburb": "BRABHAM",
   "postcode": "6055"
 },
 {
   "suburb": "BUSHMEAD",
   "postcode": "6055"
 },
 {
   "suburb": "CAVERSHAM",
   "postcode": "6055"
 },
 {
   "suburb": "DAYTON",
   "postcode": "6055"
 },
 {
   "suburb": "GUILDFORD",
   "postcode": "6055"
 },
 {
   "suburb": "HAZELMERE",
   "postcode": "6055"
 },
 {
   "suburb": "HENLEY BROOK",
   "postcode": "6055"
 },
 {
   "suburb": "SOUTH GUILDFORD",
   "postcode": "6055"
 },
 {
   "suburb": "WEST SWAN",
   "postcode": "6055"
 },
 {
   "suburb": "BASKERVILLE",
   "postcode": "6056"
 },
 {
   "suburb": "BELLEVUE",
   "postcode": "6056"
 },
 {
   "suburb": "BOYA",
   "postcode": "6056"
 },
 {
   "suburb": "GREENMOUNT",
   "postcode": "6056"
 },
 {
   "suburb": "HELENA VALLEY",
   "postcode": "6056"
 },
 {
   "suburb": "HERNE HILL",
   "postcode": "6056"
 },
 {
   "suburb": "JANE BROOK",
   "postcode": "6056"
 },
 {
   "suburb": "KOONGAMIA",
   "postcode": "6056"
 },
 {
   "suburb": "MIDDLE SWAN",
   "postcode": "6056"
 },
 {
   "suburb": "MIDLAND",
   "postcode": "6056"
 },
 {
   "suburb": "MIDVALE",
   "postcode": "6056"
 },
 {
   "suburb": "MILLENDON",
   "postcode": "6056"
 },
 {
   "suburb": "RED HILL",
   "postcode": "6056"
 },
 {
   "suburb": "STRATTON",
   "postcode": "6056"
 },
 {
   "suburb": "SWAN VIEW",
   "postcode": "6056"
 },
 {
   "suburb": "VIVEASH",
   "postcode": "6056"
 },
 {
   "suburb": "WOODBRIDGE",
   "postcode": "6056"
 },
 {
   "suburb": "HIGH WYCOMBE",
   "postcode": "6057"
 },
 {
   "suburb": "MAIDA VALE",
   "postcode": "6057"
 },
 {
   "suburb": "FORRESTFIELD",
   "postcode": "6058"
 },
 {
   "suburb": "DIANELLA",
   "postcode": "6059"
 },
 {
   "suburb": "JOONDANNA",
   "postcode": "6060"
 },
 {
   "suburb": "TUART HILL",
   "postcode": "6060"
 },
 {
   "suburb": "YOKINE",
   "postcode": "6060"
 },
 {
   "suburb": "BALGA",
   "postcode": "6061"
 },
 {
   "suburb": "MIRRABOOKA",
   "postcode": "6061"
 },
 {
   "suburb": "NOLLAMARA",
   "postcode": "6061"
 },
 {
   "suburb": "WESTMINSTER",
   "postcode": "6061"
 },
 {
   "suburb": "EMBLETON",
   "postcode": "6062"
 },
 {
   "suburb": "MORLEY",
   "postcode": "6062"
 },
 {
   "suburb": "NORANDA",
   "postcode": "6062"
 },
 {
   "suburb": "BEECHBORO",
   "postcode": "6063"
 },
 {
   "suburb": "BENNETT SPRINGS",
   "postcode": "6063"
 },
 {
   "suburb": "ALEXANDER HEIGHTS",
   "postcode": "6064"
 },
 {
   "suburb": "GIRRAWHEEN",
   "postcode": "6064"
 },
 {
   "suburb": "KOONDOOLA",
   "postcode": "6064"
 },
 {
   "suburb": "MARANGAROO",
   "postcode": "6064"
 },
 {
   "suburb": "ASHBY",
   "postcode": "6065"
 },
 {
   "suburb": "DARCH",
   "postcode": "6065"
 },
 {
   "suburb": "HOCKING",
   "postcode": "6065"
 },
 {
   "suburb": "KINGSWAY",
   "postcode": "6065"
 },
 {
   "suburb": "LANDSDALE",
   "postcode": "6065"
 },
 {
   "suburb": "MADELEY",
   "postcode": "6065"
 },
 {
   "suburb": "PEARSALL",
   "postcode": "6065"
 },
 {
   "suburb": "SINAGRA",
   "postcode": "6065"
 },
 {
   "suburb": "TAPPING",
   "postcode": "6065"
 },
 {
   "suburb": "WANGARA",
   "postcode": "6065"
 },
 {
   "suburb": "WANNEROO",
   "postcode": "6065"
 },
 {
   "suburb": "BALLAJURA",
   "postcode": "6066"
 },
 {
   "suburb": "CULLACABARDEE",
   "postcode": "6067"
 },
 {
   "suburb": "WHITEMAN",
   "postcode": "6068"
 },
 {
   "suburb": "AVELEY",
   "postcode": "6069"
 },
 {
   "suburb": "BELHUS",
   "postcode": "6069"
 },
 {
   "suburb": "BRIGADOON",
   "postcode": "6069"
 },
 {
   "suburb": "ELLENBROOK",
   "postcode": "6069"
 },
 {
   "suburb": "THE VINES",
   "postcode": "6069"
 },
 {
   "suburb": "UPPER SWAN",
   "postcode": "6069"
 },
 {
   "suburb": "DARLINGTON",
   "postcode": "6070"
 },
 {
   "suburb": "GLEN FORREST",
   "postcode": "6071"
 },
 {
   "suburb": "HOVEA",
   "postcode": "6071"
 },
 {
   "suburb": "MAHOGANY CREEK",
   "postcode": "6072"
 },
 {
   "suburb": "MUNDARING",
   "postcode": "6073"
 },
 {
   "suburb": "SAWYERS VALLEY",
   "postcode": "6074"
 },
 {
   "suburb": "BICKLEY",
   "postcode": "6076"
 },
 {
   "suburb": "CARMEL",
   "postcode": "6076"
 },
 {
   "suburb": "GOOSEBERRY HILL",
   "postcode": "6076"
 },
 {
   "suburb": "HACKETTS GULLY",
   "postcode": "6076"
 },
 {
   "suburb": "KALAMUNDA",
   "postcode": "6076"
 },
 {
   "suburb": "LESMURDIE",
   "postcode": "6076"
 },
 {
   "suburb": "PAULLS VALLEY",
   "postcode": "6076"
 },
 {
   "suburb": "PICKERING BROOK",
   "postcode": "6076"
 },
 {
   "suburb": "PIESSE BROOK",
   "postcode": "6076"
 },
 {
   "suburb": "WALLISTON",
   "postcode": "6076"
 },
 {
   "suburb": "GNANGARA",
   "postcode": "6077"
 },
 {
   "suburb": "JANDABUP",
   "postcode": "6077"
 },
 {
   "suburb": "MARIGINIUP",
   "postcode": "6078"
 },
 {
   "suburb": "PINJAR",
   "postcode": "6078"
 },
 {
   "suburb": "LEXIA",
   "postcode": "6079"
 },
 {
   "suburb": "MELALEUCA",
   "postcode": "6079"
 },
 {
   "suburb": "PARKERVILLE",
   "postcode": "6081"
 },
 {
   "suburb": "STONEVILLE",
   "postcode": "6081"
 },
 {
   "suburb": "BAILUP",
   "postcode": "6082"
 },
 {
   "suburb": "MOUNT HELENA",
   "postcode": "6082"
 },
 {
   "suburb": "GIDGEGANNUP",
   "postcode": "6083"
 },
 {
   "suburb": "MORANGUP",
   "postcode": "6083"
 },
 {
   "suburb": "AVON VALLEY NATIONAL PARK",
   "postcode": "6084"
 },
 {
   "suburb": "BULLSBROOK",
   "postcode": "6084"
 },
 {
   "suburb": "CHITTERING",
   "postcode": "6084"
 },
 {
   "suburb": "LOWER CHITTERING",
   "postcode": "6084"
 },
 {
   "suburb": "WALYUNGA NATIONAL PARK",
   "postcode": "6084"
 },
 {
   "suburb": "MALAGA",
   "postcode": "6090"
 },
 {
   "suburb": "BURSWOOD",
   "postcode": "6100"
 },
 {
   "suburb": "LATHLAIN",
   "postcode": "6100"
 },
 {
   "suburb": "VICTORIA PARK",
   "postcode": "6100"
 },
 {
   "suburb": "CARLISLE",
   "postcode": "6101"
 },
 {
   "suburb": "CARLISLE NORTH",
   "postcode": "6101"
 },
 {
   "suburb": "CARLISLE SOUTH",
   "postcode": "6101"
 },
 {
   "suburb": "EAST VICTORIA PARK",
   "postcode": "6101"
 },
 {
   "suburb": "BENTLEY",
   "postcode": "6102"
 },
 {
   "suburb": "BENTLEY SOUTH",
   "postcode": "6102"
 },
 {
   "suburb": "ST JAMES",
   "postcode": "6102"
 },
 {
   "suburb": "RIVERVALE",
   "postcode": "6103"
 },
 {
   "suburb": "ASCOT",
   "postcode": "6104"
 },
 {
   "suburb": "BELMONT",
   "postcode": "6104"
 },
 {
   "suburb": "REDCLIFFE",
   "postcode": "6104"
 },
 {
   "suburb": "CLOVERDALE",
   "postcode": "6105"
 },
 {
   "suburb": "KEWDALE",
   "postcode": "6105"
 },
 {
   "suburb": "PERTH AIRPORT",
   "postcode": "6105"
 },
 {
   "suburb": "WELSHPOOL",
   "postcode": "6106"
 },
 {
   "suburb": "BECKENHAM",
   "postcode": "6107"
 },
 {
   "suburb": "CANNINGTON",
   "postcode": "6107"
 },
 {
   "suburb": "EAST CANNINGTON",
   "postcode": "6107"
 },
 {
   "suburb": "KENWICK",
   "postcode": "6107"
 },
 {
   "suburb": "QUEENS PARK",
   "postcode": "6107"
 },
 {
   "suburb": "WATTLE GROVE",
   "postcode": "6107"
 },
 {
   "suburb": "WILSON",
   "postcode": "6107"
 },
 {
   "suburb": "THORNLIE",
   "postcode": "6108"
 },
 {
   "suburb": "MADDINGTON",
   "postcode": "6109"
 },
 {
   "suburb": "ORANGE GROVE",
   "postcode": "6109"
 },
 {
   "suburb": "GOSNELLS",
   "postcode": "6110"
 },
 {
   "suburb": "HUNTINGDALE",
   "postcode": "6110"
 },
 {
   "suburb": "MARTIN",
   "postcode": "6110"
 },
 {
   "suburb": "SOUTHERN RIVER",
   "postcode": "6110"
 },
 {
   "suburb": "ASHENDON",
   "postcode": "6111"
 },
 {
   "suburb": "CAMILLO",
   "postcode": "6111"
 },
 {
   "suburb": "CANNING MILLS",
   "postcode": "6111"
 },
 {
   "suburb": "CHAMPION LAKES",
   "postcode": "6111"
 },
 {
   "suburb": "KARRAGULLEN",
   "postcode": "6111"
 },
 {
   "suburb": "KELMSCOTT",
   "postcode": "6111"
 },
 {
   "suburb": "LESLEY",
   "postcode": "6111"
 },
 {
   "suburb": "ROLEYSTONE",
   "postcode": "6111"
 },
 {
   "suburb": "ARMADALE",
   "postcode": "6112"
 },
 {
   "suburb": "BEDFORDALE",
   "postcode": "6112"
 },
 {
   "suburb": "BROOKDALE",
   "postcode": "6112"
 },
 {
   "suburb": "FORRESTDALE",
   "postcode": "6112"
 },
 {
   "suburb": "HARRISDALE",
   "postcode": "6112"
 },
 {
   "suburb": "HAYNES",
   "postcode": "6112"
 },
 {
   "suburb": "HILBERT",
   "postcode": "6112"
 },
 {
   "suburb": "MOUNT NASURA",
   "postcode": "6112"
 },
 {
   "suburb": "MOUNT RICHON",
   "postcode": "6112"
 },
 {
   "suburb": "PIARA WATERS",
   "postcode": "6112"
 },
 {
   "suburb": "SEVILLE GROVE",
   "postcode": "6112"
 },
 {
   "suburb": "WUNGONG",
   "postcode": "6112"
 },
 {
   "suburb": "OAKFORD",
   "postcode": "6121"
 },
 {
   "suburb": "OLDBURY",
   "postcode": "6121"
 },
 {
   "suburb": "BYFORD",
   "postcode": "6122"
 },
 {
   "suburb": "CARDUP",
   "postcode": "6122"
 },
 {
   "suburb": "DARLING DOWNS",
   "postcode": "6122"
 },
 {
   "suburb": "KARRAKUP",
   "postcode": "6122"
 },
 {
   "suburb": "MUNDIJONG",
   "postcode": "6123"
 },
 {
   "suburb": "WHITBY",
   "postcode": "6123"
 },
 {
   "suburb": "HOPELAND",
   "postcode": "6125"
 },
 {
   "suburb": "MARDELLA",
   "postcode": "6125"
 },
 {
   "suburb": "SERPENTINE",
   "postcode": "6125"
 },
 {
   "suburb": "LANGFORD",
   "postcode": "6147"
 },
 {
   "suburb": "LYNWOOD",
   "postcode": "6147"
 },
 {
   "suburb": "PARKWOOD",
   "postcode": "6147"
 },
 {
   "suburb": "FERNDALE",
   "postcode": "6148"
 },
 {
   "suburb": "RIVERTON",
   "postcode": "6148"
 },
 {
   "suburb": "ROSSMOYNE",
   "postcode": "6148"
 },
 {
   "suburb": "SHELLEY",
   "postcode": "6148"
 },
 {
   "suburb": "BULL CREEK",
   "postcode": "6149"
 },
 {
   "suburb": "LEEMING",
   "postcode": "6149"
 },
 {
   "suburb": "BATEMAN",
   "postcode": "6150"
 },
 {
   "suburb": "MURDOCH",
   "postcode": "6150"
 },
 {
   "suburb": "WINTHROP",
   "postcode": "6150"
 },
 {
   "suburb": "KENSINGTON",
   "postcode": "6151"
 },
 {
   "suburb": "SOUTH PERTH",
   "postcode": "6151"
 },
 {
   "suburb": "SOUTH PERTH ANGELO ST",
   "postcode": "6151"
 },
 {
   "suburb": "COMO",
   "postcode": "6152"
 },
 {
   "suburb": "KARAWARA",
   "postcode": "6152"
 },
 {
   "suburb": "MANNING",
   "postcode": "6152"
 },
 {
   "suburb": "SALTER POINT",
   "postcode": "6152"
 },
 {
   "suburb": "WATERFORD",
   "postcode": "6152"
 },
 {
   "suburb": "APPLECROSS",
   "postcode": "6153"
 },
 {
   "suburb": "APPLECROSS NORTH",
   "postcode": "6153"
 },
 {
   "suburb": "ARDROSS",
   "postcode": "6153"
 },
 {
   "suburb": "BRENTWOOD",
   "postcode": "6153"
 },
 {
   "suburb": "MOUNT PLEASANT",
   "postcode": "6153"
 },
 {
   "suburb": "ALFRED COVE",
   "postcode": "6154"
 },
 {
   "suburb": "BOORAGOON",
   "postcode": "6154"
 },
 {
   "suburb": "MYAREE",
   "postcode": "6154"
 },
 {
   "suburb": "CANNING VALE",
   "postcode": "6155"
 },
 {
   "suburb": "WILLETTON",
   "postcode": "6155"
 },
 {
   "suburb": "ATTADALE",
   "postcode": "6156"
 },
 {
   "suburb": "MELVILLE",
   "postcode": "6156"
 },
 {
   "suburb": "WILLAGEE",
   "postcode": "6156"
 },
 {
   "suburb": "WILLAGEE CENTRAL",
   "postcode": "6156"
 },
 {
   "suburb": "BICTON",
   "postcode": "6157"
 },
 {
   "suburb": "PALMYRA",
   "postcode": "6157"
 },
 {
   "suburb": "EAST FREMANTLE",
   "postcode": "6158"
 },
 {
   "suburb": "NORTH FREMANTLE",
   "postcode": "6159"
 },
 {
   "suburb": "FREMANTLE",
   "postcode": "6160"
 },
 {
   "suburb": "BEACONSFIELD",
   "postcode": "6162"
 },
 {
   "suburb": "SOUTH FREMANTLE",
   "postcode": "6162"
 },
 {
   "suburb": "WHITE GUM VALLEY",
   "postcode": "6162"
 },
 {
   "suburb": "BIBRA LAKE",
   "postcode": "6163"
 },
 {
   "suburb": "COOLBELLUP",
   "postcode": "6163"
 },
 {
   "suburb": "HAMILTON HILL",
   "postcode": "6163"
 },
 {
   "suburb": "HILTON",
   "postcode": "6163"
 },
 {
   "suburb": "KARDINYA",
   "postcode": "6163"
 },
 {
   "suburb": "NORTH COOGEE",
   "postcode": "6163"
 },
 {
   "suburb": "NORTH LAKE",
   "postcode": "6163"
 },
 {
   "suburb": "O'CONNOR",
   "postcode": "6163"
 },
 {
   "suburb": "SAMSON",
   "postcode": "6163"
 },
 {
   "suburb": "SPEARWOOD",
   "postcode": "6163"
 },
 {
   "suburb": "ATWELL",
   "postcode": "6164"
 },
 {
   "suburb": "AUBIN GROVE",
   "postcode": "6164"
 },
 {
   "suburb": "BANJUP",
   "postcode": "6164"
 },
 {
   "suburb": "BEELIAR",
   "postcode": "6164"
 },
 {
   "suburb": "COCKBURN CENTRAL",
   "postcode": "6164"
 },
 {
   "suburb": "HAMMOND PARK",
   "postcode": "6164"
 },
 {
   "suburb": "JANDAKOT",
   "postcode": "6164"
 },
 {
   "suburb": "SOUTH LAKE",
   "postcode": "6164"
 },
 {
   "suburb": "SUCCESS",
   "postcode": "6164"
 },
 {
   "suburb": "TREEBY",
   "postcode": "6164"
 },
 {
   "suburb": "YANGEBUP",
   "postcode": "6164"
 },
 {
   "suburb": "HOPE VALLEY",
   "postcode": "6165"
 },
 {
   "suburb": "NAVAL BASE",
   "postcode": "6165"
 },
 {
   "suburb": "COOGEE",
   "postcode": "6166"
 },
 {
   "suburb": "HENDERSON",
   "postcode": "6166"
 },
 {
   "suburb": "LAKE COOGEE",
   "postcode": "6166"
 },
 {
   "suburb": "MUNSTER",
   "postcode": "6166"
 },
 {
   "suburb": "WATTLEUP",
   "postcode": "6166"
 },
 {
   "suburb": "ANKETELL",
   "postcode": "6167"
 },
 {
   "suburb": "BERTRAM",
   "postcode": "6167"
 },
 {
   "suburb": "CALISTA",
   "postcode": "6167"
 },
 {
   "suburb": "CASUARINA",
   "postcode": "6167"
 },
 {
   "suburb": "KWINANA BEACH",
   "postcode": "6167"
 },
 {
   "suburb": "KWINANA TOWN CENTRE",
   "postcode": "6167"
 },
 {
   "suburb": "MANDOGALUP",
   "postcode": "6167"
 },
 {
   "suburb": "MEDINA",
   "postcode": "6167"
 },
 {
   "suburb": "ORELIA",
   "postcode": "6167"
 },
 {
   "suburb": "PARMELIA",
   "postcode": "6167"
 },
 {
   "suburb": "POSTANS",
   "postcode": "6167"
 },
 {
   "suburb": "THE SPECTACLES",
   "postcode": "6167"
 },
 {
   "suburb": "WANDI",
   "postcode": "6167"
 },
 {
   "suburb": "COOLOONGUP",
   "postcode": "6168"
 },
 {
   "suburb": "EAST ROCKINGHAM",
   "postcode": "6168"
 },
 {
   "suburb": "GARDEN ISLAND",
   "postcode": "6168"
 },
 {
   "suburb": "HILLMAN",
   "postcode": "6168"
 },
 {
   "suburb": "PERON",
   "postcode": "6168"
 },
 {
   "suburb": "ROCKINGHAM",
   "postcode": "6168"
 },
 {
   "suburb": "ROCKINGHAM BEACH",
   "postcode": "6168"
 },
 {
   "suburb": "SAFETY BAY",
   "postcode": "6169"
 },
 {
   "suburb": "SHOALWATER",
   "postcode": "6169"
 },
 {
   "suburb": "WAIKIKI",
   "postcode": "6169"
 },
 {
   "suburb": "WARNBRO",
   "postcode": "6169"
 },
 {
   "suburb": "LEDA",
   "postcode": "6170"
 },
 {
   "suburb": "WELLARD",
   "postcode": "6170"
 },
 {
   "suburb": "BALDIVIS",
   "postcode": "6171"
 },
 {
   "suburb": "PORT KENNEDY",
   "postcode": "6172"
 },
 {
   "suburb": "SECRET HARBOUR",
   "postcode": "6173"
 },
 {
   "suburb": "GOLDEN BAY",
   "postcode": "6174"
 },
 {
   "suburb": "SINGLETON",
   "postcode": "6175"
 },
 {
   "suburb": "KARNUP",
   "postcode": "6176"
 },
 {
   "suburb": "LAKELANDS",
   "postcode": "6180"
 },
 {
   "suburb": "PARKLANDS",
   "postcode": "6180"
 },
 {
   "suburb": "STAKE HILL",
   "postcode": "6181"
 },
 {
   "suburb": "KERALUP",
   "postcode": "6182"
 },
 {
   "suburb": "MYARA",
   "postcode": "6207"
 },
 {
   "suburb": "NAMBEELUP",
   "postcode": "6207"
 },
 {
   "suburb": "NORTH DANDALUP",
   "postcode": "6207"
 },
 {
   "suburb": "SOLUS",
   "postcode": "6207"
 },
 {
   "suburb": "WHITTAKER",
   "postcode": "6207"
 },
 {
   "suburb": "BLYTHEWOOD",
   "postcode": "6208"
 },
 {
   "suburb": "FAIRBRIDGE",
   "postcode": "6208"
 },
 {
   "suburb": "MEELON",
   "postcode": "6208"
 },
 {
   "suburb": "NIRIMBA",
   "postcode": "6208"
 },
 {
   "suburb": "NORTH YUNDERUP",
   "postcode": "6208"
 },
 {
   "suburb": "PINJARRA",
   "postcode": "6208"
 },
 {
   "suburb": "RAVENSWOOD",
   "postcode": "6208"
 },
 {
   "suburb": "SOUTH YUNDERUP",
   "postcode": "6208"
 },
 {
   "suburb": "WEST PINJARRA",
   "postcode": "6208"
 },
 {
   "suburb": "BARRAGUP",
   "postcode": "6209"
 },
 {
   "suburb": "FURNISSDALE",
   "postcode": "6209"
 },
 {
   "suburb": "COODANUP",
   "postcode": "6210"
 },
 {
   "suburb": "DUDLEY PARK",
   "postcode": "6210"
 },
 {
   "suburb": "ERSKINE",
   "postcode": "6210"
 },
 {
   "suburb": "FALCON",
   "postcode": "6210"
 },
 {
   "suburb": "GREENFIELDS",
   "postcode": "6210"
 },
 {
   "suburb": "HALLS HEAD",
   "postcode": "6210"
 },
 {
   "suburb": "MADORA BAY",
   "postcode": "6210"
 },
 {
   "suburb": "MANDURAH",
   "postcode": "6210"
 },
 {
   "suburb": "MEADOW SPRINGS",
   "postcode": "6210"
 },
 {
   "suburb": "SAN REMO",
   "postcode": "6210"
 },
 {
   "suburb": "SILVER SANDS",
   "postcode": "6210"
 },
 {
   "suburb": "WANNANUP",
   "postcode": "6210"
 },
 {
   "suburb": "BOUVARD",
   "postcode": "6211"
 },
 {
   "suburb": "CLIFTON",
   "postcode": "6211"
 },
 {
   "suburb": "DAWESVILLE",
   "postcode": "6211"
 },
 {
   "suburb": "HERRON",
   "postcode": "6211"
 },
 {
   "suburb": "BIRCHMONT",
   "postcode": "6214"
 },
 {
   "suburb": "COOLUP",
   "postcode": "6214"
 },
 {
   "suburb": "WEST COOLUP",
   "postcode": "6214"
 },
 {
   "suburb": "HAMEL",
   "postcode": "6215"
 },
 {
   "suburb": "LAKE CLIFTON",
   "postcode": "6215"
 },
 {
   "suburb": "PRESTON BEACH",
   "postcode": "6215"
 },
 {
   "suburb": "WAGERUP",
   "postcode": "6215"
 },
 {
   "suburb": "WAROONA",
   "postcode": "6215"
 },
 {
   "suburb": "YARLOOP",
   "postcode": "6218"
 },
 {
   "suburb": "COOKERNUP",
   "postcode": "6220"
 },
 {
   "suburb": "HARVEY",
   "postcode": "6220"
 },
 {
   "suburb": "MYALUP",
   "postcode": "6220"
 },
 {
   "suburb": "UDUC",
   "postcode": "6220"
 },
 {
   "suburb": "WARAWARRUP",
   "postcode": "6220"
 },
 {
   "suburb": "WOKALUP",
   "postcode": "6221"
 },
 {
   "suburb": "BENGER",
   "postcode": "6223"
 },
 {
   "suburb": "BEELA",
   "postcode": "6224"
 },
 {
   "suburb": "BRUNSWICK",
   "postcode": "6224"
 },
 {
   "suburb": "ALLANSON",
   "postcode": "6225"
 },
 {
   "suburb": "BOWELLING",
   "postcode": "6225"
 },
 {
   "suburb": "BUCKINGHAM",
   "postcode": "6225"
 },
 {
   "suburb": "CARDIFF",
   "postcode": "6225"
 },
 {
   "suburb": "COLLIE",
   "postcode": "6225"
 },
 {
   "suburb": "COLLIE BURN",
   "postcode": "6225"
 },
 {
   "suburb": "HARRIS RIVER",
   "postcode": "6225"
 },
 {
   "suburb": "LYALLS MILL",
   "postcode": "6225"
 },
 {
   "suburb": "MCALINDEN",
   "postcode": "6225"
 },
 {
   "suburb": "MUJA",
   "postcode": "6225"
 },
 {
   "suburb": "MUMBALLUP",
   "postcode": "6225"
 },
 {
   "suburb": "MUNGALUP",
   "postcode": "6225"
 },
 {
   "suburb": "NOGGERUP",
   "postcode": "6225"
 },
 {
   "suburb": "PALMER",
   "postcode": "6225"
 },
 {
   "suburb": "PRESTON SETTLEMENT",
   "postcode": "6225"
 },
 {
   "suburb": "SHOTTS",
   "postcode": "6225"
 },
 {
   "suburb": "WORSLEY",
   "postcode": "6225"
 },
 {
   "suburb": "YOURDAMUNG LAKE",
   "postcode": "6225"
 },
 {
   "suburb": "ROELANDS",
   "postcode": "6226"
 },
 {
   "suburb": "BUREKUP",
   "postcode": "6227"
 },
 {
   "suburb": "WATERLOO",
   "postcode": "6228"
 },
 {
   "suburb": "PICTON",
   "postcode": "6229"
 },
 {
   "suburb": "PICTON EAST",
   "postcode": "6229"
 },
 {
   "suburb": "BUNBURY",
   "postcode": "6230"
 },
 {
   "suburb": "CAREY PARK",
   "postcode": "6230"
 },
 {
   "suburb": "COLLEGE GROVE",
   "postcode": "6230"
 },
 {
   "suburb": "DALYELLUP",
   "postcode": "6230"
 },
 {
   "suburb": "DAVENPORT",
   "postcode": "6230"
 },
 {
   "suburb": "EAST BUNBURY",
   "postcode": "6230"
 },
 {
   "suburb": "GELORUP",
   "postcode": "6230"
 },
 {
   "suburb": "GLEN IRIS",
   "postcode": "6230"
 },
 {
   "suburb": "PELICAN POINT",
   "postcode": "6230"
 },
 {
   "suburb": "SOUTH BUNBURY",
   "postcode": "6230"
 },
 {
   "suburb": "USHER",
   "postcode": "6230"
 },
 {
   "suburb": "VITTORIA",
   "postcode": "6230"
 },
 {
   "suburb": "WITHERS",
   "postcode": "6230"
 },
 {
   "suburb": "EATON",
   "postcode": "6232"
 },
 {
   "suburb": "MILLBRIDGE",
   "postcode": "6232"
 },
 {
   "suburb": "AUSTRALIND",
   "postcode": "6233"
 },
 {
   "suburb": "BINNINGUP",
   "postcode": "6233"
 },
 {
   "suburb": "LESCHENAULT",
   "postcode": "6233"
 },
 {
   "suburb": "PARKFIELD",
   "postcode": "6233"
 },
 {
   "suburb": "WELLESLEY",
   "postcode": "6233"
 },
 {
   "suburb": "CROOKED BROOK",
   "postcode": "6236"
 },
 {
   "suburb": "DARDANUP",
   "postcode": "6236"
 },
 {
   "suburb": "DARDANUP WEST",
   "postcode": "6236"
 },
 {
   "suburb": "FERGUSON",
   "postcode": "6236"
 },
 {
   "suburb": "HENTY",
   "postcode": "6236"
 },
 {
   "suburb": "PARADISE",
   "postcode": "6236"
 },
 {
   "suburb": "WELLINGTON FOREST",
   "postcode": "6236"
 },
 {
   "suburb": "WELLINGTON MILL",
   "postcode": "6236"
 },
 {
   "suburb": "BOYANUP",
   "postcode": "6237"
 },
 {
   "suburb": "ELGIN",
   "postcode": "6237"
 },
 {
   "suburb": "GWINDINUP",
   "postcode": "6237"
 },
 {
   "suburb": "NORTH BOYANUP",
   "postcode": "6237"
 },
 {
   "suburb": "STRATHAM",
   "postcode": "6237"
 },
 {
   "suburb": "THE PLAINS",
   "postcode": "6237"
 },
 {
   "suburb": "ARGYLE",
   "postcode": "6239"
 },
 {
   "suburb": "BEELERUP",
   "postcode": "6239"
 },
 {
   "suburb": "BROOKHAMPTON",
   "postcode": "6239"
 },
 {
   "suburb": "CHARLEY CREEK",
   "postcode": "6239"
 },
 {
   "suburb": "DONNYBROOK",
   "postcode": "6239"
 },
 {
   "suburb": "GLEN MERVYN",
   "postcode": "6239"
 },
 {
   "suburb": "PAYNEDALE",
   "postcode": "6239"
 },
 {
   "suburb": "QUEENWOOD",
   "postcode": "6239"
 },
 {
   "suburb": "THOMSON BROOK",
   "postcode": "6239"
 },
 {
   "suburb": "UPPER CAPEL",
   "postcode": "6239"
 },
 {
   "suburb": "YABBERUP",
   "postcode": "6239"
 },
 {
   "suburb": "LOWDEN",
   "postcode": "6240"
 },
 {
   "suburb": "KIRUP",
   "postcode": "6251"
 },
 {
   "suburb": "NEWLANDS",
   "postcode": "6251"
 },
 {
   "suburb": "MULLALYUP",
   "postcode": "6252"
 },
 {
   "suburb": "BALINGUP",
   "postcode": "6253"
 },
 {
   "suburb": "GREENBUSHES",
   "postcode": "6254"
 },
 {
   "suburb": "NORTH GREENBUSHES",
   "postcode": "6254"
 },
 {
   "suburb": "BRIDGETOWN",
   "postcode": "6255"
 },
 {
   "suburb": "CATTERICK",
   "postcode": "6255"
 },
 {
   "suburb": "HESTER",
   "postcode": "6255"
 },
 {
   "suburb": "HESTER BROOK",
   "postcode": "6255"
 },
 {
   "suburb": "KANGAROO GULLY",
   "postcode": "6255"
 },
 {
   "suburb": "GLENLYNN",
   "postcode": "6256"
 },
 {
   "suburb": "YORNUP",
   "postcode": "6256"
 },
 {
   "suburb": "DINGUP",
   "postcode": "6258"
 },
 {
   "suburb": "JARDEE",
   "postcode": "6258"
 },
 {
   "suburb": "MANJIMUP",
   "postcode": "6258"
 },
 {
   "suburb": "MIDDLESEX",
   "postcode": "6258"
 },
 {
   "suburb": "PALGARUP",
   "postcode": "6258"
 },
 {
   "suburb": "WILGARRUP",
   "postcode": "6258"
 },
 {
   "suburb": "CAPEL",
   "postcode": "6271"
 },
 {
   "suburb": "CAPEL RIVER",
   "postcode": "6271"
 },
 {
   "suburb": "FORREST BEACH",
   "postcode": "6271"
 },
 {
   "suburb": "PEPPERMINT GROVE BEACH",
   "postcode": "6271"
 },
 {
   "suburb": "STIRLING ESTATE",
   "postcode": "6271"
 },
 {
   "suburb": "ABBA RIVER",
   "postcode": "6280"
 },
 {
   "suburb": "ABBEY",
   "postcode": "6280"
 },
 {
   "suburb": "ACTON PARK",
   "postcode": "6280"
 },
 {
   "suburb": "AMBERGATE",
   "postcode": "6280"
 },
 {
   "suburb": "ANNIEBROOK",
   "postcode": "6280"
 },
 {
   "suburb": "BOALLIA",
   "postcode": "6280"
 },
 {
   "suburb": "BOVELL",
   "postcode": "6280"
 },
 {
   "suburb": "BROADWATER",
   "postcode": "6280"
 },
 {
   "suburb": "BUSSELTON",
   "postcode": "6280"
 },
 {
   "suburb": "CARBUNUP RIVER",
   "postcode": "6280"
 },
 {
   "suburb": "CHAPMAN HILL",
   "postcode": "6280"
 },
 {
   "suburb": "GEOGRAPHE",
   "postcode": "6280"
 },
 {
   "suburb": "HITHERGREEN",
   "postcode": "6280"
 },
 {
   "suburb": "JINDONG",
   "postcode": "6280"
 },
 {
   "suburb": "KALGUP",
   "postcode": "6280"
 },
 {
   "suburb": "KALOORUP",
   "postcode": "6280"
 },
 {
   "suburb": "KEALY",
   "postcode": "6280"
 },
 {
   "suburb": "LUDLOW",
   "postcode": "6280"
 },
 {
   "suburb": "MARYBROOK",
   "postcode": "6280"
 },
 {
   "suburb": "METRICUP",
   "postcode": "6280"
 },
 {
   "suburb": "NORTH JINDONG",
   "postcode": "6280"
 },
 {
   "suburb": "REINSCOURT",
   "postcode": "6280"
 },
 {
   "suburb": "RUABON",
   "postcode": "6280"
 },
 {
   "suburb": "SABINA RIVER",
   "postcode": "6280"
 },
 {
   "suburb": "SIESTA PARK",
   "postcode": "6280"
 },
 {
   "suburb": "TUTUNUP",
   "postcode": "6280"
 },
 {
   "suburb": "VASSE",
   "postcode": "6280"
 },
 {
   "suburb": "WALSALL",
   "postcode": "6280"
 },
 {
   "suburb": "WEST BUSSELTON",
   "postcode": "6280"
 },
 {
   "suburb": "WILYABRUP",
   "postcode": "6280"
 },
 {
   "suburb": "WONNERUP",
   "postcode": "6280"
 },
 {
   "suburb": "YALYALUP",
   "postcode": "6280"
 },
 {
   "suburb": "YELVERTON",
   "postcode": "6280"
 },
 {
   "suburb": "YOONGARILLUP",
   "postcode": "6280"
 },
 {
   "suburb": "DUNSBOROUGH",
   "postcode": "6281"
 },
 {
   "suburb": "EAGLE BAY",
   "postcode": "6281"
 },
 {
   "suburb": "NATURALISTE",
   "postcode": "6281"
 },
 {
   "suburb": "QUEDJINUP",
   "postcode": "6281"
 },
 {
   "suburb": "QUINDALUP",
   "postcode": "6281"
 },
 {
   "suburb": "YALLINGUP",
   "postcode": "6282"
 },
 {
   "suburb": "YALLINGUP SIDING",
   "postcode": "6282"
 },
 {
   "suburb": "COWARAMUP",
   "postcode": "6284"
 },
 {
   "suburb": "GRACETOWN",
   "postcode": "6284"
 },
 {
   "suburb": "TREETON",
   "postcode": "6284"
 },
 {
   "suburb": "BRAMLEY",
   "postcode": "6285"
 },
 {
   "suburb": "BURNSIDE",
   "postcode": "6285"
 },
 {
   "suburb": "GNARABUP",
   "postcode": "6285"
 },
 {
   "suburb": "MARGARET RIVER",
   "postcode": "6285"
 },
 {
   "suburb": "OSMINGTON",
   "postcode": "6285"
 },
 {
   "suburb": "PREVELLY",
   "postcode": "6285"
 },
 {
   "suburb": "ROSA BROOK",
   "postcode": "6285"
 },
 {
   "suburb": "ROSA GLEN",
   "postcode": "6285"
 },
 {
   "suburb": "BORANUP",
   "postcode": "6286"
 },
 {
   "suburb": "FOREST GROVE",
   "postcode": "6286"
 },
 {
   "suburb": "REDGATE",
   "postcode": "6286"
 },
 {
   "suburb": "WITCHCLIFFE",
   "postcode": "6286"
 },
 {
   "suburb": "ALEXANDRA BRIDGE",
   "postcode": "6288"
 },
 {
   "suburb": "COURTENAY",
   "postcode": "6288"
 },
 {
   "suburb": "HAMELIN BAY",
   "postcode": "6288"
 },
 {
   "suburb": "KARRIDALE",
   "postcode": "6288"
 },
 {
   "suburb": "NILLUP",
   "postcode": "6288"
 },
 {
   "suburb": "SCOTT RIVER",
   "postcode": "6288"
 },
 {
   "suburb": "WARNER GLEN",
   "postcode": "6288"
 },
 {
   "suburb": "AUGUSTA",
   "postcode": "6290"
 },
 {
   "suburb": "DEEPDENE",
   "postcode": "6290"
 },
 {
   "suburb": "EAST AUGUSTA",
   "postcode": "6290"
 },
 {
   "suburb": "KUDARDUP",
   "postcode": "6290"
 },
 {
   "suburb": "LEEUWIN",
   "postcode": "6290"
 },
 {
   "suburb": "MOLLOY ISLAND",
   "postcode": "6290"
 },
 {
   "suburb": "BADGIN",
   "postcode": "6302"
 },
 {
   "suburb": "BALLADONG",
   "postcode": "6302"
 },
 {
   "suburb": "BURGES",
   "postcode": "6302"
 },
 {
   "suburb": "CALJIE",
   "postcode": "6302"
 },
 {
   "suburb": "COLD HARBOUR",
   "postcode": "6302"
 },
 {
   "suburb": "DALIAK",
   "postcode": "6302"
 },
 {
   "suburb": "FLINT",
   "postcode": "6302"
 },
 {
   "suburb": "FLYNN",
   "postcode": "6302"
 },
 {
   "suburb": "GILGERING",
   "postcode": "6302"
 },
 {
   "suburb": "GREENHILLS",
   "postcode": "6302"
 },
 {
   "suburb": "GWAMBYGINE",
   "postcode": "6302"
 },
 {
   "suburb": "INKPEN",
   "postcode": "6302"
 },
 {
   "suburb": "KAURING",
   "postcode": "6302"
 },
 {
   "suburb": "MALEBELLING",
   "postcode": "6302"
 },
 {
   "suburb": "MOUNT HARDEY",
   "postcode": "6302"
 },
 {
   "suburb": "MOUNT OBSERVATION",
   "postcode": "6302"
 },
 {
   "suburb": "NARRALOGGAN",
   "postcode": "6302"
 },
 {
   "suburb": "QUELLINGTON",
   "postcode": "6302"
 },
 {
   "suburb": "SAINT RONANS",
   "postcode": "6302"
 },
 {
   "suburb": "TALBOT",
   "postcode": "6302"
 },
 {
   "suburb": "TALBOT WEST",
   "postcode": "6302"
 },
 {
   "suburb": "WILBERFORCE",
   "postcode": "6302"
 },
 {
   "suburb": "YORK",
   "postcode": "6302"
 },
 {
   "suburb": "BUCKLAND",
   "postcode": "6401"
 },
 {
   "suburb": "BURLONG",
   "postcode": "6401"
 },
 {
   "suburb": "CUNJARDINE",
   "postcode": "6401"
 },
 {
   "suburb": "IRISHTOWN",
   "postcode": "6401"
 },
 {
   "suburb": "JENNACUBBINE",
   "postcode": "6401"
 },
 {
   "suburb": "JENNAPULLIN",
   "postcode": "6401"
 },
 {
   "suburb": "MALABAINE",
   "postcode": "6401"
 },
 {
   "suburb": "MEENAAR",
   "postcode": "6401"
 },
 {
   "suburb": "MOKINE",
   "postcode": "6401"
 },
 {
   "suburb": "MULUCKINE",
   "postcode": "6401"
 },
 {
   "suburb": "MUMBERKINE",
   "postcode": "6401"
 },
 {
   "suburb": "MURESK",
   "postcode": "6401"
 },
 {
   "suburb": "NORTHAM",
   "postcode": "6401"
 },
 {
   "suburb": "ROSSMORE",
   "postcode": "6401"
 },
 {
   "suburb": "SOUTHERN BROOK",
   "postcode": "6401"
 },
 {
   "suburb": "SPENCERS BROOK",
   "postcode": "6401"
 },
 {
   "suburb": "THROSSELL",
   "postcode": "6401"
 },
 {
   "suburb": "WONGAMINE",
   "postcode": "6401"
 },
 {
   "suburb": "GRASS VALLEY",
   "postcode": "6403"
 },
 {
   "suburb": "COWALLA",
   "postcode": "6503"
 },
 {
   "suburb": "NEERGABBY",
   "postcode": "6503"
 },
 {
   "suburb": "WANERIE",
   "postcode": "6503"
 },
 {
   "suburb": "CATABY",
   "postcode": "6507"
 },
 {
   "suburb": "COOLJARLOO",
   "postcode": "6507"
 },
 {
   "suburb": "MIMEGARRA",
   "postcode": "6507"
 },
 {
   "suburb": "CERVANTES",
   "postcode": "6511"
 },
 {
   "suburb": "GREEN HEAD",
   "postcode": "6514"
 },
 {
   "suburb": "LEEMAN",
   "postcode": "6514"
 },
 {
   "suburb": "JURIEN BAY",
   "postcode": "6516"
 },
 {
   "suburb": "ENEABBA",
   "postcode": "6518"
 },
 {
   "suburb": "WARRADARGE",
   "postcode": "6518"
 },
 {
   "suburb": "GREY",
   "postcode": "6521"
 },
 {
   "suburb": "HILL RIVER",
   "postcode": "6521"
 },
 {
   "suburb": "NAMBUNG",
   "postcode": "6521"
 },
 {
   "suburb": "ALLANOOKA",
   "postcode": "6525"
 },
 {
   "suburb": "ARROWSMITH",
   "postcode": "6525"
 },
 {
   "suburb": "BONNIEFIELD",
   "postcode": "6525"
 },
 {
   "suburb": "BOOKARA",
   "postcode": "6525"
 },
 {
   "suburb": "DONGARA",
   "postcode": "6525"
 },
 {
   "suburb": "IRWIN",
   "postcode": "6525"
 },
 {
   "suburb": "MILO",
   "postcode": "6525"
 },
 {
   "suburb": "MOUNT ADAMS",
   "postcode": "6525"
 },
 {
   "suburb": "MOUNT HORNER",
   "postcode": "6525"
 },
 {
   "suburb": "PORT DENISON",
   "postcode": "6525"
 },
 {
   "suburb": "SPRINGFIELD",
   "postcode": "6525"
 },
 {
   "suburb": "YARDARINO",
   "postcode": "6525"
 },
 {
   "suburb": "MOUNT HILL",
   "postcode": "6528"
 },
 {
   "suburb": "SOUTH GREENOUGH",
   "postcode": "6528"
 },
 {
   "suburb": "WALKAWAY",
   "postcode": "6528"
 },
 {
   "suburb": "BEACHLANDS",
   "postcode": "6530"
 },
 {
   "suburb": "BERESFORD",
   "postcode": "6530"
 },
 {
   "suburb": "BLUFF POINT",
   "postcode": "6530"
 },
 {
   "suburb": "GERALDTON",
   "postcode": "6530"
 },
 {
   "suburb": "KARLOO",
   "postcode": "6530"
 },
 {
   "suburb": "MAHOMETS FLATS",
   "postcode": "6530"
 },
 {
   "suburb": "MERU",
   "postcode": "6530"
 },
 {
   "suburb": "MORESBY",
   "postcode": "6530"
 },
 {
   "suburb": "MOUNT TARCOOLA",
   "postcode": "6530"
 },
 {
   "suburb": "RANGEWAY",
   "postcode": "6530"
 },
 {
   "suburb": "SPALDING",
   "postcode": "6530"
 },
 {
   "suburb": "STRAHALBYN",
   "postcode": "6530"
 },
 {
   "suburb": "STRATHALBYN",
   "postcode": "6530"
 },
 {
   "suburb": "SUNSET BEACH",
   "postcode": "6530"
 },
 {
   "suburb": "TARCOOLA BEACH",
   "postcode": "6530"
 },
 {
   "suburb": "UTAKARRA",
   "postcode": "6530"
 },
 {
   "suburb": "WAGGRAKINE",
   "postcode": "6530"
 },
 {
   "suburb": "WANDINA",
   "postcode": "6530"
 },
 {
   "suburb": "WEBBERTON",
   "postcode": "6530"
 },
 {
   "suburb": "WEST END",
   "postcode": "6530"
 },
 {
   "suburb": "WONTHELLA",
   "postcode": "6530"
 },
 {
   "suburb": "WOORREE",
   "postcode": "6530"
 },
 {
   "suburb": "BOOTENAL",
   "postcode": "6532"
 },
 {
   "suburb": "BRINGO",
   "postcode": "6532"
 },
 {
   "suburb": "BULLER",
   "postcode": "6532"
 },
 {
   "suburb": "BURMA ROAD",
   "postcode": "6532"
 },
 {
   "suburb": "CAPE BURNEY",
   "postcode": "6532"
 },
 {
   "suburb": "DEEPDALE",
   "postcode": "6532"
 },
 {
   "suburb": "DRUMMOND COVE",
   "postcode": "6532"
 },
 {
   "suburb": "EAST CHAPMAN",
   "postcode": "6532"
 },
 {
   "suburb": "GELNFIELD",
   "postcode": "6532"
 },
 {
   "suburb": "GEORGINA",
   "postcode": "6532"
 },
 {
   "suburb": "GLENFIELD",
   "postcode": "6532"
 },
 {
   "suburb": "GREENOUGH",
   "postcode": "6532"
 },
 {
   "suburb": "HOWATHARRA",
   "postcode": "6532"
 },
 {
   "suburb": "MOONYOONOOKA",
   "postcode": "6532"
 },
 {
   "suburb": "NANSON",
   "postcode": "6532"
 },
 {
   "suburb": "NARNGULU",
   "postcode": "6532"
 },
 {
   "suburb": "NARRA TARRA",
   "postcode": "6532"
 },
 {
   "suburb": "OAKAJEE",
   "postcode": "6532"
 },
 {
   "suburb": "RUDDS GULLY",
   "postcode": "6532"
 },
 {
   "suburb": "WHITE PEAK",
   "postcode": "6532"
 },
 {
   "suburb": "YETNA",
   "postcode": "6532"
 },
 {
   "suburb": "BEECHINA",
   "postcode": "6556"
 },
 {
   "suburb": "CHIDLOW",
   "postcode": "6556"
 },
 {
   "suburb": "GORRIE",
   "postcode": "6556"
 },
 {
   "suburb": "MALMALLING",
   "postcode": "6556"
 },
 {
   "suburb": "THE LAKES",
   "postcode": "6556"
 },
 {
   "suburb": "WOOROLOO",
   "postcode": "6558"
 },
 {
   "suburb": "BAKERS HILL",
   "postcode": "6562"
 },
 {
   "suburb": "COPLEY",
   "postcode": "6562"
 },
 {
   "suburb": "WOOTTATING",
   "postcode": "6562"
 },
 {
   "suburb": "BEJOORDING",
   "postcode": "6566"
 },
 {
   "suburb": "CARANI",
   "postcode": "6566"
 },
 {
   "suburb": "COONDLE",
   "postcode": "6566"
 },
 {
   "suburb": "CULHAM",
   "postcode": "6566"
 },
 {
   "suburb": "DUMBARTON",
   "postcode": "6566"
 },
 {
   "suburb": "HODDYS WELL",
   "postcode": "6566"
 },
 {
   "suburb": "KATRINE",
   "postcode": "6566"
 },
 {
   "suburb": "NUNILE",
   "postcode": "6566"
 },
 {
   "suburb": "TOODYAY",
   "postcode": "6566"
 },
 {
   "suburb": "WEST TOODYAY",
   "postcode": "6566"
 },
 {
   "suburb": "NEDLANDS",
   "postcode": "6907"
 },
 {
   "suburb": "GLEBE",
   "postcode": "7000"
 },
 {
   "suburb": "HOBART",
   "postcode": "7000"
 },
 {
   "suburb": "MOUNT STUART",
   "postcode": "7000"
 },
 {
   "suburb": "NORTH HOBART",
   "postcode": "7000"
 },
 {
   "suburb": "QUEENS DOMAIN",
   "postcode": "7000"
 },
 {
   "suburb": "WEST HOBART",
   "postcode": "7000"
 },
 {
   "suburb": "HOBART",
   "postcode": "7001"
 },
 {
   "suburb": "NORTH HOBART",
   "postcode": "7002"
 },
 {
   "suburb": "BATTERY POINT",
   "postcode": "7004"
 },
 {
   "suburb": "SOUTH HOBART",
   "postcode": "7004"
 },
 {
   "suburb": "DYNNYRNE",
   "postcode": "7005"
 },
 {
   "suburb": "LOWER SANDY BAY",
   "postcode": "7005"
 },
 {
   "suburb": "SANDY BAY",
   "postcode": "7005"
 },
 {
   "suburb": "SANDY BAY",
   "postcode": "7006"
 },
 {
   "suburb": "MOUNT NELSON",
   "postcode": "7007"
 },
 {
   "suburb": "TOLMANS HILL",
   "postcode": "7007"
 },
 {
   "suburb": "LENAH VALLEY",
   "postcode": "7008"
 },
 {
   "suburb": "NEW TOWN",
   "postcode": "7008"
 },
 {
   "suburb": "DERWENT PARK",
   "postcode": "7009"
 },
 {
   "suburb": "LUTANA",
   "postcode": "7009"
 },
 {
   "suburb": "MOONAH",
   "postcode": "7009"
 },
 {
   "suburb": "WEST MOONAH",
   "postcode": "7009"
 },
 {
   "suburb": "DOWSING POINT",
   "postcode": "7010"
 },
 {
   "suburb": "GLENORCHY",
   "postcode": "7010"
 },
 {
   "suburb": "GOODWOOD",
   "postcode": "7010"
 },
 {
   "suburb": "MONTROSE",
   "postcode": "7010"
 },
 {
   "suburb": "ROSETTA",
   "postcode": "7010"
 },
 {
   "suburb": "AUSTINS FERRY",
   "postcode": "7011"
 },
 {
   "suburb": "BERRIEDALE",
   "postcode": "7011"
 },
 {
   "suburb": "CHIGWELL",
   "postcode": "7011"
 },
 {
   "suburb": "CLAREMONT",
   "postcode": "7011"
 },
 {
   "suburb": "COLLINSVALE",
   "postcode": "7012"
 },
 {
   "suburb": "GLENLUSK",
   "postcode": "7012"
 },
 {
   "suburb": "GEILSTON BAY",
   "postcode": "7015"
 },
 {
   "suburb": "LINDISFARNE",
   "postcode": "7015"
 },
 {
   "suburb": "ROSE BAY",
   "postcode": "7015"
 },
 {
   "suburb": "RISDON VALE",
   "postcode": "7016"
 },
 {
   "suburb": "GRASSTREE HILL",
   "postcode": "7017"
 },
 {
   "suburb": "HONEYWOOD",
   "postcode": "7017"
 },
 {
   "suburb": "OLD BEACH",
   "postcode": "7017"
 },
 {
   "suburb": "OTAGO",
   "postcode": "7017"
 },
 {
   "suburb": "RISDON",
   "postcode": "7017"
 },
 {
   "suburb": "TEA TREE",
   "postcode": "7017"
 },
 {
   "suburb": "BELLERIVE",
   "postcode": "7018"
 },
 {
   "suburb": "HOWRAH",
   "postcode": "7018"
 },
 {
   "suburb": "MONTAGU BAY",
   "postcode": "7018"
 },
 {
   "suburb": "MORNINGTON",
   "postcode": "7018"
 },
 {
   "suburb": "ROSNY",
   "postcode": "7018"
 },
 {
   "suburb": "ROSNY PARK",
   "postcode": "7018"
 },
 {
   "suburb": "TRANMERE",
   "postcode": "7018"
 },
 {
   "suburb": "WARRANE",
   "postcode": "7018"
 },
 {
   "suburb": "CLARENDON VALE",
   "postcode": "7019"
 },
 {
   "suburb": "OAKDOWNS",
   "postcode": "7019"
 },
 {
   "suburb": "ROKEBY",
   "postcode": "7019"
 },
 {
   "suburb": "CLIFTON BEACH",
   "postcode": "7020"
 },
 {
   "suburb": "SANDFORD",
   "postcode": "7020"
 },
 {
   "suburb": "LAUDERDALE",
   "postcode": "7021"
 },
 {
   "suburb": "SOUTH ARM",
   "postcode": "7022"
 },
 {
   "suburb": "OPOSSUM BAY",
   "postcode": "7023"
 },
 {
   "suburb": "CREMORNE",
   "postcode": "7024"
 },
 {
   "suburb": "DULCOT",
   "postcode": "7025"
 },
 {
   "suburb": "RICHMOND",
   "postcode": "7025"
 },
 {
   "suburb": "CAMPANIA",
   "postcode": "7026"
 },
 {
   "suburb": "COLEBROOK",
   "postcode": "7027"
 },
 {
   "suburb": "APSLEY",
   "postcode": "7030"
 },
 {
   "suburb": "BAGDAD",
   "postcode": "7030"
 },
 {
   "suburb": "BOTHWELL",
   "postcode": "7030"
 },
 {
   "suburb": "BRIDGEWATER",
   "postcode": "7030"
 },
 {
   "suburb": "BRIGHTON",
   "postcode": "7030"
 },
 {
   "suburb": "BROADMARSH",
   "postcode": "7030"
 },
 {
   "suburb": "DROMEDARY",
   "postcode": "7030"
 },
 {
   "suburb": "DYSART",
   "postcode": "7030"
 },
 {
   "suburb": "ELDERSLIE",
   "postcode": "7030"
 },
 {
   "suburb": "GAGEBROOK",
   "postcode": "7030"
 },
 {
   "suburb": "GRANTON",
   "postcode": "7030"
 },
 {
   "suburb": "HERDSMANS COVE",
   "postcode": "7030"
 },
 {
   "suburb": "JERICHO",
   "postcode": "7030"
 },
 {
   "suburb": "KEMPTON",
   "postcode": "7030"
 },
 {
   "suburb": "MANGALORE",
   "postcode": "7030"
 },
 {
   "suburb": "MELTON MOWBRAY",
   "postcode": "7030"
 },
 {
   "suburb": "PELHAM",
   "postcode": "7030"
 },
 {
   "suburb": "PONTVILLE",
   "postcode": "7030"
 },
 {
   "suburb": "KINGSTON",
   "postcode": "7050"
 },
 {
   "suburb": "KINGSTON BEACH",
   "postcode": "7050"
 },
 {
   "suburb": "BLACKMANS BAY",
   "postcode": "7052"
 },
 {
   "suburb": "BONNET HILL",
   "postcode": "7053"
 },
 {
   "suburb": "TAROONA",
   "postcode": "7053"
 },
 {
   "suburb": "BARRETTA",
   "postcode": "7054"
 },
 {
   "suburb": "CONINGHAM",
   "postcode": "7054"
 },
 {
   "suburb": "ELECTRONA",
   "postcode": "7054"
 },
 {
   "suburb": "FERN TREE",
   "postcode": "7054"
 },
 {
   "suburb": "HOWDEN",
   "postcode": "7054"
 },
 {
   "suburb": "LESLIE VALE",
   "postcode": "7054"
 },
 {
   "suburb": "LOWER SNUG",
   "postcode": "7054"
 },
 {
   "suburb": "MARGATE",
   "postcode": "7054"
 },
 {
   "suburb": "NEIKA",
   "postcode": "7054"
 },
 {
   "suburb": "RIDGEWAY",
   "postcode": "7054"
 },
 {
   "suburb": "SNUG",
   "postcode": "7054"
 },
 {
   "suburb": "TINDERBOX",
   "postcode": "7054"
 },
 {
   "suburb": "WELLINGTON PARK",
   "postcode": "7054"
 },
 {
   "suburb": "HUNTINGFIELD",
   "postcode": "7055"
 },
 {
   "suburb": "CRABTREE",
   "postcode": "7109"
 },
 {
   "suburb": "CRADOC",
   "postcode": "7109"
 },
 {
   "suburb": "GLAZIERS BAY",
   "postcode": "7109"
 },
 {
   "suburb": "GLEN HUON",
   "postcode": "7109"
 },
 {
   "suburb": "GROVE",
   "postcode": "7109"
 },
 {
   "suburb": "HUONVILLE",
   "postcode": "7109"
 },
 {
   "suburb": "JUDBURY",
   "postcode": "7109"
 },
 {
   "suburb": "LOWER LONGLEY",
   "postcode": "7109"
 },
 {
   "suburb": "LOWER WATTLE GROVE",
   "postcode": "7109"
 },
 {
   "suburb": "LUCASTON",
   "postcode": "7109"
 },
 {
   "suburb": "LYMINGTON",
   "postcode": "7109"
 },
 {
   "suburb": "MOUNTAIN RIVER",
   "postcode": "7109"
 },
 {
   "suburb": "PETCHEYS BAY",
   "postcode": "7109"
 },
 {
   "suburb": "RANELAGH",
   "postcode": "7109"
 },
 {
   "suburb": "WATTLE GROVE",
   "postcode": "7109"
 },
 {
   "suburb": "WOODSTOCK",
   "postcode": "7109"
 },
 {
   "suburb": "CYGNET",
   "postcode": "7112"
 },
 {
   "suburb": "GARDNERS BAY",
   "postcode": "7112"
 },
 {
   "suburb": "NICHOLLS RIVULET",
   "postcode": "7112"
 },
 {
   "suburb": "FRANKLIN",
   "postcode": "7113"
 },
 {
   "suburb": "STONOR",
   "postcode": "7119"
 },
 {
   "suburb": "ANTILL PONDS",
   "postcode": "7120"
 },
 {
   "suburb": "OATLANDS",
   "postcode": "7120"
 },
 {
   "suburb": "PARATTAH",
   "postcode": "7120"
 },
 {
   "suburb": "RHYNDASTON",
   "postcode": "7120"
 },
 {
   "suburb": "TIBERIAS",
   "postcode": "7120"
 },
 {
   "suburb": "TUNBRIDGE",
   "postcode": "7120"
 },
 {
   "suburb": "WOODBURY",
   "postcode": "7120"
 },
 {
   "suburb": "BLACK HILLS",
   "postcode": "7140"
 },
 {
   "suburb": "BOYER",
   "postcode": "7140"
 },
 {
   "suburb": "BRADYS LAKE",
   "postcode": "7140"
 },
 {
   "suburb": "BRONTE PARK",
   "postcode": "7140"
 },
 {
   "suburb": "BUSHY PARK",
   "postcode": "7140"
 },
 {
   "suburb": "BUTLERS GORGE",
   "postcode": "7140"
 },
 {
   "suburb": "DERWENT BRIDGE",
   "postcode": "7140"
 },
 {
   "suburb": "ELLENDALE",
   "postcode": "7140"
 },
 {
   "suburb": "FENTONBURY",
   "postcode": "7140"
 },
 {
   "suburb": "FITZGERALD",
   "postcode": "7140"
 },
 {
   "suburb": "GLENFERN",
   "postcode": "7140"
 },
 {
   "suburb": "GLENORA",
   "postcode": "7140"
 },
 {
   "suburb": "GRETNA",
   "postcode": "7140"
 },
 {
   "suburb": "HAMILTON",
   "postcode": "7140"
 },
 {
   "suburb": "HAYES",
   "postcode": "7140"
 },
 {
   "suburb": "HOLLOW TREE",
   "postcode": "7140"
 },
 {
   "suburb": "KARANJA",
   "postcode": "7140"
 },
 {
   "suburb": "LACHLAN",
   "postcode": "7140"
 },
 {
   "suburb": "LAWITTA",
   "postcode": "7140"
 },
 {
   "suburb": "MACQUARIE PLAINS",
   "postcode": "7140"
 },
 {
   "suburb": "MAGRA",
   "postcode": "7140"
 },
 {
   "suburb": "MALBINA",
   "postcode": "7140"
 },
 {
   "suburb": "MAYDENA",
   "postcode": "7140"
 },
 {
   "suburb": "MEADOWBANK",
   "postcode": "7140"
 },
 {
   "suburb": "MOLESWORTH",
   "postcode": "7140"
 },
 {
   "suburb": "MOUNT FIELD",
   "postcode": "7140"
 },
 {
   "suburb": "NATIONAL PARK",
   "postcode": "7140"
 },
 {
   "suburb": "NEW NORFOLK",
   "postcode": "7140"
 },
 {
   "suburb": "OUSE",
   "postcode": "7140"
 },
 {
   "suburb": "PLENTY",
   "postcode": "7140"
 },
 {
   "suburb": "ROSEGARLAND",
   "postcode": "7140"
 },
 {
   "suburb": "SORELL CREEK",
   "postcode": "7140"
 },
 {
   "suburb": "STRICKLAND",
   "postcode": "7140"
 },
 {
   "suburb": "STYX",
   "postcode": "7140"
 },
 {
   "suburb": "TARRALEAH",
   "postcode": "7140"
 },
 {
   "suburb": "TYENNA",
   "postcode": "7140"
 },
 {
   "suburb": "WAYATINAH",
   "postcode": "7140"
 },
 {
   "suburb": "WESTERWAY",
   "postcode": "7140"
 },
 {
   "suburb": "ALLENS RIVULET",
   "postcode": "7150"
 },
 {
   "suburb": "KAOOTA",
   "postcode": "7150"
 },
 {
   "suburb": "LONGLEY",
   "postcode": "7150"
 },
 {
   "suburb": "OYSTER COVE",
   "postcode": "7150"
 },
 {
   "suburb": "PELVERATA",
   "postcode": "7150"
 },
 {
   "suburb": "SANDFLY",
   "postcode": "7150"
 },
 {
   "suburb": "UPPER WOODSTOCK",
   "postcode": "7150"
 },
 {
   "suburb": "KETTERING",
   "postcode": "7155"
 },
 {
   "suburb": "ACTON PARK",
   "postcode": "7170"
 },
 {
   "suburb": "CAMBRIDGE",
   "postcode": "7170"
 },
 {
   "suburb": "MOUNT RUMNEY",
   "postcode": "7170"
 },
 {
   "suburb": "ROCHES BEACH",
   "postcode": "7170"
 },
 {
   "suburb": "SEVEN MILE BEACH",
   "postcode": "7170"
 },
 {
   "suburb": "MIDWAY POINT",
   "postcode": "7171"
 },
 {
   "suburb": "PENNA",
   "postcode": "7171"
 },
 {
   "suburb": "SORELL",
   "postcode": "7172"
 },
 {
   "suburb": "CARLTON",
   "postcode": "7173"
 },
 {
   "suburb": "CARLTON RIVER",
   "postcode": "7173"
 },
 {
   "suburb": "DODGES FERRY",
   "postcode": "7173"
 },
 {
   "suburb": "FORCETT",
   "postcode": "7173"
 },
 {
   "suburb": "LEWISHAM",
   "postcode": "7173"
 },
 {
   "suburb": "PRIMROSE SANDS",
   "postcode": "7173"
 },
 {
   "suburb": "ROSS",
   "postcode": "7209"
 },
 {
   "suburb": "CAMPBELL TOWN",
   "postcode": "7210"
 },
 {
   "suburb": "CLEVELAND",
   "postcode": "7211"
 },
 {
   "suburb": "EPPING FOREST",
   "postcode": "7211"
 },
 {
   "suburb": "EVANDALE",
   "postcode": "7212"
 },
 {
   "suburb": "WESTERN JUNCTION",
   "postcode": "7212"
 },
 {
   "suburb": "INVERMAY",
   "postcode": "7248"
 },
 {
   "suburb": "MAYFIELD",
   "postcode": "7248"
 },
 {
   "suburb": "MOWBRAY",
   "postcode": "7248"
 },
 {
   "suburb": "NEWNHAM",
   "postcode": "7248"
 },
 {
   "suburb": "ROCHERLEA",
   "postcode": "7248"
 },
 {
   "suburb": "KINGS MEADOWS",
   "postcode": "7249"
 },
 {
   "suburb": "PUNCHBOWL",
   "postcode": "7249"
 },
 {
   "suburb": "SOUTH LAUNCESTON",
   "postcode": "7249"
 },
 {
   "suburb": "YOUNGTOWN",
   "postcode": "7249"
 },
 {
   "suburb": "BLACKSTONE HEIGHTS",
   "postcode": "7250"
 },
 {
   "suburb": "EAST LAUNCESTON",
   "postcode": "7250"
 },
 {
   "suburb": "LAUNCESTON",
   "postcode": "7250"
 },
 {
   "suburb": "NEWSTEAD",
   "postcode": "7250"
 },
 {
   "suburb": "NORWOOD",
   "postcode": "7250"
 },
 {
   "suburb": "PROSPECT",
   "postcode": "7250"
 },
 {
   "suburb": "PROSPECT VALE",
   "postcode": "7250"
 },
 {
   "suburb": "RAVENSWOOD",
   "postcode": "7250"
 },
 {
   "suburb": "RIVERSIDE",
   "postcode": "7250"
 },
 {
   "suburb": "ST LEONARDS",
   "postcode": "7250"
 },
 {
   "suburb": "SUMMERHILL",
   "postcode": "7250"
 },
 {
   "suburb": "TRAVELLERS REST",
   "postcode": "7250"
 },
 {
   "suburb": "TREVALLYN",
   "postcode": "7250"
 },
 {
   "suburb": "WAVERLEY",
   "postcode": "7250"
 },
 {
   "suburb": "WEST LAUNCESTON",
   "postcode": "7250"
 },
 {
   "suburb": "DILSTON",
   "postcode": "7252"
 },
 {
   "suburb": "HILLWOOD",
   "postcode": "7252"
 },
 {
   "suburb": "MOUNT DIRECTION",
   "postcode": "7252"
 },
 {
   "suburb": "SWAN BAY",
   "postcode": "7252"
 },
 {
   "suburb": "WINDERMERE",
   "postcode": "7252"
 },
 {
   "suburb": "BELL BAY",
   "postcode": "7253"
 },
 {
   "suburb": "GEORGE TOWN",
   "postcode": "7253"
 },
 {
   "suburb": "LONG REACH",
   "postcode": "7253"
 },
 {
   "suburb": "LOW HEAD",
   "postcode": "7253"
 },
 {
   "suburb": "LEBRINA",
   "postcode": "7254"
 },
 {
   "suburb": "TUNNEL",
   "postcode": "7254"
 },
 {
   "suburb": "BREADALBANE",
   "postcode": "7258"
 },
 {
   "suburb": "RELBIA",
   "postcode": "7258"
 },
 {
   "suburb": "WHITE HILLS",
   "postcode": "7258"
 },
 {
   "suburb": "BANGOR",
   "postcode": "7267"
 },
 {
   "suburb": "KAROOLA",
   "postcode": "7267"
 },
 {
   "suburb": "LALLA",
   "postcode": "7267"
 },
 {
   "suburb": "LOWER TURNERS MARSH",
   "postcode": "7267"
 },
 {
   "suburb": "TURNERS MARSH",
   "postcode": "7267"
 },
 {
   "suburb": "LILYDALE",
   "postcode": "7268"
 },
 {
   "suburb": "BADGER HEAD",
   "postcode": "7270"
 },
 {
   "suburb": "BEACONSFIELD",
   "postcode": "7270"
 },
 {
   "suburb": "BEAUTY POINT",
   "postcode": "7270"
 },
 {
   "suburb": "CLARENCE POINT",
   "postcode": "7270"
 },
 {
   "suburb": "FLOWERY GULLY",
   "postcode": "7270"
 },
 {
   "suburb": "GREENS BEACH",
   "postcode": "7270"
 },
 {
   "suburb": "KAYENA",
   "postcode": "7270"
 },
 {
   "suburb": "KELSO",
   "postcode": "7270"
 },
 {
   "suburb": "ROWELLA",
   "postcode": "7270"
 },
 {
   "suburb": "SIDMOUTH",
   "postcode": "7270"
 },
 {
   "suburb": "YORK TOWN",
   "postcode": "7270"
 },
 {
   "suburb": "BLACKWALL",
   "postcode": "7275"
 },
 {
   "suburb": "DEVIOT",
   "postcode": "7275"
 },
 {
   "suburb": "EXETER",
   "postcode": "7275"
 },
 {
   "suburb": "FRANKFORD",
   "postcode": "7275"
 },
 {
   "suburb": "GLENGARRY",
   "postcode": "7275"
 },
 {
   "suburb": "HOLWELL",
   "postcode": "7275"
 },
 {
   "suburb": "LANENA",
   "postcode": "7275"
 },
 {
   "suburb": "LOIRA",
   "postcode": "7275"
 },
 {
   "suburb": "NOTLEY HILLS",
   "postcode": "7275"
 },
 {
   "suburb": "ROBIGANA",
   "postcode": "7275"
 },
 {
   "suburb": "SWAN POINT",
   "postcode": "7275"
 },
 {
   "suburb": "WINKLEIGH",
   "postcode": "7275"
 },
 {
   "suburb": "GRAVELLY BEACH",
   "postcode": "7276"
 },
 {
   "suburb": "BRIDGENORTH",
   "postcode": "7277"
 },
 {
   "suburb": "GRINDELWALD",
   "postcode": "7277"
 },
 {
   "suburb": "LEGANA",
   "postcode": "7277"
 },
 {
   "suburb": "ROSEVEARS",
   "postcode": "7277"
 },
 {
   "suburb": "HADSPEN",
   "postcode": "7290"
 },
 {
   "suburb": "CARRICK",
   "postcode": "7291"
 },
 {
   "suburb": "HAGLEY",
   "postcode": "7292"
 },
 {
   "suburb": "QUAMBY BEND",
   "postcode": "7292"
 },
 {
   "suburb": "ROSEVALE",
   "postcode": "7292"
 },
 {
   "suburb": "SELBOURNE",
   "postcode": "7292"
 },
 {
   "suburb": "WESTWOOD",
   "postcode": "7292"
 },
 {
   "suburb": "DEVON HILLS",
   "postcode": "7300"
 },
 {
   "suburb": "PERTH",
   "postcode": "7300"
 },
 {
   "suburb": "POWRANNA",
   "postcode": "7300"
 },
 {
   "suburb": "BISHOPSBOURNE",
   "postcode": "7301"
 },
 {
   "suburb": "LONGFORD",
   "postcode": "7301"
 },
 {
   "suburb": "TOIBERRY",
   "postcode": "7301"
 },
 {
   "suburb": "BRACKNELL",
   "postcode": "7302"
 },
 {
   "suburb": "BIRRALEE",
   "postcode": "7303"
 },
 {
   "suburb": "CLUAN",
   "postcode": "7303"
 },
 {
   "suburb": "EXTON",
   "postcode": "7303"
 },
 {
   "suburb": "OAKS",
   "postcode": "7303"
 },
 {
   "suburb": "OSMASTON",
   "postcode": "7303"
 },
 {
   "suburb": "WESTBURY",
   "postcode": "7303"
 },
 {
   "suburb": "WHITEMORE",
   "postcode": "7303"
 },
 {
   "suburb": "CAVESIDE",
   "postcode": "7304"
 },
 {
   "suburb": "CHUDLEIGH",
   "postcode": "7304"
 },
 {
   "suburb": "DAIRY PLAINS",
   "postcode": "7304"
 },
 {
   "suburb": "DELORAINE",
   "postcode": "7304"
 },
 {
   "suburb": "DUNORLAN",
   "postcode": "7304"
 },
 {
   "suburb": "ELIZABETH TOWN",
   "postcode": "7304"
 },
 {
   "suburb": "JACKEYS MARSH",
   "postcode": "7304"
 },
 {
   "suburb": "KIMBERLEY",
   "postcode": "7304"
 },
 {
   "suburb": "MEANDER",
   "postcode": "7304"
 },
 {
   "suburb": "MOLE CREEK",
   "postcode": "7304"
 },
 {
   "suburb": "MOLTEMA",
   "postcode": "7304"
 },
 {
   "suburb": "MONTANA",
   "postcode": "7304"
 },
 {
   "suburb": "NEEDLES",
   "postcode": "7304"
 },
 {
   "suburb": "PARKHAM",
   "postcode": "7304"
 },
 {
   "suburb": "QUAMBY BROOK",
   "postcode": "7304"
 },
 {
   "suburb": "RED HILLS",
   "postcode": "7304"
 },
 {
   "suburb": "REEDY MARSH",
   "postcode": "7304"
 },
 {
   "suburb": "WEEGENA",
   "postcode": "7304"
 },
 {
   "suburb": "WEETAH",
   "postcode": "7304"
 },
 {
   "suburb": "WESTERN CREEK",
   "postcode": "7304"
 },
 {
   "suburb": "MERSEYLEA",
   "postcode": "7305"
 },
 {
   "suburb": "RAILTON",
   "postcode": "7305"
 },
 {
   "suburb": "SUNNYSIDE",
   "postcode": "7305"
 },
 {
   "suburb": "ACACIA HILLS",
   "postcode": "7306"
 },
 {
   "suburb": "BARRINGTON",
   "postcode": "7306"
 },
 {
   "suburb": "BEULAH",
   "postcode": "7306"
 },
 {
   "suburb": "CETHANA",
   "postcode": "7306"
 },
 {
   "suburb": "CLAUDE ROAD",
   "postcode": "7306"
 },
 {
   "suburb": "GOWRIE PARK",
   "postcode": "7306"
 },
 {
   "suburb": "LOWER BARRINGTON",
   "postcode": "7306"
 },
 {
   "suburb": "LOWER BEULAH",
   "postcode": "7306"
 },
 {
   "suburb": "MOUNT ROLAND",
   "postcode": "7306"
 },
 {
   "suburb": "NOOK",
   "postcode": "7306"
 },
 {
   "suburb": "NOWHERE ELSE",
   "postcode": "7306"
 },
 {
   "suburb": "PARADISE",
   "postcode": "7306"
 },
 {
   "suburb": "PROMISED LAND",
   "postcode": "7306"
 },
 {
   "suburb": "ROLAND",
   "postcode": "7306"
 },
 {
   "suburb": "SHEFFIELD",
   "postcode": "7306"
 },
 {
   "suburb": "STAVERTON",
   "postcode": "7306"
 },
 {
   "suburb": "STOODLEY",
   "postcode": "7306"
 },
 {
   "suburb": "WEST KENTISH",
   "postcode": "7306"
 },
 {
   "suburb": "HAWLEY BEACH",
   "postcode": "7307"
 },
 {
   "suburb": "LATROBE",
   "postcode": "7307"
 },
 {
   "suburb": "MORIARTY",
   "postcode": "7307"
 },
 {
   "suburb": "NORTHDOWN",
   "postcode": "7307"
 },
 {
   "suburb": "PORT SORELL",
   "postcode": "7307"
 },
 {
   "suburb": "SASSAFRAS",
   "postcode": "7307"
 },
 {
   "suburb": "SHEARWATER",
   "postcode": "7307"
 },
 {
   "suburb": "SQUEAKING POINT",
   "postcode": "7307"
 },
 {
   "suburb": "THIRLSTANE",
   "postcode": "7307"
 },
 {
   "suburb": "WESLEY VALE",
   "postcode": "7307"
 },
 {
   "suburb": "ABERDEEN",
   "postcode": "7310"
 },
 {
   "suburb": "AMBLESIDE",
   "postcode": "7310"
 },
 {
   "suburb": "DEVONPORT",
   "postcode": "7310"
 },
 {
   "suburb": "DON",
   "postcode": "7310"
 },
 {
   "suburb": "EAST DEVONPORT",
   "postcode": "7310"
 },
 {
   "suburb": "ERRIBA",
   "postcode": "7310"
 },
 {
   "suburb": "EUGENANA",
   "postcode": "7310"
 },
 {
   "suburb": "FORTH",
   "postcode": "7310"
 },
 {
   "suburb": "FORTHSIDE",
   "postcode": "7310"
 },
 {
   "suburb": "KINDRED",
   "postcode": "7310"
 },
 {
   "suburb": "LILLICO",
   "postcode": "7310"
 },
 {
   "suburb": "LOWER WILMOT",
   "postcode": "7310"
 },
 {
   "suburb": "MELROSE",
   "postcode": "7310"
 },
 {
   "suburb": "MIANDETTA",
   "postcode": "7310"
 },
 {
   "suburb": "PALOONA",
   "postcode": "7310"
 },
 {
   "suburb": "QUOIBA",
   "postcode": "7310"
 },
 {
   "suburb": "SOUTH SPREYTON",
   "postcode": "7310"
 },
 {
   "suburb": "SPREYTON",
   "postcode": "7310"
 },
 {
   "suburb": "STONY RISE",
   "postcode": "7310"
 },
 {
   "suburb": "TARLETON",
   "postcode": "7310"
 },
 {
   "suburb": "TUGRAH",
   "postcode": "7310"
 },
 {
   "suburb": "WILMOT",
   "postcode": "7310"
 },
 {
   "suburb": "ABBOTSHAM",
   "postcode": "7315"
 },
 {
   "suburb": "CASTRA",
   "postcode": "7315"
 },
 {
   "suburb": "GAWLER",
   "postcode": "7315"
 },
 {
   "suburb": "GUNNS PLAINS",
   "postcode": "7315"
 },
 {
   "suburb": "LEITH",
   "postcode": "7315"
 },
 {
   "suburb": "NIETTA",
   "postcode": "7315"
 },
 {
   "suburb": "NORTH MOTTON",
   "postcode": "7315"
 },
 {
   "suburb": "PRESTON",
   "postcode": "7315"
 },
 {
   "suburb": "SOUTH PRESTON",
   "postcode": "7315"
 },
 {
   "suburb": "SPALFORD",
   "postcode": "7315"
 },
 {
   "suburb": "SPRENT",
   "postcode": "7315"
 },
 {
   "suburb": "TURNERS BEACH",
   "postcode": "7315"
 },
 {
   "suburb": "ULVERSTONE",
   "postcode": "7315"
 },
 {
   "suburb": "UPPER CASTRA",
   "postcode": "7315"
 },
 {
   "suburb": "WEST ULVERSTONE",
   "postcode": "7315"
 },
 {
   "suburb": "CAMENA",
   "postcode": "7316"
 },
 {
   "suburb": "CUPRONA",
   "postcode": "7316"
 },
 {
   "suburb": "HEYBRIDGE",
   "postcode": "7316"
 },
 {
   "suburb": "HOWTH",
   "postcode": "7316"
 },
 {
   "suburb": "PENGUIN",
   "postcode": "7316"
 },
 {
   "suburb": "PRESERVATION BAY",
   "postcode": "7316"
 },
 {
   "suburb": "RIANA",
   "postcode": "7316"
 },
 {
   "suburb": "SOUTH RIANA",
   "postcode": "7316"
 },
 {
   "suburb": "SULPHUR CREEK",
   "postcode": "7316"
 },
 {
   "suburb": "WEST PINE",
   "postcode": "7316"
 },
 {
   "suburb": "ACTON",
   "postcode": "7320"
 },
 {
   "suburb": "BROOKLYN",
   "postcode": "7320"
 },
 {
   "suburb": "BURNIE",
   "postcode": "7320"
 },
 {
   "suburb": "CAMDALE",
   "postcode": "7320"
 },
 {
   "suburb": "COOEE",
   "postcode": "7320"
 },
 {
   "suburb": "DOWNLANDS",
   "postcode": "7320"
 },
 {
   "suburb": "EMU HEIGHTS",
   "postcode": "7320"
 },
 {
   "suburb": "HAVENVIEW",
   "postcode": "7320"
 },
 {
   "suburb": "HILLCREST",
   "postcode": "7320"
 },
 {
   "suburb": "MONTELLO",
   "postcode": "7320"
 },
 {
   "suburb": "OCEAN VISTA",
   "postcode": "7320"
 },
 {
   "suburb": "PARK GROVE",
   "postcode": "7320"
 },
 {
   "suburb": "PARKLANDS",
   "postcode": "7320"
 },
 {
   "suburb": "ROMAINE",
   "postcode": "7320"
 },
 {
   "suburb": "ROUND HILL",
   "postcode": "7320"
 },
 {
   "suburb": "SHOREWELL PARK",
   "postcode": "7320"
 },
 {
   "suburb": "SOUTH BURNIE",
   "postcode": "7320"
 },
 {
   "suburb": "UPPER BURNIE",
   "postcode": "7320"
 },
 {
   "suburb": "WIVENHOE",
   "postcode": "7320"
 },
 {
   "suburb": "BLACK RIVER",
   "postcode": "7321"
 },
 {
   "suburb": "BOAT HARBOUR",
   "postcode": "7321"
 },
 {
   "suburb": "BOAT HARBOUR BEACH",
   "postcode": "7321"
 },
 {
   "suburb": "CHASM CREEK",
   "postcode": "7321"
 },
 {
   "suburb": "COWRIE POINT",
   "postcode": "7321"
 },
 {
   "suburb": "CRAYFISH CREEK",
   "postcode": "7321"
 },
 {
   "suburb": "DETENTION",
   "postcode": "7321"
 },
 {
   "suburb": "EAST CAM",
   "postcode": "7321"
 },
 {
   "suburb": "EAST RIDGLEY",
   "postcode": "7321"
 },
 {
   "suburb": "EDGCUMBE BEACH",
   "postcode": "7321"
 },
 {
   "suburb": "HELLYER",
   "postcode": "7321"
 },
 {
   "suburb": "HIGHCLERE",
   "postcode": "7321"
 },
 {
   "suburb": "MONTUMANA",
   "postcode": "7321"
 },
 {
   "suburb": "MOOREVILLE",
   "postcode": "7321"
 },
 {
   "suburb": "NATONE",
   "postcode": "7321"
 },
 {
   "suburb": "PORT LATTA",
   "postcode": "7321"
 },
 {
   "suburb": "RIDGLEY",
   "postcode": "7321"
 },
 {
   "suburb": "ROCKY CAPE",
   "postcode": "7321"
 },
 {
   "suburb": "SISTERS BEACH",
   "postcode": "7321"
 },
 {
   "suburb": "STOWPORT",
   "postcode": "7321"
 },
 {
   "suburb": "TEWKESBURY",
   "postcode": "7321"
 },
 {
   "suburb": "UPPER NATONE",
   "postcode": "7321"
 },
 {
   "suburb": "UPPER STOWPORT",
   "postcode": "7321"
 },
 {
   "suburb": "WEST MOOREVILLE",
   "postcode": "7321"
 },
 {
   "suburb": "WEST RIDGLEY",
   "postcode": "7321"
 },
 {
   "suburb": "WILTSHIRE",
   "postcode": "7321"
 },
 {
   "suburb": "SOMERSET",
   "postcode": "7322"
 },
 {
   "suburb": "DOCTORS ROCKS",
   "postcode": "7325"
 },
 {
   "suburb": "ELLIOTT",
   "postcode": "7325"
 },
 {
   "suburb": "FLOWERDALE",
   "postcode": "7325"
 },
 {
   "suburb": "HENRIETTA",
   "postcode": "7325"
 },
 {
   "suburb": "MOUNT HICKS",
   "postcode": "7325"
 },
 {
   "suburb": "MYALLA",
   "postcode": "7325"
 },
 {
   "suburb": "SISTERS CREEK",
   "postcode": "7325"
 },
 {
   "suburb": "TABLE CAPE",
   "postcode": "7325"
 },
 {
   "suburb": "WYNYARD",
   "postcode": "7325"
 },
 {
   "suburb": "YOLLA",
   "postcode": "7325"
 },
 {
   "suburb": "FOREST",
   "postcode": "7330"
 },
 {
   "suburb": "SMITHTON",
   "postcode": "7330"
 },
 {
   "suburb": "SOUTH FOREST",
   "postcode": "7330"
 },
 {
   "suburb": "STANLEY",
   "postcode": "7331"
 }
];